(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["baasicSdkJavaScript"] = factory();
	else
		root["baasicSdkJavaScript"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 34);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator.throw(value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
};

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), q = [], c, i;
    return i = { next: verb("next"), "throw": verb("throw"), "return": verb("return") }, i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { return function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]), next(); }); }; }
    function next() { if (!c && q.length) resume((c = q.shift())[0], c[1]); }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(c[3], e); } }
    function step(r) { r.done ? settle(c[2], r) : r.value[0] === "yield" ? settle(c[2], { value: r.value[1], done: false }) : Promise.resolve(r.value[1]).then(r.value[0] === "delegate" ? delegate : fulfill, reject); }
    function delegate(r) { step(r.done ? r : { value: ["yield", r.value], done: false }); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { c = void 0, f(v), next(); }
};

function __asyncDelegator(o) {
    var i = { next: verb("next"), "throw": verb("throw", function (e) { throw e; }), "return": verb("return", function (v) { return { value: v, done: true }; }) };
    return o = __asyncValues(o), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { return function (v) { return { value: ["delegate", (o[n] || f).call(o, v)], done: false }; }; }
};

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var container_1 = __webpack_require__(50);
exports.Container = container_1.Container;
var container_module_1 = __webpack_require__(66);
exports.ContainerModule = container_module_1.ContainerModule;
var injectable_1 = __webpack_require__(67);
exports.injectable = injectable_1.injectable;
var tagged_1 = __webpack_require__(68);
exports.tagged = tagged_1.tagged;
var named_1 = __webpack_require__(69);
exports.named = named_1.named;
var inject_1 = __webpack_require__(70);
exports.inject = inject_1.inject;
var optional_1 = __webpack_require__(71);
exports.optional = optional_1.optional;
var unmanaged_1 = __webpack_require__(72);
exports.unmanaged = unmanaged_1.unmanaged;
var multi_inject_1 = __webpack_require__(73);
exports.multiInject = multi_inject_1.multiInject;
var target_name_1 = __webpack_require__(74);
exports.targetName = target_name_1.targetName;
var guid_1 = __webpack_require__(24);
exports.guid = guid_1.guid;
var decorator_utils_1 = __webpack_require__(22);
exports.decorate = decorator_utils_1.decorate;
var constraint_helpers_1 = __webpack_require__(42);
exports.traverseAncerstors = constraint_helpers_1.traverseAncerstors;
exports.taggedConstraint = constraint_helpers_1.taggedConstraint;
exports.namedConstraint = constraint_helpers_1.namedConstraint;
exports.typeConstraint = constraint_helpers_1.typeConstraint;
var serialization_1 = __webpack_require__(28);
exports.getServiceIdentifierAsString = serialization_1.getServiceIdentifierAsString;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(113), exports);
var diModule_1 = __webpack_require__(44);
exports.commonDIModule = diModule_1.diModule;
var diModule_2 = __webpack_require__(44);
exports.TYPES = diModule_2.TYPES;
tslib_1.__exportStar(__webpack_require__(114), exports);
tslib_1.__exportStar(__webpack_require__(115), exports);
tslib_1.__exportStar(__webpack_require__(116), exports);
tslib_1.__exportStar(__webpack_require__(117), exports);
tslib_1.__exportStar(__webpack_require__(119), exports);
tslib_1.__exportStar(__webpack_require__(120), exports);
tslib_1.__exportStar(__webpack_require__(134), exports);


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(99), exports);
tslib_1.__exportStar(__webpack_require__(100), exports);
tslib_1.__exportStar(__webpack_require__(101), exports);
tslib_1.__exportStar(__webpack_require__(102), exports);
tslib_1.__exportStar(__webpack_require__(103), exports);
tslib_1.__exportStar(__webpack_require__(104), exports);
tslib_1.__exportStar(__webpack_require__(105), exports);
tslib_1.__exportStar(__webpack_require__(106), exports);
tslib_1.__exportStar(__webpack_require__(107), exports);
tslib_1.__exportStar(__webpack_require__(108), exports);
tslib_1.__exportStar(__webpack_require__(109), exports);
tslib_1.__exportStar(__webpack_require__(110), exports);
tslib_1.__exportStar(__webpack_require__(111), exports);
tslib_1.__exportStar(__webpack_require__(112), exports);


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var diModule_1 = __webpack_require__(43);
exports.httpDIModule = diModule_1.diModule;
var diModule_2 = __webpack_require__(43);
exports.httpTYPES = diModule_2.TYPES;
tslib_1.__exportStar(__webpack_require__(93), exports);
tslib_1.__exportStar(__webpack_require__(94), exports);
tslib_1.__exportStar(__webpack_require__(95), exports);
tslib_1.__exportStar(__webpack_require__(96), exports);
tslib_1.__exportStar(__webpack_require__(97), exports);
tslib_1.__exportStar(__webpack_require__(98), exports);


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(457), exports);
tslib_1.__exportStar(__webpack_require__(458), exports);
tslib_1.__exportStar(__webpack_require__(459), exports);
tslib_1.__exportStar(__webpack_require__(47), exports);
tslib_1.__exportStar(__webpack_require__(506), exports);
tslib_1.__exportStar(__webpack_require__(511), exports);
tslib_1.__exportStar(__webpack_require__(516), exports);
tslib_1.__exportStar(__webpack_require__(519), exports);
tslib_1.__exportStar(__webpack_require__(522), exports);
tslib_1.__exportStar(__webpack_require__(536), exports);
tslib_1.__exportStar(__webpack_require__(539), exports);
tslib_1.__exportStar(__webpack_require__(542), exports);
tslib_1.__exportStar(__webpack_require__(549), exports);


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(254), exports);
tslib_1.__exportStar(__webpack_require__(255), exports);
tslib_1.__exportStar(__webpack_require__(256), exports);
tslib_1.__exportStar(__webpack_require__(272), exports);
tslib_1.__exportStar(__webpack_require__(46), exports);
tslib_1.__exportStar(__webpack_require__(273), exports);
tslib_1.__exportStar(__webpack_require__(282), exports);
tslib_1.__exportStar(__webpack_require__(285), exports);
tslib_1.__exportStar(__webpack_require__(288), exports);
tslib_1.__exportStar(__webpack_require__(293), exports);
tslib_1.__exportStar(__webpack_require__(300), exports);
tslib_1.__exportStar(__webpack_require__(301), exports);
tslib_1.__exportStar(__webpack_require__(302), exports);
tslib_1.__exportStar(__webpack_require__(303), exports);
tslib_1.__exportStar(__webpack_require__(304), exports);
tslib_1.__exportStar(__webpack_require__(305), exports);
tslib_1.__exportStar(__webpack_require__(306), exports);
tslib_1.__exportStar(__webpack_require__(307), exports);
tslib_1.__exportStar(__webpack_require__(308), exports);
tslib_1.__exportStar(__webpack_require__(309), exports);
tslib_1.__exportStar(__webpack_require__(310), exports);
tslib_1.__exportStar(__webpack_require__(311), exports);
tslib_1.__exportStar(__webpack_require__(312), exports);
tslib_1.__exportStar(__webpack_require__(313), exports);
tslib_1.__exportStar(__webpack_require__(314), exports);
tslib_1.__exportStar(__webpack_require__(315), exports);
tslib_1.__exportStar(__webpack_require__(316), exports);
tslib_1.__exportStar(__webpack_require__(317), exports);
tslib_1.__exportStar(__webpack_require__(318), exports);
tslib_1.__exportStar(__webpack_require__(319), exports);
tslib_1.__exportStar(__webpack_require__(320), exports);
tslib_1.__exportStar(__webpack_require__(321), exports);
tslib_1.__exportStar(__webpack_require__(322), exports);
tslib_1.__exportStar(__webpack_require__(46), exports);
tslib_1.__exportStar(__webpack_require__(323), exports);


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(552), exports);
tslib_1.__exportStar(__webpack_require__(553), exports);
tslib_1.__exportStar(__webpack_require__(576), exports);
tslib_1.__exportStar(__webpack_require__(579), exports);
tslib_1.__exportStar(__webpack_require__(584), exports);
tslib_1.__exportStar(__webpack_require__(598), exports);
tslib_1.__exportStar(__webpack_require__(603), exports);
tslib_1.__exportStar(__webpack_require__(48), exports);
tslib_1.__exportStar(__webpack_require__(629), exports);
tslib_1.__exportStar(__webpack_require__(630), exports);
tslib_1.__exportStar(__webpack_require__(631), exports);
tslib_1.__exportStar(__webpack_require__(632), exports);
tslib_1.__exportStar(__webpack_require__(633), exports);


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(75)() ? Symbol : __webpack_require__(76);


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(195), exports);
tslib_1.__exportStar(__webpack_require__(196), exports);
tslib_1.__exportStar(__webpack_require__(197), exports);
tslib_1.__exportStar(__webpack_require__(198), exports);
tslib_1.__exportStar(__webpack_require__(199), exports);
tslib_1.__exportStar(__webpack_require__(200), exports);
tslib_1.__exportStar(__webpack_require__(201), exports);
tslib_1.__exportStar(__webpack_require__(202), exports);
tslib_1.__exportStar(__webpack_require__(203), exports);
tslib_1.__exportStar(__webpack_require__(204), exports);
tslib_1.__exportStar(__webpack_require__(205), exports);
tslib_1.__exportStar(__webpack_require__(206), exports);
tslib_1.__exportStar(__webpack_require__(207), exports);
tslib_1.__exportStar(__webpack_require__(208), exports);
tslib_1.__exportStar(__webpack_require__(209), exports);
tslib_1.__exportStar(__webpack_require__(210), exports);
tslib_1.__exportStar(__webpack_require__(211), exports);
tslib_1.__exportStar(__webpack_require__(212), exports);
tslib_1.__exportStar(__webpack_require__(213), exports);
tslib_1.__exportStar(__webpack_require__(214), exports);
tslib_1.__exportStar(__webpack_require__(215), exports);
tslib_1.__exportStar(__webpack_require__(216), exports);
tslib_1.__exportStar(__webpack_require__(217), exports);
tslib_1.__exportStar(__webpack_require__(218), exports);
tslib_1.__exportStar(__webpack_require__(219), exports);
tslib_1.__exportStar(__webpack_require__(220), exports);
tslib_1.__exportStar(__webpack_require__(221), exports);
tslib_1.__exportStar(__webpack_require__(222), exports);
tslib_1.__exportStar(__webpack_require__(223), exports);
tslib_1.__exportStar(__webpack_require__(224), exports);
tslib_1.__exportStar(__webpack_require__(225), exports);
tslib_1.__exportStar(__webpack_require__(226), exports);
tslib_1.__exportStar(__webpack_require__(227), exports);


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(421), exports);
tslib_1.__exportStar(__webpack_require__(422), exports);
tslib_1.__exportStar(__webpack_require__(423), exports);
tslib_1.__exportStar(__webpack_require__(424), exports);
tslib_1.__exportStar(__webpack_require__(425), exports);
tslib_1.__exportStar(__webpack_require__(426), exports);
tslib_1.__exportStar(__webpack_require__(427), exports);
tslib_1.__exportStar(__webpack_require__(428), exports);
tslib_1.__exportStar(__webpack_require__(429), exports);
tslib_1.__exportStar(__webpack_require__(430), exports);
tslib_1.__exportStar(__webpack_require__(431), exports);
tslib_1.__exportStar(__webpack_require__(432), exports);
tslib_1.__exportStar(__webpack_require__(433), exports);
tslib_1.__exportStar(__webpack_require__(434), exports);
tslib_1.__exportStar(__webpack_require__(435), exports);
tslib_1.__exportStar(__webpack_require__(436), exports);
tslib_1.__exportStar(__webpack_require__(437), exports);
tslib_1.__exportStar(__webpack_require__(438), exports);
tslib_1.__exportStar(__webpack_require__(439), exports);
tslib_1.__exportStar(__webpack_require__(440), exports);
tslib_1.__exportStar(__webpack_require__(441), exports);
tslib_1.__exportStar(__webpack_require__(442), exports);
tslib_1.__exportStar(__webpack_require__(443), exports);
tslib_1.__exportStar(__webpack_require__(444), exports);
tslib_1.__exportStar(__webpack_require__(445), exports);
tslib_1.__exportStar(__webpack_require__(446), exports);
tslib_1.__exportStar(__webpack_require__(447), exports);
tslib_1.__exportStar(__webpack_require__(448), exports);
tslib_1.__exportStar(__webpack_require__(449), exports);
tslib_1.__exportStar(__webpack_require__(450), exports);


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(771), exports);
tslib_1.__exportStar(__webpack_require__(772), exports);
tslib_1.__exportStar(__webpack_require__(773), exports);
tslib_1.__exportStar(__webpack_require__(774), exports);
tslib_1.__exportStar(__webpack_require__(775), exports);
tslib_1.__exportStar(__webpack_require__(776), exports);
tslib_1.__exportStar(__webpack_require__(777), exports);
tslib_1.__exportStar(__webpack_require__(778), exports);
tslib_1.__exportStar(__webpack_require__(779), exports);
tslib_1.__exportStar(__webpack_require__(780), exports);
tslib_1.__exportStar(__webpack_require__(781), exports);
tslib_1.__exportStar(__webpack_require__(782), exports);
tslib_1.__exportStar(__webpack_require__(783), exports);
tslib_1.__exportStar(__webpack_require__(784), exports);
tslib_1.__exportStar(__webpack_require__(785), exports);
tslib_1.__exportStar(__webpack_require__(786), exports);
tslib_1.__exportStar(__webpack_require__(787), exports);
tslib_1.__exportStar(__webpack_require__(788), exports);
tslib_1.__exportStar(__webpack_require__(789), exports);
tslib_1.__exportStar(__webpack_require__(790), exports);
tslib_1.__exportStar(__webpack_require__(791), exports);
tslib_1.__exportStar(__webpack_require__(792), exports);
tslib_1.__exportStar(__webpack_require__(793), exports);
tslib_1.__exportStar(__webpack_require__(794), exports);
tslib_1.__exportStar(__webpack_require__(795), exports);
tslib_1.__exportStar(__webpack_require__(796), exports);
tslib_1.__exportStar(__webpack_require__(797), exports);
tslib_1.__exportStar(__webpack_require__(798), exports);
tslib_1.__exportStar(__webpack_require__(799), exports);
tslib_1.__exportStar(__webpack_require__(800), exports);


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(730), exports);
tslib_1.__exportStar(__webpack_require__(731), exports);
tslib_1.__exportStar(__webpack_require__(732), exports);
tslib_1.__exportStar(__webpack_require__(733), exports);
tslib_1.__exportStar(__webpack_require__(734), exports);
tslib_1.__exportStar(__webpack_require__(735), exports);
tslib_1.__exportStar(__webpack_require__(736), exports);
tslib_1.__exportStar(__webpack_require__(737), exports);
tslib_1.__exportStar(__webpack_require__(738), exports);
tslib_1.__exportStar(__webpack_require__(739), exports);
tslib_1.__exportStar(__webpack_require__(740), exports);
tslib_1.__exportStar(__webpack_require__(741), exports);
tslib_1.__exportStar(__webpack_require__(742), exports);
tslib_1.__exportStar(__webpack_require__(743), exports);
tslib_1.__exportStar(__webpack_require__(744), exports);
tslib_1.__exportStar(__webpack_require__(745), exports);
tslib_1.__exportStar(__webpack_require__(746), exports);
tslib_1.__exportStar(__webpack_require__(747), exports);
tslib_1.__exportStar(__webpack_require__(748), exports);
tslib_1.__exportStar(__webpack_require__(749), exports);
tslib_1.__exportStar(__webpack_require__(750), exports);
tslib_1.__exportStar(__webpack_require__(751), exports);
tslib_1.__exportStar(__webpack_require__(752), exports);
tslib_1.__exportStar(__webpack_require__(753), exports);
tslib_1.__exportStar(__webpack_require__(754), exports);
tslib_1.__exportStar(__webpack_require__(755), exports);
tslib_1.__exportStar(__webpack_require__(756), exports);
tslib_1.__exportStar(__webpack_require__(757), exports);
tslib_1.__exportStar(__webpack_require__(758), exports);


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(152), exports);
tslib_1.__exportStar(__webpack_require__(153), exports);
tslib_1.__exportStar(__webpack_require__(154), exports);
tslib_1.__exportStar(__webpack_require__(155), exports);
tslib_1.__exportStar(__webpack_require__(156), exports);
tslib_1.__exportStar(__webpack_require__(157), exports);
tslib_1.__exportStar(__webpack_require__(158), exports);
tslib_1.__exportStar(__webpack_require__(159), exports);
tslib_1.__exportStar(__webpack_require__(160), exports);
tslib_1.__exportStar(__webpack_require__(161), exports);
tslib_1.__exportStar(__webpack_require__(162), exports);
tslib_1.__exportStar(__webpack_require__(163), exports);
tslib_1.__exportStar(__webpack_require__(164), exports);
tslib_1.__exportStar(__webpack_require__(165), exports);
tslib_1.__exportStar(__webpack_require__(166), exports);
tslib_1.__exportStar(__webpack_require__(167), exports);
tslib_1.__exportStar(__webpack_require__(168), exports);
tslib_1.__exportStar(__webpack_require__(169), exports);
tslib_1.__exportStar(__webpack_require__(170), exports);
tslib_1.__exportStar(__webpack_require__(171), exports);
tslib_1.__exportStar(__webpack_require__(172), exports);
tslib_1.__exportStar(__webpack_require__(173), exports);
tslib_1.__exportStar(__webpack_require__(174), exports);


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.NAMED_TAG = "named";
exports.NAME_TAG = "name";
exports.UNMANAGED_TAG = "unmanaged";
exports.OPTIONAL_TAG = "optional";
exports.INJECT_TAG = "inject";
exports.MULTI_INJECT_TAG = "multi_inject";
exports.TAGGED = "inversify:tagged";
exports.TAGGED_PROP = "inversify:tagged_props";
exports.PARAM_TYPES = "inversify:paramtypes";
exports.DESIGN_PARAM_TYPES = "design:paramtypes";


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(354), exports);
tslib_1.__exportStar(__webpack_require__(355), exports);
tslib_1.__exportStar(__webpack_require__(356), exports);
tslib_1.__exportStar(__webpack_require__(357), exports);
tslib_1.__exportStar(__webpack_require__(358), exports);
tslib_1.__exportStar(__webpack_require__(359), exports);
tslib_1.__exportStar(__webpack_require__(360), exports);
tslib_1.__exportStar(__webpack_require__(361), exports);
tslib_1.__exportStar(__webpack_require__(362), exports);
tslib_1.__exportStar(__webpack_require__(363), exports);
tslib_1.__exportStar(__webpack_require__(364), exports);
tslib_1.__exportStar(__webpack_require__(365), exports);
tslib_1.__exportStar(__webpack_require__(366), exports);
tslib_1.__exportStar(__webpack_require__(367), exports);
tslib_1.__exportStar(__webpack_require__(375), exports);
tslib_1.__exportStar(__webpack_require__(380), exports);


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(685), exports);
tslib_1.__exportStar(__webpack_require__(686), exports);
tslib_1.__exportStar(__webpack_require__(687), exports);
tslib_1.__exportStar(__webpack_require__(688), exports);
tslib_1.__exportStar(__webpack_require__(689), exports);
tslib_1.__exportStar(__webpack_require__(690), exports);
tslib_1.__exportStar(__webpack_require__(691), exports);
tslib_1.__exportStar(__webpack_require__(692), exports);
tslib_1.__exportStar(__webpack_require__(693), exports);
tslib_1.__exportStar(__webpack_require__(694), exports);
tslib_1.__exportStar(__webpack_require__(695), exports);
tslib_1.__exportStar(__webpack_require__(696), exports);
tslib_1.__exportStar(__webpack_require__(697), exports);
tslib_1.__exportStar(__webpack_require__(698), exports);
tslib_1.__exportStar(__webpack_require__(699), exports);
tslib_1.__exportStar(__webpack_require__(700), exports);
tslib_1.__exportStar(__webpack_require__(701), exports);
tslib_1.__exportStar(__webpack_require__(702), exports);
tslib_1.__exportStar(__webpack_require__(703), exports);
tslib_1.__exportStar(__webpack_require__(704), exports);
tslib_1.__exportStar(__webpack_require__(705), exports);


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(651), exports);
tslib_1.__exportStar(__webpack_require__(652), exports);
tslib_1.__exportStar(__webpack_require__(653), exports);
tslib_1.__exportStar(__webpack_require__(654), exports);
tslib_1.__exportStar(__webpack_require__(655), exports);
tslib_1.__exportStar(__webpack_require__(656), exports);
tslib_1.__exportStar(__webpack_require__(657), exports);
tslib_1.__exportStar(__webpack_require__(658), exports);
tslib_1.__exportStar(__webpack_require__(659), exports);
tslib_1.__exportStar(__webpack_require__(660), exports);
tslib_1.__exportStar(__webpack_require__(661), exports);
tslib_1.__exportStar(__webpack_require__(662), exports);
tslib_1.__exportStar(__webpack_require__(663), exports);
tslib_1.__exportStar(__webpack_require__(664), exports);
tslib_1.__exportStar(__webpack_require__(665), exports);
tslib_1.__exportStar(__webpack_require__(666), exports);
tslib_1.__exportStar(__webpack_require__(667), exports);
tslib_1.__exportStar(__webpack_require__(668), exports);
tslib_1.__exportStar(__webpack_require__(669), exports);


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(402), exports);
tslib_1.__exportStar(__webpack_require__(403), exports);
tslib_1.__exportStar(__webpack_require__(404), exports);
tslib_1.__exportStar(__webpack_require__(405), exports);
tslib_1.__exportStar(__webpack_require__(406), exports);
tslib_1.__exportStar(__webpack_require__(407), exports);
tslib_1.__exportStar(__webpack_require__(408), exports);
tslib_1.__exportStar(__webpack_require__(409), exports);
tslib_1.__exportStar(__webpack_require__(410), exports);
tslib_1.__exportStar(__webpack_require__(411), exports);
tslib_1.__exportStar(__webpack_require__(412), exports);
tslib_1.__exportStar(__webpack_require__(413), exports);
tslib_1.__exportStar(__webpack_require__(414), exports);
tslib_1.__exportStar(__webpack_require__(415), exports);
tslib_1.__exportStar(__webpack_require__(416), exports);
tslib_1.__exportStar(__webpack_require__(417), exports);


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var METADATA_KEY = __webpack_require__(14);
var Metadata = (function () {
    function Metadata(key, value) {
        this.key = key;
        this.value = value;
    }
    Metadata.prototype.toString = function () {
        if (this.key === METADATA_KEY.NAMED_TAG) {
            return "named: " + this.value.toString() + " ";
        }
        else {
            return "tagged: { key:" + this.key.toString() + ", value: " + this.value + " }";
        }
    };
    return Metadata;
}());
exports.Metadata = Metadata;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.DUPLICATED_INJECTABLE_DECORATOR = "Cannot apply @injectable decorator multiple times.";
exports.DUPLICATED_METADATA = "Metadata key was used more than once in a parameter:";
exports.NULL_ARGUMENT = "NULL argument";
exports.KEY_NOT_FOUND = "Key Not Found";
exports.AMBIGUOUS_MATCH = "Ambiguous match found for serviceIdentifier:";
exports.CANNOT_UNBIND = "Could not unbind serviceIdentifier:";
exports.NOT_REGISTERED = "No matching bindings found for serviceIdentifier:";
exports.MISSING_INJECTABLE_ANNOTATION = "Missing required @injectable annotation in:";
exports.MISSING_INJECT_ANNOTATION = "Missing required @inject or @multiInject annotation in:";
exports.CIRCULAR_DEPENDENCY = "Circular dependency found:";
exports.NOT_IMPLEMENTED = "Sorry, this feature is not fully implemented yet.";
exports.INVALID_BINDING_TYPE = "Invalid binding type:";
exports.NO_MORE_SNAPSHOTS_AVAILABLE = "No snapshot available to restore.";
exports.INVALID_MIDDLEWARE_RETURN = "Invalid return type in middleware. Middleware must return!";
exports.INVALID_FUNCTION_BINDING = "Value provided to function binding must be a function!";
exports.INVALID_TO_SELF_VALUE = "The toSelf function can only be applied when a constructor is " +
    "used as service identifier";
exports.INVALID_DECORATOR_OPERATION = "The @inject @multiInject @tagged and @named decorators " +
    "must be applied to the parameters of a class constructor or a class property.";
exports.ARGUMENTS_LENGTH_MISMATCH_1 = "The number of constructor arguments in the derived class ";
exports.ARGUMENTS_LENGTH_MISMATCH_2 = " must be >= than the number of constructor arguments of its base class.";
exports.CONTAINER_OPTIONS_MUST_BE_AN_OBJECT = "Invalid Container constructor argument. Container options " +
    "must be an object.";
exports.CONTAINER_OPTIONS_INVALID_DEFAULT_SCOPE = "Invalid Container option. Default scope must " +
    "be a string ('singleton' or 'transient').";
exports.INVALID_BINDING_PROPERTY = "TODO";


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BindingScopeEnum = {
    Singleton: "Singleton",
    Transient: "Transient"
};
exports.BindingScopeEnum = BindingScopeEnum;
var BindingTypeEnum = {
    ConstantValue: "ConstantValue",
    Constructor: "Constructor",
    DynamicValue: "DynamicValue",
    Factory: "Factory",
    Function: "Function",
    Instance: "Instance",
    Invalid: "Invalid",
    Provider: "Provider"
};
exports.BindingTypeEnum = BindingTypeEnum;
var TargetTypeEnum = {
    ClassProperty: "ClassProperty",
    ConstructorArgument: "ConstructorArgument",
    Variable: "Variable"
};
exports.TargetTypeEnum = TargetTypeEnum;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var METADATA_KEY = __webpack_require__(14);
var ERROR_MSGS = __webpack_require__(20);
function tagParameter(annotationTarget, propertyName, parameterIndex, metadata) {
    var metadataKey = METADATA_KEY.TAGGED;
    _tagParameterOrProperty(metadataKey, annotationTarget, propertyName, metadata, parameterIndex);
}
exports.tagParameter = tagParameter;
function tagProperty(annotationTarget, propertyName, metadata) {
    var metadataKey = METADATA_KEY.TAGGED_PROP;
    _tagParameterOrProperty(metadataKey, annotationTarget.constructor, propertyName, metadata);
}
exports.tagProperty = tagProperty;
function _tagParameterOrProperty(metadataKey, annotationTarget, propertyName, metadata, parameterIndex) {
    var paramsOrPropertiesMetadata = {};
    var isParameterDecorator = (typeof parameterIndex === "number");
    var key = (parameterIndex !== undefined && isParameterDecorator) ? parameterIndex.toString() : propertyName;
    if (isParameterDecorator === true && propertyName !== undefined) {
        throw new Error(ERROR_MSGS.INVALID_DECORATOR_OPERATION);
    }
    if (Reflect.hasOwnMetadata(metadataKey, annotationTarget) === true) {
        paramsOrPropertiesMetadata = Reflect.getMetadata(metadataKey, annotationTarget);
    }
    var paramOrPropertyMetadata = paramsOrPropertiesMetadata[key];
    if (Array.isArray(paramOrPropertyMetadata) !== true) {
        paramOrPropertyMetadata = [];
    }
    else {
        for (var i = 0; i < paramOrPropertyMetadata.length; i++) {
            var m = paramOrPropertyMetadata[i];
            if (m.key === metadata.key) {
                throw new Error(ERROR_MSGS.DUPLICATED_METADATA + " " + m.key);
            }
        }
    }
    paramOrPropertyMetadata.push(metadata);
    paramsOrPropertiesMetadata[key] = paramOrPropertyMetadata;
    Reflect.defineMetadata(metadataKey, paramsOrPropertiesMetadata, annotationTarget);
}
function _decorate(decorators, target) {
    Reflect.decorate(decorators, target);
}
function _param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); };
}
function decorate(decorator, target, parameterIndex) {
    if (typeof parameterIndex === "number") {
        _decorate([_param(parameterIndex, decorator)], target);
    }
    else {
        _decorate([decorator], target);
    }
}
exports.decorate = decorate;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(338), exports);
tslib_1.__exportStar(__webpack_require__(339), exports);
tslib_1.__exportStar(__webpack_require__(340), exports);
tslib_1.__exportStar(__webpack_require__(341), exports);
tslib_1.__exportStar(__webpack_require__(342), exports);
tslib_1.__exportStar(__webpack_require__(343), exports);
tslib_1.__exportStar(__webpack_require__(344), exports);
tslib_1.__exportStar(__webpack_require__(345), exports);
tslib_1.__exportStar(__webpack_require__(346), exports);
tslib_1.__exportStar(__webpack_require__(347), exports);
tslib_1.__exportStar(__webpack_require__(348), exports);
tslib_1.__exportStar(__webpack_require__(349), exports);


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function guid() {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    return s4() + s4() + "-" + s4() + "-" + s4() + "-" +
        s4() + "-" + s4() + s4() + s4();
}
exports.guid = guid;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(324), exports);
tslib_1.__exportStar(__webpack_require__(325), exports);
tslib_1.__exportStar(__webpack_require__(326), exports);
tslib_1.__exportStar(__webpack_require__(327), exports);
tslib_1.__exportStar(__webpack_require__(328), exports);
tslib_1.__exportStar(__webpack_require__(329), exports);
tslib_1.__exportStar(__webpack_require__(330), exports);
tslib_1.__exportStar(__webpack_require__(331), exports);
tslib_1.__exportStar(__webpack_require__(332), exports);
tslib_1.__exportStar(__webpack_require__(333), exports);


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(381), exports);
tslib_1.__exportStar(__webpack_require__(382), exports);
tslib_1.__exportStar(__webpack_require__(383), exports);
tslib_1.__exportStar(__webpack_require__(384), exports);
tslib_1.__exportStar(__webpack_require__(385), exports);
tslib_1.__exportStar(__webpack_require__(386), exports);
tslib_1.__exportStar(__webpack_require__(387), exports);
tslib_1.__exportStar(__webpack_require__(388), exports);
tslib_1.__exportStar(__webpack_require__(389), exports);
tslib_1.__exportStar(__webpack_require__(390), exports);


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(634), exports);
tslib_1.__exportStar(__webpack_require__(635), exports);
tslib_1.__exportStar(__webpack_require__(636), exports);
tslib_1.__exportStar(__webpack_require__(637), exports);
tslib_1.__exportStar(__webpack_require__(638), exports);
tslib_1.__exportStar(__webpack_require__(639), exports);
tslib_1.__exportStar(__webpack_require__(640), exports);
tslib_1.__exportStar(__webpack_require__(641), exports);
tslib_1.__exportStar(__webpack_require__(650), exports);


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ERROR_MSGS = __webpack_require__(20);
function getServiceIdentifierAsString(serviceIdentifier) {
    if (typeof serviceIdentifier === "function") {
        var _serviceIdentifier = serviceIdentifier;
        return _serviceIdentifier.name;
    }
    else if (typeof serviceIdentifier === "symbol") {
        return serviceIdentifier.toString();
    }
    else {
        var _serviceIdentifier = serviceIdentifier;
        return _serviceIdentifier;
    }
}
exports.getServiceIdentifierAsString = getServiceIdentifierAsString;
function listRegisteredBindingsForServiceIdentifier(container, serviceIdentifier, getBindings) {
    var registeredBindingsList = "";
    var registeredBindings = getBindings(container, serviceIdentifier);
    if (registeredBindings.length !== 0) {
        registeredBindingsList = "\nRegistered bindings:";
        registeredBindings.forEach(function (binding) {
            var name = "Object";
            if (binding.implementationType !== null) {
                name = getFunctionName(binding.implementationType);
            }
            registeredBindingsList = registeredBindingsList + "\n " + name;
            if (binding.constraint.metaData) {
                registeredBindingsList = registeredBindingsList + " - " + binding.constraint.metaData;
            }
        });
    }
    return registeredBindingsList;
}
exports.listRegisteredBindingsForServiceIdentifier = listRegisteredBindingsForServiceIdentifier;
function circularDependencyToException(request, previousServiceIdentifiers) {
    if (previousServiceIdentifiers === void 0) { previousServiceIdentifiers = []; }
    var parentServiceIdentifier = getServiceIdentifierAsString(request.serviceIdentifier);
    previousServiceIdentifiers.push(parentServiceIdentifier);
    request.childRequests.forEach(function (childRequest) {
        var childServiceIdentifier = getServiceIdentifierAsString(childRequest.serviceIdentifier);
        if (previousServiceIdentifiers.indexOf(childServiceIdentifier) === -1) {
            if (childRequest.childRequests.length > 0) {
                circularDependencyToException(childRequest, previousServiceIdentifiers);
            }
            else {
                previousServiceIdentifiers.push(childServiceIdentifier);
            }
        }
        else {
            previousServiceIdentifiers.push(childServiceIdentifier);
            var services = previousServiceIdentifiers.reduce(function (prev, curr) {
                return (prev !== "") ? prev + " -> " + curr : "" + curr;
            }, "");
            throw new Error(ERROR_MSGS.CIRCULAR_DEPENDENCY + " " + services);
        }
    });
}
exports.circularDependencyToException = circularDependencyToException;
function listMetadataForTarget(serviceIdentifierString, target) {
    if (target.isTagged() || target.isNamed()) {
        var m_1 = "";
        var namedTag = target.getNamedTag();
        var otherTags = target.getCustomTags();
        if (namedTag !== null) {
            m_1 += namedTag.toString() + "\n";
        }
        if (otherTags !== null) {
            otherTags.forEach(function (tag) {
                m_1 += tag.toString() + "\n";
            });
        }
        return " " + serviceIdentifierString + "\n " + serviceIdentifierString + " - " + m_1;
    }
    else {
        return " " + serviceIdentifierString;
    }
}
exports.listMetadataForTarget = listMetadataForTarget;
function getFunctionName(v) {
    if (v.name) {
        return v.name;
    }
    else {
        var name_1 = v.toString();
        var match = name_1.match(/^function\s*([^\s(]+)/);
        return match ? match[1] : "Anonymous function: " + name_1;
    }
}
exports.getFunctionName = getFunctionName;


/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(246), exports);
tslib_1.__exportStar(__webpack_require__(247), exports);
tslib_1.__exportStar(__webpack_require__(248), exports);
tslib_1.__exportStar(__webpack_require__(249), exports);
tslib_1.__exportStar(__webpack_require__(250), exports);
tslib_1.__exportStar(__webpack_require__(251), exports);


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(395), exports);
tslib_1.__exportStar(__webpack_require__(396), exports);
tslib_1.__exportStar(__webpack_require__(397), exports);
tslib_1.__exportStar(__webpack_require__(398), exports);
tslib_1.__exportStar(__webpack_require__(399), exports);
tslib_1.__exportStar(__webpack_require__(400), exports);


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(672), exports);
tslib_1.__exportStar(__webpack_require__(673), exports);
tslib_1.__exportStar(__webpack_require__(674), exports);
tslib_1.__exportStar(__webpack_require__(675), exports);
tslib_1.__exportStar(__webpack_require__(676), exports);
tslib_1.__exportStar(__webpack_require__(677), exports);
tslib_1.__exportStar(__webpack_require__(678), exports);
tslib_1.__exportStar(__webpack_require__(679), exports);


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(141), exports);
tslib_1.__exportStar(__webpack_require__(142), exports);
var diModule_1 = __webpack_require__(143);
exports.coreDIModule = diModule_1.diModule;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(807), exports);
tslib_1.__exportStar(__webpack_require__(808), exports);
tslib_1.__exportStar(__webpack_require__(809), exports);
tslib_1.__exportStar(__webpack_require__(810), exports);


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(49), exports);
tslib_1.__exportStar(__webpack_require__(144), exports);
tslib_1.__exportStar(__webpack_require__(670), exports);
var httpApi_1 = __webpack_require__(4);
exports.IHttpClient = httpApi_1.IHttpClient;
exports.IHttpHeaders = httpApi_1.IHttpHeaders;
exports.IHttpRequest = httpApi_1.IHttpRequest;
exports.IHttpResponse = httpApi_1.IHttpResponse;
var contracts_1 = __webpack_require__(3);
exports.IStorageHandler = contracts_1.IStorageHandler;
exports.IEventHandler = contracts_1.IEventHandler;
exports.ITokenHandler = contracts_1.ITokenHandler;
exports.IBaasicAppOptions = contracts_1.IBaasicAppOptions;
exports.IBaasicOptions = contracts_1.IBaasicOptions;
exports.IToken = contracts_1.IToken;
exports.TokenTypes = contracts_1.TokenTypes;
exports.IUser = contracts_1.IUser;
exports.IUserHandler = contracts_1.IUserHandler;
exports.IDefaultStorageConfig = contracts_1.IDefaultStorageConfig;
tslib_1.__exportStar(__webpack_require__(2), exports);
tslib_1.__exportStar(__webpack_require__(45), exports);


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var binding_on_syntax_1 = __webpack_require__(36);
var constraint_helpers_1 = __webpack_require__(42);
var BindingWhenSyntax = (function () {
    function BindingWhenSyntax(binding) {
        this._binding = binding;
    }
    BindingWhenSyntax.prototype.when = function (constraint) {
        this._binding.constraint = constraint;
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenTargetNamed = function (name) {
        this._binding.constraint = constraint_helpers_1.namedConstraint(name);
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenTargetIsDefault = function () {
        this._binding.constraint = function (request) {
            var targetIsDefault = (request.target !== null) &&
                (request.target.isNamed() === false) &&
                (request.target.isTagged() === false);
            return targetIsDefault;
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenTargetTagged = function (tag, value) {
        this._binding.constraint = constraint_helpers_1.taggedConstraint(tag)(value);
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenInjectedInto = function (parent) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.typeConstraint(parent)(request.parentRequest);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenParentNamed = function (name) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.namedConstraint(name)(request.parentRequest);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenParentTagged = function (tag, value) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.taggedConstraint(tag)(value)(request.parentRequest);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.typeConstraint(ancestor));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.typeConstraint(ancestor));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorNamed = function (name) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.namedConstraint(name));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorNamed = function (name) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.namedConstraint(name));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.taggedConstraint(tag)(value));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint_helpers_1.taggedConstraint(tag)(value));
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        this._binding.constraint = function (request) {
            return constraint_helpers_1.traverseAncerstors(request, constraint);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    BindingWhenSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        this._binding.constraint = function (request) {
            return !constraint_helpers_1.traverseAncerstors(request, constraint);
        };
        return new binding_on_syntax_1.BindingOnSyntax(this._binding);
    };
    return BindingWhenSyntax;
}());
exports.BindingWhenSyntax = BindingWhenSyntax;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var binding_when_syntax_1 = __webpack_require__(35);
var BindingOnSyntax = (function () {
    function BindingOnSyntax(binding) {
        this._binding = binding;
    }
    BindingOnSyntax.prototype.onActivation = function (handler) {
        this._binding.onActivation = handler;
        return new binding_when_syntax_1.BindingWhenSyntax(this._binding);
    };
    return BindingOnSyntax;
}());
exports.BindingOnSyntax = BindingOnSyntax;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _undefined = __webpack_require__(84)(); // Support ES3 engines

module.exports = function (val) {
 return (val !== _undefined) && (val !== null);
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(145), exports);
tslib_1.__exportStar(__webpack_require__(146), exports);
tslib_1.__exportStar(__webpack_require__(147), exports);
tslib_1.__exportStar(__webpack_require__(148), exports);


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(241), exports);
tslib_1.__exportStar(__webpack_require__(242), exports);
tslib_1.__exportStar(__webpack_require__(243), exports);
tslib_1.__exportStar(__webpack_require__(244), exports);


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metadata_1 = __webpack_require__(19);
var queryable_string_1 = __webpack_require__(57);
var guid_1 = __webpack_require__(24);
var METADATA_KEY = __webpack_require__(14);
var Target = (function () {
    function Target(type, name, serviceIdentifier, namedOrTagged) {
        this.guid = guid_1.guid();
        this.type = type;
        this.serviceIdentifier = serviceIdentifier;
        this.name = new queryable_string_1.QueryableString(name || "");
        this.metadata = new Array();
        var metadataItem = null;
        if (typeof namedOrTagged === "string") {
            metadataItem = new metadata_1.Metadata(METADATA_KEY.NAMED_TAG, namedOrTagged);
        }
        else if (namedOrTagged instanceof metadata_1.Metadata) {
            metadataItem = namedOrTagged;
        }
        if (metadataItem !== null) {
            this.metadata.push(metadataItem);
        }
    }
    Target.prototype.hasTag = function (key) {
        for (var i = 0; i < this.metadata.length; i++) {
            var m = this.metadata[i];
            if (m.key === key) {
                return true;
            }
        }
        return false;
    };
    Target.prototype.isArray = function () {
        return this.hasTag(METADATA_KEY.MULTI_INJECT_TAG);
    };
    Target.prototype.matchesArray = function (name) {
        return this.matchesTag(METADATA_KEY.MULTI_INJECT_TAG)(name);
    };
    Target.prototype.isNamed = function () {
        return this.hasTag(METADATA_KEY.NAMED_TAG);
    };
    Target.prototype.isTagged = function () {
        return this.metadata.some(function (m) {
            return (m.key !== METADATA_KEY.INJECT_TAG) &&
                (m.key !== METADATA_KEY.MULTI_INJECT_TAG) &&
                (m.key !== METADATA_KEY.NAME_TAG) &&
                (m.key !== METADATA_KEY.UNMANAGED_TAG) &&
                (m.key !== METADATA_KEY.NAMED_TAG);
        });
    };
    Target.prototype.isOptional = function () {
        return this.matchesTag(METADATA_KEY.OPTIONAL_TAG)(true);
    };
    Target.prototype.getNamedTag = function () {
        if (this.isNamed()) {
            return this.metadata.filter(function (m) { return m.key === METADATA_KEY.NAMED_TAG; })[0];
        }
        return null;
    };
    Target.prototype.getCustomTags = function () {
        if (this.isTagged()) {
            return this.metadata.filter(function (m) {
                return (m.key !== METADATA_KEY.INJECT_TAG) &&
                    (m.key !== METADATA_KEY.MULTI_INJECT_TAG) &&
                    (m.key !== METADATA_KEY.NAME_TAG) &&
                    (m.key !== METADATA_KEY.UNMANAGED_TAG) &&
                    (m.key !== METADATA_KEY.NAMED_TAG);
            });
        }
        return null;
    };
    Target.prototype.matchesNamedTag = function (name) {
        return this.matchesTag(METADATA_KEY.NAMED_TAG)(name);
    };
    Target.prototype.matchesTag = function (key) {
        var _this = this;
        return function (value) {
            for (var i = 0; i < _this.metadata.length; i++) {
                var m = _this.metadata[i];
                if (m.key === key && m.value === value) {
                    return true;
                }
            }
            return false;
        };
    };
    return Target;
}());
exports.Target = Target;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var binding_when_syntax_1 = __webpack_require__(35);
var binding_on_syntax_1 = __webpack_require__(36);
var BindingWhenOnSyntax = (function () {
    function BindingWhenOnSyntax(binding) {
        this._binding = binding;
        this._bindingWhenSyntax = new binding_when_syntax_1.BindingWhenSyntax(this._binding);
        this._bindingOnSyntax = new binding_on_syntax_1.BindingOnSyntax(this._binding);
    }
    BindingWhenOnSyntax.prototype.when = function (constraint) {
        return this._bindingWhenSyntax.when(constraint);
    };
    BindingWhenOnSyntax.prototype.whenTargetNamed = function (name) {
        return this._bindingWhenSyntax.whenTargetNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenTargetIsDefault = function () {
        return this._bindingWhenSyntax.whenTargetIsDefault();
    };
    BindingWhenOnSyntax.prototype.whenTargetTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenTargetTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenInjectedInto = function (parent) {
        return this._bindingWhenSyntax.whenInjectedInto(parent);
    };
    BindingWhenOnSyntax.prototype.whenParentNamed = function (name) {
        return this._bindingWhenSyntax.whenParentNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenParentTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenParentTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenAnyAncestorIs(ancestor);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenNoAncestorIs(ancestor);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenAnyAncestorNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenAnyAncestorTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenNoAncestorNamed(name);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenNoAncestorTagged(tag, value);
    };
    BindingWhenOnSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenAnyAncestorMatches(constraint);
    };
    BindingWhenOnSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenNoAncestorMatches(constraint);
    };
    BindingWhenOnSyntax.prototype.onActivation = function (handler) {
        return this._bindingOnSyntax.onActivation(handler);
    };
    return BindingWhenOnSyntax;
}());
exports.BindingWhenOnSyntax = BindingWhenOnSyntax;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metadata_1 = __webpack_require__(19);
var METADATA_KEY = __webpack_require__(14);
var traverseAncerstors = function (request, constraint) {
    var parent = request.parentRequest;
    if (parent !== null) {
        return constraint(parent) ? true : traverseAncerstors(parent, constraint);
    }
    else {
        return false;
    }
};
exports.traverseAncerstors = traverseAncerstors;
var taggedConstraint = function (key) { return function (value) {
    var constraint = function (request) {
        return request !== null && request.target !== null && request.target.matchesTag(key)(value);
    };
    constraint.metaData = new metadata_1.Metadata(key, value);
    return constraint;
}; };
exports.taggedConstraint = taggedConstraint;
var namedConstraint = taggedConstraint(METADATA_KEY.NAMED_TAG);
exports.namedConstraint = namedConstraint;
var typeConstraint = function (type) { return function (request) {
    var binding = null;
    if (request !== null) {
        binding = request.bindings[0];
        if (typeof type === "string") {
            var serviceIdentifier = binding.serviceIdentifier;
            return serviceIdentifier === type;
        }
        else {
            var constructor = request.bindings[0].implementationType;
            return type === constructor;
        }
    }
    return false;
}; };
exports.typeConstraint = typeConstraint;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(4);
var TYPES = {
    ApiClient: Symbol("ApiClient"),
    IHttpClient: Symbol("IHttpClient"),
    IAbortSignal: Symbol("IAbortSignal")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ApiClient).to(_1.ApiClient);
});
exports.diModule = diModule;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(2);
var TYPES = {
    Utility: Symbol("Utility"),
    DateFormatter: Symbol("DateFormatter"),
    ModelMapper: Symbol("ModelMapper"),
    IHALParser: Symbol("IHALParser"),
    IURLFactory: Symbol("IURLFactory")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.Utility).to(_1.Utility);
    bind(TYPES.DateFormatter).to(_1.DateFormatter);
    bind(TYPES.ModelMapper).to(_1.ModelMapper);
    bind(TYPES.IHALParser).toConstantValue(_1.HALParser);
});
exports.diModule = diModule;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ApplicationSettings = __webpack_require__(38);
exports.ApplicationSettings = ApplicationSettings;
var Membership = __webpack_require__(13);
exports.Membership = Membership;
var UserProfile = __webpack_require__(9);
exports.UserProfile = UserProfile;
var KeyValue = __webpack_require__(39);
exports.KeyValue = KeyValue;
var ValueSet = __webpack_require__(29);
exports.ValueSet = ValueSet;
var Article = __webpack_require__(6);
exports.Article = Article;
var DynamicResource = __webpack_require__(25);
exports.DynamicResource = DynamicResource;
var MediaVault = __webpack_require__(23);
exports.MediaVault = MediaVault;
var MediaGallery = __webpack_require__(15);
exports.MediaGallery = MediaGallery;
var Files = __webpack_require__(26);
exports.Files = Files;
var Templating = __webpack_require__(30);
exports.Templating = Templating;
var Metering = __webpack_require__(18);
exports.Metering = Metering;
var Notifications = __webpack_require__(10);
exports.Notifications = Notifications;
var Commerce = __webpack_require__(5);
exports.Commerce = Commerce;
var Calendar = __webpack_require__(7);
exports.Calendar = Calendar;
var ShoppingCart = __webpack_require__(27);
exports.ShoppingCart = ShoppingCart;
var Blog = __webpack_require__(17);
exports.Blog = Blog;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleClient
 * @description  Articles Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleClient` uses `articleRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var common_1 = __webpack_require__(2);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleClient = /** @class */ (function () {
    function ArticleClient(articleInstanceCommentsClient, articleInstanceFilesClient, articleInstanceRatingsClient, articleInstanceTagsClient, articleInstanceSubscriptionsClient, articleRoute, articleACLClient, apiClient) {
        this.articleInstanceCommentsClient = articleInstanceCommentsClient;
        this.articleInstanceFilesClient = articleInstanceFilesClient;
        this.articleInstanceRatingsClient = articleInstanceRatingsClient;
        this.articleInstanceTagsClient = articleInstanceTagsClient;
        this.articleInstanceSubscriptionsClient = articleInstanceSubscriptionsClient;
        this.articleRoute = articleRoute;
        this.articleACLClient = articleACLClient;
        this.apiClient = apiClient;
        this.utility = new common_1.Utility();
        this.articleUtility = new _1.BaasicArticleUtility();
        this.statuses = _1.ArticleStatus;
        this.commentStatuses = _1.CommentStatus;
    }
    Object.defineProperty(ArticleClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `articleRoute`.
         * @method
         * @example articleClient.routeDefinition.get();
         **/
        get: function () {
            return this.articleRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleClient.prototype, "comments", {
        get: function () {
            return this.articleInstanceCommentsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleClient.prototype, "files", {
        get: function () {
            return this.articleInstanceFilesClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleClient.prototype, "tags", {
        get: function () {
            return this.articleInstanceTagsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleClient.prototype, "ratings", {
        get: function () {
            return this.articleInstanceRatingsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleClient.prototype, "subscriptions", {
        get: function () {
            return this.articleInstanceSubscriptionsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleClient.prototype, "acl", {
        get: function () {
            return this.articleACLClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article resources matching the given criteria.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    ArticleClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a single article resource.
     * @method
     * @param id Article slug or id which uniquely identifies article resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @returns a promise that is resolved once the get action has been performed.
     * @example articleClient.get('<article-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.articleRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create article action has been performed, this action creates a new article resource.
     * @method
     * @param data An article object that needs to be inserted into the system.
     * @returns a promise that is resolved once the create article action has been performed.
     * @example articleClient.create({
                    publishDate : new Date(),
                    title : '<title>',
                    content : '<content>',
                    slug : '',
                    status : baasicArticleService.statuses.draft,
                    $tags : ['<tag1>', '<tag2>']
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    ArticleClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update article action has been performed; this action updates an article resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(article);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An article object that needs to be updated into the system.
     * @returns A promise that is resolved once the update article action has been performed.
     * @example // article is a resource previously fetched using get action.
                    article.title = '<title>';
                    articleClient.update(article)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the saveDraft article action has been performed. This action saves an article with "draft" status. If an article does not exist it will create a new article resource otherwise it will update an existing article resource.
     * @method
     * @param data An article object that needs to be inserted into the system.
     * @returns A promise that is resolved once the saveDraft article action has been performed.
     * @example // article is a resource previously fetched using get action.
                        articleClient.saveDraft(article)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    ArticleClient.prototype.saveDraft = function (data) {
        if (this.utility.isUndefined(data.id)) {
            // Create new draft
            return this.create(data);
        }
        // Update draft
        return this.update(data);
    };
    /**
     * Returns a promise that is resolved once the remove article action has been performed. If the action is successfully completed, the article resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(article);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An article object that needs to be removed from the system.
     * @returns A promise that is resolved once the remove article action has been performed.
     * @example // article is a resource previously fetched using get action.
                    articleClient.remove(article)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the archive article action has been performed. This action sets the status of an article from "published" to "archive". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(article);
     * let uri = params['model'].links('archive').href;
     * ```
     * @method
     * @param data An article object.
     * @param options Notification options.
     * @returns A promise that is resolved once the archive article action has been performed.
     * @example // article is a resource previously fetched using get action.
                    articleClient.archive(article, articleOptions)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleClient.prototype.archive = function (data, options) {
        return this.apiClient.put(this.routeDefinition.archive(data), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the restore article action has been performed. This action sets the status of an article from "archive" to "published". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicArticleRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(article);
     * let uri = params['model'].links('restore').href;
     * ```
     * @method
     * @param data Article object.
     * @returns A promise that is resolved once the restore article action has been performed.
     * @example // article is a resource previously fetched using get action.
                        articleClient.restore(article)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    ArticleClient.prototype.restore = function (data) {
        return this.apiClient.put(this.routeDefinition.restore(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unpublish article action has been performed. This action sets the status of an article from "published" to "draft". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(article);
     * let uri = params['model'].links('unpublish').href;
     * ```
     * @method
     * @param data An article object.
     * @returns A promise that is resolved once the unpublish article action has been performed.
     * @example 	// article is a resource previously fetched using get action.
                        articleClient.unpublish(article)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    ArticleClient.prototype.unpublish = function (data) {
        return this.apiClient.put(this.routeDefinition.unpublish(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the publish article action has been performed. This action sets the status of an article from "draft" to "published".
     * @method
     * @param data An article object.
     * @param articleOptions Notification options.
     * @returns A promise that is resolved once the unpublish article action has been performed.
     * @example articleClient.publish(article, articleOptions)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleClient.prototype.publish = function (data, articleOptions) {
        return this.apiClient.put(this.routeDefinition.publish(data), this.routeDefinition.updateParams(articleOptions));
    };
    /**
     * Returns a promise that is resolved once the purge articles action has been performed. Please note that all article resources will be deleted from the system once the action is successfully completed and therefore it can only be executed by user assigned to account owner role.
     * @method
     * @example articleClient.purge({})
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleClient.prototype.purge = function (options) {
        return this.apiClient.delete(this.routeDefinition.purge(options));
    };
    var _a, _b, _c, _d, _e, _f, _g, _h;
    ArticleClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleInstanceCommentsClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ArticleInstanceFilesClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.ArticleInstanceRatingsClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.ArticleInstanceTagsClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.ArticleInstanceSubscriptionsClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.ArticleRoute)),
        tslib_1.__param(6, inversify_1.inject(_1.TYPES.ArticleACLClient)),
        tslib_1.__param(7, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleInstanceCommentsClient !== "undefined" && _1.ArticleInstanceCommentsClient) === "function" ? _a : Object, typeof (_b = typeof _1.ArticleInstanceFilesClient !== "undefined" && _1.ArticleInstanceFilesClient) === "function" ? _b : Object, typeof (_c = typeof _1.ArticleInstanceRatingsClient !== "undefined" && _1.ArticleInstanceRatingsClient) === "function" ? _c : Object, typeof (_d = typeof _1.ArticleInstanceTagsClient !== "undefined" && _1.ArticleInstanceTagsClient) === "function" ? _d : Object, typeof (_e = typeof _1.ArticleInstanceSubscriptionsClient !== "undefined" && _1.ArticleInstanceSubscriptionsClient) === "function" ? _e : Object, typeof (_f = typeof _1.ArticleRoute !== "undefined" && _1.ArticleRoute) === "function" ? _f : Object, typeof (_g = typeof _1.ArticleACLClient !== "undefined" && _1.ArticleACLClient) === "function" ? _g : Object, typeof (_h = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _h : Object])
    ], ArticleClient);
    return ArticleClient;
}());
exports.ArticleClient = ArticleClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(460), exports);
tslib_1.__exportStar(__webpack_require__(465), exports);
tslib_1.__exportStar(__webpack_require__(470), exports);
tslib_1.__exportStar(__webpack_require__(475), exports);
tslib_1.__exportStar(__webpack_require__(480), exports);
tslib_1.__exportStar(__webpack_require__(485), exports);
tslib_1.__exportStar(__webpack_require__(490), exports);
tslib_1.__exportStar(__webpack_require__(495), exports);
tslib_1.__exportStar(__webpack_require__(500), exports);
tslib_1.__exportStar(__webpack_require__(505), exports);


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(608), exports);
tslib_1.__exportStar(__webpack_require__(613), exports);
tslib_1.__exportStar(__webpack_require__(618), exports);
tslib_1.__exportStar(__webpack_require__(623), exports);
tslib_1.__exportStar(__webpack_require__(628), exports);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var contracts_1 = __webpack_require__(3);
var jQuery_1 = __webpack_require__(135);
var localStorage_1 = __webpack_require__(137);
var browserEvents_1 = __webpack_require__(139);
var core_1 = __webpack_require__(32);
var DIModule = /** @class */ (function () {
    function DIModule() {
        this.diModules = [];
        this.kernel = new inversify_1.Container();
    }
    DIModule.prototype.init = function (app, modules) {
        var _this = this;
        var _a;
        var diModule = new inversify_1.ContainerModule(function (bind) {
            var apiKey = app.getApiKey();
            var urlBuilder = [(app.settings.useSSL ? 'https' : 'http') + "://" + app.settings.apiRootUrl];
            if (app.settings.apiVersion) {
                urlBuilder.push(app.settings.apiVersion);
            }
            urlBuilder.push(apiKey);
            urlBuilder.push('');
            if (app.settings) {
                var appOptions = {
                    apiKey: apiKey,
                    apiUrl: urlBuilder.join('/'),
                    enableHALJSON: app.settings.enableHALJSON
                };
                app.settings.apiUrl = appOptions.apiUrl;
                _this.kernel.bind(contracts_1.TYPES.IAppOptions).toConstantValue(appOptions);
                _this.kernel.bind(contracts_1.TYPES.IBaasicAppOptions).toConstantValue(app.settings);
            }
            _this.bindHandler(httpApi_1.httpTYPES.IHttpClient, app.settings.httpClient, jQuery_1.JQueryHttpClient);
            _this.bindHandlerWithOptions(contracts_1.TYPES.IStorageHandler, contracts_1.TYPES.IDefaultStorageConfig, app.settings.storageHandler, localStorage_1.LocalStorageHandler);
            if (app.settings.TokenHandler) {
                _this.kernel.bind(contracts_1.TYPES.ITokenHandler).to(app.settings.TokenHandler).inSingletonScope();
            }
            else {
                _this.kernel.bind(contracts_1.TYPES.ITokenHandler).to(core_1.TokenHandler).inSingletonScope();
            }
            _this.bindHandler(contracts_1.TYPES.IEventHandler, app.settings.eventHandler, browserEvents_1.BrowserEventHandler);
            if (app.settings.abortSignal) {
                _this.kernel.bind(httpApi_1.httpTYPES.IAbortSignal).toConstantValue(app.settings.abortSignal());
            }
            _this.kernel.bind(contracts_1.TYPES.IBaasicApp).toConstantValue(app);
        });
        this.diModules.push(diModule);
        for (var _i = 0, modules_1 = modules; _i < modules_1.length; _i++) {
            var m = modules_1[_i];
            this.addModule(m);
        }
        (_a = this.kernel).load.apply(_a, this.diModules);
    };
    DIModule.prototype.bindHandler = function (type, value, defaultBinding) {
        if (value) {
            this.kernel.bind(type).toConstantValue(value());
        }
        else {
            this.kernel.bind(type).to(defaultBinding);
        }
    };
    DIModule.prototype.bindHandlerWithOptions = function (type, optionType, value, defaultBinding) {
        if (value) {
            if (value instanceof Function) {
                this.kernel.bind(type).toConstantValue(value());
                return;
            }
            else {
                this.kernel.bind(optionType).toConstantValue(value);
            }
        }
        this.kernel.bind(type).to(defaultBinding);
    };
    DIModule.prototype.addModule = function (module) {
        if (module instanceof inversify_1.ContainerModule) {
            this.diModules.push(module);
        }
        else if (module instanceof Object && !(module instanceof Function)) {
            for (var mod in module) {
                this.addModule(module[mod]);
            }
        }
    };
    return DIModule;
}());
exports.DIModule = DIModule;
;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var binding_1 = __webpack_require__(51);
var lookup_1 = __webpack_require__(52);
var planner_1 = __webpack_require__(53);
var resolver_1 = __webpack_require__(60);
var binding_to_syntax_1 = __webpack_require__(62);
var serialization_1 = __webpack_require__(28);
var container_snapshot_1 = __webpack_require__(65);
var guid_1 = __webpack_require__(24);
var ERROR_MSGS = __webpack_require__(20);
var METADATA_KEY = __webpack_require__(14);
var literal_types_1 = __webpack_require__(21);
var Container = (function () {
    function Container(containerOptions) {
        if (containerOptions !== undefined) {
            if (typeof containerOptions !== "object") {
                throw new Error("" + ERROR_MSGS.CONTAINER_OPTIONS_MUST_BE_AN_OBJECT);
            }
            else if (containerOptions.defaultScope === undefined) {
                throw new Error("" + ERROR_MSGS.CONTAINER_OPTIONS_INVALID_DEFAULT_SCOPE);
            }
            else if (containerOptions.defaultScope !== literal_types_1.BindingScopeEnum.Singleton &&
                containerOptions.defaultScope !== literal_types_1.BindingScopeEnum.Transient) {
                throw new Error("" + ERROR_MSGS.CONTAINER_OPTIONS_INVALID_DEFAULT_SCOPE);
            }
            this.options = {
                defaultScope: containerOptions.defaultScope
            };
        }
        else {
            this.options = {
                defaultScope: literal_types_1.BindingScopeEnum.Transient
            };
        }
        this.guid = guid_1.guid();
        this._bindingDictionary = new lookup_1.Lookup();
        this._snapshots = [];
        this._middleware = null;
        this.parent = null;
    }
    Container.merge = function (container1, container2) {
        var container = new Container();
        var bindingDictionary = planner_1.getBindingDictionary(container);
        var bindingDictionary1 = planner_1.getBindingDictionary(container1);
        var bindingDictionary2 = planner_1.getBindingDictionary(container2);
        function copyDictionary(origing, destination) {
            origing.traverse(function (key, value) {
                value.forEach(function (binding) {
                    destination.add(binding.serviceIdentifier, binding.clone());
                });
            });
        }
        copyDictionary(bindingDictionary1, bindingDictionary);
        copyDictionary(bindingDictionary2, bindingDictionary);
        return container;
    };
    Container.prototype.load = function () {
        var _this = this;
        var modules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            modules[_i] = arguments[_i];
        }
        var setModuleId = function (bindingToSyntax, moduleId) {
            bindingToSyntax._binding.moduleId = moduleId;
        };
        var getBindFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var _bind = _this.bind.bind(_this);
                var bindingToSyntax = _bind(serviceIdentifier);
                setModuleId(bindingToSyntax, moduleId);
                return bindingToSyntax;
            };
        };
        var getUnbindFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var _unbind = _this.unbind.bind(_this);
                _unbind(serviceIdentifier);
            };
        };
        var getIsboundFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var _isBound = _this.isBound.bind(_this);
                return _isBound(serviceIdentifier);
            };
        };
        var getRebindFunction = function (moduleId) {
            return function (serviceIdentifier) {
                var _rebind = _this.rebind.bind(_this);
                var bindingToSyntax = _rebind(serviceIdentifier);
                setModuleId(bindingToSyntax, moduleId);
                return bindingToSyntax;
            };
        };
        modules.forEach(function (module) {
            var bindFunction = getBindFunction(module.guid);
            var unbindFunction = getUnbindFunction(module.guid);
            var isboundFunction = getIsboundFunction(module.guid);
            var rebindFunction = getRebindFunction(module.guid);
            module.registry(bindFunction, unbindFunction, isboundFunction, rebindFunction);
        });
    };
    Container.prototype.unload = function () {
        var _this = this;
        var modules = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            modules[_i] = arguments[_i];
        }
        var conditionFactory = function (expected) { return function (item) {
            return item.moduleId === expected;
        }; };
        modules.forEach(function (module) {
            var condition = conditionFactory(module.guid);
            _this._bindingDictionary.removeByCondition(condition);
        });
    };
    Container.prototype.bind = function (serviceIdentifier) {
        var defaultScope = literal_types_1.BindingScopeEnum.Transient;
        defaultScope = (this.options.defaultScope === defaultScope) ? defaultScope : literal_types_1.BindingScopeEnum.Singleton;
        var binding = new binding_1.Binding(serviceIdentifier, defaultScope);
        this._bindingDictionary.add(serviceIdentifier, binding);
        return new binding_to_syntax_1.BindingToSyntax(binding);
    };
    Container.prototype.rebind = function (serviceIdentifier) {
        this.unbind(serviceIdentifier);
        return this.bind(serviceIdentifier);
    };
    Container.prototype.unbind = function (serviceIdentifier) {
        try {
            this._bindingDictionary.remove(serviceIdentifier);
        }
        catch (e) {
            throw new Error(ERROR_MSGS.CANNOT_UNBIND + " " + serialization_1.getServiceIdentifierAsString(serviceIdentifier));
        }
    };
    Container.prototype.unbindAll = function () {
        this._bindingDictionary = new lookup_1.Lookup();
    };
    Container.prototype.isBound = function (serviceIdentifier) {
        return this._bindingDictionary.hasKey(serviceIdentifier);
    };
    Container.prototype.isBoundNamed = function (serviceIdentifier, named) {
        return this.isBoundTagged(serviceIdentifier, METADATA_KEY.NAMED_TAG, named);
    };
    Container.prototype.isBoundTagged = function (serviceIdentifier, key, value) {
        var bindings = this._bindingDictionary.get(serviceIdentifier);
        var request = planner_1.createMockRequest(this, serviceIdentifier, key, value);
        return bindings.some(function (b) { return b.constraint(request); });
    };
    Container.prototype.snapshot = function () {
        this._snapshots.push(container_snapshot_1.ContainerSnapshot.of(this._bindingDictionary.clone(), this._middleware));
    };
    Container.prototype.restore = function () {
        var snapshot = this._snapshots.pop();
        if (snapshot === undefined) {
            throw new Error(ERROR_MSGS.NO_MORE_SNAPSHOTS_AVAILABLE);
        }
        this._bindingDictionary = snapshot.bindings;
        this._middleware = snapshot.middleware;
    };
    Container.prototype.createChild = function () {
        var child = new Container();
        child.parent = this;
        return child;
    };
    Container.prototype.applyMiddleware = function () {
        var middlewares = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            middlewares[_i] = arguments[_i];
        }
        var initial = (this._middleware) ? this._middleware : this._planAndResolve();
        this._middleware = middlewares.reduce(function (prev, curr) {
            return curr(prev);
        }, initial);
    };
    Container.prototype.get = function (serviceIdentifier) {
        return this._get(false, false, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier);
    };
    Container.prototype.getTagged = function (serviceIdentifier, key, value) {
        return this._get(false, false, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier, key, value);
    };
    Container.prototype.getNamed = function (serviceIdentifier, named) {
        return this.getTagged(serviceIdentifier, METADATA_KEY.NAMED_TAG, named);
    };
    Container.prototype.getAll = function (serviceIdentifier) {
        return this._get(true, true, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier);
    };
    Container.prototype.getAllTagged = function (serviceIdentifier, key, value) {
        return this._get(false, true, literal_types_1.TargetTypeEnum.Variable, serviceIdentifier, key, value);
    };
    Container.prototype.getAllNamed = function (serviceIdentifier, named) {
        return this.getAllTagged(serviceIdentifier, METADATA_KEY.NAMED_TAG, named);
    };
    Container.prototype._get = function (avoidConstraints, isMultiInject, targetType, serviceIdentifier, key, value) {
        var result = null;
        var defaultArgs = {
            avoidConstraints: avoidConstraints,
            contextInterceptor: function (context) { return context; },
            isMultiInject: isMultiInject,
            key: key,
            serviceIdentifier: serviceIdentifier,
            targetType: targetType,
            value: value
        };
        if (this._middleware) {
            result = this._middleware(defaultArgs);
            if (result === undefined || result === null) {
                throw new Error(ERROR_MSGS.INVALID_MIDDLEWARE_RETURN);
            }
        }
        else {
            result = this._planAndResolve()(defaultArgs);
        }
        return result;
    };
    Container.prototype._planAndResolve = function () {
        var _this = this;
        return function (args) {
            var context = planner_1.plan(_this, args.isMultiInject, args.targetType, args.serviceIdentifier, args.key, args.value, args.avoidConstraints);
            context = args.contextInterceptor(context);
            var result = resolver_1.resolve(context);
            return result;
        };
    };
    return Container;
}());
exports.Container = Container;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var guid_1 = __webpack_require__(24);
var literal_types_1 = __webpack_require__(21);
var Binding = (function () {
    function Binding(serviceIdentifier, defaultScope) {
        this.guid = guid_1.guid();
        this.activated = false;
        this.serviceIdentifier = serviceIdentifier;
        this.scope = defaultScope;
        this.type = literal_types_1.BindingTypeEnum.Invalid;
        this.constraint = function (request) { return true; };
        this.implementationType = null;
        this.cache = null;
        this.factory = null;
        this.provider = null;
        this.onActivation = null;
        this.dynamicValue = null;
    }
    Binding.prototype.clone = function () {
        var clone = new Binding(this.serviceIdentifier, this.scope);
        clone.activated = false;
        clone.implementationType = this.implementationType;
        clone.dynamicValue = this.dynamicValue;
        clone.scope = this.scope;
        clone.type = this.type;
        clone.factory = this.factory;
        clone.provider = this.provider;
        clone.constraint = this.constraint;
        clone.onActivation = this.onActivation;
        clone.cache = this.cache;
        return clone;
    };
    return Binding;
}());
exports.Binding = Binding;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ERROR_MSGS = __webpack_require__(20);
var Lookup = (function () {
    function Lookup() {
        this._map = new Map();
    }
    Lookup.prototype.getMap = function () {
        return this._map;
    };
    Lookup.prototype.add = function (serviceIdentifier, value) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        ;
        if (value === null || value === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        ;
        var entry = this._map.get(serviceIdentifier);
        if (entry !== undefined) {
            entry.push(value);
            this._map.set(serviceIdentifier, entry);
        }
        else {
            this._map.set(serviceIdentifier, [value]);
        }
    };
    Lookup.prototype.get = function (serviceIdentifier) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        var entry = this._map.get(serviceIdentifier);
        if (entry !== undefined) {
            return entry;
        }
        else {
            throw new Error(ERROR_MSGS.KEY_NOT_FOUND);
        }
    };
    Lookup.prototype.remove = function (serviceIdentifier) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        if (!this._map.delete(serviceIdentifier)) {
            throw new Error(ERROR_MSGS.KEY_NOT_FOUND);
        }
    };
    Lookup.prototype.removeByCondition = function (condition) {
        var _this = this;
        this._map.forEach(function (entries, key) {
            var updatedEntries = entries.filter(function (entry) { return !condition(entry); });
            if (updatedEntries.length > 0) {
                _this._map.set(key, updatedEntries);
            }
            else {
                _this._map.delete(key);
            }
        });
    };
    Lookup.prototype.hasKey = function (serviceIdentifier) {
        if (serviceIdentifier === null || serviceIdentifier === undefined) {
            throw new Error(ERROR_MSGS.NULL_ARGUMENT);
        }
        return this._map.has(serviceIdentifier);
    };
    Lookup.prototype.clone = function () {
        var copy = new Lookup();
        this._map.forEach(function (value, key) {
            value.forEach(function (b) { return copy.add(key, b.clone()); });
        });
        return copy;
    };
    Lookup.prototype.traverse = function (func) {
        this._map.forEach(function (value, key) {
            func(key, value);
        });
    };
    ;
    return Lookup;
}());
exports.Lookup = Lookup;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var plan_1 = __webpack_require__(54);
var context_1 = __webpack_require__(55);
var request_1 = __webpack_require__(56);
var target_1 = __webpack_require__(40);
var binding_count_1 = __webpack_require__(58);
var reflection_utils_1 = __webpack_require__(59);
var metadata_1 = __webpack_require__(19);
var ERROR_MSGS = __webpack_require__(20);
var METADATA_KEY = __webpack_require__(14);
var literal_types_1 = __webpack_require__(21);
var serialization_1 = __webpack_require__(28);
function getBindingDictionary(cntnr) {
    return cntnr._bindingDictionary;
}
exports.getBindingDictionary = getBindingDictionary;
function _createTarget(isMultiInject, targetType, serviceIdentifier, name, key, value) {
    var metadataKey = isMultiInject ? METADATA_KEY.MULTI_INJECT_TAG : METADATA_KEY.INJECT_TAG;
    var injectMetadata = new metadata_1.Metadata(metadataKey, serviceIdentifier);
    var target = new target_1.Target(targetType, name, serviceIdentifier, injectMetadata);
    if (key !== undefined) {
        var tagMetadata = new metadata_1.Metadata(key, value);
        target.metadata.push(tagMetadata);
    }
    return target;
}
function _getActiveBindings(avoidConstraints, context, parentRequest, target) {
    var bindings = getBindings(context.container, target.serviceIdentifier);
    var activeBindings = [];
    if (avoidConstraints === false) {
        activeBindings = bindings.filter(function (binding) {
            var request = new request_1.Request(binding.serviceIdentifier, context, parentRequest, binding, target);
            return binding.constraint(request);
        });
    }
    else {
        activeBindings = bindings;
    }
    _validateActiveBindingCount(target.serviceIdentifier, activeBindings, target, context.container);
    return activeBindings;
}
function _validateActiveBindingCount(serviceIdentifier, bindings, target, container) {
    switch (bindings.length) {
        case binding_count_1.BindingCount.NoBindingsAvailable:
            if (target.isOptional() === true) {
                return bindings;
            }
            else {
                var serviceIdentifierString = serialization_1.getServiceIdentifierAsString(serviceIdentifier);
                var msg = ERROR_MSGS.NOT_REGISTERED;
                msg += serialization_1.listMetadataForTarget(serviceIdentifierString, target);
                msg += serialization_1.listRegisteredBindingsForServiceIdentifier(container, serviceIdentifierString, getBindings);
                throw new Error(msg);
            }
        case binding_count_1.BindingCount.OnlyOneBindingAvailable:
            if (target.isArray() === false) {
                return bindings;
            }
        case binding_count_1.BindingCount.MultipleBindingsAvailable:
        default:
            if (target.isArray() === false) {
                var serviceIdentifierString = serialization_1.getServiceIdentifierAsString(serviceIdentifier), msg = ERROR_MSGS.AMBIGUOUS_MATCH + " " + serviceIdentifierString;
                msg += serialization_1.listRegisteredBindingsForServiceIdentifier(container, serviceIdentifierString, getBindings);
                throw new Error(msg);
            }
            else {
                return bindings;
            }
    }
}
function _createSubRequests(avoidConstraints, serviceIdentifier, context, parentRequest, target) {
    try {
        var activeBindings = void 0;
        var childRequest_1;
        if (parentRequest === null) {
            activeBindings = _getActiveBindings(avoidConstraints, context, null, target);
            childRequest_1 = new request_1.Request(serviceIdentifier, context, null, activeBindings, target);
            var plan_2 = new plan_1.Plan(context, childRequest_1);
            context.addPlan(plan_2);
        }
        else {
            activeBindings = _getActiveBindings(avoidConstraints, context, parentRequest, target);
            childRequest_1 = parentRequest.addChildRequest(target.serviceIdentifier, activeBindings, target);
        }
        activeBindings.forEach(function (binding) {
            var subChildRequest = null;
            if (target.isArray()) {
                subChildRequest = childRequest_1.addChildRequest(binding.serviceIdentifier, binding, target);
            }
            else {
                subChildRequest = childRequest_1;
            }
            if (binding.type === literal_types_1.BindingTypeEnum.Instance && binding.implementationType !== null) {
                var dependencies = reflection_utils_1.getDependencies(binding.implementationType);
                dependencies.forEach(function (dependency) {
                    _createSubRequests(false, dependency.serviceIdentifier, context, subChildRequest, dependency);
                });
            }
        });
    }
    catch (error) {
        if (error instanceof RangeError && parentRequest !== null) {
            serialization_1.circularDependencyToException(parentRequest.parentContext.plan.rootRequest);
        }
        else {
            throw new Error(error.message);
        }
    }
}
function getBindings(container, serviceIdentifier) {
    var bindings = [];
    var bindingDictionary = getBindingDictionary(container);
    if (bindingDictionary.hasKey(serviceIdentifier)) {
        bindings = bindingDictionary.get(serviceIdentifier);
    }
    else if (container.parent !== null) {
        bindings = getBindings(container.parent, serviceIdentifier);
    }
    return bindings;
}
function plan(container, isMultiInject, targetType, serviceIdentifier, key, value, avoidConstraints) {
    if (avoidConstraints === void 0) { avoidConstraints = false; }
    var context = new context_1.Context(container);
    var target = _createTarget(isMultiInject, targetType, serviceIdentifier, "", key, value);
    _createSubRequests(avoidConstraints, serviceIdentifier, context, null, target);
    return context;
}
exports.plan = plan;
function createMockRequest(container, serviceIdentifier, key, value) {
    var target = new target_1.Target(literal_types_1.TargetTypeEnum.Variable, "", serviceIdentifier, new metadata_1.Metadata(key, value));
    var context = new context_1.Context(container);
    var request = new request_1.Request(serviceIdentifier, context, null, [], target);
    return request;
}
exports.createMockRequest = createMockRequest;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var Plan = (function () {
    function Plan(parentContext, rootRequest) {
        this.parentContext = parentContext;
        this.rootRequest = rootRequest;
    }
    return Plan;
}());
exports.Plan = Plan;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var guid_1 = __webpack_require__(24);
var Context = (function () {
    function Context(container) {
        this.guid = guid_1.guid();
        this.container = container;
    }
    Context.prototype.addPlan = function (plan) {
        this.plan = plan;
    };
    return Context;
}());
exports.Context = Context;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var guid_1 = __webpack_require__(24);
var Request = (function () {
    function Request(serviceIdentifier, parentContext, parentRequest, bindings, target) {
        this.guid = guid_1.guid();
        this.serviceIdentifier = serviceIdentifier;
        this.parentContext = parentContext;
        this.parentRequest = parentRequest;
        this.target = target;
        this.childRequests = [];
        this.bindings = (Array.isArray(bindings) ? bindings : [bindings]);
    }
    Request.prototype.addChildRequest = function (serviceIdentifier, bindings, target) {
        var child = new Request(serviceIdentifier, this.parentContext, this, bindings, target);
        this.childRequests.push(child);
        return child;
    };
    return Request;
}());
exports.Request = Request;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var QueryableString = (function () {
    function QueryableString(str) {
        this.str = str;
    }
    QueryableString.prototype.startsWith = function (searchString) {
        return this.str.indexOf(searchString) === 0;
    };
    QueryableString.prototype.endsWith = function (searchString) {
        var reverseString = "";
        var reverseSearchString = searchString.split("").reverse().join("");
        reverseString = this.str.split("").reverse().join("");
        return this.startsWith.call({ str: reverseString }, reverseSearchString);
    };
    QueryableString.prototype.contains = function (searchString) {
        return (this.str.indexOf(searchString) !== -1);
    };
    QueryableString.prototype.equals = function (compareString) {
        return this.str === compareString;
    };
    QueryableString.prototype.value = function () {
        return this.str;
    };
    return QueryableString;
}());
exports.QueryableString = QueryableString;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var BindingCount = {
    MultipleBindingsAvailable: 2,
    NoBindingsAvailable: 0,
    OnlyOneBindingAvailable: 1
};
exports.BindingCount = BindingCount;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var serialization_1 = __webpack_require__(28);
var target_1 = __webpack_require__(40);
var ERROR_MSGS = __webpack_require__(20);
var METADATA_KEY = __webpack_require__(14);
var literal_types_1 = __webpack_require__(21);
function getDependencies(func) {
    var constructorName = serialization_1.getFunctionName(func);
    var targets = getTargets(func, false);
    var baseClassDepencencyCount = getBaseClassDepencencyCount(func);
    if (targets.length < baseClassDepencencyCount) {
        var error = ERROR_MSGS.ARGUMENTS_LENGTH_MISMATCH_1 +
            constructorName + ERROR_MSGS.ARGUMENTS_LENGTH_MISMATCH_2;
        throw new Error(error);
    }
    return targets;
}
exports.getDependencies = getDependencies;
function getTargets(func, isBaseClass) {
    var constructorName = serialization_1.getFunctionName(func);
    var serviceIdentifiers = Reflect.getMetadata(METADATA_KEY.PARAM_TYPES, func);
    if (serviceIdentifiers === undefined) {
        var msg = ERROR_MSGS.MISSING_INJECTABLE_ANNOTATION + " " + constructorName + ".";
        throw new Error(msg);
    }
    var constructorArgsMetadata = Reflect.getMetadata(METADATA_KEY.TAGGED, func) || [];
    var targets = (getConstructorArgsAsTargets(isBaseClass, constructorName, serviceIdentifiers, constructorArgsMetadata, func.length)).concat((getClassPropsAsTargets(func)));
    return targets;
}
function getConstructorArgsAsTargets(isBaseClass, constructorName, serviceIdentifiers, constructorArgsMetadata, constructorLength) {
    var targets = [];
    for (var i = 0; i < constructorLength; i++) {
        var targetMetadata = constructorArgsMetadata[i.toString()] || [];
        var metadata = formatTargetMetadata(targetMetadata);
        var serviceIndentifier = serviceIdentifiers[i];
        var hasInjectAnnotations = (metadata.inject || metadata.multiInject);
        serviceIndentifier = (hasInjectAnnotations) ? (hasInjectAnnotations) : serviceIndentifier;
        var isObject = serviceIndentifier === Object;
        var isFunction = serviceIndentifier === Function;
        var isUndefined = serviceIndentifier === undefined;
        var isUnknownType = (isObject || isFunction || isUndefined);
        if (isBaseClass === false && isUnknownType) {
            var msg = ERROR_MSGS.MISSING_INJECT_ANNOTATION + " argument " + i + " in class " + constructorName + ".";
            throw new Error(msg);
        }
        var target = new target_1.Target(literal_types_1.TargetTypeEnum.ConstructorArgument, metadata.targetName, serviceIndentifier);
        target.metadata = targetMetadata;
        targets.push(target);
    }
    return targets;
}
function getClassPropsAsTargets(func) {
    var classPropsMetadata = Reflect.getMetadata(METADATA_KEY.TAGGED_PROP, func) || [];
    var targets = [];
    var keys = Object.keys(classPropsMetadata);
    for (var i = 0; i < keys.length; i++) {
        var key = keys[i];
        var targetMetadata = classPropsMetadata[key];
        var metadata = formatTargetMetadata(classPropsMetadata[key]);
        var targetName = metadata.targetName || key;
        var serviceIndentifier = (metadata.inject || metadata.multiInject);
        var target = new target_1.Target(literal_types_1.TargetTypeEnum.ClassProperty, targetName, serviceIndentifier);
        target.metadata = targetMetadata;
        targets.push(target);
    }
    var baseConstructor = Object.getPrototypeOf(func.prototype).constructor;
    if (baseConstructor !== Object) {
        var baseTargets = getClassPropsAsTargets(baseConstructor);
        targets = targets.concat(baseTargets);
    }
    return targets;
}
function getBaseClassDepencencyCount(func) {
    var baseConstructor = Object.getPrototypeOf(func.prototype).constructor;
    if (baseConstructor !== Object) {
        var targets = getTargets(baseConstructor, true);
        var metadata = targets.map(function (t) {
            return t.metadata.filter(function (m) {
                return m.key === METADATA_KEY.UNMANAGED_TAG;
            });
        });
        var unmanagedCount = [].concat.apply([], metadata).length;
        var dependencyCount = targets.length - unmanagedCount;
        if (dependencyCount > 0) {
            return dependencyCount;
        }
        else {
            return getBaseClassDepencencyCount(baseConstructor);
        }
    }
    else {
        return 0;
    }
}
function formatTargetMetadata(targetMetadata) {
    var targetMetadataMap = {};
    targetMetadata.forEach(function (m) {
        targetMetadataMap[m.key.toString()] = m.value;
    });
    return {
        inject: targetMetadataMap[METADATA_KEY.INJECT_TAG],
        multiInject: targetMetadataMap[METADATA_KEY.MULTI_INJECT_TAG],
        targetName: targetMetadataMap[METADATA_KEY.NAME_TAG],
        unmanaged: targetMetadataMap[METADATA_KEY.UNMANAGED_TAG]
    };
}


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var literal_types_1 = __webpack_require__(21);
var serialization_1 = __webpack_require__(28);
var instantiation_1 = __webpack_require__(61);
var ERROR_MSGS = __webpack_require__(20);
function _resolveRequest(request) {
    var bindings = request.bindings;
    var childRequests = request.childRequests;
    var targetIsAnAray = request.target && request.target.isArray();
    var targetParentIsNotAnArray = !request.parentRequest ||
        !request.parentRequest.target ||
        !request.target ||
        !request.parentRequest.target.matchesArray(request.target.serviceIdentifier);
    if (targetIsAnAray && targetParentIsNotAnArray) {
        return childRequests.map(function (childRequest) {
            return _resolveRequest(childRequest);
        });
    }
    else {
        var result = null;
        if (request.target.isOptional() === true && bindings.length === 0) {
            return undefined;
        }
        var binding = bindings[0];
        var isSingleton = binding.scope === literal_types_1.BindingScopeEnum.Singleton;
        if (isSingleton && binding.activated === true) {
            return binding.cache;
        }
        if (binding.type === literal_types_1.BindingTypeEnum.ConstantValue) {
            result = binding.cache;
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.Function) {
            result = binding.cache;
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.Constructor) {
            result = binding.implementationType;
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.DynamicValue && binding.dynamicValue !== null) {
            result = binding.dynamicValue(request.parentContext);
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.Factory && binding.factory !== null) {
            result = binding.factory(request.parentContext);
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.Provider && binding.provider !== null) {
            result = binding.provider(request.parentContext);
        }
        else if (binding.type === literal_types_1.BindingTypeEnum.Instance && binding.implementationType !== null) {
            result = instantiation_1.resolveInstance(binding.implementationType, childRequests, _resolveRequest);
        }
        else {
            var serviceIdentifier = serialization_1.getServiceIdentifierAsString(request.serviceIdentifier);
            throw new Error(ERROR_MSGS.INVALID_BINDING_TYPE + " " + serviceIdentifier);
        }
        if (typeof binding.onActivation === "function") {
            result = binding.onActivation(request.parentContext, result);
        }
        if (isSingleton) {
            binding.cache = result;
            binding.activated = true;
        }
        return result;
    }
}
function resolve(context) {
    return _resolveRequest(context.plan.rootRequest);
}
exports.resolve = resolve;


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var literal_types_1 = __webpack_require__(21);
function _injectProperties(instance, childRequests, resolveRequest) {
    var propertyInjectionsRequests = childRequests.filter(function (childRequest) {
        return (childRequest.target !== null && childRequest.target.type === literal_types_1.TargetTypeEnum.ClassProperty);
    });
    var propertyInjections = propertyInjectionsRequests.map(function (childRequest) {
        return resolveRequest(childRequest);
    });
    propertyInjectionsRequests.forEach(function (r, index) {
        var propertyName = "";
        propertyName = r.target.name.value();
        var injection = propertyInjections[index];
        instance[propertyName] = injection;
    });
    return instance;
}
function _createInstance(Func, injections) {
    return new (Func.bind.apply(Func, [void 0].concat(injections)))();
}
function resolveInstance(constr, childRequests, resolveRequest) {
    var result = null;
    if (childRequests.length > 0) {
        var constructorInjectionsRequests = childRequests.filter(function (childRequest) {
            return (childRequest.target !== null && childRequest.target.type === literal_types_1.TargetTypeEnum.ConstructorArgument);
        });
        var constructorInjections = constructorInjectionsRequests.map(function (childRequest) {
            return resolveRequest(childRequest);
        });
        result = _createInstance(constr, constructorInjections);
        result = _injectProperties(result, childRequests, resolveRequest);
    }
    else {
        result = new constr();
    }
    return result;
}
exports.resolveInstance = resolveInstance;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var binding_in_when_on_syntax_1 = __webpack_require__(63);
var binding_when_on_syntax_1 = __webpack_require__(41);
var literal_types_1 = __webpack_require__(21);
var ERROR_MSGS = __webpack_require__(20);
var BindingToSyntax = (function () {
    function BindingToSyntax(binding) {
        this._binding = binding;
    }
    BindingToSyntax.prototype.to = function (constructor) {
        this._binding.type = literal_types_1.BindingTypeEnum.Instance;
        this._binding.implementationType = constructor;
        return new binding_in_when_on_syntax_1.BindingInWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toSelf = function () {
        if (typeof this._binding.serviceIdentifier !== "function") {
            throw new Error("" + ERROR_MSGS.INVALID_TO_SELF_VALUE);
        }
        var self = this._binding.serviceIdentifier;
        return this.to(self);
    };
    BindingToSyntax.prototype.toConstantValue = function (value) {
        this._binding.type = literal_types_1.BindingTypeEnum.ConstantValue;
        this._binding.cache = value;
        this._binding.dynamicValue = null;
        this._binding.implementationType = null;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toDynamicValue = function (func) {
        this._binding.type = literal_types_1.BindingTypeEnum.DynamicValue;
        this._binding.cache = null;
        this._binding.dynamicValue = func;
        this._binding.implementationType = null;
        return new binding_in_when_on_syntax_1.BindingInWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toConstructor = function (constructor) {
        this._binding.type = literal_types_1.BindingTypeEnum.Constructor;
        this._binding.implementationType = constructor;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toFactory = function (factory) {
        this._binding.type = literal_types_1.BindingTypeEnum.Factory;
        this._binding.factory = factory;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toFunction = function (func) {
        if (typeof func !== "function") {
            throw new Error(ERROR_MSGS.INVALID_FUNCTION_BINDING);
        }
        ;
        var bindingWhenOnSyntax = this.toConstantValue(func);
        this._binding.type = literal_types_1.BindingTypeEnum.Function;
        return bindingWhenOnSyntax;
    };
    BindingToSyntax.prototype.toAutoFactory = function (serviceIdentifier) {
        this._binding.type = literal_types_1.BindingTypeEnum.Factory;
        this._binding.factory = function (context) {
            return function () {
                return context.container.get(serviceIdentifier);
            };
        };
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingToSyntax.prototype.toProvider = function (provider) {
        this._binding.type = literal_types_1.BindingTypeEnum.Provider;
        this._binding.provider = provider;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    return BindingToSyntax;
}());
exports.BindingToSyntax = BindingToSyntax;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var binding_in_syntax_1 = __webpack_require__(64);
var binding_when_syntax_1 = __webpack_require__(35);
var binding_on_syntax_1 = __webpack_require__(36);
var BindingInWhenOnSyntax = (function () {
    function BindingInWhenOnSyntax(binding) {
        this._binding = binding;
        this._bindingWhenSyntax = new binding_when_syntax_1.BindingWhenSyntax(this._binding);
        this._bindingOnSyntax = new binding_on_syntax_1.BindingOnSyntax(this._binding);
        this._bindingInSyntax = new binding_in_syntax_1.BindingInSyntax(binding);
    }
    BindingInWhenOnSyntax.prototype.inSingletonScope = function () {
        return this._bindingInSyntax.inSingletonScope();
    };
    BindingInWhenOnSyntax.prototype.inTransientScope = function () {
        return this._bindingInSyntax.inTransientScope();
    };
    BindingInWhenOnSyntax.prototype.when = function (constraint) {
        return this._bindingWhenSyntax.when(constraint);
    };
    BindingInWhenOnSyntax.prototype.whenTargetNamed = function (name) {
        return this._bindingWhenSyntax.whenTargetNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenTargetIsDefault = function () {
        return this._bindingWhenSyntax.whenTargetIsDefault();
    };
    BindingInWhenOnSyntax.prototype.whenTargetTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenTargetTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenInjectedInto = function (parent) {
        return this._bindingWhenSyntax.whenInjectedInto(parent);
    };
    BindingInWhenOnSyntax.prototype.whenParentNamed = function (name) {
        return this._bindingWhenSyntax.whenParentNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenParentTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenParentTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenAnyAncestorIs(ancestor);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorIs = function (ancestor) {
        return this._bindingWhenSyntax.whenNoAncestorIs(ancestor);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenAnyAncestorNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenAnyAncestorTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorNamed = function (name) {
        return this._bindingWhenSyntax.whenNoAncestorNamed(name);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorTagged = function (tag, value) {
        return this._bindingWhenSyntax.whenNoAncestorTagged(tag, value);
    };
    BindingInWhenOnSyntax.prototype.whenAnyAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenAnyAncestorMatches(constraint);
    };
    BindingInWhenOnSyntax.prototype.whenNoAncestorMatches = function (constraint) {
        return this._bindingWhenSyntax.whenNoAncestorMatches(constraint);
    };
    BindingInWhenOnSyntax.prototype.onActivation = function (handler) {
        return this._bindingOnSyntax.onActivation(handler);
    };
    return BindingInWhenOnSyntax;
}());
exports.BindingInWhenOnSyntax = BindingInWhenOnSyntax;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var literal_types_1 = __webpack_require__(21);
var binding_when_on_syntax_1 = __webpack_require__(41);
var BindingInSyntax = (function () {
    function BindingInSyntax(binding) {
        this._binding = binding;
    }
    BindingInSyntax.prototype.inSingletonScope = function () {
        this._binding.scope = literal_types_1.BindingScopeEnum.Singleton;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    BindingInSyntax.prototype.inTransientScope = function () {
        this._binding.scope = literal_types_1.BindingScopeEnum.Transient;
        return new binding_when_on_syntax_1.BindingWhenOnSyntax(this._binding);
    };
    return BindingInSyntax;
}());
exports.BindingInSyntax = BindingInSyntax;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ContainerSnapshot = (function () {
    function ContainerSnapshot() {
    }
    ContainerSnapshot.of = function (bindings, middleware) {
        var snapshot = new ContainerSnapshot();
        snapshot.bindings = bindings;
        snapshot.middleware = middleware;
        return snapshot;
    };
    return ContainerSnapshot;
}());
exports.ContainerSnapshot = ContainerSnapshot;


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var guid_1 = __webpack_require__(24);
var ContainerModule = (function () {
    function ContainerModule(registry) {
        this.guid = guid_1.guid();
        this.registry = registry;
    }
    return ContainerModule;
}());
exports.ContainerModule = ContainerModule;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var METADATA_KEY = __webpack_require__(14);
var ERRORS_MSGS = __webpack_require__(20);
function injectable() {
    return function (target) {
        if (Reflect.hasOwnMetadata(METADATA_KEY.PARAM_TYPES, target) === true) {
            throw new Error(ERRORS_MSGS.DUPLICATED_INJECTABLE_DECORATOR);
        }
        var types = Reflect.getMetadata(METADATA_KEY.DESIGN_PARAM_TYPES, target) || [];
        Reflect.defineMetadata(METADATA_KEY.PARAM_TYPES, types, target);
        return target;
    };
}
exports.injectable = injectable;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metadata_1 = __webpack_require__(19);
var decorator_utils_1 = __webpack_require__(22);
function tagged(metadataKey, metadataValue) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(metadataKey, metadataValue);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.tagged = tagged;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metadata_1 = __webpack_require__(19);
var decorator_utils_1 = __webpack_require__(22);
var METADATA_KEY = __webpack_require__(14);
function named(name) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.NAMED_TAG, name);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.named = named;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metadata_1 = __webpack_require__(19);
var decorator_utils_1 = __webpack_require__(22);
var METADATA_KEY = __webpack_require__(14);
function inject(serviceIdentifier) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.INJECT_TAG, serviceIdentifier);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.inject = inject;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metadata_1 = __webpack_require__(19);
var decorator_utils_1 = __webpack_require__(22);
var METADATA_KEY = __webpack_require__(14);
function optional() {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.OPTIONAL_TAG, true);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.optional = optional;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metadata_1 = __webpack_require__(19);
var decorator_utils_1 = __webpack_require__(22);
var METADATA_KEY = __webpack_require__(14);
function unmanaged() {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.UNMANAGED_TAG, true);
        decorator_utils_1.tagParameter(target, targetKey, index, metadata);
    };
}
exports.unmanaged = unmanaged;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metadata_1 = __webpack_require__(19);
var decorator_utils_1 = __webpack_require__(22);
var METADATA_KEY = __webpack_require__(14);
function multiInject(serviceIdentifier) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.MULTI_INJECT_TAG, serviceIdentifier);
        if (typeof index === "number") {
            decorator_utils_1.tagParameter(target, targetKey, index, metadata);
        }
        else {
            decorator_utils_1.tagProperty(target, targetKey, metadata);
        }
    };
}
exports.multiInject = multiInject;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var metadata_1 = __webpack_require__(19);
var decorator_utils_1 = __webpack_require__(22);
var METADATA_KEY = __webpack_require__(14);
function targetName(name) {
    return function (target, targetKey, index) {
        var metadata = new metadata_1.Metadata(METADATA_KEY.NAME_TAG, name);
        decorator_utils_1.tagParameter(target, targetKey, index, metadata);
    };
}
exports.targetName = targetName;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var validTypes = { object: true, symbol: true };

module.exports = function () {
	var symbol;
	if (typeof Symbol !== 'function') return false;
	symbol = Symbol('test symbol');
	try { String(symbol); } catch (e) { return false; }

	// Return 'true' also for polyfills
	if (!validTypes[typeof Symbol.iterator]) return false;
	if (!validTypes[typeof Symbol.toPrimitive]) return false;
	if (!validTypes[typeof Symbol.toStringTag]) return false;

	return true;
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ES2015 Symbol polyfill for environments that do not (or partially) support it



var d              = __webpack_require__(77)
  , validateSymbol = __webpack_require__(91)

  , create = Object.create, defineProperties = Object.defineProperties
  , defineProperty = Object.defineProperty, objPrototype = Object.prototype
  , NativeSymbol, SymbolPolyfill, HiddenSymbol, globalSymbols = create(null)
  , isNativeSafe;

if (typeof Symbol === 'function') {
	NativeSymbol = Symbol;
	try {
		String(NativeSymbol());
		isNativeSafe = true;
	} catch (ignore) {}
}

var generateName = (function () {
	var created = create(null);
	return function (desc) {
		var postfix = 0, name, ie11BugWorkaround;
		while (created[desc + (postfix || '')]) ++postfix;
		desc += (postfix || '');
		created[desc] = true;
		name = '@@' + desc;
		defineProperty(objPrototype, name, d.gs(null, function (value) {
			// For IE11 issue see:
			// https://connect.microsoft.com/IE/feedbackdetail/view/1928508/
			//    ie11-broken-getters-on-dom-objects
			// https://github.com/medikoo/es6-symbol/issues/12
			if (ie11BugWorkaround) return;
			ie11BugWorkaround = true;
			defineProperty(this, name, d(value));
			ie11BugWorkaround = false;
		}));
		return name;
	};
}());

// Internal constructor (not one exposed) for creating Symbol instances.
// This one is used to ensure that `someSymbol instanceof Symbol` always return false
HiddenSymbol = function Symbol(description) {
	if (this instanceof HiddenSymbol) throw new TypeError('Symbol is not a constructor');
	return SymbolPolyfill(description);
};

// Exposed `Symbol` constructor
// (returns instances of HiddenSymbol)
module.exports = SymbolPolyfill = function Symbol(description) {
	var symbol;
	if (this instanceof Symbol) throw new TypeError('Symbol is not a constructor');
	if (isNativeSafe) return NativeSymbol(description);
	symbol = create(HiddenSymbol.prototype);
	description = (description === undefined ? '' : String(description));
	return defineProperties(symbol, {
		__description__: d('', description),
		__name__: d('', generateName(description))
	});
};
defineProperties(SymbolPolyfill, {
	for: d(function (key) {
		if (globalSymbols[key]) return globalSymbols[key];
		return (globalSymbols[key] = SymbolPolyfill(String(key)));
	}),
	keyFor: d(function (s) {
		var key;
		validateSymbol(s);
		for (key in globalSymbols) if (globalSymbols[key] === s) return key;
	}),

	// To ensure proper interoperability with other native functions (e.g. Array.from)
	// fallback to eventual native implementation of given symbol
	hasInstance: d('', (NativeSymbol && NativeSymbol.hasInstance) || SymbolPolyfill('hasInstance')),
	isConcatSpreadable: d('', (NativeSymbol && NativeSymbol.isConcatSpreadable) ||
		SymbolPolyfill('isConcatSpreadable')),
	iterator: d('', (NativeSymbol && NativeSymbol.iterator) || SymbolPolyfill('iterator')),
	match: d('', (NativeSymbol && NativeSymbol.match) || SymbolPolyfill('match')),
	replace: d('', (NativeSymbol && NativeSymbol.replace) || SymbolPolyfill('replace')),
	search: d('', (NativeSymbol && NativeSymbol.search) || SymbolPolyfill('search')),
	species: d('', (NativeSymbol && NativeSymbol.species) || SymbolPolyfill('species')),
	split: d('', (NativeSymbol && NativeSymbol.split) || SymbolPolyfill('split')),
	toPrimitive: d('', (NativeSymbol && NativeSymbol.toPrimitive) || SymbolPolyfill('toPrimitive')),
	toStringTag: d('', (NativeSymbol && NativeSymbol.toStringTag) || SymbolPolyfill('toStringTag')),
	unscopables: d('', (NativeSymbol && NativeSymbol.unscopables) || SymbolPolyfill('unscopables'))
});

// Internal tweaks for real symbol producer
defineProperties(HiddenSymbol.prototype, {
	constructor: d(SymbolPolyfill),
	toString: d('', function () { return this.__name__; })
});

// Proper implementation of methods exposed on Symbol.prototype
// They won't be accessible on produced symbol instances as they derive from HiddenSymbol.prototype
defineProperties(SymbolPolyfill.prototype, {
	toString: d(function () { return 'Symbol (' + validateSymbol(this).__description__ + ')'; }),
	valueOf: d(function () { return validateSymbol(this); })
});
defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toPrimitive, d('', function () {
	var symbol = validateSymbol(this);
	if (typeof symbol === 'symbol') return symbol;
	return symbol.toString();
}));
defineProperty(SymbolPolyfill.prototype, SymbolPolyfill.toStringTag, d('c', 'Symbol'));

// Proper implementaton of toPrimitive and toStringTag for returned symbol instances
defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toStringTag,
	d('c', SymbolPolyfill.prototype[SymbolPolyfill.toStringTag]));

// Note: It's important to define `toPrimitive` as last one, as some implementations
// implement `toPrimitive` natively without implementing `toStringTag` (or other specified symbols)
// And that may invoke error in definition flow:
// See: https://github.com/medikoo/es6-symbol/issues/13#issuecomment-164146149
defineProperty(HiddenSymbol.prototype, SymbolPolyfill.toPrimitive,
	d('c', SymbolPolyfill.prototype[SymbolPolyfill.toPrimitive]));


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var assign        = __webpack_require__(78)
  , normalizeOpts = __webpack_require__(86)
  , isCallable    = __webpack_require__(87)
  , contains      = __webpack_require__(88)

  , d;

d = module.exports = function (dscr, value/*, options*/) {
	var c, e, w, options, desc;
	if ((arguments.length < 2) || (typeof dscr !== 'string')) {
		options = value;
		value = dscr;
		dscr = null;
	} else {
		options = arguments[2];
	}
	if (dscr == null) {
		c = w = true;
		e = false;
	} else {
		c = contains.call(dscr, 'c');
		e = contains.call(dscr, 'e');
		w = contains.call(dscr, 'w');
	}

	desc = { value: value, configurable: c, enumerable: e, writable: w };
	return !options ? desc : assign(normalizeOpts(options), desc);
};

d.gs = function (dscr, get, set/*, options*/) {
	var c, e, options, desc;
	if (typeof dscr !== 'string') {
		options = set;
		set = get;
		get = dscr;
		dscr = null;
	} else {
		options = arguments[3];
	}
	if (get == null) {
		get = undefined;
	} else if (!isCallable(get)) {
		options = get;
		get = set = undefined;
	} else if (set == null) {
		set = undefined;
	} else if (!isCallable(set)) {
		options = set;
		set = undefined;
	}
	if (dscr == null) {
		c = true;
		e = false;
	} else {
		c = contains.call(dscr, 'c');
		e = contains.call(dscr, 'e');
	}

	desc = { get: get, set: set, configurable: c, enumerable: e };
	return !options ? desc : assign(normalizeOpts(options), desc);
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(79)()
	? Object.assign
	: __webpack_require__(80);


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	var assign = Object.assign, obj;
	if (typeof assign !== "function") return false;
	obj = { foo: "raz" };
	assign(obj, { bar: "dwa" }, { trzy: "trzy" });
	return (obj.foo + obj.bar + obj.trzy) === "razdwatrzy";
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys  = __webpack_require__(81)
  , value = __webpack_require__(85)
  , max   = Math.max;

module.exports = function (dest, src /*, …srcn*/) {
	var error, i, length = max(arguments.length, 2), assign;
	dest = Object(value(dest));
	assign = function (key) {
		try {
			dest[key] = src[key];
		} catch (e) {
			if (!error) error = e;
		}
	};
	for (i = 1; i < length; ++i) {
		src = arguments[i];
		keys(src).forEach(assign);
	}
	if (error !== undefined) throw error;
	return dest;
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(82)()
	? Object.keys
	: __webpack_require__(83);


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	try {
		Object.keys("primitive");
		return true;
	} catch (e) {
 return false;
}
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(37);

var keys = Object.keys;

module.exports = function (object) {
	return keys(isValue(object) ? Object(object) : object);
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// eslint-disable-next-line no-empty-function
module.exports = function () {};


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(37);

module.exports = function (value) {
	if (!isValue(value)) throw new TypeError("Cannot use null or undefined");
	return value;
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isValue = __webpack_require__(37);

var forEach = Array.prototype.forEach, create = Object.create;

var process = function (src, obj) {
	var key;
	for (key in src) obj[key] = src[key];
};

// eslint-disable-next-line no-unused-vars
module.exports = function (opts1 /*, …options*/) {
	var result = create(null);
	forEach.call(arguments, function (options) {
		if (!isValue(options)) return;
		process(Object(options), result);
	});
	return result;
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Deprecated



module.exports = function (obj) {
 return typeof obj === "function";
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(89)()
	? String.prototype.contains
	: __webpack_require__(90);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var str = "razdwatrzy";

module.exports = function () {
	if (typeof str.contains !== "function") return false;
	return (str.contains("dwa") === true) && (str.contains("foo") === false);
};


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var indexOf = String.prototype.indexOf;

module.exports = function (searchString/*, position*/) {
	return indexOf.call(this, searchString, arguments[1]) > -1;
};


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isSymbol = __webpack_require__(92);

module.exports = function (value) {
	if (!isSymbol(value)) throw new TypeError(value + " is not a symbol");
	return value;
};


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function (x) {
	if (!x) return false;
	if (typeof x === 'symbol') return true;
	if (!x.constructor) return false;
	if (x.constructor.name !== 'Symbol') return false;
	return (x[x.constructor.toStringTag] === 'Symbol');
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var _1 = __webpack_require__(4);
var contracts_1 = __webpack_require__(3);
var common_1 = __webpack_require__(2);
var ApiClient = /** @class */ (function () {
    function ApiClient(appOptions, httpClient, tokenHandler, halParser) {
        this.appOptions = appOptions;
        this.httpClient = httpClient;
        this.tokenHandler = tokenHandler;
        this.halParser = halParser;
        this.wwwAuthenticateTokenizer = (function () {
            var ws = '(?:(?:\\r\\n)?[ \\t])+', token = '(?:[\\x21\\x23-\\x27\\x2A\\x2B\\x2D\\x2E\\x30-\\x39\\x3F\\x41-\\x5A\\x5E-\\x7A\\x7C\\x7E]+)', quotedString = '"(?:[\\x00-\\x0B\\x0D-\\x21\\x23-\\x5B\\\\x5D-\\x7F]|' + ws + '|\\\\[\\x00-\\x7F])*"';
            return new RegExp(token + '(?:=(?:' + quotedString + '|' + token + '))?', 'g');
        })();
        this.createPromise = httpClient.createPromise;
    }
    ApiClient_1 = ApiClient;
    ApiClient.prototype.request = function (request) {
        var _this = this;
        if (request && request.url) {
            request.url = this.compileUrl(request.url);
        }
        var headers = request.headers || (request.headers = {});
        var authToken = this.tokenHandler.get();
        var syncToken = false;
        if (authToken) {
            syncToken = authToken.sliding_window !== undefined;
            /*jshint camelcase: false */
            headers["AUTHORIZATION"] = "BEARER " + authToken.token;
        }
        if (request.data && !this.headerExists(headers, 'Content-Type')) {
            if (!(request.data instanceof FormData)) {
                headers['Content-Type'] = 'application/json; charset=UTF-8';
            }
        }
        if (this.appOptions.enableHALJSON) {
            if (!this.headerExists(headers, 'Accept')) {
                headers["Accept"] = 'application/hal+json; charset=UTF-8';
            }
        }
        var promise = this.httpClient.request(request);
        promise.then(function (data) {
            if (syncToken)
                _this.tokenHandler.store(authToken);
            var contentType = _this.getHeader(data.headers, 'Content-Type');
            if (contentType && contentType.toLowerCase().indexOf('application/hal+json') !== -1) {
                data.data = _this.halParser.parse(data.data);
            }
            return data;
        }, function (response) {
            if (response.statusCode === 401) {
                var err = response.data;
                if (err && err.details) {
                    switch (err.details) {
                        case 'invalid_token':
                            _this.tokenHandler.store(null);
                            break;
                        case 'invalid_request':
                            /*jshint camelcase: false */
                            switch (err.message) {
                                /*jshint camelcase: true */
                                case 'Missing or invalid session':
                                    _this.tokenHandler.store(null);
                                    break;
                            }
                            break;
                    }
                }
            }
            return response;
        });
        return promise;
    };
    ApiClient.prototype.get = function (url, headers, abortSignal) {
        return this.internalRequest(url, "GET", undefined, headers, abortSignal);
    };
    ApiClient.prototype.delete = function (url, headers, data, abortSignal) {
        return this.internalRequest(url, "DELETE", data, headers, abortSignal);
    };
    ApiClient.prototype.post = function (url, data, headers, abortSignal) {
        return this.internalRequest(url, "POST", data, headers, abortSignal);
    };
    ApiClient.prototype.put = function (url, data, headers, abortSignal) {
        return this.internalRequest(url, "PUT", data, headers, abortSignal);
    };
    ApiClient.prototype.patch = function (url, data, headers, abortSignal) {
        return this.internalRequest(url, "PATCH", data, headers, abortSignal);
    };
    ApiClient.prototype.compileUrl = function (url) {
        if (!ApiClient_1.httpTest.test(url)) {
            var rootUrl = this.appOptions.apiUrl;
            if (url.indexOf(rootUrl) < 0) {
                return "" + rootUrl + url;
            }
        }
        return url;
    };
    ApiClient.prototype.internalRequest = function (url, method, data, headers, abortSignal) {
        url = this.compileUrl(url);
        var request = {
            url: url,
            method: method
        };
        if (data) {
            request.data = data;
        }
        if (headers) {
            request.headers = headers;
        }
        if (abortSignal) {
            request.abortSignal = abortSignal;
        }
        return this.request(request);
    };
    ApiClient.prototype.unquote = function (quotedString) {
        return quotedString.substr(1, quotedString.length - 2).replace(/(?:(?:\r\n)?[ \t])+/g, ' ');
    };
    ApiClient.prototype.headerExists = function (headers, key) {
        return headers && (headers.hasOwnProperty(key) || headers.hasOwnProperty(key.toLowerCase()));
    };
    ApiClient.prototype.getHeader = function (headers, key) {
        if (headers) {
            var header = headers[key] || headers[key.toLowerCase()];
            if (Array.isArray(header)) {
                header = header.join(';');
            }
            return header;
        }
        return undefined;
    };
    ApiClient.prototype.parseWWWAuthenticateHeader = function (value) {
        var tokens;
        if (typeof value === 'string') {
            tokens = value.match(this.wwwAuthenticateTokenizer);
        }
        else if (Array.isArray(value)) {
            tokens = value[0].split(' ').concat(value.slice(1));
        }
        if (tokens && tokens.length > 0) {
            var wwwAutheniticate = {
                scheme: tokens[0]
            };
            if (tokens.length > 1) {
                var details = {};
                for (var i = 1, l = tokens.length; i < l; i++) {
                    var values = tokens[i].split('=');
                    details[values[0]] = this.unquote(values[1]);
                }
                wwwAutheniticate.details = details;
            }
            return wwwAutheniticate;
        }
    };
    var ApiClient_1, _a, _b, _c, _d;
    ApiClient.httpTest = new RegExp("^(http|https)://", "i");
    ApiClient = ApiClient_1 = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.httpTYPES.IHttpClient)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.ITokenHandler)),
        tslib_1.__param(3, inversify_1.inject(common_1.TYPES.IHALParser)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.IHttpClient !== "undefined" && _1.IHttpClient) === "function" ? _b : Object, typeof (_c = typeof contracts_1.ITokenHandler !== "undefined" && contracts_1.ITokenHandler) === "function" ? _c : Object, typeof (_d = typeof common_1.IHALParser !== "undefined" && common_1.IHALParser) === "function" ? _d : Object])
    ], ApiClient);
    return ApiClient;
}());
exports.ApiClient = ApiClient;
;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.TokenTypes = {
    Access: 'access',
    Refresh: 'refresh'
};


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Symbol = __webpack_require__(8);
var TYPES = {
    IBaasicAppOptions: Symbol("IBaasicAppOptions"),
    IAppOptions: Symbol("IAppOptions"),
    IStorageHandler: Symbol("IStorageHandler"),
    IEventHandler: Symbol("IEventHandler"),
    ITokenHandler: Symbol("ITokenHandler"),
    IUserHandler: Symbol("IUserHandler"),
    IBaasicApp: Symbol("IBaasicApp"),
    IBaasicPlatform: Symbol("IBaasicPlatform"),
    IDefaultStorageConfig: Symbol("IDefaultStorageConfig")
};
exports.TYPES = TYPES;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ALPHABET = {
    a: /[\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250]/ig,
    aa: /[\uA733]/ig,
    ae: /[\u00E6\u01FD\u01E3]/ig,
    ao: /[\uA735]/ig,
    au: /[\uA737]/ig,
    av: /[\uA739\uA73B]/ig,
    ay: /[\uA73D]/ig,
    b: /[\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253]/ig,
    c: /[\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184]/ig,
    d: /[\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A]/ig,
    dz: /[\u01F3\u01C6]/ig,
    e: /[\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD]/ig,
    f: /[\u0066\u24D5\uFF46\u1E1F\u0192\uA77C]/ig,
    g: /[\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F]/ig,
    h: /[\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265]/ig,
    hv: /[\u0195]/ig,
    i: /[\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131]/ig,
    j: /[\u006A\u24D9\uFF4A\u0135\u01F0\u0249]/ig,
    k: /[\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3]/ig,
    l: /[\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747]/ig,
    lj: /[\u01C9]/ig,
    m: /[\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F]/ig,
    n: /[\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5]/ig,
    nj: /[\u01CC]/ig,
    o: /[\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275]/ig,
    oi: /[\u01A3]/ig,
    ou: /[\u0223]/ig,
    oo: /[\uA74F]/ig,
    p: /[\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755]/ig,
    q: /[\u0071\u24E0\uFF51\u024B\uA757\uA759]/ig,
    r: /[\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783]/ig,
    s: /[\u0073\u24E2\uFF53\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B]/ig,
    ss: /[\u00DF\u1E9E]/ig,
    t: /[\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787]/ig,
    tz: /[\uA729]/ig,
    u: /[\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289]/ig,
    v: /[\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C]/ig,
    vy: /[\uA761]/ig,
    w: /[\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73]/ig,
    x: /[\u0078\u24E7\uFF58\u1E8B\u1E8D]/ig,
    y: /[\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF]/ig,
    z: /[\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763]/ig,
    '': /[\u0300\u0301\u0302\u0303\u0308]/ig
};
exports.ALPHABET = ALPHABET;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var Utility = /** @class */ (function () {
    function Utility() {
    }
    /**
     * Order an array by specified order type.
     * @param values of T type
     * @param orderType property name
     * @returns ordered array.
     */
    Utility.prototype.OrderByArray = function (values, orderType) {
        return values.sort(function (a, b) {
            if (a[orderType] < b[orderType]) {
                return -1;
            }
            if (a[orderType] > b[orderType]) {
                return 1;
            }
            return 0;
        });
    };
    /**
     * Checks if provided value is javascript object.
     * @param value any given value
     * @returns true if provided value is object, otherwise false.
     */
    Utility.prototype.isObject = function (value) {
        return value !== null && typeof value === 'object';
    };
    Utility.prototype.isUndefined = function (value) {
        return typeof value === 'undefined';
    };
    /**
     * Copies properties from source object to destination object.
     * @param dstObj destination object
     * @param srcObj source object
     * @returns destination object with new properties from source object.
     */
    Utility.prototype.extend = function (dstObj) {
        var srcObj = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            srcObj[_i - 1] = arguments[_i];
        }
        var newObj = dstObj;
        for (var _a = 0, srcObj_1 = srcObj; _a < srcObj_1.length; _a++) {
            var obj = srcObj_1[_a];
            for (var key in obj) {
                //copy all the fields
                newObj[key] = obj[key];
            }
        }
        return newObj;
    };
    /**
     * Copies properties from source object to destination object.
     * @param dstObj destination object
     * @param srcObj source object
     * @returns destination object with new properties from source object.
     */
    Utility.prototype.extendAs = function (dstObj) {
        var srcObj = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            srcObj[_i - 1] = arguments[_i];
        }
        srcObj.unshift(dstObj);
        return this.extend.apply(this, srcObj);
    };
    Utility = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__metadata("design:paramtypes", [])
    ], Utility);
    return Utility;
}());
exports.Utility = Utility;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module modelMapper
 * @description This service is used to perform low level model or option transformations before they are sent to the Baasic back-end.
 **/
Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(2);
var ModelMapper = /** @class */ (function () {
    function ModelMapper() {
        this.idPropertyName = 'id';
        this.modelPropertyName = 'model';
        this.utility = new _1.Utility();
    }
    ModelMapper.prototype.FindParams = function (options) {
        var object = {};
        if (this.utility.isObject(options)) {
            this.utility.extend(object, options);
            if (options.orderBy && options.orderDirection) {
                var orderByParams = options.orderBy.split(',');
                var orderDirectionParams_1 = options.orderDirection.split(',');
                if (orderByParams.length === orderDirectionParams_1.length) {
                    object.sort = orderByParams.map(function (item, index) {
                        return item + "|" + orderDirectionParams_1[index];
                    }).join(', ');
                }
            }
            if (options.hasOwnProperty('search')) {
                object.searchQuery = options.search;
            }
            if (options.hasOwnProperty('pageNumber')) {
                object.page = options.pageNumber;
            }
            if (options.hasOwnProperty('pageSize')) {
                object.rpp = options.pageSize;
            }
        }
        else {
            object.searchQuery = options;
        }
        return object;
    };
    ModelMapper.prototype.KeyParams = function (id, options, propName) {
        var object = {};
        if (this.utility.isObject(id)) {
            this.utility.extend(object, id);
        }
        else {
            if (propName !== undefined) {
                object[propName] = id;
            }
            else {
                object[this.idPropertyName] = id;
            }
        }
        if (options !== undefined && this.utility.isObject(options)) {
            this.utility.extend(object, options);
        }
        return object;
    };
    ModelMapper.prototype.ModelParams = function (data) {
        var object = {};
        if (data && data.hasOwnProperty(this.modelPropertyName)) {
            this.utility.extend(object, data);
        }
        else {
            object[this.modelPropertyName] = data;
        }
        return object;
    };
    /**
     * Parses Baasic Api pagination, sorting and search parameters.
     * @param options query resources options object
     * @method
     * @example modelMapper.findParams({ pageNumber:1, pageSize:10 });
     **/
    ModelMapper.prototype.findParams = function (options) {
        return this.FindParams(options);
    };
    /**
     * Parses specified key parameters; initial object can be expanded with additional parameters.
     * @param id Resources unique identifier
     * @param options query resources options object
     * @param propName property name
     * @method
     * @example modelMapper.getParams(('<value>', {additionalOptions: '<option>'},'<property-name>'));
     **/
    ModelMapper.prototype.getParams = function (id, options, propName) {
        return this.KeyParams(id, options, propName);
    };
    /**
     * Performs create resource transforms on an object so that it can be safely expanded with additional properties.
     * @param data data object
     * @method
     * @example modelMapper.createParams({});
     **/
    ModelMapper.prototype.createParams = function (data) {
        return this.ModelParams(data);
    };
    /**
     * Performs update resource transforms on transforms an object so that it can be safely expanded with additional properties.
     * @param data data object
     * @method
     * @example modelMapper.updateParams({});
     **/
    ModelMapper.prototype.updateParams = function (data) {
        return this.ModelParams(data);
    };
    /**
     * Performs remove resource transforms on transforms an object so that it can be safely expanded with additional properties.
     * @param data data object
     * @method
     * @example modelMapper.removeParams({});
     **/
    ModelMapper.prototype.removeParams = function (data) {
        return this.ModelParams(data);
    };
    /**
 * Performs remove resource transforms on transforms an object so that it can be safely expanded with additional properties.
 * @param data data object
 * @method
 * @example modelMapper.batchRemoveParams({});
 **/
    ModelMapper.prototype.batchRemoveParams = function (data) {
        var _this = this;
        var items = [];
        data.forEach(function (item) {
            if (_this.utility.isObject(item)) {
                items.push(item[_this.idPropertyName]);
            }
        });
        return items;
    };
    return ModelMapper;
}());
exports.ModelMapper = ModelMapper;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var uritemplate = __webpack_require__(118);
var _1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var inversify_1 = __webpack_require__(1);
var BaseRoute = /** @class */ (function () {
    function BaseRoute(appOptions) {
        this.appOptions = appOptions;
        this.utility = new _1.Utility();
        this.modelMapper = new _1.ModelMapper();
        this.dateFormatter = new _1.DateFormatter();
    }
    /**
     * Parses resources route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain resource subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the resource property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @returns Query resources uri with search params
     * @example baasicBaseDefinition.find();
     **/
    BaseRoute.prototype.baseFind = function (route, options) {
        var params = this.modelMapper.findParams(options);
        return uritemplate.parse(route).expand(params);
    };
    /**
      * Parses get resource route which must be expanded with the Id of the previously created resource in the system.
      * @returns get resource uri
      * @method
      * @example baseRoute.get(route, id);
      **/
    BaseRoute.prototype.baseGet = function (route, id, options, propName) {
        if (options !== null && !this.utility.isUndefined(options) && !this.utility.isUndefined(options.dateUpdated)) {
            options.t = this.dateFormatter.FormatToString(new Date(options.dateUpdated), null);
        }
        return uritemplate.parse(route).expand(this.modelMapper.getParams(id, options, propName));
    };
    /**
      * Parses get resource route which must be expanded with the Id of the previously created resource in the system.
      * @returns get resource uri
      * @method
      * @example baseRoute.create();
      **/
    BaseRoute.prototype.baseCreate = function (route, data) {
        if (data !== null && !this.utility.isUndefined(data) && !this.utility.isUndefined(data.dateUpdated)) {
            data.t = this.dateFormatter.FormatToString(new Date(data.dateUpdated), null);
        }
        return uritemplate.parse(route).expand(data);
    };
    /**
     * Parses get resource route.
     * @returns update resource uri
     * @method
     * @example baseRoute.update();
     */
    BaseRoute.prototype.baseUpdate = function (route, data, options, linkName) {
        var link = linkName ? linkName : 'put';
        var params = this.modelMapper.updateParams(data);
        var model = params[this.modelMapper.modelPropertyName];
        if (typeof options === 'undefined') {
            if (this.appOptions.enableHALJSON && model.links) {
                return model.links(link).href;
            }
            else {
                return uritemplate.parse(route).expand(model);
            }
        }
        else {
            var modelCopy = this.utility.extend({}, model);
            var opt = this.utility.extend(modelCopy, options);
            if (this.appOptions.enableHALJSON && model.links) {
                return uritemplate.parse(model.links(link).href).expand(opt);
            }
            else {
                return uritemplate.parse(route).expand(opt);
            }
        }
    };
    /**
     * Parses delete resource route.
     * @returns delete resource uri.
     * @method
     * @example baseRoute.delete();
     */
    BaseRoute.prototype.baseDelete = function (route, data, options, linkName) {
        var link = linkName ? linkName : 'delete';
        var params = this.modelMapper.removeParams(data);
        var model = params[this.modelMapper.modelPropertyName];
        if (typeof options === 'undefined') {
            if (this.appOptions.enableHALJSON && model.links) {
                return model.links(link).href;
            }
            else {
                return uritemplate.parse(route).expand(model);
            }
        }
        else {
            var opt = this.utility.extend(model, options);
            if (this.appOptions.enableHALJSON && model.links) {
                return uritemplate.parse(model.links(link).href).expand(opt);
            }
            else {
                return uritemplate.parse(route).expand(opt);
            }
        }
    };
    BaseRoute.prototype.createParams = function (data, prop) {
        var propertyName = prop || this.modelMapper.modelPropertyName;
        return this.modelMapper.createParams(data)[propertyName];
    };
    BaseRoute.prototype.updateParams = function (data) {
        return this.modelMapper.updateParams(data)[this.modelMapper.modelPropertyName];
    };
    BaseRoute.prototype.deleteParams = function (data) {
        return this.modelMapper.removeParams(data)[this.modelMapper.modelPropertyName];
    };
    BaseRoute.prototype.deleteBatchParams = function (data) {
        return this.modelMapper.batchRemoveParams(data);
    };
    /**
     * Parses and expands URI templates based on [RFC6570](http://tools.ietf.org/html/rfc6570) specifications. For more information please visit the project [GitHub](https://github.com/Baasic/uritemplate-js) page.
     * @method
     * @example baseRoute.parse('<route>/{?embed,fields,options}').expand({embed: '<embedded-resource>'});
     **/
    BaseRoute.prototype.parse = function (route) {
        return uritemplate.parse(route);
    };
    var _a;
    BaseRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], BaseRoute);
    return BaseRoute;
}());
exports.BaseRoute = BaseRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

/*global unescape, module, define, window, global*/

/*
 UriTemplate Copyright (c) 2012-2013 Franz Antesberger. All Rights Reserved.
 Available via the MIT license.
*/

(function (exportCallback) {
    "use strict";

var UriTemplateError = (function () {

    function UriTemplateError (options) {
        this.options = options;
    }

    UriTemplateError.prototype.toString = function () {
        if (JSON && JSON.stringify) {
            return JSON.stringify(this.options);
        }
        else {
            return this.options;
        }
    };

    return UriTemplateError;
}());

var objectHelper = (function () {
    function isArray (value) {
        return Object.prototype.toString.apply(value) === '[object Array]';
    }

    function isString (value) {
        return Object.prototype.toString.apply(value) === '[object String]';
    }
    
    function isNumber (value) {
        return Object.prototype.toString.apply(value) === '[object Number]';
    }
    
    function isBoolean (value) {
        return Object.prototype.toString.apply(value) === '[object Boolean]';
    }
    
    function join (arr, separator) {
        var
            result = '',
            first = true,
            index;
        for (index = 0; index < arr.length; index += 1) {
            if (first) {
                first = false;
            }
            else {
                result += separator;
            }
            result += arr[index];
        }
        return result;
    }

    function map (arr, mapper) {
        var
            result = [],
            index = 0;
        for (; index < arr.length; index += 1) {
            result.push(mapper(arr[index]));
        }
        return result;
    }

    function filter (arr, predicate) {
        var
            result = [],
            index = 0;
        for (; index < arr.length; index += 1) {
            if (predicate(arr[index])) {
                result.push(arr[index]);
            }
        }
        return result;
    }

    function deepFreezeUsingObjectFreeze (object) {
        if (typeof object !== "object" || object === null) {
            return object;
        }
        Object.freeze(object);
        var property, propertyName;
        for (propertyName in object) {
            if (object.hasOwnProperty(propertyName)) {
                property = object[propertyName];
                // be aware, arrays are 'object', too
                if (typeof property === "object") {
                    deepFreeze(property);
                }
            }
        }
        return object;
    }

    function deepFreeze (object) {
        if (typeof Object.freeze === 'function') {
            return deepFreezeUsingObjectFreeze(object);
        }
        return object;
    }


    return {
        isArray: isArray,
        isString: isString,
        isNumber: isNumber,
        isBoolean: isBoolean,
        join: join,
        map: map,
        filter: filter,
        deepFreeze: deepFreeze
    };
}());

var charHelper = (function () {

    function isAlpha (chr) {
        return (chr >= 'a' && chr <= 'z') || ((chr >= 'A' && chr <= 'Z'));
    }

    function isDigit (chr) {
        return chr >= '0' && chr <= '9';
    }

    function isHexDigit (chr) {
        return isDigit(chr) || (chr >= 'a' && chr <= 'f') || (chr >= 'A' && chr <= 'F');
    }

    return {
        isAlpha: isAlpha,
        isDigit: isDigit,
        isHexDigit: isHexDigit
    };
}());

var pctEncoder = (function () {
    var utf8 = {
        encode: function (chr) {
            // see http://ecmanaut.blogspot.de/2006/07/encoding-decoding-utf8-in-javascript.html
            return unescape(encodeURIComponent(chr));
        },
        numBytes: function (firstCharCode) {
            if (firstCharCode <= 0x7F) {
                return 1;
            }
            else if (0xC2 <= firstCharCode && firstCharCode <= 0xDF) {
                return 2;
            }
            else if (0xE0 <= firstCharCode && firstCharCode <= 0xEF) {
                return 3;
            }
            else if (0xF0 <= firstCharCode && firstCharCode <= 0xF4) {
                return 4;
            }
            // no valid first octet
            return 0;
        },
        isValidFollowingCharCode: function (charCode) {
            return 0x80 <= charCode && charCode <= 0xBF;
        }
    };

    /**
     * encodes a character, if needed or not.
     * @param chr
     * @return pct-encoded character
     */
    function encodeCharacter (chr) {
        var
            result = '',
            octets = utf8.encode(chr),
            octet,
            index;
        for (index = 0; index < octets.length; index += 1) {
            octet = octets.charCodeAt(index);
            result += '%' + (octet < 0x10 ? '0' : '') + octet.toString(16).toUpperCase();
        }
        return result;
    }

    /**
     * Returns, whether the given text at start is in the form 'percent hex-digit hex-digit', like '%3F'
     * @param text
     * @param start
     * @return {boolean|*|*}
     */
    function isPercentDigitDigit (text, start) {
        return text.charAt(start) === '%' && charHelper.isHexDigit(text.charAt(start + 1)) && charHelper.isHexDigit(text.charAt(start + 2));
    }

    /**
     * Parses a hex number from start with length 2.
     * @param text a string
     * @param start the start index of the 2-digit hex number
     * @return {Number}
     */
    function parseHex2 (text, start) {
        return parseInt(text.substr(start, 2), 16);
    }

    /**
     * Returns whether or not the given char sequence is a correctly pct-encoded sequence.
     * @param chr
     * @return {boolean}
     */
    function isPctEncoded (chr) {
        if (!isPercentDigitDigit(chr, 0)) {
            return false;
        }
        var firstCharCode = parseHex2(chr, 1);
        var numBytes = utf8.numBytes(firstCharCode);
        if (numBytes === 0) {
            return false;
        }
        for (var byteNumber = 1; byteNumber < numBytes; byteNumber += 1) {
            if (!isPercentDigitDigit(chr, 3*byteNumber) || !utf8.isValidFollowingCharCode(parseHex2(chr, 3*byteNumber + 1))) {
                return false;
            }
        }
        return true;
    }

    /**
     * Reads as much as needed from the text, e.g. '%20' or '%C3%B6'. It does not decode!
     * @param text
     * @param startIndex
     * @return the character or pct-string of the text at startIndex
     */
    function pctCharAt(text, startIndex) {
        var chr = text.charAt(startIndex);
        if (!isPercentDigitDigit(text, startIndex)) {
            return chr;
        }
        var utf8CharCode = parseHex2(text, startIndex + 1);
        var numBytes = utf8.numBytes(utf8CharCode);
        if (numBytes === 0) {
            return chr;
        }
        for (var byteNumber = 1; byteNumber < numBytes; byteNumber += 1) {
            if (!isPercentDigitDigit(text, startIndex + 3 * byteNumber) || !utf8.isValidFollowingCharCode(parseHex2(text, startIndex + 3 * byteNumber + 1))) {
                return chr;
            }
        }
        return text.substr(startIndex, 3 * numBytes);
    }

    return {
        encodeCharacter: encodeCharacter,
        isPctEncoded: isPctEncoded,
        pctCharAt: pctCharAt
    };
}());

var rfcCharHelper = (function () {

    /**
     * Returns if an character is an varchar character according 2.3 of rfc 6570
     * @param chr
     * @return (Boolean)
     */
    function isVarchar (chr) {
        return charHelper.isAlpha(chr) || charHelper.isDigit(chr) || chr === '_' || pctEncoder.isPctEncoded(chr);
    }

    /**
     * Returns if chr is an unreserved character according 1.5 of rfc 6570
     * @param chr
     * @return {Boolean}
     */
    function isUnreserved (chr) {
        return charHelper.isAlpha(chr) || charHelper.isDigit(chr) || chr === '-' || chr === '.' || chr === '_' || chr === '~';
    }

    /**
     * Returns if chr is an reserved character according 1.5 of rfc 6570
     * or the percent character mentioned in 3.2.1.
     * @param chr
     * @return {Boolean}
     */
    function isReserved (chr) {
        return chr === ':' || chr === '/' || chr === '?' || chr === '#' || chr === '[' || chr === ']' || chr === '@' || chr === '!' || chr === '$' || chr === '&' || chr === '(' ||
            chr === ')' || chr === '*' || chr === '+' || chr === ',' || chr === ';' || chr === '=' || chr === "'";
    }

    return {
        isVarchar: isVarchar,
        isUnreserved: isUnreserved,
        isReserved: isReserved
    };

}());

/**
 * encoding of rfc 6570
 */
var encodingHelper = (function () {

    function encode (text, passReserved) {
        var
            result = '',
            index,
            chr = '';
        if (typeof text === "number" || typeof text === "boolean") {
            text = text.toString();
        }
        for (index = 0; index < text.length; index += chr.length) {
            chr = text.charAt(index);
            result += rfcCharHelper.isUnreserved(chr) || (passReserved && rfcCharHelper.isReserved(chr)) ? chr : pctEncoder.encodeCharacter(chr);
        }
        return result;
    }

    function encodePassReserved (text) {
        return encode(text, true);
    }

    function encodeLiteralCharacter (literal, index) {
        var chr = pctEncoder.pctCharAt(literal, index);
        if (chr.length > 1) {
            return chr;
        }
        else {
            return rfcCharHelper.isReserved(chr) || rfcCharHelper.isUnreserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
        }
    }

    function encodeLiteral (literal) {
        var
            result = '',
            index,
            chr = '';
        for (index = 0; index < literal.length; index += chr.length) {
            chr = pctEncoder.pctCharAt(literal, index);
            if (chr.length > 1) {
                result += chr;
            }
            else {
                result += rfcCharHelper.isReserved(chr) || rfcCharHelper.isUnreserved(chr) ? chr : pctEncoder.encodeCharacter(chr);
            }
        }
        return result;
    }

    return {
        encode: encode,
        encodePassReserved: encodePassReserved,
        encodeLiteral: encodeLiteral,
        encodeLiteralCharacter: encodeLiteralCharacter
    };

}());


// the operators defined by rfc 6570
var operators = (function () {

    var
        bySymbol = {};

    function create (symbol) {
        bySymbol[symbol] = {
            symbol: symbol,
            separator: (symbol === '?') ? '&' : (symbol === '' || symbol === '+' || symbol === '#') ? ',' : symbol,
            named: symbol === ';' || symbol === '&' || symbol === '?',
            ifEmpty: (symbol === '&' || symbol === '?') ? '=' : '',
            first: (symbol === '+' ) ? '' : symbol,
            encode: (symbol === '+' || symbol === '#') ? encodingHelper.encodePassReserved : encodingHelper.encode,
            toString: function () {
                return this.symbol;
            }
        };
    }

    create('');
    create('+');
    create('#');
    create('.');
    create('/');
    create(';');
    create('?');
    create('&');
    return {
        valueOf: function (chr) {
            if (bySymbol[chr]) {
                return bySymbol[chr];
            }
            if ("=,!@|".indexOf(chr) >= 0) {
                return null;
            }
            return bySymbol[''];
        }
    };
}());


/**
 * Detects, whether a given element is defined in the sense of rfc 6570
 * Section 2.3 of the RFC makes clear defintions:
 * * undefined and null are not defined.
 * * the empty string is defined
 * * an array ("list") is defined, if it is not empty (even if all elements are not defined)
 * * an object ("map") is defined, if it contains at least one property with defined value
 * @param object
 * @return {Boolean}
 */
function isDefined (object) {
    var
        propertyName;
    if (object === null || object === undefined) {
        return false;
    }
    if (objectHelper.isArray(object)) {
        // Section 2.3: A variable defined as a list value is considered undefined if the list contains zero members
        return object.length > 0;
    }
    if (typeof object === "string" || typeof object === "number" || typeof object === "boolean") {
        // falsy values like empty strings, false or 0 are "defined"
        return true;
    }
    // else Object
    for (propertyName in object) {
        if (object.hasOwnProperty(propertyName) && isDefined(object[propertyName])) {
            return true;
        }
    }
    return false;
}

var LiteralExpression = (function () {
    function LiteralExpression (literal) {
        this.literal = encodingHelper.encodeLiteral(literal);
    }

    LiteralExpression.prototype.expand = function () {
        return this.literal;
    };

    LiteralExpression.prototype.toString = LiteralExpression.prototype.expand;

    return LiteralExpression;
}());

var parse = (function () {

    function parseExpression (expressionText) {
        var
            operator,
            varspecs = [],
            varspec = null,
            varnameStart = null,
            maxLengthStart = null,
            index,
            chr = '';

        function closeVarname () {
            var varname = expressionText.substring(varnameStart, index);
            if (varname.length === 0) {
                throw new UriTemplateError({expressionText: expressionText, message: "a varname must be specified", position: index});
            }
            varspec = {varname: varname, exploded: false, maxLength: null};
            varnameStart = null;
        }

        function closeMaxLength () {
            if (maxLengthStart === index) {
                throw new UriTemplateError({expressionText: expressionText, message: "after a ':' you have to specify the length", position: index});
            }
            varspec.maxLength = parseInt(expressionText.substring(maxLengthStart, index), 10);
            maxLengthStart = null;
        }

        operator = (function (operatorText) {
            var op = operators.valueOf(operatorText);
            if (op === null) {
                throw new UriTemplateError({expressionText: expressionText, message: "illegal use of reserved operator", position: index, operator: operatorText});
            }
            return op;
        }(expressionText.charAt(0)));
        index = operator.symbol.length;

        varnameStart = index;

        for (; index < expressionText.length; index += chr.length) {
            chr = pctEncoder.pctCharAt(expressionText, index);

            if (varnameStart !== null) {
                // the spec says: varname =  varchar *( ["."] varchar )
                // so a dot is allowed except for the first char
                if (chr === '.') {
                    if (varnameStart === index) {
                        throw new UriTemplateError({expressionText: expressionText, message: "a varname MUST NOT start with a dot", position: index});
                    }
                    continue;
                }
                if (rfcCharHelper.isVarchar(chr)) {
                    continue;
                }
                closeVarname();
            }
            if (maxLengthStart !== null) {
                if (index === maxLengthStart && chr === '0') {
                    throw new UriTemplateError({expressionText: expressionText, message: "A :prefix must not start with digit 0", position: index});
                }
                if (charHelper.isDigit(chr)) {
                    if (index - maxLengthStart >= 4) {
                        throw new UriTemplateError({expressionText: expressionText, message: "A :prefix must have max 4 digits", position: index});
                    }
                    continue;
                }
                closeMaxLength();
            }
            if (chr === ':') {
                if (varspec.maxLength !== null) {
                    throw new UriTemplateError({expressionText: expressionText, message: "only one :maxLength is allowed per varspec", position: index});
                }
                if (varspec.exploded) {
                    throw new UriTemplateError({expressionText: expressionText, message: "an exploeded varspec MUST NOT be varspeced", position: index});
                }
                maxLengthStart = index + 1;
                continue;
            }
            if (chr === '*') {
                if (varspec === null) {
                    throw new UriTemplateError({expressionText: expressionText, message: "exploded without varspec", position: index});
                }
                if (varspec.exploded) {
                    throw new UriTemplateError({expressionText: expressionText, message: "exploded twice", position: index});
                }
                if (varspec.maxLength) {
                    throw new UriTemplateError({expressionText: expressionText, message: "an explode (*) MUST NOT follow to a prefix", position: index});
                }
                varspec.exploded = true;
                continue;
            }
            // the only legal character now is the comma
            if (chr === ',') {
                varspecs.push(varspec);
                varspec = null;
                varnameStart = index + 1;
                continue;
            }
            throw new UriTemplateError({expressionText: expressionText, message: "illegal character", character: chr, position: index});
        } // for chr
        if (varnameStart !== null) {
            closeVarname();
        }
        if (maxLengthStart !== null) {
            closeMaxLength();
        }
        varspecs.push(varspec);
        return new VariableExpression(expressionText, operator, varspecs);
    }

    function parse (uriTemplateText) {
        // assert filled string
        var
            index,
            chr,
            expressions = [],
            braceOpenIndex = null,
            literalStart = 0;
        for (index = 0; index < uriTemplateText.length; index += 1) {
            chr = uriTemplateText.charAt(index);
            if (literalStart !== null) {
                if (chr === '}') {
                    throw new UriTemplateError({templateText: uriTemplateText, message: "unopened brace closed", position: index});
                }
                if (chr === '{') {
                    if (literalStart < index) {
                        expressions.push(new LiteralExpression(uriTemplateText.substring(literalStart, index)));
                    }
                    literalStart = null;
                    braceOpenIndex = index;
                }
                continue;
            }

            if (braceOpenIndex !== null) {
                // here just { is forbidden
                if (chr === '{') {
                    throw new UriTemplateError({templateText: uriTemplateText, message: "brace already opened", position: index});
                }
                if (chr === '}') {
                    if (braceOpenIndex + 1 === index) {
                        throw new UriTemplateError({templateText: uriTemplateText, message: "empty braces", position: braceOpenIndex});
                    }
                    try {
                        expressions.push(parseExpression(uriTemplateText.substring(braceOpenIndex + 1, index)));
                    }
                    catch (error) {
                        if (error.prototype === UriTemplateError.prototype) {
                            throw new UriTemplateError({templateText: uriTemplateText, message: error.options.message, position: braceOpenIndex + error.options.position, details: error.options});
                        }
                        throw error;
                    }
                    braceOpenIndex = null;
                    literalStart = index + 1;
                }
                continue;
            }
            throw new Error('reached unreachable code');
        }
        if (braceOpenIndex !== null) {
            throw new UriTemplateError({templateText: uriTemplateText, message: "unclosed brace", position: braceOpenIndex});
        }
        if (literalStart < uriTemplateText.length) {
            expressions.push(new LiteralExpression(uriTemplateText.substr(literalStart)));
        }
        return new UriTemplate(uriTemplateText, expressions);
    }

    return parse;
}());

var VariableExpression = (function () {
    // helper function if JSON is not available
    function prettyPrint (value) {
        return (JSON && JSON.stringify) ? JSON.stringify(value) : value;
    }

    function isEmpty (value) {
        if (!isDefined(value)) {
            return true;
        }
        if (objectHelper.isString(value)) {
            return value === '';
        }
        if (objectHelper.isNumber(value) || objectHelper.isBoolean(value)) {
            return false;
        }
        if (objectHelper.isArray(value)) {
            return value.length === 0;
        }
        for (var propertyName in value) {
            if (value.hasOwnProperty(propertyName)) {
                return false;
            }
        }
        return true;
    }

    function propertyArray (object) {
        var
            result = [],
            propertyName;
        for (propertyName in object) {
            if (object.hasOwnProperty(propertyName)) {
                result.push({name: propertyName, value: object[propertyName]});
            }
        }
        return result;
    }

    function VariableExpression (templateText, operator, varspecs) {
        this.templateText = templateText;
        this.operator = operator;
        this.varspecs = varspecs;
    }

    VariableExpression.prototype.toString = function () {
        return this.templateText;
    };

    function expandSimpleValue(varspec, operator, value) {
        var result = '';
        value = value.toString();
        if (operator.named) {
            result += encodingHelper.encodeLiteral(varspec.varname);
            if (value === '') {
                result += operator.ifEmpty;
                return result;
            }
            result += '=';
        }
        if (varspec.maxLength !== null) {
            value = value.substr(0, varspec.maxLength);
        }
        result += operator.encode(value);
        return result;
    }

    function valueDefined (nameValue) {
        return isDefined(nameValue.value);
    }

    function expandNotExploded(varspec, operator, value) {
        var
            arr = [],
            result = '';
        if (operator.named) {
            result += encodingHelper.encodeLiteral(varspec.varname);
            if (isEmpty(value)) {
                result += operator.ifEmpty;
                return result;
            }
            result += '=';
        }
        if (objectHelper.isArray(value)) {
            arr = value;
            arr = objectHelper.filter(arr, isDefined);
            arr = objectHelper.map(arr, operator.encode);
            result += objectHelper.join(arr, ',');
        }
        else {
            arr = propertyArray(value);
            arr = objectHelper.filter(arr, valueDefined);
            arr = objectHelper.map(arr, function (nameValue) {
                return operator.encode(nameValue.name) + ',' + operator.encode(nameValue.value);
            });
            result += objectHelper.join(arr, ',');
        }
        return result;
    }

    function expandExplodedNamed (varspec, operator, value) {
        var
            isArray = objectHelper.isArray(value),
            arr = [];
        if (isArray) {
            arr = value;
            arr = objectHelper.filter(arr, isDefined);
            arr = objectHelper.map(arr, function (listElement) {
                var tmp = encodingHelper.encodeLiteral(varspec.varname);
                if (isEmpty(listElement)) {
                    tmp += operator.ifEmpty;
                }
                else {
                    tmp += '=' + operator.encode(listElement);
                }
                return tmp;
            });
        }
        else {
            arr = propertyArray(value);
            arr = objectHelper.filter(arr, valueDefined);
            arr = objectHelper.map(arr, function (nameValue) {
                var tmp = encodingHelper.encodeLiteral(nameValue.name);
                if (isEmpty(nameValue.value)) {
                    tmp += operator.ifEmpty;
                }
                else {
                    tmp += '=' + operator.encode(nameValue.value);
                }
                return tmp;
            });
        }
        return objectHelper.join(arr, operator.separator);
    }

    function expandExplodedUnnamed (operator, value) {
        var
            arr = [],
            result = '';
        if (objectHelper.isArray(value)) {
            arr = value;
            arr = objectHelper.filter(arr, isDefined);
            arr = objectHelper.map(arr, operator.encode);
            result += objectHelper.join(arr, operator.separator);
        }
        else {
            arr = propertyArray(value);
            arr = objectHelper.filter(arr, function (nameValue) {
                return isDefined(nameValue.value);
            });
            arr = objectHelper.map(arr, function (nameValue) {
                return operator.encode(nameValue.name) + '=' + operator.encode(nameValue.value);
            });
            result += objectHelper.join(arr, operator.separator);
        }
        return result;
    }


    VariableExpression.prototype.expand = function (variables) {
        var
            expanded = [],
            index,
            varspec,
            value,
            valueIsArr,
            oneExploded = false,
            operator = this.operator;

        // expand each varspec and join with operator's separator
        for (index = 0; index < this.varspecs.length; index += 1) {
            varspec = this.varspecs[index];
            value = variables[varspec.varname];
            // if (!isDefined(value)) {
            // if (variables.hasOwnProperty(varspec.name)) {
            if (value === null || value === undefined) {
                continue;
            }
            if (varspec.exploded) {
                oneExploded = true;
            }
            valueIsArr = objectHelper.isArray(value);
            if (typeof value === "string" || typeof value === "number" || typeof value === "boolean") {
                expanded.push(expandSimpleValue(varspec, operator, value));
            }
            else if (varspec.maxLength && isDefined(value)) {
                // 2.4.1 of the spec says: "Prefix modifiers are not applicable to variables that have composite values."
                throw new Error('Prefix modifiers are not applicable to variables that have composite values. You tried to expand ' + this + " with " + prettyPrint(value));
            }
            else if (!varspec.exploded) {
                if (operator.named || !isEmpty(value)) {
                    expanded.push(expandNotExploded(varspec, operator, value));
                }
            }
            else if (isDefined(value)) {
                if (operator.named) {
                    expanded.push(expandExplodedNamed(varspec, operator, value));
                }
                else {
                    expanded.push(expandExplodedUnnamed(operator, value));
                }
            }
        }

        if (expanded.length === 0) {
            return "";
        }
        else {
            return operator.first + objectHelper.join(expanded, operator.separator);
        }
    };

    return VariableExpression;
}());

var UriTemplate = (function () {
    function UriTemplate (templateText, expressions) {
        this.templateText = templateText;
        this.expressions = expressions;
        objectHelper.deepFreeze(this);
    }

    UriTemplate.prototype.toString = function () {
        return this.templateText;
    };

    UriTemplate.prototype.expand = function (variables) {
        // this.expressions.map(function (expression) {return expression.expand(variables);}).join('');
        var
            index,
            result = '';
        for (index = 0; index < this.expressions.length; index += 1) {
            result += this.expressions[index].expand(variables);
        }
        return result;
    };

    UriTemplate.parse = parse;
    UriTemplate.UriTemplateError = UriTemplateError;
    return UriTemplate;
}());

    exportCallback(UriTemplate);

}(function (UriTemplate) {
        "use strict";
        // export UriTemplate, when module is present, or pass it to window or global
        if (true) {
            module.exports = UriTemplate;
        }
        else {}
    }
));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var _1 = __webpack_require__(2);
var utility = new _1.Utility();
//HAL Parser is based on https://github.com/Baasic/angular-hal & https://github.com/jasonaden/angular-hal implementation. Parser is used to parse [HAL (Hyptertext Application Language)](http://stateless.co/hal_specification.html) JSON structures into usable JavaScript objects.
var __bind = function (fn, me) { return function () { return fn.apply(me, arguments); }; };
var removeNamespace;
removeNamespace = function (name, ns) {
    ns = ns ? ns + ':' : '';
    if (ns) { }
    if (name.substr(0, ns.length) === ns) {
        return name.substr(ns.length);
    }
    else {
        return name;
    }
};
var Link, Links, Resource;
function Parser(ns) {
    this.ns = ns;
    this.parse = __bind(this.parse, this);
}
Parser.prototype.parse = function (hal) {
    var json, _embedded, _links;
    json = utility.extend(hal);
    _links = json._links, _embedded = json._embedded;
    delete json._links;
    delete json._embedded;
    return new Resource(json, _links, _embedded, this.ns);
};
Resource = (function () {
    function Resource(data, links, embedded, ns) {
        var em, name, prop, resourceLinks;
        ns = ns ? ns : '';
        utility.extend(this, data);
        resourceLinks = links ? new Links(links) : {};
        for (name in embedded) {
            prop = embedded[name];
            this[removeNamespace(name, ns)] = (function () {
                var _i, _len, _results;
                if (prop) {
                    if (Array.isArray(prop)) {
                        _results = [];
                        for (_i = 0, _len = prop.length; _i < _len; _i++) {
                            em = prop[_i];
                            _results.push(new Parser(ns).parse(em, ns));
                        }
                        return _results;
                    }
                    else {
                        return new Parser(ns).parse(prop, ns);
                    }
                }
            })();
        }
        this.links = function (name) {
            var key;
            if (name == null) {
                name = '';
            }
            key = name === 'self' ? name : resourceLinks[name] ? name : ns + ':' + name;
            if (resourceLinks[key]) {
                return resourceLinks[key];
            }
            else {
                return resourceLinks;
            }
        };
    }
    return Resource;
})();
Links = (function () {
    function Links(links, ns) {
        var link, lk, name;
        if (!(links != null ? links.self : void 0)) {
            console.log('Self link is missing.');
        }
        for (name in links) {
            link = links[name];
            this[name] = (function () {
                var _i, _len, _results;
                if (Array.isArray(link)) {
                    _results = [];
                    for (_i = 0, _len = link.length; _i < _len; _i++) {
                        lk = link[_i];
                        _results.push(new Link(lk, ns));
                    }
                    return _results;
                }
                else {
                    return new Link(link, ns);
                }
            })();
        }
    }
    return Links;
})();
Link = (function () {
    function Link(link, ns) {
        if (!(link != null ? link.href : void 0)) {
            throw 'href is required for all links';
        }
        this.href = link.href, this.name = link.name, this.profile = link.profile;
        this.templated = !!link.templated;
        this.title = link.title || '';
    }
    return Link;
})();
var HALParser;
exports.HALParser = HALParser;
exports.HALParser = HALParser = new Parser('JavaScriptSDK');


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(121), exports);
tslib_1.__exportStar(__webpack_require__(122), exports);
tslib_1.__exportStar(__webpack_require__(123), exports);
tslib_1.__exportStar(__webpack_require__(124), exports);
tslib_1.__exportStar(__webpack_require__(125), exports);
tslib_1.__exportStar(__webpack_require__(126), exports);
tslib_1.__exportStar(__webpack_require__(127), exports);
tslib_1.__exportStar(__webpack_require__(128), exports);
tslib_1.__exportStar(__webpack_require__(129), exports);
tslib_1.__exportStar(__webpack_require__(130), exports);
tslib_1.__exportStar(__webpack_require__(131), exports);
tslib_1.__exportStar(__webpack_require__(132), exports);
tslib_1.__exportStar(__webpack_require__(133), exports);


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var DateFormatter = /** @class */ (function () {
    function DateFormatter() {
    }
    /**
     * Format the date to the given format
     * @param date Date
     * @param format? nullable format value. If not provided, the yyyyMMddHHmmss format is used
     * @returns formatted date.
     */
    DateFormatter.prototype.FormatToString = function (date, format) {
        var formatSet = 'yyyyMMddHHmmss';
        if (format !== undefined && format !== null && format !== '') {
            formatSet = format;
        }
        var formattsSplitted = formatSet.match(/(.)\1*/g);
        if (formattsSplitted.length === 0) {
            return '';
        }
        var dateFormatted = '';
        for (var i = 0; i < formattsSplitted.length; i++) {
            var formatSelected = formattsSplitted[i];
            dateFormatted += this.GetDateSectionFormatted(date, formatSelected);
        }
        return dateFormatted;
    };
    DateFormatter.prototype.GetDateSectionFormatted = function (date, format) {
        var sectionFormatted;
        switch (format) {
            case 'yyyy':
                sectionFormatted = date.getFullYear().toString();
                break;
            case 'MM':
                // JS Month is 0 index based
                var month = date.getMonth() + 1;
                sectionFormatted = month < 10 ? sectionFormatted = "0" + month : month.toString();
                break;
            case 'dd':
                var day = date.getDay();
                sectionFormatted = day < 10 ? sectionFormatted = "0" + day : day.toString();
                break;
            case 'HH':
                var hours = date.getHours();
                sectionFormatted = hours < 10 ? sectionFormatted = "0" + hours : hours.toString();
                break;
            case 'mm':
                var minutes = date.getMinutes();
                sectionFormatted = minutes < 10 ? sectionFormatted = "0" + minutes : minutes.toString();
                break;
            case 'ss':
                var sec = date.getSeconds();
                sectionFormatted = sec < 10 ? sectionFormatted = "0" + sec : sec.toString();
                break;
            default:
                sectionFormatted = '';
        }
        return sectionFormatted;
    };
    DateFormatter = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__metadata("design:paramtypes", [])
    ], DateFormatter);
    return DateFormatter;
}());
exports.DateFormatter = DateFormatter;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(136), exports);


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var JQueryHttpClient = /** @class */ (function () {
    function JQueryHttpClient() {
    }
    JQueryHttpClient.prototype.request = function (request) {
        var jqueryParams = {
            method: request.method,
            xhrFields: {
                withCredentials: true
            }
        };
        if (request.headers) {
            jqueryParams.headers = request.headers;
        }
        if (request.data) {
            var contentType = getHeader(request.headers, 'Content-Type');
            if (contentType && contentType.toLowerCase().indexOf('application/json') !== -1) {
                jqueryParams.data = JSON.stringify(request.data);
            }
            else {
                jqueryParams.data = request.data;
            }
        }
        if (request.responseType) {
            jqueryParams.dataType = request.responseType;
        }
        return $.ajax(request.url.toString(), jqueryParams)
            .then(function (data, textStatus, jqXHR) {
            return {
                request: request,
                statusText: textStatus,
                statusCode: jqXHR.status,
                headers: parseHeaders(jqXHR.getAllResponseHeaders()),
                data: data
            };
        }, function (jqXHR, textStatus, errorThrown) {
            throw {
                request: request,
                statusText: textStatus,
                statusCode: jqXHR.status,
                headers: parseHeaders(jqXHR.getAllResponseHeaders()),
                data: tryConvertToJson(jqXHR.responseText) || jqXHR.responseXML
            };
        });
    };
    JQueryHttpClient.prototype.createPromise = function (deferFn) {
        var deferred = $.Deferred();
        deferFn(deferred.resolve, deferred.reject);
        return deferred.promise();
    };
    JQueryHttpClient = tslib_1.__decorate([
        inversify_1.injectable()
    ], JQueryHttpClient);
    return JQueryHttpClient;
}());
exports.JQueryHttpClient = JQueryHttpClient;
function parseHeaders(headers) {
    var result = {};
    if (headers) {
        var arrayOfLines = headers.match(/[^\r\n]+/g);
        for (var i = 0; i < arrayOfLines.length; i++) {
            var line = arrayOfLines[i];
            var keyValue = line.split(':');
            if (keyValue.length === 2) {
                result[keyValue[0]] = keyValue[1].trim();
            }
            else if (keyValue.length === 1) {
                result[keyValue[0]] = null;
            }
        }
    }
    return result;
}
function getHeader(headers, key) {
    if (headers) {
        var header = headers[key] || headers[key.toLowerCase()];
        if (Array.isArray(header)) {
            header = header.join(';');
        }
        return header;
    }
    return undefined;
}
function tryConvertToJson(obj) {
    try {
        return JSON.parse(obj);
    }
    catch (err) {
        return obj;
    }
}


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(138), exports);


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var contracts_1 = __webpack_require__(3);
var inversify_1 = __webpack_require__(1);
var LocalStorageHandler = /** @class */ (function () {
    function LocalStorageHandler(config) {
        config = config || {};
        if (!localStorage) {
            throw new Error("Local storage not found.");
        }
        var parseKey = config.keyGenerator;
        var getHandler;
        if (parseKey) {
            getHandler = function (fn) { return function () { arguments[0] = parseKey(arguments[0]); return fn.apply(this, arguments); }; };
        }
        else {
            getHandler = function (fn) { return fn; };
        }
        this.clear = localStorage.clear;
        this.remove = getHandler(this.removeItem);
        this.set = getHandler(this.setItem);
        this.get = getHandler(this.getItem);
    }
    LocalStorageHandler.prototype.removeItem = function (key) {
        localStorage.removeItem(key);
    };
    LocalStorageHandler.prototype.getItem = function (key) {
        return JSON.parse(localStorage.getItem(key));
    };
    LocalStorageHandler.prototype.setItem = function (key, data) {
        localStorage.setItem(key, JSON.stringify(data));
    };
    var _a;
    LocalStorageHandler = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IDefaultStorageConfig)), tslib_1.__param(0, inversify_1.optional()),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IDefaultStorageConfig !== "undefined" && contracts_1.IDefaultStorageConfig) === "function" ? _a : Object])
    ], LocalStorageHandler);
    return LocalStorageHandler;
}());
exports.LocalStorageHandler = LocalStorageHandler;
;


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(140), exports);


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var inversify_1 = __webpack_require__(1);
var utility = new common_1.Utility();
var BrowserEventHandler = /** @class */ (function () {
    function BrowserEventHandler(storageHandler, application) {
        this.storageHandler = storageHandler;
        this.application = application;
        this.messageBusKey = 'baasic-message-bus-' + this.application.getApiKey();
        var jQueryLoaded = window.jQuery;
        if (jQueryLoaded) {
            this.triggerEvent = function (eventName, data) {
                var event = utility.extend($.Event(eventName), data);
                $(document).trigger(event);
            };
        }
        else if (CustomEvent && typeof CustomEvent === 'function') {
            this.triggerEvent = function (eventName, data) {
                var event = utility.extend(new CustomEvent(eventName, { bubbles: true }), data);
                document.dispatchEvent(event);
            };
        }
        else if (document.createEvent) {
            this.triggerEvent = function (eventName, data) {
                var event = utility.extend(document.createEvent('CustomEvent'), data);
                event.initEvent(eventName, true, true);
                document.dispatchEvent(event);
            };
        }
        else {
            this.triggerEvent = function (eventName, data) {
                var doc = document;
                var event = utility.extend(doc.createEventObject(), data);
                event.eventType = eventName;
                doc.fireEvent('on' + event.eventType, event);
            };
        }
        if (jQueryLoaded) {
            this.addEvent = function (eventName, func) { return $(window).on(eventName, func); };
        }
        else if (window.addEventListener) {
            this.addEvent = function (eventName, func) { return window.addEventListener(eventName, func, false); };
        }
        else if (window.attachEvent) {
            this.addEvent = function (eventName, func) { return window.attachEvent('on' + eventName, func); };
        }
        else {
            this.addEvent = function (eventName, func) { return window['on' + eventName] = func; };
        }
        this.initEventing();
    }
    BrowserEventHandler.prototype.pushMessage = function (message, args) {
        this.storageHandler.remove(this.messageBusKey);
        this.storageHandler.set(this.messageBusKey, {
            message: message,
            args: args
        });
    };
    BrowserEventHandler.prototype.initEventing = function () {
        var self = this;
        this.addEvent('storage', function (e) {
            e = e || event;
            if (e.originalEvent) {
                e = e.originalEvent;
            }
            if (e.key === self.messageBusKey) {
                var value = e.newValue;
                if (value && value !== '') {
                    var data = JSON.parse(value);
                    if (typeof data === 'string') {
                        data = JSON.parse(data);
                    }
                    self.triggerEvent(data.message.type, utility.extend(data.args, { app: self.application }));
                }
            }
        });
    };
    var _a, _b;
    BrowserEventHandler = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IStorageHandler)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IBaasicApp)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IStorageHandler !== "undefined" && contracts_1.IStorageHandler) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IBaasicApp !== "undefined" && contracts_1.IBaasicApp) === "function" ? _b : Object])
    ], BrowserEventHandler);
    return BrowserEventHandler;
}());
exports.BrowserEventHandler = BrowserEventHandler;
;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var inversify_1 = __webpack_require__(1);
var TokenHandler = /** @class */ (function () {
    function TokenHandler(eventHandler, storageHandler, application) {
        this.eventHandler = eventHandler;
        this.storageHandler = storageHandler;
        this.application = application;
        this.utility = new common_1.Utility();
        this.messageTypes = {
            tokenExpired: 'tokenExpired',
            tokenUpdated: 'tokenUpdated'
        };
        this.initEventing();
        this.tokenKey = 'baasic-auth-token-' + this.application.getApiKey();
        this.token = this.get(contracts_1.TokenTypes.Access);
        if (this.token) {
            this.userAccessTokenTimerHandle = this.setExpirationTimer(this.token);
        }
    }
    Object.defineProperty(TokenHandler.prototype, "tokenExpiredEventName", {
        get: function () {
            return "tokenExpired-" + this.application.getApiKey();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TokenHandler.prototype, "tokenUpdatedEventName", {
        get: function () {
            return "tokenUpdated-" + this.application.getApiKey();
        },
        enumerable: true,
        configurable: true
    });
    TokenHandler.prototype.store = function (token, options) {
        //Type guard for plain JavaScript
        var anyToken = token;
        if (anyToken && !this.utility.isUndefined(anyToken.access_token)) {
            var t = {
                token: anyToken.access_token,
                expires_in: anyToken.expires_in,
                sliding_window: anyToken.sliding_window,
                tokenUrl: anyToken.access_url_token,
                type: anyToken.token_type
            };
            token = t;
        }
        this.syncToken(token);
        if (token === undefined || token === null) {
            this.storageHandler.remove(this.tokenKey);
        }
        else {
            this.storageHandler.set(this.tokenKey, token);
        }
        if (options && options.skipTokenEvents) {
            return;
        }
        this.handleTokenEvent(token);
    };
    TokenHandler.prototype.handleTokenEvent = function (token) {
        if (token === undefined || token === null) {
            this.triggerTokenExpired(this.application);
        }
        else {
            this.triggerTokenUpdated(this.application);
        }
    };
    TokenHandler.prototype.get = function (type) {
        var token = this.storageHandler.get(this.tokenKey);
        if (typeof token === 'string') {
            return JSON.parse(token);
        }
        return token;
    };
    TokenHandler.prototype.triggerTokenExpired = function (app) {
        var data = { app: app };
        this.eventHandler.triggerEvent(this.tokenExpiredEventName, data);
        this.eventHandler.pushMessage({
            type: this.tokenExpiredEventName
        }, {});
    };
    TokenHandler.prototype.triggerTokenUpdated = function (app) {
        var data = { app: app };
        this.eventHandler.triggerEvent(this.tokenUpdatedEventName, data);
        this.eventHandler.pushMessage({
            type: this.tokenUpdatedEventName
        }, {});
    };
    TokenHandler.prototype.setExpirationTimer = function (token) {
        var _this = this;
        if (token && token.expireTime) {
            var expiresIn = token.expireTime - new Date().getTime();
            if (expiresIn > 0) {
                return setTimeout(function () {
                    _this.store(null);
                }, expiresIn);
            }
            else {
                this.store(null);
            }
        }
        return null;
    };
    TokenHandler.prototype.syncToken = function (newToken) {
        clearTimeout(this.userAccessTokenTimerHandle);
        if (newToken) {
            if (newToken.expires_in && !newToken.expireTime) {
                newToken.expireTime = new Date().getTime() + (newToken.expires_in * 1000);
            }
            else if (newToken.sliding_window) {
                newToken.expireTime = new Date().getTime() + (newToken.sliding_window * 1000);
            }
            this.userAccessTokenTimerHandle = this.setExpirationTimer(newToken);
        }
    };
    TokenHandler.prototype.initEventing = function () {
        var _this = this;
        this.eventHandler.addEvent(this.tokenExpiredEventName, function (e) {
            e = e || event;
            if (e.originalEvent) {
                e = e.originalEvent;
            }
            _this.syncToken(null);
        });
    };
    var _a, _b, _c;
    TokenHandler = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IEventHandler)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IStorageHandler)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IBaasicApp)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IEventHandler !== "undefined" && contracts_1.IEventHandler) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IStorageHandler !== "undefined" && contracts_1.IStorageHandler) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IBaasicApp !== "undefined" && contracts_1.IBaasicApp) === "function" ? _c : Object])
    ], TokenHandler);
    return TokenHandler;
}());
exports.TokenHandler = TokenHandler;
;


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var contracts_1 = __webpack_require__(3);
var inversify_1 = __webpack_require__(1);
var UserHandler = /** @class */ (function () {
    function UserHandler(eventHandler, storageHandler, application) {
        var _this = this;
        this.eventHandler = eventHandler;
        this.storageHandler = storageHandler;
        this.application = application;
        this.messageTypes = {
            userChanged: 'userChanged'
        };
        this.userInfoKey = 'baasic-user-info-' + this.application.getApiKey();
        this.user = {
            isAuthenticated: function () {
                var token = _this.application.getAccessToken();
                return token !== undefined && token !== null && (token.expireTime === undefined || token.expireTime === null || (token.expireTime - new Date().getTime()) > 0);
            }
        };
    }
    UserHandler.prototype.getUser = function () {
        var userInfo;
        var json = this.storageHandler.get(this.userInfoKey);
        if (typeof json === 'string') {
            userInfo = JSON.parse(json);
        }
        else {
            userInfo = json;
        }
        if (userInfo) {
            this.user.user = userInfo;
        }
        else {
            delete this.user.user;
        }
        return this.user;
    };
    UserHandler.prototype.setUser = function (userInfo) {
        if (userInfo === undefined || userInfo === null) {
            this.storageHandler.remove(this.userInfoKey);
        }
        else {
            this.storageHandler.set(this.userInfoKey, userInfo);
        }
        this.eventHandler.pushMessage({
            type: this.messageTypes.userChanged
        }, {
            user: this.getUser()
        });
    };
    var _a, _b, _c;
    UserHandler = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IEventHandler)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IStorageHandler)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IBaasicApp)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IEventHandler !== "undefined" && contracts_1.IEventHandler) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IStorageHandler !== "undefined" && contracts_1.IStorageHandler) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IBaasicApp !== "undefined" && contracts_1.IBaasicApp) === "function" ? _c : Object])
    ], UserHandler);
    return UserHandler;
}());
exports.UserHandler = UserHandler;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(32);
var diModule = new inversify_1.ContainerModule(function (bind) {
    // bind<ITokenHandler>(TYPES.ITokenHandler).to(TokenHandler).inSingletonScope();
    bind(contracts_1.TYPES.IUserHandler).to(_1.UserHandler).inSingletonScope();
});
exports.diModule = diModule;


/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var core_1 = __webpack_require__(32);
var _1 = __webpack_require__(34);
var httpApi_1 = __webpack_require__(4);
var modules = __webpack_require__(45);
var BaasicApp = /** @class */ (function () {
    function BaasicApp(apiKey, options) {
        this.apiKey = apiKey;
        this.options = options;
        this.utility = new common_1.Utility();
        if (!this.apiKey) {
            throw new Error("API Key is required.");
        }
        var opt = {};
        if (options) {
            opt = options;
        }
        this.settings = this.utility.extendAs({}, BaasicApp.defaultSettings, opt);
        this.diModule = new _1.DIModule();
        this.diModule.init(this, [common_1.commonDIModule, core_1.coreDIModule, httpApi_1.httpDIModule, modules]);
        this.tokenHandler = this.diModule.kernel.get(contracts_1.TYPES.ITokenHandler);
        this.userHandler = this.diModule.kernel.get(contracts_1.TYPES.IUserHandler);
        this.eventHandler = this.diModule.kernel.get(contracts_1.TYPES.IEventHandler);
        this.apiClient = this.diModule.kernel.get(httpApi_1.httpTYPES.ApiClient);
        this.membershipModule = this.diModule.kernel.get(modules.Membership.TYPES.Root);
        //Modules
        this.applicationSettingModule = this.diModule.kernel.get(modules.ApplicationSettings.TYPES.ApplicationSettingsClient);
        this.keyValueModule = this.diModule.kernel.get(modules.KeyValue.TYPES.KeyValueClient);
        this.valueSetModule = this.diModule.kernel.get(modules.ValueSet.TYPES.ValueSetClient);
        this.userProfileModule = this.diModule.kernel.get(modules.UserProfile.TYPES.Root);
        this.templatingModule = this.diModule.kernel.get(modules.Templating.TYPES.TemplatingClient);
        this.meteringModule = this.diModule.kernel.get(modules.Metering.TYPES.MeteringClient);
        this.mediaVaultModule = this.diModule.kernel.get(modules.MediaVault.TYPES.MediaVaultClient);
        this.mediaGalleryModule = this.diModule.kernel.get(modules.MediaGallery.TYPES.Root);
        this.fileModule = this.diModule.kernel.get(modules.Files.TYPES.FilesClient);
        this.dynamicResourceModule = this.diModule.kernel.get(modules.DynamicResource.TYPES.DynamicResourceClient);
        this.notificationModule = this.diModule.kernel.get(modules.Notifications.TYPES.NotificationsClient);
        this.articleModule = this.diModule.kernel.get(modules.Article.TYPES.Root);
        this.commerceModule = this.diModule.kernel.get(modules.Commerce.TYPES.CommerceClient);
        this.calendarModule = this.diModule.kernel.get(modules.Calendar.TYPES.Root);
        this.shoppingCartModule = this.diModule.kernel.get(modules.ShoppingCart.TYPES.Root);
        this.blogModule = this.diModule.kernel.get(modules.Blog.TYPES.Root);
    }
    BaasicApp.prototype.getAccessToken = function () {
        return this.tokenHandler.get(contracts_1.TokenTypes.Access);
    };
    BaasicApp.prototype.updateAccessToken = function (value) {
        this.tokenHandler.store(value);
    };
    BaasicApp.prototype.getApiKey = function () {
        return this.apiKey;
    };
    BaasicApp.prototype.getApiUrl = function () {
        return this.settings.apiUrl;
    };
    BaasicApp.prototype.getUser = function () {
        return this.userHandler.getUser();
    };
    BaasicApp.prototype.setUser = function (userInfo) {
        this.userHandler.setUser(userInfo);
    };
    BaasicApp.defaultSettings = {
        useSSL: true,
        apiRootUrl: 'api.baasic.com',
        apiVersion: 'v1',
        enableHALJSON: false
    };
    return BaasicApp;
}());
exports.BaasicApp = BaasicApp;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(38);
var TYPES = {
    ApplicationSettingsClient: Symbol("ApplicationSettingsClient"),
    ApplicationSettingsRoute: Symbol("ApplicationSettingsRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ApplicationSettingsRoute).to(_1.ApplicationSettingsRoute);
    bind(TYPES.ApplicationSettingsClient).to(_1.ApplicationSettingsClient);
});
exports.diModule = diModule;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module applicationSettingsRoute
 * @description Baasic Application Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Application Settings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ApplicationSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ApplicationSettingsRoute, _super);
    function ApplicationSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'applications/{?embed,fields}';
        _this.updateRoute = 'applications/';
        return _this;
    }
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param options Query resource options object.
     * @example applicationSettingsRoute.get();
     **/
    ApplicationSettingsRoute.prototype.get = function (options) {
        return _super.prototype.baseGet.call(this, this.getRoute, undefined, options);
    };
    /**
     * Parses update route; this route doesn't expose any properties.
     * @method
     * @param data An application object used to update application settings of the specified application resource.
     * @example applicationSettingsRoute.update();
     **/
    ApplicationSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    ApplicationSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ApplicationSettingsRoute);
    return ApplicationSettingsRoute;
}(common_1.BaseRoute));
exports.ApplicationSettingsRoute = ApplicationSettingsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module applicationSettingsClient
 * @description  Application Settings Client provides an easy way to consume  Application Settings REST API end-points. In order to obtain needed routes `applicationSettingsClient` uses `applicationSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(38);
var ApplicationSettingsClient = /** @class */ (function () {
    function ApplicationSettingsClient(applicationSettingsRoute, apiClient) {
        this.applicationSettingsRoute = applicationSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ApplicationSettingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `applicationSettingsRoute`.
         * @method
         * @example ApplicationSettingsClient.routeDefinition.get(options)
         **/
        get: function () {
            return this.applicationSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the application settings resource.
     * @method
     * @param options Query resource options object.
     * @example applicationSettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ApplicationSettingsClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update application settings action has been performed. This action updates the application setting resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't use `applicationSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(appSettings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An application object used to update application settings of the specified application resource.
     * @example // appSettings is a resource previously fetched using get action.
                    appSettings.allowAnyOrigin = true;
                    applicationSettingsClient.update(appSettings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ApplicationSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    ApplicationSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ApplicationSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ApplicationSettingsRoute !== "undefined" && _1.ApplicationSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ApplicationSettingsClient);
    return ApplicationSettingsClient;
}());
exports.ApplicationSettingsClient = ApplicationSettingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(149), exports);
tslib_1.__exportStar(__webpack_require__(150), exports);
tslib_1.__exportStar(__webpack_require__(151), exports);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(13);
var TYPES = {
    LoginRoute: Symbol("LoginRoute"),
    LoginClient: Symbol("LoginClient"),
    LoginSocialRoute: Symbol("LoginSocialRoute"),
    LoginSocialClient: Symbol("LoginSocialClient"),
    PasswordRecoveryClient: Symbol("PasswordRecoveryClient"),
    PasswordRecoveryRoute: Symbol("PasswordRecoveryRoute"),
    RegisterClient: Symbol("RegisterClient"),
    RegisterRoute: Symbol("RegisterRoute"),
    RoleBatchClient: Symbol("RoleBatchClient"),
    RoleBatchRoute: Symbol("RoleBatchRoute"),
    RoleClient: Symbol("RoleClient"),
    RoleRoute: Symbol("RoleRoute"),
    UserSocialLoginClient: Symbol("UserSocialLoginClient"),
    UserSocialLoginRoute: Symbol("UserSocialLoginRoute"),
    UserClient: Symbol("UserClient"),
    UserRoute: Symbol("UserRoute"),
    PermissionRoute: Symbol("PermissionRoute"),
    PermissionClient: Symbol("PermissionClient"),
    LookupRoute: Symbol("LookupRoute"),
    LookupClient: Symbol("LookupClient"),
    Root: Symbol("Membership-Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.LoginSocialRoute).to(_1.LoginSocialRoute);
    bind(TYPES.LoginSocialClient).to(_1.LoginSocialClient);
    bind(TYPES.LoginRoute).to(_1.LoginRoute);
    bind(TYPES.LoginClient).to(_1.LoginClient);
    bind(TYPES.PasswordRecoveryRoute).to(_1.PasswordRecoveryRoute);
    bind(TYPES.PasswordRecoveryClient).to(_1.PasswordRecoveryClient);
    bind(TYPES.RegisterRoute).to(_1.RegisterRoute);
    bind(TYPES.RegisterClient).to(_1.RegisterClient);
    bind(TYPES.RoleBatchRoute).to(_1.RoleBatchRoute);
    bind(TYPES.RoleBatchClient).to(_1.RoleBatchClient);
    bind(TYPES.RoleRoute).to(_1.RoleRoute);
    bind(TYPES.RoleClient).to(_1.RoleClient);
    bind(TYPES.UserSocialLoginRoute).to(_1.UserSocialLoginRoute);
    bind(TYPES.UserSocialLoginClient).to(_1.UserSocialLoginClient);
    bind(TYPES.UserRoute).to(_1.UserRoute);
    bind(TYPES.UserClient).to(_1.UserClient);
    bind(TYPES.PermissionRoute).to(_1.PermissionRoute);
    bind(TYPES.PermissionClient).to(_1.PermissionClient);
    bind(TYPES.LookupRoute).to(_1.LookupRoute);
    bind(TYPES.LookupClient).to(_1.LookupClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module loginSocialRoute
 * @description Baasic Login Social Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Login Social Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var LoginSocialRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LoginSocialRoute, _super);
    function LoginSocialRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Social login get route with route and query parameters.
        **/
        _this.getRoute = 'login/social/{provider}/{?returnUrl}';
        /**
        * Social login post route with route and query parameters.
        **/
        _this.postRoute = 'login/social/{provider}/{?embed,fields,options}';
        return _this;
    }
    /**
     * Parses get social login route which can be expanded with additional items. Supported items are:
     * - `provider` - Provider name or Id for which the login URL should be generated.
     * - `returnUrl` - Redirect Uri for the provider which will be used when the user is redirected back to the application.
     * @method
     * @param provider Provider name or id for which the login URL should be generated.
     * @param returnUrl Redirect Uri for the provider which will be used when the user is redirected back to the application.
     * @example loginSocialRoute.get({   provider : '<provider>',   returnUrl: '<returnUrl>' });
     **/
    LoginSocialRoute.prototype.get = function (provider, returnUrl) {
        var params = {
            provider: provider,
            returnUrl: returnUrl
        };
        return _super.prototype.baseFind.call(this, this.getRoute, params);
    };
    /**
     * Parses post social login route which can be expanded with additional items. Supported items are:
     * - `provider` - Provider name or Id being used to login with.
     * @method
     * @example loginSocialClient.post({ provider : '<provider>' });
     **/
    LoginSocialRoute.prototype.post = function (provider, options) {
        return _super.prototype.baseCreate.call(this, this.postRoute, { provider: provider, options: options });
    };
    var _a;
    LoginSocialRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], LoginSocialRoute);
    return LoginSocialRoute;
}(common_1.BaseRoute));
exports.LoginSocialRoute = LoginSocialRoute;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module loginSocialClient
 * @description  Login Social Client provides an easy way to consume  Application Registration REST API end-points. In order to obtain needed routes `loginSocialClient` uses `loginSocialRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(13);
var LoginSocialClient = /** @class */ (function () {
    function LoginSocialClient(loginSocialRoute, tokenHandler, apiClient) {
        this.loginSocialRoute = loginSocialRoute;
        this.tokenHandler = tokenHandler;
        this.apiClient = apiClient;
    }
    Object.defineProperty(LoginSocialClient.prototype, "routeDefinition", {
        get: function () {
            return this.loginSocialRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a resolved social login provider Url.
     * @method
     * @param provider Provider name or id for which the login URL should be generated.
     * @param returnUrl Redirect Uri for the provider which will be used when the user is redirected back to the application.
     * @returns A promise that is resolved once the get action has been performed.
     * @example loginSocialClient.get('<provider>', '<returnUrl>')
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    LoginSocialClient.prototype.get = function (provider, returnUrl) {
        return this.apiClient.get(this.loginSocialRoute.get(provider, returnUrl));
    };
    /**
     * Returns a promise that is resolved once the post action has been performed. This action logs user into the application and success response returns the token resource.
     * @method
     * @param provider Provider name or Id which uniquely identifies social login for which access token should be issued.
     * @param data Object used to identify social login information.
     * @param options Comma separated list of additional options defining token behavior. Supported values are: "session" and "sliding".
     * @example let postData = {
                    email : '<email>',
                    code:'<code>',
                    activationUrl : '<activationUrl>',
                    oAuthToken : '<oAuthToken>',
                    oAuthVerifier : '<oAuthVerifier>',
                    password : '<password>',
                    returnUrl : '<returnUrl>'
                };
                loginSocialClient.post('<provider>', postData)
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    LoginSocialClient.prototype.post = function (provider, data, options) {
        var params = { provider: provider };
        if (options) {
            params.options = options;
        }
        var self = this;
        return this.apiClient.createPromise(function (resolve, reject) {
            self.apiClient.post(self.loginSocialRoute.post(provider, options), self.loginSocialRoute.createParams(data), { 'Content-Type': 'application/json; charset=UTF-8' })
                .then(function (data) {
                if (data) {
                    var token = {
                        token: data.data.access_token,
                        expires_in: data.data.expires_in,
                        sliding_window: data.data.sliding_window,
                        tokenUrl: data.data.access_url_token,
                        type: data.data.token_type
                    };
                    self.tokenHandler.store(token);
                }
                resolve(data);
            }, function (data) {
                reject(data);
            });
        });
    };
    LoginSocialClient.prototype.parseResponse = function (provider, returnUrl) {
        var params = this.parseUrlParams();
        var result = {};
        switch (provider) {
            case 'twitter':
                /** jshint camelcase: false*/
                result.oAuthToken = params.oauth_token;
                result.oAuthVerifier = params.oauth_verifier;
                break;
            default:
                result.code = params.code;
                result.returnUrl = returnUrl;
                break;
        }
        return result;
    };
    // Getting query string values in javascript: http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    LoginSocialClient.prototype.parseUrlParams = function () {
        var urlParams;
        var match, pl = /\+/g, search = /([^&=]+)=?([^&]*)/g, decode = function (s) { return decodeURIComponent(s.replace(pl, ' ')); }, query = window.location.search.substring(1);
        urlParams = {};
        /* jshint -W084*/
        while (match = search.exec(query)) {
            urlParams[decode(match[1])] = decode(match[2]);
        }
        return urlParams;
    };
    var _a, _b, _c;
    LoginSocialClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LoginSocialRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.ITokenHandler)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LoginSocialRoute !== "undefined" && _1.LoginSocialRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.ITokenHandler !== "undefined" && contracts_1.ITokenHandler) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], LoginSocialClient);
    return LoginSocialClient;
}());
exports.LoginSocialClient = LoginSocialClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* globals module */
/**
 * @module loginRoute
 * @description Baasic Login Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Login Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var LoginRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LoginRoute, _super);
    function LoginRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Login route with route and query parameters.
         **/
        _this.loginRoute = 'login/{?embed,fields,options}';
        return _this;
    }
    /**
     * Parses login route which can be expanded with additional options. Supported items are:
     * - `options` - Comma separated list of options used to setup authentication token with cookie session. Supported values are: "session" and "sliding".
     * @method
     * @example loginRoute.login( {options: 'sliding'});
     **/
    LoginRoute.prototype.login = function (options) {
        return _super.prototype.baseCreate.call(this, this.loginRoute, options);
    };
    var _a;
    LoginRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], LoginRoute);
    return LoginRoute;
}(common_1.BaseRoute));
exports.LoginRoute = LoginRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module loginClient
 * @description  Login Client provides an easy way to consume  Application Registration REST API end-points. In order to obtain needed routes `loginClient` uses `loginRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(13);
var LoginClient = /** @class */ (function () {
    function LoginClient(loginRoute, tokenHandler, apiClient) {
        this.loginRoute = loginRoute;
        this.tokenHandler = tokenHandler;
        this.apiClient = apiClient;
        this.utility = new common_1.Utility();
    }
    Object.defineProperty(LoginClient.prototype, "routeDefinition", {
        get: function () {
            return this.loginRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the login action has been performed. This action logs user into the application and success response returns the token resource.
     * @method
     * @example loginClient.login({
                    username : '<username>',
                    password : '<password>',
                    options : ['session', 'sliding']
                })
                .then(function (data) {
                    // perform success actions here
                },
                 function (data, status) {
                     // perform error handling here
                })
                .finally (function () {});
     **/
    LoginClient.prototype.login = function (data) {
        var settings = this.utility.extend({}, data);
        if (settings.options) {
            var options = settings.options;
            if (options instanceof Array) {
                settings.options = options.join();
            }
        }
        var loginData = this.transformData({
            grant_type: 'password',
            username: settings.username,
            password: settings.password
        });
        var self = this;
        return this.apiClient.createPromise(function (resolve, reject) {
            self.apiClient.post(self.loginRoute.login(settings), loginData, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' })
                .then(function (data) {
                var token = {
                    token: data.data.access_token,
                    expires_in: data.data.expires_in,
                    sliding_window: data.data.sliding_window,
                    tokenUrl: data.data.access_url_token,
                    type: data.data.token_type
                };
                self.tokenHandler.store(token);
                resolve(data);
            }, function (data) {
                reject(data);
            });
        });
    };
    /**
     * Returns a promise that is resolved once the loadUserData action has been performed. This action retrieves the account information of the currently logged in user. Retrieved account information will contain permission collection which identifies access policies assigned to the user and application sections.
     * @method
     * @example loginClient.loadUserData()
                    .then(function (data) {
                        // perform success actions here
                    },
                     function (data) {
                         // perform error handling here
                    })
                    .finally (function () {});
     */
    LoginClient.prototype.loadUserData = function (data) {
        data = data || {};
        return this.apiClient.get(this.loginRoute.login(data), { 'Accept': 'application/json; charset=UTF-8' });
    };
    /**
     * Returns a promise that is resolved once the logout action has been performed. This action invalidates user token logging the user out of the system.
     * @method
     * @param token Authentication token which uniquely identifies user that needs to be logged out from the system.
     * @param type Token type.
     * @returns A promise that is resolved once the logout action has been performed.
     * @example let token = baasicAuthorizationService.getAccessToken();
                loginClient.logout(token.access_token, token.token_type)
                .then(function (data) {
                    // perform success handling here
                }, function() {
                    // perform error handling here
                })
                .finally (function () {});
     */
    LoginClient.prototype.logout = function (token, type) {
        var data = {
            token: token,
            type: type
        };
        var self = this;
        return this.apiClient.createPromise(function (resolve, reject) {
            self.apiClient.delete(self.loginRoute.login({}), null, data)
                .then(function (result) {
                self.tokenHandler.store(null);
                resolve(result);
            }, function (result) {
                reject(result);
            });
        });
    };
    /**
     * Returns url encoded form data.
     */
    LoginClient.prototype.transformData = function (data) {
        var items = [];
        for (var key in data) {
            items.push([encodeURIComponent(key), encodeURIComponent(data[key])].join('='));
        }
        return items.join('&');
    };
    var _a, _b, _c;
    LoginClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LoginRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.ITokenHandler)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LoginRoute !== "undefined" && _1.LoginRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.ITokenHandler !== "undefined" && contracts_1.ITokenHandler) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], LoginClient);
    return LoginClient;
}());
exports.LoginClient = LoginClient;
/**
 * @overview
  ***Notes:**
  - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
  - All end-point objects are transformed by the associated route definition.
  */ 


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module passwordRecoveryRoute
 * @description Baasic Password Recovery Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Password Recovery Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var PasswordRecoveryRoute = /** @class */ (function (_super) {
    tslib_1.__extends(PasswordRecoveryRoute, _super);
    function PasswordRecoveryRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Password recovery route with route and query parameters.
        **/
        _this.passwordRecoveryRoute = 'recover-password';
        return _this;
    }
    /**
     * Parses recover-password route, recover-password route doesn't expose any additional properties.
     * @method
     * @example passwordRecoveryRoute.passwordRecovery();
     **/
    PasswordRecoveryRoute.prototype.passwordRecovery = function () {
        return _super.prototype.baseCreate.call(this, this.passwordRecoveryRoute, {});
    };
    var _a;
    PasswordRecoveryRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], PasswordRecoveryRoute);
    return PasswordRecoveryRoute;
}(common_1.BaseRoute));
exports.PasswordRecoveryRoute = PasswordRecoveryRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module passwordRecoveryClient
 * @description  Password Recovery Client provides an easy way to consume  Password Recovery REST API end-points. In order to obtain needed routes `passwordRecoveryClient` uses `passwordRecoveryRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(13);
var PasswordRecoveryClient = /** @class */ (function () {
    function PasswordRecoveryClient(passwordRecoveryRoute, apiClient) {
        this.passwordRecoveryRoute = passwordRecoveryRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(PasswordRecoveryClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `passwordRecoveryRoute`.
         * @method
         * @example passwordRecoveryClient.routeDefinition.requestReset(data);
         **/
        get: function () {
            return this.passwordRecoveryRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the password recovery requestReset action is completed. This action initiates the password recovery process for the user.
     * @method
     * @param data A password recovery object which contains parameters required for the password retrieval request.
     * @example passwordRecoveryClient.requestReset({
                    challengeIdentifier : '<challenge-identifier>',
                    challengeResponse : '<challenge-response>',
                    recoverUrl : '<recover-url>',
                    username : '<username>'
                })
                .then(function () {
                    // perform success action here
                },
                 function (data) {
                    // perform error handling here
                })
                .finally (function () {});
     */
    PasswordRecoveryClient.prototype.requestReset = function (data) {
        return this.apiClient.post(this.passwordRecoveryRoute.passwordRecovery(), data);
    };
    /**
     * Returns a promise that is resolved once the password reset action is completed. This updates user's password selection.
     * @method
     * @param data Password recovery object used to update user's current password selection.
     * @example passwordRecoveryClient.reset({
                    newPassword : '<new-password>',
                    passwordRecoveryToken : '<password-recovery-token>'
                })
                .then(function () {
                    // perform success action here
                },
                 function (data) {
                    // perform error handling here
                })
                .finally (function () {});
     */
    PasswordRecoveryClient.prototype.reset = function (data) {
        return this.apiClient.put(this.passwordRecoveryRoute.passwordRecovery(), data);
    };
    var _a, _b;
    PasswordRecoveryClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.PasswordRecoveryRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.PasswordRecoveryRoute !== "undefined" && _1.PasswordRecoveryRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], PasswordRecoveryClient);
    return PasswordRecoveryClient;
}());
exports.PasswordRecoveryClient = PasswordRecoveryClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module registerRoute
 * @description Baasic Register Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Register Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var RegisterRoute = /** @class */ (function (_super) {
    tslib_1.__extends(RegisterRoute, _super);
    function RegisterRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'register';
        /**
        * Activate route with route and query parameters.
        **/
        _this.activateRoute = 'register/activate/{activationToken}/';
        return _this;
    }
    /**
     * Parses register route, this route doesn't support any additional properties.
     * @method
     * @example registerRoute.create();
     **/
    RegisterRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses activation route; route should be expanded with the `activationToken` which uniquely identifies the user account that needs to be activated.
     * @method
     * @param data Security code which uniquely identifies user account that needs to be activated.
     * @example registerRoute.activate({activationToken: '<activation-token>'});
     **/
    RegisterRoute.prototype.activate = function (data) {
        var params = this.modelMapper.getParams(data, undefined, 'activationToken');
        return _super.prototype.baseCreate.call(this, this.activateRoute, params);
    };
    var _a;
    RegisterRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], RegisterRoute);
    return RegisterRoute;
}(common_1.BaseRoute));
exports.RegisterRoute = RegisterRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module registerClient
 * @description  Register Client provides an easy way to consume  Application Registration REST API end-points. In order to obtain needed routes `registerClient` uses `registerRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(13);
var RegisterClient = /** @class */ (function () {
    function RegisterClient(registerRoute, apiClient, tokenHandler) {
        this.registerRoute = registerRoute;
        this.apiClient = apiClient;
        this.tokenHandler = tokenHandler;
    }
    Object.defineProperty(RegisterClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `registerRoute`.
         * @method
         * @example registerClient.routeDefinition.get();
         **/
        get: function () {
            return this.registerRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the register create has been performed. This action will create a new user if completed successfully. Created user is not approved immediately, instead an activation e-mail is sent to the user.
     * @param data A user account object that needs to be inserted into the system.
     * @method
     * @example registerClient.create({
                    activationUrl : '<activation-url>',
                    challengeIdentifier : '<challenge-identifier>',
                    challengeResponse : '<challenge-response>',
                    confirmPassword : '<confirm-password>',
                    email : '<email>',
                    password : '<password>',
                    username : '<username>'
                })
                .success(function (data) {
                    // perform success actions here
                }).error(function (data, status) {
                    // perform error handling here
                })
                .finally (function () {});
     **/
    RegisterClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the account activation action has been performed; this action activates a user account and success response returns the token resource.
     * @param data Security code which uniquely identifies user account that needs to be activated.
     * @returns A promise that is resolved once the account activation action has been performed.
     * @method
     * @example registerClient.activate({
                   activationToken : '<activation-token>'
               })
               .then(function (data) {
                   // perform success actions here
               },
                function (data, status) {
                   // perform error handling here
               })
               .finally (function () {});
    **/
    RegisterClient.prototype.activate = function (data) {
        var self = this;
        var promise = this.apiClient.put(this.registerRoute.activate(data), data);
        promise.then(function (data) {
            var token = {
                token: data.data.access_token,
                expires_in: data.data.expires_in,
                sliding_window: data.data.sliding_window,
                tokenUrl: data.data.access_url_token,
                type: data.data.token_type
            };
            self.tokenHandler.store(token);
            return data;
        }, function (response) {
            return response;
        });
        return promise;
    };
    var _a, _b, _c;
    RegisterClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.RegisterRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.ITokenHandler)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.RegisterRoute !== "undefined" && _1.RegisterRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof contracts_1.ITokenHandler !== "undefined" && contracts_1.ITokenHandler) === "function" ? _c : Object])
    ], RegisterClient);
    return RegisterClient;
}());
exports.RegisterClient = RegisterClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module roleRoute
 * @description Baasic Role Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Role Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var RoleBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(RoleBatchRoute, _super);
    function RoleBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'lookups/roles/batch';
        /**
        * Update route with route and query parameters.
        **/
        _this.updateRoute = 'lookups/roles/batch';
        /**
        * Delete route with route and query parameters.
        **/
        _this.removeRoute = 'lookups/roles/batch';
        return _this;
    }
    /**
     * Parses create batch roles route; this URI template does not expose any additional options.
     * @method
     * @example roleBatchRoute.create();
     **/
    RoleBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update batch roles route.
     * @method
     * @param data A role object used to update specified role resource.
     * @example roleBatchRoute.update(data);
     */
    RoleBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delete batch roles route.
     * @method
     * @param data A role object used to delete specified role resource.
     * @example roleBatchRoute.delete(data);
     */
    RoleBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.removeRoute, {});
    };
    var _a;
    RoleBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], RoleBatchRoute);
    return RoleBatchRoute;
}(common_1.BaseRoute));
exports.RoleBatchRoute = RoleBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module roleBatchClient
 * @description  Role Batch Client provides an easy way to consume  Role REST API end-points. In order to obtain needed routes `roleBatchClient` uses `roleBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(13);
var RoleBatchClient = /** @class */ (function () {
    function RoleBatchClient(roleBatchRoute, apiClient) {
        this.roleBatchRoute = roleBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(RoleBatchClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `roleRoute`.
         * @method
         * @example roleBatchClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.roleBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create action has been performed; this action creates a role.
     * @method
     * @param data A role object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create action has beend performed.
     * @example roleBatchClient.create({
                    description : '<description>',
                    name : '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    RoleBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update role action has been performed; this action updates a role. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `roleClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(role);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A role object used to update specified role resource.
     * @returns A promise that is resolved once the update role action has been performed.
     * @example // role is a resource previously fetched using get action.
                    role.name = '<new-name>';
                    roleBatchClient.update(role)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    RoleBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove role action has been performed. This action will remove a role from the system, if completed successfully. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `roleClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(role);
     * let uri = params['model'].links('delete').href; ```
     * @param data A role object used to delete specified role resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example // Role is a resource previously fetched using get action.
                    roleBatchClient.remove(role)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    RoleBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteBatchParams(data));
    };
    var _a, _b;
    RoleBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.RoleBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.RoleBatchRoute !== "undefined" && _1.RoleBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], RoleBatchClient);
    return RoleBatchClient;
}());
exports.RoleBatchClient = RoleBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module roleRoute
 * @description Baasic Role Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Role Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(13);
var RoleRoute = /** @class */ (function (_super) {
    tslib_1.__extends(RoleRoute, _super);
    function RoleRoute(appOptions, roleBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.roleBatchRoute = roleBatchRoute;
        /**
        * Find route with route and query parameters.
        **/
        _this.findRoute = 'lookups/roles/{?searchQuery,page,rpp,sort,embed,fields}';
        /**
        * Get route with route and query parameters.
        **/
        _this.getRoute = 'lookups/roles/{id}/{?embed,fields}';
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'lookups/roles';
        /**
        * Update route with route and query parameters.
        **/
        _this.updateRoute = 'lookups/roles/{id}';
        /**
        * Remove route with route and query parameters.
        **/
        _this.removeRoute = 'lookups/roles/{id}';
        return _this;
    }
    Object.defineProperty(RoleRoute.prototype, "batch", {
        /**
         * Provides direct access to 'roleBatchRoute'
         * @method
        **/
        get: function () {
            return this.roleBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find role route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify role resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain role subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the role property to sort the result collection by.
     * @method
     * @param options Query resource options object.
     * @example roleRoute.find({searchQuery: '<search-phrase>'});
     **/
    RoleRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get role route which should be expanded with the role Id. Note that the role Id is the primary key of the role.
     * @method
     * @param id Role unique indentifer.
     * @param options Query resource options object.
     * @example roleRoute.get().expand({id: '<role-id>'});
     **/
    RoleRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create role route; this URI template does not expose any additional options.
     * @method
     * @example roleRoute.create();
     **/
    RoleRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update role route.
     * @method
     * @param data A role object used to update specified role resource.
     * @example roleRoute.update(data);
     */
    RoleRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete role route.
     * @method
     * @param data A role object used to delete specified role resource.
     * @example roleRoute.delete(data);
     */
    RoleRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.removeRoute, data);
    };
    var _a, _b;
    RoleRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.RoleBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.RoleBatchRoute !== "undefined" && _1.RoleBatchRoute) === "function" ? _b : Object])
    ], RoleRoute);
    return RoleRoute;
}(common_1.BaseRoute));
exports.RoleRoute = RoleRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module roleClient
 * @description  Role Client provides an easy way to consume  Role REST API end-points. In order to obtain needed routes `roleClient` uses `roleRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(13);
var RoleClient = /** @class */ (function () {
    function RoleClient(roleBatchClient, roleRoute, apiClient) {
        this.roleBatchClient = roleBatchClient;
        this.roleRoute = roleRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(RoleClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `roleRoute`.
         * @method
         * @example roleClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.roleRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoleClient.prototype, "batch", {
        /**
         * Provides direct access to `roleBatchClient`.
         * @method
         **/
        get: function () {
            return this.roleBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of role resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has beend performed.
     * @example roleClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    RoleClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified role resource.
     * @param id Role unique indentifer.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @method
     * @example roleClient.get('<role-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    RoleClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.roleRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create action has been performed; this action creates a role.
     * @method
     * @param data A role object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create action has beend performed.
     * @example roleClient.create({
                    description : '<description>',
                    name : '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    RoleClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update role action has been performed; this action updates a role. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `roleClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(role);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A role object used to update specified role resource.
     * @returns A promise that is resolved once the update role action has been performed.
     * @example // role is a resource previously fetched using get action.
                    role.name = '<new-name>';
                    roleClient.update(role)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    RoleClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove role action has been performed. This action will remove a role from the system, if completed successfully. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `roleClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(role);
     * let uri = params['model'].links('delete').href; ```
     * @param data A role object used to delete specified role resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example // Role is a resource previously fetched using get action.
                    roleClient.remove(role)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    RoleClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    RoleClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.RoleBatchClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.RoleRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.RoleBatchClient !== "undefined" && _1.RoleBatchClient) === "function" ? _a : Object, typeof (_b = typeof _1.RoleRoute !== "undefined" && _1.RoleRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], RoleClient);
    return RoleClient;
}());
exports.RoleClient = RoleClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userSocialLoginRoute
 * @description Baasic User Social Login Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var UserSocialLoginRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserSocialLoginRoute, _super);
    function UserSocialLoginRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Get route with route and query parameters.
        **/
        _this.getRoute = 'users/{username}/social-login';
        /**
        * Remove route with route and query parameters.
        **/
        _this.removeRoute = 'users/{username}/social-login/{provider}';
        return _this;
    }
    /**
     * Parses get social login route, URI template should be expanded with the username of the user resource whose social login connections should be retrieved.
     * @method
     * @param username A username or id which uniquely identifies user resource whose social login connections need to be retrieved.
     * @example userSocialLoginRoute.get('<username>');
     **/
    UserSocialLoginRoute.prototype.get = function (username) {
        return _super.prototype.baseGet.call(this, this.getRoute, username, { username: username });
    };
    /**
     * Parses remove social login route which can be expanded with additional items. Supported items are:
     * - `username` - A username which uniquely identifies an application user whose social login connection needs to be removed.
     * - `provider` - Provider from which to disconnect the login resource from.
     * @method
     * @param username A username which uniquely identifies an application user whose social login connection needs to be removed.
     * @param provider Provider from which to disconnect the login resource from.
     * @example userSocialLoginRoute.remove('<username>', '<provider>');
     **/
    UserSocialLoginRoute.prototype.remove = function (username, provider) {
        var params;
        if (provider.hasOwnProperty('abrv')) {
            params = {
                provider: provider.abrv
            };
        }
        else if (provider.hasOwnProperty('id')) {
            params = {
                provider: provider.id
            };
        }
        else {
            params = this.utility.extend({}, provider);
        }
        params.username = username;
        return _super.prototype.baseFind.call(this, this.removeRoute, params);
    };
    var _a;
    UserSocialLoginRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserSocialLoginRoute);
    return UserSocialLoginRoute;
}(common_1.BaseRoute));
exports.UserSocialLoginRoute = UserSocialLoginRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userRoute
 * @description Baasic User Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var _1 = __webpack_require__(13);
var contracts_1 = __webpack_require__(3);
var UserRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserRoute, _super);
    function UserRoute(appOptions, userSocialLoginRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.userSocialLoginRoute = userSocialLoginRoute;
        /**
        * Find route with route and query parameters.
        **/
        _this.findRoute = 'users/{?searchQuery,userIds,roleIds,roleNames,isApproved,isLocked,page,rpp,sort,embed,fields}';
        /**
        * Get route with route and query parameters.
        **/
        _this.getRoute = 'users/{username}/{?embed,fields}';
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'users';
        /**
        * Update route with route and query parameters.
        **/
        _this.updateRoute = 'users/{id}';
        /**
        * Delete route with route and query parameters.
        **/
        _this.deleteRoute = 'users/{id}';
        /**
        * Exists route with route and query parameters.
        **/
        _this.existsRoute = 'users/{username}/exists/';
        /**
        * Change password route with route and query parameters.
        **/
        _this.changePasswordRoute = 'users/{username}/change-password';
        /**
        * Unlock route with route and query parameters.
        **/
        _this.unlockRoute = 'users/{id}/unlock';
        /**
        * Lock route with route and query parameters.
        **/
        _this.lockRoute = 'users/{id}/lock';
        /**
        * Approve route with route and query parameters.
        **/
        _this.approveRoute = 'users/{id}/approve';
        /**
        * Disapprove route with route and query parameters.
        **/
        _this.disapproveRoute = 'users/{id}/disapprove';
        return _this;
    }
    Object.defineProperty(UserRoute.prototype, "socialLogin", {
        get: function () {
            return this.userSocialLoginRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find user route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example userRoute.find({searchQuery: '<search-phrase>'});
     **/
    UserRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get user route which must be expanded with the username of the previously created user resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example userRoute.get({username: '<username>'})
     **/
    UserRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options, 'username');
    };
    /**
     * Parses create user route, this URI template does not expose any additional options.
     * @method
     * @example userRoute.create();
     **/
    UserRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    UserRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    UserRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses user exists route; URI template should be expanded with the username whose availability you'd like to check.
     * @method
     * @param username A username which uniquely identifies an application user.
     * @example userRoute.exists({username: '<username>'});
     **/
    UserRoute.prototype.exists = function (username, options) {
        return _super.prototype.baseGet.call(this, this.existsRoute, username, options, 'username');
    };
    /**
     * Parses change password route, URI template should be expanded with the username of the user resource whose password should be updated.
     * @method
     * @param username A username or id which uniquely identifies user resource.
     * @example userRoute.changePassword({username: '<username>'});
     **/
    UserRoute.prototype.changePassword = function (username) {
        return _super.prototype.baseUpdate.call(this, this.changePasswordRoute, { username: username });
    };
    UserRoute.prototype.unlock = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unlockRoute, data, null, 'unlock');
    };
    UserRoute.prototype.lock = function (data) {
        return _super.prototype.baseUpdate.call(this, 'users/{id}/lock', data, null, 'lock');
    };
    UserRoute.prototype.approve = function (data) {
        return _super.prototype.baseUpdate.call(this, this.approveRoute, data, null, 'approve');
    };
    UserRoute.prototype.disapprove = function (data) {
        return _super.prototype.baseUpdate.call(this, this.disapproveRoute, data, null, 'disapprove');
    };
    var _a, _b;
    UserRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserSocialLoginRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.UserSocialLoginRoute !== "undefined" && _1.UserSocialLoginRoute) === "function" ? _b : Object])
    ], UserRoute);
    return UserRoute;
}(common_1.BaseRoute));
exports.UserRoute = UserRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userSocialLoginClient
 * @description  User Social Login Client provides an easy way to consume  User REST API end-points. In order to obtain needed routes `userSocialLoginClient` uses `userSocialLoginRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(13);
var UserSocialLoginClient = /** @class */ (function () {
    function UserSocialLoginClient(userSocialLoginRoute, apiClient) {
        this.userSocialLoginRoute = userSocialLoginRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserSocialLoginClient.prototype, "routeDefinition", {
        /**
          * Provides direct access to `userSocialLoginRoute`.
          * @method
          * @example userSocialLoginClient.routeDefinition.get().expand(expandObject);
          **/
        get: function () {
            return this.userSocialLoginRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list user resource connected social login providers.
     * @param username A username or id which uniquely identifies user resource whose social login connections need to be retrieved.
     * @returns A promise that is resolved once the get action has been performed.
     * @method
     * @example userSocialLoginClient.get('<username>')
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    UserSocialLoginClient.prototype.get = function (username) {
        return this.apiClient.get(this.routeDefinition.get(username));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action removes the user resource social login connection from the specified provider.
     * @param username A username or id which uniquely identifies user resource whose social login connection needs to be removed.
     * @param provider A value which uniquely identifies provider from which the user resource needs to be disconnected.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example userSocialLoginClient.remove('<username>', '<provider>')
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    UserSocialLoginClient.prototype.remove = function (username, provider) {
        return this.apiClient.delete(this.userSocialLoginRoute.remove(username, provider));
    };
    var _a, _b;
    UserSocialLoginClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserSocialLoginRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserSocialLoginRoute !== "undefined" && _1.UserSocialLoginRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserSocialLoginClient);
    return UserSocialLoginClient;
}());
exports.UserSocialLoginClient = UserSocialLoginClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userClient
 * @description  User Client provides an easy way to consume  User REST API end-points. In order to obtain needed routes `userClient` uses `userRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(13);
var UserClient = /** @class */ (function () {
    function UserClient(userRoute, userSocialLoginClient, apiClient) {
        this.userRoute = userRoute;
        this.userSocialLoginClient = userSocialLoginClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `userRoute`.
         * @method
         * @example userClient.routeDefinition.get();
         **/
        get: function () {
            return this.userRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserClient.prototype, "socialLogin", {
        get: function () {
            return this.userSocialLoginClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the exists action has been performed. This action checks if user exists in the application.
     * @method
     * @param username A username which uniquely identifies an application user.
     * @example userClient.exists('<username>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    UserClient.prototype.exists = function (username, options) {
        return this.apiClient.get(this.userRoute.exists(username, options));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @example userClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    UserClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified user resource.
     * @method
     * @param id A username or id which uniquely identifies an application user whose account information needs to be retrieved.
     * @param options Query resources options.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userClient.get({
                    username : '<username>',
                    embed : '<embedded-resource>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    UserClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user action has been performed; this action creates a new user.
     * @method
     * @param data An user object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user action has been performed.
     * @example userClient.create({
                    confirmPassword : '<password>',
                    email : '<email>',
                    password : '<password>',
                    sendEmailNotification : true,
                    username : '<username>',
                    roles: ['<role-name>'],
                    additionalProperty: '<additional-property>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    UserClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user action has been performed; this action updates a user. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('put').href;
     * ```
     * @param data A user object used to update specified user resource.
     * @returns A promise that is resolved once the update user action has been performed.
     * @method
     * @example // user is a resource previously fetched using get action.
                    user.roles = ['<role-name>', '<new-role-name>'];
                    user.email = '<new-email>';
                    userClient.update(user)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    UserClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove user action has been performed. This action will remove a user from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data  A user object used to delete specified user resource.
     * @returns A promise that is resolved once the remove user action has been performed.
     * @example // user is a resource previously fetched using get action.
                    userClient.remove(user)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    UserClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the unlock user action has been performed. This action will unlock the user resource which was previously locked either manually or automatically by the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('unlock').href;
     * ```
     * @method
     * @param data A user object used to unlock specified user resource.
     * @returns A promise that is resolved once the unlock user action has been performed.
     * @example //  user is a resource previously fetched using get action.
                        userClient.unlock(user)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                // perform error handling here
                            });
     **/
    UserClient.prototype.unlock = function (data) {
        return this.apiClient.put(this.userRoute.unlock(data), data);
    };
    /**
     * Returns a promise that is resolved once the lock user action has been performed. This action will lock the user resource out of the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('lock').href;
     * ```
     * @method
     * @param data A user object used to lock specified user resource.
     * @returns A promise that is resolved once the lock user action has been performed.
     * @example // user is a resource previously fetched using get action.
                    userClient.lock(user)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    UserClient.prototype.lock = function (data) {
        return this.apiClient.put(this.userRoute.lock(data), data);
    };
    /**
     * Returns a promise that is resolved once the approve user action has been performed. This action will mark the user resource as 'approved' in the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('approve').href;
     * ```
     * @method
     * @param data A user object used to approve specified user resource.
     * @returns A promise that is resolved once the approve user action has been performed.
     * @example // user is a resource previously fetched using get action.
                    userClient.approve(user)
                        .then(function (data) {
                            // perform success action here
                        })
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    UserClient.prototype.approve = function (data) {
        return this.apiClient.put(this.userRoute.approve(data), data);
    };
    /**
     * Returns a promise that is resolved once the disapprove user action has been performed. This action will mark the user resource as 'not approved' in the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('disapprove').href;
     * ```
     * @method
     * @example // user is a resource previously fetched using get action.
                    userClient.disapprove(user).then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    UserClient.prototype.disapprove = function (data) {
        return this.apiClient.put(this.userRoute.disapprove(data), data);
    };
    /**
     * Returns a promise that is resolved once the changePassword action has been performed. This action will update user's password selection.
     * @method
     * @param username A username or id which uniquely identifies user resource.
     * @param data A new password object used to update specified user password resource.
     * @returns A promise that is resolved once the changedPassword action has been performed.
     * @example userClient.changePassword('<username>', {
                    newPassword : '<new-password>',
                    sendMailNotification : false
                })
                .then(function () {
                    // perform success action here
                },
                 function (data, status, headers, config) {
                    // perform error handling here
                })
                .finally (function () {});
     **/
    UserClient.prototype.changePassword = function (username, data) {
        return this.apiClient.put(this.userRoute.changePassword(username), data);
    };
    var _a, _b, _c;
    UserClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserSocialLoginClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserRoute !== "undefined" && _1.UserRoute) === "function" ? _a : Object, typeof (_b = typeof _1.UserSocialLoginClient !== "undefined" && _1.UserSocialLoginClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], UserClient);
    return UserClient;
}());
exports.UserClient = UserClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* globals module */
/**
 * @module loginRoute
 * @description Baasic Login Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Login Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var PermissionRoute = /** @class */ (function (_super) {
    tslib_1.__extends(PermissionRoute, _super);
    function PermissionRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Find all route with route and query parameters.
         */
        _this.findAllRoute = 'permissions/sections{?searchQuery,sort,embed,fields}';
        /**
         * Find route with route and query parameters.
         **/
        _this.findRoute = 'permissions/sections/{section}/{?searchQuery,sort,embed,fields}';
        /**
         * sectionsPolicies route and query parameters.
         */
        _this.sectionsPoliciesRoute = 'permissions/sections/policies/{?sectionAbrvs,searchQuery,sort,embed,fields}';
        /**
         * Get actions route with route and query parameters.
         **/
        _this.getActionsRoute = 'permissions/actions/{?searchQuery,sort,embed,fields}';
        /**
         * Get roles route with route and query parameters.
         **/
        _this.getRolesRoute = 'lookups/roles/{?searchQuery,page,rpp,sort,embed,fields}';
        /**
         * Get users route with route and query parameters.
         **/
        _this.getUsersRoute = 'users/{?searchQuery,page,rpp,sort,embed,fields}';
        /**
         * Create route with route and query parameters.
         **/
        _this.createRoute = 'permissions/';
        /**
         * Remove route with route and query parameters.
         **/
        _this.removeRoute = 'permissions/sections/{section}/actions/{action}/{{operation}}/{{subject}}/';
        return _this;
    }
    /**
     * Parses find all route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify access policy resources using the phrase search.
     * - `sort` - A string used to set the access policy property to sort the result collection by.
     * @method
     * @example
     permissionRoute.findAll(
     {searchQuery: '<search-phrase>'}
     );
     **/
    PermissionRoute.prototype.findAll = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.findAllRoute, this.utility.extend(opt));
    };
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `section` - Section abbreviation which identifies part of the application for which security privileges can be retrieved and managed.
     * - `searchQuery` - A string value used to identify access policy resources using the phrase search.
     * - `sort` - A string used to set the access policy property to sort the result collection by.
     * @method
     * @example
     permissionRoute.find(
     'sectionName',
     {searchQuery: '<search-phrase>'}
     );
     **/
    PermissionRoute.prototype.find = function (section, options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.findRoute, this.utility.extend({ section: section }, opt));
    };
    /**
     * Parses getActions route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify access action resources using the phrase search.
     * - `sort` - A string used to set the access action property to sort the result collection by.
     * @method
     * @example
     permissionRoute.getActions(
     {searchQuery: '<search-phrase>'}
     );
     **/
    PermissionRoute.prototype.getActions = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.getActionsRoute, opt);
    };
    /**
     * Parses getRoles route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify access policy resources using the phrase search.
     * - `sort` - A string used to set the access policy property to sort the result collection by.
     * - `page` - A value used to set the page number, i.e. to retrieve certain access policy subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * @method
     * @example
     permissionRoute.getRoles(
     {searchQuery: '<search-phrase>'}
     );
     **/
    PermissionRoute.prototype.getRoles = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.getRolesRoute, opt);
    };
    /**
     * Parses getUsers route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify access policy resources using the phrase search.
     * - `sort` - A string used to set the access policy property to sort the result collection by.
     * - `page` - A value used to set the page number, i.e. to retrieve certain access policy subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * @method
     * @example
     permissionRoute.getRoles(
     {searchQuery: '<search-phrase>'}
     );
     **/
    PermissionRoute.prototype.getUsers = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.getUsersRoute, opt);
    };
    /**
     * Parses sectionsPoliciesRoute which can be expanded with additional options.
     * - `searchQuery` - A string value used to identify access policy resources using the phrase search.
     * - `sort` - A string used to set the access policy property to sort the result collection by.
     * - `page` - A value used to set the page number, i.e. to retrieve certain access policy subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `section` - Section abbreviation which identifies part of the application for which security privileges can be retrieved and managed.
     * @param {string} sections - Comma-spearated list of section abbreviations that identify parts of the application for which security privileges can be retrieved and managed.
     */
    PermissionRoute.prototype.findSectionsPolicies = function (sectionAbrvs, options) {
        var opt = tslib_1.__assign({ sectionAbrvs: sectionAbrvs }, options);
        return _super.prototype.baseFind.call(this, this.sectionsPoliciesRoute, opt);
    };
    /**
     * Parses create permission route; this URI template doesn't expose any additional properties.
     * @method
     * @example permissionRoute.create({});
     **/
    PermissionRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute);
    };
    /**
     * Returns a promise that is resolved once the remove permission action has been performed. This action will remove a permission from the system, if completed successfully.
     * @param data A permission object used to delete specified permission resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example // Permission is a resource previously fetched using get action.
     permissionClient.remove(permission)
     .then(function (data) {
                            // perform success action here
                        },
     function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    PermissionRoute.prototype.remove = function (data) {
        var params = _super.prototype.deleteParams.call(this, data);
        var action = data.actions[0];
        var operation = '';
        var subject = '';
        if (data.role && data.role.length > 0) {
            operation = 'Role';
            subject = data.role;
        }
        else {
            operation = 'User';
            subject = data.userName;
        }
        var route = this.removeRoute.replace('{{operation}}', operation.toLowerCase() + 's').replace('{{subject}}', subject);
        return _super.prototype.baseDelete.call(this, route, data, null, 'delete' + action.abrv + operation);
    };
    var _a;
    PermissionRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], PermissionRoute);
    return PermissionRoute;
}(common_1.BaseRoute));
exports.PermissionRoute = PermissionRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module permissionClient
 * @description  Role Client provides an easy way to consume  Role REST API end-points. In order to obtain needed routes `permissionClient` uses `permissionRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(13);
var contracts_1 = __webpack_require__(3);
var PermissionClient = /** @class */ (function () {
    function PermissionClient(permissionRoute, apiClient, application) {
        this.permissionRoute = permissionRoute;
        this.apiClient = apiClient;
        this.application = application;
        this.utility = new common_1.Utility();
        this.permissionHash = {};
    }
    Object.defineProperty(PermissionClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `permissionRoute`.
         * @method
         * @example permissionClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.permissionRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the findAll action has been performed. Success response returns a list of access sections matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example permissionClient.findAll({
                    searchQuery : '<search-phrase>'
                })
     .then(function (collection) {
                    // perform success action here
                },
     function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    PermissionClient.prototype.findAll = function (options) {
        return this.apiClient.get(this.permissionRoute.findAll(options));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of role resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example permissionClient.find({
                    section : '<access-section>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    PermissionClient.prototype.find = function (section, options) {
        return this.apiClient.get(this.permissionRoute.find(section, options));
    };
    /**
    * Returns a promise that is resolved once the getActions action has been performed. Success response returns a list of access policies that match the specified search parameters.
    * @method
    * @example
            permissionClient.getActions({
            search : '<search-phrase>'
            })
            .success(function (collection) {
            // perform success action here
            })
            .error(function (response, status, headers, config) {
            // perform error handling here
            });
    **/
    PermissionClient.prototype.getActions = function (options) {
        return this.apiClient.get(this.routeDefinition.getActions(options));
    };
    /**
     * Returns a promise that is resolved once the getSectionPolicies action has beed preformed. Success response returns a list of requested access policies that match the specified search parameters
     */
    PermissionClient.prototype.getSectionsPolicies = function (sectionAbrvs, options) {
        return this.apiClient.get(this.permissionRoute.findSectionsPolicies(sectionAbrvs, options));
    };
    /**
    * Returns a promise that is resolved once the getPermissionSubjects action has been performed. Success response returns a list of matching user and role resources.
    * @method
    * @example
            permissionClient.getPermissionSubjects({
            orderBy : '<field>',
            orderDirection : '<asc|desc>',
            search : '<search-phrase>'
            })
            .success(function (collection) {
            // perform success action here
            })
            .error(function (response, status, headers, config) {
            // perform error handling here
            });
    **/
    PermissionClient.prototype.getPermissionSubjects = function (options) {
        var queue = [];
        var resolvedTasks = 0;
        var self = this;
        queue.push(this.getUsers(options)
            .then(function (collection) {
            var membCollection = [];
            collection.data.item.forEach(function (element) {
                var membershipItem = {
                    name: element.userName,
                    role: ''
                };
                membCollection.push(self.utility.extend(membershipItem, element));
            });
            return membCollection;
        }, function (data) {
            if (data.status !== undefined && data.status !== 403) {
                return data;
            }
        }));
        queue.push(self.getRoles(options)
            .then(function (collection) {
            var membCollection = [];
            collection.data.item.forEach(function (element) {
                var membershipItem = {
                    name: element.name,
                    roleName: element.name,
                    userName: ''
                };
                membCollection.push(self.utility.extend(membershipItem, element));
            });
            return membCollection;
        }, function (data) {
            if (data.status !== undefined && data.status !== 403) {
                return data;
            }
        }));
        return Promise.all(queue).then(function (membershipCollection) {
            return self.utility.OrderByArray([].concat.apply([], membershipCollection), 'name');
        });
    };
    /**
     * Returns a promise that is resolved once the create action has been performed; this action creates a new permission resource.
     * @method
     * @example
            // readAction and updateActions are resources previously fetched using getActions.
            permissionClient.create({
            actions : [readAction, updateAction],
            section : '<section-name>',
            userName : '<userName>'
            })
            .success(function (data) {
            // perform success action here
            })
            .error(function (response, status, headers, config) {
            // perform error handling here
            });
    **/
    PermissionClient.prototype.create = function (data) {
        return this.apiClient.post(this.permissionRoute.create(), data);
    };
    /**
    * Returns a promise that is resolved once the remove action has been performed. If the action is successfully complete, an access policy assigned to the specified role and section will be removed.
    * @method
    * @example
            // permission is a resource previously fetched using get action.
            permissionClient.remove(permission)
            .success(function (data) {
            // perform success action here
            })
            .error(function (response, status, headers, config) {
            // perform error handling here
            });
   **/
    PermissionClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.remove(data));
    };
    /**
    * Creates a new in-memory permission object.
    * @method
    * @example
            // action collection are lookup items fetched using lookupClient.get action.
            var actionCollection;
            return lookupClient.get()
            .success(function (data) {
            actionCollection = data;
            })
            .error(function (data, status, headers, config) {});
            // subjectItem is an item fetched using permissionClient.getPermissionSubjects action.
            permissionClient.createPermission('<section-Name>', actionCollection, subjectItem);
   **/
    PermissionClient.prototype.createPermission = function (section, actions, membershipItem) {
        var _this = this;
        var permission = {
            dirty: true,
            role: membershipItem.roleName,
            userName: membershipItem.userName,
            section: section,
            actions: []
        };
        actions.forEach(function (element) {
            var newAction = {
                checked: false
            };
            _this.utility.extend(newAction, element);
            permission.actions.push(newAction);
        });
        return permission;
    };
    /**
    * Finds a permission in a given permission collection.
    * @method
    * @example permissionClient.findPermission(permissionObj, permissionCollection);
   **/
    PermissionClient.prototype.findPermission = function (permission, permissionCollection) {
        for (var i = 0; i < permissionCollection.length; i++) {
            var item = permissionCollection[i];
            if (item.section === permission.section &&
                ((!this.isEmpty(item.role) && !this.isEmpty(permission.role) && item.role === permission.role) ||
                    (!this.isEmpty(item.userName) && !this.isEmpty(permission.userName) && item.userName === permission.userName))) {
                return item;
            }
        }
        return undefined;
    };
    /**
    * Checks if a permission object exists in a given permission collection.
    * @method
    * @example permissionClient.exists(permissionObj, permissionCollection);
   **/
    PermissionClient.prototype.exists = function (permission, permissionCollection) {
        return this.findPermission(permission, permissionCollection) !== undefined;
    };
    /**
    * Returns a promise that is resolved once the togglePermission action has been completed. The action will internally either call a `remove` or `create` action based on given criteria.
    * @method
    * @example permissionClient.togglePermission(permissionObj, action);
    **/
    PermissionClient.prototype.togglePermission = function (permission, action) {
        var requestPermission = {
            actions: []
        };
        this.utility.extend(requestPermission, permission);
        requestPermission.actions = [action];
        var operation;
        if (!action.checked) {
            operation = this.remove;
        }
        else {
            operation = this.create;
        }
        return operation.call(this, requestPermission);
    };
    /**
    * Fetches and returns and object containing all existing module permissions.
    * @method
    * @example permissionClient.getModulePermissions('<section-name>');
    **/
    PermissionClient.prototype.getModulePermissions = function (section) {
        var permission = {
            update: this.hasPermission(this.firstCharToLowerCase(section) + '.update'),
            create: this.hasPermission(this.firstCharToLowerCase(section) + '.create'),
            remove: this.hasPermission(this.firstCharToLowerCase(section) + '.delete'),
            read: this.hasPermission(this.firstCharToLowerCase(section) + '.read'),
            full: this.hasPermission(this.firstCharToLowerCase(section) + '.full')
        };
        return permission;
    };
    PermissionClient.prototype.resetPermissions = function () {
        this.permissionHash[this.application.getApiKey()] = {};
    };
    /**
    * Checks if current user has permissions to perform a certain action. To optimize performance this information is cached and can be reset using the resetPermissions action. Permissions cache should be reset when updated user information is set.
    * @method
    * @example baasicAuthorizationService.hasPermission("<baasic-Section>.<action>");
    **/
    PermissionClient.prototype.hasPermission = function (authorization) {
        var apiKey = this.application.getApiKey();
        //Initialize application permissions
        if (!this.permissionHash.hasOwnProperty(apiKey)) {
            this.resetPermissions();
        }
        if (this.permissionHash[apiKey].hasOwnProperty(authorization)) {
            return this.permissionHash[apiKey][authorization];
        }
        var userContainer = this.application.getUser();
        if (userContainer === undefined) {
            return;
        }
        var user = userContainer.user;
        var hasPermission = false;
        if (user) {
            if (user.permissions) {
                var tokens = authorization.split('.');
                if (tokens.length > 0) {
                    var section = tokens[0];
                    var sectionPermissions = user.permissions[section];
                    if (sectionPermissions) {
                        if (tokens.length > 1) {
                            var action = tokens[1].toLowerCase();
                            for (var i = 0; i < sectionPermissions.length; i++) {
                                if (sectionPermissions[i].toLowerCase() === action) {
                                    hasPermission = true;
                                    break;
                                }
                            }
                        }
                        else {
                            hasPermission = true;
                        }
                    }
                }
            }
        }
        this.permissionHash[apiKey][authorization] = hasPermission;
        return hasPermission;
    };
    PermissionClient.prototype.isEmpty = function (data) {
        return data === undefined || data === null || data === '';
    };
    PermissionClient.prototype.getRoles = function (options) {
        return this.apiClient.get(this.routeDefinition.getRoles(options));
    };
    PermissionClient.prototype.getUsers = function (options) {
        return this.apiClient.get(this.routeDefinition.getUsers(options));
    };
    PermissionClient.prototype.firstCharToLowerCase = function (text) {
        return text.replace(/^./, function (char) {
            return char.toLowerCase();
        });
    };
    var _a, _b, _c;
    PermissionClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.PermissionRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IBaasicApp)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.PermissionRoute !== "undefined" && _1.PermissionRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IBaasicApp !== "undefined" && contracts_1.IBaasicApp) === "function" ? _c : Object])
    ], PermissionClient);
    return PermissionClient;
}());
exports.PermissionClient = PermissionClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 *@module lookupRoute
 * @description Baasic Lookup Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Lookup Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var LookupRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LookupRoute, _super);
    function LookupRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Get route with route and query parameters.
        **/
        _this.getRoute = 'lookups/{?embed,fields}';
        return _this;
    }
    /**
     * Parses get route which can be expanded with additional options. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example baasicLookupRouteService.get(data);
     **/
    LookupRoute.prototype.get = function (data) {
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    var _a;
    LookupRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], LookupRoute);
    return LookupRoute;
}(common_1.BaseRoute));
exports.LookupRoute = LookupRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module lookupClient
 * @description  Lookup Client provides an easy way to consume  Lookup REST API end-points. In order to obtain needed routes `lookupClient` uses `lookupRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var common_1 = __webpack_require__(2);
var _1 = __webpack_require__(13);
var httpApi_1 = __webpack_require__(4);
var LookupClient = /** @class */ (function () {
    function LookupClient(lookupRoute, apiClient) {
        this.lookupRoute = lookupRoute;
        this.apiClient = apiClient;
        this.utility = new common_1.Utility();
    }
    Object.defineProperty(LookupClient.prototype, "routeDefinition", {
        get: function () {
            return this.lookupRoute;
        },
        enumerable: true,
        configurable: true
    });
    LookupClient.prototype.getResponseData = function (embed, data) {
        var responseData = {};
        if (embed) {
            var embeds = embed.split(',');
        }
        for (var index in embeds) {
            var propName = embeds[index];
            if (data.hasOwnProperty(propName)) {
                responseData[propName] = data[propName];
            }
        }
        return responseData;
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the lookup resources.
     * @method
     * @param options Options object that contains comma separated list of related resources to be contained within the current representation.
     * @returns A promise that is resolved once the get action has been performed.
     * @example lookupClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    LookupClient.prototype.get = function (options) {
        var _this = this;
        var embed = options.embed || 'role,accessAction,accessSection,snProvider';
        var opt = this.utility.extend({}, options, { embed: embed });
        var self = this;
        return this.apiClient.createPromise(function (resolve, reject) {
            self.apiClient.get(_this.lookupRoute.get(opt))
                .then(function (data) {
                data.data = self.getResponseData(embed, data.data);
                resolve(data);
            }, function (data) {
                reject(data);
            });
        });
    };
    var _a, _b;
    LookupClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LookupRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LookupRoute !== "undefined" && _1.LookupRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], LookupClient);
    return LookupClient;
}());
exports.LookupClient = LookupClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(13);
var inversify_1 = __webpack_require__(1);
var Root = /** @class */ (function () {
    function Root(login, loginSocial, passwordRecovery, register, role, user, permissions, lookups) {
        this.login = login;
        this.loginSocial = loginSocial;
        this.passwordRecovery = passwordRecovery;
        this.register = register;
        this.role = role;
        this.user = user;
        this.permissions = permissions;
        this.lookups = lookups;
    }
    var _a, _b, _c, _d, _e, _f, _g, _h;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LoginClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.LoginSocialClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.PasswordRecoveryClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.RegisterClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.RoleClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.UserClient)),
        tslib_1.__param(6, inversify_1.inject(_1.TYPES.PermissionClient)),
        tslib_1.__param(7, inversify_1.inject(_1.TYPES.LookupClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LoginClient !== "undefined" && _1.LoginClient) === "function" ? _a : Object, typeof (_b = typeof _1.LoginSocialClient !== "undefined" && _1.LoginSocialClient) === "function" ? _b : Object, typeof (_c = typeof _1.PasswordRecoveryClient !== "undefined" && _1.PasswordRecoveryClient) === "function" ? _c : Object, typeof (_d = typeof _1.RegisterClient !== "undefined" && _1.RegisterClient) === "function" ? _d : Object, typeof (_e = typeof _1.RoleClient !== "undefined" && _1.RoleClient) === "function" ? _e : Object, typeof (_f = typeof _1.UserClient !== "undefined" && _1.UserClient) === "function" ? _f : Object, typeof (_g = typeof _1.PermissionClient !== "undefined" && _1.PermissionClient) === "function" ? _g : Object, typeof (_h = typeof _1.LookupClient !== "undefined" && _1.LookupClient) === "function" ? _h : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(175), exports);
tslib_1.__exportStar(__webpack_require__(176), exports);
tslib_1.__exportStar(__webpack_require__(177), exports);
tslib_1.__exportStar(__webpack_require__(178), exports);
tslib_1.__exportStar(__webpack_require__(179), exports);
tslib_1.__exportStar(__webpack_require__(180), exports);
tslib_1.__exportStar(__webpack_require__(181), exports);
tslib_1.__exportStar(__webpack_require__(182), exports);
tslib_1.__exportStar(__webpack_require__(183), exports);
tslib_1.__exportStar(__webpack_require__(184), exports);
tslib_1.__exportStar(__webpack_require__(185), exports);
tslib_1.__exportStar(__webpack_require__(186), exports);
tslib_1.__exportStar(__webpack_require__(187), exports);
tslib_1.__exportStar(__webpack_require__(188), exports);
tslib_1.__exportStar(__webpack_require__(189), exports);
tslib_1.__exportStar(__webpack_require__(190), exports);
tslib_1.__exportStar(__webpack_require__(191), exports);
tslib_1.__exportStar(__webpack_require__(192), exports);
tslib_1.__exportStar(__webpack_require__(193), exports);
tslib_1.__exportStar(__webpack_require__(194), exports);


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(9);
var TYPES = {
    CompanyBatchClient: Symbol("CompanyBatchClient"),
    CompanyBatchRoute: Symbol("CompanyBatchRoute"),
    CompanyClient: Symbol("CompanyClient"),
    CompanyRoute: Symbol("CompanyRoute"),
    OrganizationBatchClient: Symbol("OrganizationBatchClient"),
    OrganizationBatchRoute: Symbol("OrganizationBatchRoute"),
    OrganizationClient: Symbol("OrganizationClient"),
    OrganizationRoute: Symbol("OrganizationRoute"),
    SkillBatchClient: Symbol("SkillBatchClient"),
    SkillBatchRoute: Symbol("SkillBatchRoute"),
    SkillClient: Symbol("SkillClient"),
    SkillRoute: Symbol("SkillRoute"),
    UserEducationClient: Symbol("UserEducationClient"),
    UserEducationRoute: Symbol("UserEducationRoute"),
    UserProfileACLClient: Symbol("UserProfileACLClient"),
    UserProfileACLRoute: Symbol("UserProfileACLRoute"),
    UserProfileAvatarClient: Symbol("UserProfileAvatarClient"),
    UserProfileAvatarRoute: Symbol("UserProfileAvatarRoute"),
    UserProfileAvatarStreamsClient: Symbol("UserProfileAvatarStreamsClient"),
    UserProfileAvatarStreamsRoute: Symbol("UserProfileAvatarStreamsClient"),
    UserProfileClient: Symbol("UserProfileClient"),
    UserProfileRoute: Symbol("UserProfileRoute"),
    UserSkillClient: Symbol("UserSkillClient"),
    UserSkillRoute: Symbol("UserSkillRoute"),
    UserWorkClient: Symbol("UserWorkClient"),
    UserWorkRoute: Symbol("UserWorkRoute"),
    LanguageBatchRoute: Symbol("LanguageBatchRoute"),
    LanguageBatchClient: Symbol("LanguageBatchClient"),
    LanguageRoute: Symbol("LanguageRoute"),
    LanguageClient: Symbol("LanguageClient"),
    Root: Symbol("UserProfile-Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.CompanyBatchRoute).to(_1.CompanyBatchRoute);
    bind(TYPES.CompanyBatchClient).to(_1.CompanyBatchClient);
    bind(TYPES.CompanyRoute).to(_1.CompanyRoute);
    bind(TYPES.CompanyClient).to(_1.CompanyClient);
    bind(TYPES.OrganizationBatchRoute).to(_1.OrganizationBatchRoute);
    bind(TYPES.OrganizationBatchClient).to(_1.OrganizationBatchClient);
    bind(TYPES.OrganizationRoute).to(_1.OrganizationRoute);
    bind(TYPES.OrganizationClient).to(_1.OrganizationClient);
    bind(TYPES.SkillBatchRoute).to(_1.SkillBatchRoute);
    bind(TYPES.SkillBatchClient).to(_1.SkillBatchClient);
    bind(TYPES.SkillRoute).to(_1.SkillRoute);
    bind(TYPES.SkillClient).to(_1.SkillClient);
    bind(TYPES.UserEducationRoute).to(_1.UserEducationRoute);
    bind(TYPES.UserEducationClient).to(_1.UserEducationClient);
    bind(TYPES.UserProfileACLRoute).to(_1.UserProfileACLRoute);
    bind(TYPES.UserProfileACLClient).to(_1.UserProfileACLClient);
    bind(TYPES.UserProfileAvatarStreamsRoute).to(_1.UserProfileAvatarStreamsRoute);
    bind(TYPES.UserProfileAvatarStreamsClient).to(_1.UserProfileAvatarStreamsClient);
    bind(TYPES.UserProfileAvatarRoute).to(_1.UserProfileAvatarRoute);
    bind(TYPES.UserProfileAvatarClient).to(_1.UserProfileAvatarClient);
    bind(TYPES.UserProfileRoute).to(_1.UserProfileRoute);
    bind(TYPES.UserProfileClient).to(_1.UserProfileClient);
    bind(TYPES.UserSkillRoute).to(_1.UserSkillRoute);
    bind(TYPES.UserSkillClient).to(_1.UserSkillClient);
    bind(TYPES.UserWorkRoute).to(_1.UserWorkRoute);
    bind(TYPES.UserWorkClient).to(_1.UserWorkClient);
    bind(TYPES.LanguageBatchRoute).to(_1.LanguageBatchRoute);
    bind(TYPES.LanguageBatchClient).to(_1.LanguageBatchClient);
    bind(TYPES.LanguageRoute).to(_1.LanguageRoute);
    bind(TYPES.LanguageClient).to(_1.LanguageClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module companyBatchRoute
 * @description Baasic Company Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CompanyBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CompanyBatchRoute, _super);
    function CompanyBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'lookups/companies/batch';
        _this.updateRoute = 'lookups/companies/batch';
        _this.deleteRoute = 'lookups/companies/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example companyRoute.create();
     **/
    CompanyBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example companyRoute.update();
     **/
    CompanyBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example companyRoute.remove();
     **/
    CompanyBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CompanyBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CompanyBatchRoute);
    return CompanyBatchRoute;
}(common_1.BaseRoute));
exports.CompanyBatchRoute = CompanyBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module companyBatchClient
 * @description  Company Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var CompanyBatchClient = /** @class */ (function () {
    function CompanyBatchClient(companyBatchRoute, apiClient) {
        this.companyBatchRoute = companyBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CompanyBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.companyBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create company action has been performed; this action creates new company resources.
     * @method
     * @param data A collection of company objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create company action has been performed.
     * @example  companyBatchClient.create([{
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                 }])
                 .then(function (data) {
                     // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                 });
     **/
    CompanyBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update company action has been performed; this action updates specified company resources.
     * @method
     * @param data A collection of company objects used to update specified company resources.
     * @returns A promise that is resolved once the update company action has been performed.
     * @example   companyBatchClient.update(companies)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CompanyBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove company resources from the system if successfully completed.
     * @method
     * @param ids Collection of company ids which uniquely identifies company resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example companyBatchClient.remove(companyIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CompanyBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.companyBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CompanyBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CompanyBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CompanyBatchRoute !== "undefined" && _1.CompanyBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CompanyBatchClient);
    return CompanyBatchClient;
}());
exports.CompanyBatchClient = CompanyBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module companyRoute
 * @description Baasic Company Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(9);
var contracts_1 = __webpack_require__(3);
var CompanyRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CompanyRoute, _super);
    function CompanyRoute(appOptions, companyBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.companyBatchRoute = companyBatchRoute;
        _this.findRoute = 'lookups/companies/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.createRoute = 'lookups/companies';
        _this.getRoute = 'lookups/companies/{id}/{?embed,fields}';
        _this.updateRoute = 'lookups/companies/{id}';
        _this.deleteRoute = 'lookups/companies/{id}';
        return _this;
    }
    Object.defineProperty(CompanyRoute.prototype, "batch", {
        get: function () {
            return this.companyBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing company properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain company subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the company property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example companyRoute.find({searchQuery: '<search-phrase>'});
     **/
    CompanyRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example companyRoute.create();
     **/
    CompanyRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id Company id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example companyRoute.get();
     **/
    CompanyRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    CompanyRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    CompanyRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CompanyRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CompanyBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.CompanyBatchRoute !== "undefined" && _1.CompanyBatchRoute) === "function" ? _b : Object])
    ], CompanyRoute);
    return CompanyRoute;
}(common_1.BaseRoute));
exports.CompanyRoute = CompanyRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module companyClient
 * @description  Company Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var CompanyClient = /** @class */ (function () {
    function CompanyClient(companyBatchClient, companyRoute, apiClient) {
        this.companyBatchClient = companyBatchClient;
        this.companyRoute = companyRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CompanyClient.prototype, "routeDefinition", {
        get: function () {
            return this.companyRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanyClient.prototype, "batch", {
        get: function () {
            return this.companyBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of company resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example companyClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CompanyClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the company resource.
     * @method
     * @param id Company id which uniquely identifies resource that needs to be retrieved.
     * @returns A promise that is resolved once the get action has been performed.
     * @param options Query resource options object.
     * @example companyClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CompanyClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.companyRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create company action has been performed; this action creates a new company resource.
     * @method
     * @param data A company object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create company action has been performed.
     * @example companyClient.create({
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CompanyClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update company action has been performed; this action updates a company resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `companyRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(company);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A company object used to update specified company resource.
     * @returns A promise that is resolved once the update company action has been performed.
     * @example // company is a resource previously fetched using get action.
                    company.description = '<description>';
                    baasicCompanyService.update(company)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CompanyClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a company resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `companyRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(company);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data A company object used to delete specified company resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // company is a resource previously fetched using get action.
                    companyClient.remove(company)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                    });
     **/
    CompanyClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CompanyClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CompanyBatchClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CompanyRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CompanyBatchClient !== "undefined" && _1.CompanyBatchClient) === "function" ? _a : Object, typeof (_b = typeof _1.CompanyRoute !== "undefined" && _1.CompanyRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CompanyClient);
    return CompanyClient;
}());
exports.CompanyClient = CompanyClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module organizationBatchRoute
 * @description Baasic Organization Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Organization Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var OrganizationBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(OrganizationBatchRoute, _super);
    function OrganizationBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'lookups/organizations/batch';
        _this.updateRoute = 'lookups/organizations/batch';
        _this.deleteRoute = 'lookups/organizations/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example organizationBatchRoute.create();
     **/
    OrganizationBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example organizationBatchRoute.update();
     **/
    OrganizationBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example organizationBatchRoute.delete();
     **/
    OrganizationBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    OrganizationBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], OrganizationBatchRoute);
    return OrganizationBatchRoute;
}(common_1.BaseRoute));
exports.OrganizationBatchRoute = OrganizationBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module organizationBatchClient
 * @description  Organization Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Organization Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var OrganizationBatchClient = /** @class */ (function () {
    function OrganizationBatchClient(organizationBatchRoute, apiClient) {
        this.organizationBatchRoute = organizationBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(OrganizationBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.organizationBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create organization action has been performed; this action creates new organization resources.
     * @method
     * @param data A collection of organization objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create organization action has been performed.
     * @example   organizationBatchClient.create([{
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                  }])
                  .then(function (data) {
                      // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
     **/
    OrganizationBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update organization action has been performed; this action updates specified organization resources.
     * @method
     * @param data A collection of organization objects used to update specified organization resources.
     * @returns A promise that is resolved once the update organization action has been performed.
     * @example   organizationBatchClient.update(organizations)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    OrganizationBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove organization resources from the system if successfully completed.
     * @method
     * @example organizationBatchClient.remove(organizationIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    OrganizationBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.organizationBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    OrganizationBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.OrganizationBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.OrganizationBatchRoute !== "undefined" && _1.OrganizationBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], OrganizationBatchClient);
    return OrganizationBatchClient;
}());
exports.OrganizationBatchClient = OrganizationBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module organizationRoute
 * @description Baasic Organization Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Organization Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(9);
var contracts_1 = __webpack_require__(3);
var OrganizationRoute = /** @class */ (function (_super) {
    tslib_1.__extends(OrganizationRoute, _super);
    function OrganizationRoute(appOptions, organizationBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.organizationBatchRoute = organizationBatchRoute;
        _this.findRoute = 'lookups/organizations/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'lookups/organizations/{id}/{?embed,fields}';
        _this.createRoute = 'lookups/organizations';
        _this.updateRoute = 'lookups/organizations/{id}';
        _this.deleteRoute = 'lookups/organizations/{id}';
        return _this;
    }
    Object.defineProperty(OrganizationRoute.prototype, "batch", {
        get: function () {
            return this.organizationBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing organization properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain organization subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the organization property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example organizationRoute.find({searchQuery: '<search-phrase>'});
     **/
    OrganizationRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id Organization id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example organizationRoute.get(id, options);
     **/
    OrganizationRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example organizationRoute.create();
     **/
    OrganizationRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data An organization object used to update specified organization resource.
     * @example organizationRoute.updata(data);
     **/
    OrganizationRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this URI template does not expose any additional options.
     * @method
     * @param data An organization object used to delete specified organization resource.
     * @example organizationRoute.delete(data);
     **/
    OrganizationRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    OrganizationRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.OrganizationBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.OrganizationBatchRoute !== "undefined" && _1.OrganizationBatchRoute) === "function" ? _b : Object])
    ], OrganizationRoute);
    return OrganizationRoute;
}(common_1.BaseRoute));
exports.OrganizationRoute = OrganizationRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module organizationClient
 * @description  Organization Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Organization Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var OrganizationClient = /** @class */ (function () {
    function OrganizationClient(organizationRoute, organizationBatchClient, apiClient) {
        this.organizationRoute = organizationRoute;
        this.organizationBatchClient = organizationBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(OrganizationClient.prototype, "routeDefinition", {
        get: function () {
            return this.organizationRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganizationClient.prototype, "batch", {
        get: function () {
            return this.organizationBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of organization resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example organizationClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    OrganizationClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the organization resource.
     * @method
     * @param id Organization id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example organizationClient.get(id, options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    OrganizationClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.organizationRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create organization action has been performed; this action creates a new organization resource.
     * @method
     * @param data An organization object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create organization action has been performed.
     * @example organizationClient.create({
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    OrganizationClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update organization action has been performed; this action updates an organization resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `organizationRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(organization);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An organization object used to update specified organization resource.
     * @returns A promise that is resolved once the update organization action has been performed.
     * @example // organization is a resource previously fetched using get action.
                    organization.description = '<description>';
                    organizationClient.update(organization)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    OrganizationClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove an organization resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `organizationRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(organization);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An organization object used to delete specified organization resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // organization is a resource previously fetched using get action.
                       organizationClient.remove(organization)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    OrganizationClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    OrganizationClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.OrganizationRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.OrganizationBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.OrganizationRoute !== "undefined" && _1.OrganizationRoute) === "function" ? _a : Object, typeof (_b = typeof _1.OrganizationBatchClient !== "undefined" && _1.OrganizationBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], OrganizationClient);
    return OrganizationClient;
}());
exports.OrganizationClient = OrganizationClient;


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module skillBatchRoute
 * @description Baasic Skill Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Skill Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var SkillBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(SkillBatchRoute, _super);
    function SkillBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'profile/lookups/skills/batch';
        _this.updateRoute = 'profile/lookups/skills/batch';
        _this.deleteRoute = 'profile/lookups/skills/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example skillBatchRoute.create();
     **/
    SkillBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
      * Parses update route; this URI template does not expose any additional options.
      * @method
      * @example skillBatchRoute.update();
      **/
    SkillBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
      * Parses delete route; this URI template does not expose any additional options.
      * @method
      * @example skillBatchRoute.delete();
      **/
    SkillBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    SkillBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], SkillBatchRoute);
    return SkillBatchRoute;
}(common_1.BaseRoute));
exports.SkillBatchRoute = SkillBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module skillBatchClient
 * @description Baasic Skill Batch Service provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Skill Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var SkillBatchClient = /** @class */ (function () {
    function SkillBatchClient(skillBatchRoute, apiClient) {
        this.skillBatchRoute = skillBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(SkillBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.skillBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create skill action has been performed; this action creates new skill resources.
     * @method
     * @param data A collection of skill objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create skill action has been performed.
     * @example   skillClient.create([{
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                  }])
                  .then(function (data) {
                      // perform success action here
                  },
                    function (response, status, headers, config) {
                        // perform error handling here
                  });
     **/
    SkillBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update skill action has been performed; this action updates specified skill resources.
     * @method
     * @param data A collection of skill objects used to update specified skill resources.
     * @returns A promise that is resolved once the update skill action has been performed.
     * @example   skillBatchClient.update(companies)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    SkillBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove skill resources from the system if successfully completed.
     * @method
     * @param ids Collection of skill ids which uniquely identifies skill resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example skillBatchClient.remove(skillIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    SkillBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.skillBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    SkillBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.SkillBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.SkillBatchRoute !== "undefined" && _1.SkillBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], SkillBatchClient);
    return SkillBatchClient;
}());
exports.SkillBatchClient = SkillBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module skillRoute
 * @description Baasic Skill Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Skill Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(9);
var contracts_1 = __webpack_require__(3);
var SkillRoute = /** @class */ (function (_super) {
    tslib_1.__extends(SkillRoute, _super);
    function SkillRoute(appOptions, skillBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.skillBatchRoute = skillBatchRoute;
        _this.findRoute = 'profile/lookups/skills/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profile/lookups/skills/{id}/{?embed,fields}';
        _this.createRoute = 'profile/lookups/skills';
        _this.updateRoute = 'profile/lookups/skills/{id}';
        _this.deleteRoute = 'lookups/skills/{id}';
        return _this;
    }
    Object.defineProperty(SkillRoute.prototype, "batch", {
        get: function () {
            return this.skillBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing skill properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain skill subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the skill property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example skillRoute.find({searchQuery: '<search-phrase>'});
     **/
    SkillRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id Skill id which uniquely identifies skill resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example skillRoute.get(id, options);
     **/
    SkillRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example skillRoute.create();
     **/
    SkillRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data A skill object used to update specified skill resource.
     * @example skillRoute.update(data);
     **/
    SkillRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this URI template does not expose any additional options.
     * @method
     * @param data A skill object used to delete specified skill resource.
     * @example skillRoute.delete(data);
     **/
    SkillRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    SkillRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.SkillBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.SkillBatchRoute !== "undefined" && _1.SkillBatchRoute) === "function" ? _b : Object])
    ], SkillRoute);
    return SkillRoute;
}(common_1.BaseRoute));
exports.SkillRoute = SkillRoute;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module skillClient
 * @description  Skill Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Skill Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var SkillClient = /** @class */ (function () {
    function SkillClient(skillRoute, skillBatchClient, apiClient) {
        this.skillRoute = skillRoute;
        this.skillBatchClient = skillBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(SkillClient.prototype, "routeDefinition", {
        get: function () {
            return this.skillRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SkillClient.prototype, "batch", {
        get: function () {
            return this.skillBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of skill resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example skillClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    SkillClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the skill resource.
     * @method
     * @param id Skill id which uniquely identifies skill resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example skillClient.get(id, options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    SkillClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.skillRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create skill action has been performed; this action creates a new skill resource.
     * @method
     * @param data A skill object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create skill action has been performed.
     * @example skillClient.create({
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    SkillClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update skill action has been performed; this action updates a skill resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `skillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A skill object used to update specified skill resource.
     * @returns A promise that is resolved once the update skill action has been performed.
     * @example // skill is a resource previously fetched using get action.
                    skill.description = '<description>';
                    skillClient.update(skill)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    SkillClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a skill resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `skillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param A skill object used to delete specified skill resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // skill is a resource previously fetched using get action.
                       skillClient.remove(skill)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    SkillClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    SkillClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.SkillRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.SkillBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.SkillRoute !== "undefined" && _1.SkillRoute) === "function" ? _a : Object, typeof (_b = typeof _1.SkillBatchClient !== "undefined" && _1.SkillBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], SkillClient);
    return SkillClient;
}());
exports.SkillClient = SkillClient;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userEducationRoute
 * @description Baasic User Education Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Education Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var UserEducationRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserEducationRoute, _super);
    function UserEducationRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'profiles/{userId}/educations/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{userId}/educations/{id}/{?embed,fields}';
        _this.createRoute = 'profiles/{userId}/educations';
        _this.updateRoute = 'profiles/{userId}/educations/{id}';
        _this.deleteRoute = 'profiles/{userId}/educations/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user education properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user education subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user education property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userEducationRoute.find({searchQuery: '<search-phrase>'});
     **/
    UserEducationRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User education id which uniquely identifies user education resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userEducationRoute.get(id);
     **/
    UserEducationRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @param data An user education object that needs to be inserted into the system.
     * @example userEducationRoute.create(data);
     **/
    UserEducationRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data An user education object used to update specified skill resource.
     * @example userEducationRoute.update(data);
     **/
    UserEducationRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route; this URI template does not expose any additional options.
     * @method
     * @param data An user education object used to delete specified skill resource.
     * @example userEducationRoute.delete(data);
     **/
    UserEducationRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    UserEducationRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserEducationRoute);
    return UserEducationRoute;
}(common_1.BaseRoute));
exports.UserEducationRoute = UserEducationRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userEducationClient  * @description  User Education Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Education Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var UserEducationClient = /** @class */ (function () {
    function UserEducationClient(userEducationRoute, apiClient) {
        this.userEducationRoute = userEducationRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserEducationClient.prototype, "routeDefinition", {
        get: function () {
            return this.userEducationRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user education resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example userEducationClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserEducationClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the user education resource.
     * @method
     * @example userEducationClient.get(id)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserEducationClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userEducationRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user education action has been performed; this action creates a new user education resource.
     * @method
     * @param data An user education object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user education action has been performed.
     * @example userEducationClient.create({
                    organizationName : '<organization-name>',
                    summary: '<summary>',
                    userId: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserEducationClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user education action has been performed; this action updates a user education resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userEducationRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(education);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An user education object used to update specified user education resource.
     * @returns A promise that is resolved once the update user education action has been performed.
     * @example // education is a resource previously fetched using get action.
                    education.degree = '<degree>';
                    userEducationClient.update(education)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserEducationClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a user education resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicUserEducationRoutDefinition` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(education);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // education is a resource previously fetched using get action.
                    userEducationClient.remove(education)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserEducationClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    UserEducationClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserEducationRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserEducationRoute !== "undefined" && _1.UserEducationRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserEducationClient);
    return UserEducationClient;
}());
exports.UserEducationClient = UserEducationClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileAvatarStreamsRoute
 * @description Baasic User Profile Avatar Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Avatar Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var UserProfileAvatarStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileAvatarStreamsRoute, _super);
    function UserProfileAvatarStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'profiles/{id}/avatar-streams/{?width,height,t}';
        _this.createRoute = 'profiles/{id}/avatar-streams/{filename}';
        _this.updateRoute = 'profiles/{id}/avatar-streams/{?width,height}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id of profile. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @example userProfileAvatarStreamsRoute.get({id: '<file-id>'});
     **/
    UserProfileAvatarStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the filename which indicates where the stream will be saved as well with id of the profile.
     * @method
     * @example userProfileAvatarStreamRoute.create({ filename: '<filename>', id: '<file-id>' });
     **/
    UserProfileAvatarStreamsRoute.prototype.create = function (id, data) {
        if (!this.utility.isObject(data)) {
            data = {
                filename: data
            };
        }
        var params = this.utility.extend({}, data);
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.createRoute, params);
    };
    /**
     * Parses update route; this route should be expanded with the id of the profile. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @param data
     * @example userProfileAvatarStreamsRoute.update({id: '<file-id>'});
     **/
    UserProfileAvatarStreamsRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.updateRoute, data);
    };
    var _a;
    UserProfileAvatarStreamsRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserProfileAvatarStreamsRoute);
    return UserProfileAvatarStreamsRoute;
}(common_1.BaseRoute));
exports.UserProfileAvatarStreamsRoute = UserProfileAvatarStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileAvatarStreamsClient
 * @description  User Profile Avatar Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Avatar Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var UserProfileAvatarStreamsClient = /** @class */ (function () {
    function UserProfileAvatarStreamsClient(userProfileAvatarStreamsRoute, apiClient) {
        this.userProfileAvatarStreamsRoute = userProfileAvatarStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserProfileAvatarStreamsClient.prototype, "routeDefinition", {
        get: function () {
            return this.userProfileAvatarStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a stream of the derived resource. Otherwise, stream of the original file resource will be retrieved.
     * @method
     * @param data User unique identifier.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original file stream
                    userProfileAvatarStreamsClient.get({id: '<file-id>'})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
                    // Request derived file stream
                    userProfileAvatarStreamsClient.get({id: '<file-id>', width: <width>, height: <height>, t: <timestamp>})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserProfileAvatarStreamsClient.prototype.get = function (data) {
        return this.apiClient.get(this.routeDefinition.get(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a blob of the derived file resource. Otherwise, blob of the original file resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @example // Request the original blob
                    userProfileAvatarStreamsClient.getBlob('<file-id>')
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
                        // Request derived blob
                        userProfileAvatarStreamsClient.getBlob({id: '<file-id>', width: <width>, height: <height>, t: <timestamp>})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    UserProfileAvatarStreamsClient.prototype.getBlob = function (data) {
        return this.apiClient.request({
            url: this.userProfileAvatarStreamsRoute.get(data),
            responseType: 'blob',
            headers: { 'Accept': 'application/octet-stream' },
            method: 'GET'
        });
    };
    /**
     * Returns a promise that is resolved once the create file stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param id
     * @param data
     * @param stream
     * @returns A promise that is resolved once the create file stream action has been performed.
     * @example userProfileAvatarStreamsClient.create('<file-id>', '<filename'>, <blob>)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileAvatarStreamsClient.prototype.create = function (id, data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.userProfileAvatarStreamsRoute.create(id, data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the update file stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of file stream data type).
     * @method
     * @param data
     * @param stream
     * @returns A promise that is resolved once the update file stream action has been performed.
     * @example // Update original file stream
                    userProfileAvatarStreamsClient.update('<file-id>', <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
                        // Update derived file stream
                        userProfileAvatarStreamsClient.update({id: '<file-id>', width: <width>, height: <height>}, <file-stream>)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    UserProfileAvatarStreamsClient.prototype.update = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.userProfileAvatarStreamsRoute.update(data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    UserProfileAvatarStreamsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileAvatarStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileAvatarStreamsRoute !== "undefined" && _1.UserProfileAvatarStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserProfileAvatarStreamsClient);
    return UserProfileAvatarStreamsClient;
}());
exports.UserProfileAvatarStreamsClient = UserProfileAvatarStreamsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileAvatarRoute
 * @description Baasic User Profile Avatar Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Avatar Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(9);
var contracts_1 = __webpack_require__(3);
var UserProfileAvatarRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileAvatarRoute, _super);
    function UserProfileAvatarRoute(appOptions, userProfileAvatarStreamsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.userProfileAvatarStreamsRoute = userProfileAvatarStreamsRoute;
        _this.getRoute = 'profiles/{id}/avatars/{?embed,fields}';
        _this.updateRoute = 'profiles/{id}/avatars';
        _this.linkRoute = 'profiles/{id}/avatars/link';
        _this.unlinkRoute = 'profiles/{id}/avatars/unlink';
        return _this;
    }
    Object.defineProperty(UserProfileAvatarRoute.prototype, "streams", {
        get: function () {
            return this.userProfileAvatarStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses get route; this route should be expanded with the Id of the profile.
     * @method
     * @param id User Profile id which uniquely identifies user avatar resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userProfileAvatarRoute.get({id: '<file-id>'});
     **/
    UserProfileAvatarRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data A Profile Avatar object used to update specified Profile Avatar resource.
     * @example userProfileAvatarRoute.update(data);
     **/
    UserProfileAvatarRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses link route; this route should be expanded with the Id of the profile.
     * @method
     * @param id User Profile id which uniquely identifies user avatar resource that needs to be retrieved.
     * @param data A Profile Avatar object used to link specified Profile Avatar resource.
     * @example userProfileAvatarRoute.link({id: '<file-id>'});
     **/
    UserProfileAvatarRoute.prototype.link = function (id, data) {
        var params = this.utility.extend({}, data);
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses link route; this route should be expanded with the Id of the profile.
     * @method
     * @param data A Profile Avatar object used to unlink specified Profile Avatar resource.
     * @param options Query resource options object.
     * @example userProfileAvatarRoute.unlink(data);
     **/
    UserProfileAvatarRoute.prototype.unlink = function (data, options) {
        if (!options) {
            options = {};
        }
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data, options);
    };
    UserProfileAvatarRoute.prototype.createParams = function (data, id) {
        var params = this.utility.extend(data);
        params.id = id;
        return _super.prototype.createParams.call(this, params);
    };
    var _a, _b;
    UserProfileAvatarRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserProfileAvatarStreamsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.UserProfileAvatarStreamsRoute !== "undefined" && _1.UserProfileAvatarStreamsRoute) === "function" ? _b : Object])
    ], UserProfileAvatarRoute);
    return UserProfileAvatarRoute;
}(common_1.BaseRoute));
exports.UserProfileAvatarRoute = UserProfileAvatarRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileAvatarClient
 * @description  User Profile Avatar Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Avatar Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var UserProfileAvatarClient = /** @class */ (function () {
    function UserProfileAvatarClient(userProfileAvatarRoute, userProfileAvatarStreamsClient, apiClient) {
        this.userProfileAvatarRoute = userProfileAvatarRoute;
        this.userProfileAvatarStreamsClient = userProfileAvatarStreamsClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserProfileAvatarClient.prototype, "routeDefinition", {
        get: function () {
            return this.userProfileAvatarRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileAvatarClient.prototype, "streams", {
        get: function () {
            return this.userProfileAvatarStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested file resource.
     * @method
     * @param id User Profile id which uniquely identifies user avatar resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userProfileAvatarClient.get('<file-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    UserProfileAvatarClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userProfileAvatarRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update file action has been performed; this action will update a file resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userProfileAvatarRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(fileEntry);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data Avatar file object that need to be updated in the system.
     * @returns A promise that is resolved once the update file action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                       fileEntry.description = '<description>';
                       userProfileAvatarClient.update(fileEntry)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                           });
                                // perform error handling here
    **/
    UserProfileAvatarClient.prototype.update = function (data) {
        return this.apiClient.put(this.userProfileAvatarRoute.update(data), data);
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resource from other modules into the Profile Files module (For example: file resources from the Media Vault module can be linked directly into the Profile Files module).
     * @method
     * @param id User Profile id which uniquely identifies user avatar resource that needs to be retrieved.
     * @param data A profile avatar file object that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example userProfileAvatarClient.link(fileObject)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileAvatarClient.prototype.link = function (id, data) {
        return this.apiClient.post(this.routeDefinition.link(id, data), this.routeDefinition.createParams(data, id));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove one or many file resources from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply userProfileAvatarRoute route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink').href;
     * ```
     * @method
     * @param data A profile avatar file object used to remove specific profile avatar from the system.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action. The following action will remove the original file resource and all accompanying derived file resources.
                    userProfileAvatarRoute.remove(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserProfileAvatarClient.prototype.unlink = function (data, options) {
        return this.apiClient.delete(this.userProfileAvatarRoute.unlink(data, options));
    };
    var _a, _b, _c;
    UserProfileAvatarClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileAvatarRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserProfileAvatarStreamsClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileAvatarRoute !== "undefined" && _1.UserProfileAvatarRoute) === "function" ? _a : Object, typeof (_b = typeof _1.UserProfileAvatarStreamsClient !== "undefined" && _1.UserProfileAvatarStreamsClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], UserProfileAvatarClient);
    return UserProfileAvatarClient;
}());
exports.UserProfileAvatarClient = UserProfileAvatarClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileACLRoute
 * @description Baasic User ACL Profile Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile ACL Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var UserProfileACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileACLRoute, _super);
    function UserProfileACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'profiles/{id}/acl/{?fields}';
        _this.updateRoute = 'profiles/{id}/acl/{?fields}';
        _this.deleteByUserRoute = 'profiles/{id}/acl/actions/{accessAction}/users/{user}/';
        _this.deleteByRoleRoute = 'profiles/{id}/acl/actions/{accessAction}/roles/{role}/';
        return _this;
    }
    /**
     * Parses get user profile acl route; this URI template should be expanded with the Id of the user profile resource.
     * @method
     * @param options Query resource options object.
     * @example userProfileACLRoute.get({id: '<profile-id>'});
     **/
    UserProfileACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update user profile acl route; this URI template should be expanded with the Id of the user profile.
     * @method
     * @param options ACL options object.
     * @example userProfileACLRoute.update({id: '<profile-id>'});
     **/
    UserProfileACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    UserProfileACLRoute.prototype.updateParams = function (options) {
        var params = this.utility.extend({}, options);
        return params[this.modelMapper.modelPropertyName];
    };
    /**
     * Parses deleteByUser user profile acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the user profile resource.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and user profile resource.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param profileId User profile id which uniquely identifies user profile resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user profile resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL policy object used to delete specified ACL policy resource.
     * @example userProfileACLRoute.deleteByUser({ id: '<profile-id>', accessAction: '<access-action>', user: '<username>' });
     **/
    UserProfileACLRoute.prototype.deleteByUser = function (profileId, action, user, data) {
        var params = this.modelMapper.removeParams(data);
        params.profileId = profileId;
        params.user = user;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByUser user profile acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the user profile.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and user profile resource.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param profileId User profile id which uniquely identifies user profile resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user profile resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data  ACL policy object used to delete specified ACL policy resource.
     * @example userProfileACLRoute.deleteByRole.expand({ id: '<profile-id>', accessAction: '<access-action>', role: '<role-name>' });
     **/
    UserProfileACLRoute.prototype.deleteByRole = function (profileId, action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.profileId = profileId;
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    var _a;
    UserProfileACLRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserProfileACLRoute);
    return UserProfileACLRoute;
}(common_1.BaseRoute));
exports.UserProfileACLRoute = UserProfileACLRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileACLClient
 * @description  User Profile ACL Client provides an easy way to consume  User Profile REST API end-points. In order to obtain needed routes `userProfileACLClient` uses `userProfileACLRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var UserProfileACLClient = /** @class */ (function () {
    function UserProfileACLClient(userProfileACLRoute, apiClient) {
        this.userProfileACLRoute = userProfileACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserProfileACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.userProfileACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified user profile resource.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userProfileACLClient.get({id: '<profile-id>'})
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed, this action creates new ACL policy for the specified user profile resource.
     * @method
     * @param options ACL options object.
     * @returns A promise that is resolved once the update acl action has been performed.
     * @example let options = {id : '<profile-id>'};
                let aclObj =  {  actionId: '<action-id'>,  roleId: '<roleId>',  userId: '<userId>' };
                options[baasicConstants.modelPropertyName] = aclObj;
                userProfileACLClient.update(options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and user profile resource.
     * @method
     * @param profileId User profile id which uniquely identifies user profile resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user profile resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL policy object used to delete specified ACL policy resource.
     * @returns A promise that is resolved once the removeByUser action has been performed.
     * @example userProfileACLClient.removeByUser('<profile-id>', '<access-action>', '<username>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileACLClient.prototype.removeByUser = function (profileId, action, user, data) {
        return this.apiClient.delete(this.userProfileACLRoute.deleteByUser(profileId, action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and user profile resource.
     * @method
     * @param profileId User profile id which uniquely identifies user profile resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user profile resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data  ACL policy object used to delete specified ACL policy resource.
     * @returns A promise that is resolved once the removeByRole action has been performed.
     * @example userProfileACLClient.removeByRole('<profile-id>', '<access-action>', '<role-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileACLClient.prototype.removeByRole = function (profileId, action, role, data) {
        return this.apiClient.delete(this.userProfileACLRoute.deleteByRole(profileId, action, role, data));
    };
    var _a, _b;
    UserProfileACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileACLRoute !== "undefined" && _1.UserProfileACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserProfileACLClient);
    return UserProfileACLClient;
}());
exports.UserProfileACLClient = UserProfileACLClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileRoute
 * @description Baasic User Profile Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(9);
var contracts_1 = __webpack_require__(3);
var UserProfileRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileRoute, _super);
    function UserProfileRoute(appOptions, userProfileACLRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.userProfileACLRoute = userProfileACLRoute;
        _this.findRoute = 'profiles/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{id}/{?embed,fields}';
        _this.createRoute = 'profiles';
        _this.updateRoute = 'profiles/{id}';
        _this.deleteRoute = 'profiles/{id}';
        return _this;
    }
    Object.defineProperty(UserProfileRoute.prototype, "acl", {
        get: function () {
            return this.userProfileACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find user profile route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify user profile resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user profile subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user profile property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userProfileRoute.find.({searchQuery: '<search-phrase>'});
     **/
    UserProfileRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User profile id which uniquely identifies user profile resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userProfileRoute.get(id, options);
     **/
    UserProfileRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create user profile route; this URI template does not expose any additional options.
     * @method
     * @example baasicUserProfileRouteService.create();
     **/
    UserProfileRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update user profile route; this URI template does not expose any additional options.
     * @method
     * @param data An user profile object used to update specified user profile resource.
     * @example baasicUserProfileRouteService.update(data);
     **/
    UserProfileRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses update user profile route; this URI template does not expose any additional options.
     * @method
     * @param data An user profile object used to delete specified user profile resource.
     * @example baasicUserProfileRouteService.delete(data);
     **/
    UserProfileRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    UserProfileRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserProfileACLRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.UserProfileACLRoute !== "undefined" && _1.UserProfileACLRoute) === "function" ? _b : Object])
    ], UserProfileRoute);
    return UserProfileRoute;
}(common_1.BaseRoute));
exports.UserProfileRoute = UserProfileRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileClient
 * @description  User Profile Client provides an easy way to consume  User Profile REST API end-points. In order to obtain needed routes `userProfileClient` uses `userProfileRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var UserProfileClient = /** @class */ (function () {
    function UserProfileClient(userProfileACLClient, userProfileRoute, apiClient, userEducationClient, userProfileAvatarClient, userSkillClient, userWorkClient) {
        this.userProfileACLClient = userProfileACLClient;
        this.userProfileRoute = userProfileRoute;
        this.apiClient = apiClient;
        this.userEducationClient = userEducationClient;
        this.userProfileAvatarClient = userProfileAvatarClient;
        this.userSkillClient = userSkillClient;
        this.userWorkClient = userWorkClient;
    }
    Object.defineProperty(UserProfileClient.prototype, "acl", {
        get: function () {
            return this.userProfileACLClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileClient.prototype, "routeDefinition", {
        get: function () {
            return this.userProfileRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileClient.prototype, "education", {
        get: function () {
            return this.userEducationClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileClient.prototype, "avatar", {
        get: function () {
            return this.userProfileAvatarClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileClient.prototype, "skill", {
        get: function () {
            return this.userSkillClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileClient.prototype, "work", {
        get: function () {
            return this.userWorkClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user profile resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example userProfileClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserProfileClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the user profile resource.
     * @method
     * @param id User profile id which uniquely identifies user profile resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userProfileClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userProfileRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user profile action has been performed; this action creates a new user profile resource.
     * @method
     * @param data An user profile object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user profile action has been performed.
     * @example userProfileClient.create({
                    firstName : '<first-name>',
                    lastName : '<last-name>',
                    displayName: '<nick-name>'
                }.then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserProfileClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user profile action has been performed; this action updates a user profile resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userProfileRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(userProfile);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An user profile object used to update specified user profile resource.
     * @returns A promise that is resolved once the update user profile action has been performed.
     * @example // userProfile is a resource previously fetched using get action.
                       userProfile.displayName = '<nick-name>';
                       userProfileClient.update(userProfile)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    UserProfileClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a user profile resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userProfileRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(userProfile);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An user profile object used to delete specified user profile resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // userProfile is a resource previously fetched using get action.
                    userProfileClient.remove(userProfile)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserProfileClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c, _d, _e, _f, _g;
    UserProfileClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileACLClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserProfileRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.UserEducationClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.UserProfileAvatarClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.UserSkillClient)),
        tslib_1.__param(6, inversify_1.inject(_1.TYPES.UserWorkClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileACLClient !== "undefined" && _1.UserProfileACLClient) === "function" ? _a : Object, typeof (_b = typeof _1.UserProfileRoute !== "undefined" && _1.UserProfileRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object, typeof (_d = typeof _1.UserEducationClient !== "undefined" && _1.UserEducationClient) === "function" ? _d : Object, typeof (_e = typeof _1.UserProfileAvatarClient !== "undefined" && _1.UserProfileAvatarClient) === "function" ? _e : Object, typeof (_f = typeof _1.UserSkillClient !== "undefined" && _1.UserSkillClient) === "function" ? _f : Object, typeof (_g = typeof _1.UserWorkClient !== "undefined" && _1.UserWorkClient) === "function" ? _g : Object])
    ], UserProfileClient);
    return UserProfileClient;
}());
exports.UserProfileClient = UserProfileClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userSkillRoute
 * @description Baasic User Skill Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Skill Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var UserSkillRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserSkillRoute, _super);
    function UserSkillRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'profiles/{userId}/skills/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{userId}/skills/{id}/{?embed,fields}';
        _this.createRoute = 'profiles/{userId}/skills';
        _this.updateRoute = 'profiles/{userId}/skills/{id}';
        _this.deleteRoute = 'profiles/{userId}/skills/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user skill properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user skill subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user skill property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userSkillRoute.find({searchQuery: '<search-phrase>'});
     **/
    UserSkillRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User profile id or display name which uniquely identifies user profile whose skill resources need to be retrieved.
     * @param options Query resource options object.
     * @example userSkillRoute.get(id, options);
     **/
    UserSkillRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @param data An user skill object that needs to be inserted into the system.
     * @example userSkillRoute.create(data);
     **/
    UserSkillRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data An user skill object used to update specific user skill resource in the system.
     * @example userSkillRoute.update(data);
     **/
    UserSkillRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this URI template does not expose any additional options.
     * @method
     * @param data An user skill object used to delete specific user skill resource in the system.
     * @example userSkillRoute.delete(data);
     **/
    UserSkillRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    UserSkillRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserSkillRoute);
    return UserSkillRoute;
}(common_1.BaseRoute));
exports.UserSkillRoute = UserSkillRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userSkillClient
 * @description  User Skill Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Skill Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var UserSkillClient = /** @class */ (function () {
    function UserSkillClient(userSkillRoute, apiClient) {
        this.userSkillRoute = userSkillRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserSkillClient.prototype, "routeDefinition", {
        get: function () {
            return this.userSkillRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user skill resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example userSkillClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserSkillClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the user skill resource.
     * @method
     * @param id User profile id or display name which uniquely identifies user profile whose skill resources need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userSkillClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserSkillClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userSkillRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user skill action has been performed; this action creates a new user skill resource.
     * @method
     * @param data An user skill object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user skill action has been performed.
     * @example userSkillClient.create({ skillName : '<skill-name>', userId: '<user-id>' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserSkillClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user skill action has been performed; this action updates a user skill resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userSkillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An user skill object used to update specified user skill resource.
     * @returns A promise that is resolved once the update user skill action has been performed.
     * @example // skill is a resource previously fetched using get action.
                       skill.description = '<description>';
                       userSkillClient.update(skill)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    UserSkillClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a user skill resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userSkillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An user skill object used to delete specific user skill resource in the system.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // skill is a resource previously fetched using get action.
                    userSkillClient.remove(skill)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserSkillClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    UserSkillClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserSkillRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserSkillRoute !== "undefined" && _1.UserSkillRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserSkillClient);
    return UserSkillClient;
}());
exports.UserSkillClient = UserSkillClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userWorkRoute
 * @description Baasic User Work Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Work Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var UserWorkRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserWorkRoute, _super);
    function UserWorkRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'profiles/{userId}/work/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{userId}/work/{id}/{?embed,fields}';
        _this.createRoute = 'profiles/{userId}/work';
        _this.updateRoute = 'profiles/{userId}/work/{id}';
        _this.deleteRoute = 'profiles/{userId}/work/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user work properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user work subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user work property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userWorkRoute.find({searchQuery: '<search-phrase>'});
     **/
    UserWorkRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User work id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userWorkRoute.get(id, options);
     **/
    UserWorkRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @param data An user work object that needs to be inserted into the system.
     * @example userWorkRoute.create(data);
     **/
    UserWorkRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
      * Parses update route; this URI template does not expose any additional options.
      * @method
      * @param data An user work object used to update specified user work resource.
      * @example userWorkRoute.create(data);
      **/
    UserWorkRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    UserWorkRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    UserWorkRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserWorkRoute);
    return UserWorkRoute;
}(common_1.BaseRoute));
exports.UserWorkRoute = UserWorkRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userWorkClient
 * @description  User Work Client provides  route templates which can be expanded to  REST URIs. Various services can use  User Work Route Client to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var UserWorkClient = /** @class */ (function () {
    function UserWorkClient(userWorkRoute, apiClient) {
        this.userWorkRoute = userWorkRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserWorkClient.prototype, "routeDefinition", {
        get: function () {
            return this.userWorkRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user work resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example userWorkClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserWorkClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the user work resource.
     * @method
     * @param id User work id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userWorkClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserWorkClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user work action has been performed; this action creates a new user work resource.
     * @method
     * @param data An user work object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user work action has been performed.
     * @example userWorkClient.create({ companyName : '<company-name>', userId: '<user-id>' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserWorkClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user work action has been performed; this action updates a user work resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userWorkRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(work);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An user work object used to update specified user work resource.
     * @returns A promise that is resolved once the update user work action has been performed.
     * @example // work is a resource previously fetched using get action.
                    work.companyName = '<company-name>';
                    userWorkClient.update(work)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserWorkClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a user work resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userWorkRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(work);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // work is a resource previously fetched using get action.
                       userWorkClient.remove(work)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    UserWorkClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    UserWorkClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserWorkRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserWorkRoute !== "undefined" && _1.UserWorkRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserWorkClient);
    return UserWorkClient;
}());
exports.UserWorkClient = UserWorkClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module LanguageBatchRoute
 * @description Baasic Language Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Language Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var LanguageBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LanguageBatchRoute, _super);
    function LanguageBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'lookups/language/batch';
        _this.updateRoute = 'lookups/language/batch';
        _this.deleteRoute = 'lookups/language/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example languageRoute.create();
     **/
    LanguageBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example languageRoute.update();
     **/
    LanguageBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example languageRoute.remove();
     **/
    LanguageBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    LanguageBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], LanguageBatchRoute);
    return LanguageBatchRoute;
}(common_1.BaseRoute));
exports.LanguageBatchRoute = LanguageBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module languageBatchClient
 * @description  Language Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Language Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var LanguageBatchClient = /** @class */ (function () {
    function LanguageBatchClient(languageBatchRoute, apiClient) {
        this.languageBatchRoute = languageBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(LanguageBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.languageBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create company action has been performed; this action creates new company resources.
     * @method
     * @param data A collection of company objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create company action has been performed.
     * @example  languageBatchClient.create([{
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                 }])
                 .then(function (data) {
                     // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                 });
     **/
    LanguageBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.languageBatchRoute.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update company action has been performed; this action updates specified company resources.
     * @method
     * @param data A collection of company objects used to update specified company resources.
     * @returns A promise that is resolved once the update company action has been performed.
     * @example   languageBatchClient.update(companies)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    LanguageBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.languageBatchRoute.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove company resources from the system if successfully completed.
     * @method
     * @param ids Collection of company ids which uniquely identifies company resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example languageBatchClient.remove(companyIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    LanguageBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.languageBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    LanguageBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LanguageBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LanguageBatchRoute !== "undefined" && _1.LanguageBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], LanguageBatchClient);
    return LanguageBatchClient;
}());
exports.LanguageBatchClient = LanguageBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module languageRoute
 * @description Baasic Language Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Language Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(9);
var contracts_1 = __webpack_require__(3);
var LanguageRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LanguageRoute, _super);
    function LanguageRoute(appOptions, languageBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.languageBatchRoute = languageBatchRoute;
        _this.findRoute = 'lookups/language/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.createRoute = 'lookups/language';
        _this.getRoute = 'lookups/language/{id}/{?embed,fields}';
        _this.updateRoute = 'lookups/language/{id}';
        _this.deleteRoute = 'lookups/language/{id}';
        return _this;
    }
    Object.defineProperty(LanguageRoute.prototype, "batch", {
        get: function () {
            return this.languageBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing company properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain company subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the company property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example languageRoute.find({searchQuery: '<search-phrase>'});
     **/
    LanguageRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example languageRoute.create();
     **/
    LanguageRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id Company id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example languageRoute.get();
     **/
    LanguageRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    LanguageRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    LanguageRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    LanguageRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.LanguageBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.LanguageBatchRoute !== "undefined" && _1.LanguageBatchRoute) === "function" ? _b : Object])
    ], LanguageRoute);
    return LanguageRoute;
}(common_1.BaseRoute));
exports.LanguageRoute = LanguageRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module languageClient
 * @description  Language Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Language Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(9);
var LanguageClient = /** @class */ (function () {
    function LanguageClient(languageBatchClient, languageRoute, apiClient) {
        this.languageBatchClient = languageBatchClient;
        this.languageRoute = languageRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(LanguageClient.prototype, "routeDefinition", {
        get: function () {
            return this.languageRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LanguageClient.prototype, "batch", {
        get: function () {
            return this.languageBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of company resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example languageClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    LanguageClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the company resource.
     * @method
     * @param id Company id which uniquely identifies resource that needs to be retrieved.
     * @returns A promise that is resolved once the get action has been performed.
     * @param options Query resource options object.
     * @example languageClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    LanguageClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.languageRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create company action has been performed; this action creates a new company resource.
     * @method
     * @param data A company object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create company action has been performed.
     * @example languageClient.create({
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    LanguageClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update company action has been performed; this action updates a company resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `companyRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(company);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A company object used to update specified company resource.
     * @returns A promise that is resolved once the update company action has been performed.
     * @example // company is a resource previously fetched using get action.
                    company.description = '<description>';
                    baasicCompanyService.update(company)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    LanguageClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a company resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `companyRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(company);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data A company object used to delete specified company resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // company is a resource previously fetched using get action.
                    languageClient.remove(company)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                    });
     **/
    LanguageClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    LanguageClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LanguageBatchClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.LanguageRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LanguageBatchClient !== "undefined" && _1.LanguageBatchClient) === "function" ? _a : Object, typeof (_b = typeof _1.LanguageRoute !== "undefined" && _1.LanguageRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], LanguageClient);
    return LanguageClient;
}());
exports.LanguageClient = LanguageClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(9);
var inversify_1 = __webpack_require__(1);
var Root = /** @class */ (function () {
    function Root(profile, company, organization, skill, language) {
        this.profile = profile;
        this.company = company;
        this.organization = organization;
        this.skill = skill;
        this.language = language;
    }
    var _a, _b, _c, _d, _e;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CompanyClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.OrganizationClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.SkillClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.LanguageClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileClient !== "undefined" && _1.UserProfileClient) === "function" ? _a : Object, typeof (_b = typeof _1.CompanyClient !== "undefined" && _1.CompanyClient) === "function" ? _b : Object, typeof (_c = typeof _1.OrganizationClient !== "undefined" && _1.OrganizationClient) === "function" ? _c : Object, typeof (_d = typeof _1.SkillClient !== "undefined" && _1.SkillClient) === "function" ? _d : Object, typeof (_e = typeof _1.LanguageClient !== "undefined" && _1.LanguageClient) === "function" ? _e : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;


/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(228), exports);
tslib_1.__exportStar(__webpack_require__(229), exports);
tslib_1.__exportStar(__webpack_require__(230), exports);
tslib_1.__exportStar(__webpack_require__(231), exports);
tslib_1.__exportStar(__webpack_require__(232), exports);
tslib_1.__exportStar(__webpack_require__(233), exports);
tslib_1.__exportStar(__webpack_require__(234), exports);
tslib_1.__exportStar(__webpack_require__(235), exports);
tslib_1.__exportStar(__webpack_require__(236), exports);
tslib_1.__exportStar(__webpack_require__(237), exports);
tslib_1.__exportStar(__webpack_require__(238), exports);
tslib_1.__exportStar(__webpack_require__(239), exports);
tslib_1.__exportStar(__webpack_require__(240), exports);


/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(39);
var TYPES = {
    KeyValueClient: Symbol("KeyValueClient"),
    KeyValueRoute: Symbol("KeyValueRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.KeyValueRoute).to(_1.KeyValueRoute);
    bind(TYPES.KeyValueClient).to(_1.KeyValueClient);
});
exports.diModule = diModule;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module keyValueRoute
 * @description Baasic Key Value Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Key Value Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var KeyValueRoute = /** @class */ (function (_super) {
    tslib_1.__extends(KeyValueRoute, _super);
    function KeyValueRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'key-values/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'key-values/{id}/{?embed,fields}';
        _this.createRoute = 'key-values';
        _this.updateRoute = 'key-values/{id}';
        _this.deleteRoute = 'key-values/{id}';
        return _this;
    }
    /**
     * Parses find key value route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify key value resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain key value subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the key value property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example keyValueRoute.find(options);
     **/
    KeyValueRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get key value route which must be expanded with the Id of the previously created key value resource in the system.
     * @method
     * @param id Key value resource unique identifier.
     * @param options Query resource options object.
     * @example keyValueRoute.get();
     **/
    KeyValueRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create key value route; this URI template does not expose any additional options.
     * @method
     * @example keyValueRoute.create();
     **/
    KeyValueRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update key value route.
     * @method
     * @param data Key Value object used to create update route.
     * @example keyValueRoute.update(data);
     */
    KeyValueRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete key value route.
     * @method
     * @param data Key Value object used to create delete route.
     * @example keyValueRoute.delete(data);
     */
    KeyValueRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    KeyValueRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], KeyValueRoute);
    return KeyValueRoute;
}(common_1.BaseRoute));
exports.KeyValueRoute = KeyValueRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module keyValueClient
 * @description  Key Value Client provides an easy way to consume  Key Value REST API end-points. In order to obtain needed routes `keyValueClient` uses `baasicKeyValueRouteClient`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(39);
var KeyValueClient = /** @class */ (function () {
    function KeyValueClient(keyValueRoute, apiClient) {
        this.keyValueRoute = keyValueRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(KeyValueClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `keyValueRoute`.
         * @method
         * @example keyValueClient.routeDefinition.get();
         **/
        get: function () {
            return this.keyValueRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of key value resources matching the given criteria.
     * @param options query resource options object
     * @returns A promise that is resolved once the find action has beend performed.
     * @method
     * @example keyValueClient.find({
                 pageNumber: 1,
                 pageSize: 10,
                 orderBy: '<field>',
                 orderDirection: '<asc|desc>',
                 search: '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    KeyValueClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified key value resource.
     * @param id unique identifer of key value resources
     * @param options query resource options object
     * @returns A promise that is resolved once the get action has beend performed.
     * @method
     * @example keyValueClient.get('<key-value-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    KeyValueClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.keyValueRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create key value action has been performed; this action creates a new key value resource.
     * @param data A key value object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create key value action has beend performed.
     * @method
     * @example keyValueClient.create({key: '<key>', value: '<value>', })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     */
    KeyValueClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update key value action has been performed; this action updates a key value resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicKeyValueRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(keyValue);
     * let uri = params['model'].links('put').href;
     * ```
     * @param data A key value object used to update specified key value resource.
     * @return A promise that is resolved once the update key value action has been performed.
     * @method
     * @example // keyValue is a resource previously fetched using get action.
                   keyValue.value = '<new-value>';
                   keyValueClient.update(keyValue)
                   .then(function (data) {
                       // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    KeyValueClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a key value resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicKeyValueRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(keyValue);
     * let uri = params['model'].links('delete').href;
     * ```
     * @param data A key value object used to delete specified key value resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example // keyValue is a resource previously fetched using get action.
                    keyValueClient.remove(keyValue)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    KeyValueClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data), this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    KeyValueClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.KeyValueRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.KeyValueRoute !== "undefined" && _1.KeyValueRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], KeyValueClient);
    return KeyValueClient;
}());
exports.KeyValueClient = KeyValueClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(245), exports);


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(29);
var TYPES = {
    ValueSetClient: Symbol("ValueSetClient"),
    ValueSetItemClient: Symbol("ValueSetItemClient"),
    ValueSetItemRoute: Symbol("ValueSetItemRoute"),
    ValueSetRoute: Symbol("ValueSetRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ValueSetItemRoute).to(_1.ValueSetItemRoute);
    bind(TYPES.ValueSetItemClient).to(_1.ValueSetItemClient);
    bind(TYPES.ValueSetRoute).to(_1.ValueSetRoute);
    bind(TYPES.ValueSetClient).to(_1.ValueSetClient);
});
exports.diModule = diModule;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/**
 * @module valueSetItemRoute
 * @description Baasic Value Set Item Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Value Set Item Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var ValueSetItemRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ValueSetItemRoute, _super);
    function ValueSetItemRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'value-sets/{setName}/items/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'value-sets/{setName}/items/{id}/{?embed,fields}';
        _this.createRoute = 'value-sets/{setName}/items/';
        _this.updateRoute = 'value-sets/{setId}/items/{id}';
        _this.deleteRoute = 'value-sets/{setId}/items/{id}';
        return _this;
    }
    /**
     * Parses find value set items route which can be expanded with additional options. Supported items are:
     * - `setName` - Value set name.
     * - `searchQuery` - A string value used to identify value set items using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain value set item subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the value set item property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method items.find
     * @param options Options object.
     * @example valueSetItemRoute.find(options);
     **/
    ValueSetItemRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route which must be expanded with the following items:
     * - `setName` - Value set name.
     * - `id` - Value set item id.
     * @method
     * @param setName Value set name.
     * @param id Value set id.
     * @param options Query resource options object.
     * @example valueSetItemRoute.get(setName, id, options);
     **/
    ValueSetItemRoute.prototype.get = function (setName, id, options) {
        var params = this.utility.extend({}, options);
        params.setName = setName;
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create value set item route; the URI template should be expanded with the value set name.
     * @method
     * @param data A value set item object that needs to be inserted into the system.
     * @example valueSetItemRoute.create(data);
     **/
    ValueSetItemRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update value set item route.
     * @method
     * @param data A value set item object used to update specified value set resource.
     * @example valueSetItemRoute.update(data);
     */
    ValueSetItemRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete value set item route.
     * @method
     * @param data A value set item object used to delete specified value set resource.
     * @example valueSetItemRoute.delete(data);
     */
    ValueSetItemRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    ValueSetItemRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ValueSetItemRoute);
    return ValueSetItemRoute;
}(common_1.BaseRoute));
exports.ValueSetItemRoute = ValueSetItemRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/**
 * @module valueSetItemClient
 * @description  Value Set Item Client provides an easy way to consume  Value Set Item REST end-points. In order to obtain needed routes `valueSetItemClient` uses `valueSetItemRoute`.
 */
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(29);
var ValueSetItemClient = /** @class */ (function () {
    function ValueSetItemClient(valueSetItemRoute, apiClient) {
        this.valueSetItemRoute = valueSetItemRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ValueSetItemClient.prototype, "routeDefinition", {
        get: function () {
            return this.valueSetItemRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of value set item resources matching given criteria.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @method items.find
     * @example valueSetItemClient.find({
                    setName: '<value-set-name>',
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>' })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ValueSetItemClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified value set item resource.
     * @param setName value set name
     * @param id unique identifier of value set resource
     * @param options query resource options object
     * @returns A promise that is resolved once the get action has been performed.
     * @method items.get
     * @example valueSetItemClient.get('<value-set-name>', '<set-item-id>')
                   .then(function (data) {
                        // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ValueSetItemClient.prototype.get = function (setName, id, options) {
        return this.apiClient.get(this.valueSetItemRoute.get(setName, id, options));
    };
    /**
     * Returns a promise that is resolved once the create value set item action has been performed; this action creates a new value set item resource.
     * @method
     * @param data A value set item object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create value set item action has been performed.
     * @example valueSetItemClient.create({
                    setId: '<value-set-id>',
                    value: '<value>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ValueSetItemClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update value set item action has been performed; this action updates a value set item resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `valueSetClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(valueSetItem);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A value set item object used to update specified value set resource.
     * @returns A promise that is resolved once the update value set item action has been performed.
     * @example // valueSetItem is a resource previously fetched using get action.
                valueSetItem.value = '<new-value>';
                valueSetItemClient.update(valueSetItem)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ValueSetItemClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will delete a value set item if the action is completed successfully. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `valueSetClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(valueSetItem);
     * let uri = params['model'].links('delete').href;
     * ```
     * @param data A value set item object used to delete specified value set resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example // valueSetItem is a resource previously fetched using get action.
                valueSetItemClient.remove(valueSetItem)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ValueSetItemClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    ValueSetItemClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ValueSetItemRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ValueSetItemRoute !== "undefined" && _1.ValueSetItemRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ValueSetItemClient);
    return ValueSetItemClient;
}());
exports.ValueSetItemClient = ValueSetItemClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module valueSetRoute
 * @description Baasic Value Set Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Value Set Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(29);
var contracts_1 = __webpack_require__(3);
var ValueSetRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ValueSetRoute, _super);
    function ValueSetRoute(appOptions, valueSetItemRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.valueSetItemRoute = valueSetItemRoute;
        _this.findRoute = 'value-sets/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'value-sets/{setName}/{?embed,fields}';
        _this.createRoute = 'value-sets';
        _this.updateRoute = 'value-sets/{id}';
        _this.deleteRoute = 'value-sets/{id}';
        return _this;
    }
    Object.defineProperty(ValueSetRoute.prototype, "items", {
        get: function () {
            return this.valueSetItemRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find value set route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify value set resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain value set subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the value set property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example valueSetRoute.find(options);
     **/
    ValueSetRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get value set route which must be expanded with the name of the previously created value set resource in the system.
     * @method
     * @param setName Value Set name.
     * @param options Query resource options object.
     * @example valueSetRoute.get(setName, options);
     **/
    ValueSetRoute.prototype.get = function (setName, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, setName, options, 'setName');
    };
    /**
     * Parses create value set route; this URI template does not expose any additional options.
     * @method
     * @example valueSetRoute.create();
     **/
    ValueSetRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update value set route.
     * @method
     * @param data Value set object used to update specified value set resource.
     * @example valueSetRoute.update(data);
     */
    ValueSetRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete value set route.
     * @method
     * @param data A value set object used to delete specified value set resource.
     * @example valueSetRoute.delete(data);
     */
    ValueSetRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    ValueSetRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ValueSetItemRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.ValueSetItemRoute !== "undefined" && _1.ValueSetItemRoute) === "function" ? _b : Object])
    ], ValueSetRoute);
    return ValueSetRoute;
}(common_1.BaseRoute));
exports.ValueSetRoute = ValueSetRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module valueSetClient
 * @description  Value Set Client provides an easy way to consume Baasic Value Set REST end-points. In order to obtain needed routes `baasicValueSetService` uses `baasicValueSetRouteService`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(29);
var ValueSetClient = /** @class */ (function () {
    function ValueSetClient(valueSetRoute, valueSetItemClient, apiClient) {
        this.valueSetRoute = valueSetRoute;
        this.valueSetItemClient = valueSetItemClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ValueSetClient.prototype, "items", {
        get: function () {
            return this.valueSetItemClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValueSetClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `valueSetRoute`.
         * @method
         * @example valueSetClient.routeDefinition.get().expand(expandObject);
        **/
        get: function () {
            return this.valueSetRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of value set resources matching given criteria.
     * @param options query resource options object
     * @returns A promise that is resolved once the find action has beend performed.
     * @method
     * @example valueSetClient.find({
                    pageNumber: 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ValueSetClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified value set resource.
     * @param setName value set name
     * @param options query resource options object
     * @returns A promise that is resolved once the get action has been performed.
     * @method
     * @example valueSetClient.get('<value-set-name>')
                   .success(function (data) {
                       // perform success action here
                   })
                   .error(function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ValueSetClient.prototype.get = function (setName, options) {
        return this.apiClient.get(this.valueSetRoute.get(setName, options));
    };
    /**
     * Returns a promise that is resolved once the create value set action has been performed; this action creates a new value set resource.
     * @param data A key value object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create value set action has beend performed.
     * @method
     * @example valueSetClient.create({
                    name: '<value-set-name>',
                    description: '<description>',
                    values: [{value: '<value>'}]
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ValueSetClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update value set action has been performed; this action updates a value set resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicValueSetService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(valueSet);
     * let uri = params['model'].links('put').href;
     * ```
     * @param data Value set object used to update specified value set resource.
     * @returns A promise that is resolved once the update value set action has been performed.
     * @method
     * @example // valueSet is a resource previously fetched using get action.
                    valueSet.name = '<new-name>';
                    valueSetClient.update(valueSet)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ValueSetClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will delete a value set resource if the action is completed successfully. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `valueSetClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(valueSet);
     * let uri = params['model'].links('delete').href;
     * ```
     * @param data A value set object used to delete specified value set resource.
     * @method
     * @example // valueSet is a resource previously fetched using get action.
                    valueSetClient.remove(valueSet)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ValueSetClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    ValueSetClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ValueSetRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ValueSetItemClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ValueSetRoute !== "undefined" && _1.ValueSetRoute) === "function" ? _a : Object, typeof (_b = typeof _1.ValueSetItemClient !== "undefined" && _1.ValueSetItemClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], ValueSetClient);
    return ValueSetClient;
}());
exports.ValueSetClient = ValueSetClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(252), exports);
tslib_1.__exportStar(__webpack_require__(253), exports);


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(6);
var TYPES = {
    ArticleCommentRepliesClient: Symbol("ArticleCommentRepliesClient"),
    ArticleCommentRepliesRoute: Symbol("ArticleCommentRepliesRoute"),
    ArticleCommentsClient: Symbol("ArticleCommentsClient"),
    ArticleCommentsRoute: Symbol("ArticleCommentsRoute"),
    ArticleFilesClient: Symbol("ArticleFilesClient"),
    ArticleFilesRoute: Symbol("ArticleFilesRoute"),
    ArticleFilesBatchClient: Symbol("ArticleFilesBatchClient"),
    ArticleFilesBatchRoute: Symbol("ArticleFilesBatchRoute"),
    ArticleFilesStreamsClient: Symbol("ArticleFilesStreamsClient"),
    ArticleFilesStreamsRoute: Symbol("ArticleFilesStreamsRoute"),
    ArticleRatingsClient: Symbol("ArticleRatingsClient"),
    ArticleRatingsRoute: Symbol("ArticleRatingsRoute"),
    ArticleClient: Symbol("ArticleClient"),
    ArticleRoute: Symbol("ArticleRoute"),
    ArticleSettingsClient: Symbol("ArticleSettingsClient"),
    ArticleSettingsRoute: Symbol("ArticleSettingsRoute"),
    ArticleTagsClient: Symbol("ArticleTagsClient"),
    ArticleTagsRoute: Symbol("ArticleTagsRoute"),
    ArticleTagsSubscriptionsClient: Symbol("ArticleTagsSubscriptionsClient"),
    ArticleTagsSubscriptionsRoute: Symbol("ArticleTagsSubscriptionsRoute"),
    ArticleSubscriptionsArticleRoute: Symbol("ArticleSubscriptionsArticleRoute"),
    ArticleSubscriptionsCommentReportedRoute: Symbol("ArticleSubscriptionsCommentReportedRoute"),
    ArticleSubscriptionsCommentRequiresModerationRoute: Symbol("ArticleSubscriptionsCommentRequiresModerationRoute"),
    ArticleSubscriptionsRoute: Symbol("ArticleSubscriptionsRoute"),
    ArticleSubscriptionsClient: Symbol("ArticleSubscriptionsClient"),
    ArticleSubscriptionsArticleClient: Symbol("ArticleSubscriptionsArticleClient"),
    ArticleSubscriptionsCommentReportedClient: Symbol("ArticleSubscriptionsCommentReportedClient"),
    ArticleSubscriptionsCommentRequiresModerationClient: Symbol("ArticleSubscriptionsCommentRequiresModerationClient"),
    ArticleInstanceSubscriptionsClient: Symbol("ArticleInstanceSubscriptionsClient"),
    ArticleInstanceSubscriptionsRoute: Symbol("ArticleInstanceSubscriptionsRoute"),
    ArticleInstanceRatingsRoute: Symbol("ArticleInstanceRatingsRoute"),
    ArticleInstanceRatingsClient: Symbol("ArticleInstanceRatingsClient"),
    ArticleInstanceTagsRoute: Symbol("ArticleInstanceTagsRoute"),
    ArticleInstanceTagsClient: Symbol("ArticleInstanceTagsClient"),
    ArticleInstanceCommentsRoute: Symbol("ArticleInstanceCommentsRoute"),
    ArticleInstanceCommentsClient: Symbol("ArticleInstanceCommentsClient"),
    ArticleInstanceCommentRepliesRoute: Symbol("ArticleInstanceCommentRepliesRoute"),
    ArticleInstanceCommentRepliesClient: Symbol("ArticleInstanceCommentRepliesClient"),
    ArticleInstanceFilesRoute: Symbol("ArticleInstanceFilesRoute"),
    ArticleInstanceFilesClient: Symbol("ArticleInstanceFilesClient"),
    ArticleInstanceFilesStreamsRoute: Symbol("ArticleInstanceFilesStreamsRoute"),
    ArticleInstanceFilesStreamsClient: Symbol("ArticleInstanceFilesStreamsClient"),
    ArticleInstanceFilesBatchRoute: Symbol("ArticleInstanceFilesBatchRoute"),
    ArticleInstanceFilesBatchClient: Symbol("ArticleInstanceFilesBatchClient"),
    ArticleACLRoute: Symbol(" ArticleACLRoute"),
    ArticleACLClient: Symbol("ArticleACLClient"),
    Root: Symbol("Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ArticleCommentRepliesRoute).to(_1.ArticleCommentRepliesRoute);
    bind(TYPES.ArticleCommentRepliesClient).to(_1.ArticleCommentRepliesClient);
    bind(TYPES.ArticleCommentsRoute).to(_1.ArticleCommentsRoute);
    bind(TYPES.ArticleCommentsClient).to(_1.ArticleCommentsClient);
    bind(TYPES.ArticleFilesBatchRoute).to(_1.ArticleFilesBatchRoute);
    bind(TYPES.ArticleFilesBatchClient).to(_1.ArticleFilesBatchClient);
    bind(TYPES.ArticleFilesStreamsRoute).to(_1.ArticleFilesStreamsRoute);
    bind(TYPES.ArticleFilesStreamsClient).to(_1.ArticleFilesStreamsClient);
    bind(TYPES.ArticleFilesRoute).to(_1.ArticleFilesRoute);
    bind(TYPES.ArticleFilesClient).to(_1.ArticleFilesClient);
    bind(TYPES.ArticleRatingsRoute).to(_1.ArticleRatingsRoute);
    bind(TYPES.ArticleRatingsClient).to(_1.ArticleRatingsClient);
    bind(TYPES.ArticleSettingsRoute).to(_1.ArticleSettingsRoute);
    bind(TYPES.ArticleSettingsClient).to(_1.ArticleSettingsClient);
    bind(TYPES.ArticleTagsSubscriptionsRoute).to(_1.ArticleTagsSubscriptionsRoute);
    bind(TYPES.ArticleTagsSubscriptionsClient).to(_1.ArticleTagsSubscriptionsClient);
    bind(TYPES.ArticleTagsRoute).to(_1.ArticleTagsRoute);
    bind(TYPES.ArticleTagsClient).to(_1.ArticleTagsClient);
    bind(TYPES.ArticleSubscriptionsArticleRoute).to(_1.ArticleSubscriptionsArticleRoute);
    bind(TYPES.ArticleSubscriptionsCommentReportedRoute).to(_1.ArticleSubscriptionsCommentReportedRoute);
    bind(TYPES.ArticleSubscriptionsCommentRequiresModerationRoute).to(_1.ArticleSubscriptionsCommentRequiresModerationRoute);
    bind(TYPES.ArticleSubscriptionsRoute).to(_1.ArticleSubscriptionsRoute);
    bind(TYPES.ArticleSubscriptionsArticleClient).to(_1.ArticleSubscriptionsArticleClient);
    bind(TYPES.ArticleSubscriptionsCommentReportedClient).to(_1.ArticleSubscriptionsCommentReportedClient);
    bind(TYPES.ArticleSubscriptionsCommentRequiresModerationClient).to(_1.ArticleSubscriptionsCommentRequiresModerationClient);
    bind(TYPES.ArticleSubscriptionsClient).to(_1.ArticleSubscriptionsClient);
    bind(TYPES.ArticleInstanceRatingsRoute).to(_1.ArticleInstanceRatingsRoute);
    bind(TYPES.ArticleInstanceRatingsClient).to(_1.ArticleInstanceRatingsClient);
    bind(TYPES.ArticleInstanceTagsRoute).to(_1.ArticleInstanceTagsRoute);
    bind(TYPES.ArticleInstanceTagsClient).to(_1.ArticleInstanceTagsClient);
    bind(TYPES.ArticleInstanceCommentsRoute).to(_1.ArticleInstanceCommentsRoute);
    bind(TYPES.ArticleInstanceCommentsClient).to(_1.ArticleInstanceCommentsClient);
    bind(TYPES.ArticleInstanceCommentRepliesRoute).to(_1.ArticleInstanceCommentRepliesRoute);
    bind(TYPES.ArticleInstanceCommentRepliesClient).to(_1.ArticleInstanceCommentRepliesClient);
    bind(TYPES.ArticleInstanceFilesRoute).to(_1.ArticleInstanceFilesRoute);
    bind(TYPES.ArticleInstanceFilesClient).to(_1.ArticleInstanceFilesClient);
    bind(TYPES.ArticleInstanceFilesStreamsRoute).to(_1.ArticleInstanceFilesStreamsRoute);
    bind(TYPES.ArticleInstanceFilesStreamsClient).to(_1.ArticleInstanceFilesStreamsClient);
    bind(TYPES.ArticleInstanceFilesBatchRoute).to(_1.ArticleInstanceFilesBatchRoute);
    bind(TYPES.ArticleInstanceFilesBatchClient).to(_1.ArticleInstanceFilesBatchClient);
    bind(TYPES.ArticleInstanceSubscriptionsClient).to(_1.ArticleInstanceSubscriptionsClient);
    bind(TYPES.ArticleInstanceSubscriptionsRoute).to(_1.ArticleInstanceSubscriptionsRoute);
    bind(TYPES.ArticleACLRoute).to(_1.ArticleACLRoute);
    bind(TYPES.ArticleACLClient).to(_1.ArticleACLClient);
    bind(TYPES.ArticleRoute).to(_1.ArticleRoute);
    bind(TYPES.ArticleClient).to(_1.ArticleClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ArticleStatus = {
    none: 0,
    published: 2,
    draft: 1,
    archive: 4
};
exports.ArticleStatus = ArticleStatus;
var CommentStatus = {
    approved: 1,
    spam: 2,
    reported: 4,
    flagged: 8,
    unapproved: 16
};
exports.CommentStatus = CommentStatus;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(257), exports);
tslib_1.__exportStar(__webpack_require__(258), exports);
tslib_1.__exportStar(__webpack_require__(259), exports);
tslib_1.__exportStar(__webpack_require__(260), exports);
tslib_1.__exportStar(__webpack_require__(261), exports);
tslib_1.__exportStar(__webpack_require__(262), exports);
tslib_1.__exportStar(__webpack_require__(263), exports);
tslib_1.__exportStar(__webpack_require__(264), exports);
tslib_1.__exportStar(__webpack_require__(265), exports);
tslib_1.__exportStar(__webpack_require__(266), exports);
tslib_1.__exportStar(__webpack_require__(267), exports);
tslib_1.__exportStar(__webpack_require__(268), exports);
tslib_1.__exportStar(__webpack_require__(269), exports);
tslib_1.__exportStar(__webpack_require__(270), exports);
tslib_1.__exportStar(__webpack_require__(271), exports);


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var BaasicArticleUtility = /** @class */ (function () {
    function BaasicArticleUtility() {
        this.utility = new common_1.Utility();
    }
    BaasicArticleUtility.prototype.replaceDiacritics = function (str) {
        for (var letter in common_1.ALPHABET) {
            str = str.replace(common_1.ALPHABET[letter], letter);
        }
        return str;
    };
    BaasicArticleUtility.prototype.toSlug = function (str) {
        if (this.utility.isUndefined(str) || str === null || str === '') {
            return str;
        }
        str = this.replaceDiacritics(str);
        str = str.toLowerCase();
        str = str.replace(/[^a-z0-9]+/g, '-');
        str = str.replace(/^-|-$/g, '');
        return str;
    };
    BaasicArticleUtility.prototype.updateSlug = function (resource) {
        var newSlug = this.toSlug(resource.slug);
        if (this.utility.isUndefined(newSlug) || newSlug === null || newSlug === '') {
            newSlug = this.toSlug(resource.title);
        }
        if (!this.utility.isUndefined(newSlug) || newSlug !== null || newSlug !== '') {
            if (resource.slug !== newSlug) {
                resource.slug = newSlug;
            }
        }
    };
    return BaasicArticleUtility;
}());
exports.BaasicArticleUtility = BaasicArticleUtility;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(274), exports);
tslib_1.__exportStar(__webpack_require__(275), exports);
tslib_1.__exportStar(__webpack_require__(276), exports);
tslib_1.__exportStar(__webpack_require__(277), exports);
tslib_1.__exportStar(__webpack_require__(278), exports);
tslib_1.__exportStar(__webpack_require__(279), exports);
tslib_1.__exportStar(__webpack_require__(280), exports);
tslib_1.__exportStar(__webpack_require__(281), exports);


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSubscriptionsArticleRoute
 * @description Baasic Article Subscriptions Article Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Subscriptions Article Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ArticleSubscriptionsArticleRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleSubscriptionsArticleRoute, _super);
    function ArticleSubscriptionsArticleRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.subscribeRoute = 'articles/{articleId}/subscriptions';
        _this.isSubscribedRoute = 'articles/{articleId}/subscriptions/{subscriberId}';
        _this.unSubscribeRoute = 'articles/{articleId}/subscriptions';
        return _this;
    }
    /**
     * Parses article subscribe route which must be expanded with id of the article.
     * @method
     * @param article The article identifier.
     * @param data The subscribe information.
     * @example articleSubscriptionsArticleRoute.subscribe({id: '<article-id>'});
     **/
    ArticleSubscriptionsArticleRoute.prototype.subscribe = function (article, data) {
        var params = this.utility.extend(article, data);
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, params);
    };
    /**
     * Parses article isSubscribed route which must be expanded with subscriber Id and the id of the article.
     * @method
     * @param article The article identifier.
     * @param data The subscriber identifier.
     * @example articleRoute.subscriptions.article.isSubscribed.expand({id: '<article-id>', subscriberId: '<subscriber-id>' });
     **/
    ArticleSubscriptionsArticleRoute.prototype.isSubscribed = function (article, data) {
        var params = this.utility.extend(article, data);
        return _super.prototype.baseCreate.call(this, this.isSubscribedRoute, params);
    };
    /**
     * Parses article unSubscribe route which must be expanded with the id of the article.
     * @method
     * @param article The article identifier.
     * @param data The unsubscribe information.
     * @example articleSubscriptionsArticleRoute.unSubscribe({id: '<article-id>'});
     **/
    ArticleSubscriptionsArticleRoute.prototype.unSubscribe = function (article, data) {
        var params = this.utility.extend(article, data);
        return _super.prototype.baseCreate.call(this, this.unSubscribeRoute, params);
    };
    ArticleSubscriptionsArticleRoute.prototype.subscribeParams = function (article, data) {
        return this.utility.extend(article, data);
    };
    var _a;
    ArticleSubscriptionsArticleRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleSubscriptionsArticleRoute);
    return ArticleSubscriptionsArticleRoute;
}(common_1.BaseRoute));
exports.ArticleSubscriptionsArticleRoute = ArticleSubscriptionsArticleRoute;


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSubscriptionsCommentReportedRoute
 * @description Baasic Article Subscriptions Comment Reported Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Subscriptions Comment Reported Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ArticleSubscriptionsCommentReportedRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleSubscriptionsCommentReportedRoute, _super);
    function ArticleSubscriptionsCommentReportedRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.subscribeRoute = 'articles/subscriptions/comment-reported';
        _this.isSubscribedRoute = 'articles/subscriptions/comment-reported/{subscriberId}';
        _this.unSubscribeRoute = 'articles/subscriptions/comment-reported';
        return _this;
    }
    /**
     * Parses commentReported subscribe route which doesn't support any additional options.
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsCommentReportedRoute.subscribe(data);
     **/
    ArticleSubscriptionsCommentReportedRoute.prototype.subscribe = function (data) {
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, data);
    };
    /**
     * Parses commentReported isSubscribed route which must be expanded with subscriber Id.
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsCommentReportedRoute.isSubscribed({subscriberId: '<subscriber-id>'});
     **/
    ArticleSubscriptionsCommentReportedRoute.prototype.isSubscribed = function (data) {
        return _super.prototype.baseCreate.call(this, this.isSubscribedRoute, data);
    };
    /**
     * Parses commentReported unSubscribe route which doesn't support any additional options.
     * @method
     * @param data The unsubscribe information.
     * @example articleSubscriptionsCommentReportedRoute.unSubscribe(data);
     **/
    ArticleSubscriptionsCommentReportedRoute.prototype.unSubscribe = function (data) {
        return _super.prototype.baseCreate.call(this, this.unSubscribeRoute, data);
    };
    var _a;
    ArticleSubscriptionsCommentReportedRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleSubscriptionsCommentReportedRoute);
    return ArticleSubscriptionsCommentReportedRoute;
}(common_1.BaseRoute));
exports.ArticleSubscriptionsCommentReportedRoute = ArticleSubscriptionsCommentReportedRoute;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSubscriptionsCommentRequiresModerationRoute
 * @description Baasic Article Subscriptions Comment Requires Moderation Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Subscriptions Comment Requires Moderation Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ArticleSubscriptionsCommentRequiresModerationRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleSubscriptionsCommentRequiresModerationRoute, _super);
    function ArticleSubscriptionsCommentRequiresModerationRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.subscribeRoute = 'articles/subscriptions/comment-requires-moderation';
        _this.isSubscribedRoute = 'articles/subscriptions/comment-requires-moderation/{subscriberId}';
        _this.unSubscribeRoute = 'articles/subscriptions/comment-requires-moderation';
        return _this;
    }
    /**
     * Parses commentRequiresModeration subscribe route which doesn't support any additional options.
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsCommentRequiresModerationRoute.subscribe(data);
     **/
    ArticleSubscriptionsCommentRequiresModerationRoute.prototype.subscribe = function (data) {
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, data);
    };
    /**
     * Parses commentRequiresModeration isSubscribed route which must be expanded with subscriber Id.
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsCommentRequiresModerationRoute.isSubscribed({subscriberId: '<subscriber-id>'});
     **/
    ArticleSubscriptionsCommentRequiresModerationRoute.prototype.isSubscribed = function (data) {
        return _super.prototype.baseCreate.call(this, this.isSubscribedRoute, data);
    };
    /**
     * Parses commentRequiresModeration unSubscribe route which doesn't support any additional options.
     * @method
     * @param data The unsubscribe information.
     * @example articleSubscriptionsCommentRequiresModerationRoute.unSubscribe(data)
     **/
    ArticleSubscriptionsCommentRequiresModerationRoute.prototype.unSubscribe = function (data) {
        return _super.prototype.baseCreate.call(this, this.unSubscribeRoute, data);
    };
    var _a;
    ArticleSubscriptionsCommentRequiresModerationRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleSubscriptionsCommentRequiresModerationRoute);
    return ArticleSubscriptionsCommentRequiresModerationRoute;
}(common_1.BaseRoute));
exports.ArticleSubscriptionsCommentRequiresModerationRoute = ArticleSubscriptionsCommentRequiresModerationRoute;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSubscriptionsRoute
 * @description Baasic Article Subscriptions Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Subscriptions Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(6);
var ArticleInstanceSubscriptionsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceSubscriptionsRoute, _super);
    function ArticleInstanceSubscriptionsRoute(articleSubscriptionsCommentReportedRoute, articleSubscriptionsArticleRoute, articleSubscriptionsCommentRequiresModerationRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.articleSubscriptionsCommentReportedRoute = articleSubscriptionsCommentReportedRoute;
        _this.articleSubscriptionsArticleRoute = articleSubscriptionsArticleRoute;
        _this.articleSubscriptionsCommentRequiresModerationRoute = articleSubscriptionsCommentRequiresModerationRoute;
        _this.appOptions = appOptions;
        return _this;
    }
    Object.defineProperty(ArticleInstanceSubscriptionsRoute.prototype, "commentReported", {
        get: function () {
            return this.articleSubscriptionsCommentReportedRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceSubscriptionsRoute.prototype, "article", {
        get: function () {
            return this.articleSubscriptionsArticleRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceSubscriptionsRoute.prototype, "commentRequiresModeration", {
        get: function () {
            return this.articleSubscriptionsCommentRequiresModerationRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c, _d;
    ArticleInstanceSubscriptionsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentReportedRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.ArticleSubscriptionsArticleRoute)),
        tslib_1.__param(2, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentRequiresModerationRoute)),
        tslib_1.__param(3, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleSubscriptionsCommentReportedRoute !== "undefined" && __1.ArticleSubscriptionsCommentReportedRoute) === "function" ? _a : Object, typeof (_b = typeof __1.ArticleSubscriptionsArticleRoute !== "undefined" && __1.ArticleSubscriptionsArticleRoute) === "function" ? _b : Object, typeof (_c = typeof __1.ArticleSubscriptionsCommentRequiresModerationRoute !== "undefined" && __1.ArticleSubscriptionsCommentRequiresModerationRoute) === "function" ? _c : Object, typeof (_d = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _d : Object])
    ], ArticleInstanceSubscriptionsRoute);
    return ArticleInstanceSubscriptionsRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceSubscriptionsRoute = ArticleInstanceSubscriptionsRoute;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSubscriptionsArticleClient
 * @description  Article Subscriptions Article Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleSubscriptionsArticleClient` uses `articleSubscriptionsArticleRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(6);
var ArticleSubscriptionsArticleClient = /** @class */ (function () {
    function ArticleSubscriptionsArticleClient(articleSubscriptionsArticleRoute, apiClient) {
        this.articleSubscriptionsArticleRoute = articleSubscriptionsArticleRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleSubscriptionsArticleClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleSubscriptionsArticleRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the subscribe action has been performed. This action subscribes an user to the specified article.
     * @method
     * @param article The article identifier.
     * @param data The subscribe information.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example articleSubscriptionsArticleClient.subscribe(article, user)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsArticleClient.prototype.subscribe = function (article, data) {
        return this.apiClient.post(this.routeDefinition.subscribe(article, data), this.routeDefinition.subscribeParams(article, data));
    };
    /**
     * Returns a promise that is resolved once the isSubscribed action has been performed. This action checks if a user is subscribed to the specified article.
     * @method
     * @param article The article identifier.
     * @param data The subscriber identifier.
     * @returns A promise that is resolved once the isSubscribed action has been performed.
     * @example articleSubscriptionsArticleClient.subscribe(article, user)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsArticleClient.prototype.isSubscribed = function (article, data) {
        return this.apiClient.get(this.articleSubscriptionsArticleRoute.isSubscribed(article, data));
    };
    /**
     * Returns a promise that is resolved once the unSubscribe action has been performed. This action unsubscribes a user from the specified article.
     * @method
     * @param article The article identifier.
     * @param data The unsubscribe information.
     * @returns A promise that is resolved once the unSubscribe action has been performed.
     * @example articleSubscriptionsArticleClient.subscribe(article, user)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsArticleClient.prototype.unSubscribe = function (article, data) {
        return this.apiClient.delete(this.articleSubscriptionsArticleRoute.unSubscribe(article, data));
    };
    var _a, _b;
    ArticleSubscriptionsArticleClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleSubscriptionsArticleRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleSubscriptionsArticleRoute !== "undefined" && __1.ArticleSubscriptionsArticleRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleSubscriptionsArticleClient);
    return ArticleSubscriptionsArticleClient;
}());
exports.ArticleSubscriptionsArticleClient = ArticleSubscriptionsArticleClient;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSubscriptionsCommentReportedClient
 * @description  Article Subscriptions Comment Reported Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleSubscriptionsCommentReportedClient` uses `articleSubscriptionsCommentReportedRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(6);
var ArticleSubscriptionsCommentReportedClient = /** @class */ (function () {
    function ArticleSubscriptionsCommentReportedClient(articleSubscriptionsCommentReportedRoute, apiClient) {
        this.articleSubscriptionsCommentReportedRoute = articleSubscriptionsCommentReportedRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleSubscriptionsCommentReportedClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleSubscriptionsCommentReportedRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Subscribes user to article comment reported updates. Returns a promise that is resolved once the subscribe action has been performed.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example articleSubscriptionsCommentReportedClient.subscribe(data)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsCommentReportedClient.prototype.subscribe = function (data) {
        return this.apiClient.post(this.articleSubscriptionsCommentReportedRoute.subscribe(data), data);
    };
    /**
     * Determines whether user is subscribed to article comment reported updates. Returns a promise that is resolved once the isSubscribed action has been performed.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the isSubscribed action has been performed.
     * @example articleSubscriptionsCommentReportedClient.isSubscribed(data)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsCommentReportedClient.prototype.isSubscribed = function (data) {
        return this.apiClient.get(this.routeDefinition.isSubscribed(data));
    };
    /**
     * Unsubscribe user from article comment reported updates. Returns a promise that is commentReported once the unSubscribe action has been performed.
     * @method
     * @param data The unsubscribe information.
     * @returns A promise that is commentReported once the unSubscribe action has been performed.
     * @example articleSubscriptionsCommentReportedClient.isSubscribed(data)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsCommentReportedClient.prototype.unSubscribe = function (data) {
        return this.apiClient.delete(this.articleSubscriptionsCommentReportedRoute.unSubscribe(data), undefined, data);
    };
    var _a, _b;
    ArticleSubscriptionsCommentReportedClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentReportedRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleSubscriptionsCommentReportedRoute !== "undefined" && __1.ArticleSubscriptionsCommentReportedRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleSubscriptionsCommentReportedClient);
    return ArticleSubscriptionsCommentReportedClient;
}());
exports.ArticleSubscriptionsCommentReportedClient = ArticleSubscriptionsCommentReportedClient;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSubscriptionsCommentRequiresModerationClient
 * @description  Article Subscriptions Comment Requires Moderation Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleSubscriptionsCommentRequiresModerationClient` uses `articleSubscriptionsCommentRequiresModerationRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(6);
var ArticleSubscriptionsCommentRequiresModerationClient = /** @class */ (function () {
    function ArticleSubscriptionsCommentRequiresModerationClient(articleSubscriptionsCommentRequiresModerationRoute, apiClient) {
        this.articleSubscriptionsCommentRequiresModerationRoute = articleSubscriptionsCommentRequiresModerationRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleSubscriptionsCommentRequiresModerationClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleSubscriptionsCommentRequiresModerationRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Subscribes user to article comment requires moderation updates. Returns a promise that is resolved once the subscribe action has been performed.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example articleCommentRequiresModerationClient.subscribe(data)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsCommentRequiresModerationClient.prototype.subscribe = function (data) {
        return this.apiClient.post(this.articleSubscriptionsCommentRequiresModerationRoute.subscribe(data), data);
    };
    /**
     * Determines whether user is subscribed to article comment requires moderation updates. Returns a promise that is resolved once the isSubscribed action has been performed.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the isSubscribed action has been performed.
     * @example articleCommentRequiresModerationClient.isSubscribed(data)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsCommentRequiresModerationClient.prototype.isSubscribed = function (data) {
        return this.apiClient.get(this.routeDefinition.isSubscribed(data));
    };
    /**
     * Unsubscribe user from article comment requires moderation updates. Returns a promise that is commentReported once the unSubscribe action has been performed.
     * @method
     * @param data The unsubscribe information.
     * @returns A promise that is commentReported once the unSubscribe action has been performed.
     * @example articleCommentRequiresModerationClient.unSubscribed(data)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleSubscriptionsCommentRequiresModerationClient.prototype.unSubscribed = function (data) {
        return this.apiClient.delete(this.routeDefinition.unSubscribe(data));
    };
    var _a, _b;
    ArticleSubscriptionsCommentRequiresModerationClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentRequiresModerationRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleSubscriptionsCommentRequiresModerationRoute !== "undefined" && __1.ArticleSubscriptionsCommentRequiresModerationRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleSubscriptionsCommentRequiresModerationClient);
    return ArticleSubscriptionsCommentRequiresModerationClient;
}());
exports.ArticleSubscriptionsCommentRequiresModerationClient = ArticleSubscriptionsCommentRequiresModerationClient;


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSubscriptionsClient
 * @description  Articles Subscriptions Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleSubscriptionsClient` uses `articleSubscriptionsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var __1 = __webpack_require__(6);
var ArticleInstanceSubscriptionsClient = /** @class */ (function () {
    function ArticleInstanceSubscriptionsClient(articleSubscriptionsCommentReportedClient, articleSubscriptionsArticleClient, articleSubscriptionsCommentRequiresModerationClient, articleInstanceSubscriptionsRoute) {
        this.articleSubscriptionsCommentReportedClient = articleSubscriptionsCommentReportedClient;
        this.articleSubscriptionsArticleClient = articleSubscriptionsArticleClient;
        this.articleSubscriptionsCommentRequiresModerationClient = articleSubscriptionsCommentRequiresModerationClient;
        this.articleInstanceSubscriptionsRoute = articleInstanceSubscriptionsRoute;
    }
    Object.defineProperty(ArticleInstanceSubscriptionsClient.prototype, "commentReported", {
        get: function () {
            return this.articleSubscriptionsCommentReportedClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceSubscriptionsClient.prototype, "article", {
        get: function () {
            return this.articleSubscriptionsArticleClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceSubscriptionsClient.prototype, "commentRequiresModeration", {
        get: function () {
            return this.articleSubscriptionsCommentRequiresModerationClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceSubscriptionsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleInstanceSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c, _d;
    ArticleInstanceSubscriptionsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentReportedClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.ArticleSubscriptionsArticleClient)),
        tslib_1.__param(2, inversify_1.inject(__1.TYPES.ArticleSubscriptionsCommentRequiresModerationClient)),
        tslib_1.__param(3, inversify_1.inject(__1.TYPES.ArticleInstanceSubscriptionsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleSubscriptionsCommentReportedClient !== "undefined" && __1.ArticleSubscriptionsCommentReportedClient) === "function" ? _a : Object, typeof (_b = typeof __1.ArticleSubscriptionsArticleClient !== "undefined" && __1.ArticleSubscriptionsArticleClient) === "function" ? _b : Object, typeof (_c = typeof __1.ArticleSubscriptionsCommentRequiresModerationClient !== "undefined" && __1.ArticleSubscriptionsCommentRequiresModerationClient) === "function" ? _c : Object, typeof (_d = typeof __1.ArticleInstanceSubscriptionsRoute !== "undefined" && __1.ArticleInstanceSubscriptionsRoute) === "function" ? _d : Object])
    ], ArticleInstanceSubscriptionsClient);
    return ArticleInstanceSubscriptionsClient;
}());
exports.ArticleInstanceSubscriptionsClient = ArticleInstanceSubscriptionsClient;


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(283), exports);
tslib_1.__exportStar(__webpack_require__(284), exports);


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceRatingsRoute
 * @description Baasic Article Instance Ratings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Sub Ratings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var ArticleInstanceRatingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceRatingsRoute, _super);
    function ArticleInstanceRatingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'articles/{articleId}/ratings/';
        _this.findRoute = 'articles/{articleId}/ratings{?page,rpp,sort,embed,fields}';
        _this.findByUserRoute = 'articles/{articleId}/users/{username}/ratings/{?embed,fields}';
        _this.getRoute = 'articles/{articleId}/ratings/{id}/{?embed,fields}';
        _this.updateRoute = 'articles/{articleId}/ratings/{id}';
        _this.deleteRoute = 'articles/{articleId}/ratings/{id}';
        _this.deleteAllRoute = 'articles/{articleId}/ratings';
        return _this;
    }
    /**
     * Parses create article rating route; this URI does not support any additional embed items.
     * @method
     * @param data An article rating object that needs to be inserted into the system.
     * @example articleInstanceRatingsRoute.create(data);
     **/
    ArticleInstanceRatingsRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses find article rating route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing article rating properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article rating subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article rating property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose rating resources need to be retrieved.
     * @param options Query resource options object.
     * @example articleInstanceRatingsRoute.find({searchQuery: '<search-phrase>'});
     **/
    ArticleInstanceRatingsRoute.prototype.find = function (articleId, options) {
        var params = this.utility.extend({}, options);
        params.articleId = articleId;
        return _super.prototype.baseFind.call(this, this.findRoute, params);
    };
    /**
     * Parses findByUser article rating route which can be expanded with additional options. Supported items are:
     * - `username` - A value that uniquely identifies a user which has created an article rating.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article rating subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article rating property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose rating resources need to be retrieved.
     * @param username Username which uniquely identifies a user which has created an article rating.
     * @param options Query resource options object.
     * @example articleInstanceRatingsRoute.find({username: '<username>'});
     **/
    ArticleInstanceRatingsRoute.prototype.findByUser = function (articleId, username, options) {
        var params = this.utility.extend({}, options);
        params.username = username;
        params.articleId = articleId;
        return _super.prototype.baseFind.call(this, this.findByUserRoute, params);
    };
    /**
     * Parses get article rating route which must be expanded with the Id of the previously created article rating resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose rating resources need to be retrieved.
     * @param id Article slug or id which uniquely identifies article resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example articleInstanceRatingsRoute.get({id: '<articleRating-id>'});
     **/
    ArticleInstanceRatingsRoute.prototype.get = function (articleId, id, options) {
        var params = this.utility.extend({}, options);
        params.articleId = articleId;
        return _super.prototype.baseGet.call(this, this.getRoute, id, params);
    };
    /**
     * Parses update article rating route; this URI does not support any additional embed items.
     * @method
     * @param data An article object used to update specified article resource.
     * @example articleInstanceRatingsRoute.update(data);
     **/
    ArticleInstanceRatingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete article rating route; this URI does not support any additional embed items.
    * @method
    * @param data Rating resource resource that needs to be deleted.
    * @example articleInstanceRatingsRoute.delete(data);
    **/
    ArticleInstanceRatingsRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
    * Parses delete article rating route; this URI does not support any additional embed items.
    * @method
    * @param data Article object whose ratings needs to be deleted.
    * @example articleInstanceRatingsRoute.deleteAll(data);
    **/
    ArticleInstanceRatingsRoute.prototype.deleteAll = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteAllRoute, data, undefined, 'delete-ratings-by-article');
    };
    var _a;
    ArticleInstanceRatingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleInstanceRatingsRoute);
    return ArticleInstanceRatingsRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceRatingsRoute = ArticleInstanceRatingsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSubRatingsClient
 * @description  Article Sub Ratings Client provides an easy way to consume  Article Ratings REST API end-points. `articleRatingsClient` functions enable performing standard CRUD operations directly on article rating resources, whereas the `articleService` functions allow management between article and article rating. In order to obtain needed routes `articleRatingsClient` uses `articleRatingsRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(6);
var ArticleInstanceRatingsClient = /** @class */ (function () {
    function ArticleInstanceRatingsClient(articleInstanceRatingsRoute, apiClient) {
        this.articleInstanceRatingsRoute = articleInstanceRatingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleInstanceRatingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `articleRatingsRoute`.
         * @method
         * @example articleInstanceRatingsClient.routeDefinition.get(id);
         **/
        get: function () {
            return this.articleInstanceRatingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create article rating action has been performed; this action creates a new rating for an article.
     * @method
     * @param data An article rating object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create article rating action has been performed.
     * @example articleInstanceRatingsClient.create({ articleId : '<article-id>', rating : 5, userId : '<user-id>' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleInstanceRatingsClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article rating resources matching the given criteria.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose rating resources need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleInstanceRatingsClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleInstanceRatingsClient.prototype.find = function (articleId, options) {
        return this.apiClient.get(this.articleInstanceRatingsRoute.find(articleId, options));
    };
    /**
     * Returns a promise that is resolved once the findByUser action has been performed. Success response returns a list of article rating resources filtered by username.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose rating resources need to be retrieved.
     * @param username Username which uniquely identifies a user which has created an article rating.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the findByUser action has been performed.
     * @example articleInstanceRatingsClient.find('<username>', {
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleInstanceRatingsClient.prototype.findByUser = function (articleId, username, options) {
        return this.apiClient.get(this.articleInstanceRatingsRoute.findByUser(articleId, username, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified article rating resource.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose rating resources need to be retrieved.
     * @param id Article slug or id which uniquely identifies article resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleInstanceRatingsClient.get('<articleRating-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleInstanceRatingsClient.prototype.get = function (articleId, id, options) {
        return this.apiClient.get(this.articleInstanceRatingsRoute.get(articleId, id, options));
    };
    /**
     * Returns a promise that is resolved once the update article rating action has been performed; this action updates an article rating. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRatingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleRating);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An article object used to update specified article resource.
     * @returns A promise that is resolved once the update article rating action has been performed.
     * @example // articleRating is a resource previously fetched using get action.
                    articleRating.rating = 4;
                    articleInstanceRatingsClient.update(articleRating)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceRatingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove article rating action has been performed. If the action is successfully completed, the article rating resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRatingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleRating);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data Rating resource resource that needs to be deleted.
     * @returns a promise that is resolved once the remove article rating action has been performed.
     * @example // articleRating is a resource previously fetched using get action.
                    articleInstanceRatingsClient.remove(articleRating)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceRatingsClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the removeAll article rating action has been performed. If the action is successfully completed, the article rating resources will be permanently removed from the system for a specified article resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleInstanceRouteClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     *  ```
     * let params = modelMapper.removeParams(article);
     * let uri = params['model'].links('delete-ratings-by-article').href;
     * ```
     * @method
     * @param data Article object whose ratings needs to be deleted.
     * @returns A promise that is resolved once the removeAll article rating action has been performed.
     * @example // article is a resource previously fetched using get action.
                    articleInstanceRatingsClient.removeAll(article)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleInstanceRatingsClient.prototype.removeAll = function (data) {
        return this.apiClient.delete(this.routeDefinition.deleteAll(data));
    };
    var _a, _b;
    ArticleInstanceRatingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleInstanceRatingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleInstanceRatingsRoute !== "undefined" && __1.ArticleInstanceRatingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleInstanceRatingsClient);
    return ArticleInstanceRatingsClient;
}());
exports.ArticleInstanceRatingsClient = ArticleInstanceRatingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(286), exports);
tslib_1.__exportStar(__webpack_require__(287), exports);


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceTagsRoute
 * @description Baasic Article Instance Tags Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Instance Tags Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var ArticleInstanceTagsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceTagsRoute, _super);
    function ArticleInstanceTagsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'articles/{articleId}/tags/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'articles/{articleId}/tags/{tag}/{?embed,fields}';
        _this.createRoute = 'articles/{articleId}/tags/{tag}/';
        _this.deleteRoute = 'articles/{articleId}/tags/{id}';
        _this.deleteAllRoute = 'articles/{articleId}/tags';
        return _this;
    }
    /**
     * Parses find article tags route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify article tags using the phrase search; multiple tag keywords must be comma separated.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article tag subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article tag property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose tag resources need to be retrieved.
     * @param options Query resource options object.
     * @example articleInstanceTagsRoute.find().expand({searchQuery: '<search-phrase>'});
     **/
    ArticleInstanceTagsRoute.prototype.find = function (articleId, options) {
        var params = this.utility.extend({}, options);
        params.articleId = articleId;
        return _super.prototype.baseFind.call(this, this.findRoute, params);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose tag resource needs to be retrieved.
     * @param id A slug or id which uniquely identifies article tag resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example articleInstanceTagsRoute.get({id: '<articleTag-id>'});
     **/
    ArticleInstanceTagsRoute.prototype.get = function (articleId, id, options) {
        var params = this.utility.extend({}, options);
        params.articleId = articleId;
        return _super.prototype.baseGet.call(this, this.getRoute, id, params);
    };
    /**
     * Parses create article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param data An article tag value that needs to be inserted as new article tag resource into the system.
     * @example articleInstanceTagsRoute.create({id: '<articleTag-id>'});
     **/
    ArticleInstanceTagsRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param data Article Tag object that needs to be removed from the system.
     * @example articleInstanceTagsRoute.delete({id: '<articleTag-id>'});
     **/
    ArticleInstanceTagsRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param data Article object whoose tags needs to be removed from the system.
     * @example articleInstanceTagsRoute.deleteAll({id: '<articleTag-id>'});
     **/
    ArticleInstanceTagsRoute.prototype.deleteAll = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteAllRoute, data, undefined, 'delete-tags-by-article');
    };
    var _a;
    ArticleInstanceTagsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleInstanceTagsRoute);
    return ArticleInstanceTagsRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceTagsRoute = ArticleInstanceTagsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
- All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module baasicArticleInstanceTagsDefinition
 * @description  Article Instance Tags Definition provides an easy way to consume  Article Tags REST API end-points. `articleInstanceTagsRouteClient` functions enable performing standard CRUD operations directly on article tag resources, whereas the `articleClient` functions allow management between article and article tag. In order to obtain needed routes `articleInstanceTagsClient` uses `articleInstanceTagsRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(6);
var ArticleInstanceTagsClient = /** @class */ (function () {
    function ArticleInstanceTagsClient(articleInstanceTagsRoute, apiClient) {
        this.articleInstanceTagsRoute = articleInstanceTagsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleInstanceTagsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleInstanceTagsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article tag resources matching the given criteria.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose tag resources need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleInstanceTagsClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleInstanceTagsClient.prototype.find = function (articleId, options) {
        return this.apiClient.get(this.articleInstanceTagsRoute.find(articleId, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified article tag resource.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose tag resource needs to be retrieved.
     * @param id A slug or id which uniquely identifies article tag resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleInstanceTagsClient.get('<articleTag-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleInstanceTagsClient.prototype.get = function (articleId, id, options) {
        return this.apiClient.get(this.articleInstanceTagsRoute.get(articleId, id, options));
    };
    /**
     * Returns a promise that is resolved once the create article tag action has been performed; this action creates a new tag for an article.
     * @method
     * @param data An article tag value that needs to be inserted as new article tag resource into the system.
     * @returns A promise that is resolved once the create article tag action has been performed.
     * @example articleInstanceTagsClient.create({
                    articleId : '<article-id>',
                    tag : {
                        slug : '<slug>',
                        sortOrder : 1,
                        tag : '<tag>'
                    }
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    ArticleInstanceTagsClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove article tag action has been performed. If the action is successfully completed, the article tag resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleTagsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleTag);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data Article Tag object that needs to be removed from the system.
     * @returns A promise that is resolved once the remove article tag action has been performed.
     * @example // articleTag is a resource previously fetched using get action.
                    articleInstanceTagsClient.remove(articleTag)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceTagsClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the removeAll article tag action has been performed. This action will remove all tags from an article if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicArticleRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(article);
     * let uri = params['model'].links('delete-tags-by-article').href;
     * ```
     * @method
     * @param data Article object whoose tags needs to be removed from the system.
     * @returns A promise that is resolved once the removeAll article tag action has been performed.
     * @example // article is a resource previously fetched using get action.
                    articleInstanceTagsClient.removeAll(article)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleInstanceTagsClient.prototype.removeAll = function (data) {
        return this.apiClient.delete(this.routeDefinition.deleteAll(data));
    };
    var _a, _b;
    ArticleInstanceTagsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleInstanceTagsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleInstanceTagsRoute !== "undefined" && __1.ArticleInstanceTagsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleInstanceTagsClient);
    return ArticleInstanceTagsClient;
}());
exports.ArticleInstanceTagsClient = ArticleInstanceTagsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(289), exports);
tslib_1.__exportStar(__webpack_require__(290), exports);
tslib_1.__exportStar(__webpack_require__(291), exports);
tslib_1.__exportStar(__webpack_require__(292), exports);


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceCommentRepliesRoute
 * @description Baasic Article Instance Comment Replies Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Instance Comment Replies Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var ArticleInstanceCommentRepliesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceCommentRepliesRoute, _super);
    function ArticleInstanceCommentRepliesRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'articles/{articleId}/comments/{commentId}/replies/{?searchQuery,statuses,page,rpp,sort,embed,fields}';
        _this.getRoute = 'articles/{articleId}/comments/{commentId}/replies/{id}/{?embed,fields}';
        _this.createRoute = 'articles/{articleId}/comments/{commentId}/replies';
        _this.updateRoute = 'articles/{articleId}/comments/{id}';
        _this.approveRoute = 'articles/{articleId}/comments/{commentId}/replies/{id}/approve';
        _this.unapproveRoute = '/articles/{articleId}/comments/{commentId}/replies/{id}/unapprove';
        _this.flagRoute = 'articles/{articleId}/comments/{commentId}/replies/{id}/flag';
        _this.unflagRoute = 'articles/{articleId}/comments/{commentId}/replies/{id}/unflag';
        _this.reportRoute = 'articles/{articleId}/comments/{commentId}/replies/{id}/report';
        _this.deleteRoute = 'articles/{articleId}/comments/{id}';
        _this.deleteAllRoute = 'articles/{articleId}/comments';
        _this.unreportRoute = 'articles/{articleId}/comments/{commentId}/replies/{id}/unreport';
        _this.spamRoute = 'articles/{articleId}/comments/{commentId}/replies/{id}/spam';
        _this.unspamRoute = '/articles/{articleId}/comments/{commentId}/replies/{id}/unspam';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify article comment reply resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article comment reply subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article comment reply property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `statuses` - Comma separated list of article comment reply states that specify where search should be done (Allowed states: Approved, Spam, Reported, Flagged and UnApproved).
     * @method
     * @param articleId Article id which uniquely identifies article whose comment reply resources need to be retrieved.
     * @param commentId Comment id which uniquely identifies comment whose reply resources need to be retrieved.
     * @param options Query resource options.
     * @example articleCommentRepliesRoute.find({ searchQuery: '<search-phrase>' });
     **/
    ArticleInstanceCommentRepliesRoute.prototype.find = function (articleId, commentId, options) {
        var params = this.modelMapper.findParams(options);
        params.articleId = articleId;
        params.commentId = commentId;
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route which can be expanded with additional options. Supported items are:
     * - `id` - Id which uniquely identifies article comment reply resource that needs to be retrieved.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example articleCommentRepliesRoute.get({ id: '<comment-reply-id>' });
     **/
    ArticleInstanceCommentRepliesRoute.prototype.get = function (articleId, commentId, replyId, options) {
        var params = this.utility.extend({}, options);
        params.articleId = articleId;
        params.commentId = commentId;
        return _super.prototype.baseGet.call(this, this.getRoute, replyId, params);
    };
    /**
     * Parses create article comment reply route; this URI template does not support any additional items.
     * @method
     * @example articleCommentRepliesRoute.create(data);
     **/
    ArticleInstanceCommentRepliesRoute.prototype.create = function (articleId, data) {
        var params = this.utility.extend({}, data);
        params.articleId = articleId;
        return _super.prototype.baseCreate.call(this, this.createRoute, params);
    };
    ArticleInstanceCommentRepliesRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    ArticleInstanceCommentRepliesRoute.prototype.approve = function (data) {
        return _super.prototype.baseUpdate.call(this, this.approveRoute, data, undefined, 'comment-approve');
    };
    ArticleInstanceCommentRepliesRoute.prototype.unapprove = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unapproveRoute, data, undefined, 'comment-unapprove');
    };
    ArticleInstanceCommentRepliesRoute.prototype.flag = function (data) {
        return _super.prototype.baseUpdate.call(this, this.flagRoute, data, undefined, 'comment-flag');
    };
    ArticleInstanceCommentRepliesRoute.prototype.unflag = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unflagRoute, data, undefined, 'comment-unflag');
    };
    ArticleInstanceCommentRepliesRoute.prototype.report = function (data) {
        return _super.prototype.baseUpdate.call(this, this.reportRoute, data, undefined, 'comment-report');
    };
    ArticleInstanceCommentRepliesRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    ArticleInstanceCommentRepliesRoute.prototype.deleteAll = function (data) {
        return _super.prototype.baseUpdate.call(this, this.deleteAllRoute, data, undefined, 'delete-comments-by-article');
    };
    ArticleInstanceCommentRepliesRoute.prototype.unreport = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unreportRoute, data, undefined, 'comment-unreport');
    };
    ArticleInstanceCommentRepliesRoute.prototype.spam = function (data) {
        return _super.prototype.baseUpdate.call(this, this.spamRoute, data, undefined, 'comment-spam');
    };
    ArticleInstanceCommentRepliesRoute.prototype.unspam = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unspamRoute, data, undefined, 'comment-unspam');
    };
    var _a;
    ArticleInstanceCommentRepliesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleInstanceCommentRepliesRoute);
    return ArticleInstanceCommentRepliesRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceCommentRepliesRoute = ArticleInstanceCommentRepliesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceCommentRepliesClient
 * @description  Article Instance Comment Replies Client provides an easy way to consume  Article Comment Replies REST API end-points. `articleCommentRepliesService` functions enable performing standard CRUD operations directly on article comment reply resources, whereas the `articleClient` functions allow management between article and article comment reply. In order to obtain needed routes `articleCommentRepliesService` uses `articleCommentRepliesRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(6);
var ArticleInstanceCommentRepliesClient = /** @class */ (function () {
    function ArticleInstanceCommentRepliesClient(articleInstanceCommentRepliesRoute, apiClient) {
        this.articleInstanceCommentRepliesRoute = articleInstanceCommentRepliesRoute;
        this.apiClient = apiClient;
        /**
         * Contains a reference to valid list of article comment reply states. It returns an object containing all article comment reply states.
         * @method
         * @example articleCommentRepliesClient.statuses.approved;
         **/
        this.statuses = __1.CommentStatus;
    }
    Object.defineProperty(ArticleInstanceCommentRepliesClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `articleCommentRepliesRoute`.
         * @method
         * @example articleInstanceCommentRepliesClient.routeDefinition.get();
         **/
        get: function () {
            return this.articleInstanceCommentRepliesRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the approve article comment reply action has been performed. This action sets the state of an article comment reply to "approved". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-approve').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @param options Notification configuration used to control the article comment recourse access when managing notification distribution.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleInstanceCommentRepliesClient.approve(articleCommentReply, commentOptions)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentRepliesClient.prototype.approve = function (data, options) {
        return this.apiClient.put(this.routeDefinition.approve(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unapprove article comment reply action has been performed. This action sets the state of an article comment reply to "unapproved". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-unapprove').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the unapprove article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleInstanceCommentRepliesClient.unapprove(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentRepliesClient.prototype.unapprove = function (data) {
        return this.apiClient.put(this.routeDefinition.unapprove(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create article comment reply action has been performed; this action creates a new comment reply for an article.
     * @method
     * @param articleId Article id which uniquely identifies article that needs to be updated with new comment reply resource.
     * @param data An article comment reply object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create article comment reply action has been performed.
     * @example articleInstanceCommentRepliesClient.create('<article-id>', {
                    commentId : '<comment-id>',
                    comment : <comment>,
                    userId : '<user-id>' })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleInstanceCommentRepliesClient.prototype.create = function (articleId, data) {
        return this.apiClient.post(this.routeDefinition.create(articleId, data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article comment reply resources matching the given criteria.
     * @method
     * @param articleId Article id which uniquely identifies article whose comment reply resources need to be retrieved.
     * @param commentId Comment id which uniquely identifies comment whose reply resources need to be retrieved.
     * @param options Query resource options.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleInstanceCommentRepliesClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleInstanceCommentRepliesClient.prototype.find = function (articleId, commentId, options) {
        return this.apiClient.get(this.articleInstanceCommentRepliesRoute.find(articleId, commentId, options));
    };
    /**
     * Returns a promise that is resolved once the flag article comment reply action has been performed. This action sets the state of an article comment reply to "flagged". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-flag').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the flag article comment reply action has been performed.
     * @example     // articleCommentReply is a resource previously fetched using get action.
                        articleInstanceCommentRepliesClient.flag(articleCommentReply)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                // perform error handling here
                            });
     **/
    ArticleInstanceCommentRepliesClient.prototype.flag = function (data) {
        return this.apiClient.put(this.routeDefinition.flag(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unflag article comment reply action has been performed. This action removes the "flagged" comment reply state. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-unflag').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the unflag article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleInstanceCommentRepliesClient.unflag(articleCommentReply)
                        .success(function (data) {
                            // perform success action here
                        }).error(function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentRepliesClient.prototype.unflag = function (data) {
        return this.apiClient.put(this.routeDefinition.unflag(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified article comment reply resource.
     * @method
     * @param articleId Article id which uniquely identifies article whose comment reply resource needs to be retrieved.
     * @param commentId Comment id which uniquely identifies comment whose reply resource needs to be retrieved.
     * @param replyId Id which uniquely identifies article comment reply resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleInstanceCommentRepliesClient.get('<comment-reply-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleInstanceCommentRepliesClient.prototype.get = function (articleId, commentId, replyId, options) {
        return this.apiClient.get(this.articleInstanceCommentRepliesRoute.get(articleId, commentId, replyId, options));
    };
    /**
     * Returns a promise that is resolved once the remove article comment reply action has been performed. If the action is successfully completed, the article comment reply resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = apiClient.removeParams(articleCommentReply);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An article comment object used to delete specified article comment reply resource.
     * @returns A promise that is resolved once the remove article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleInstanceCommentRepliesClient.remove(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentRepliesClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the removeAll article comment reply action has been performed. This action will remove all comment replies from an article comment if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleInstanceCommentsRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleCommentReply);
     * let uri = params['model'].links('delete-comments-by-article').href;
     * ```
     * @method
     * @param data Article object used to delete all article comments in the system.
     * @returns a promise that is resolved once the removeAll article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleInstanceCommentRepliesClient.removeAll(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleInstanceCommentRepliesClient.prototype.removeAll = function (data) {
        return this.apiClient.delete(this.routeDefinition.deleteAll(data));
    };
    /**
     * Returns a promise that is resolved once the report article comment reply action has been performed. This action sets the state of an article comment reply to "reported". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-report').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @param options Notification configuration used to control the article comment recourse access when managing notification distribution.
     * @returns A promise that is resolved once the report article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleInstanceCommentRepliesClient.report(articleCommentReply, commentOptions)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentRepliesClient.prototype.report = function (data, options) {
        return this.apiClient.put(this.routeDefinition.report(data), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the unreport article comment reply action has been performed. This action removes the "reported" comment reply state. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-unreport').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the unreport article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleInstanceCommentRepliesClient.unreport(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentRepliesClient.prototype.unreport = function (data) {
        return this.apiClient.put(this.routeDefinition.unreport(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the mark as spam article comment reply action has been performed. This action sets the state of an article comment reply to "spam". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-spam').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the mark as spam article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleInstanceCommentRepliesClient.spam(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentRepliesClient.prototype.spam = function (data) {
        return this.apiClient.put(this.routeDefinition.spam(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unspam article comment reply action has been performed. This action removes the "spam" comment reply state. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-unspam').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns a promise that is resolved once the unspam article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                      articleInstanceCommentRepliesClient.unspam(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentRepliesClient.prototype.unspam = function (data) {
        return this.apiClient.put(this.routeDefinition.unspam(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update article comment reply action has been performed; this action updates an article comment reply resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An article comment object used to update specified article comment reply resource.
     * @returns A promise that is resolved once the update article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleInstanceCommentRepliesClient.update(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentRepliesClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    ArticleInstanceCommentRepliesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleInstanceCommentRepliesRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleInstanceCommentRepliesRoute !== "undefined" && __1.ArticleInstanceCommentRepliesRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleInstanceCommentRepliesClient);
    return ArticleInstanceCommentRepliesClient;
}());
exports.ArticleInstanceCommentRepliesClient = ArticleInstanceCommentRepliesClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceCommentsRoute
 * @description Baasic Article Instance Comments Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Instance Comments Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(6);
var ArticleInstanceCommentsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceCommentsRoute, _super);
    function ArticleInstanceCommentsRoute(articleInstanceCommentRepliesRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.articleInstanceCommentRepliesRoute = articleInstanceCommentRepliesRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'articles/{articleId}/comments/{?searchQuery,statuses,page,rpp,sort,embed,fields}';
        _this.getRoute = 'articles/{articleId}/comments/{id}/{?embed,fields}';
        _this.createRoute = 'articles/{articleId}/comments/';
        _this.updateRoute = 'articles/{articleId}/comments/{id}';
        _this.deleteRoute = 'articles/{articleId}/comments/{id}';
        _this.deleteAllRoute = 'articles/{articleId}/comments/{id}';
        _this.approveRoute = 'articles/{articleId}/comments/{id}/approve';
        _this.unapproveRoute = 'articles/{articleId}/comments/{id}/unapprove';
        _this.flagRoute = 'articles/{articleId}/comments/{id}/flag';
        _this.unflagRoute = 'articles/{articleId}/comments/{id}/unflag';
        _this.reportRoute = 'articles/{articleId}/comments/{id}/report';
        _this.unreportRoute = 'articles/{articleId}/comments/{id}/unreport';
        _this.spamRoute = 'articles/{articleId}/comments/{id}/spam';
        _this.unspamRoute = 'articles/{articleId}/comments/{id}/unspam';
        return _this;
    }
    Object.defineProperty(ArticleInstanceCommentsRoute.prototype, "replies", {
        get: function () {
            return this.articleInstanceCommentRepliesRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify article comment resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article comment subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article comment property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `statuses` - Comma separated list of article comment states that specify where search should be done (Allowed states: Approved, Spam, Reported, Flagged and UnApproved).
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose comment resources need to be retrieved.
     * @param options Query resource options object.
     * @example articleInstanceCommentsRoute.find({ searchQuery: '<search-phrase>' });
     **/
    ArticleInstanceCommentsRoute.prototype.find = function (articleId, options) {
        var params = this.modelMapper.findParams(options);
        params.articleId = articleId;
        return _super.prototype.baseCreate.call(this, this.findRoute, params);
    };
    /**
     * Parses get route which can be expanded with additional options. Supported items are:
     * - `id` - Id which uniquely identifies article comment resource that needs to be retrieved.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose comment resource needs to be retrieved.
     * @param commentId Id which identifies article comment resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example articleInstanceCommentsRoute.get().expand({ id: '<comment-id>' });
     **/
    ArticleInstanceCommentsRoute.prototype.get = function (articleId, commentId, options) {
        var params = this.utility.extend({}, options);
        params.articleId = articleId;
        params.id = commentId;
        return _super.prototype.baseGet.call(this, this.getRoute, params);
    };
    /**
     * Parses create route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comment object that needs to be inserted into the system.
     * @example articleInstanceCommentsRoute.create(data);
     **/
    ArticleInstanceCommentsRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comments object used to update specified article comment resource.
     * @example articleInstanceCommentsRoute.update(data);
     **/
    ArticleInstanceCommentsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comments object used to delete specified article comment resource.
     * @example articleInstanceCommentsRoute.delete(data);
     **/
    ArticleInstanceCommentsRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses delete all route; this URI template doesnt support any additional options.
     * @method
     * @param data An article object used to delete specified article comment resource.
     * @example articleInstanceCommentsRoute.deleteAll(data);
     **/
    ArticleInstanceCommentsRoute.prototype.deleteAll = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteAllRoute, data, undefined, 'delete-comments-by-article');
    };
    /**
     * Parses approve route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comment object.
     * @example articleInstanceCommentsRoute.approve(data);
     **/
    ArticleInstanceCommentsRoute.prototype.approve = function (data) {
        return _super.prototype.baseUpdate.call(this, this.approveRoute, data, undefined, 'comment-approve');
    };
    /**
     * Parses unapprove route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comment object.
     * @example articleInstanceCommentsRoute.unapprove(data);
     **/
    ArticleInstanceCommentsRoute.prototype.unapprove = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unapproveRoute, data, undefined, 'comment-unapprove');
    };
    /**
     * Parses flag route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comment object.
     * @example articleInstanceCommentsRoute.flag(data);
     **/
    ArticleInstanceCommentsRoute.prototype.flag = function (data) {
        return _super.prototype.baseUpdate.call(this, this.flagRoute, data, undefined, 'comment-flag');
    };
    /**
     * Parses unflag route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comment object.
     * @example articleInstanceCommentsRoute.unflag(data);
     **/
    ArticleInstanceCommentsRoute.prototype.unflag = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unflagRoute, data, undefined, 'comment-unflag');
    };
    /**
     * Parses report route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comment object.
     * @example articleInstanceCommentsRoute.report(data);
     **/
    ArticleInstanceCommentsRoute.prototype.report = function (data) {
        return _super.prototype.baseUpdate.call(this, this.reportRoute, data, undefined, 'comment-report');
    };
    /**
     * Parses unreport route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comment object.
     * @example articleInstanceCommentsRoute.unreport(data);
     **/
    ArticleInstanceCommentsRoute.prototype.unreport = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unreportRoute, data, undefined, 'comment-unreport');
    };
    /**
     * Parses spam route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comment object.
     * @example articleInstanceCommentsRoute.spam(data);
     **/
    ArticleInstanceCommentsRoute.prototype.spam = function (data) {
        return _super.prototype.baseUpdate.call(this, this.spamRoute, data, undefined, 'comment-spam');
    };
    /**
     * Parses unspam route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comment object.
     * @example articleInstanceCommentsRoute.unspam(data);
     **/
    ArticleInstanceCommentsRoute.prototype.unspam = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unspamRoute, data, undefined, 'comment-unspam');
    };
    var _a, _b;
    ArticleInstanceCommentsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleInstanceCommentRepliesRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleInstanceCommentRepliesRoute !== "undefined" && __1.ArticleInstanceCommentRepliesRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], ArticleInstanceCommentsRoute);
    return ArticleInstanceCommentsRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceCommentsRoute = ArticleInstanceCommentsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceCommentsClient
 * @description  Article Instance Comments Client provides an easy way to consume  Article Comments REST API end-points. `articleCommentsClient` functions enable performing standard CRUD operations directly on article comment resources, whereas the `articleClient` functions allow management between article and article comments. In order to obtain needed routes `articleCommentsClient` uses `articleCommentsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(6);
var ArticleInstanceCommentsClient = /** @class */ (function () {
    function ArticleInstanceCommentsClient(articleInstanceCommentsRoute, articleInstanceCommentsRepliesClient, apiClient) {
        this.articleInstanceCommentsRoute = articleInstanceCommentsRoute;
        this.articleInstanceCommentsRepliesClient = articleInstanceCommentsRepliesClient;
        this.apiClient = apiClient;
        /**
       * Contains a reference to valid list of article comment states. It returns an object containing all article comment states.
       * @method
       * @example articleInstanceCommentsClient.statuses.approved;
       **/
        this.statuses = __1.CommentStatus;
    }
    Object.defineProperty(ArticleInstanceCommentsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleInstanceCommentsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceCommentsClient.prototype, "replies", {
        get: function () {
            return this.articleInstanceCommentsRepliesClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the approve article comment action has been performed. This action sets the state of an article comment to "approved". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-approve').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @param options Notification configuration used to control the article comment recourse access when managing notification distribution.
     * @returns A promise that is resolved once the approve article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleInstanceCommentsClient.approve(articleComment, commentOptions)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentsClient.prototype.approve = function (data, options) {
        return this.apiClient.put(this.routeDefinition.approve(data), this.routeDefinition.createParams(options));
    };
    /**
     * Returns a promise that is resolved once the unapprove article comment action has been performed. This action sets the state of an article comment to "unapproved". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-unapprove').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the unapprove article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleInstanceCommentsClient.unapprove(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentsClient.prototype.unapprove = function (data) {
        return this.apiClient.put(this.routeDefinition.unapprove(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create article comment action has been performed; this action creates a new comment for an article.
     * @method
     * @param data An article comment object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create article comment action has been performed.
     * @example articleInstanceCommentsClient.create({
                        articleId : '<article-id>',
                        comment : <comment>,
                        userId : '<user-id>' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleInstanceCommentsClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article comment resources matching the given criteria.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose comment resources need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleInstanceCommentsClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .success(function (collection) {
                    // perform success action here
                })
                .error(function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleInstanceCommentsClient.prototype.find = function (articleId, options) {
        return this.apiClient.get(this.articleInstanceCommentsRoute.find(articleId, options));
    };
    /**
     * Returns a promise that is resolved once the flag article comment action has been performed. This action sets the state of an article comment to "flagged". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-flag').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the flag article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleInstanceCommentsClient.flag(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentsClient.prototype.flag = function (data) {
        return this.apiClient.put(this.routeDefinition.flag(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unflag article comment action has been performed. This action removes the "flagged" comment mark. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-unflag').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the unflag article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleInstanceCommentsClient.unflag(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentsClient.prototype.unflag = function (data) {
        return this.apiClient.put(this.routeDefinition.unflag(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified article comment resource.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose comment resource needs to be retrieved.
     * @param commentId Id which identifies article comment resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleInstanceCommentsClient.get('<article-id>', '<comment-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleInstanceCommentsClient.prototype.get = function (articleId, commentId, options) {
        return this.apiClient.get(this.articleInstanceCommentsRoute.get(articleId, commentId, options));
    };
    /**
     * Returns a promise that is resolved once the remove article comment action has been performed. If the action is successfully completed, the article comment resource and its replies will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     ```
     let params = modelMapper.removeParams(articleComment);
     let uri = params['model'].links('delete').href;
     ```
     * @method
     * @param data An article comment object used to delete specified article comment resource.
     * @returns A promise that is resolved once the remove article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                       articleInstanceCommentsClient.remove(articleComment)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                               // perform error handling here
                           });
    **/
    ArticleInstanceCommentsClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the removeAll article comment action has been performed. This action will remove all comments and comment replies from an article if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleInstanceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleComment);
     * let uri = params['model'].links('delete-comments-by-article').href;
     * ```
     * @method
     * @param data An article object used to delete specified article comment resource.
     * @returns A promise that is resolved once the removeAll article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleInstanceCommentsClient.removeAll(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleInstanceCommentsClient.prototype.removeAll = function (data) {
        return this.apiClient.delete(this.routeDefinition.deleteAll(data));
    };
    /**
     * Returns a promise that is resolved once the report article comment action has been performed. This action sets the state of an article comment to "reported". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-report').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @param options Notification configuration used to control the article comment recourse access when managing notification distribution.
     * @returns A promise that is resolved once the report article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleInstanceCommentsClient.report(articleComment, commentOptions)
                        .success(function (data) {
                            // perform success action here
                        })
                        .error(function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentsClient.prototype.report = function (data, options) {
        return this.apiClient.put(this.routeDefinition.report(data), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the unreport article comment action has been performed. This action removes the "reported" comment mark. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-unreport').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the unreport article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleInstanceCommentsClient.unreport(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceCommentsClient.prototype.unreport = function (data) {
        return this.apiClient.put(this.routeDefinition.unreport(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update article comment action has been performed; this action updates an article comment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An article comments object used to update specified article comment resource.
     * @returns A promise that is resolved once the update article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleInstanceCommentsClient.update(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleInstanceCommentsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the mark as spam article comment action has been performed. This action sets the state of an article comment to "spam". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleInstanceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-spam').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the mark as spam article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleInstanceClient.spam(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleInstanceCommentsClient.prototype.spam = function (data) {
        return this.apiClient.put(this.routeDefinition.spam(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unspam article comment action has been performed. This action removes the "spam" comment state. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleInstanceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-unspam').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the unspam article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                        articleInstanceClient.unspam(articleComment)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    ArticleInstanceCommentsClient.prototype.unspam = function (data) {
        return this.apiClient.put(this.routeDefinition.unspam(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    ArticleInstanceCommentsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleInstanceCommentsRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.ArticleCommentRepliesClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleInstanceCommentsRoute !== "undefined" && __1.ArticleInstanceCommentsRoute) === "function" ? _a : Object, typeof (_b = typeof __1.ArticleInstanceCommentRepliesClient !== "undefined" && __1.ArticleInstanceCommentRepliesClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], ArticleInstanceCommentsClient);
    return ArticleInstanceCommentsClient;
}());
exports.ArticleInstanceCommentsClient = ArticleInstanceCommentsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(294), exports);
tslib_1.__exportStar(__webpack_require__(295), exports);
tslib_1.__exportStar(__webpack_require__(296), exports);
tslib_1.__exportStar(__webpack_require__(297), exports);
tslib_1.__exportStar(__webpack_require__(298), exports);
tslib_1.__exportStar(__webpack_require__(299), exports);


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceFilesStreamsRoute
 * @description Baasic Article Instance Files Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Streams Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ArticleInstanceFilesStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceFilesStreamsRoute, _super);
    function ArticleInstanceFilesStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'articles/{articleId}/file-streams/{id}/{?width,height,t}';
        _this.createRoute = 'articles/{articleId}/file-streams/{filename}';
        _this.updateRoute = 'articles/{articleId}/file-streams/{id}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id of desired file stream. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be retrieved.
     * @param data Article File object used to identify stream that needs to be retrieved from the system.
     * @example articleInstanceFilesRoute.get({id: '<filename>'});
     **/
    ArticleInstanceFilesStreamsRoute.prototype.get = function (articleId, data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        var params = this.utility.extend({}, data);
        params.articleId = articleId;
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses create route; this route should be expanded with the filename which indicates where the stream will be saved.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be inserted.
     * @param data Article File object that need to be inserted into the system.
     * @example articleInstanceFilesRoute.create({filename: '<filename>'});
     **/
    ArticleInstanceFilesStreamsRoute.prototype.create = function (articleId, data) {
        var params = this.utility.extend({}, data);
        params.articleId = articleId;
        return _super.prototype.baseCreate.call(this, this.createRoute, params);
    };
    /**
     * Parses update route; this route should be expanded with the id of the previously saved resource. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be updated.
     * @param data Article File object used to identify stream that needs to be updated.
     * @example articleFilesRoute.update({id: '<filename>'});
     **/
    ArticleInstanceFilesStreamsRoute.prototype.update = function (articleId, data) {
        var params = this.utility.extend({}, data);
        params.articleId = articleId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    ArticleInstanceFilesStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleInstanceFilesStreamsRoute);
    return ArticleInstanceFilesStreamsRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceFilesStreamsRoute = ArticleInstanceFilesStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceFilesStreamsClient
 * @description  Article Instance Files Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(6);
var ArticleInstanceFilesStreamsClient = /** @class */ (function () {
    function ArticleInstanceFilesStreamsClient(articleInstanceFilesStreamsRoute, apiClient) {
        this.articleInstanceFilesStreamsRoute = articleInstanceFilesStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleInstanceFilesStreamsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleInstanceFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a stream of the derived resource. Otherwise, stream of the original file resource will be retrieved.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be retrieved.
     * @param data Article File object used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original file stream
                    articleInstanceFilesStreamsClient.get({id: '<file-id>'})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });

                // Request derived file stream
                        articleInstanceFilesStreamsClient.get({id: '<file-id>', width: <width>, height: <height>, t: <timestamp>})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    ArticleInstanceFilesStreamsClient.prototype.get = function (articleId, data) {
        return this.apiClient.get(this.articleInstanceFilesStreamsRoute.get(articleId, data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a blob of the derived file resource. Otherwise, blob of the original file resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be retrieved.
     * @param data Article File object used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original blob
                    articleInstanceFilesStreamsClient.getBlob('<file-id>')
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
                        
                // Request derived blob
                        articleInstanceFilesStreamsClient.getBlob({
                            id: '<file-id>',
                            width: <width>,
                            height: <height>,
                            t: <timestamp>
                        })
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceFilesStreamsClient.prototype.getBlob = function (articleId, data) {
        return this.apiClient.get(this.articleInstanceFilesStreamsRoute.get(articleId, data), { 'Accept': 'application/octet-stream' });
    };
    /**
     * Returns a promise that is resolved once the update file stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of file stream data type).
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be updated.
     * @param data Article File object used to identify stream that needs to be updated.
     * @param stream
     * @returns A promise that is resolved once the update file stream action has been performed.
     * @example // Update original file stream
                    articleInstanceFilesStreamsClient.update('<file-id>', <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
                // Update derived file stream
                    articleInstanceFilesStreamsClient.update({id: '<file-id>', width: <width>, height: <height>}, <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceFilesStreamsClient.prototype.update = function (articleId, data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.articleInstanceFilesStreamsRoute.update(articleId, data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the create file stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be inserted.
     * @param data Article File object that need to be inserted into the system.
     * @param stream
     * @returns A promise that is resolved once the create file stream action has been performed.
     * @example articleInstanceFilesStreamsClient.create('<file-id>', <blob>)
                   .then(function (data) {
                        // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleInstanceFilesStreamsClient.prototype.create = function (articleId, data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.articleInstanceFilesStreamsRoute.create(articleId, data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    ArticleInstanceFilesStreamsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleInstanceFilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleInstanceFilesStreamsRoute !== "undefined" && __1.ArticleInstanceFilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleInstanceFilesStreamsClient);
    return ArticleInstanceFilesStreamsClient;
}());
exports.ArticleInstanceFilesStreamsClient = ArticleInstanceFilesStreamsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceFilesBatchRoute
 * @description Baasic Article Instance Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Batch Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ArticleInstanceFilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceFilesBatchRoute, _super);
    function ArticleInstanceFilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.unlinkRoute = 'articles/{articleId}/files/batch/unlink';
        _this.updateRoute = 'articles/{articleId}/files/batch';
        _this.linkRoute = 'articles/{articleId}/files/batch/link';
        return _this;
    }
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param articleId Article file id of the original article file used to identify article files on which delete action should be performed.
     * @example articleInstanceFilesBatchRoute.unlink(articleId);
     **/
    ArticleInstanceFilesBatchRoute.prototype.unlink = function (articleId) {
        var params = { articleId: articleId };
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be updated.
     * @example articleInstanceFilesStreamsRoute.update(articleId);
     **/
    ArticleInstanceFilesBatchRoute.prototype.update = function (articleId) {
        var params = { articleId: articleId };
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be linked.
     * @example articleInstanceFilesStreamsRoute.link(articleId);
     **/
    ArticleInstanceFilesBatchRoute.prototype.link = function (articleId) {
        var params = { articleId: articleId };
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    var _a;
    ArticleInstanceFilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleInstanceFilesBatchRoute);
    return ArticleInstanceFilesBatchRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceFilesBatchRoute = ArticleInstanceFilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceFilesBatchClient
 * @description  Article Instance Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(6);
var ArticleInstanceFilesBatchClient = /** @class */ (function () {
    function ArticleInstanceFilesBatchClient(articleInstanceFilesBatchRoute, apiClient) {
        this.articleInstanceFilesBatchRoute = articleInstanceFilesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleInstanceFilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleInstanceFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will remove just derived resource. Otherwise, specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param articleId Article file id of the original article file used to identify article files on which delete action should be performed.
     * @param data Collection of article delete requests which uniquely identifies article files that need to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                   articleInstanceFilesBatchClient.unlink([{ id: '<file-id>' }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
               // Remove derived file resources
                   articleInstanceFilesBatchClient.unlink([{ id: '<file-id>', fileFormat: { width: <width>, height: <height> } }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    ArticleInstanceFilesBatchClient.prototype.unlink = function (articleId, data) {
        return this.apiClient.delete(this.articleInstanceFilesBatchRoute.unlink(articleId), undefined, data);
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article file need to be updated.
     * @param data Article file object that need to be updated in the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example articleInstanceFilesBatchClient.update(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleInstanceFilesBatchClient.prototype.update = function (articleId, data) {
        return this.apiClient.put(this.routeDefinition.update(articleId), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be linked.
     * @param data A collection of article file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example articleInstanceFilesBatchClient.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleInstanceFilesBatchClient.prototype.link = function (articleId, data) {
        return this.apiClient.post(this.routeDefinition.link(articleId), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    ArticleInstanceFilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleInstanceFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleInstanceFilesBatchRoute !== "undefined" && __1.ArticleInstanceFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleInstanceFilesBatchClient);
    return ArticleInstanceFilesBatchClient;
}());
exports.ArticleInstanceFilesBatchClient = ArticleInstanceFilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceFilesRoute
 * @description Baasic Article Instance Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(6);
var ArticleInstanceFilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleInstanceFilesRoute, _super);
    function ArticleInstanceFilesRoute(articleInstanceFilesStreamsRoute, articleInstanceFilesBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.articleInstanceFilesStreamsRoute = articleInstanceFilesStreamsRoute;
        _this.articleInstanceFilesBatchRoute = articleInstanceFilesBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'articles/{articleId}/files/{?searchQuery,fileName,minFileSize,maxFileSize,ids,from,to,page,rpp,sort,embed,fields}';
        _this.getRoute = 'articles/{articleId}/files/{id}/{?embed,fields}';
        _this.linkRoute = 'articles/{articleId}/files/link';
        _this.unlinkRoute = 'articles/{articleId}/files/unlink/{id}';
        _this.unlinkByArticleRoute = 'articles/{articleId}/files/unlink/{id}';
        _this.updateRoute = 'articles/{articleId}/comments/{id}';
        return _this;
    }
    Object.defineProperty(ArticleInstanceFilesRoute.prototype, "streams", {
        get: function () {
            return this.articleInstanceFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceFilesRoute.prototype, "batch", {
        get: function () {
            return this.articleInstanceFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be retrieved.
     * @param options Query resource options object.
     * @example articleInstanceFilesRoute.find({searchQuery: '<search-phrase>'});
     **/
    ArticleInstanceFilesRoute.prototype.find = function (articleId, options) {
        var params = this.modelMapper.findParams(options);
        params.articleId = articleId;
        return _super.prototype.baseCreate.call(this, this.findRoute, params);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be retrieved.
     * @param id Article file id which uniquely identifies article file that needs to be retrieved.
     * @param options options object that contains embed data.
     * @example articleInstanceFilesRoute.get({id: '<file-id>'});
     **/
    ArticleInstanceFilesRoute.prototype.get = function (articleId, id, options) {
        var params = this.utility.extend({}, options);
        params.articleId = articleId;
        params.id = id;
        return _super.prototype.baseGet.call(this, this.getRoute, params);
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be deleted.
     * @param data
     * @param options
     * @example articleInstanceFilesRoute.link();
     **/
    ArticleInstanceFilesRoute.prototype.link = function (articleId, data) {
        var params = this.utility.extend({}, data);
        params.articleId = articleId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be deleted.
     * @param data
     * @param options
     * @example articleFilesRoute.unlink(data);
     **/
    ArticleInstanceFilesRoute.prototype.unlink = function (articleId, data, options) {
        if (!options) {
            options = {};
        }
        var params = this.modelMapper.removeParams(data);
        params.articleId = articleId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params, options, 'unlink');
    };
    /**
     * Parses unlink by article route; this URI template does not expose any additional options.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be deleted.
     * @param data
     * @param options
     * @example articleFilesRoute.unlinkByArticle(data);
     **/
    ArticleInstanceFilesRoute.prototype.unlinkByArticle = function (articleId, data, options) {
        if (!options) {
            options = {};
        }
        var params = this.modelMapper.removeParams(data);
        params.articleId = articleId;
        return _super.prototype.baseDelete.call(this, this.unlinkByArticleRoute, params, options, 'unlink-by-article');
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example articleInstanceFilesRoute.update(data);
     **/
    ArticleInstanceFilesRoute.prototype.update = function (articleId, data) {
        var params = this.modelMapper.updateParams(data);
        params.articleId = articleId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    var _a, _b, _c;
    ArticleInstanceFilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleInstanceFilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.ArticleInstanceFilesBatchRoute)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleInstanceFilesStreamsRoute !== "undefined" && __1.ArticleInstanceFilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof __1.ArticleInstanceFilesBatchRoute !== "undefined" && __1.ArticleInstanceFilesBatchRoute) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _c : Object])
    ], ArticleInstanceFilesRoute);
    return ArticleInstanceFilesRoute;
}(common_1.BaseRoute));
exports.ArticleInstanceFilesRoute = ArticleInstanceFilesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleInstanceFilesClient
 * @description  Article Instance Files Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(6);
var ArticleInstanceFilesClient = /** @class */ (function () {
    function ArticleInstanceFilesClient(articleInstanceFilesRoute, articleInstanceFilesStreamsClient, ArticleInstanceFilesBatchClient, apiClient) {
        this.articleInstanceFilesRoute = articleInstanceFilesRoute;
        this.articleInstanceFilesStreamsClient = articleInstanceFilesStreamsClient;
        this.ArticleInstanceFilesBatchClient = ArticleInstanceFilesBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleInstanceFilesClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleInstanceFilesRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceFilesClient.prototype, "streams", {
        get: function () {
            return this.articleInstanceFilesStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleInstanceFilesClient.prototype, "batch", {
        get: function () {
            return this.ArticleInstanceFilesBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of file resources matching the given criteria.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleInstanceFilesClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleInstanceFilesClient.prototype.find = function (articleId, options) {
        return this.apiClient.get(this.articleInstanceFilesRoute.find(articleId, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested file resource.
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be retrieved.
     * @param id Article file id which uniquely identifies article file that needs to be retrieved.
     * @param options options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleInstanceFilesClient.get('<file-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleInstanceFilesClient.prototype.get = function (articleId, id, options) {
        return this.apiClient.get(this.articleInstanceFilesRoute.get(articleId, id, options));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove one or many file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicArticleFilesRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink').href;
     * ```
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be deleted.
     * @param data
     * @param options
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action. The following action will remove the original file resource and all accompanying derived file resources.
                    articleInstanceFilesRoute.remove(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleInstanceFilesClient.prototype.unlink = function (articleId, data, options) {
        return this.apiClient.delete(this.articleInstanceFilesRoute.unlink(articleId, data, options));
    };
    /**
     * Returns a promise that is resolved once the unlink by article action has been performed. This action will remove all file resources from the system related to the requested article if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicArticleService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink-by-article').href;
     * ```
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be deleted.
     * @param data
     * @param options
     * @returns A promise that is resolved once the unlink by article action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                    articleInstanceFilesClient.unlinkByArticle(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleInstanceFilesClient.prototype.unlinkByArticle = function (articleId, data, options) {
        return this.apiClient.delete(this.articleInstanceFilesRoute.unlink(articleId, data, options));
    };
    /**
     * Returns a promise that is resolved once the update file action has been performed; this action will update a file resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicArticleFilesRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     ```
     let params = modelMapper.updateParams(fileEntry);
     let uri = params['model'].links('put').href;
     ```
     * @method
     * @param articleId An article object used to update specified article resource.
     * @param data Article File object used to update specific article file data in the system.
     * @returns A promise that is resolved once the update file action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                   fileEntry.description = '<description>';
                   articleInstanceFilesClient.update(fileEntry)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    ArticleInstanceFilesClient.prototype.update = function (articleId, data) {
        return this.apiClient.put(this.routeDefinition.update(articleId, data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resource from other modules into the Article Files module (For example: file resources from the Media Vault module can be linked directly into the Article Files module).
     * @method
     * @param articleId Article slug or id which uniquely identifies article whose article files need to be linked.
     * @param data A article file object that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example articleInstanceFilesClient.link(fileObject)
                    .then(function (response, status, headers, config) {
                        // perform success handling here
                    },
                        function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleInstanceFilesClient.prototype.link = function (articleId, data) {
        return this.apiClient.post(this.routeDefinition.link(articleId, data), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c, _d;
    ArticleInstanceFilesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.ArticleInstanceFilesRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.ArticleInstanceFilesStreamsClient)),
        tslib_1.__param(2, inversify_1.inject(__1.TYPES.ArticleInstanceFilesBatchClient)),
        tslib_1.__param(3, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.ArticleInstanceFilesRoute !== "undefined" && __1.ArticleInstanceFilesRoute) === "function" ? _a : Object, typeof (_b = typeof __1.ArticleInstanceFilesStreamsClient !== "undefined" && __1.ArticleInstanceFilesStreamsClient) === "function" ? _b : Object, typeof (_c = typeof __1.ArticleInstanceFilesBatchClient !== "undefined" && __1.ArticleInstanceFilesBatchClient) === "function" ? _c : Object, typeof (_d = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _d : Object])
    ], ArticleInstanceFilesClient);
    return ArticleInstanceFilesClient;
}());
exports.ArticleInstanceFilesClient = ArticleInstanceFilesClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module baasicArticleACLRouteService
 * @description Baasic Article ACL Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var ArticleACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleACLRoute, _super);
    function ArticleACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'articles/{id}/acl/{?fields}';
        _this.updateRoute = 'articles/{id}/acl/{?fields}';
        _this.deleteByUserRoute = 'articles/{id}/acl/actions/{accessAction}/users/{user}/';
        _this.deleteByRoleRoute = 'articles/{id}/acl/actions/{accessAction}/roles/{role}/';
        return _this;
    }
    /**
     * Parses get article acl route; this URI template should be expanded with the Id of the article.
     * @method
     * @example articleACLRoute.get({id: '<article-id>'});
     **/
    ArticleACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update article acl route; this URI template should be expanded with the Id of the article.
     * @method
     * @example articleACLRoute.update({id: '<article-id>'});
     **/
    ArticleACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses deleteByUser article acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the article.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and article resource.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param articleId Article id which uniquely identifies article resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and article resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data An ACL policy object that needs to be updated in the system.
     * @example articleACLRoute.deleteByUser({
                        id: '<article-id>',
                        accessAction: '<access-action>',
                        user: '<username>'
                });
     **/
    ArticleACLRoute.prototype.deleteByUser = function (articleId, action, user, data) {
        var params = this.modelMapper.removeParams(data);
        params.articleId = articleId;
        params.user = user;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByUser article acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the article.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and article resource.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param articleId Article id which uniquely identifies article resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and article resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data An ACL policy object that needs to be updated in the system.
     * @example articleACLRoute.deleteByRole({
                    id: '<article-id>',
                    accessAction: '<access-action>',
                    role: '<role-name>'
                });
     **/
    ArticleACLRoute.prototype.deleteByRole = function (articleId, action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.articleId = articleId;
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    ArticleACLRoute.prototype.updateParams = function (options) {
        var params = this.utility.extend({}, options);
        return params[this.modelMapper.modelPropertyName];
    };
    var _a;
    ArticleACLRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleACLRoute);
    return ArticleACLRoute;
}(common_1.BaseRoute));
exports.ArticleACLRoute = ArticleACLRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleACLClient
 * @description  Article ACL Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleACLClient` uses `articleACLRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleACLClient = /** @class */ (function () {
    function ArticleACLClient(articleACLRoute, apiClient) {
        this.articleACLRoute = articleACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified article resource.
     * @method
     * @example articleACLClient.get({id: '<article-id>'})
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed, this action creates new ACL policy for the specified article resource.
     * @method
     * @param options An ACL policy object that needs to be updated in the system. This object specifies parameters necessary for establishing user and/or role set of rights.
     * @returns A promise that is resolved once the update acl action has been performed.
     * @example let options = {id : '<article-id>'};
                let aclObj =  {
                    actionId: '<action-id'>,
                    roleId: '<roleId>',
                    userId: '<userId>'
                };
                options[baasicConstants.modelPropertyName] = aclObj;
                articleACLClient.update(options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and article resource.
     * @method
     * @param articleId Article id which uniquely identifies article resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and article resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data An ACL policy object that needs to be updated in the system.
     * @returns A promise that is resolved once the removeByUser action has been performed.
     * @example articleACLClient.removeByUser('<article-id>', '<access-action>', '<username>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleACLClient.prototype.removeByUser = function (articleId, action, user, data) {
        return this.apiClient.delete(this.articleACLRoute.deleteByUser(articleId, action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and article resource.
     * @method
     * @param articleId Article id which uniquely identifies article resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and article resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data An ACL policy object that needs to be updated in the system.
     * @returns A promise that is resolved once the removeByRole action has been performed.
     * @example articleACLClient.removeByRole('<article-id>', '<access-action>', '<role-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleACLClient.prototype.removeByRole = function (articleId, action, role, data) {
        return this.apiClient.delete(this.articleACLRoute.deleteByRole(articleId, action, role, data));
    };
    var _a, _b;
    ArticleACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleACLRoute !== "undefined" && _1.ArticleACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleACLClient);
    return ArticleACLClient;
}());
exports.ArticleACLClient = ArticleACLClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleCommentRepliesRoute
 * @description Baasic Article Comment Replies Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Comment Replies Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var ArticleCommentRepliesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleCommentRepliesRoute, _super);
    function ArticleCommentRepliesRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'article-comment-replies/{?searchQuery,statuses,page,rpp,sort,embed,fields}';
        _this.getRoute = 'article-comment-replies/{id}/{?embed,fields}';
        _this.createRoute = 'article-comment-replies';
        _this.updateRoute = 'article-comment-replies/{id}';
        _this.deleteRoute = 'article-comment-replies/{id}';
        _this.approveRoute = 'article-comment-replies/{id}/approve';
        _this.unapproveRoute = 'article-comment-replies/{id}/unapprove';
        _this.flagRoute = 'article-comment-replies/{id}/flag';
        _this.unflagRoute = 'article-comment-replies/{id}/unflag';
        _this.reportRoute = 'article-comment-replies/{id}/report';
        _this.unreportRoute = 'article-comment-replies/{id}/unreport';
        _this.spamRoute = 'article-comment-replies/{id}/spam';
        _this.unspamRoute = 'article-comment-replies/{id}/unspam';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify article comment reply resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article comment reply subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article comment reply property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `statuses` - Comma separated list of article comment reply states that specify where search should be done (Allowed states: Approved, Spam, Reported, Flagged and UnApproved).
     * @method
     * @param options Query resource options object.
     * @example articleCommentRepliesRoute.find({ searchQuery: '<search-phrase>' });
     **/
    ArticleCommentRepliesRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route which can be expanded with additional options. Supported items are:
     * - `id` - Id which uniquely identifies article comment reply resource that needs to be retrieved.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id Id which uniquely identifies article comment reply resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example articleCommentRepliesRoute.get({ id: '<comment-reply-id>' });
     **/
    ArticleCommentRepliesRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create article comment reply route; this URI template does not support any additional items.
     * @method
     * @param data An article comment reply object that needs to be inserted into the system.
     * @example articleCommentRepliesRoute.create(data);
     **/
    ArticleCommentRepliesRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update article comment reply route; this URI template does not support any additional items.
     * @method
     * @param data An Article Comments Reply object used to update specified article comment reply resource.
     * @example articleCommentRepliesRoute.update(data);
     **/
    ArticleCommentRepliesRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete article comment reply route; this URI template does not support any additional items.
    * @method
    * @param data Article Comment Reply object.
    * @example articleCommentRepliesRoute.delete(data);
    **/
    ArticleCommentRepliesRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses approve article comment reply route; this URI template does not support any additional items.
     * @method
     * @param data Article Comment Reply object.
     * @example articleCommentRepliesRoute.approve(data);
     **/
    ArticleCommentRepliesRoute.prototype.approve = function (data) {
        return _super.prototype.baseUpdate.call(this, this.approveRoute, data, undefined, 'comment-approve');
    };
    /**
    * Parses unapprove article comment reply route; this URI template does not support any additional items.
    * @method
    * @param data Article Comment Reply object.
    * @example articleCommentRepliesRoute.unapprove(data);
    **/
    ArticleCommentRepliesRoute.prototype.unapprove = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unapproveRoute, data, undefined, 'comment-unapprove');
    };
    /**
    * Parses flag article comment reply route; this URI template does not support any additional items.
    * @method
    * @param data Article Comment Reply object.
    * @example articleCommentRepliesRoute.flag(data);
    **/
    ArticleCommentRepliesRoute.prototype.flag = function (data) {
        return _super.prototype.baseUpdate.call(this, this.flagRoute, data, undefined, 'comment-flag');
    };
    /**
    * Parses unflag article comment reply route; this URI template does not support any additional items.
    * @method
    * @param data Article Comment Reply object.
    * @example articleCommentRepliesRoute.unflag(data);
    **/
    ArticleCommentRepliesRoute.prototype.unflag = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unflagRoute, data, undefined, 'comment-unflag');
    };
    /**
    * Parses report article comment reply route; this URI template does not support any additional items.
    * @method
    * @param data Article Comment Reply object.
    * @example articleCommentRepliesRoute.report(data);
    **/
    ArticleCommentRepliesRoute.prototype.report = function (data) {
        return _super.prototype.baseUpdate.call(this, this.reportRoute, data, undefined, 'comment-report');
    };
    /**
    * Parses unreport article comment reply route; this URI template does not support any additional items.
    * @method
    * @param data Article Comment Reply object.
    * @example articleCommentRepliesRoute.unreport(data);
    **/
    ArticleCommentRepliesRoute.prototype.unreport = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unreportRoute, data, undefined, 'comment-unreport');
    };
    /**
    * Parses spam article comment reply route; this URI template does not support any additional items.
    * @method
    * @param data Article Comment Reply object.
    * @example articleCommentRepliesRoute.spam(data);
    **/
    ArticleCommentRepliesRoute.prototype.spam = function (data) {
        return _super.prototype.baseUpdate.call(this, this.spamRoute, data, undefined, 'comment-spam');
    };
    /**
    * Parses unspam article comment reply route; this URI template does not support any additional items.
    * @method
    * @param data Article Comment Reply object.
    * @example articleCommentRepliesRoute.unspam(data);
    **/
    ArticleCommentRepliesRoute.prototype.unspam = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unspamRoute, data, undefined, 'comment-unspam');
    };
    var _a;
    ArticleCommentRepliesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleCommentRepliesRoute);
    return ArticleCommentRepliesRoute;
}(common_1.BaseRoute));
exports.ArticleCommentRepliesRoute = ArticleCommentRepliesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleCommentRepliesClient
 * @description  Article Comment Replies Client provides an easy way to consume  Article Comment Replies REST API end-points. `articleCommentRepliesService` functions enable performing standard CRUD operations directly on article comment reply resources, whereas the `articleClient` functions allow management between article and article comment reply. In order to obtain needed routes `articleCommentRepliesService` uses `articleCommentRepliesRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleCommentRepliesClient = /** @class */ (function () {
    function ArticleCommentRepliesClient(articleCommentRepliesRoute, apiClient) {
        this.articleCommentRepliesRoute = articleCommentRepliesRoute;
        this.apiClient = apiClient;
        /**
         * Contains a reference to valid list of article comment reply states. It returns an object containing all article comment reply states.
         * @method
         * @example articleCommentRepliesClient.statuses.approved;
         **/
        this.statuses = _1.CommentStatus;
    }
    Object.defineProperty(ArticleCommentRepliesClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `articleCommentRepliesRoute`.
         * @method
         * @example articleCommentRepliesClient.routeDefinition.get();
         **/
        get: function () {
            return this.articleCommentRepliesRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the approve article comment reply action has been performed. This action sets the state of an article comment reply to "approved". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-approve').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @param options Notification configuration used to control the article comment recourse access when managing notification distribution.
     * @returns A promise that is resolved once the approve article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleCommentRepliesClient.approve(articleCommentReply, commentOptions)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentRepliesClient.prototype.approve = function (data, options) {
        return this.apiClient.put(this.routeDefinition.approve(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unapprove article comment reply action has been performed. This action sets the state of an article comment reply to "unapproved". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-unapprove').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the unapprove article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleCommentRepliesClient.unapprove(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentRepliesClient.prototype.unapprove = function (data) {
        return this.apiClient.put(this.routeDefinition.unapprove(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create article comment reply action has been performed; this action creates a new comment reply for an article.
     * @method
     * @param data An article comment reply object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create article comment reply action has been performed.
     * @example articleCommentRepliesClient.create('<article-id>', {
                    commentId : '<comment-id>',
                    comment : <comment>,
                    userId : '<user-id>' })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleCommentRepliesClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article comment reply resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleCommentRepliesClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleCommentRepliesClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the flag article comment reply action has been performed. This action sets the state of an article comment reply to "flagged". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-flag').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the flag article comment reply action has been performed.
     * @example     // articleCommentReply is a resource previously fetched using get action.
                        articleCommentRepliesClient.flag(articleCommentReply)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                // perform error handling here
                            });
     **/
    ArticleCommentRepliesClient.prototype.flag = function (data) {
        return this.apiClient.put(this.routeDefinition.flag(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unflag article comment reply action has been performed. This action removes the "flagged" comment reply state. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-unflag').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the unflag article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleCommentRepliesClient.unflag(articleCommentReply)
                        .success(function (data) {
                            // perform success action here
                        }).error(function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentRepliesClient.prototype.unflag = function (data) {
        return this.apiClient.put(this.routeDefinition.unflag(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified article comment reply resource.
     * @method
     * @param id Id which uniquely identifies article comment reply resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleCommentRepliesClient.get('<comment-reply-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    ArticleCommentRepliesClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.articleCommentRepliesRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove article comment reply action has been performed. If the action is successfully completed, the article comment reply resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = apiClient.removeParams(articleCommentReply);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An article Comment Reply object used to update specified article comment reply resource.
     * @returns A promise that is resolved once the remove article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleCommentRepliesClient.remove(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentRepliesClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the report article comment reply action has been performed. This action sets the state of an article comment reply to "reported". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-report').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @param options Notification configuration used to control the article comment recourse access when managing notification distribution.
     * @returns A promise that is resolved once the report article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleCommentRepliesClient.report(articleCommentReply, commentOptions)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentRepliesClient.prototype.report = function (data, options) {
        return this.apiClient.put(this.routeDefinition.report(data), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the unreport article comment reply action has been performed. This action removes the "reported" comment reply state. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-unreport').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the unreport article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleCommentRepliesClient.unreport(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentRepliesClient.prototype.unreport = function (data) {
        return this.apiClient.put(this.routeDefinition.unreport(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the mark as spam article comment reply action has been performed. This action sets the state of an article comment reply to "spam". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-spam').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the mark as spam article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleCommentRepliesClient.spam(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentRepliesClient.prototype.spam = function (data) {
        return this.apiClient.put(this.routeDefinition.spam(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unspam article comment reply action has been performed. This action removes the "spam" comment reply state. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('comment-unspam').href;
     * ```
     * @method
     * @param data Article Comment Reply object.
     * @returns A promise that is resolved once the unspam article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                      articleCommentRepliesClient.unspam(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentRepliesClient.prototype.unspam = function (data) {
        return this.apiClient.put(this.routeDefinition.unspam(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update article comment reply action has been performed; this action updates an article comment reply resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentRepliesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleCommentReply);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An Article Comments Reply object used to update specified article comment reply resource.
     * @returns A promise that is resolved once the update article comment reply action has been performed.
     * @example // articleCommentReply is a resource previously fetched using get action.
                    articleCommentRepliesClient.update(articleCommentReply)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentRepliesClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    ArticleCommentRepliesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleCommentRepliesRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleCommentRepliesRoute !== "undefined" && _1.ArticleCommentRepliesRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleCommentRepliesClient);
    return ArticleCommentRepliesClient;
}());
exports.ArticleCommentRepliesClient = ArticleCommentRepliesClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleCommentsRoute
 * @description Baasic Article Comments Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Comments Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var ArticleCommentsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleCommentsRoute, _super);
    function ArticleCommentsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'article-comments/{?searchQuery,statuses,page,rpp,sort,embed,fields}';
        _this.getRoute = 'article-comments/{id}/{?embed,fields}';
        _this.createRoute = 'article-comments/';
        _this.updateRoute = 'article-comments/{id}';
        _this.deleteRoute = 'article-comments/{id}';
        _this.approveRoute = 'article-comments/{id}/approve';
        _this.unapproveRoute = 'article-comments/{id}/unapprove';
        _this.flagRoute = 'article-comments/{id}';
        _this.unflagRoute = 'article-comments/{id}/unflag';
        _this.reportRoute = 'article-comments/{id}/report';
        _this.unreportRoute = 'article-comments/{id}/unreport';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify article comment resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article comment subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article comment property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `statuses` - Comma separated list of article comment states that specify where search should be done (Allowed states: Approved, Spam, Reported, Flagged and UnApproved).
     * @method
     * @param options Query resource options object.
     * @example articleCommentsRoute.find({ searchQuery: '<search-phrase>' });
     **/
    ArticleCommentsRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route which can be expanded with additional options. Supported items are:
     * - `id` - Id which uniquely identifies article comment resource that needs to be retrieved.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id Id which uniquely identifies article comment resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example articleCommentsRoute.get().expand({ id: '<comment-id>' });
     **/
    ArticleCommentsRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template doesnt support any additional options.
     * @method
     * @param data An article comment object that needs to be inserted into the system.
     * @example articleCommentsRoute.create(data);
     **/
    ArticleCommentsRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this URI template doesnt support any additional options.
     * @method An article comment object used to update specified article comment resource.
     * @example articleCommentsRoute.update(data);
     **/
    ArticleCommentsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this URI template doesnt support any additional options.
     * @method An article comment object used to delete specified article comment resource.
     * @example articleCommentsRoute.delete(data);
     **/
    ArticleCommentsRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
    * Parses approve route; this URI template doesnt support any additional options.
    * @method An article comment object.
    * @example articleCommentsRoute.approve(data);
    **/
    ArticleCommentsRoute.prototype.approve = function (data) {
        return _super.prototype.baseUpdate.call(this, this.approveRoute, data, undefined, 'comment-approve');
    };
    /**
    * Parses unapprove route; this URI template doesnt support any additional options.
    * @method An article comment object.
    * @example articleCommentsRoute.unapprove(data);
    **/
    ArticleCommentsRoute.prototype.unapprove = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unapproveRoute, data, undefined, 'comment-unapprove');
    };
    /**
    * Parses flag route; this URI template doesnt support any additional options.
    * @method An article comment object.
    * @example articleCommentsRoute.flag(data);
    **/
    ArticleCommentsRoute.prototype.flag = function (data) {
        return _super.prototype.baseUpdate.call(this, this.flagRoute, data, undefined, 'comment-flag');
    };
    /**
    * Parses unflag route; this URI template doesnt support any additional options.
    * @method An article comment object.
    * @example articleCommentsRoute.unflag(data);
    **/
    ArticleCommentsRoute.prototype.unflag = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unflagRoute, data, undefined, 'comment-unflag');
    };
    /**
    * Parses report route; this URI template doesnt support any additional options.
    * @method An article comment object.
    * @example articleCommentsRoute.report(data);
    **/
    ArticleCommentsRoute.prototype.report = function (data) {
        return _super.prototype.baseUpdate.call(this, this.reportRoute, data, undefined, 'comment-report');
    };
    /**
    * Parses unreport route; this URI template doesnt support any additional options.
    * @method An article comment object.
    * @example articleCommentsRoute.unreport(data);
    **/
    ArticleCommentsRoute.prototype.unreport = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unreportRoute, data, undefined, 'comment-unreport');
    };
    var _a;
    ArticleCommentsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleCommentsRoute);
    return ArticleCommentsRoute;
}(common_1.BaseRoute));
exports.ArticleCommentsRoute = ArticleCommentsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleCommentsClient
 * @description  Article Comments Client provides an easy way to consume  Article Comments REST API end-points. `articleCommentsClient` functions enable performing standard CRUD operations directly on article comment resources, whereas the `articleClient` functions allow management between article and article comments. In order to obtain needed routes `articleCommentsClient` uses `articleCommentsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleCommentsClient = /** @class */ (function () {
    function ArticleCommentsClient(articleCommentRepliesClient, articleCommentsRoute, apiClient) {
        this.articleCommentRepliesClient = articleCommentRepliesClient;
        this.articleCommentsRoute = articleCommentsRoute;
        this.apiClient = apiClient;
        /**
        * Contains a reference to valid list of article comment states. It returns an object containing all article comment states.
        * @method
        * @example articleCommentsClient.statuses.approved;
        **/
        this.statuses = _1.CommentStatus;
    }
    Object.defineProperty(ArticleCommentsClient.prototype, "replies", {
        /**
         * Provides direct access to `articleCommentRepliesClient`.
         * @method
         **/
        get: function () {
            return this.articleCommentRepliesClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleCommentsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `articleCommentsRoute`.
         * @method
         * @example articleCommentsRoute.routeDefinition.get();
         **/
        get: function () {
            return this.articleCommentsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the approve article comment action has been performed. This action sets the state of an article comment to "approved". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-approve').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @param options Notification configuration used to control the article comment recourse access when managing notification distribution.
     * @returns A promise that is resolved once the approve article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleCommentsClient.approve(articleComment, commentOptions)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentsClient.prototype.approve = function (data, options) {
        return this.apiClient.put(this.routeDefinition.approve(data), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the unapprove article comment action has been performed. This action sets the state of an article comment to "unapproved". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-unapprove').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the unapprove article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleCommentsClient.unapprove(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentsClient.prototype.unapprove = function (data) {
        return this.apiClient.put(this.routeDefinition.unapprove(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create article comment action has been performed; this action creates a new comment for an article.
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the create article comment action has been performed.
     * @example articleCommentsClient.create({
                        articleId : '<article-id>',
                        comment : <comment>,
                        userId : '<user-id>' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleCommentsClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article comment resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleCommentsClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .success(function (collection) {
                    // perform success action here
                })
                .error(function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleCommentsClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the flag article comment action has been performed. This action sets the state of an article comment to "flagged". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-flag').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the flag article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleCommentsClient.flag(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentsClient.prototype.flag = function (data) {
        return this.apiClient.put(this.routeDefinition.flag(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unflag article comment action has been performed. This action removes the "flagged" comment mark. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-unflag').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the unflag article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleCommentsClient.unflag(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentsClient.prototype.unflag = function (data) {
        return this.apiClient.put(this.routeDefinition.unflag(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified article comment resource.
     * @method
     * @param id Id which uniquely identifies article comment resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleCommentsClient.get('<article-id>', '<comment-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleCommentsClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.articleCommentsRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove article comment action has been performed. If the action is successfully completed, the article comment resource and its replies will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     ```
     let params = modelMapper.removeParams(articleComment);
     let uri = params['model'].links('delete').href;
     ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the remove article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                       articleCommentsClient.remove(articleComment)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                               // perform error handling here
                           });
    **/
    ArticleCommentsClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the report article comment action has been performed. This action sets the state of an article comment to "reported". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-report').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @param options Notification configuration used to control the article comment recourse access when managing notification distribution.
     * @returns A promise that is resolved once the report article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleCommentsClient.report(articleComment, commentOptions)
                        .success(function (data) {
                            // perform success action here
                        })
                        .error(function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentsClient.prototype.report = function (data, options) {
        return this.apiClient.put(this.routeDefinition.report(data), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the unreport article comment action has been performed. This action removes the "reported" comment mark. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('comment-unreport').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the unreport article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleCommentsClient.unreport(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleCommentsClient.prototype.unreport = function (data) {
        return this.apiClient.put(this.routeDefinition.unreport(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update article comment action has been performed; this action updates an article comment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleCommentsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(articleComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data Article Comment object.
     * @returns A promise that is resolved once the update article comment action has been performed.
     * @example // articleComment is a resource previously fetched using get action.
                    articleCommentsClient.update(articleComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleCommentsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    ArticleCommentsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleCommentRepliesClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ArticleCommentsRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleCommentRepliesClient !== "undefined" && _1.ArticleCommentRepliesClient) === "function" ? _a : Object, typeof (_b = typeof _1.ArticleCommentsRoute !== "undefined" && _1.ArticleCommentsRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], ArticleCommentsClient);
    return ArticleCommentsClient;
}());
exports.ArticleCommentsClient = ArticleCommentsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleFilesBatchRoute
 * @description Baasic Article Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Batch Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ArticleFilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleFilesBatchRoute, _super);
    function ArticleFilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.unlinkRoute = 'article-files/batch/unlink';
        _this.updateRoute = 'article-files/batch';
        _this.linkRoute = 'article-files/batch/link';
        return _this;
    }
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @example articleFilesBatchRoute.unlink();
     **/
    ArticleFilesBatchRoute.prototype.unlink = function () {
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example articleFilesStreamsRoute.update();
     **/
    ArticleFilesBatchRoute.prototype.update = function () {
        return _super.prototype.baseCreate.call(this, this.updateRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example articleFilesStreamsRoute.link();
     **/
    ArticleFilesBatchRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    var _a;
    ArticleFilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleFilesBatchRoute);
    return ArticleFilesBatchRoute;
}(common_1.BaseRoute));
exports.ArticleFilesBatchRoute = ArticleFilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleFilesBatchClient
 * @description  Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleFilesBatchClient = /** @class */ (function () {
    function ArticleFilesBatchClient(articleFilesBatchRoute, apiClient) {
        this.articleFilesBatchRoute = articleFilesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleFilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will remove just derived resource. Otherwise, specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param data Collection of article files that needs to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                   articleFilesBatchClient.unlink([{ id: '<file-id>' }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
               // Remove derived file resources
                   articleFilesBatchClient.unlink([{ id: '<file-id>', fileFormat: { width: <width>, height: <height> } }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    ArticleFilesBatchClient.prototype.unlink = function (data) {
        return this.apiClient.delete(this.articleFilesBatchRoute.unlink(), undefined, data);
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param data A collection of article files objects used to update specified article files.
     * @returns A promise that is resolved once the update action has been performed.
     * @example articleFilesClient.batch.update(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleFilesBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param data A collection of article file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example articleFilesClient.batch.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleFilesBatchClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    ArticleFilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleFilesBatchRoute !== "undefined" && _1.ArticleFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleFilesBatchClient);
    return ArticleFilesBatchClient;
}());
exports.ArticleFilesBatchClient = ArticleFilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleFilesStreamsRoute
 * @description Baasic Article Files Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Streams Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ArticleFilesStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleFilesStreamsRoute, _super);
    function ArticleFilesStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'article-file-streams/{id}/{?width,height,t}';
        _this.createRoute = 'article-file-streams/{filename}/{?articleId}';
        _this.updateRoute = 'article-file-streams/{id}/{?width,height}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id of desired file stream. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @param data Article file id of the original article file used to identify stream that needs to be retrieved from the system.
     * @example articleFilesRoute.get({id: '<filename>'});
     **/
    ArticleFilesStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the filename which indicates where the stream will be saved.
     * @method
     * @param data article file that needs to be saved into the system.
     * @example articleFilesRoute.create({filename: '<filename>'});
     **/
    ArticleFilesStreamsRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this route should be expanded with the id of the previously saved resource. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @param data article file used to identify stream that needs to be updated.
     * @example articleFilesRoute.update({id: '<filename>'});
     **/
    ArticleFilesStreamsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    ArticleFilesStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleFilesStreamsRoute);
    return ArticleFilesStreamsRoute;
}(common_1.BaseRoute));
exports.ArticleFilesStreamsRoute = ArticleFilesStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleFilesStreamsClient
 * @description  Article Files Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleFilesStreamsClient = /** @class */ (function () {
    function ArticleFilesStreamsClient(articleFilesStreamsRoute, apiClient) {
        this.articleFilesStreamsRoute = articleFilesStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleFilesStreamsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a stream of the derived resource. Otherwise, stream of the original file resource will be retrieved.
     * @method
     * @param data Article file id of the original article file used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original file stream
                    articleFilesStreamsClient.get({id: '<file-id>'})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });

                // Request derived file stream
                        articleFilesStreamsClient.get({id: '<file-id>', width: <width>, height: <height>, t: <timestamp>})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    ArticleFilesStreamsClient.prototype.get = function (data) {
        return this.apiClient.get(this.routeDefinition.get(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a blob of the derived file resource. Otherwise, blob of the original file resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param data Article file id of the original article file used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original blob
                    articleFilesStreamsClient.getBlob('<file-id>')
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });

                // Request derived blob
                        articleFilesStreamsClient.getBlob({
                            id: '<file-id>',
                            width: <width>,
                            height: <height>,
                            t: <timestamp>
                        })
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleFilesStreamsClient.prototype.getBlob = function (data) {
        return this.apiClient.request({
            url: this.articleFilesStreamsRoute.get(data),
            responseType: 'blob',
            headers: { 'Accept': 'application/octet-stream' },
            method: 'GET'
        });
    };
    /**
     * Returns a promise that is resolved once the update file stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of file stream data type).
     * @method
     * @param data article file used to identify stream that needs to be updated.
     * @param stream
     * @returns A promise that is resolved once the update file stream action has been performed.
     * @example // Update original file stream
                    articleFilesStreamsClient.update('<file-id>', <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
                // Update derived file stream
                    articleFilesStreamsClient.update({id: '<file-id>', width: <width>, height: <height>}, <file-stream>)
                        .then(function (data) {
                            //  perform success action here
                       },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleFilesStreamsClient.prototype.update = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.articleFilesStreamsRoute.update(data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the create file stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param data article file that needs to be saved into the system.
     * @param stream
     * @returns A promise that is resolved once the create file stream action has been performed.
     * @example articleFilesStreamsClient.create('<file-id>', <blob>)
                   .then(function (data) {
                        // perform success action her
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleFilesStreamsClient.prototype.create = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.articleFilesStreamsRoute.create(data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    ArticleFilesStreamsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleFilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleFilesStreamsRoute !== "undefined" && _1.ArticleFilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleFilesStreamsClient);
    return ArticleFilesStreamsClient;
}());
exports.ArticleFilesStreamsClient = ArticleFilesStreamsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleFilesRoute
 * @description Baasic Article Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(6);
var ArticleFilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleFilesRoute, _super);
    function ArticleFilesRoute(articleFilesStreamsRoute, articleFilesBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.articleFilesStreamsRoute = articleFilesStreamsRoute;
        _this.articleFilesBatchRoute = articleFilesBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'article-files/{?searchQuery,fileName,minFileSize,maxFileSize,ids,from,to,age,rpp,sort,embed,fields}';
        _this.getRoute = 'article-files/{id}/{?embed,fields}';
        _this.linkRoute = 'article-files/link';
        _this.unlinkRoute = 'article-files/unlink/{id}';
        _this.updateRoute = 'article-files/{id}';
        return _this;
    }
    Object.defineProperty(ArticleFilesRoute.prototype, "streams", {
        get: function () {
            return this.articleFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleFilesRoute.prototype, "batch", {
        get: function () {
            return this.articleFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example articleFilesRoute.find({searchQuery: '<search-phrase>'});
     **/
    ArticleFilesRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param id Article file id which uniquely identifies article resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example articleFilesRoute.get({id: '<file-id>'});
     **/
    ArticleFilesRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @example articleFilesRoute.link();
     **/
    ArticleFilesRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @example articleFilesRoute.unlink(data);
     **/
    ArticleFilesRoute.prototype.unlink = function (data, options) {
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data, options, 'unlink');
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example articleFilesRoute.update(data);
     **/
    ArticleFilesRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b, _c;
    ArticleFilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleFilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ArticleFilesBatchRoute)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleFilesStreamsRoute !== "undefined" && _1.ArticleFilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.ArticleFilesBatchRoute !== "undefined" && _1.ArticleFilesBatchRoute) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _c : Object])
    ], ArticleFilesRoute);
    return ArticleFilesRoute;
}(common_1.BaseRoute));
exports.ArticleFilesRoute = ArticleFilesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleFilesClient
 * @description  Files Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleFilesClient = /** @class */ (function () {
    function ArticleFilesClient(articleFilesRoute, articleFilesStreamsClient, ArticleFilesBatchClient, apiClient) {
        this.articleFilesRoute = articleFilesRoute;
        this.articleFilesStreamsClient = articleFilesStreamsClient;
        this.ArticleFilesBatchClient = ArticleFilesBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleFilesClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleFilesRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleFilesClient.prototype, "streams", {
        get: function () {
            return this.articleFilesStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleFilesClient.prototype, "batch", {
        get: function () {
            return this.ArticleFilesBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of file resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleFilesClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleFilesClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested file resource.
     * @method
     * @param id Article file id which uniquely identifies article resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleFilesClient.get('<file-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleFilesClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.articleFilesRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove one or many file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicArticleFilesRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink').href;
     * ```
     * @method
     * @param data Article file object.
     * @param options options object.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action. The following action will remove the original file resource and all accompanying derived file resources.
                    articleFilesRoute.remove(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleFilesClient.prototype.unlink = function (data, options) {
        if (!options) {
            options = {};
        }
        return this.apiClient.delete(this.articleFilesRoute.unlink(data, options));
    };
    /**
     * Returns a promise that is resolved once the update file action has been performed; this action will update a file resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicArticleFilesRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     ```
     let params = modelMapper.updateParams(fileEntry);
     let uri = params['model'].links('put').href;
     ```
     * @method
     * @param data Article file object that need to be updated in the system.
     * @returns A promise that is resolved once the update file action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                   fileEntry.description = '<description>';
                   articleFilesClient.update(fileEntry)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    ArticleFilesClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resource from other modules into the Article Files module (For example: file resources from the Media Vault module can be linked directly into the Article Files module).
     * @method
     * @param data Article file object.
     * @returns A promise that is resolved once the link action has been performed.
     * @example articleFilesClient.link(fileObject)
                    .then(function (response, status, headers, config) {
                        // perform success handling here
                    },
                        function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleFilesClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c, _d;
    ArticleFilesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleFilesRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ArticleFilesStreamsClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.ArticleFilesBatchClient)),
        tslib_1.__param(3, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleFilesRoute !== "undefined" && _1.ArticleFilesRoute) === "function" ? _a : Object, typeof (_b = typeof _1.ArticleFilesStreamsClient !== "undefined" && _1.ArticleFilesStreamsClient) === "function" ? _b : Object, typeof (_c = typeof _1.ArticleFilesBatchClient !== "undefined" && _1.ArticleFilesBatchClient) === "function" ? _c : Object, typeof (_d = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _d : Object])
    ], ArticleFilesClient);
    return ArticleFilesClient;
}());
exports.ArticleFilesClient = ArticleFilesClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleRatingsRoute
 * @description Baasic Article Ratings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Ratings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var ArticleRatingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleRatingsRoute, _super);
    function ArticleRatingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'article-ratings';
        _this.findRoute = 'article-ratings/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.findByUserRoute = 'article-ratings/{?username,page,rpp,sort,embed,fields}';
        _this.getRoute = 'article-ratings/{id}/{?embed,fields}';
        _this.updateRoute = 'article-ratings/{id}';
        _this.deleteRoute = 'article-ratings/{id}';
        return _this;
    }
    /**
     * Parses create article rating route; this URI does not support any additional embed items.
     * @method
     * @param data An article rating object that needs to be inserted into the system.
     * @example articleRatingsRoute.create(data);
     **/
    ArticleRatingsRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses find article rating route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing article rating properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article rating subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article rating property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example articleRatingsRoute.find({searchQuery: '<search-phrase>'});
     **/
    ArticleRatingsRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses findByUser article rating route which can be expanded with additional options. Supported items are:
     * - `username` - A value that uniquely identifies a user which has created an article rating.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article rating subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article rating property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param username Username which uniquely identifies a user which has created an article rating.
     * @param options Query resource options object.
     * @example articleRatingsRoute.find({username: '<username>'});
     **/
    ArticleRatingsRoute.prototype.findByUser = function (username, options) {
        var params = this.utility.extend({}, options);
        params.username = username;
        return _super.prototype.baseFind.call(this, this.findByUserRoute, params);
    };
    /**
     * Parses get article rating route which must be expanded with the Id of the previously created article rating resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id Id which uniquely identifies article rating resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example articleRatingsRoute.get({id: '<articleRating-id>'});
     **/
    ArticleRatingsRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update article rating route; this URI does not support any additional embed items.
     * @method
     * @param data An article object used to update specified article rating resource.
     * @example articleRatingsRoute.update(data);
     **/
    ArticleRatingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete article rating route; this URI does not support any additional embed items.
    * @method
    * @param data An article object used to delete specified article rating resource.
    * @example articleRatingsRoute.delete(data);
    **/
    ArticleRatingsRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    ArticleRatingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleRatingsRoute);
    return ArticleRatingsRoute;
}(common_1.BaseRoute));
exports.ArticleRatingsRoute = ArticleRatingsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleRatingsClient
 * @description  Article Ratings Client provides an easy way to consume  Article Ratings REST API end-points. `articleRatingsClient` functions enable performing standard CRUD operations directly on article rating resources, whereas the `articleService` functions allow management between article and article rating. In order to obtain needed routes `articleRatingsClient` uses `articleRatingsRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleRatingsClient = /** @class */ (function () {
    function ArticleRatingsClient(articleRatingsRoute, apiClient) {
        this.articleRatingsRoute = articleRatingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleRatingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `articleRatingsRoute`.
         * @method
         * @example articleRatingsClient.routeDefinition.get(id);
         **/
        get: function () {
            return this.articleRatingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create article rating action has been performed; this action creates a new rating for an article.
     * @method
     * @param data An article rating object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create article rating action has been performed.
     * @example articleRatingsClient.create({
                    articleId : '<article-id>',
                    rating : 5,
                    userId : '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleRatingsClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article rating resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleRatingsClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleRatingsClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the findByUser action has been performed. Success response returns a list of article rating resources filtered by username.
     * @method
     * @param username Username which uniquely identifies a user which has created an article rating.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the findByUser action has been performed.
     * @example articleRatingsClient.find('<username>', {
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleRatingsClient.prototype.findByUser = function (username, options) {
        return this.apiClient.get(this.articleRatingsRoute.findByUser(username, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified article rating resource.
     * @method
     * @param id Id which uniquely identifies article rating resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleRatingsClient.get('<articleRating-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleRatingsClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.articleRatingsRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update article rating action has been performed; this action updates an article rating. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRatingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleRating);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An article object used to update specified article rating resource.
     * @returns A promise that is resolved once the update article rating action has been performed.
     * @example // articleRating is a resource previously fetched using get action.
                    articleRating.rating = 4;
                    articleRatingsClient.update(articleRating)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleRatingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove article rating action has been performed. If the action is successfully completed, the article rating resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRatingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleRating);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An article object used to delete specified article rating resource.
     * @returns A promise that is resolved once the remove article rating action has been performed.
     * @example // articleRating is a resource previously fetched using get action.
                    articleRatingsClient.remove(articleRating)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleRatingsClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    ArticleRatingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleRatingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleRatingsRoute !== "undefined" && _1.ArticleRatingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleRatingsClient);
    return ArticleRatingsClient;
}());
exports.ArticleRatingsClient = ArticleRatingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
* @module articleSettingsRoute
* @description Baasic Article Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Settings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var ArticleSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleSettingsRoute, _super);
    function ArticleSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'article-settings/{?embed,fields}';
        _this.updateRoute = 'article-settings/{id}';
        return _this;
    }
    /**
     * Parses get article settings route; this URI template doesn't expose any additional properties.
     * @method
     * @param options Options object that contains embed data.
     * @example articleSettingsRoute.get(options);
     **/
    ArticleSettingsRoute.prototype.get = function (options) {
        return _super.prototype.baseGet.call(this, this.getRoute, undefined, options);
    };
    /**
     * Parses update article settings route; this URI template doesn't expose any additional properties.
     * @method
     * @param options Options object that contains embed data.
     * @example articleSettingsRoute.update(data);
     **/
    ArticleSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    ArticleSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleSettingsRoute);
    return ArticleSettingsRoute;
}(common_1.BaseRoute));
exports.ArticleSettingsRoute = ArticleSettingsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSettingsClient
 * @description  Article Settings Client provides an easy way to consume  Article Settings REST API end-points. In order to obtain needed routes `articleSettingsClient` uses `articleSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleSettingsClient = /** @class */ (function () {
    function ArticleSettingsClient(articleSettingsRoute, apiClient) {
        this.articleSettingsRoute = articleSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleSettingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `baasicArticleSettingsRouteService`.
         * @method
         * @example articleSettingsClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.articleSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the article settings.
     * @method
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleSettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleSettingsClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update article settings action has been performed; this action updates article settings. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleSettings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the update article settings action has been performed.
     * @example // articleSettings is a resource previously fetched using get action.
                    articleSettings.allowArchive = true;
                    articleSettingsClient.update(articleSettings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    ArticleSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleSettingsRoute !== "undefined" && _1.ArticleSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleSettingsClient);
    return ArticleSettingsClient;
}());
exports.ArticleSettingsClient = ArticleSettingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleTagsSubscriptionsRoute
 * @description Baasic Article Tags Subscriptions Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Tags Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ArticleTagsSubscriptionsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleTagsSubscriptionsRoute, _super);
    function ArticleTagsSubscriptionsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.subscribeRoute = 'article-tags/{id}/subscriptions';
        _this.isSubscribedRoute = 'article-tags/{id}/subscriptions/{subscriberId}';
        _this.unSubscribeRoute = 'article-tags/{id}/subscriptions';
        return _this;
    }
    /**
     * Parses subscribe route which must be expanded with id of the tag.
     * @method
     * @param tag article tag object.
     * @param data The subscribe information.
     * @example articleTagsSubscriptionsRoute.subscribe( {id: '<tag-id>'} );
     **/
    ArticleTagsSubscriptionsRoute.prototype.subscribe = function (tag, data) {
        var params = this.utility.extend(tag, data);
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, params);
    };
    /**
     * Parses isSubscribed route which must be expanded with subscriber id and the id of the tag.
     * @method
     * @param tag Article tag object.
     * @param data The subscriber identifier.
     * @example articleSubscriptionsRoute.isSubscribed({ id: '<tag-id>', subscriberId: '<subscriber-id>' });
     **/
    ArticleTagsSubscriptionsRoute.prototype.isSubscribed = function (tag, data) {
        var params = this.utility.extend(tag, data);
        return _super.prototype.baseCreate.call(this, this.isSubscribedRoute, params);
    };
    /**
     * Parses unSubscribe route which must be expanded with the id of the article.
     * @method
     * @param tag Article tag object.
     * @param data The unsubscribe information.
     * @example articleUnSubscribeRoute.unSubscribe({id: '<tag-id>'});
     **/
    ArticleTagsSubscriptionsRoute.prototype.unSubscribe = function (tag, data) {
        var params = this.utility.extend(tag, data);
        return _super.prototype.baseCreate.call(this, this.unSubscribeRoute, params);
    };
    ArticleTagsSubscriptionsRoute.prototype.subscribeParams = function (tag, data) {
        return this.utility.extend(tag, data);
    };
    var _a;
    ArticleTagsSubscriptionsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleTagsSubscriptionsRoute);
    return ArticleTagsSubscriptionsRoute;
}(common_1.BaseRoute));
exports.ArticleTagsSubscriptionsRoute = ArticleTagsSubscriptionsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
- All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module baasicArticleTagsSubscriptionsDefinition
 * @description  Article Tags Subscriptions Definition provides an easy way to consume  Article Tags REST API end-points. `articleTagsDefinition` functions enable performing standard CRUD operations directly on article tag resources, whereas the `articleClient` functions allow management between article and article tag. In order to obtain needed routes `articleTagsDefinition` uses `articleTagsRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleTagsSubscriptionsClient = /** @class */ (function () {
    function ArticleTagsSubscriptionsClient(articleTagsSubscriptionsRoute, apiClient) {
        this.articleTagsSubscriptionsRoute = articleTagsSubscriptionsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleTagsSubscriptionsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleTagsSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the subscribe action has been performed. This action subscribes an user to the specified tag.
     * @method
     * @param tag article tag object.
     * @param data The subscribe information.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example articleTagsSubscriptionsClient.subscribe(tag, user)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleTagsSubscriptionsClient.prototype.subscribe = function (tag, data) {
        return this.apiClient.post(this.routeDefinition.subscribe(tag, data), this.routeDefinition.subscribeParams(tag, data));
    };
    /**
     * Returns a promise that is resolved once the isSubscribed action has been performed. This action checks if a user is subscribed to the specified tag.
     * @method
     * @param tag Article tag object.
     * @param data The subscriber identifier.
     * @returns A promise that is resolved once the isSubscribed action has been performed.
     * @example articleTagsSubscriptionsClient.isSubscribed(tag, user)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ArticleTagsSubscriptionsClient.prototype.isSubscribed = function (tag, data) {
        return this.apiClient.get(this.articleTagsSubscriptionsRoute.isSubscribed(tag, data));
    };
    /**
     * Returns a promise that is resolved once the unSubscribe action has been performed. This action unsubscribes a user from the specified tag.
     * @method
     * @param tag Article tag object.
     * @param data The unsubscribe information.
     * @returns A promise that is resolved once the unSubscribe action has been performed.
     * @example articleTagsSubscriptionsClient.unSubscribe(tag, user)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleTagsSubscriptionsClient.prototype.unSubscribe = function (tag, data) {
        return this.apiClient.delete(this.routeDefinition.unSubscribe(tag, data), this.routeDefinition.subscribeParams(tag, data));
    };
    var _a, _b;
    ArticleTagsSubscriptionsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleTagsSubscriptionsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleTagsSubscriptionsRoute !== "undefined" && _1.ArticleTagsSubscriptionsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleTagsSubscriptionsClient);
    return ArticleTagsSubscriptionsClient;
}());
exports.ArticleTagsSubscriptionsClient = ArticleTagsSubscriptionsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleTagsRoute
 * @description Baasic Article Tags Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Tags Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(6);
var ArticleTagsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleTagsRoute, _super);
    function ArticleTagsRoute(articleTagsSubscriptionsRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.articleTagsSubscriptionsRoute = articleTagsSubscriptionsRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'article-tags/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'article-tags/{id}/{?embed,fields}';
        _this.updateRoute = 'article-tags/{id}';
        _this.deleteRoute = 'article-tags/{id}';
        return _this;
    }
    Object.defineProperty(ArticleTagsRoute.prototype, "subscriptions", {
        get: function () {
            return this.articleTagsSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find article tags route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify article tags using the phrase search; multiple tag keywords must be comma separated.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article tag subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article tag property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example articleTagsRoute.find().expand({searchQuery: '<search-phrase>'});
     **/
    ArticleTagsRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id Article tag id or slug that uniquely identifies article tag resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example articleTagsRoute.get({id: '<articleTag-id>'});
     **/
    ArticleTagsRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param data An article tag object used to update specified article tag resource.
     * @example articleTagsRoute.update({id: '<articleTag-id>'});
     **/
    ArticleTagsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses get article tag route which must be expanded with the Id of the previously created article tag resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param data An article tag object used to delete specified article tag resource.
     * @example articleTagsRoute.delete({id: '<articleTag-id>'});
     **/
    ArticleTagsRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    ArticleTagsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleTagsSubscriptionsRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleTagsSubscriptionsRoute !== "undefined" && _1.ArticleTagsSubscriptionsRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], ArticleTagsRoute);
    return ArticleTagsRoute;
}(common_1.BaseRoute));
exports.ArticleTagsRoute = ArticleTagsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
- All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module baasicArticleTagsDefinition
 * @description  Article Tags Definition provides an easy way to consume  Article Tags REST API end-points. `articleTagsDefinition` functions enable performing standard CRUD operations directly on article tag resources, whereas the `articleClient` functions allow management between article and article tag. In order to obtain needed routes `articleTagsDefinition` uses `articleTagsRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleTagsClient = /** @class */ (function () {
    function ArticleTagsClient(articleTagsRoute, articleTagsSubscriptionsClient, apiClient) {
        this.articleTagsRoute = articleTagsRoute;
        this.articleTagsSubscriptionsClient = articleTagsSubscriptionsClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleTagsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleTagsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleTagsClient.prototype, "subscriptions", {
        get: function () {
            return this.articleTagsSubscriptionsClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article tag resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleTagsClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ArticleTagsClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified article tag resource.
     * @method
     * @param id Article tag id or slug that uniquely identifies article tag resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example articleTagsClient.get('<articleTag-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    ArticleTagsClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.articleTagsRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update article tag action has been performed; this action updates a tag. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleTagsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleTag);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An article tag object used to update specified article tag resource.
     * @returns A promise that is resolved once the update article tag action has been performed.
     * @example // articleTag is a resource previously fetched using get action.
                    articleTag.tag = '<new-tag>';
                    articleTagsClient.update(articleTag)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleTagsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove article tag action has been performed. If the action is successfully completed, the article tag resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleTagsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(articleTag);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An article tag object used to delete specified article tag resource.
     * @returns A promise that is resolved once the remove article tag action has been performed.
     * @example // articleTag is a resource previously fetched using get action.
                    articleTagsClient.remove(articleTag)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ArticleTagsClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    ArticleTagsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleTagsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ArticleTagsSubscriptionsClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleTagsRoute !== "undefined" && _1.ArticleTagsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.ArticleTagsSubscriptionsClient !== "undefined" && _1.ArticleTagsSubscriptionsClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], ArticleTagsClient);
    return ArticleTagsClient;
}());
exports.ArticleTagsClient = ArticleTagsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module ArticleSubscriptionsRoute
 * @description Baasic Article Subscriptions Article Module Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Subscriptions Article Module Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ArticleSubscriptionsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleSubscriptionsRoute, _super);
    function ArticleSubscriptionsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.subscribeRoute = 'articles/subscriptions';
        _this.isSubscribedRoute = 'articles/subscriptions/{subscriberId}';
        _this.unSubscribeRoute = 'articles/subscriptions';
        return _this;
    }
    /**
     * Parses article module subscribe route which doesn't support any additional options.
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsRoute.subscribe(data);
     **/
    ArticleSubscriptionsRoute.prototype.subscribe = function (data) {
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, data);
    };
    /**
     * Parses article module isSubscribed route which must be expanded with subscriber Id
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsRoute.isSubscribed({subscriberId: '<subscriber-id>'});
     **/
    ArticleSubscriptionsRoute.prototype.isSubscribed = function (data) {
        return _super.prototype.baseCreate.call(this, this.isSubscribedRoute, data);
    };
    /**
     * Parses article module unSubscribe route which doesn't support any additional options.
     * @method
     * @param data The subscribe information.
     * @example articleSubscriptionsRoute.unSubscribe(data);
     **/
    ArticleSubscriptionsRoute.prototype.unSubscribe = function (data) {
        return _super.prototype.baseCreate.call(this, this.unSubscribeRoute, data);
    };
    var _a;
    ArticleSubscriptionsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ArticleSubscriptionsRoute);
    return ArticleSubscriptionsRoute;
}(common_1.BaseRoute));
exports.ArticleSubscriptionsRoute = ArticleSubscriptionsRoute;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleSubscriptionsArticleModuleClient
 * @description  Article Subscriptions Article Module Client provides an easy way to consume  Articles REST API end-points. In order to obtain needed routes `articleSubscriptionsClient` uses `articleSubscriptionsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(6);
var ArticleSubscriptionsClient = /** @class */ (function () {
    function ArticleSubscriptionsClient(articleSubscriptionsRoute, apiClient) {
        this.articleSubscriptionsRoute = articleSubscriptionsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ArticleSubscriptionsClient.prototype, "routeDefinition", {
        get: function () {
            return this.articleSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Subscribes user or existing user to article module updates. Returns a promise that is resolved once the subscribe action has been performed. This action subscribes an user to the article module.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example articleSubscriptionsArticleModuleClient.subscribe(data)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    ArticleSubscriptionsClient.prototype.subscribe = function (data) {
        return this.apiClient.post(this.articleSubscriptionsRoute.subscribe(data), data);
    };
    /**
     * Determines whether existing or anonymous user are subscribed to article module updates. Returns a promise that is resolved once the isSubscribed action has been performed. This action checks if a user is subscribed to the article module.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the isSubscribed action has been performed.
     * @example articleSubscriptionsArticleModuleClient.isSubscribe(data)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
     **/
    ArticleSubscriptionsClient.prototype.isSubscribed = function (data) {
        return this.apiClient.get(this.routeDefinition.isSubscribed(data));
    };
    /**
     * Unsubscribe existing or anonymous user from article module updates. Returns a promise that is resolved once the unSubscribe action has been performed. This action unsubscribes a user from the article module.
     * @method
     * @param data The subscribe information.
     * @returns A promise that is resolved once the unSubscribe action has been performed.
     * @example articleSubscriptionsArticleModuleClient.unSubscribe(data)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });                          **/
    ArticleSubscriptionsClient.prototype.unSubscribe = function (data) {
        return this.apiClient.delete(this.routeDefinition.unSubscribe(data));
    };
    var _a, _b;
    ArticleSubscriptionsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleSubscriptionsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleSubscriptionsRoute !== "undefined" && _1.ArticleSubscriptionsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ArticleSubscriptionsClient);
    return ArticleSubscriptionsClient;
}());
exports.ArticleSubscriptionsClient = ArticleSubscriptionsClient;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module articleRoute
 * @description Baasic Article Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(6);
var ArticleRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ArticleRoute, _super);
    function ArticleRoute(articleSubscriptionsRoute, articleInstanceCommentsRoute, articleInstanceFilesRoute, articleInstanceRatingsRoute, articleInstanceTagsRoute, articleACLRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.articleSubscriptionsRoute = articleSubscriptionsRoute;
        _this.articleInstanceCommentsRoute = articleInstanceCommentsRoute;
        _this.articleInstanceFilesRoute = articleInstanceFilesRoute;
        _this.articleInstanceRatingsRoute = articleInstanceRatingsRoute;
        _this.articleInstanceTagsRoute = articleInstanceTagsRoute;
        _this.articleACLRoute = articleACLRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'articles/{?searchQuery,page,rpp,sort,embed,fields,statuses,tags,startDate,endDate}';
        _this.getRoute = 'articles/{id}/{?embed,fields}';
        _this.publishRoute = 'articles/{id}/publish/';
        _this.purgeRoute = 'articles/purge/';
        _this.createRoute = 'articles';
        _this.updateRoute = 'articles/{id}';
        _this.deleteRoute = 'articles/{id}';
        _this.archiveRoute = 'articles/{id}/archive';
        _this.restoreRoute = 'articles/{id}/restore';
        _this.unpublishRoute = 'articles/{id}/unpublish';
        return _this;
    }
    Object.defineProperty(ArticleRoute.prototype, "subscriptions", {
        get: function () {
            return this.articleSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleRoute.prototype, "comments", {
        get: function () {
            return this.articleInstanceCommentsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleRoute.prototype, "files", {
        get: function () {
            return this.articleInstanceFilesRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleRoute.prototype, "ratings", {
        get: function () {
            return this.articleInstanceRatingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleRoute.prototype, "tags", {
        get: function () {
            return this.articleInstanceTagsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ArticleRoute.prototype, "acl", {
        get: function () {
            return this.articleACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find article route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing article properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain article subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the article property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `startDate` - A value used to specify the article creation, publish or archive date date starting from which article resource collection should be returned.
     * - `endDate` - A value used to specify the article creation, publish or archive date until (and including) which article resource collection should be returned.
     * - `statuses` - Comma separated list of article statuses that specify where search should be done (Allowed statuses: Published, Draft and Archived).
     * - `tags` - A value used to restrict the search to article resources with these tags. Multiple tags should be comma separated.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @example articleRoute.find.expand({searchQuery: '<search-phrase>'});
     **/
    ArticleRoute.prototype.find = function (options) {
        var opt = options || {};
        opt.startDate = this.getStartDate(opt);
        opt.endDate = this.getEndDate(opt);
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get article route which must be expanded with the Id of the previously created article resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id Article slug or id which uniquely identifies article resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @example articleRoute.get({id: '<article-id>'});
     **/
    ArticleRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses publish article route which must be expanded with the Id of the previously created article resource in the system.
     * @method
     * @param data An article object.
     * @example articleRoute.publish.expand({id: '<article-id>'});
     **/
    ArticleRoute.prototype.publish = function (data) {
        return _super.prototype.baseGet.call(this, this.publishRoute, data);
    };
    /**
     * Parses purge article route, this URI template doesn't expose any additional properties.
     * @method
     * @example articleRoute.purge();
     **/
    ArticleRoute.prototype.purge = function (options) {
        return _super.prototype.baseCreate.call(this, this.purgeRoute, options);
    };
    /**
     * Parses create article route; this URI template doesn't expose any additional properties.
     * @method
     * @example articleRoute.create();
     **/
    ArticleRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update article route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An article object that needs to be updated into the system.
     * @example articleRoute.update(data);
     **/
    ArticleRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete article route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An article object that needs to be removed from the system.
     * @example articleRoute.delete(data);
     **/
    ArticleRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses archive article route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An article object.
     * @example articleRoute.archive(data);
     **/
    ArticleRoute.prototype.archive = function (data) {
        return _super.prototype.baseUpdate.call(this, this.archiveRoute, data, undefined, 'archive');
    };
    /**
     * Parses restore article route; this URI template doesn't expose any additional properties.
     * @method
     * @example articleRoute.restore(data);
     **/
    ArticleRoute.prototype.restore = function (data) {
        return _super.prototype.baseUpdate.call(this, this.restoreRoute, data, undefined, 'restore');
    };
    /**
     * Returns a promise that is resolved once the unpublish article action has been performed. This action sets the status of an article from "published" to "draft". This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(article);
     * let uri = params['model'].links('unpublish').href;
     * ```
     * @method
     * @example // article is a resource previously fetched using get action.
                    articleClient.unpublish(article)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    ArticleRoute.prototype.unpublish = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unpublishRoute, data, undefined, 'unpublish');
    };
    ArticleRoute.prototype.getStartDate = function (options) {
        if (!this.utility.isUndefined(options.startDate) && options.startDate !== null) {
            return options.startDate.toISOString();
        }
        return undefined;
    };
    ArticleRoute.prototype.getEndDate = function (options) {
        if (!this.utility.isUndefined(options.endDate) && options.endDate !== null) {
            return options.endDate.toISOString();
        }
        return undefined;
    };
    var _a, _b, _c, _d, _e, _f, _g;
    ArticleRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleSubscriptionsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ArticleInstanceCommentsRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.ArticleInstanceFilesRoute)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.ArticleInstanceRatingsRoute)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.ArticleInstanceTagsRoute)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.ArticleACLRoute)),
        tslib_1.__param(6, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleSubscriptionsRoute !== "undefined" && _1.ArticleSubscriptionsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.ArticleInstanceCommentsRoute !== "undefined" && _1.ArticleInstanceCommentsRoute) === "function" ? _b : Object, typeof (_c = typeof _1.ArticleInstanceFilesRoute !== "undefined" && _1.ArticleInstanceFilesRoute) === "function" ? _c : Object, typeof (_d = typeof _1.ArticleInstanceRatingsRoute !== "undefined" && _1.ArticleInstanceRatingsRoute) === "function" ? _d : Object, typeof (_e = typeof _1.ArticleInstanceTagsRoute !== "undefined" && _1.ArticleInstanceTagsRoute) === "function" ? _e : Object, typeof (_f = typeof _1.ArticleACLRoute !== "undefined" && _1.ArticleACLRoute) === "function" ? _f : Object, typeof (_g = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _g : Object])
    ], ArticleRoute);
    return ArticleRoute;
}(common_1.BaseRoute));
exports.ArticleRoute = ArticleRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(6);
var inversify_1 = __webpack_require__(1);
var Root = /** @class */ (function () {
    function Root(articles, comments, files, ratings, subscriptions, tags, settings) {
        this.articles = articles;
        this.comments = comments;
        this.files = files;
        this.ratings = ratings;
        this.subscriptions = subscriptions;
        this.tags = tags;
        this.settings = settings;
    }
    var _a, _b, _c, _d, _e, _f, _g;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ArticleClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ArticleCommentsClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.ArticleFilesClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.ArticleRatingsClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.ArticleSubscriptionsClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.ArticleTagsClient)),
        tslib_1.__param(6, inversify_1.inject(_1.TYPES.ArticleSettingsClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ArticleClient !== "undefined" && _1.ArticleClient) === "function" ? _a : Object, typeof (_b = typeof _1.ArticleCommentsClient !== "undefined" && _1.ArticleCommentsClient) === "function" ? _b : Object, typeof (_c = typeof _1.ArticleFilesClient !== "undefined" && _1.ArticleFilesClient) === "function" ? _c : Object, typeof (_d = typeof _1.ArticleRatingsClient !== "undefined" && _1.ArticleRatingsClient) === "function" ? _d : Object, typeof (_e = typeof _1.ArticleSubscriptionsClient !== "undefined" && _1.ArticleSubscriptionsClient) === "function" ? _e : Object, typeof (_f = typeof _1.ArticleTagsClient !== "undefined" && _1.ArticleTagsClient) === "function" ? _f : Object, typeof (_g = typeof _1.ArticleSettingsClient !== "undefined" && _1.ArticleSettingsClient) === "function" ? _g : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(25);
var TYPES = {
    DynamicResourceBatchRoute: Symbol("DynamicResourceBatchRoute"),
    DynamicResourceBatchClient: Symbol("DynamicResourceBatchClient"),
    DynamicResourceACLClient: Symbol("DynamicResourceACLClient"),
    DynamicResourceACLRoute: Symbol("DynamicResourceACLRoute"),
    DynamicResourceClient: Symbol("DynamicResourceClient"),
    DynamicResourceRoute: Symbol("DynamicResourceRoute"),
    DynamicSchemaClient: Symbol("DynamicSchemaClient"),
    DynamicSchemaRoute: Symbol("DynamicSchemaRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.DynamicResourceACLRoute).to(_1.DynamicResourceACLRoute);
    bind(TYPES.DynamicResourceACLClient).to(_1.DynamicResourceACLClient);
    bind(TYPES.DynamicResourceRoute).to(_1.DynamicResourceRoute);
    bind(TYPES.DynamicResourceClient).to(_1.DynamicResourceClient);
    bind(TYPES.DynamicResourceBatchRoute).to(_1.DynamicResourceBatchRoute);
    bind(TYPES.DynamicResourceBatchClient).to(_1.DynamicResourceBatchClient);
    bind(TYPES.DynamicSchemaRoute).to(_1.DynamicSchemaRoute);
    bind(TYPES.DynamicSchemaClient).to(_1.DynamicSchemaClient);
});
exports.diModule = diModule;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module dynamicResourceBatchRoute
 * @description DynamicResourceBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use DynamicResourceBatchRoute Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var DynamicResourceBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(DynamicResourceBatchRoute, _super);
    function DynamicResourceBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'resources/{schemaName}/batch';
        _this.updateRoute = 'resources/{schemaName}/batch';
        _this.patchRoute = 'resources/{schemaName}/batch';
        _this.deleteRoute = 'resources/{schemaName}/batch';
        return _this;
    }
    /**
    * Parses create route. This URI template does not expose any additional options.
    * @method
    * @example dynamicResourceBatchRoute.create();
    */
    DynamicResourceBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example dynamicResourceBatchRoute.update();
     */
    DynamicResourceBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses patch route. This URI template does not expose any additional options.
     * @method
     * @example dynamicResourceBatchRoute.patch();
     */
    DynamicResourceBatchRoute.prototype.patch = function () {
        return _super.prototype.baseUpdate.call(this, this.patchRoute, {});
    };
    /**
     * Parses delete route. This URI template does not expose any additional options.
     * @method
     * @example dynamicResourceBatchRoute.delete();
     */
    DynamicResourceBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    DynamicResourceBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], DynamicResourceBatchRoute);
    return DynamicResourceBatchRoute;
}(common_1.BaseRoute));
exports.DynamicResourceBatchRoute = DynamicResourceBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module dynamicResourceBatchClient
 * @description  DynamicResourceBatchClient provides an easy way to consume DynamicResourceBatchBatch REST API end-points. In order to obtain needed routes `dynamicResourceBatchClient` uses `dynamicResourceBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(25);
var DynamicResourceBatchClient = /** @class */ (function () {
    function DynamicResourceBatchClient(dynamicResourceBatchRoute, apiClient) {
        this.dynamicResourceBatchRoute = dynamicResourceBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(DynamicResourceBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.dynamicResourceBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create JSON object action has been performed; this action creates new JSON object resources.
     * @method
     * @param data JSON object objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create JSON object action has been performed.
     * @example dynamicResourceBatchClient.create([{
                    name: '<name>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    DynamicResourceBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update JSON object action has been performed; this action updates JSON object resources.
     * @method
     * @param data JSON object objects used to update specified JSON object resources.
     * @returns A promise that is resolved once the update JSON object action has been performed.
     * @example JSON object are resources previously fetched using get action.
                dynamicResourceBatchClient.update([{
                    id: '<id>',
                    name: '<name>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    DynamicResourceBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the patch JSON object action has been performed; this action patches JSON object resources.
     * @method
     * @param data JSON object objects used to patch specified JSON object resources.
     * @returns A promise that is resolved once the patch JSON object action has been performed.
     * @example JSON object are resources previously fetched using get action.
                dynamicResourceBatchClient.patch([{
                    id: '<id>',
                    name: '<name>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    DynamicResourceBatchClient.prototype.patch = function (data) {
        return this.apiClient.put(this.routeDefinition.patch(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove JSON object resources from the system if successfully completed.
     * @method
     * @param data JSON object Ids which uniquely identify JSON object resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example JSON object Ids are identifiers which uniquely identify JSON object resources.
                dynamicResourceBatchClient.remove(['<id1>', '<id2>']])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    DynamicResourceBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    DynamicResourceBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.DynamicResourceBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.DynamicResourceBatchRoute !== "undefined" && _1.DynamicResourceBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], DynamicResourceBatchClient);
    return DynamicResourceBatchClient;
}());
exports.DynamicResourceBatchClient = DynamicResourceBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module dynamicSchemaRoute
 * @description Baasic Dynamic Schema Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Dynamic Schema Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var DynamicSchemaRoute = /** @class */ (function (_super) {
    tslib_1.__extends(DynamicSchemaRoute, _super);
    function DynamicSchemaRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'schemas/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'schemas/{name}/{?embed,fields}';
        _this.generateRoute = 'schemas/generate';
        _this.createRoute = 'schemas';
        _this.updateRoute = 'schemas/{id}';
        _this.deleteRoute = 'schemas/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing dynamic resource schema properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain dynamic resource schema subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the dynamic resource schema property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example dynamicSchemaRoute.find({searchQuery: '<search-phrase>'});
     **/
    DynamicSchemaRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route which must be expanded with name of the previously created dynamic resource schema. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example dynamicSchemaRoute.find({name: '<schema-name>'});
     **/
    DynamicSchemaRoute.prototype.get = function (name, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, this.modelMapper.getParams(name, options, 'name'));
    };
    /**
     * Parses create route; this URI template doesn't expose any additional properties.
     * @method
     * @example dynamicSchemaRoute.generate();
     **/
    DynamicSchemaRoute.prototype.generate = function () {
        return _super.prototype.baseCreate.call(this, this.generateRoute, {});
    };
    /**
     * Parses create route; this URI template doesn't expose any additional properties.
     * @method
     * @example dynamicSchemaRoute.create(data);
     **/
    DynamicSchemaRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route.
     * @method
     * @param data A dynamic schema object used to update specified dynamic resource schema.
     * @example dynamicSchemaRoute.update(data);
     */
    DynamicSchemaRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route.
     * @method
     * @param data A dynamic schema object used to delete specified dynamic resource schema.
     */
    DynamicSchemaRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    DynamicSchemaRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], DynamicSchemaRoute);
    return DynamicSchemaRoute;
}(common_1.BaseRoute));
exports.DynamicSchemaRoute = DynamicSchemaRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module dynamicSchemaClient
 * @description  Dynamic Schema Client provides an easy way to consume  Dynamic Schema REST API end-points. In order to obtain needed routes `dynamicSchemaClient` uses `dynamicSchemaRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(25);
var DynamicSchemaClient = /** @class */ (function () {
    function DynamicSchemaClient(dynamicSchemaRoute, apiClient) {
        this.dynamicSchemaRoute = dynamicSchemaRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(DynamicSchemaClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `dynamicSchemaRoute`.
         * @method
         * @example dynamicSchemaClient.routeDefinition.get();
         **/
        get: function () {
            return this.dynamicSchemaRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of dynamic resource schemas matching the given criteria.
     * @method
     * @param options Options object.
     * @example dynamicSchemaClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    DynamicSchemaClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified dynamic resource schema.
     * @method
     * @param name Name of dynamic resource schema which need to be retrieved.
     * @param options Options object.
     * @example dynamicSchemaClient.get('<schema-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    DynamicSchemaClient.prototype.get = function (name, options) {
        return this.apiClient.get(this.dynamicSchemaRoute.get(name, options));
    };
    /**
     * Returns a promise that is resolved once the create action has been performed; this action creates a new dynamic resource schema item.
     * @method
     * @param data A dynamic resource schema object that needs to be inserted into the system.
     * @example dynamicSchemaClient.create({
                    schema : {
                        type : 'object',
                        properties : {
                            id : {
                                title : '<unique-identifier-field>',
                                readonly : true,
                                hidden : true,
                                type : 'string'
                            },
                            description : {
                                type: string
                            }
                        }
                    },
                    name : '<schema-name>',
                    description : '<description>',
                    enforceSchemaValidation : true
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    DynamicSchemaClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update dynamic resource schema action has been performed; this action updates a dynamic resource schema item. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `dynamicSchemaRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(dynamicResourceSchema);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A dynamic schema object used to update specified dynamic resource schema.
     * @example // dynamicResourceSchema is a resource previously fetched using get action.
                    dynamicResourceSchema.description = '<description>';
                    dynamicSchemaClient.update(dynamicResourceSchema)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    DynamicSchemaClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a dynamic resource schema item from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `dynamicSchemaRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(dynamicResourceSchema);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data A dynamic schema object used to delete specified dynamic resource schema.
     * @example // dynamicResourceSchema is a resource previously fetched using get action.
                    dynamicSchemaClient.remove(dynamicResourceSchema)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    DynamicSchemaClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the generate schema action has been performed. Success response returns a schema generated based on the json input.
     * @method
     * @param data Unordered collection of key value pairs used to specify dynamic schema definition.
     * @example baasicDynamicSchemaService.generate({
                    id : '<schema-Id>',
                    description : '<description>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    DynamicSchemaClient.prototype.generate = function (data) {
        return this.apiClient.post(this.routeDefinition.generate(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    DynamicSchemaClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.DynamicSchemaRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.DynamicSchemaRoute !== "undefined" && _1.DynamicSchemaRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], DynamicSchemaClient);
    return DynamicSchemaClient;
}());
exports.DynamicSchemaClient = DynamicSchemaClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module dynamicResourceACLRoute
 * @description Baasic Dynamic Resource ACL Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Dynamic Resource ACL Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var DynamicResourceACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(DynamicResourceACLRoute, _super);
    function DynamicResourceACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'resources/{schemaName}/{id}/acl/{?fields}';
        _this.updateRoute = 'resources/{schemaName}/{id}/acl/{?fields}';
        _this.deleteByUserRoute = 'resources/{schemaName}/{id}/acl/actions/{accessAction}/users/{user}/';
        _this.deleteByRoleRoute = 'resources/{schemaName}/{id}/acl/actions/{accessAction}/roles/{role}/';
        return _this;
    }
    /**
     * Parses get acl route; this URI template should be expanded with the Id of the dynamic resource and name of the dynamic resource schema.
     * @method
     * @param options Query resource options object.
     * @example dynamicResourceACLRoute.get(options)
     **/
    DynamicResourceACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update acl route; this URI template should be expanded with the Id of the dynamic resource and name of the dynamic resource schema.
     * @method
     * @param options Options object.
     * @example dynamicResourceACLRoute.update(options)
     **/
    DynamicResourceACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, options);
    };
    /**
     * Parses deleteByUser acl route which can be expanded with additional options. Supported items are:
     * - `schemaName` - Name of the dynamic resource schema.
     * - `id` - Id of the dynamic resource.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and dynamic resource item.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and dynamic resource item.
     * @param username A value which uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL Policy object used to perform delete action.
     * @example dynamicResourceACLRoute.deleteByUser(action, username, data);
     **/
    DynamicResourceACLRoute.prototype.deleteByUser = function (action, username, data) {
        var params = this.modelMapper.removeParams(data);
        params.user = username;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByRole acl route which can be expanded with additional options. Supported items are:
     * - `schemaName` - Name of the dynamic resource schema.
     * - `id` - Id of the dynamic resource.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and dynamic resource item.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param action Action abbreviation which identifies ACL policy assigned to the specified role and dynamic resource item.
     * @param role A value which uniquely identifies role for which ACL policy needs to be removed.
     * @param data ACLPolicy object used to perform delete action.
     * @example dynamicResourceACLRoute.deleteByRole(action, role, data)
     **/
    DynamicResourceACLRoute.prototype.deleteByRole = function (action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    DynamicResourceACLRoute.prototype.updateParams = function (options) {
        var params = this.utility.extend({}, options);
        return params[this.modelMapper.modelPropertyName];
    };
    var _a;
    DynamicResourceACLRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], DynamicResourceACLRoute);
    return DynamicResourceACLRoute;
}(common_1.BaseRoute));
exports.DynamicResourceACLRoute = DynamicResourceACLRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module dynamicResourceACLClient
 * @description  Dynamic Resource ACL Client provides an easy way to consume  Dynamic Resource REST API end-points. In order to obtain needed routes `dynamicResourceACLClient` uses `dynamicResourceACLRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(25);
var DynamicResourceACLClient = /** @class */ (function () {
    function DynamicResourceACLClient(dynamicResourceACLRoute, apiClient) {
        this.dynamicResourceACLRoute = dynamicResourceACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(DynamicResourceACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.dynamicResourceACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified dynamic resource.
     * @method
     * @param options Options object.
     * @example dynamicResourceACLClient.get({id: '<dynamic-resource-id>', schemaName: '<schema-name>'})
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    DynamicResourceACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed; this action creates new ACL policy for the specified dynamic resource.
     * @method
     * @param options Options object.
     * @example dynamicResourceACLClient.update({id: '<dynamic-resource-id>', schemaName: '<schema-name>'})
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    DynamicResourceACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and dynamic resource.
     * @method
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and dynamic resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user Username which uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL Policy whose security privileges need to be retrieved and updated.
     * @example // dynamicResource is a resource previously fetched using get action.
                    dynamicResourceACLClient.removeByUser('<access-action>', '<username>', dynamicResource)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    DynamicResourceACLClient.prototype.removeByUser = function (action, user, data) {
        return this.apiClient.delete(this.dynamicResourceACLRoute.deleteByUser(action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and dynamic resource.
     * @method
     * @param action Action abbreviation which identifies ACL policy assigned to the specified role and dynamic resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role Role's name which uniquely identifies role for which ACL policy needs to be removed.
     * @param data ACL Policy whose security privileges need to be retrieved and updated.
     * @example // dynamicResource is a resource previously fetched using get action.
                    dynamicResourceACLClient.removeByRole('<access-action>', '<role-name>', dynamicResource)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    DynamicResourceACLClient.prototype.removeByRole = function (action, role, data) {
        return this.apiClient.delete(this.dynamicResourceACLRoute.deleteByRole(action, role, data));
    };
    var _a, _b;
    DynamicResourceACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.DynamicResourceACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.DynamicResourceACLRoute !== "undefined" && _1.DynamicResourceACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], DynamicResourceACLClient);
    return DynamicResourceACLClient;
}());
exports.DynamicResourceACLClient = DynamicResourceACLClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module dynamicResourceRoute
 * @description Baasic Dynamic Resource Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Dynamic Resource Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(25);
var contracts_1 = __webpack_require__(3);
var DynamicResourceRoute = /** @class */ (function (_super) {
    tslib_1.__extends(DynamicResourceRoute, _super);
    function DynamicResourceRoute(appOptions, dynamicResourceACLRoute, dynamicSchemaRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.dynamicResourceACLRoute = dynamicResourceACLRoute;
        _this.dynamicSchemaRoute = dynamicSchemaRoute;
        _this.findRoute = 'resources/{schemaName}/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'resources/{schemaName}/{id}/{?embed,fields}';
        _this.createRoute = 'resources/{schemaName}';
        _this.updateRoute = 'resources/{schemaName}/{id}/{?embed,fields,query}';
        _this.patchRoute = 'resources/{schemaName}/{id}/{?embed,fields,query}';
        _this.deleteRoute = 'resources/{schemaName}/{id}/{?query}';
        _this.purgeRoute = 'resources/{schemaName}/purge';
        return _this;
    }
    Object.defineProperty(DynamicResourceRoute.prototype, "acl", {
        get: function () {
            return this.dynamicResourceACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicResourceRoute.prototype, "dynamicSchema", {
        get: function () {
            return this.dynamicSchemaRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `schemaName` - Name of the dynamic resource schema.
     * - `searchQuery` - A string referencing dynamic resource properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain dynamic resource subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the dynamic resource property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options query resource options object
     * @example dynamicResourceRoute.find(options);
     **/
    DynamicResourceRoute.prototype.find = function (schemaName, options) {
        return _super.prototype.baseFind.call(this, this.findRoute, this.utility.extend({ schemaName: schemaName }, options));
    };
    /**
     * Parses get route which must be expanded with the name of the previously created dynamic resource schema in the system and the Id of the previously created dynamic resource. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id Unique identifier of dynamic resources
     * @param schemaName schema name
     * @param options query resource options object
     * @example dynamicResourceRoute.get(id, schemaName, options);
     **/
    DynamicResourceRoute.prototype.get = function (id, schemaName, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, this.utility.extend({ schemaName: schemaName }, options));
    };
    DynamicResourceRoute.prototype.create = function (schemaName) {
        var params = this.modelMapper.getParams(schemaName, undefined, 'schemaName');
        return _super.prototype.baseCreate.call(this, this.createRoute, params);
    };
    DynamicResourceRoute.prototype.update = function (schemaName, data, options) {
        var opt = options || {};
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data, this.utility.extend({ schemaName: schemaName }, opt));
    };
    DynamicResourceRoute.prototype.patch = function (schemaName, data, options) {
        var opt = options || {};
        return _super.prototype.baseUpdate.call(this, this.patchRoute, data, this.utility.extend({ schemaName: schemaName }, opt), 'patch');
    };
    DynamicResourceRoute.prototype.delete = function (schemaName, data, options) {
        var opt = options || {};
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data, this.utility.extend({ schemaName: schemaName }, opt));
    };
    DynamicResourceRoute.prototype.purge = function (schemaName) {
        return _super.prototype.baseCreate.call(this, this.purgeRoute, { schemaName: schemaName });
    };
    var _a, _b, _c;
    DynamicResourceRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.DynamicResourceACLRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.DynamicSchemaRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.DynamicResourceACLRoute !== "undefined" && _1.DynamicResourceACLRoute) === "function" ? _b : Object, typeof (_c = typeof _1.DynamicSchemaRoute !== "undefined" && _1.DynamicSchemaRoute) === "function" ? _c : Object])
    ], DynamicResourceRoute);
    return DynamicResourceRoute;
}(common_1.BaseRoute));
exports.DynamicResourceRoute = DynamicResourceRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * @module dynamicResourceClient
 * @description  Dynamic Resource Client provides an easy way to consume  Dynamic Resource REST API end-points. In order to obtain needed routes `dynamicResourceClient` uses `dynamicResourceRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(25);
var DynamicResourceClient = /** @class */ (function () {
    function DynamicResourceClient(dynamicResourceRoute, dynamicResourceBatchClient, dynamicResourceACLClient, dynamicSchemaClient, apiClient) {
        this.dynamicResourceRoute = dynamicResourceRoute;
        this.dynamicResourceBatchClient = dynamicResourceBatchClient;
        this.dynamicResourceACLClient = dynamicResourceACLClient;
        this.dynamicSchemaClient = dynamicSchemaClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(DynamicResourceClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `dynamicResourceRoute`.
         * @method
         * @example dynamicResourceClient.routeDefinition.get(schemaName, id, options)
         **/
        get: function () {
            return this.dynamicResourceRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicResourceClient.prototype, "acl", {
        get: function () {
            return this.dynamicResourceACLClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicResourceClient.prototype, "schema", {
        get: function () {
            return this.dynamicSchemaClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DynamicResourceClient.prototype, "batch", {
        get: function () {
            return this.dynamicResourceBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of dynamic resources matching the given criteria.
     * @method
     * @param schemaName Name of dynamic resource schema whose dynamic resources need to be retrieved.
     * @param options Query resource options object.
     * @returns Promise that is resolved once the find action has been performed.
     * @example dynamicResourceClient.find('<schema-name>', {
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    DynamicResourceClient.prototype.find = function (schemaName, options) {
        return this.apiClient.get(this.dynamicResourceRoute.find(schemaName, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified dynamic resource.
     * @method
     * @example dynamicResourceClient.get('<schema-name>', '<dynamic-resource-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    DynamicResourceClient.prototype.get = function (schemaName, id, options) {
        return this.apiClient.get(this.dynamicResourceRoute.get(id, schemaName, options));
    };
    /**
     * Returns a promise that is resolved once the create dynamic resource action has been performed; this action creates a new dynamic resource item.
     * @method
     * @param schemaName Name of dynamic resource schema that needs to be updated with new dynamic resource.
     * @param data A JSON object that needs to be inserted into the system as dynamic resource. JSON object is an unordered collection of zero or more key/value pairs structured using the standard JSON syntax rules.
     * @example dynamicResourceClient.create('<schema-name>', {
                    id : '',
                    description : '<description>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    DynamicResourceClient.prototype.create = function (schemaName, data) {
        return this.apiClient.post(this.routeDefinition.create(schemaName), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates a dynamic resource item. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `dynamicResourceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(dynamicResource);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A JSON object used to update specified dynamic resource. JSON object is an unordered collection of zero or more key/value pairs structured using the standard JSON syntax rules.
     * @param options Options object.
     * @example // dynamicResource is a resource previously fetched using get action.
                    dynamicResource.description = '<description>';
                    dynamicResourceClient.update(dynamicResource, {
                        query: "where field = 'value' "
                    })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    DynamicResourceClient.prototype.update = function (schemaName, data, options) {
        return this.apiClient.put(this.routeDefinition.update(schemaName, data, options), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the patch action has been performed; this action patches an existing dynamic resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `dynamicResourceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(dynamicResource);
     * let uri = params['model'].links('patch').href;
     * ```
     * @method
     * @param data JSON object used for partial update of specified dynamic resource. JSON object is an unordered collection of zero or more key/value pairs structured using the standard JSON syntax rules.
     * @param options Options object.
     * @example // dynamicResource is a resource previously fetched using get action.
                    dynamicResource.description = '<new-description>';
                    dynamicResource.newField = '<newfield-value>';
                    dynamicResourceClient.patch(dynamicResource, {
                        query: "where field = 'value' "
                    })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                        
                    });
     **/
    DynamicResourceClient.prototype.patch = function (schemaName, data, options) {
        return this.apiClient.patch(this.routeDefinition.patch(schemaName, data, options), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a dynamic resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `dynamicResourceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(dynamicResource);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data JSON object used to delete specified dynamic resource. JSON object is an unordered collection of zero or more key/value pairs structured using the standard JSON syntax rules.
     * @example // dynamicResource is a resource previously fetched using get action.
                    dynamicResourceClient.remove(dynamicResource, {
                        query: "where field = 'value' "
                    })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    DynamicResourceClient.prototype.remove = function (schemaName, data, options) {
        return this.apiClient.delete(this.dynamicResourceRoute.delete(schemaName, data, options));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all dynamic resources from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `dynamicResourceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(dynamicResource);
     * let uri = params['model'].links('purge').href;
     * ```
     * @method
     * @param data JSON object used to purge dynamic resources.
     * @example // dynamicResource is a resource previously fetched using get action.
                    dynamicResourceClient.purge('<schema-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    DynamicResourceClient.prototype.purge = function (schemaName) {
        return this.apiClient.delete(this.dynamicResourceRoute.purge(schemaName));
    };
    var _a, _b, _c, _d, _e;
    DynamicResourceClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.DynamicResourceRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.DynamicResourceBatchClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.DynamicResourceACLClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.DynamicSchemaClient)),
        tslib_1.__param(4, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.DynamicResourceRoute !== "undefined" && _1.DynamicResourceRoute) === "function" ? _a : Object, typeof (_b = typeof _1.DynamicResourceBatchClient !== "undefined" && _1.DynamicResourceBatchClient) === "function" ? _b : Object, typeof (_c = typeof _1.DynamicResourceACLClient !== "undefined" && _1.DynamicResourceACLClient) === "function" ? _c : Object, typeof (_d = typeof _1.DynamicSchemaClient !== "undefined" && _1.DynamicSchemaClient) === "function" ? _d : Object, typeof (_e = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _e : Object])
    ], DynamicResourceClient);
    return DynamicResourceClient;
}());
exports.DynamicResourceClient = DynamicResourceClient;


/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(334), exports);
tslib_1.__exportStar(__webpack_require__(335), exports);
tslib_1.__exportStar(__webpack_require__(336), exports);
tslib_1.__exportStar(__webpack_require__(337), exports);


/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(23);
var TYPES = {
    MediaVaultBatchRoute: Symbol("MediaVaultBatchRoute"),
    MediaVaultBatchClient: Symbol("MediaVaultBatchClient"),
    MediaVaultRoute: Symbol("MediaVaultRoute"),
    MediaVaultProcessingProviderSettingsClient: Symbol("MediaVaultProcessingProviderSettingsClient"),
    MediaVaultProcessingProviderSettingsRoute: Symbol("MediaVaultProcessingProviderSettingsRoute"),
    MediaVaultClient: Symbol("MediaVaultClient"),
    MediaVaultSettingsRoute: Symbol("MediaVaultSettingsRoute"),
    MediaVaultSettingsClient: Symbol("MediaVaultSettingsClient"),
    MediaVaultStreamsRoute: Symbol("MediaVaultStreamsRoute"),
    MediaVaultStreamsClient: Symbol("MediaVaultStreamsClient")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.MediaVaultStreamsRoute).to(_1.MediaVaultStreamsRoute);
    bind(TYPES.MediaVaultStreamsClient).to(_1.MediaVaultStreamsClient);
    bind(TYPES.MediaVaultBatchRoute).to(_1.MediaVaultBatchRoute);
    bind(TYPES.MediaVaultBatchClient).to(_1.MediaVaultBatchClient);
    bind(TYPES.MediaVaultSettingsRoute).to(_1.MediaVaultSettingsRoute);
    bind(TYPES.MediaVaultSettingsClient).to(_1.MediaVaultSettingsClient);
    bind(TYPES.MediaVaultProcessingProviderSettingsRoute).to(_1.MediaVaultProcessingProviderSettingsRoute);
    bind(TYPES.MediaVaultProcessingProviderSettingsClient).to(_1.MediaVaultProcessingProviderSettingsClient);
    bind(TYPES.MediaVaultRoute).to(_1.MediaVaultRoute);
    bind(TYPES.MediaVaultClient).to(_1.MediaVaultClient);
});
exports.diModule = diModule;


/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaVaultStreamsRoute
 * @description Baasic MediaVault Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var MediaVaultStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaVaultStreamsRoute, _super);
    function MediaVaultStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'media-vault-streams/{id}/{?width,height,t}';
        _this.createRoute = 'media-vault-streams/{path}';
        _this.updateRoute = 'media-vault-streams/{id}/{?width,height}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id or path of desired media vault stream. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @example mediaVaultRoute.get({id: '<path>'});
     **/
    MediaVaultStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the path which indicates where the stream will be saved.
     * @method
     * @example mediaVaultStreamsRoute.create({path: '<path>'});
     **/
    MediaVaultStreamsRoute.prototype.create = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                path: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this route should be expanded with the id or path of the previously saved media vault resource. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * @method
     * @example mediaVaultStreamsRoute.update({id: '<path>'});
     **/
    MediaVaultStreamsRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    MediaVaultStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaVaultStreamsRoute);
    return MediaVaultStreamsRoute;
}(common_1.BaseRoute));
exports.MediaVaultStreamsRoute = MediaVaultStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaVaultStreamsClient
 * @description  Media Vault Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Streams Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(23);
var MediaVaultStreamsClient = /** @class */ (function () {
    function MediaVaultStreamsClient(mediaVaultStreamsRoute, apiClient) {
        this.mediaVaultStreamsRoute = mediaVaultStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaVaultStreamsClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaVaultStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the media vault stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of media vault resource, the operation will return a stream of the derived resource. Otherwise, stream of the original media vault resource will be retrieved.
     * @method
     * @example // Request the original media vault stream
                        mediaVaultStreamsClient.get('<path>')
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
                // Request derived media vault stream
                        mediaVaultStreamsClient.get({id: '<path>', width: <width>, height: <height>, t: <timestamp>})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    MediaVaultStreamsClient.prototype.get = function (data) {
        return this.apiClient.get(this.routeDefinition.get(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the media vault stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of media vault resource, the operation will return a blob of the derived media vault resource. Otherwise, blob of the original media vault resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @example // Request the original blob
                        mediaVaultStreamsClient.getBlob('<path>')
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
                // Request derived blob
                        mediaVaultStreamsClient.getBlob({id: '<path>', width: <width>, height: <height>, t: <timestamp>})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    MediaVaultStreamsClient.prototype.getBlob = function (data) {
        return this.apiClient.request({
            url: this.mediaVaultStreamsRoute.get(data),
            responseType: 'blob',
            headers: { 'Accept': 'application/octet-stream' },
            method: 'GET'
        });
    };
    /**
     * Returns a promise that is resolved once the create media vault stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @example mediaVaultStreamsClient.create('<path>', <blob>)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaVaultStreamsClient.prototype.create = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.mediaVaultStreamsRoute.create(data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the update media vault stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of media vault stream data type).
     * @method
     * @example // Update existing original media vault stream
                        mediaVaultStreamsClient.update('<path>', <media-vault-stream>)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
                // Update derived media vault stream
                    mediaVaultStreamsClient.update({id: '<path>', width: <width>, height: <height>}, <media-vault-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                          function (response, status, headers, config) {
                              // perform error handling here
                        });
     **/
    MediaVaultStreamsClient.prototype.update = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.mediaVaultStreamsRoute.update(data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    MediaVaultStreamsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaVaultStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaVaultStreamsRoute !== "undefined" && _1.MediaVaultStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaVaultStreamsClient);
    return MediaVaultStreamsClient;
}());
exports.MediaVaultStreamsClient = MediaVaultStreamsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaVaultBatchRoute
 * @description Baasic Media Vault Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var MediaVaultBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaVaultBatchRoute, _super);
    function MediaVaultBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.updateRoute = 'media-vaults/batch';
        _this.deleteRoute = 'media-vaults/batch';
        return _this;
    }
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example mediaVaultBatchRoute.update();
     **/
    MediaVaultBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example mediaVaultBatchRoute.delete();
     **/
    MediaVaultBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    MediaVaultBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaVaultBatchRoute);
    return MediaVaultBatchRoute;
}(common_1.BaseRoute));
exports.MediaVaultBatchRoute = MediaVaultBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaVaultBatchClient
 * @description  Media Vault Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(23);
var MediaVaultBatchClient = /** @class */ (function () {
    function MediaVaultBatchClient(mediaVaultBatchRoute, apiClient) {
        this.mediaVaultBatchRoute = mediaVaultBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaVaultBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaVaultBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified media vault resources.
     * @method
     * @param data A collection of media vault objects used to update specified media vault resources.
     * @returns A promise that is resolved once the update action has been performed.
     * @example mediaVaultStreamsClient.update(files)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    MediaVaultBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove media vault resources from the system if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of media vault resource, the operation will remove just derived resource. Otherwise, specified media vault and all its accompanying derived resources will be removed from the system.
     * @method
     * @param data Collection of media vault delete requests which uniquely identifies media vault resources that need to be deleted.
     * @example // Remove original media vault resources
                        mediaVaultBatchClient.remove([{ id: '<media-vault-id>' }])
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
                // Remove derived media vault resources
                        mediaVaultBatchClient.remove([{ id: '<media-vault-id>', fileFormat: { width: <width>, height: <height> } }])
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    MediaVaultBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.mediaVaultBatchRoute.delete(), undefined, data);
    };
    var _a, _b;
    MediaVaultBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaVaultBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaVaultBatchRoute !== "undefined" && _1.MediaVaultBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaVaultBatchClient);
    return MediaVaultBatchClient;
}());
exports.MediaVaultBatchClient = MediaVaultBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaVaultSettingsRoute
 * @description Baasic Media Vault Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Settings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var MediaVaultSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaVaultSettingsRoute, _super);
    function MediaVaultSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'media-vault-settings';
        _this.updateRoute = 'media-vault-settings';
        return _this;
    }
    /**
     * Parses get route; this route doesn not expose any additional options.
     * @method
     * @example mediaVaultSettingsRoute.get();
     **/
    MediaVaultSettingsRoute.prototype.get = function () {
        return _super.prototype.baseCreate.call(this, this.getRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example mediaVaultSettingsRoute.update();
     **/
    MediaVaultSettingsRoute.prototype.update = function () {
        return _super.prototype.baseCreate.call(this, this.updateRoute, {});
    };
    var _a;
    MediaVaultSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaVaultSettingsRoute);
    return MediaVaultSettingsRoute;
}(common_1.BaseRoute));
exports.MediaVaultSettingsRoute = MediaVaultSettingsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaVaultSettingsClient
 * @description  Media Vault Settings Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Settings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(23);
var MediaVaultSettingsClient = /** @class */ (function () {
    function MediaVaultSettingsClient(mediaVaultSettingsRoute, apiClient) {
        this.mediaVaultSettingsRoute = mediaVaultSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaVaultSettingsClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaVaultSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns media vault settings resource.
     * @method
     * @returns A promise that is resolved once the get action has been performed.
     * @example mediaVaultSettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaVaultSettingsClient.prototype.get = function () {
        return this.apiClient.get(this.routeDefinition.get());
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates the media vault settings resource.
     * @method
     * @param data A media vault settings object used to update media vault settings in the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example mediaVaultSettingsClient.update(mediaVaultSettings)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaVaultSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    MediaVaultSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaVaultSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaVaultSettingsRoute !== "undefined" && _1.MediaVaultSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaVaultSettingsClient);
    return MediaVaultSettingsClient;
}());
exports.MediaVaultSettingsClient = MediaVaultSettingsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaVaultProcessingProviderSettingsRoute
 * @description Baasic Media Vault Processing Provider Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Processing Provider Settings Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var MediaVaultProcessingProviderSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaVaultProcessingProviderSettingsRoute, _super);
    function MediaVaultProcessingProviderSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'media-vault-preprocessing-settings/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'media-vault-settings';
        _this.updateRoute = 'media-vault-preprocessing-settings/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing media vault processing provider setting properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain media vault processing provider setting subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the media vault processing provider setting property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example mediaVaultProcessingProviderSettingsRoute.find({searchQuery: '<search-phrase>'});
     **/
    MediaVaultProcessingProviderSettingsRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with Id of the media vault processing provider setting resource.
     * @method
     * @example mediaVaultProcessingProviderSettingsRoute.get({id: '<id>'});
     **/
    MediaVaultProcessingProviderSettingsRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route should be expanded with Id of the media vault processing provider setting resource.
     * @method
     * @param data A media vault preprocessing provider settings object used to update specified media vault preprocessing provider settings in the system.
     * @example mediaVaultProcessingProviderSettingsRoute.update(data);
     **/
    MediaVaultProcessingProviderSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    MediaVaultProcessingProviderSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaVaultProcessingProviderSettingsRoute);
    return MediaVaultProcessingProviderSettingsRoute;
}(common_1.BaseRoute));
exports.MediaVaultProcessingProviderSettingsRoute = MediaVaultProcessingProviderSettingsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaVaultProcessingProviderSettingsClient
 * @description  Media Vault Processing Provider Settings Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Processing Provider Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(23);
var MediaVaultProcessingProviderSettingsClient = /** @class */ (function () {
    function MediaVaultProcessingProviderSettingsClient(mediaVaultProcessingProviderSettingsRoute, apiClient) {
        this.mediaVaultProcessingProviderSettingsRoute = mediaVaultProcessingProviderSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaVaultProcessingProviderSettingsClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaVaultProcessingProviderSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of media vault processing providers matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example mediaVaultProcessingProviderSettingsClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    MediaVaultProcessingProviderSettingsClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the media vault processing provider resource.
     * @method
     * @param id Preprocessing provider id which uniquely identifies preprocessing provider whose settings need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example mediaVaultProcessingProviderSettingsClient.get('<id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaVaultProcessingProviderSettingsClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.mediaVaultProcessingProviderSettingsRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates a media vault processing provider setting resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `mediaVaultProcessingProviderSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(processingProviderSetting);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A media vault preprocessing provider settings object used to update specified media vault preprocessing provider settings in the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example // processingProviderSettings is a resource previously fetched using get action.
                    processingProviderSettings.settings.faceDetection = true;
                    mediaVaultProcessingProviderSettingsClient.update(processingProviderSetting)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MediaVaultProcessingProviderSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    MediaVaultProcessingProviderSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaVaultProcessingProviderSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaVaultProcessingProviderSettingsRoute !== "undefined" && _1.MediaVaultProcessingProviderSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaVaultProcessingProviderSettingsClient);
    return MediaVaultProcessingProviderSettingsClient;
}());
exports.MediaVaultProcessingProviderSettingsClient = MediaVaultProcessingProviderSettingsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaVaultRoute
 * @description Baasic Media Vault Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(23);
var contracts_1 = __webpack_require__(3);
var MediaVaultRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaVaultRoute, _super);
    function MediaVaultRoute(appOptions, mediaVaultStreamsRoute, mediaVaultBatchRoute, mediaVaultSettingsRoute, mediaVaultProcessingProviderSettingsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.mediaVaultStreamsRoute = mediaVaultStreamsRoute;
        _this.mediaVaultBatchRoute = mediaVaultBatchRoute;
        _this.mediaVaultSettingsRoute = mediaVaultSettingsRoute;
        _this.mediaVaultProcessingProviderSettingsRoute = mediaVaultProcessingProviderSettingsRoute;
        _this.findRoute = 'media-vaults/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'media-vaults/{id}/{?embed,fields}';
        _this.updateRoute = 'media-vaults/{id}';
        _this.deleteRoute = 'media-vaults/{id}/{?height,width}';
        return _this;
    }
    Object.defineProperty(MediaVaultRoute.prototype, "streams", {
        get: function () {
            return this.mediaVaultStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaVaultRoute.prototype, "batch", {
        get: function () {
            return this.mediaVaultBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaVaultRoute.prototype, "settings", {
        get: function () {
            return this.mediaVaultSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaVaultRoute.prototype, "processingProviderSettings", {
        get: function () {
            return this.mediaVaultProcessingProviderSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing media vault properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain media vault subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the media vault property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example mediaVaultRoute.find({searchQuery: '<search-phrase>'});
     **/
    MediaVaultRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of media vault resource.
     * @method
     * @param id Media vault id which uniquely identifies media vault resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example mediaVaultRoute.get({id: '<media-vault-id>'});
     **/
    MediaVaultRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route should be expanded with the Id of media vault resource.
     * @method
     * @param data Media vault object used to update specific Media vault resource in the system.
     * @example mediaVaultRoute.get({id: '<media-vault-id>'});
     **/
    MediaVaultRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this route should be expanded with the Id of media vault resource.
     * @method
     * @param data Media vault object used to update specific Media vault resource in the system.
     * @param options Options object.
     * @example mediaVaultRoute.delete({id: '<media-vault-id>'});
     **/
    MediaVaultRoute.prototype.delete = function (data, options) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data, options);
    };
    var _a, _b, _c, _d, _e;
    MediaVaultRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MediaVaultStreamsRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MediaVaultBatchRoute)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.MediaVaultSettingsRoute)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.MediaVaultProcessingProviderSettingsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.MediaVaultStreamsRoute !== "undefined" && _1.MediaVaultStreamsRoute) === "function" ? _b : Object, typeof (_c = typeof _1.MediaVaultBatchRoute !== "undefined" && _1.MediaVaultBatchRoute) === "function" ? _c : Object, typeof (_d = typeof _1.MediaVaultSettingsRoute !== "undefined" && _1.MediaVaultSettingsRoute) === "function" ? _d : Object, typeof (_e = typeof _1.MediaVaultProcessingProviderSettingsRoute !== "undefined" && _1.MediaVaultProcessingProviderSettingsRoute) === "function" ? _e : Object])
    ], MediaVaultRoute);
    return MediaVaultRoute;
}(common_1.BaseRoute));
exports.MediaVaultRoute = MediaVaultRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaVaultClient
 * @description  Media Vault Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Vault Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(23);
var MediaVaultClient = /** @class */ (function () {
    function MediaVaultClient(mediaVaultRoute, apiClient, mediaVaultStreamsClient, mediaVaultBatchClient, mediaVaultSettingsClient, mediaVaultProcessingProviderSettingsClient) {
        this.mediaVaultRoute = mediaVaultRoute;
        this.apiClient = apiClient;
        this.mediaVaultStreamsClient = mediaVaultStreamsClient;
        this.mediaVaultBatchClient = mediaVaultBatchClient;
        this.mediaVaultSettingsClient = mediaVaultSettingsClient;
        this.mediaVaultProcessingProviderSettingsClient = mediaVaultProcessingProviderSettingsClient;
    }
    Object.defineProperty(MediaVaultClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaVaultRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaVaultClient.prototype, "streams", {
        get: function () {
            return this.mediaVaultStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaVaultClient.prototype, "batch", {
        get: function () {
            return this.mediaVaultBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaVaultClient.prototype, "settings", {
        get: function () {
            return this.mediaVaultSettingsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaVaultClient.prototype, "processingProviderSettings", {
        get: function () {
            return this.mediaVaultProcessingProviderSettingsClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of media vault resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example mediaVaultClient.find({
                  pageNumber : 1,
                  pageSize : 10,
                  orderBy : '<field>',
                  orderDirection : '<asc|desc>',
                  search : '<search-phrase>'
               })
               .then(function (collection) {
                   // perform success action here
              },
               function (response, status, headers, config) {
                   // perform error handling here
              });
   **/
    MediaVaultClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested media vault resource.
     * @method
     * @param id Media vault id which uniquely identifies media vault resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example mediaVaultClient.get('<media-vault-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaVaultClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.mediaVaultRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update media vault action has been performed; this action will update a media vault resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `mediaVaultRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(mediaVaultEntry);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A media vault object used to update specified media vault resource.
     * @returns A promise that is resolved once the update media vault action has been performed.
     * @example // mediaVaultEntry is a media vault resource previously fetched using get action.
                    mediaVaultEntry.description = '<description>';
                    mediaVaultClient.update(mediaVaultEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MediaVaultClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove one or many media vault resources from the system if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of media vault resource, the operation will remove just derived resource. Otherwise, specified media vault and all its accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicMediaVaultRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(mediaVaultEntry);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data Media vault object used to delete specific Media vault resource from the system.
     * @param options Options object.
     * @example // mediaVaultEntry is a media vault resource previously fetched using get action. The following action will remove the original media vault resource and all accompanying derived media vault resources.
                   mediaVaultClient.remove(mediaVaultEntry)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
               // mediaVaultEntry is a media vault resource previously fetched using get action. The following action will remove derived media vault resource only.
                   mediaVaultClient.remove(mediaVaultEntry, {width: <width>, height: <height>})
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
    **/
    MediaVaultClient.prototype.remove = function (data, options) {
        return this.apiClient.delete(this.mediaVaultRoute.delete(data, options));
    };
    var _a, _b, _c, _d, _e, _f;
    MediaVaultClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaVaultRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MediaVaultStreamsClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.MediaVaultBatchClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.MediaVaultSettingsClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.MediaVaultProcessingProviderSettingsClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaVaultRoute !== "undefined" && _1.MediaVaultRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof _1.MediaVaultStreamsClient !== "undefined" && _1.MediaVaultStreamsClient) === "function" ? _c : Object, typeof (_d = typeof _1.MediaVaultBatchClient !== "undefined" && _1.MediaVaultBatchClient) === "function" ? _d : Object, typeof (_e = typeof _1.MediaVaultSettingsClient !== "undefined" && _1.MediaVaultSettingsClient) === "function" ? _e : Object, typeof (_f = typeof _1.MediaVaultProcessingProviderSettingsClient !== "undefined" && _1.MediaVaultProcessingProviderSettingsClient) === "function" ? _f : Object])
    ], MediaVaultClient);
    return MediaVaultClient;
}());
exports.MediaVaultClient = MediaVaultClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(350), exports);
tslib_1.__exportStar(__webpack_require__(351), exports);
tslib_1.__exportStar(__webpack_require__(352), exports);
tslib_1.__exportStar(__webpack_require__(353), exports);


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(15);
var TYPES = {
    MediaGalleryClient: Symbol("MediaGalleryClient"),
    MediaGalleryRoute: Symbol("MediaGalleryRoute"),
    MediaGalleryBatchClient: Symbol("MediaGalleryBatchClient"),
    MediaGalleryBatchRoute: Symbol("MediaGalleryBatchRoute"),
    MediaGallerySettingsClient: Symbol("MediaGallerySettingsClient"),
    MediaGallerySettingsRoute: Symbol("MediaGallerySettingsRoute"),
    MediaGalleryInstanceFilesBatchClient: Symbol("MediaGalleryInstanceFilesBatchClient"),
    MediaGalleryInstanceFilesBatchRoute: Symbol("MediaGalleryInstanceFilesBatchRoute"),
    MediaGalleryInstanceFilesClient: Symbol("MediaGalleryInstanceFilesClient"),
    MediaGalleryInstanceFilesRoute: Symbol("MediaGalleryInstanceFilesRoute"),
    MediaGalleryFileStreamClient: Symbol("MediaGalleryFileStreamClient"),
    MediaGalleryFileStreamRoute: Symbol("MediaGalleryFileStreamRoute"),
    MediaGalleryFileBatchClient: Symbol("MediaGalleryFileBatchClient"),
    MediaGalleryFileBatchRoute: Symbol("MediaGalleryFileBatchRoute"),
    MediaGalleryFileClient: Symbol("MediaGalleryFileClient"),
    MediaGalleryFileRoute: Symbol("MediaGalleryFileRoute"),
    MediaGalleryFileStreamsClient: Symbol("MediaGalleryFileStreamsClient"),
    MediaGalleryFileStreamsRoute: Symbol("MediaGalleryFileStreamsRoute"),
    Root: Symbol("Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.MediaGalleryClient).to(_1.MediaGalleryClient);
    bind(TYPES.MediaGalleryRoute).to(_1.MediaGalleryRoute);
    bind(TYPES.MediaGalleryBatchClient).to(_1.MediaGalleryBatchClient);
    bind(TYPES.MediaGalleryBatchRoute).to(_1.MediaGalleryBatchRoute);
    bind(TYPES.MediaGallerySettingsClient).to(_1.MediaGallerySettingsClient);
    bind(TYPES.MediaGallerySettingsRoute).to(_1.MediaGallerySettingsRoute);
    bind(TYPES.MediaGalleryInstanceFilesBatchClient).to(_1.MediaGalleryInstanceFilesBatchClient);
    bind(TYPES.MediaGalleryInstanceFilesBatchRoute).to(_1.MediaGalleryInstanceFilesBatchRoute);
    bind(TYPES.MediaGalleryInstanceFilesClient).to(_1.MediaGalleryInstanceFilesClient);
    bind(TYPES.MediaGalleryInstanceFilesRoute).to(_1.MediaGalleryInstanceFilesRoute);
    bind(TYPES.MediaGalleryFileBatchClient).to(_1.MediaGalleryFileBatchClient);
    bind(TYPES.MediaGalleryFileBatchRoute).to(_1.MediaGalleryFileBatchRoute);
    bind(TYPES.MediaGalleryFileClient).to(_1.MediaGalleryFileClient);
    bind(TYPES.MediaGalleryFileRoute).to(_1.MediaGalleryFileRoute);
    bind(TYPES.MediaGalleryFileStreamClient).to(_1.MediaGalleryFileStreamClient);
    bind(TYPES.MediaGalleryFileStreamRoute).to(_1.MediaGalleryFileStreamRoute);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryBatchRoute
 * @description Baasic Media Gallery Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var MediaGalleryBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryBatchRoute, _super);
    function MediaGalleryBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.updateRoute = 'media-galleries/batch';
        _this.deleteRoute = 'media-galleries/batch';
        _this.createRoute = 'media-galleries/batch';
        return _this;
    }
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example mediaGalleryBatchRoute.update();
     **/
    MediaGalleryBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example mediaGalleryBatchRoute.create();
     **/
    MediaGalleryBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example mediaGalleryBatchRoute.delete();
     **/
    MediaGalleryBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    MediaGalleryBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaGalleryBatchRoute);
    return MediaGalleryBatchRoute;
}(common_1.BaseRoute));
exports.MediaGalleryBatchRoute = MediaGalleryBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryBatchClient
 * @description  Media Gallery Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(15);
var MediaGalleryBatchClient = /** @class */ (function () {
    function MediaGalleryBatchClient(mediaGalleryBatchRoute, apiClient) {
        this.mediaGalleryBatchRoute = mediaGalleryBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaGalleryBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGalleryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified media gallery resources.
     * @method
     * @param data A collection of media gallery objects used to update specified media gallery resources.
     * @returns A promise that is resolved once the update action has been performed.
     * @example mediaGalleryStreamsClient.update(files)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    MediaGalleryBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove media gallery resources from the system if successfully completed. Specified media galleries and all accompanying derived resources will be removed from the system.
     * @method
     * @param ids Collection of media gallery Id which uniquely identifies media gallery resources that need to be deleted.
     * @example // Remove original media gallery resources
                        mediaGalleryBatchClient.remove([<media-gallery-id>])
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    MediaGalleryBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.mediaGalleryBatchRoute.delete(), undefined, ids);
    };
    /**
    * Returns a promise that is resolved once the create action has been performed; this action creates specified media gallery resources.
    * @method
    * @param data A collection of media gallery objects used to create specified media gallery resources.
    * @returns A promise that is resolved once the create action has been performed.
    * @example mediaGalleryStreamsClient.create(files)
                  .then(function (data) {
                      // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                  });
   **/
    MediaGalleryBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    MediaGalleryBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGalleryBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGalleryBatchRoute !== "undefined" && _1.MediaGalleryBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaGalleryBatchClient);
    return MediaGalleryBatchClient;
}());
exports.MediaGalleryBatchClient = MediaGalleryBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module MediaGallerySettingsRoute
 * @description Baasic Media Gallery Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Settings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var MediaGallerySettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGallerySettingsRoute, _super);
    function MediaGallerySettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'media-gallery-settings';
        _this.updateRoute = 'media-gallery-settings';
        return _this;
    }
    /**
     * Parses get route; this route doesn not expose any additional options.
     * @method
     * @example mediaGallerySettingsRoute.get();
     **/
    MediaGallerySettingsRoute.prototype.get = function () {
        return _super.prototype.baseCreate.call(this, this.getRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example mediaGallerySettingsRoute.update();
     **/
    MediaGallerySettingsRoute.prototype.update = function () {
        return _super.prototype.baseCreate.call(this, this.updateRoute, {});
    };
    var _a;
    MediaGallerySettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaGallerySettingsRoute);
    return MediaGallerySettingsRoute;
}(common_1.BaseRoute));
exports.MediaGallerySettingsRoute = MediaGallerySettingsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGallerySettingsClient
 * @description  Media Gallery Settings Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Settings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(15);
var MediaGallerySettingsClient = /** @class */ (function () {
    function MediaGallerySettingsClient(mediaGallerySettingsRoute, apiClient) {
        this.mediaGallerySettingsRoute = mediaGallerySettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaGallerySettingsClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGallerySettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns media gallery settings resource.
     * @method
     * @returns A promise that is resolved once the get action has been performed.
     * @example mediaGallerySettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaGallerySettingsClient.prototype.get = function () {
        return this.apiClient.get(this.routeDefinition.get());
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates the media gallery settings resource.
     * @method
     * @param data A media gallery settings object used to update media gallery settings in the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example mediaGallerySettingsClient.update(mediaGallerySettings)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaGallerySettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    MediaGallerySettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGallerySettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGallerySettingsRoute !== "undefined" && _1.MediaGallerySettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaGallerySettingsClient);
    return MediaGallerySettingsClient;
}());
exports.MediaGallerySettingsClient = MediaGallerySettingsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module MediaGalleryRoute
 * @description Baasic Media Gallery Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(15);
var contracts_1 = __webpack_require__(3);
var MediaGalleryRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryRoute, _super);
    function MediaGalleryRoute(appOptions, mediaGalleryBatchRoute, mediaGallerySettingsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.mediaGalleryBatchRoute = mediaGalleryBatchRoute;
        _this.mediaGallerySettingsRoute = mediaGallerySettingsRoute;
        _this.findRoute = 'media-galleries/{?searchQuery,ids,from,to,page,rpp,sort,embed,fields}';
        _this.getRoute = 'media-galleries/{id}/{?embed,fields}';
        _this.updateRoute = 'media-galleries/{id}';
        _this.deleteRoute = 'media-galleries/{id}';
        _this.createRoute = 'media-galleries/';
        _this.purgeRoute = 'media-galleries/purge';
        return _this;
    }
    Object.defineProperty(MediaGalleryRoute.prototype, "batch", {
        get: function () {
            return this.mediaGalleryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaGalleryRoute.prototype, "settings", {
        get: function () {
            return this.mediaGallerySettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing media gallery properties using the phrase search.
     * - `ids` - Comma separated list of media gallery ids to be retrieved.       *
     * - `from` - The from date.
     * - `to` - The to date.
     * - `page` - A value used to set the page number, i.e. to retrieve certain media gallery subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the media gallery property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example mediaGalleryRoute.find({searchQuery: '<search-phrase>'});
     **/
    MediaGalleryRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of media gallery resource.
     * @method
     * @param id Media gallery id which uniquely identifies media gallery resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example mediaGalleryRoute.get({id: '<media-gallery-id>'});
     **/
    MediaGalleryRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route should be expanded with the Id of media gallery resource.
     * @method
     * @param data Media gallery object used to update specific Media gallery resource in the system.
     * @example mediaGalleryRoute.update(data);
     **/
    MediaGalleryRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this route should be expanded with the Id of media gallery resource.
     * @method
     * @param data Media gallery object of specific Media gallery resource in the system.
     * @example mediaGalleryRoute.delete(<media-gallery>);
     **/
    MediaGalleryRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
    * Parses create route; this URI template doesnt support any additional options.
    * @method
    * @param data An media gallery  object that needs to be inserted into the system.
    * @example mediaGalleryRoute.create(data);
    **/
    MediaGalleryRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses purge route; this URI template does not expose any additional options.
     * @method
     * @example mediaGalleryPurgeRoute.purge();
     **/
    MediaGalleryRoute.prototype.purge = function () {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, {});
    };
    var _a, _b, _c;
    MediaGalleryRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MediaGalleryBatchRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MediaGallerySettingsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.MediaGalleryBatchRoute !== "undefined" && _1.MediaGalleryBatchRoute) === "function" ? _b : Object, typeof (_c = typeof _1.MediaGallerySettingsRoute !== "undefined" && _1.MediaGallerySettingsRoute) === "function" ? _c : Object])
    ], MediaGalleryRoute);
    return MediaGalleryRoute;
}(common_1.BaseRoute));
exports.MediaGalleryRoute = MediaGalleryRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryClient
 * @description  Media Gallery Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(15);
var MediaGalleryClient = /** @class */ (function () {
    function MediaGalleryClient(mediaGalleryRoute, apiClient, mediaGalleryBatchClient, mediaGalleryFileStreamClient, mediaGalleryInstanceFilesClient, mediaGallerySettingsClient) {
        this.mediaGalleryRoute = mediaGalleryRoute;
        this.apiClient = apiClient;
        this.mediaGalleryBatchClient = mediaGalleryBatchClient;
        this.mediaGalleryFileStreamClient = mediaGalleryFileStreamClient;
        this.mediaGalleryInstanceFilesClient = mediaGalleryInstanceFilesClient;
        this.mediaGallerySettingsClient = mediaGallerySettingsClient;
    }
    Object.defineProperty(MediaGalleryClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGalleryRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaGalleryClient.prototype, "streams", {
        get: function () {
            return this.mediaGalleryFileStreamClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaGalleryClient.prototype, "batch", {
        get: function () {
            return this.mediaGalleryBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaGalleryClient.prototype, "files", {
        get: function () {
            return this.mediaGalleryInstanceFilesClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of media gallery resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example mediaGalleryClient.find({
                  pageNumber : 1,
                  pageSize : 10,
                  orderBy : '<field>',
                  orderDirection : '<asc|desc>',
                  search : '<search-phrase>',
                  ids: '1,2,5',
                  from: '',
                  to: ''
               })
               .then(function (collection) {
                   // perform success action here
              },
               function (response, status, headers, config) {
                   // perform error handling here
              });
   **/
    MediaGalleryClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested media gallery resource.
     * @method
     * @param id Media gallery id which uniquely identifies media gallery resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example mediaGalleryClient.get('<media-gallery-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaGalleryClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update media gallery action has been performed; this action will update a media gallery resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `mediaGalleryRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(mediaGalleryEntry);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A media gallery object used to update specified media gallery resource.
     * @returns A promise that is resolved once the update media gallery action has been performed.
     * @example // mediaGalleryEntry is a media gallery resource previously fetched using get action.
                    mediaGalleryEntry.description = '<description>';
                    mediaGalleryClient.update(mediaGalleryEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MediaGalleryClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove one media gallery resources from the system if successfully completed. Specified media gallery and all accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicMediaGalleryRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(mediaGalleryEntry);
     * let uri = params['id'].links('delete').href;
     * ```
     * @method
     * @param id Media gallery id used to delete specific Media gallery resource from the system.
     * @example // id is a media gallery resource id previously fetched using get action. The following action will remove the original media gallery resource and all accompanying derived media gallery resources.
                   mediaGalleryClient.remove(id)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
    **/
    MediaGalleryClient.prototype.remove = function (id) {
        return this.apiClient.delete(this.routeDefinition.delete(id));
    };
    /**
     * Returns a promise that is resolved once the create media gallery action has been performed; this action creates a new media gallery.
     * @method
     * @param data Media Gallery object.
     * @returns A promise that is resolved once the create media gallery action has been performed.
     * @example mediaGalleryClient.create(mediaGallery)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    MediaGalleryClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all media gallery resources from the system if successfully completed.
     * @method
     * @example // Remove original media gallery resources
                        mediaGalleryClient.purge()
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    MediaGalleryClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c, _d, _e, _f;
    MediaGalleryClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGalleryRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MediaGalleryBatchClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.MediaGalleryFileStreamClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.MediaGalleryInstanceFilesClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.MediaGallerySettingsClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGalleryRoute !== "undefined" && _1.MediaGalleryRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof _1.MediaGalleryBatchClient !== "undefined" && _1.MediaGalleryBatchClient) === "function" ? _c : Object, typeof (_d = typeof _1.MediaGalleryFileStreamClient !== "undefined" && _1.MediaGalleryFileStreamClient) === "function" ? _d : Object, typeof (_e = typeof _1.MediaGalleryInstanceFilesClient !== "undefined" && _1.MediaGalleryInstanceFilesClient) === "function" ? _e : Object, typeof (_f = typeof _1.MediaGallerySettingsClient !== "undefined" && _1.MediaGallerySettingsClient) === "function" ? _f : Object])
    ], MediaGalleryClient);
    return MediaGalleryClient;
}());
exports.MediaGalleryClient = MediaGalleryClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module MediaGalleryFileRoute
 * @description Baasic Media Gallery File Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery File Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(15);
var contracts_1 = __webpack_require__(3);
var MediaGalleryFileRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryFileRoute, _super);
    function MediaGalleryFileRoute(appOptions, mediaGalleryBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.mediaGalleryBatchRoute = mediaGalleryBatchRoute;
        _this.findRoute = 'media-gallery-files/{?searchQuery,fileName,minFileSize,maxFileSize,ids,from,to,page,rpp,sort,embed,fields,mediaGalleryIds,isCover}';
        _this.getRoute = 'media-gallery-files/{id}/{?embed,fields}';
        _this.updateRoute = 'media-gallery-files/{id}';
        _this.unlinkRoute = 'media-gallery-files/unlink({id}';
        _this.linkRoute = 'media-gallery-files/';
        return _this;
    }
    Object.defineProperty(MediaGalleryFileRoute.prototype, "batch", {
        get: function () {
            return this.mediaGalleryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing media gallery properties using the phrase search.
     * - `ids` - Comma separated list of media gallery ids to be retrieved.       *
     * - `from` - The from date.
     * - `to` - The to date.
     * - `page` - A value used to set the page number, i.e. to retrieve certain media gallery subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the media gallery property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example mediaGalleryFileRoute.find({searchQuery: '<search-phrase>'});
     **/
    MediaGalleryFileRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of media gallery resource.
     * @method
     * @param id Media gallery file id which uniquely identifies media gallery resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example mediaGalleryFileRoute.get({id: '<media-gallery-id>'});
     **/
    MediaGalleryFileRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route should be expanded with the Id of media gallery resource.
     * @method
     * @param data Media gallery file object used to update specific Media gallery file resource in the system.
     * @example mediaGalleryFileRoute.update(data);
     **/
    MediaGalleryFileRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this route should be expanded with the Id of media gallery file resource.
     * @method
     * @param id Media gallery file object id used to delete specific Media gallery file file resource in the system.
     * @example mediaGalleryFileRoute.delete({id: '<media-gallery-file--id>'});
     **/
    MediaGalleryFileRoute.prototype.unlink = function (id) {
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, id);
    };
    /**
    * Parses create route; this URI template doesnt support any additional options.
    * @method
    * @param data An media gallery file object that needs to be inserted into the system.
    * @example mediaGalleryFileRoute.create(data);
    **/
    MediaGalleryFileRoute.prototype.link = function (data) {
        return _super.prototype.baseCreate.call(this, this.linkRoute, data);
    };
    var _a, _b;
    MediaGalleryFileRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MediaGalleryFileBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.MediaGalleryFileBatchRoute !== "undefined" && _1.MediaGalleryFileBatchRoute) === "function" ? _b : Object])
    ], MediaGalleryFileRoute);
    return MediaGalleryFileRoute;
}(common_1.BaseRoute));
exports.MediaGalleryFileRoute = MediaGalleryFileRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryFileClient
 * @description  Media Gallery File Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery File Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(15);
var MediaGalleryFileClient = /** @class */ (function () {
    function MediaGalleryFileClient(mediaGalleryFileRoute, apiClient, mediaGalleryFileBatchClient) {
        this.mediaGalleryFileRoute = mediaGalleryFileRoute;
        this.apiClient = apiClient;
        this.mediaGalleryFileBatchClient = mediaGalleryFileBatchClient;
    }
    Object.defineProperty(MediaGalleryFileClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGalleryFileRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaGalleryFileClient.prototype, "batch", {
        get: function () {
            return this.mediaGalleryFileBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of media gallery resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example mediaGalleryClient.find({
                  pageNumber : 1,
                  pageSize : 10,
                  orderBy : '<field>',
                  orderDirection : '<asc|desc>',
                  search : '<search-phrase>',
                  ids: '1,2,5',
                  from: '',
                  to: ''
               })
               .then(function (collection) {
                   // perform success action here
              },
               function (response, status, headers, config) {
                   // perform error handling here
              });
   **/
    MediaGalleryFileClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested media gallery resource.
     * @method
     * @param id Media gallery id which uniquely identifies media gallery resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example mediaGalleryClient.get('<media-gallery-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MediaGalleryFileClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update media gallery action has been performed; this action will update a media gallery resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `mediaGalleryRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(mediaGalleryEntry);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A media gallery object used to update specified media gallery resource.
     * @returns A promise that is resolved once the update media gallery action has been performed.
     * @example // mediaGalleryEntry is a media gallery resource previously fetched using get action.
                    mediaGalleryEntry.description = '<description>';
                    mediaGalleryClient.update(mediaGalleryEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MediaGalleryFileClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove one media gallery file resources from the system if successfully completed. Specified media gallery file and all accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicMediaGalleryFileRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(mediaGalleryFileEntry);
     * let uri = params['id'].links('delete').href;
     * ```
     * @method
     * @param id Media gallery file id used to delete specific Media gallery resource from the system.
     * @example // id is a media gallery file resource id previously fetched using get action. The following action will remove the original media gallery file resource and all accompanying derived media gallery file resources.
                   mediaGalleryFileClient.remove(id)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
    **/
    MediaGalleryFileClient.prototype.remove = function (id) {
        return this.apiClient.delete(this.routeDefinition.unlink(id));
    };
    /**
     * Returns a promise that is resolved once the create media gallery action has been performed; this action creates a new media gallery.
     * @method
     * @param data Media Gallery object.
     * @returns A promise that is resolved once the create media gallery action has been performed.
     * @example mediaGalleryClient.create(mediaGallery)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    MediaGalleryFileClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.link(data), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c;
    MediaGalleryFileClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGalleryFileRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MediaGalleryFileBatchClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGalleryFileRoute !== "undefined" && _1.MediaGalleryFileRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof _1.MediaGalleryFileBatchClient !== "undefined" && _1.MediaGalleryFileBatchClient) === "function" ? _c : Object])
    ], MediaGalleryFileClient);
    return MediaGalleryFileClient;
}());
exports.MediaGalleryFileClient = MediaGalleryFileClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryFileBatchRoute
 * @description Baasic Media Gallery Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var MediaGalleryFileBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryFileBatchRoute, _super);
    function MediaGalleryFileBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.updateRoute = 'media-gallery-files/batch';
        _this.unlinkRoute = 'media-gallery-files/batch/unlink';
        _this.linkRoute = 'media-gallery-files/batch/link';
        return _this;
    }
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example mediaGalleryFileBatchRoute.update();
     **/
    MediaGalleryFileBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @example mediaGalleryFileBatchRoute.link();
     **/
    MediaGalleryFileBatchRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @example mediaGalleryFileBatchRoute.unlink();
     **/
    MediaGalleryFileBatchRoute.prototype.unlink = function () {
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, {});
    };
    var _a;
    MediaGalleryFileBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaGalleryFileBatchRoute);
    return MediaGalleryFileBatchRoute;
}(common_1.BaseRoute));
exports.MediaGalleryFileBatchRoute = MediaGalleryFileBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryFileBatchClient
 * @description  Media Gallery Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(15);
var MediaGalleryFileBatchClient = /** @class */ (function () {
    function MediaGalleryFileBatchClient(mediaGalleryBatchRoute, apiClient) {
        this.mediaGalleryBatchRoute = mediaGalleryBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaGalleryFileBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGalleryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified media gallery file resources.
     * @method
     * @param data A collection of media gallery file objects used to update specified media gallery file resources.
     * @returns A promise that is resolved once the update action has been performed.
     * @example mediaGalleryFileBatchClient.update(files)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    MediaGalleryFileBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove media gallery file resources from the system if successfully completed. Specified media galleries and all accompanying derived resources will be removed from the system.
     * @method
     * @param ids Collection of media gallery Id which uniquely identifies media gallery file resources that need to be deleted.
     * @example // Remove original media gallery file resources
                        mediaGalleryFileBatchClient.unlink([<media-gallery-id>])
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    MediaGalleryFileBatchClient.prototype.unlink = function (ids) {
        return this.apiClient.delete(this.mediaGalleryBatchRoute.unlink(), undefined, ids);
    };
    /**
    * Returns a promise that is resolved once the create action has been performed; this action creates specified media gallery file resources.
    * @method
    * @param data A collection of media gallery file objects used to create specified media gallery file resources.
    * @returns A promise that is resolved once the create action has been performed.
    * @example mediaGalleryFileBatchClient.link(files)
                  .then(function (data) {
                      // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                  });
   **/
    MediaGalleryFileBatchClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    MediaGalleryFileBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGalleryBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGalleryFileBatchRoute !== "undefined" && _1.MediaGalleryFileBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaGalleryFileBatchClient);
    return MediaGalleryFileBatchClient;
}());
exports.MediaGalleryFileBatchClient = MediaGalleryFileBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module MediaGalleryFilesStreamsRoute
 * @description Baasic Media Gallery  Files Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Files Streams Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var MediaGalleryFileStreamRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryFileStreamRoute, _super);
    function MediaGalleryFileStreamRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'media-gallery-file-streams/{id}/{?mediaGalleryId,t}';
        _this.createRoute = 'media-gallery-file-streams/{filename}/{?mediaGalleryId}';
        _this.updateRoute = 'media-gallery-file-streams/{id}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id of desired file stream.
     * @method
     * @param id Media Gallery File id which uniquely identifies media gallery whose media gallery file need to be retrieved.
     * @param data Media Gallery File object used to identify stream that needs to be retrieved from the system.
     * @example mediaGalleryFileStreamRoute.get(id);
     **/
    MediaGalleryFileStreamRoute.prototype.get = function (id, data) {
        if (!this.utility.isObject(data)) {
            data = {
                mediaGalleryId: data
            };
        }
        var params = this.utility.extend({}, data);
        params.id = id;
        return _super.prototype.baseGet.call(this, this.getRoute, params);
    };
    /**
     * Parses create route; this route should be expanded with the filename which indicates where the stream will be saved.
     * @method
     * @param data Media Gallery File object that need to be inserted into the system.
     * @example mediaGalleryFileStreamRoute.create({filename: '<filename>'});
     **/
    MediaGalleryFileStreamRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this route should be expanded with the id of the previously saved resource. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @param mediaGalleryId Media Gallery slug or id which uniquely identifies media gallery whose media gallery file need to be updated.
     * @param data Media Gallery File object used to identify stream that needs to be updated.
     * @example mediaGalleryFileStreamRoute.update({id: '<filename>'});
     **/
    MediaGalleryFileStreamRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    MediaGalleryFileStreamRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaGalleryFileStreamRoute);
    return MediaGalleryFileStreamRoute;
}(common_1.BaseRoute));
exports.MediaGalleryFileStreamRoute = MediaGalleryFileStreamRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryFilesStreamsClient
 * @description  Media Gallery Files Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(15);
var MediaGalleryFileStreamClient = /** @class */ (function () {
    function MediaGalleryFileStreamClient(mediaGalleryFilesStreamsRoute, apiClient) {
        this.mediaGalleryFilesStreamsRoute = mediaGalleryFilesStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaGalleryFileStreamClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGalleryFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a stream of the derived resource. Otherwise, stream of the original file resource will be retrieved.
     * @method
     * @param id Media Gallery Entry id which uniquely identifies media gallery file that needs to be retrieved.
     * @param data Media Gallery File object used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original file stream
                    mediaGalleryFilesStreamsClient.get({id: '<file-id>'}, {mediaGalleryid: '<media-gallery-id>', t: '<timestamp>'})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    MediaGalleryFileStreamClient.prototype.get = function (id, data) {
        return this.apiClient.get(this.mediaGalleryFilesStreamsRoute.get(id, data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a blob of the derived file resource. Otherwise, blob of the original file resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param id Media Gallery Entry id which uniquely identifies media gallery file that needs to be retrieved.
     * @param data Media Gallery File object used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original blob
                    mediaGalleryFilesStreamsClient.getBlob('<file-id>', {mediaGalleryId:'<media-gallery-id>', t: '<timestamp>'})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    MediaGalleryFileStreamClient.prototype.getBlob = function (id, data) {
        return this.apiClient.get(this.mediaGalleryFilesStreamsRoute.get(id, data), { 'Accept': 'application/octet-stream' });
    };
    /**
     * Returns a promise that is resolved once the update file stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of file stream data type).
     * @method
     * @param data Media GalleryFile object used to identify stream that needs to be updated.
     * @param stream
     * @returns A promise that is resolved once the update file stream action has been performed.
     * @example // Update original file stream
                    mediaGalleryFilesStreamsClient.update({id:'<file-id>'}, <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    MediaGalleryFileStreamClient.prototype.update = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.mediaGalleryFilesStreamsRoute.update(data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the create file stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param data Media GalleryFile object that need to be inserted into the system.
     * @param stream
     * @returns A promise that is resolved once the create file stream action has been performed.
     * @example mediaGalleryFilesStreamsClient.create({mediaGalleryId:'<media-gallery-id>'}, <blob>)
                   .then(function (data) {
                        // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    MediaGalleryFileStreamClient.prototype.create = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.mediaGalleryFilesStreamsRoute.create(data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    MediaGalleryFileStreamClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGalleryFileStreamRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGalleryFileStreamRoute !== "undefined" && _1.MediaGalleryFileStreamRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaGalleryFileStreamClient);
    return MediaGalleryFileStreamClient;
}());
exports.MediaGalleryFileStreamClient = MediaGalleryFileStreamClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(368), exports);
tslib_1.__exportStar(__webpack_require__(369), exports);
tslib_1.__exportStar(__webpack_require__(370), exports);
tslib_1.__exportStar(__webpack_require__(371), exports);
tslib_1.__exportStar(__webpack_require__(372), exports);
tslib_1.__exportStar(__webpack_require__(373), exports);
tslib_1.__exportStar(__webpack_require__(374), exports);


/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(376), exports);
tslib_1.__exportStar(__webpack_require__(377), exports);
tslib_1.__exportStar(__webpack_require__(378), exports);
tslib_1.__exportStar(__webpack_require__(379), exports);


/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryInstanceFilesBatchRoute
 * @description Baasic Media Gallery Instance Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Files Batch Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var MediaGalleryInstanceFilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryInstanceFilesBatchRoute, _super);
    function MediaGalleryInstanceFilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.unlinkRoute = 'media-galleries/{mediaGalleryId}/files/batch/unlink';
        _this.updateRoute = 'media-galleries/{mediaGalleryId}/files/batch';
        _this.linkRoute = 'media-galleries/{mediaGalleryId}/files/batch/link';
        return _this;
    }
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery file id of the original media gallery file used to identify media gallery files on which delete action should be performed.
     * @example mediaGalleryInstanceFilesBatchRoute.unlink(mediaGalleryId);
     **/
    MediaGalleryInstanceFilesBatchRoute.prototype.unlink = function (mediaGalleryId) {
        var params = { mediaGalleryId: mediaGalleryId };
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery file need to be updated.
     * @example mediaGalleryInstanceFilesStreamsRoute.update(mediaGalleryId);
     **/
    MediaGalleryInstanceFilesBatchRoute.prototype.update = function (mediaGalleryId) {
        var params = { mediaGalleryId: mediaGalleryId };
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery slug or id which uniquely identifies media gallery whose media gallery files need to be linked.
     * @example mediaGalleryInstanceFilesStreamsRoute.link(mediaGalleryId);
     **/
    MediaGalleryInstanceFilesBatchRoute.prototype.link = function (mediaGalleryId) {
        var params = { mediaGalleryId: mediaGalleryId };
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    var _a;
    MediaGalleryInstanceFilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MediaGalleryInstanceFilesBatchRoute);
    return MediaGalleryInstanceFilesBatchRoute;
}(common_1.BaseRoute));
exports.MediaGalleryInstanceFilesBatchRoute = MediaGalleryInstanceFilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryInstanceFilesBatchClient
 * @description  Media Gallery Instance Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(15);
var MediaGalleryInstanceFilesBatchClient = /** @class */ (function () {
    function MediaGalleryInstanceFilesBatchClient(mediaGalleryInstanceFilesBatchRoute, apiClient) {
        this.mediaGalleryInstanceFilesBatchRoute = mediaGalleryInstanceFilesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaGalleryInstanceFilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGalleryInstanceFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param mediaGalleryId Media Gallery file id of the original media gallery file used to identify media gallery files on which delete action should be performed.
     * @param data Collection of media gallery delete requests which uniquely identifies media gallery files that need to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                   mediaGalleryInstanceFilesBatchClient.unlink([{ id: '<file-id>' }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    MediaGalleryInstanceFilesBatchClient.prototype.unlink = function (mediaGalleryId, data) {
        return this.apiClient.delete(this.mediaGalleryInstanceFilesBatchRoute.unlink(mediaGalleryId), undefined, data);
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery file need to be updated.
     * @param data Media Gallery file object that need to be updated in the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example mediaGalleryInstanceFilesBatchClient.update('<media-gallery-id>', files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    MediaGalleryInstanceFilesBatchClient.prototype.update = function (mediaGalleryId, data) {
        return this.apiClient.put(this.routeDefinition.update(mediaGalleryId), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param mediaGalleryId Media Gallery slug or id which uniquely identifies media gallery whose media gallery files need to be linked.
     * @param data A collection of media gallery file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example mediaGalleryInstanceFilesBatchClient.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    MediaGalleryInstanceFilesBatchClient.prototype.link = function (mediaGalleryId, data) {
        return this.apiClient.post(this.routeDefinition.link(mediaGalleryId), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    MediaGalleryInstanceFilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.MediaGalleryInstanceFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.MediaGalleryInstanceFilesBatchRoute !== "undefined" && __1.MediaGalleryInstanceFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MediaGalleryInstanceFilesBatchClient);
    return MediaGalleryInstanceFilesBatchClient;
}());
exports.MediaGalleryInstanceFilesBatchClient = MediaGalleryInstanceFilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryInstanceFilesRoute
 * @description Baasic Media Gallery Instance Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Media Gallery Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(15);
var MediaGalleryInstanceFilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MediaGalleryInstanceFilesRoute, _super);
    function MediaGalleryInstanceFilesRoute(mediaGalleryInstanceFilesBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.mediaGalleryInstanceFilesBatchRoute = mediaGalleryInstanceFilesBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'media-galleries/{mediaGalleryId}/files/{?searchQuery,fileName,minFileSize,maxFileSize,ids,from,to,page,rpp,sort,embed,fields}';
        _this.getRoute = 'media-galleries/{mediaGalleryId}/files/{id}/{?embed,fields}';
        _this.linkRoute = 'media-galleries/{mediaGalleryId}/files/link';
        _this.unlinkRoute = 'media-galleries/{mediaGalleryId}/files/unlink/{id}';
        _this.unlinkByMediaGalleryRoute = 'media-galleries/{mediaGalleryId}/files/unlink';
        _this.updateRoute = 'media-galleries/{mediaGalleryId}/files/{id}';
        return _this;
    }
    Object.defineProperty(MediaGalleryInstanceFilesRoute.prototype, "batch", {
        get: function () {
            return this.mediaGalleryInstanceFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param mediaGalleryId Media Gallery slug or id which uniquely identifies media gallery whose media gallery files need to be retrieved.
     * @param options Query resource options object.
     * @example mediaGalleryInstanceFilesRoute.find({searchQuery: '<search-phrase>'});
     **/
    MediaGalleryInstanceFilesRoute.prototype.find = function (mediaGalleryId, options) {
        var params = this.modelMapper.findParams(options);
        params.mediaGalleryId = mediaGalleryId;
        return _super.prototype.baseGet.call(this, this.findRoute, params);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery files need to be retrieved.
     * @param id Media Gallery file id which uniquely identifies media gallery file that needs to be retrieved.
     * @param options options object that contains embed data.
     * @example mediaGalleryInstanceFilesRoute.get({id: '<file-id>'});
     **/
    MediaGalleryInstanceFilesRoute.prototype.get = function (mediaGalleryId, id, options) {
        var params = this.utility.extend({}, options);
        params.mediaGalleryId = mediaGalleryId;
        params.id = id;
        return _super.prototype.baseGet.call(this, this.getRoute, params);
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery files need to be deleted.
     * @param data
     * @param options
     * @example mediaGalleryInstanceFilesRoute.link();
     **/
    MediaGalleryInstanceFilesRoute.prototype.link = function (mediaGalleryId, data) {
        var params = this.utility.extend({}, data);
        params.mediaGalleryId = mediaGalleryId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies gallery whose gallery files need to be deleted.
     * @param data
     * @example mediaGalleryFilesRoute.unlink(mediaGalleryId,data);
     **/
    MediaGalleryInstanceFilesRoute.prototype.unlink = function (mediaGalleryId, data) {
        data.mediaGalleryId = mediaGalleryId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data);
    };
    /**
     * Parses unlink by media gallery route; this URI template does not expose any additional options.
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery files need to be deleted.
     * @param data
     * @param options
     * @example mediaGalleryFilesRoute.unlinkByMediaGallery(data);
     **/
    MediaGalleryInstanceFilesRoute.prototype.unlinkByMediaGallery = function (mediaGalleryId, options) {
        return _super.prototype.baseDelete.call(this, this.unlinkByMediaGalleryRoute, mediaGalleryId, options, 'unlink-by-media-gallery');
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example mediaGalleryInstanceFilesRoute.update(data);
     **/
    MediaGalleryInstanceFilesRoute.prototype.update = function (mediaGalleryId, data) {
        var params = this.modelMapper.updateParams(data);
        params.mediaGalleryId = mediaGalleryId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    var _a, _b;
    MediaGalleryInstanceFilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.MediaGalleryInstanceFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.MediaGalleryInstanceFilesBatchRoute !== "undefined" && __1.MediaGalleryInstanceFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], MediaGalleryInstanceFilesRoute);
    return MediaGalleryInstanceFilesRoute;
}(common_1.BaseRoute));
exports.MediaGalleryInstanceFilesRoute = MediaGalleryInstanceFilesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module mediaGalleryInstanceFilesClient
 * @description  Media Gallery Instance Files Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(15);
var MediaGalleryInstanceFilesClient = /** @class */ (function () {
    function MediaGalleryInstanceFilesClient(mediaGalleryInstanceFilesRoute, MediaGalleryInstanceFilesBatchClient, apiClient) {
        this.mediaGalleryInstanceFilesRoute = mediaGalleryInstanceFilesRoute;
        this.MediaGalleryInstanceFilesBatchClient = MediaGalleryInstanceFilesBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MediaGalleryInstanceFilesClient.prototype, "routeDefinition", {
        get: function () {
            return this.mediaGalleryInstanceFilesRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MediaGalleryInstanceFilesClient.prototype, "batch", {
        get: function () {
            return this.MediaGalleryInstanceFilesBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of file resources matching the given criteria.
     * @method
     * @param mediaGalleryId Media Galleryslug or id which uniquely identifies media gallery whose media gallery files need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example mediaGalleryInstanceFilesClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    ids: '1,2,3',
                    from: '',
                    to: '',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    MediaGalleryInstanceFilesClient.prototype.find = function (mediaGalleryId, options) {
        return this.apiClient.get(this.mediaGalleryInstanceFilesRoute.find(mediaGalleryId, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested file resource.
     * @method
     * @param mediaGalleryId Media Galleryslug or id which uniquely identifies media gallery whose media gallery files need to be retrieved.
     * @param id Media Galleryfile id which uniquely identifies media gallery file that needs to be retrieved.
     * @param options options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example mediaGalleryInstanceFilesClient.get('<file-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    MediaGalleryInstanceFilesClient.prototype.get = function (mediaGalleryId, id, options) {
        return this.apiClient.get(this.mediaGalleryInstanceFilesRoute.get(mediaGalleryId, id, options));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove one or many file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicMediaGalleryFilesRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink').href;
     * ```
     * @method
     * @param mediaGalleryId Media Gallery slug or id which uniquely identifies media gallery whose media gallery files need to be deleted.
     * @param data
     * @param options
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action. The following action will unlink the original file resource and all accompanying derived file resources.
                    mediaGalleryInstanceFilesRoute.unlink(galleryId, fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    MediaGalleryInstanceFilesClient.prototype.unlink = function (mediaGalleryId, data) {
        return this.apiClient.delete(this.mediaGalleryInstanceFilesRoute.unlink(mediaGalleryId, data));
    };
    /**
     * Returns a promise that is resolved once the unlink by media gallery action has been performed. This action will remove all file resources from the system related to the requested media gallery if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicMediaGalleryService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink-by-media-gallery').href;
     * ```
     * @method
     * @param mediaGalleryId Media Galleryslug or id which uniquely identifies media gallery whose media gallery files need to be deleted.
     * @param data
     * @param options
     * @returns A promise that is resolved once the unlink by media gallery action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                    mediaGalleryInstanceFilesClient.unlinkByMediaGallery(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MediaGalleryInstanceFilesClient.prototype.unlinkByMediaGallery = function (mediaGalleryId, options) {
        return this.apiClient.delete(this.mediaGalleryInstanceFilesRoute.unlinkByMediaGallery(mediaGalleryId, options));
    };
    /**
     * Returns a promise that is resolved once the update file action has been performed; this action will update a file resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicMediaGalleryFilesRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     ```
     let params = modelMapper.updateParams(fileEntry);
     let uri = params['model'].links('put').href;
     ```
     * @method
     * @param mediaGalleryId An media gallery object used to update specified media gallery resource.
     * @param data Media GalleryFile object used to update specific media gallery file data in the system.
     * @returns A promise that is resolved once the update file action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                   fileEntry.description = '<description>';
                   mediaGalleryInstanceFilesClient.update(fileEntry)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    MediaGalleryInstanceFilesClient.prototype.update = function (mediaGalleryId, data) {
        return this.apiClient.put(this.routeDefinition.update(mediaGalleryId, data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resource from other modules into the Media GalleryFiles module (For example: file resources from the Media Vault module can be linked directly into the Media GalleryFiles module).
     * @method
     * @param mediaGalleryId Media Gallery id which uniquely identifies media gallery whose media gallery files need to be linked.
     * @param data A media gallery file object that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example mediaGalleryInstanceFilesClient.link(fileObject)
                    .then(function (response, status, headers, config) {
                        // perform success handling here
                    },
                        function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    MediaGalleryInstanceFilesClient.prototype.link = function (mediaGalleryId, data) {
        return this.apiClient.post(this.routeDefinition.link(mediaGalleryId, data), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c;
    MediaGalleryInstanceFilesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.MediaGalleryInstanceFilesRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.MediaGalleryInstanceFilesBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.MediaGalleryInstanceFilesRoute !== "undefined" && __1.MediaGalleryInstanceFilesRoute) === "function" ? _a : Object, typeof (_b = typeof __1.MediaGalleryInstanceFilesBatchClient !== "undefined" && __1.MediaGalleryInstanceFilesBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], MediaGalleryInstanceFilesClient);
    return MediaGalleryInstanceFilesClient;
}());
exports.MediaGalleryInstanceFilesClient = MediaGalleryInstanceFilesClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(15);
var inversify_1 = __webpack_require__(1);
var Root = /** @class */ (function () {
    function Root(galleries, files, settings) {
        this.galleries = galleries;
        this.files = files;
        this.settings = settings;
    }
    var _a, _b, _c;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MediaGalleryClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MediaGalleryFileClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MediaGallerySettingsClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MediaGalleryClient !== "undefined" && _1.MediaGalleryClient) === "function" ? _a : Object, typeof (_b = typeof _1.MediaGalleryFileClient !== "undefined" && _1.MediaGalleryFileClient) === "function" ? _b : Object, typeof (_c = typeof _1.MediaGallerySettingsClient !== "undefined" && _1.MediaGallerySettingsClient) === "function" ? _c : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;


/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(26);
var TYPES = {
    FilesACLClient: Symbol("FilesACLClient"),
    FilesACLRoute: Symbol("FilesACLRoute"),
    FilesBatchRoute: Symbol("FilesBatchRoute"),
    FilesBatchClient: Symbol("FilesBatchClient"),
    FilesRoute: Symbol("FilesRoute"),
    FilesClient: Symbol("FilesClient"),
    FilesStreamsRoute: Symbol("FilesStreamsRoute"),
    FilesStreamsClient: Symbol("FilesStreamsClient")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.FilesBatchRoute).to(_1.FilesBatchRoute);
    bind(TYPES.FilesBatchClient).to(_1.FilesBatchClient);
    bind(TYPES.FilesStreamsRoute).to(_1.FilesStreamsRoute);
    bind(TYPES.FilesStreamsClient).to(_1.FilesStreamsClient);
    bind(TYPES.FilesACLRoute).to(_1.FilesACLRoute);
    bind(TYPES.FilesACLClient).to(_1.FilesACLClient);
    bind(TYPES.FilesRoute).to(_1.FilesRoute);
    bind(TYPES.FilesClient).to(_1.FilesClient);
});
exports.diModule = diModule;


/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module filesStreamsRoute
 * @description Baasic Files Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var FilesStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(FilesStreamsRoute, _super);
    function FilesStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'file-streams/{id}/{?width,height,t}';
        _this.updateRoute = 'file-streams/{id}/{?width,height}';
        _this.createRoute = 'file-streams/{path}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id or path of desired file stream. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @example filesStreamsRoute.get({id: '<path>'});
     **/
    FilesStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses update route; this route should be expanded with the id or path of the previously saved resource. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @example filesStreamsRoute.update({id: '<path>'});
     **/
    FilesStreamsRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.updateRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the path which indicates where the stream will be saved.
     * @method
     * @example filesStreamsRoute.create({path: '<path>'});
     **/
    FilesStreamsRoute.prototype.create = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                path: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    var _a;
    FilesStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], FilesStreamsRoute);
    return FilesStreamsRoute;
}(common_1.BaseRoute));
exports.FilesStreamsRoute = FilesStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module filesStreamsClient
 * @description  Files Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(26);
var FilesStreamsClient = /** @class */ (function () {
    function FilesStreamsClient(filesStreamsRoute, apiClient) {
        this.filesStreamsRoute = filesStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(FilesStreamsClient.prototype, "routeDefinition", {
        get: function () {
            return this.filesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a stream of the derived resource. Otherwise, stream of the original file resource will be retrieved.
     * @method
     * @param id File id of the original file resource used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original file stream
                        filesStreamsClient.get({id: '<path>'})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
                // Request derived file stream
                    filesStreamsClient.get({id: '<path>', width: <width>, height: <height>, t: <timestamp>})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    FilesStreamsClient.prototype.get = function (data) {
        return this.apiClient.get(this.routeDefinition.get(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a blob of the derived file resource. Otherwise, blob of the original file resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @example // Request the original blob
                    filesStreamsClient.getBlob('<path>')
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
                // Request derived blob
                    filesStreamsClient.getBlob({id: '<path>', width: <width>, height: <height>, t: <timestamp>})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    FilesStreamsClient.prototype.getBlob = function (data) {
        return this.apiClient.request({
            url: this.filesStreamsRoute.get(data),
            responseType: 'blob',
            headers: { 'Accept': 'application/octet-stream' },
            method: 'GET'
        });
    };
    /**
     * Returns a promise that is resolved once the update file stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of file stream data type).
     * @method
     * @example // Update original file stream
                    filesStreamsClient.update('<path>', <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
                // Update derived file stream
                    filesStreamsClient.update({id: '<path>', width: <width>, height: <height>}, <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    FilesStreamsClient.prototype.update = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.filesStreamsRoute.update(data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the create file stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @example filesStreamsClient.create('<path>', <blob>)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    FilesStreamsClient.prototype.create = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.filesStreamsRoute.create(data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    FilesStreamsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.FilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.FilesStreamsRoute !== "undefined" && _1.FilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], FilesStreamsClient);
    return FilesStreamsClient;
}());
exports.FilesStreamsClient = FilesStreamsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */


/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module filesBatchRoute
 * @description Baasic Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var FilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(FilesBatchRoute, _super);
    function FilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.updateRoute = 'files/batch';
        _this.linkRoute = 'files/batch/link';
        _this.unlinkRoute = 'files/batch/unlink';
        return _this;
    }
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example filesBatchRoute.update();
     **/
    FilesBatchRoute.prototype.update = function () {
        return _super.prototype.baseCreate.call(this, this.updateRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example filesBatchRoute.link();
     **/
    FilesBatchRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @example filesBatchRoute.unlink();
     **/
    FilesBatchRoute.prototype.unlink = function () {
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, {});
    };
    var _a;
    FilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], FilesBatchRoute);
    return FilesBatchRoute;
}(common_1.BaseRoute));
exports.FilesBatchRoute = FilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module filesBatchClient
 * @description  Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(26);
var FilesBatchClient = /** @class */ (function () {
    function FilesBatchClient(filesBatchRoute, apiClient) {
        this.filesBatchRoute = filesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(FilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.filesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param data A collection of file objects used to update specified file resources.
     * @returns A promise that is resolved once the update action has been performed.
     * @example filesClient.update(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param data A collection of file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example filesBatchClient.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesBatchClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will remove just derived resource. Otherwise, specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param data Collection of file delete requests which uniquely identifies file resources that need to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                    filesBatchClient.unlink([{ id: '<file-id>' }])
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
                // Remove derived file resources
                    filesBatchClient.unlink([{ id: '<file-id>', fileFormat: { width: <width>, height: <height> } }])
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    FilesBatchClient.prototype.unlink = function (data) {
        return this.apiClient.delete(this.filesBatchRoute.unlink(), undefined, data);
    };
    var _a, _b;
    FilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.FilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.FilesBatchRoute !== "undefined" && _1.FilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], FilesBatchClient);
    return FilesBatchClient;
}());
exports.FilesBatchClient = FilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module filesACLRoute
 * @description Baasic Files ACL Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var FilesACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(FilesACLRoute, _super);
    function FilesACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'files/{id}/acl/{?fields}';
        _this.updateRoute = 'files/{id}/acl/{?fields}';
        _this.deleteByUserRoute = 'files/{id}/acl/actions/{accessAction}/users/{user}/';
        _this.deleteByRoleRoute = 'files/{id}/acl/actions/{accessAction}/roles/{role}/';
        return _this;
    }
    /**
     * Parses get acl route; this URI template should be expanded with the Id of the file resource.
     * @method
     * @example filesACLRoute.get({id: '<file-id>'});
     **/
    FilesACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update acl route; this URI template should be expanded with the Id of the file resource.
     * @method
     * @example filesACLRoute.update({id: '<file-id>'});
     **/
    FilesACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses deleteByUser acl route which can be expanded with additional options. Supported items are:
     * - `id` - File id which uniquely identifies file resource whose security privileges need to be retrieved and updated.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and file resource.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param id File id which uniquely identifies file resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and file resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @example filesACLRoute.deleteByUser({ id: '<file-id>', accessAction: '<access-action>', user: '<username>' });
     **/
    FilesACLRoute.prototype.deleteByUser = function (id, action, user, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.user = user;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByUser acl route which can be expanded with additional options. Supported items are:
     * - `id` - File id which uniquely identifies file resource whose security privileges need to be retrieved and updated.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and file resource.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param id File id which uniquely identifies file resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and file resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @example filesACLRoute.deleteByRole({ id: '<file-id>', accessAction: '<access-action>', role: '<role-name>' });
     **/
    FilesACLRoute.prototype.deleteByRole = function (id, action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    FilesACLRoute.prototype.updateParams = function (data) {
        var params = this.utility.extend({}, data);
        return params[this.modelMapper.modelPropertyName];
    };
    var _a;
    FilesACLRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], FilesACLRoute);
    return FilesACLRoute;
}(common_1.BaseRoute));
exports.FilesACLRoute = FilesACLRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module filesACLClient
 * @description  Files ACL Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(26);
var FilesACLClient = /** @class */ (function () {
    function FilesACLClient(filesACLRoute, apiClient) {
        this.filesACLRoute = filesACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(FilesACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.filesACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified file resource.
     * @method
     * @param options ACL options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example filesACLClient.get({id: '<file-id>'})
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed, this action creates new ACL policy for the specified file resource.
     * @method
     * @param options An ACL policy object that needs to be inserted into the system. This object specifies parameters necessary for establishing user and/or role set of rights.
     * @example let options = {id : '<file-id>'};
                let aclObj =  {  actionId: '<action-id>',  roleId: '<role-id>',  userId: '<user-id>' };
                options[baasicConstants.modelPropertyName] = aclObj;
                filesACLClient.update(options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and file resource.
     * @method
     * @param id File id which uniquely identifies file resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and file resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @returns A promise that is resolved once the removeByUser action has been performed.
     * @example filesACLClient.removeByUser('<file-id>', '<access-action>', '<username>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesACLClient.prototype.removeByUser = function (id, action, user, data) {
        return this.apiClient.delete(this.filesACLRoute.deleteByUser(id, action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and file resource.
     * @method
     * @example filesACLClient.removeByRole('<file-id>', '<access-action>', '<role-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesACLClient.prototype.removeByRole = function (id, action, role, data) {
        return this.apiClient.delete(this.filesACLRoute.deleteByRole(id, action, role, data));
    };
    var _a, _b;
    FilesACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.FilesACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.FilesACLRoute !== "undefined" && _1.FilesACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], FilesACLClient);
    return FilesACLClient;
}());
exports.FilesACLClient = FilesACLClient;
/**
 * @overview
***Notes:**
- Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
- All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module filesRoute
 * @description Baasic Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(26);
var contracts_1 = __webpack_require__(3);
var FilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(FilesRoute, _super);
    function FilesRoute(appOptions, filesStreamsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.filesStreamsRoute = filesStreamsRoute;
        _this.findRoute = 'files/{?searchQuery,page,rpp,sort,embed,fields,fileName,from,to,ids,minFileSize,maxFileSize}';
        _this.getRoute = 'files/{id}/{?embed,fields}';
        _this.updateRoute = 'files/{id}';
        _this.unlinkRoute = 'files/unlink/{id}/{?height,width}';
        _this.linkRoute = 'files/link';
        return _this;
    }
    Object.defineProperty(FilesRoute.prototype, "streams", {
        get: function () {
            return this.filesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example filesRoute.find({searchQuery: '<search-phrase>'});
     **/
    FilesRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param id File id which uniquely identifies file resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example filesRoute.get({id: '<file-id>'});
     **/
    FilesRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route should be expanded with the Id of the file resource.
     * @method
     * @param data A file entry object used to update specific file entry resource in the system.
     * @example filesRoute.get({id: '<file-id>'});
     **/
    FilesRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses unlink route; this route should be expanded with the Id of the file resource.
     * @method
     * @param data A file entry object used to update specific file entry resource in the system.
     * @example filesRoute.unlink({id: '<file-id>'});
     **/
    FilesRoute.prototype.unlink = function (data, options) {
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data, options, 'unlink');
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @example filesRoute.link();
     **/
    FilesRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    var _a, _b;
    FilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.FilesStreamsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.FilesStreamsRoute !== "undefined" && _1.FilesStreamsRoute) === "function" ? _b : Object])
    ], FilesRoute);
    return FilesRoute;
}(common_1.BaseRoute));
exports.FilesRoute = FilesRoute;
/**
 * @overview
***Notes:**
- Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
- [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
- All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module filesClient
 * @description  Files Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(26);
var FilesClient = /** @class */ (function () {
    function FilesClient(filesRoute, apiClient, filesStreamsClient, filesBatchClient, filesACLClient) {
        this.filesRoute = filesRoute;
        this.apiClient = apiClient;
        this.filesStreamsClient = filesStreamsClient;
        this.filesBatchClient = filesBatchClient;
        this.filesACLClient = filesACLClient;
    }
    Object.defineProperty(FilesClient.prototype, "routeDefinition", {
        get: function () {
            return this.filesRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilesClient.prototype, "streams", {
        get: function () {
            return this.filesStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilesClient.prototype, "batch", {
        get: function () {
            return this.filesBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FilesClient.prototype, "acl", {
        get: function () {
            return this.filesACLClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of file resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example filesClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    FilesClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested file resource.
     * @method
     * @param id File id which uniquely identifies file resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example filesClient.get('<file-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.filesRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update file action has been performed; this action will update a file resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `filesRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(fileEntry);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A file entry object used to update specific file entry resource in the system.
     * @example // fileEntry is a file resource previously fetched using get action.
                    fileEntry.description = '<description>';
                    filesClient.update(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    FilesClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove one or many file resources from the system if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will remove just derived resource. Otherwise, specified file and all its accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicFilesRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink').href;
     * ```
     * @method
     * @param data
     * @param options
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action. The following action will remove the original file resource and all accompanying derived file resources.
                    filesClient.unlink(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
                // fileEntry is a file resource previously fetched using get action. The following action will remove derived file resource only.
                    filesClient.unlink(fileEntry, {width: <width>, height: <height>})
                        .then(function (data) {
                            // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    FilesClient.prototype.unlink = function (data, options) {
        return this.apiClient.delete(this.filesRoute.unlink(data, options));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resource from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param data A file object that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example filesClient.link(fileObject)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    FilesClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c, _d, _e;
    FilesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.FilesRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.FilesStreamsClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.FilesBatchClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.FilesACLClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.FilesRoute !== "undefined" && _1.FilesRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof _1.FilesStreamsClient !== "undefined" && _1.FilesStreamsClient) === "function" ? _c : Object, typeof (_d = typeof _1.FilesBatchClient !== "undefined" && _1.FilesBatchClient) === "function" ? _d : Object, typeof (_e = typeof _1.FilesACLClient !== "undefined" && _1.FilesACLClient) === "function" ? _e : Object])
    ], FilesClient);
    return FilesClient;
}());
exports.FilesClient = FilesClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
    */ 


/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(391), exports);
tslib_1.__exportStar(__webpack_require__(392), exports);
tslib_1.__exportStar(__webpack_require__(393), exports);
tslib_1.__exportStar(__webpack_require__(394), exports);


/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(30);
var TYPES = {
    TemplatingBatchClient: Symbol("TemplatingBatchClient"),
    TemplatingBatchRoute: Symbol("TemplatingBatchRoute"),
    TemplatingClient: Symbol("TemplatingClient"),
    TemplatingRoute: Symbol("TemplatingRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.TemplatingBatchRoute).to(_1.TemplatingBatchRoute);
    bind(TYPES.TemplatingBatchClient).to(_1.TemplatingBatchClient);
    bind(TYPES.TemplatingRoute).to(_1.TemplatingRoute);
    bind(TYPES.TemplatingClient).to(_1.TemplatingClient);
});
exports.diModule = diModule;


/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*global module */
/**
 * @module templatingBatchRoute
 * @description Baasic Templating Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Templating Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var TemplatingBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(TemplatingBatchRoute, _super);
    function TemplatingBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'templates/batch';
        _this.updateRoute = 'templates/batch';
        _this.deleteRoute = 'templates/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example templatingBatchRoute.create();
     **/
    TemplatingBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example templatingBatchRoute.update();
     **/
    TemplatingBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example templatingBatchRoute.delete();
     **/
    TemplatingBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    TemplatingBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], TemplatingBatchRoute);
    return TemplatingBatchRoute;
}(common_1.BaseRoute));
exports.TemplatingBatchRoute = TemplatingBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module templatingBatchClient
 * @description  Templating Batch Client provides an easy way to consume  Templating REST API end-points. In order to obtain a needed routes `templatingBatchClient` uses `templatingBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(30);
var TemplatingBatchClient = /** @class */ (function () {
    function TemplatingBatchClient(templatingBatchRoute, apiClient) {
        this.templatingBatchRoute = templatingBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(TemplatingBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.templatingBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create action has been performed; this action creates new template resources.
     * @method
     * @param data An Template objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create action has been performed.
     * @example templatingBatchClient.create([{ content : '<content>', templateId : '<template-id>' }])
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
    **/
    TemplatingBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified template resources.
     * @method
     * @param data An Template objects that need to be inserted into the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example templatingBatchClient.update(templates)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    TemplatingBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove template resources from the system if successfully completed.
     * @method
     * @param ids Template ids which uniquely identify Template resources that need to be deleted.
     * @returns A promise that is resolved once the update action has been performed.
     * @example templatingBatchClient.remove(companyIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    TemplatingBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.templatingBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    TemplatingBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.TemplatingBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.TemplatingBatchRoute !== "undefined" && _1.TemplatingBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], TemplatingBatchClient);
    return TemplatingBatchClient;
}());
exports.TemplatingBatchClient = TemplatingBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/*global module */
/**
 * @module templatingRoute
 * @description Baasic Templating Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Templating Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(30);
var contracts_1 = __webpack_require__(3);
var TemplatingRoute = /** @class */ (function (_super) {
    tslib_1.__extends(TemplatingRoute, _super);
    function TemplatingRoute(appOptions, templatingBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.templatingBatchRoute = templatingBatchRoute;
        _this.findRoute = 'templates/{?searchQuery,page,rpp,sort,embed,fields,moduleNames}';
        _this.getRoute = 'templates/{id}/{?embed,fields}';
        _this.createRoute = 'templates';
        _this.updateRoute = 'templates/{id}';
        _this.deleteRoute = 'templates/{id}';
        return _this;
    }
    Object.defineProperty(TemplatingRoute.prototype, "batch", {
        get: function () {
            return this.templatingBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify template resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain template subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the template property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options.
     * @example templatingRoute.find({searchQuery: '<search-phrase>'});
     **/
    TemplatingRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route which must be expanded with the Id of the previously created template resource in the system.
     * @method
     * @param id Template id which uniquely identifies Template resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example templatingRoute.get({id: '<template-id>'});
     **/
    TemplatingRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example templatingRoute.create();
     **/
    TemplatingRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data An template object used to update specified Template resource.
     * @example templatingRoute.update(data);
     **/
    TemplatingRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this URI template does not expose any additional options.
     * @method
     * @param data An template object used to delete specified Template resource.
     * @example templatingRoute.update(data);
     **/
    TemplatingRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    TemplatingRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.TemplatingBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.TemplatingBatchRoute !== "undefined" && _1.TemplatingBatchRoute) === "function" ? _b : Object])
    ], TemplatingRoute);
    return TemplatingRoute;
}(common_1.BaseRoute));
exports.TemplatingRoute = TemplatingRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module templatingClient
 * @description  Templating Client provides an easy way to consume  Templating REST API end-points. In order to obtain a needed routes `templatingClient` uses `templatingRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(30);
var TemplatingClient = /** @class */ (function () {
    function TemplatingClient(templatingRoute, templatingBatchClient, apiClient) {
        this.templatingRoute = templatingRoute;
        this.templatingBatchClient = templatingBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(TemplatingClient.prototype, "routeDefinition", {
        get: function () {
            return this.templatingRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(TemplatingClient.prototype, "batch", {
        get: function () {
            return this.templatingBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of template resources matching the given criteria.
     * @method
     * @param options Query resource options.
     * @returns A promise that is resolved once the find action has been performed.
     * @example templatingClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    TemplatingClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified template resource.
     * @method
     * @param id Template id which uniquely identifies Template resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example templatingClient.get('<template-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    TemplatingClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.templatingRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create template action has been performed; this action creates a new template resource.
     * @method
     * @param data An Template object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create template action has been performed.
     * @example templatingClient.create({  content : '<content>',  templateId : '<template-id>' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    TemplatingClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update template action has been performed; this action updates a template resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicTemplatingRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(template);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An template object used to update specified Template resource.
     * @returns A promise that is resolved once the update template action has been performed.
     * @example // template is a resource previously fetched using get action.
                    template.content = '<new-content>';
                    templatingClient.update(template)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    TemplatingClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a template resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicTemplatingRouteDefiniton` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(template);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An template object used to delete specified Template resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // template is a resource previously fetched using get action.
                    templatingClient.remove(template)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    TemplatingClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    TemplatingClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.TemplatingRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.TemplatingBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.TemplatingRoute !== "undefined" && _1.TemplatingRoute) === "function" ? _a : Object, typeof (_b = typeof _1.TemplatingBatchClient !== "undefined" && _1.TemplatingBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], TemplatingClient);
    return TemplatingClient;
}());
exports.TemplatingClient = TemplatingClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(401), exports);


/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(18);
var TYPES = {
    MeteringACLClient: Symbol("MeteringACLClient"),
    MeteringACLRoute: Symbol("MeteringACLRoute"),
    MeteringBatchClient: Symbol("MeteringBatchClient"),
    MeteringBatchRoute: Symbol("MeteringBatchRoute"),
    MeteringCategoryBatchClient: Symbol("MeteringCategoryBatchClient"),
    MeteringCategoryBatchRoute: Symbol("MeteringCategoryBatchRoute"),
    MeteringCategoryRoute: Symbol("MeteringCategoryRoute"),
    MeteringCategoryClient: Symbol("MeteringCategoryClient"),
    MeteringRoute: Symbol("MeteringRoute"),
    MeteringClient: Symbol("MeteringClient"),
    MeteringSettingsRoute: Symbol("MeteringSettingsRoute"),
    MeteringSettingsClient: Symbol("MeteringSettingsClient"),
    MeteringStatisticsClient: Symbol("MeteringStatisticsClient"),
    MeteringStatisticsRoute: Symbol("MeteringStatisticsRoute")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.MeteringCategoryBatchRoute).to(_1.MeteringCategoryBatchRoute);
    bind(TYPES.MeteringCategoryBatchClient).to(_1.MeteringCategoryBatchClient);
    bind(TYPES.MeteringCategoryRoute).to(_1.MeteringCategoryRoute);
    bind(TYPES.MeteringCategoryClient).to(_1.MeteringCategoryClient);
    bind(TYPES.MeteringBatchRoute).to(_1.MeteringBatchRoute);
    bind(TYPES.MeteringBatchClient).to(_1.MeteringBatchClient);
    bind(TYPES.MeteringStatisticsRoute).to(_1.MeteringStatisticsRoute);
    bind(TYPES.MeteringStatisticsClient).to(_1.MeteringStatisticsClient);
    bind(TYPES.MeteringACLRoute).to(_1.MeteringACLRoute);
    bind(TYPES.MeteringACLClient).to(_1.MeteringACLClient);
    bind(TYPES.MeteringRoute).to(_1.MeteringRoute);
    bind(TYPES.MeteringClient).to(_1.MeteringClient);
    bind(TYPES.MeteringSettingsRoute).to(_1.MeteringSettingsRoute);
    bind(TYPES.MeteringSettingsClient).to(_1.MeteringSettingsClient);
});
exports.diModule = diModule;


/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringCategoryBatchRoute  * @description Baasic Metering Category Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Metering Category Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var MeteringCategoryBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MeteringCategoryBatchRoute, _super);
    function MeteringCategoryBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'metering/categories/batch';
        _this.updateRoute = 'metering/categories/batch';
        _this.deleteRoute = 'metering/categories/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example meteringCategoryBatchRoute.create();
     **/
    MeteringCategoryBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example meteringCategoryBatchRoute.update();
     **/
    MeteringCategoryBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example meteringCategoryBatchRoute.delete();
     **/
    MeteringCategoryBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    MeteringCategoryBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MeteringCategoryBatchRoute);
    return MeteringCategoryBatchRoute;
}(common_1.BaseRoute));
exports.MeteringCategoryBatchRoute = MeteringCategoryBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringCategoryBatchClient
 * @description  Metering Category Batch Client provides an easy way to consume  Metering REST API end-points. In order to obtain a needed routes `meteringCategoryBatchClient` uses `meteringCategoryBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(18);
var MeteringCategoryBatchClient = /** @class */ (function () {
    function MeteringCategoryBatchClient(meteringCategoryBatchRoute, apiClient) {
        this.meteringCategoryBatchRoute = meteringCategoryBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MeteringCategoryBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.meteringCategoryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create category action has been performed; this action creates new category resources.
     * @method
     * @param data An MeteringCategory objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create category action has been performed.
     * @example  meteringCategoryBatchClient.create([{
                    aggregateFunction : '<aggregateFunction>',
                    category : '<name>',
                     defaultSamplingRate: '<defaultSamplingRate>',
                     slug: '<slug>',
                     unitFactor: '<unitFactor>',
                     unitName: '<unitName>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    MeteringCategoryBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update category action has been performed; this action updates specified category resources.
     * @method
     * @param data An MeteringCategory objects used to update specified MeteringCategory resources.
     * @returns A promise that is resolved once the update category action has been performed.
     * @example   meteringCategoryClient.update(companies)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringCategoryBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove category resources from the system if successfully completed.
     * @method
     * @param ids MeteringCategory ids which uniquely identify MeteringCategory resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example companyClient.remove(companyIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringCategoryBatchClient.prototype.delete = function (ids) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(ids));
    };
    var _a, _b;
    MeteringCategoryBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MeteringCategoryBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MeteringCategoryBatchRoute !== "undefined" && _1.MeteringCategoryBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MeteringCategoryBatchClient);
    return MeteringCategoryBatchClient;
}());
exports.MeteringCategoryBatchClient = MeteringCategoryBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringCategoryRoute  * @description Baasic Metering Category Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Metering Category Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(18);
var contracts_1 = __webpack_require__(3);
var MeteringCategoryRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MeteringCategoryRoute, _super);
    function MeteringCategoryRoute(appOptions, meteringCategoryBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.meteringCategoryBatchRoute = meteringCategoryBatchRoute;
        _this.findRoute = 'metering/categories/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'metering/categories/{id}/{?embed,fields}';
        _this.createRoute = 'metering/categories';
        _this.updateRoute = 'metering/categories/{id}';
        _this.deleteRoute = 'metering/categories/{id}';
        return _this;
    }
    Object.defineProperty(MeteringCategoryRoute.prototype, "batch", {
        get: function () {
            return this.meteringCategoryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find metering category route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify metering resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain metering subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the metering property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example meteringCategoryRoute.find({searchQuery: '<search-phrase>'});
     **/
    MeteringCategoryRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id MeteringCategory id which uniquely identifies MeteringCategory resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example meteringCategoryRoute.get(id);
     **/
    MeteringCategoryRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create metering category route; this URI template does not expose any additional options.
     * @method
     * @example meteringCategoryRoute.create();
     **/
    MeteringCategoryRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update metering category route; this URI template does not expose any additional options.
     * @method
     * @param data An meteringCategory object used to update specified MeteringCategory resource.
     * @example meteringCategoryRoute.update();
     **/
    MeteringCategoryRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete metering category route; this URI template does not expose any additional options.
     * @method
     * @param data An meteringCategory object used to delete specified MeteringCategory resource.
     * @example meteringCategoryRoute.delete();
     **/
    MeteringCategoryRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    MeteringCategoryRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MeteringCategoryBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.MeteringCategoryBatchRoute !== "undefined" && _1.MeteringCategoryBatchRoute) === "function" ? _b : Object])
    ], MeteringCategoryRoute);
    return MeteringCategoryRoute;
}(common_1.BaseRoute));
exports.MeteringCategoryRoute = MeteringCategoryRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringCategoryClient
 * @description  Metering Category Client provides an easy way to consume  Metering REST API end-points. In order to obtain a needed routes `meteringCategoryClient` uses `meteringCategoryRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(18);
var MeteringCategoryClient = /** @class */ (function () {
    function MeteringCategoryClient(meteringCategoryRoute, apiClient, meteringCategoryBatchClient) {
        this.meteringCategoryRoute = meteringCategoryRoute;
        this.apiClient = apiClient;
        this.meteringCategoryBatchClient = meteringCategoryBatchClient;
    }
    Object.defineProperty(MeteringCategoryClient.prototype, "routeDefinition", {
        get: function () {
            return this.meteringCategoryRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeteringCategoryClient.prototype, "batch", {
        get: function () {
            return this.meteringCategoryBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of metering resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example meteringCategoryClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    MeteringCategoryClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the metering resource.
     * @method
     * @param id MeteringCategory id which uniquely identifies MeteringCategory resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example meteringCategoryClient.get(id)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringCategoryClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.meteringCategoryRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create metering action has been performed; this action creates a new metering resource.
     * @method
     * @param data An MeteringCategory object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create metering action has been performed.
     * @example meteringCategoryClient.create({
                    category : '<category-name>',
                    unitName : 'Kb',
                    unitFactor: 1,
                    defaultSamplingRate: '<value>', - Defaults: Minute = 1,Hour = 2,Day = 3,Week = 4,Month = 5,Year = 6
                    aggregateFunction: '<value>' - Defaults: None = 0,Count = 1,Avg = 2,Max = 3,Min = 4,Sum = 5
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    MeteringCategoryClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update metering action has been performed; this action updates a metering resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `meteringCategoryRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapepr.updateParams(meteringCategory);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An meteringCategory object used to update specified MeteringCategory resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // meteringCategory is a resource previously fetched using get action.
                    meteringCategory.defaultSamplingRate = 'Day';
                    meteringCategoryClient.update(meteringCategory)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MeteringCategoryClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a metering resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `meteringCategoryRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(meteringCategory);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An meteringCategory object used to update specified MeteringCategory resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // meteringCategory is a resource previously fetched using get action.
                    meteringCategoryClient.remove(meteringCategory)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MeteringCategoryClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    MeteringCategoryClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MeteringCategoryRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MeteringCategoryBatchClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MeteringCategoryRoute !== "undefined" && _1.MeteringCategoryRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof _1.MeteringCategoryBatchClient !== "undefined" && _1.MeteringCategoryBatchClient) === "function" ? _c : Object])
    ], MeteringCategoryClient);
    return MeteringCategoryClient;
}());
exports.MeteringCategoryClient = MeteringCategoryClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringBatchRoute
 * @description Baasic Metering Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Metering Route Definition Service to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var MeteringBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MeteringBatchRoute, _super);
    function MeteringBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'metering/data/batch';
        _this.updateRoute = 'metering/data/batch';
        _this.deleteRoute = 'metering/data/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example meteringBatchRoute.create();
     **/
    MeteringBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example meteringBatchRoute.update();
     **/
    MeteringBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example meteringBatchRoute.delete();
     **/
    MeteringBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    MeteringBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MeteringBatchRoute);
    return MeteringBatchRoute;
}(common_1.BaseRoute));
exports.MeteringBatchRoute = MeteringBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringBatchClient
 * @description  Metering Batch Client provides an easy way to consume  Metering REST API end-points. In order to obtain a needed routes `meteringBatchClient` uses `meteringBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(18);
var MeteringBatchClient = /** @class */ (function () {
    function MeteringBatchClient(meteringBatchRoute, apiClient) {
        this.meteringBatchRoute = meteringBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MeteringBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.meteringBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create data action has been performed; this action creates new data resources.
     * @method
     * @param data An MeteringData objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create data action has been performed.
     * @example  meteringBatchClient.create([{
                    applicationId : '<applicationId>',
                    category : '<category>',
                    name: '<name>',
                    value: '<value>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    MeteringBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update data action has been performed; this action updates specified data resources.
     * @method
     * @param data An MeteringData objects used to update specified MeteringData resources.
     * @returns A promise that is resolved once the update data action has been performed.
     * @example   meteringBatchClient.update(companies)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MeteringBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove data resources from the system if successfully completed.
     * @method
     * @param ids MeteringData ids which uniquely identify MeteringData resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example meteringClient.remove(companyIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.meteringBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    MeteringBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MeteringBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MeteringBatchRoute !== "undefined" && _1.MeteringBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MeteringBatchClient);
    return MeteringBatchClient;
}());
exports.MeteringBatchClient = MeteringBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringStatisticsRoute
 * @description Baasic Metering Statistics Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Metering Statistics Route Definition Service to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var MeteringStatisticsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MeteringStatisticsRoute, _super);
    function MeteringStatisticsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'metering/statistics/{category}/{?applicationIds,rateBy,from,to,names,moduleNames,statuses,endpoints,sources,page,rpp,sort,embed,fields}';
        return _this;
    }
    /**
     * Parses find metering route which can be expanded with additional options. Supported items are:
     * - `category` - The metering category.
     * - `applicationId` - The application identifier.
     * - `rateBy` - The sampling rate by minute,hour,day,week, month or year.
     * - `from` - The from date.
     * - `to` - The to date.
     * - `names` - The name of the resource inside the category in CSV format.
     * - `moduleNames` - The name of the resource inside the category in CSV format.
     * - `statuses` - The operation status in CSV format.
     * - `endpoints` - The back-end endpoint in CSV format.
     * - `sources` - The metering collector source in CSV format.
     * - `page` - A value used to set the page number, i.e. to retrieve certain metering subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the metering property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example meteringStatisticsRoute.find({category: '<category-name-or-id>'});
     **/
    MeteringStatisticsRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    var _a;
    MeteringStatisticsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MeteringStatisticsRoute);
    return MeteringStatisticsRoute;
}(common_1.BaseRoute));
exports.MeteringStatisticsRoute = MeteringStatisticsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringStatisticsClient
 * @description  Metering Statistics Client provides an easy way to consume  Metering REST API end-points. In order to obtain a needed routes `meteringStatisticsClient` uses `meteringStatisticsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(18);
var MeteringStatisticsClient = /** @class */ (function () {
    function MeteringStatisticsClient(meteringStatisticsRoute, apiClient) {
        this.meteringStatisticsRoute = meteringStatisticsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MeteringStatisticsClient.prototype, "routeDefinition", {
        /**
          * Provides direct access to `meteringStatisticsRoute`.
          * @method
          * @example meteringStatisticsClient.routeDefinition.get(expandObject);
          **/
        get: function () {
            return this.meteringStatisticsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of metering resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example meteringClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    category: 'Requests',
                    rateBy : '<minute,hour,day,week,month,year>',
                    from: '2 days ago',
                    to: 'now'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    MeteringStatisticsClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    var _a, _b;
    MeteringStatisticsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MeteringStatisticsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MeteringStatisticsRoute !== "undefined" && _1.MeteringStatisticsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MeteringStatisticsClient);
    return MeteringStatisticsClient;
}());
exports.MeteringStatisticsClient = MeteringStatisticsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringACLRoute
 * @description Baasic Metering ACL Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Metering ACL Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var MeteringACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MeteringACLRoute, _super);
    function MeteringACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'metering/data/{id}/acl/{?fields}';
        _this.updateRoute = 'metering/data/{id}/acl/{?fields}';
        _this.deleteByUserRoute = 'metering/data/{id}/acl/actions/{accessAction}/users/{user}/';
        _this.deleteByRoleRoute = 'metering/data/{id}/acl/actions/{accessAction}/roles/{role}/';
        return _this;
    }
    /**
     * Parses get metering acl route; this URI template should be expanded with the Id of the metering.
     * @method
     * @param options ACL options object.
     * @example meteringACLRoute.get({id: '<id>'});
     **/
    MeteringACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update metering acl route; this URI template should be expanded with the Id of the metering.
     * @method
     * @param options ACL options object.
     * @example meteringACLRoute.update({id: '<id>'});
     **/
    MeteringACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses deleteByUser metering acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the metering.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and metering resource.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param id User metering data id which uniquely identifies user metering data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user metering data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @example meteringACLRoute.deleteByUser({
                    id: '<id>',
                    accessAction: '<access-action>',
                    user: '<username>'
                });
     **/
    MeteringACLRoute.prototype.deleteByUser = function (id, action, user, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.user = user;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByUser metering acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the metering.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and metering resource.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param id User metering data id which uniquely identifies user metering data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user metering data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @example meteringACLRoute.deleteByRole({ id: '<id>', accessAction: '<access-action>', role: '<role-name>'});
     **/
    MeteringACLRoute.prototype.deleteByRole = function (id, action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    MeteringACLRoute.prototype.updateParams = function (options) {
        var params = this.utility.extend({}, options);
        return params[this.modelMapper.modelPropertyName];
    };
    var _a;
    MeteringACLRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MeteringACLRoute);
    return MeteringACLRoute;
}(common_1.BaseRoute));
exports.MeteringACLRoute = MeteringACLRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
  - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
  - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringACLClient
 * @description  Metering ACL Client provides an easy way to consume  Metering REST API end-points. In order to obtain a needed routes `meteringACLClient` uses `meteringACLRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(18);
var MeteringACLClient = /** @class */ (function () {
    function MeteringACLClient(meteringACLRoute, apiClient) {
        this.meteringACLRoute = meteringACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MeteringACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.meteringACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified metering resource.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example meteringClient.get({id: '<id>'})
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    MeteringACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed, this action creates new ACL policy for the specified metering resource.
     * @method
     * @param options ACL options object.
     * @example let options = {id : '<id>'};
                let aclObj =  {  actionId: '<action-id'>,  roleId: '<roleId>',  userId: '<userId>' };
                options[baasicConstants.modelPropertyName] = aclObj;
                meteringACLClient.update(options)
                    .then(function (data) {
                        // perform success action here
                    },
                      function (response, status, headers, config) {
                          // perform error handling here
                    });
     **/
    MeteringACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and metering resource.
     * @method
     * @param id User metering data id which uniquely identifies user metering data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user metering data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @returns A promise that is resolved once the removeByUser action has been performed.
     * @example meteringACLClient.removeByUser('<id>', '<access-action>', '<username>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringACLClient.prototype.removeByUser = function (id, action, user, data) {
        return this.apiClient.delete(this.meteringACLRoute.deleteByUser(id, action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and metering resource.
     * @method
     * @param id User metering data id which uniquely identifies user metering data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user metering data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @returns A promise that is resolved once the removeByRole action has been performed.
     * @example meteringACLClient.removeByRole('<id>', '<access-action>', '<role-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringACLClient.prototype.removeByRole = function (id, action, role, data) {
        return this.apiClient.delete(this.meteringACLRoute.deleteByRole(id, action, role, data));
    };
    var _a, _b;
    MeteringACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MeteringACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MeteringACLRoute !== "undefined" && _1.MeteringACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MeteringACLClient);
    return MeteringACLClient;
}());
exports.MeteringACLClient = MeteringACLClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* globals module */
/**
 * @module meteringRoute
 * @description Baasic Metering Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Metering Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(18);
var contracts_1 = __webpack_require__(3);
var MeteringRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MeteringRoute, _super);
    function MeteringRoute(appOptions, meteringBatchRoute, meteringStatisticsRoute, meteringACLRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.meteringBatchRoute = meteringBatchRoute;
        _this.meteringStatisticsRoute = meteringStatisticsRoute;
        _this.meteringACLRoute = meteringACLRoute;
        _this.findRoute = 'metering/data/{?applicationId,searchQuery,categories,from,to,names,moduleNames,statuses,endpoints,sources,page,rpp,sort,embed,fields}';
        _this.getRoute = 'metering/data/{id}/{?embed,fields}';
        _this.createRoute = 'metering/data';
        _this.updateRoute = 'metering/data/{id}';
        _this.deleteRoute = '/metering/data/{id}';
        _this.purgeRoute = 'metering/data/purge';
        return _this;
    }
    Object.defineProperty(MeteringRoute.prototype, "batch", {
        get: function () {
            return this.meteringBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeteringRoute.prototype, "statistics", {
        get: function () {
            return this.meteringStatisticsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeteringRoute.prototype, "acl", {
        get: function () {
            return this.meteringACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find metering route which can be expanded with additional options. Supported items are:
     * - `applicationId` - The application identifier.
     * - `categories` - The metering categories  in CSV format.
     * - `from` - The from date.
     * - `to` - The to date.
     * - `names` - The name of the resource inside the category in CSV format.
     * - `moduleNames` - The name of the resource inside the category in CSV format.
     * - `statuses` - The operation status in CSV format.
     * - `endpoints` - The back-end endpoint in CSV format.
     * - `sources` - The metering collector source in CSV format.
     * - `searchQuery` - A string value used to identify metering resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain metering subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the metering property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example meteringRoute.find({searchQuery: '<search-phrase>'});
     **/
    MeteringRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id MeteringData id which uniquely identifies MeteringData resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example meteringRoute.get();
     **/
    MeteringRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create metering route; this URI template does not expose any additional options.
     * @method
     * @example meteringRoute.create();
     **/
    MeteringRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update metering route; this URI template does not expose any additional options.
     * @method
     * @param data An metering data object used to update specified MeteringData resource.
     * @example meteringRoute.update(data);
     **/
    MeteringRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete metering route; this URI template does not expose any additional options.
     * @method
     * @param data An metering data object used to delete specified MeteringData resource.
     * @example meteringRoute.delete(data);
     **/
    MeteringRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses purge metering data route: this URI template does not expose any additional options.
     * @method
     * @example meteringRoute.purge();
     **/
    MeteringRoute.prototype.purge = function () {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, {});
    };
    var _a, _b, _c, _d;
    MeteringRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.MeteringBatchRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MeteringStatisticsRoute)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.MeteringACLRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.MeteringBatchRoute !== "undefined" && _1.MeteringBatchRoute) === "function" ? _b : Object, typeof (_c = typeof _1.MeteringStatisticsRoute !== "undefined" && _1.MeteringStatisticsRoute) === "function" ? _c : Object, typeof (_d = typeof _1.MeteringACLRoute !== "undefined" && _1.MeteringACLRoute) === "function" ? _d : Object])
    ], MeteringRoute);
    return MeteringRoute;
}(common_1.BaseRoute));
exports.MeteringRoute = MeteringRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringClient
 * @description  Metering Client provides an easy way to consume  Metering REST API end-points. In order to obtain a needed routes `meteringClient` uses `meteringRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(18);
var MeteringClient = /** @class */ (function () {
    function MeteringClient(meteringRoute, apiClient, meteringBatchClient, meteringStatisticsClient, meteringACLClient, meteringCategoryClient, meteringSettingsClient) {
        this.meteringRoute = meteringRoute;
        this.apiClient = apiClient;
        this.meteringBatchClient = meteringBatchClient;
        this.meteringStatisticsClient = meteringStatisticsClient;
        this.meteringACLClient = meteringACLClient;
        this.meteringCategoryClient = meteringCategoryClient;
        this.meteringSettingsClient = meteringSettingsClient;
    }
    Object.defineProperty(MeteringClient.prototype, "routeDefinition", {
        get: function () {
            return this.meteringRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeteringClient.prototype, "batch", {
        get: function () {
            return this.meteringBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeteringClient.prototype, "statistics", {
        get: function () {
            return this.meteringStatisticsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeteringClient.prototype, "acl", {
        get: function () {
            return this.meteringACLClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeteringClient.prototype, "settings", {
        get: function () {
            return this.meteringSettingsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeteringClient.prototype, "category", {
        get: function () {
            return this.meteringCategoryClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of metering resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example meteringClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    categories: 'Storage,Requests,Bandwidth'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    MeteringClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the metering resource.
     * @method
     * @param id MeteringData id which uniquely identifies MeteringData resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example meteringClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.meteringRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create metering action has been performed; this action creates a new metering resource.
     * @method
     * @param data An MeteringData object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create metering action has been performed
     * @example meteringClient.create({
                    category : '<category-name>',
                    name : '<sub-category-name>',
                    value: '<value>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
      **/
    MeteringClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update metering action has been performed; this action updates a metering resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `meteringRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(meteringData);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An metering data object used to update specified MeteringData resource.
     * @returns A promise that is resolved once the update metering action has been performed.
     * @example // meteringData is a resource previously fetched using get action.
                    meteringData.value = '<some-new-value>';
                    meteringClient.update(meteringData)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MeteringClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a metering resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `meteringRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(meteringData);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An metering data object used to remove specified MeteringData resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // meteringData is a resource previously fetched using get action.
                        meteringClient.remove(meteringData)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    MeteringClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all metering resources from the system if successfully completed.
     * @method
     * @returns A promise that is resolved once the purge action has been performed.
     * @example meteringClient.purge()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    MeteringClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c, _d, _e, _f, _g;
    MeteringClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MeteringRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.MeteringBatchClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.MeteringStatisticsClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.MeteringACLClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.MeteringCategoryClient)),
        tslib_1.__param(6, inversify_1.inject(_1.TYPES.MeteringSettingsClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MeteringRoute !== "undefined" && _1.MeteringRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof _1.MeteringBatchClient !== "undefined" && _1.MeteringBatchClient) === "function" ? _c : Object, typeof (_d = typeof _1.MeteringStatisticsClient !== "undefined" && _1.MeteringStatisticsClient) === "function" ? _d : Object, typeof (_e = typeof _1.MeteringACLClient !== "undefined" && _1.MeteringACLClient) === "function" ? _e : Object, typeof (_f = typeof _1.MeteringCategoryClient !== "undefined" && _1.MeteringCategoryClient) === "function" ? _f : Object, typeof (_g = typeof _1.MeteringSettingsClient !== "undefined" && _1.MeteringSettingsClient) === "function" ? _g : Object])
    ], MeteringClient);
    return MeteringClient;
}());
exports.MeteringClient = MeteringClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringSettingsRoute
 * @description Baasic Metering Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Metering Settings Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var MeteringSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MeteringSettingsRoute, _super);
    function MeteringSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'metering/settings/{id}/{?embed,fields}';
        _this.updateRoute = 'metering/settings/{id}';
        return _this;
    }
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example meteringSettingsRoute.get();
     **/
    MeteringSettingsRoute.prototype.get = function (options) {
        return _super.prototype.baseGet.call(this, this.getRoute, undefined, options);
    };
    /**
    * Parses updatea route; this route doesn't expose any properties.
    * @method
    * @param data An meteringSetting object used to update specified MeteringSetting resource.
    * @example meteringSettingsRoute.update(data);
    **/
    MeteringSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    MeteringSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MeteringSettingsRoute);
    return MeteringSettingsRoute;
}(common_1.BaseRoute));
exports.MeteringSettingsRoute = MeteringSettingsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module meteringSettingsClient
 * @description  Metering Settings Client provides an easy way to consume  Metering REST API end-points. In order to obtain a needed routes `meteringSettingsClient` uses `meteringSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(18);
var MeteringSettingsClient = /** @class */ (function () {
    function MeteringSettingsClient(meteringSettingsRoute, apiClient) {
        this.meteringSettingsRoute = meteringSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MeteringSettingsClient.prototype, "routeDefinition", {
        get: function () {
            return this.meteringSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the metering resource.
     * @method
     * @example meteringSettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                      function (response, status, headers, config) {
                          // perform error handling here
                    });
     **/
    MeteringSettingsClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update metering action has been performed; this action updates a metering resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `meteringSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(meteringSettings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An meteringSetting object used to update specified MeteringSetting resource.
     * @returns A promise that is resolved once the update metering action has been performed.
     * @example // meteringSettings is a resource previously fetched using get action.
                    meteringSettings.dataRetentionPeriod = 60;
                    meteringSettingsClient.update(meteringSettings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    MeteringSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    MeteringSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MeteringSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MeteringSettingsRoute !== "undefined" && _1.MeteringSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MeteringSettingsClient);
    return MeteringSettingsClient;
}());
exports.MeteringSettingsClient = MeteringSettingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(418), exports);
tslib_1.__exportStar(__webpack_require__(419), exports);
tslib_1.__exportStar(__webpack_require__(420), exports);


/***/ }),
/* 418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(10);
var TYPES = {
    NotificationsClient: Symbol("NotificationsClient"),
    NotificationsPublishBatchClient: Symbol("NotificationsPublishBatchClient"),
    NotificationsPublishBatchRoute: Symbol("NotificationsPublishBatchRoute"),
    NotificationsPublishRoute: Symbol("NotificationsPublishRoute"),
    NotificationsPublishClient: Symbol("NotificationsPublishClient"),
    NotificationsRegistrationsAnonymousBatchClient: Symbol("NotificationsRegistrationsAnonymousBatchClient"),
    NotificationsRegistrationsAnonymousBatchRoute: Symbol("NotificationsRegistrationsAnonymousBatchRoute"),
    NotificationsRegistrationsAnonymousClient: Symbol("BasicNotificationsRegistrationsAnonymousClient"),
    NotificationsRegistrationsAnonymousRoute: Symbol("NotificationsRegistrationsAnonymousRoute"),
    NotificationsRegistrationsRoute: Symbol("NotificationsRegistrationsRoute"),
    NotificationsRegistrationsUsersBatchRoute: Symbol("NotificationsRegistrationsUsersBatchRoute"),
    NotificationsRegistrationsUsersBatchClient: Symbol("NotificationsRegistrationsUsersBatchClient"),
    NotificationsRegistrationsUsersClient: Symbol("NotificationsRegistrationsUsersClient"),
    NotificationsRegistrationsUsersRoute: Symbol("NotificationsRegistrationsUsersRoute"),
    NotificationsRoute: Symbol("NotificationsRoute"),
    NotificationsRegistrationsClient: Symbol("NotificationsRegistrationsClient"),
    NotificationsSubscriptionsClient: Symbol("NotificationsSubscriptionsClient"),
    NotificationsSubscriptionsRoute: Symbol("NotificationsSubscriptionsRoute"),
    NotificationsSubscriptionsAnonymousBatchClient: Symbol("NotificationsSubscriptionsAnonymousBatchClient"),
    NotificationsSubscriptionsAnonymousBatchRoute: Symbol("NotificationsSubscriptionsAnonymousBatchRoute"),
    NotificationsSubscriptionsAnonymousRoute: Symbol("NotificationsSubscriptionsAnonymousRoute"),
    NotificationsSubscriptionsAnonymousClient: Symbol("NotificationsSubscriptionsAnonymousClient"),
    NotificationsSubscriptionsUsersRoute: Symbol("BasicNotificationsSubscriptionsRoute"),
    NotificationsSubscriptionsUsersBatchClient: Symbol("NotificationsSubscriptionsUsersBatchClient"),
    NotificationsSubscriptionsUsersBatchRoute: Symbol("NotificationsSubscriptionsUsersBatchRoute"),
    NotificationsSubscriptionsUsersClient: Symbol("NotificationsSubscriptionsUsersClient"),
    NotificationsSettingsRoute: Symbol("NotificationsSettingsRoute"),
    NotificationsSettingsClient: Symbol("NotificationsSettingsClient")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.NotificationsPublishBatchRoute).to(_1.NotificationsPublishBatchRoute);
    bind(TYPES.NotificationsPublishBatchClient).to(_1.NotificationsPublishBatchClient);
    bind(TYPES.NotificationsPublishRoute).to(_1.NotificationsPublishRoute);
    bind(TYPES.NotificationsPublishClient).to(_1.NotificationsPublishClient);
    bind(TYPES.NotificationsSubscriptionsUsersBatchRoute).to(_1.NotificationsSubscriptionsUsersBatchRoute);
    bind(TYPES.NotificationsSubscriptionsUsersBatchClient).to(_1.NotificationsSubscriptionsUsersBatchClient);
    bind(TYPES.NotificationsSubscriptionsUsersRoute).to(_1.NotificationsSubscriptionsUsersRoute);
    bind(TYPES.NotificationsSubscriptionsUsersClient).to(_1.NotificationsSubscriptionsUsersClient);
    bind(TYPES.NotificationsSubscriptionsAnonymousRoute).to(_1.NotificationsSubscriptionsAnonymousRoute);
    bind(TYPES.NotificationsSubscriptionsAnonymousBatchRoute).to(_1.NotificationsSubscriptionsAnonymousBatchRoute);
    bind(TYPES.NotificationsSubscriptionsAnonymousBatchClient).to(_1.NotificationsSubscriptionsAnonymousBatchClient);
    bind(TYPES.NotificationsSubscriptionsAnonymousClient).to(_1.NotificationsSubscriptionsAnonymousClient);
    bind(TYPES.NotificationsSubscriptionsRoute).to(_1.NotificationsSubscriptionsRoute);
    bind(TYPES.NotificationsSubscriptionsClient).to(_1.NotificationsSubscriptionsClient);
    bind(TYPES.NotificationsRegistrationsUsersBatchRoute).to(_1.NotificationsRegistrationsUsersBatchRoute);
    bind(TYPES.NotificationsRegistrationsUsersBatchClient).to(_1.NotificationsRegistrationsUsersBatchClient);
    bind(TYPES.NotificationsRegistrationsUsersRoute).to(_1.NotificationsRegistrationsUsersRoute);
    bind(TYPES.NotificationsRegistrationsUsersClient).to(_1.NotificationsRegistrationsUsersClient);
    bind(TYPES.NotificationsRegistrationsAnonymousBatchRoute).to(_1.NotificationsRegistrationsAnonymousBatchRoute);
    bind(TYPES.NotificationsRegistrationsAnonymousBatchClient).to(_1.NotificationsRegistrationsAnonymousBatchClient);
    bind(TYPES.NotificationsRegistrationsAnonymousRoute).to(_1.NotificationsRegistrationsAnonymousRoute);
    bind(TYPES.NotificationsRegistrationsAnonymousClient).to(_1.NotificationsRegistrationsAnonymousClient);
    bind(TYPES.NotificationsRegistrationsRoute).to(_1.NotificationsRegistrationsRoute);
    bind(TYPES.NotificationsRegistrationsClient).to(_1.NotificationsRegistrationsClient);
    bind(TYPES.NotificationsSettingsRoute).to(_1.NotificationsSettingsRoute);
    bind(TYPES.NotificationsSettingsClient).to(_1.NotificationsSettingsClient);
    bind(TYPES.NotificationsRoute).to(_1.NotificationsRoute);
    bind(TYPES.NotificationsClient).to(_1.NotificationsClient);
});
exports.diModule = diModule;


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsPublishBatchRoute
 * @description Baasic Notifications Publish Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Publish Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var NotificationsPublishBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsPublishBatchRoute, _super);
    function NotificationsPublishBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/publish/batch';
        return _this;
    }
    /**
     * Parses create publish batch route; this route does not expose any additional options.
     * @method
     * @example notificationsPublishBatchRoute.create();
     */
    NotificationsPublishBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    var _a;
    NotificationsPublishBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsPublishBatchRoute);
    return NotificationsPublishBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsPublishBatchRoute = NotificationsPublishBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsPublishBatchClient
 * @description  Notifications Publish Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsPublishBatchClient` uses `notificationsPublishBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(10);
var NotificationsPublishBatchClient = /** @class */ (function () {
    function NotificationsPublishBatchClient(notificationsPublishBatchRoute, apiClient) {
        this.notificationsPublishBatchRoute = notificationsPublishBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsPublishBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsPublishBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create notification action has been performed; this action creates new notification resources.
     * @method
     * @param data The notification collection.
     * @returns A promise that is resolved once the create notification action has been performed.
     * @example notificationsPublishBatchClient.create([{
                    channels: ['<channel-name', '<channel-name>'],
                    moduleName: '<module-name>',
                    templateName: '<template-name>',
                    templateContext: {
                        prop1: '<prop1-value>',
                        prop2: '<prop2-value>'
                    }
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsPublishBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    NotificationsPublishBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsPublishBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsPublishBatchRoute !== "undefined" && _1.NotificationsPublishBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsPublishBatchClient);
    return NotificationsPublishBatchClient;
}());
exports.NotificationsPublishBatchClient = NotificationsPublishBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsPublishRoute
 * @description Baasic Notifications Publish Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(10);
var NotificationsPublishRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsPublishRoute, _super);
    function NotificationsPublishRoute(appOptions, notificationsPublishBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsPublishBatchRoute = notificationsPublishBatchRoute;
        _this.createRoute = 'notifications/publish';
        return _this;
    }
    NotificationsPublishRoute.prototype.batch = function () {
        return this.notificationsPublishBatchRoute;
    };
    /**
     * Parses create publish route; this route does not expose any additional options.
     * @method
     * @example notificationsPublishRoute.create();
     */
    NotificationsPublishRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    var _a, _b;
    NotificationsPublishRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsPublishBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsPublishBatchRoute !== "undefined" && _1.NotificationsPublishBatchRoute) === "function" ? _b : Object])
    ], NotificationsPublishRoute);
    return NotificationsPublishRoute;
}(common_1.BaseRoute));
exports.NotificationsPublishRoute = NotificationsPublishRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsPublishClient
 * @description  Notifications Publish Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsPublishClient` uses `notificationsPublishRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(10);
var NotificationsPublishClient = /** @class */ (function () {
    function NotificationsPublishClient(notificationsPublishRoute, notificationsPublishBatchClient, apiClient) {
        this.notificationsPublishRoute = notificationsPublishRoute;
        this.notificationsPublishBatchClient = notificationsPublishBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsPublishClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsPublishRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsPublishClient.prototype, "batch", {
        get: function () {
            return this.notificationsPublishBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create notification action has been performed; this action creates a new notification resource.
     * @method
     * @param data The notification.
     * @returns A promise that is resolved once the create notification action has been performed.
     * @example notificationsPublishClient.create({
                    channels: ['<channel-name', '<channel-name>'],
                    moduleName: '<module-name>',
                    templateName: '<template-name>',
                    templateContext: {
                        prop1: '<prop1-value>',
                        prop2: '<prop2-value>'
                    }
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsPublishClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c;
    NotificationsPublishClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsPublishRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsPublishBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsPublishRoute !== "undefined" && _1.NotificationsPublishRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsPublishBatchClient !== "undefined" && _1.NotificationsPublishBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsPublishClient);
    return NotificationsPublishClient;
}());
exports.NotificationsPublishClient = NotificationsPublishClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsAnonymousBatchRoute
 * @description Baasic Notifications Registrations Anonymous Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Anonymous Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var NotificationsRegistrationsAnonymousBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsAnonymousBatchRoute, _super);
    function NotificationsRegistrationsAnonymousBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/registrations/anonymous/batch';
        _this.deleteRoute = 'notifications/registrations/anonymous/batch';
        return _this;
    }
    /**
     * Parses create anonymous registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousBatchRoute.create();
     */
    NotificationsRegistrationsAnonymousBatchRoute.prototype.create = function () {
        return this.baseCreate(this.createRoute, {});
    };
    /**
     * Parses delete anonymous registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousBatchRoute.delete();
     */
    NotificationsRegistrationsAnonymousBatchRoute.prototype.delete = function () {
        return this.baseDelete(this.deleteRoute, {});
    };
    /**
     * Parses update anonymous registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousBatchRoute.update();
     */
    NotificationsRegistrationsAnonymousBatchRoute.prototype.update = function () {
        return this.baseUpdate('notifications/registrations/anonymous/batch', {});
    };
    var _a;
    NotificationsRegistrationsAnonymousBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsRegistrationsAnonymousBatchRoute);
    return NotificationsRegistrationsAnonymousBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsAnonymousBatchRoute = NotificationsRegistrationsAnonymousBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsAnonymousBatchClient
 * @description  Notifications Registrations Anonymous Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsAnonymousBatchClient` uses `notificationsRegistrationsAnonymousBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
;
var _1 = __webpack_require__(10);
var NotificationsRegistrationsAnonymousBatchClient = /** @class */ (function () {
    function NotificationsRegistrationsAnonymousBatchClient(notificationsRegistrationsAnonymousBatchRoute, apiClient) {
        this.notificationsRegistrationsAnonymousBatchRoute = notificationsRegistrationsAnonymousBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsAnonymousBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsAnonymousBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous registration action has been performed; this action creates new anonymous registration resources.
     * @method
     * @param data AnonymousRegistration objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous registration action has been performed.
     * @example notificationsRegistrationsAnonymousBatchClient.create([{
                    provider: '<provider-name>',
                    providerData: <provider-data>,
                    expirationDate: <expiration-date>
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsAnonymousBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove anonymous registration resources from the system if successfully completed.
     * @method
     * @param ids The registration ids which uniquely identify AnonymousRegistration resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example notificationsRegistrationsAnonymousBatchClient.remove(subscriptionIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsRegistrationsAnonymousBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.notificationsRegistrationsAnonymousBatchRoute.delete(), undefined, ids);
    };
    /**
     * Returns a promise that is resolved once the update anonymous registration action has been performed; this action updates specified anonymous registration  resources.
     * @method
     * @param data AnonymousRegistration objects used to update specified AnonymousRegistration resources.
     * @returns A promise that is resolved once the update anonymous registration action has been performed.
     * @example notificationsRegistrationsAnonymousBatchClient.update(registrations)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsAnonymousBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsRegistrationsAnonymousBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsAnonymousBatchRoute !== "undefined" && _1.NotificationsRegistrationsAnonymousBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsRegistrationsAnonymousBatchClient);
    return NotificationsRegistrationsAnonymousBatchClient;
}());
exports.NotificationsRegistrationsAnonymousBatchClient = NotificationsRegistrationsAnonymousBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsAnonymousRoute
 * @description Baasic Notifications Registrations Anonymous Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Anonymous Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(10);
var NotificationsRegistrationsAnonymousRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsAnonymousRoute, _super);
    function NotificationsRegistrationsAnonymousRoute(appOptions, notificationsRegistrationsAnonymousBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsRegistrationsAnonymousBatchRoute = notificationsRegistrationsAnonymousBatchRoute;
        _this.createRoute = 'notifications/registrations/anonymous';
        _this.findRoute = 'notifications/registrations/anonymous/{?searchQuery,providers,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/registrations/anonymous/{id}/{?embed}';
        _this.updateRoute = 'notifications/registrations/anonymous/{id}';
        _this.deleteRoute = 'notifications/registrations/anonymous/{id}';
        return _this;
    }
    Object.defineProperty(NotificationsRegistrationsAnonymousRoute.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsAnonymousBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses create anonymous registrations route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousRoute.create();
     */
    NotificationsRegistrationsAnonymousRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find anonymous registrations route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `providers` - Comma separated list of notification providers.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscription subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example notificationsRegistrationsAnonymousRoute.find({
                   searchQuery: '<search-phrase>',
                   providers: '<provider-name>,<provider-name>'
               });
    */
    NotificationsRegistrationsAnonymousRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get anonymous registrations route; this route should be expanded with the Id of anonymous registrations resource.
     * @method
     * @param id The registration identifier which uniquely identifies AnonymousRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsRegistrationsAnonymousRoute.get({ id: '<registration-id>' });
     */
    NotificationsRegistrationsAnonymousRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update anonymous registrations route; this route should be expanded with the Id of anonymous registrations resource.
     * @method
     * @param data An object used to update specified AnonymousRegistration resource.
     * @example notificationsRegistrationsAnonymousRoute.update(data);
     */
    NotificationsRegistrationsAnonymousRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete anonymous registrations route; this route should be expanded with the Id of anonymous registrations resource.
     * @method
     * @param data An object used to delete specified AnonymousRegistration resource.
     * @example notificationsRegistrationsAnonymousRoute.delete(data);
     */
    NotificationsRegistrationsAnonymousRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    NotificationsRegistrationsAnonymousRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsAnonymousBatchRoute !== "undefined" && _1.NotificationsRegistrationsAnonymousBatchRoute) === "function" ? _b : Object])
    ], NotificationsRegistrationsAnonymousRoute);
    return NotificationsRegistrationsAnonymousRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsAnonymousRoute = NotificationsRegistrationsAnonymousRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsAnonymousClient
 * @description  Notifications Registrations Anonymous Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsAnonymousClient` uses `notificationsRegistrationsAnonymousRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
;
var _1 = __webpack_require__(10);
var NotificationsRegistrationsAnonymousClient = /** @class */ (function () {
    function NotificationsRegistrationsAnonymousClient(notificationsRegistrationsAnonymousRoute, notificationsRegistrationsAnonymousBatchClient, apiClient) {
        this.notificationsRegistrationsAnonymousRoute = notificationsRegistrationsAnonymousRoute;
        this.notificationsRegistrationsAnonymousBatchClient = notificationsRegistrationsAnonymousBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsAnonymousClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsAnonymousClient.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsAnonymousBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous registration action has been performed; this action creates a new anonymous registration resource.
     * @method
     * @param data An AnonymousRegistration object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous registration action has been performed.
     * @example notificationsRegistrationsAnonymousClient.create({
                    provider: '<provider-name>',
                    providerdata: <provider-data>,
                    expirationData: '<expiration-date>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsAnonymousClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of anonymous registration resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsRegistrationsAnonymousClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>',
                   providers: '<provider-name1>,<provider-name2>',
                   embed: '<embed>'
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    */
    NotificationsRegistrationsAnonymousClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified anonymous registration resource.
     * @method
     * @param id The registration identifier which uniquely identifies AnonymousRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsRegistrationsAnonymousClient.get('<registration-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsAnonymousClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsRegistrationsAnonymousRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove anonymous registration action has been performed. This action will remove a anonymous registration resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(registration);
     * var uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An object used to delete specified AnonymousRegistration resource.
     * @returns A promise that is resolved once the remove anonymous registration action has been performed.
     * @example // registration is a resource previously fetched using get action.
                    notificationsRegistrationsAnonymousClient.remove(registration)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsRegistrationsAnonymousClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update anonymous registration action has been performed; this action updates a anonymous registration resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(registration);
     * var uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified AnonymousRegistration resource.
     * @returns A promise that is resolved once the update anonymous registration action has been performed
     * @example // registration is a resource previously fetched using get action.
                        subscription.provider = '<provider-name>';
                        notificationsRegistrationsAnonymousClient.update(registration)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     */
    NotificationsRegistrationsAnonymousClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsRegistrationsAnonymousClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsAnonymousRoute !== "undefined" && _1.NotificationsRegistrationsAnonymousRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsAnonymousBatchClient !== "undefined" && _1.NotificationsRegistrationsAnonymousBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsRegistrationsAnonymousClient);
    return NotificationsRegistrationsAnonymousClient;
}());
exports.NotificationsRegistrationsAnonymousClient = NotificationsRegistrationsAnonymousClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsUsersBatchRoute
 * @description Baasic Notifications Registrations Users Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Users Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var NotificationsRegistrationsUsersBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsUsersBatchRoute, _super);
    function NotificationsRegistrationsUsersBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/registrations/user/batch';
        _this.deleteRoute = 'notifications/registrations/user/batch';
        _this.updateRoute = 'notifications/registrations/user/batch';
        return _this;
    }
    /**
     * Parses create users registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersBatchRoute.create();
     */
    NotificationsRegistrationsUsersBatchRoute.prototype.create = function () {
        return this.baseCreate(this.createRoute, {});
    };
    /**
     * Parses remove users registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersBatchRoute.delete();
     */
    NotificationsRegistrationsUsersBatchRoute.prototype.delete = function () {
        return this.baseDelete(this.deleteRoute, {});
    };
    /**
     * Parses update users registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersBatchRoute.update();
     */
    NotificationsRegistrationsUsersBatchRoute.prototype.update = function () {
        return this.baseUpdate(this.updateRoute, {});
    };
    var _a;
    NotificationsRegistrationsUsersBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsRegistrationsUsersBatchRoute);
    return NotificationsRegistrationsUsersBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsUsersBatchRoute = NotificationsRegistrationsUsersBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsUsersBatchClient
 * @description  Notifications Registrations Users Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsUsersBatchClient` uses `notificationsRegistrationsUsersBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
;
var _1 = __webpack_require__(10);
var NotificationsRegistrationsUsersBatchClient = /** @class */ (function () {
    function NotificationsRegistrationsUsersBatchClient(notificationsRegistrationsUsersBatchRoute, apiClient) {
        this.notificationsRegistrationsUsersBatchRoute = notificationsRegistrationsUsersBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsUsersBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsUsersBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user registration action has been performed; this action creates new user registration resources.
     * @method
     * @param data UserRegistration collection that need to be inserted into the system.
     * @returns A promise that is resolved once the create user registration action has been performed.
     * @example notificationsRegistrationsUsersBatchClient.create([{
                    provider: '<provider-name>',
                    providerData: <provider-data>,
                    userId: '<user-id>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsUsersBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove user registration resources from the system if successfully completed.
     * @method
     * @param ids The subscription ids which uniquely identify UserRegistration resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example notificationsRegistrationsUsersBatchClient.remove(subscriptionIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsUsersBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.notificationsRegistrationsUsersBatchRoute.delete(), undefined, ids);
    };
    /**
     * Returns a promise that is resolved once the update user registration action has been performed; this action updates specified user registration resources.
     * @method
     * @param data UserRegistration objects used to update specified UserRegistration resources.
     * @returns A promise that is resolved once the update user registration action has been performed.
     * @example notificationsRegistrationsUsersBatchClient.update(registrations)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsUsersBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsRegistrationsUsersBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsUsersBatchRoute !== "undefined" && _1.NotificationsRegistrationsUsersBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsRegistrationsUsersBatchClient);
    return NotificationsRegistrationsUsersBatchClient;
}());
exports.NotificationsRegistrationsUsersBatchClient = NotificationsRegistrationsUsersBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsUsersRoute
 * @description Baasic Notifications Registrations Users Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Users Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(10);
var NotificationsRegistrationsUsersRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsUsersRoute, _super);
    function NotificationsRegistrationsUsersRoute(appOptions, notificationsRegistrationsUsersBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsRegistrationsUsersBatchRoute = notificationsRegistrationsUsersBatchRoute;
        _this.createRoute = 'notifications/registrations/user';
        _this.findRoute = 'notifications/registrations/user/{?searchQuery,userIds,providers,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/registrations/user/{id}/{?embed}';
        _this.deleteRoute = 'notifications/registrations/user/{id}';
        _this.updateRoute = 'notifications/registrations/user/{id}';
        return _this;
    }
    Object.defineProperty(NotificationsRegistrationsUsersRoute.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsUsersBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses create users registrations route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersRoute.create();
     */
    NotificationsRegistrationsUsersRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find users registrations route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `userIds` - Comma separated list of user identifiers.
     * - `providers` - Comma separated list of notification providers.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscription subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example notificationsRegistrationsUsersRoute.find({ searchQuery: '<search-phrase>', providers: '<provider-name>,<provider-name>' });
     */
    NotificationsRegistrationsUsersRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get users registrations route; this route should be expanded with the Id of users registrations resource.
     * @method
     * @param id The registration identifier which uniquely identifies UserRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsRegistrationsUsersRoute.get({ id: '<registration-id>' });
     */
    NotificationsRegistrationsUsersRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses delete users registrations route; this route should be expanded with the Id of users registrations resource.
     * @method
     * @param data An object used to delete specified UserRegistration resource.
     * @example notificationsRegistrationsUsersRoute.delete(data);
     */
    NotificationsRegistrationsUsersRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses update users registrations route; this route should be expanded with the Id of users registrations resource.
     * @method
     * @param data An object used to update specified UserRegistration resource.
     * @example notificationsRegistrationsUsersRoute.update(data);
     */
    NotificationsRegistrationsUsersRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b;
    NotificationsRegistrationsUsersRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsUsersBatchRoute !== "undefined" && _1.NotificationsRegistrationsUsersBatchRoute) === "function" ? _b : Object])
    ], NotificationsRegistrationsUsersRoute);
    return NotificationsRegistrationsUsersRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsUsersRoute = NotificationsRegistrationsUsersRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsUsersClient
 * @description  Notifications Registrations Users Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsUsersClient` uses `notificationsRegistrationsUsersRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
;
var _1 = __webpack_require__(10);
var NotificationsRegistrationsUsersClient = /** @class */ (function () {
    function NotificationsRegistrationsUsersClient(notificationsRegistrationsUsersRoute, notificationsRegistrationsUsersBatchClient, apiClient) {
        this.notificationsRegistrationsUsersRoute = notificationsRegistrationsUsersRoute;
        this.notificationsRegistrationsUsersBatchClient = notificationsRegistrationsUsersBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsUsersClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsUsersClient.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsUsersBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user registration action has been performed; this action creates a new user registration resource.
     * @method
     * @param data An UserRegistration object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user registration action has been performed.
     * @example notificationsRegistrationsUsersClient.create({
                    provider: '<provider-name>',
                    providerData: <provider-data>,
                    userId: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsUsersClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user registrations resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsRegistrationsUsersClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>',
                   providers: '<provider-name1>,<provider-name2>',
                   userIds: '<user-id1>,<user-id2>',
                   embed: '<embed>'
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    */
    NotificationsRegistrationsUsersClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified user registrations resource.
     * @method
     * @param id The registration identifier which uniquely identifies UserRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsRegistrationsUsersClient.get('<registration-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsRegistrationsUsersClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsRegistrationsUsersRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove user registrations action has been performed. This action will remove a user registrations resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(registration);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An object used to delete specified UserRegistration resource.
     * @example // registration is a resource previously fetched using get action.
                    notificationsRegistrationsUsersClient.remove(registration)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsRegistrationsUsersClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update user registration action has been performed; this action updates a user registration resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(subsregistrationcription);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified UserRegistration resource.
     * @returns A promise that is resolved once the update user registration action has been performed.
     * @example // registration is a resource previously fetched using get action.
                    registration.provider = '<provider-name>';
                    notificationsRegistrationsUsersClient.update(registration)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsRegistrationsUsersClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsRegistrationsUsersClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsUsersRoute !== "undefined" && _1.NotificationsRegistrationsUsersRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsUsersBatchClient !== "undefined" && _1.NotificationsRegistrationsUsersBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsRegistrationsUsersClient);
    return NotificationsRegistrationsUsersClient;
}());
exports.NotificationsRegistrationsUsersClient = NotificationsRegistrationsUsersClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsRoute
 * @description Baasic Notifications Registrations Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(10);
var NotificationsRegistrationsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsRoute, _super);
    function NotificationsRegistrationsRoute(appOptions, notificationsRegistrationsUsersRoute, notificationsRegistrationsAnonymousRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsRegistrationsUsersRoute = notificationsRegistrationsUsersRoute;
        _this.notificationsRegistrationsAnonymousRoute = notificationsRegistrationsAnonymousRoute;
        return _this;
    }
    Object.defineProperty(NotificationsRegistrationsRoute.prototype, "users", {
        get: function () {
            return this.notificationsRegistrationsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsRoute.prototype, "anonymous", {
        get: function () {
            return this.notificationsRegistrationsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsRegistrationsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsUsersRoute !== "undefined" && _1.NotificationsRegistrationsUsersRoute) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsRegistrationsAnonymousRoute !== "undefined" && _1.NotificationsRegistrationsAnonymousRoute) === "function" ? _c : Object])
    ], NotificationsRegistrationsRoute);
    return NotificationsRegistrationsRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsRoute = NotificationsRegistrationsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsClient
 * @description  Notifications Registrations Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsClient` uses `notificationsRegistrationsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var _1 = __webpack_require__(10);
var NotificationsRegistrationsClient = /** @class */ (function () {
    function NotificationsRegistrationsClient(notificationsRegistrationsRoute, notificationsRegistrationsAnonymousClient, notificationsRegistrationsUsersClient) {
        this.notificationsRegistrationsRoute = notificationsRegistrationsRoute;
        this.notificationsRegistrationsAnonymousClient = notificationsRegistrationsAnonymousClient;
        this.notificationsRegistrationsUsersClient = notificationsRegistrationsUsersClient;
    }
    Object.defineProperty(NotificationsRegistrationsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsClient.prototype, "anonymous", {
        get: function () {
            return this.notificationsRegistrationsAnonymousClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsClient.prototype, "users", {
        get: function () {
            return this.notificationsRegistrationsUsersClient;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsRegistrationsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsRoute !== "undefined" && _1.NotificationsRegistrationsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsAnonymousClient !== "undefined" && _1.NotificationsRegistrationsAnonymousClient) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsRegistrationsUsersClient !== "undefined" && _1.NotificationsRegistrationsUsersClient) === "function" ? _c : Object])
    ], NotificationsRegistrationsClient);
    return NotificationsRegistrationsClient;
}());
exports.NotificationsRegistrationsClient = NotificationsRegistrationsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsUsersBatchRoute
 * @description Baasic Notifications Subscriptions Users Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Subscriptions Users Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var NotificationsSubscriptionsUsersBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsUsersBatchRoute, _super);
    function NotificationsSubscriptionsUsersBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/subscriptions/user/batch';
        _this.deleteRoute = 'notifications/subscriptions/user/batch';
        _this.updateRoute = 'notifications/subscriptions/user/batch';
        return _this;
    }
    /**
     * Parses create user subscriptions batch route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsUsersBatchRoute.create();
     */
    NotificationsSubscriptionsUsersBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove user subscriptions batch route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsUsersBatchRoute.delete(ids);
     */
    NotificationsSubscriptionsUsersBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    /**
     * Parses update user subscriptions batch route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsUsersBatchRoute.update();
     */
    NotificationsSubscriptionsUsersBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    var _a;
    NotificationsSubscriptionsUsersBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsSubscriptionsUsersBatchRoute);
    return NotificationsSubscriptionsUsersBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsUsersBatchRoute = NotificationsSubscriptionsUsersBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsUsersBatchClient
 * @description  Notifications Subscriptions Users Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsUsersBatchUsersClient` uses `notificationsSubscriptionsUsersBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(10);
var NotificationsSubscriptionsUsersBatchClient = /** @class */ (function () {
    function NotificationsSubscriptionsUsersBatchClient(notificationsSubscriptionsUsersBatchRoute, apiClient) {
        this.notificationsSubscriptionsUsersBatchRoute = notificationsSubscriptionsUsersBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsUsersBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsUsersBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user subscription action has been performed; this action creates new user subscription resources.
     * @method
     * @param data UserSubscription collection that need to be inserted into the system.
     * @returns A promise that is resolved once the create user subscription action has been performed.
     * @example notificationsSubscriptionsUsersBatchClient.create([{
                    channel: '<channel-name>',
                    userId: '<user-id>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsUsersBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove user subscription resources from the system if successfully completed.
     * @method
     * @param ids The subscription ids which uniquely identify UserSubscription resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example notificationsSubscriptionsUsersBatchClient.remove(subscriptionIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSubscriptionsUsersBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.notificationsSubscriptionsUsersBatchRoute.delete(), undefined, ids);
    };
    /**
     * Returns a promise that is resolved once the update user subscriptions action has been performed; this action updates specified user subscription resources.
     * @method
     * @param data UserSubscription objects used to update specified UserSubscription resources.
     * @returns A promise that is resolved once the update user subscriptions action has been performed.
     * @example notificationsSubscriptionsUsersBatchClient.update(subscriptions)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSubscriptionsUsersBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsSubscriptionsUsersBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsUsersBatchRoute !== "undefined" && _1.NotificationsSubscriptionsUsersBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsSubscriptionsUsersBatchClient);
    return NotificationsSubscriptionsUsersBatchClient;
}());
exports.NotificationsSubscriptionsUsersBatchClient = NotificationsSubscriptionsUsersBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousBatchRoute
 * @description Baasic Notifications Subscriptions Anonymous Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Subscriptions Anonymous Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var NotificationsSubscriptionsAnonymousBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsAnonymousBatchRoute, _super);
    function NotificationsSubscriptionsAnonymousBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/subscriptions/anonymous/batch';
        _this.deleteRoute = 'notifications/subscriptions/anonymous/batch';
        _this.updateRoute = 'notifications/subscriptions/anonymous/batch';
        return _this;
    }
    /**
     * Parses create anonymous subscription batch route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsAnonymousBatchRoute.create();
     */
    NotificationsSubscriptionsAnonymousBatchRoute.prototype.create = function () {
        return this.baseCreate(this.createRoute, {});
    };
    /**
     * Parses remove anonymous subscription batch route; this route does not expose any additional options
     * @method
     * @example baasicNotificationsSubscriptionsAnonymousBatchRouteDefinitio.delete();
     */
    NotificationsSubscriptionsAnonymousBatchRoute.prototype.delete = function () {
        return this.baseDelete(this.deleteRoute, {});
    };
    /**
     * Parses update anonymous subscription batch route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsAnonymousBatchRoute.update();
     */
    NotificationsSubscriptionsAnonymousBatchRoute.prototype.update = function () {
        return this.baseUpdate(this.updateRoute, {});
    };
    var _a;
    NotificationsSubscriptionsAnonymousBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsSubscriptionsAnonymousBatchRoute);
    return NotificationsSubscriptionsAnonymousBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsAnonymousBatchRoute = NotificationsSubscriptionsAnonymousBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousBatchClient
 * @description  Notifications Subscriptions Anonymous Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsAnonymousBatchClient` uses `notificationsSubscriptionsAnonymousBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(10);
var NotificationsSubscriptionsAnonymousBatchClient = /** @class */ (function () {
    function NotificationsSubscriptionsAnonymousBatchClient(notificationsSubscriptionsAnonymousBatchRoute, apiClient) {
        this.notificationsSubscriptionsAnonymousBatchRoute = notificationsSubscriptionsAnonymousBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsAnonymousBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous subscription action has been performed; this action creates new anonymous subscription resources.
     * @method
     * @param data AnonymousSubscription objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous subscription action has been performed.
     * @example notificationsSubscriptionsAnonymousBatchClient.create([{
                    channel: '<channel-name>',
                    registrationId: '<registration-id>' ž
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsAnonymousBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove anonymous subscription resources from the system if successfully completed.
     * @method
     * @param ids The subscription ids which uniquely identify AnonymousSubscription resources that need to be deleted.
     * @returns a promise that is resolved once the remove action has been performed.
     * @example notificationsSubscriptionsAnonymousBatchClient.remove(subscriptionIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsSubscriptionsAnonymousBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.notificationsSubscriptionsAnonymousBatchRoute.delete(), undefined, ids);
    };
    /**
     * Returns a promise that is resolved once the update anonymous subscriptions action has been performed; this action updates specified anonymous subscription resources.
     * @method
     * @param data AnonymousSubscription objects used to update specified AnonymousSubscription resources.
     * @returns A promise that is resolved once the update anonymous subscriptions action has been performed.
     * @example notificationsSubscriptionsAnonymousBatchClient.update(subscriptions)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSubscriptionsAnonymousBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsSubscriptionsAnonymousBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousBatchRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsSubscriptionsAnonymousBatchClient);
    return NotificationsSubscriptionsAnonymousBatchClient;
}());
exports.NotificationsSubscriptionsAnonymousBatchClient = NotificationsSubscriptionsAnonymousBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousRoute
 * @description Baasic Notifications Subscriptions Anonymous Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Subscriptions Anonymous Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(10);
var NotificationsSubscriptionsAnonymousRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsAnonymousRoute, _super);
    function NotificationsSubscriptionsAnonymousRoute(notificationsSubscriptionsAnonymousBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.notificationsSubscriptionsAnonymousBatchRoute = notificationsSubscriptionsAnonymousBatchRoute;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/subscriptions/anonymous';
        _this.findRoute = 'notifications/subscriptions/anonymous/{?searchQuery,registrationIds,channels,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/subscriptions/anonymous/{id}/{?embed,fields}';
        _this.deleteRoute = 'notifications/subscriptions/anonymous/{id}';
        _this.updateRoute = 'notifications/subscriptions/anonymous/{id}';
        return _this;
    }
    Object.defineProperty(NotificationsSubscriptionsAnonymousRoute.prototype, "batch", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses create anonymous subscription route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsAnonymousRoute.create();
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find anonymous subscriptions route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `registrationIds` - Comma separated list of anonymous registration identifiers.
     * - `channels` - Comma separated list of channels.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscription subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example notificationsSubscriptionsAnonymousRoute.find({
                   searchQuery: '<search-phrase>',
                   channels: '<channel-name>,<channel-name>'
               });
    */
    NotificationsSubscriptionsAnonymousRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get anonymous subscription route; this route should be expanded with the Id of anonymous subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies AnonymousSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsSubscriptionsAnonymousRoute.get({id: '<subscription-id>'});
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses delete anonymous subscription route; this route should be expanded with the Id of anonymous subscription resource.
     * @method
     * @param data The subscription identifier used to delete specific subscription resource in the system.
     * @example notificationsSubscriptionsAnonymousRoute.delete(data);
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses update anonymous subscription route; this route should be expanded with the Id of anonymous subscription resource.
     * @method
     * @param data The subscription identifier used to update specific subscription resource in the system.
     * @example notificationsSubscriptionsAnonymousRoute.update(data);
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b;
    NotificationsSubscriptionsAnonymousRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousBatchRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], NotificationsSubscriptionsAnonymousRoute);
    return NotificationsSubscriptionsAnonymousRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsAnonymousRoute = NotificationsSubscriptionsAnonymousRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousClient
 * @description  Notifications Subscriptions Anonymous Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsAnonymousClient` uses `notificationsSubscriptionsAnonymousRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(10);
var NotificationsSubscriptionsAnonymousClient = /** @class */ (function () {
    function NotificationsSubscriptionsAnonymousClient(notificationsSubscriptionsAnonymousRoute, notificationsSubscriptionsAnonymousBatchClient, apiClient) {
        this.notificationsSubscriptionsAnonymousRoute = notificationsSubscriptionsAnonymousRoute;
        this.notificationsSubscriptionsAnonymousBatchClient = notificationsSubscriptionsAnonymousBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsAnonymousClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsAnonymousClient.prototype, "batch", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous subscription action has been performed; this action creates a new anonymous subscription resource.
     * @method
     * @param data An AnonymousSubscription object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous subscription action has been performed.
     * @example notificationsSubscriptionsAnonymousClient.create({
                    channel: '<channel-name>',
                    registrationId: '<registration-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of anonymous subscription resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsSubscriptionsAnonymousClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>',
                    channels: '<channel-name1>,<channel-name2>',
                    registrationIds: '<registration-id1>,<registration-id2>',
                    embed: '<embed>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.find = function (options) {
        return this.apiClient.get(this.notificationsSubscriptionsAnonymousRoute.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified anonymous subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies AnonymousSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsSubscriptionsAnonymousClient.get('<subscription-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsSubscriptionsAnonymousRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove anonymous subscription action has been performed. This action will remove a anonymous subscription resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(subscription);
     * var uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data The subscription identifier used to delete specific subscription resource in the system.
     * @returns A promise that is resolved once the remove anonymous subscription action has been performed.
     * @example // subscription is a resource previously fetched using get action.
                        notificationsSubscriptionsAnonymousClient.remove(subscription)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update anonymous subscription action has been performed; this action updates a anonymous subscription resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(subscription);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified AnonymousSubscription resource.
     * @returns A promise that is resolved once the update anonymous subscription action has been performed.
     * @example // subscription is a resource previously fetched using get action.
                    subscription.channel = '<channel-name>';
                    notificationsSubscriptionsAnonymousClient.update(subscription)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsSubscriptionsAnonymousClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsAnonymousBatchClient !== "undefined" && _1.NotificationsSubscriptionsAnonymousBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsSubscriptionsAnonymousClient);
    return NotificationsSubscriptionsAnonymousClient;
}());
exports.NotificationsSubscriptionsAnonymousClient = NotificationsSubscriptionsAnonymousClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsUsersRoute
 * @description Baasic Notifications Subscriptions Users Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(10);
var NotificationsSubscriptionsUsersRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsUsersRoute, _super);
    function NotificationsSubscriptionsUsersRoute(appOptions, notificationsSubscriptionsUsersBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsSubscriptionsUsersBatchRoute = notificationsSubscriptionsUsersBatchRoute;
        _this.createRoute = 'notifications/subscriptions/user';
        _this.findRoute = 'notifications/subscriptions/user/{?searchQuery,userIds,channels,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/subscriptions/user/{id}/{?embed,fields}';
        _this.deleteRoute = 'notifications/subscriptions/user/{id}';
        _this.updateRoute = 'notifications/subscriptions/user/{id}';
        return _this;
    }
    NotificationsSubscriptionsUsersRoute.prototype.batch = function () {
        return this.notificationsSubscriptionsUsersBatchRoute;
    };
    /**
     * Parses create user subscription route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsUsersRoute.create();
     */
    NotificationsSubscriptionsUsersRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find user subscriptions route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `userIds` - Comma separated list of user identifiers.
     * - `channels` - Comma separated list of channels.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscriptions subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example notificationsSubscriptionsUsersRoute.find({ searchQuery: '<search-phrase>', channels: '<channel-name>,<channel-name>' });
     */
    NotificationsSubscriptionsUsersRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get user subscription route; this route should be expanded with the Id of user subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies UserSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsSubscriptionsUsersRoute.get({ id: '<subscription-id>' });
     */
    NotificationsSubscriptionsUsersRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses delete user subscription route; this route should be expanded with the Id of user subscription resource.
     * @method
     * @param data An object used to delete specified UserSubscription resource.
     * @example notificationsSubscriptionsUsersRoute.delete(data);
     */
    NotificationsSubscriptionsUsersRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses update user subscription route; this route should be expanded with the Id of user subscription resource.
     * @method
     * @param data An object used to update specified UserSubscription resource.
     * @example notificationsSubscriptionsUsersRoute.update(data);
     */
    NotificationsSubscriptionsUsersRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b;
    NotificationsSubscriptionsUsersRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsUsersBatchRoute !== "undefined" && _1.NotificationsSubscriptionsUsersBatchRoute) === "function" ? _b : Object])
    ], NotificationsSubscriptionsUsersRoute);
    return NotificationsSubscriptionsUsersRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsUsersRoute = NotificationsSubscriptionsUsersRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsUsersClient
 * @description  Notifications Subscriptions Users Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsUsersClient` uses `notificationsSubscriptionsUsersRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(10);
var NotificationsSubscriptionsUsersClient = /** @class */ (function () {
    function NotificationsSubscriptionsUsersClient(notificationsSubscriptionsUsersRoute, NotificationsSubscriptionsUsersBatchClient, apiClient) {
        this.notificationsSubscriptionsUsersRoute = notificationsSubscriptionsUsersRoute;
        this.NotificationsSubscriptionsUsersBatchClient = NotificationsSubscriptionsUsersBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsUsersClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsUsersClient.prototype, "batch", {
        get: function () {
            return this.NotificationsSubscriptionsUsersBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user subscription action has been performed; this action creates a new user subscription resource.
     * @method
     * @param data An UserSubscription object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user subscription action has been performed.
     * @example notificationsSubscriptionsUsersClient.create({
                    channel: '<channel-name>',
                    userId: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsUsersClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user subscription resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsSubscriptionsUsersClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>',
                    channels: '<channel-name1>,<channel-name2>',
                    userIds: '<user-id1>,<user-id2>',
                    embed: '<embed>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsUsersClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified user subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies UserSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsSubscriptionsUsersClient.get('<subscription-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsSubscriptionsUsersClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsSubscriptionsUsersRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove user subscription action has been performed. This action will remove a user subscription resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(subscription);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An object used to delete specified UserSubscription resource.
     * @returns A promise that is resolved once the remove user subscription action has been performed.
     * @example // subscription is a resource previously fetched using get action.
                    notificationsSubscriptionsUsersClient.remove(subscription)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsSubscriptionsUsersClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update user subscription action has been performed; this action updates a user subscription resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(subscription);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified UserSubscription resource.
     * @example // subscription is a resource previously fetched using get action.
                       subscription.channel = '<channel-name>';
                       notificationsSubscriptionsUsersClient.update(subscription)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    */
    NotificationsSubscriptionsUsersClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsSubscriptionsUsersClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsUsersRoute !== "undefined" && _1.NotificationsSubscriptionsUsersRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsUsersBatchClient !== "undefined" && _1.NotificationsSubscriptionsUsersBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsSubscriptionsUsersClient);
    return NotificationsSubscriptionsUsersClient;
}());
exports.NotificationsSubscriptionsUsersClient = NotificationsSubscriptionsUsersClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsRoute
 * @description Baasic Notifications Subscriptions Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(10);
var NotificationsSubscriptionsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsRoute, _super);
    function NotificationsSubscriptionsRoute(notificationsSubscriptionsAnonymousRoute, notificationsSubscriptionsUsersRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.notificationsSubscriptionsAnonymousRoute = notificationsSubscriptionsAnonymousRoute;
        _this.notificationsSubscriptionsUsersRoute = notificationsSubscriptionsUsersRoute;
        _this.appOptions = appOptions;
        return _this;
    }
    Object.defineProperty(NotificationsSubscriptionsRoute.prototype, "users", {
        get: function () {
            return this.notificationsSubscriptionsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsRoute.prototype, "anonymous", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsSubscriptionsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersRoute)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsUsersRoute !== "undefined" && _1.NotificationsSubscriptionsUsersRoute) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _c : Object])
    ], NotificationsSubscriptionsRoute);
    return NotificationsSubscriptionsRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsRoute = NotificationsSubscriptionsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsClient
 * @description  Notifications Subscriptions Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsClient` uses `notificationsSubscriptionsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var _1 = __webpack_require__(10);
var NotificationsSubscriptionsClient = /** @class */ (function () {
    function NotificationsSubscriptionsClient(notificationsSubscriptionsRoute, notificationsSubscriptionsAnonymousClient, notificationsSubscriptionsUsersClient) {
        this.notificationsSubscriptionsRoute = notificationsSubscriptionsRoute;
        this.notificationsSubscriptionsAnonymousClient = notificationsSubscriptionsAnonymousClient;
        this.notificationsSubscriptionsUsersClient = notificationsSubscriptionsUsersClient;
    }
    Object.defineProperty(NotificationsSubscriptionsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsClient.prototype, "anonymous", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsClient.prototype, "users", {
        get: function () {
            return this.notificationsSubscriptionsUsersClient;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsSubscriptionsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsRoute !== "undefined" && _1.NotificationsSubscriptionsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsAnonymousClient !== "undefined" && _1.NotificationsSubscriptionsAnonymousClient) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsSubscriptionsUsersClient !== "undefined" && _1.NotificationsSubscriptionsUsersClient) === "function" ? _c : Object])
    ], NotificationsSubscriptionsClient);
    return NotificationsSubscriptionsClient;
}());
exports.NotificationsSubscriptionsClient = NotificationsSubscriptionsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 446 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSettingsRoute
 * @description Baasic Notifications Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Settings Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var NotificationsSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSettingsRoute, _super);
    function NotificationsSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'notifications/settings/{id}';
        _this.updateRoute = 'notifications/settings/{id}';
        return _this;
    }
    /**
     * Parses get notification settings route; this route should be expanded with the notification provider name.
     * @method
     * @param provider The notification provider name.
     * @example notificationsSettingsRoute.get({ id: '<provider-name>' });
     */
    NotificationsSettingsRoute.prototype.get = function (provider) {
        return _super.prototype.baseGet.call(this, this.getRoute, provider);
    };
    /**
     * Parses update notification settings route; this route should be expanded with the notification provider name.
     * @method
     * @param data The notification settings.
     * @example notificationsSettingsRoute.update({ id: '<provider-name>' });
     */
    NotificationsSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    NotificationsSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsSettingsRoute);
    return NotificationsSettingsRoute;
}(common_1.BaseRoute));
exports.NotificationsSettingsRoute = NotificationsSettingsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSettingsClient
 * @description  Notifications Settings Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSettingsClient` uses `notificationsSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(10);
var NotificationsSettingsClient = /** @class */ (function () {
    function NotificationsSettingsClient(notificationsSettingsRoute, apiClient) {
        this.notificationsSettingsRoute = notificationsSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSettingsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified setting resource.
     * @method
     * @param provider The notification provider name.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsSettingsClient.get('<provider-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSettingsClient.prototype.get = function (provider) {
        return this.apiClient.get(this.routeDefinition.get(provider));
    };
    /**
     * Returns a promise that is resolved once the update settings action has been performed; this action updates a settings resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(settings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data The notification settings.
     * @returns A promise that is resolved once the update settings action has been performed.
     * @example // settings is a resource previously fetched using get action.
                    notificationsSettingsClient.update(settings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSettingsRoute !== "undefined" && _1.NotificationsSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsSettingsClient);
    return NotificationsSettingsClient;
}());
exports.NotificationsSettingsClient = NotificationsSettingsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRoute
 * @description Baasic Notifications Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(10);
var NotificationsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRoute, _super);
    function NotificationsRoute(appOptions, notificationsPublishRoute, basicNotificationsSubscriptionsRoute, notificationsRegistrationsRoute, notificationsSettingsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsPublishRoute = notificationsPublishRoute;
        _this.basicNotificationsSubscriptionsRoute = basicNotificationsSubscriptionsRoute;
        _this.notificationsRegistrationsRoute = notificationsRegistrationsRoute;
        _this.notificationsSettingsRoute = notificationsSettingsRoute;
        return _this;
    }
    Object.defineProperty(NotificationsRoute.prototype, "publish", {
        get: function () {
            return this.notificationsPublishRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRoute.prototype, "subscriptions", {
        get: function () {
            return this.basicNotificationsSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRoute.prototype, "registrations", {
        get: function () {
            return this.notificationsRegistrationsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRoute.prototype, "settings", {
        get: function () {
            return this.notificationsSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    NotificationsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsPublishRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsRoute)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.NotificationsRegistrationsRoute)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.NotificationsSettingsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsPublishRoute !== "undefined" && _1.NotificationsPublishRoute) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsSubscriptionsRoute !== "undefined" && _1.NotificationsSubscriptionsRoute) === "function" ? _c : Object, typeof (_d = typeof _1.NotificationsRegistrationsRoute !== "undefined" && _1.NotificationsRegistrationsRoute) === "function" ? _d : Object, typeof (_e = typeof _1.NotificationsSettingsRoute !== "undefined" && _1.NotificationsSettingsRoute) === "function" ? _e : Object])
    ], NotificationsRoute);
    return NotificationsRoute;
}(common_1.BaseRoute));
exports.NotificationsRoute = NotificationsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsClient
 * @description  Notifications Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsClient` uses `notificationsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var _1 = __webpack_require__(10);
var NotificationsClient = /** @class */ (function () {
    function NotificationsClient(notificationsPublishClient, basicNotificationsSubscriptionsClient, notificationsRegistrationsClient, notificationsSettingsClient, notificationsRoute) {
        this.notificationsPublishClient = notificationsPublishClient;
        this.basicNotificationsSubscriptionsClient = basicNotificationsSubscriptionsClient;
        this.notificationsRegistrationsClient = notificationsRegistrationsClient;
        this.notificationsSettingsClient = notificationsSettingsClient;
        this.notificationsRoute = notificationsRoute;
    }
    Object.defineProperty(NotificationsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "publish", {
        get: function () {
            return this.notificationsPublishClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "subscriptions", {
        get: function () {
            return this.basicNotificationsSubscriptionsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "registrations", {
        get: function () {
            return this.notificationsRegistrationsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "settings", {
        get: function () {
            return this.notificationsSettingsClient;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    NotificationsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsPublishClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsRegistrationsClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.NotificationsSettingsClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.NotificationsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsPublishClient !== "undefined" && _1.NotificationsPublishClient) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsClient !== "undefined" && _1.NotificationsSubscriptionsClient) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsRegistrationsClient !== "undefined" && _1.NotificationsRegistrationsClient) === "function" ? _c : Object, typeof (_d = typeof _1.NotificationsSettingsClient !== "undefined" && _1.NotificationsSettingsClient) === "function" ? _d : Object, typeof (_e = typeof _1.NotificationsRoute !== "undefined" && _1.NotificationsRoute) === "function" ? _e : Object])
    ], NotificationsClient);
    return NotificationsClient;
}());
exports.NotificationsClient = NotificationsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 450 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(451), exports);
tslib_1.__exportStar(__webpack_require__(452), exports);
tslib_1.__exportStar(__webpack_require__(453), exports);
tslib_1.__exportStar(__webpack_require__(454), exports);
tslib_1.__exportStar(__webpack_require__(455), exports);
tslib_1.__exportStar(__webpack_require__(456), exports);


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 455 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(5);
var TYPES = {
    CommerceCustomerPaymentMethodClient: Symbol("CommerceCustomerPaymentMethodClient"),
    CommerceCustomerPaymentMethodRoute: Symbol("CommerceCustomerPaymentMethodRoute"),
    CommerceCustomerClient: Symbol("CommerceCustomerClient"),
    CommerceCustomerRoute: Symbol("CommerceCustomerRoute"),
    CommerceInvoiceClient: Symbol("CommerceInvoiceClient"),
    CommerceInvoiceRoute: Symbol("CommerceInvoiceRoute"),
    CommerceInvoiceStreamsClient: Symbol("CommerceInvoiceStreamsClient"),
    CommerceInvoiceStreamsRoute: Symbol("CommerceInvoiceStreamsRoute"),
    CommercePaymentTransactionClient: Symbol("CommercePaymentTransactionClient"),
    CommercePaymentTransactionRoute: Symbol("CommercePaymentTransactionRoute"),
    CommerceAddOnClient: Symbol("CommerceAddOnClient"),
    CommerceAddOnRoute: Symbol("CommerceAddOnRoute"),
    CommerceProductClient: Symbol("CommerceProductClient"),
    CommerceProductRoute: Symbol("CommerceProductRoute"),
    CommerceProductFilesStreamsClient: Symbol("CommerceProductFilesStreamsClient"),
    CommerceProductFilesStreamsRoute: Symbol("CommerceProductFilesStreamsRoute"),
    CommerceProductFilesBatchClient: Symbol("CommerceProductFilesBatchClient"),
    CommerceProductFilesBatchRoute: Symbol("CommerceProductFilesBatchRoute"),
    CommerceProductFilesClient: Symbol("CommerceProductFilesClient"),
    CommerceProductFilesRoute: Symbol("CommerceProductFilesRoute"),
    CommerceProductSettingsClient: Symbol("CommerceProductSettingsClient"),
    CommerceProductSettingsRoute: Symbol("CommerceProductSettingsRoute"),
    CommerceProductInstanceFilesClient: Symbol("CommerceProductInstanceFilesClient"),
    CommerceProductInstanceFilesRoute: Symbol("CommerceProductInstanceFilesRoute"),
    CommerceProductInstanceFilesBatchClient: Symbol("CommerceProductInstanceFilesBatchClient"),
    CommerceProductInstanceFilesBatchRoute: Symbol("CommerceProductInstanceFilesBatchRoute"),
    CommerceCouponClient: Symbol("CommerceCouponClient"),
    CommerceCouponRoute: Symbol("CommerceCouponRoute"),
    CommerceCouponUseClient: Symbol("CommerceCouponUseClient"),
    CommerceCouponUseRoute: Symbol("CommerceCouponUseRoute"),
    CommerceClient: Symbol("CommerceClient"),
    CommerceRoute: Symbol("CommerceRoute"),
    CommerceLookupsAddressTypesBatchClient: Symbol("CommerceLookupsAddressTypesBatchClient"),
    CommerceLookupsAddressTypeBatchRoute: Symbol("CommerceLookupsAddressTypeBatchRoute"),
    CommerceLookupsAddressTypesClient: Symbol("CommerceLookupsAddressTypesClient"),
    CommerceLookupsAddressTypeRoute: Symbol("CommerceLookupsAddressTypeRoute"),
    CommerceLookupsCountryBatchClient: Symbol("CommerceLookupsCountryBatchClient"),
    CommerceLookupsCountryBatchRoute: Symbol("CommerceLookupsCountryBatchRoute"),
    CommerceLookupsCountryClient: Symbol("CommerceLookupsCountryClient"),
    CommerceLookupsCountryRoute: Symbol("CommerceLookupsCountryRoute"),
    CommerceLookupsCountryStateBatchClient: Symbol("CommerceLookupsCountryStateBatchClient"),
    CommerceLookupsCountryStateBatchRoute: Symbol("CommerceLookupsCountryStateBatchRoute"),
    CommerceLookupsCountryStateClient: Symbol("CommerceLookupsCountryStateClient"),
    CommerceLookupsCountryStateRoute: Symbol("CommerceLookupsCountryStateRoute"),
    CommerceLookupsPaymentMethodBatchClient: Symbol("CommerceLookupsPaymentMethodBatchClient"),
    CommerceLookupsPaymentMethodBatchRoute: Symbol("CommerceLookupsPaymentMethodBatchRoute"),
    CommerceLookupsPaymentMethodClient: Symbol("CommerceLookupsPaymentMethodClient"),
    CommerceLookupsPaymentMethodRoute: Symbol("CommerceLookupsPaymentMethodRoute"),
    CommerceLookupsPaymentTransactionStatusBatchClient: Symbol("CommerceLookupsPaymentTransactionStatusBatchClient"),
    CommerceLookupsPaymentTransactionStatusBatchRoute: Symbol("CommerceLookupsPaymentTransactionStatusBatchRoute"),
    CommerceLookupsPaymentTransactionStatusClient: Symbol("CommerceLookupsPaymentTransactionStatusClient"),
    CommerceLookupsPaymentTransactionStatusRoute: Symbol("CommerceLookupsPaymentTransactionStatusRoute"),
    CommerceLookupsRecurringCyclePeriodTypeBatchClient: Symbol("CommerceLookupsRecurringCyclePeriodTypeBatchClient"),
    CommerceLookupsRecurringCyclePeriodTypeBatchRoute: Symbol("CommerceLookupsRecurringCyclePeriodTypeBatchRoute"),
    CommerceLookupsRecurringCyclePeriodTypeClient: Symbol("CommerceLookupsRecurringCyclePeriodTypeClient"),
    CommerceLookupsRecurringCyclePeriodTypeRoute: Symbol("CommerceLookupsRecurringCyclePeriodTypeRoute"),
    CommerceLookupsSubscriptionStatusBatchClient: Symbol("CommerceLookupsSubscriptionStatusBatchClient"),
    CommerceLookupsSubscriptionStatusBatchRoute: Symbol("CommerceLookupsSubscriptionStatusBatchRoute"),
    CommerceLookupsSubscriptionStatusClient: Symbol("CommerceLookupsSubscriptionStatusClient"),
    CommerceLookupsSubscriptionStatusRoute: Symbol("CommerceLookupsSubscriptionStatusRoute"),
    CommerceLookupsInvoiceStatusBatchRoute: Symbol("CommerceLookupsInvoiceStatusBatchRoute"),
    CommerceLookupsInvoiceStatusRoute: Symbol("CommerceLookupsInvoiceStatusRoute"),
    CommerceLookupsInvoiceStatusBatchClient: Symbol("CommerceLookupsInvoiceStatusBatchClient"),
    CommerceLookupsInvoiceStatusClient: Symbol("CommerceLookupsInvoiceStatusClient"),
    CommerceLookupsCouponTypeBatchRoute: Symbol("CommerceLookupsCouponTypeBatchRoute"),
    CommerceLookupsCouponTypeRoute: Symbol("CommerceLookupsCouponTypeRoute"),
    CommerceLookupsCouponTypesBatchClient: Symbol("CommerceLookupsCouponTypesBatchClient"),
    CommerceLookupsCouponTypesClient: Symbol("CommerceLookupsCouponTypesClient"),
    Lookups: Symbol("Lookups")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.CommerceCustomerPaymentMethodRoute).to(_1.CommerceCustomerPaymentMethodRoute);
    bind(TYPES.CommerceCustomerPaymentMethodClient).to(_1.CommerceCustomerPaymentMethodClient);
    bind(TYPES.CommerceCustomerRoute).to(_1.CommerceCustomerRoute);
    bind(TYPES.CommerceCustomerClient).to(_1.CommerceCustomerClient);
    bind(TYPES.CommerceInvoiceStreamsRoute).to(_1.CommerceInvoiceStreamsRoute);
    bind(TYPES.CommerceInvoiceStreamsClient).to(_1.CommerceInvoiceStreamsClient);
    bind(TYPES.CommerceInvoiceClient).to(_1.CommerceInvoiceClient);
    bind(TYPES.CommerceInvoiceRoute).to(_1.CommerceInvoiceRoute);
    bind(TYPES.CommercePaymentTransactionRoute).to(_1.CommercePaymentTransactionRoute);
    bind(TYPES.CommercePaymentTransactionClient).to(_1.CommercePaymentTransactionClient);
    bind(TYPES.CommerceAddOnRoute).to(_1.CommerceAddOnRoute);
    bind(TYPES.CommerceAddOnClient).to(_1.CommerceAddOnClient);
    bind(TYPES.CommerceProductRoute).to(_1.CommerceProductRoute);
    bind(TYPES.CommerceProductClient).to(_1.CommerceProductClient);
    bind(TYPES.CommerceProductFilesStreamsRoute).to(_1.CommerceProductFilesStreamsRoute);
    bind(TYPES.CommerceProductFilesStreamsClient).to(_1.CommerceProductFilesStreamsClient);
    bind(TYPES.CommerceProductFilesBatchRoute).to(_1.CommerceProductFilesBatchRoute);
    bind(TYPES.CommerceProductFilesBatchClient).to(_1.CommerceProductFilesBatchClient);
    bind(TYPES.CommerceProductFilesClient).to(_1.CommerceProductFilesClient);
    bind(TYPES.CommerceProductFilesRoute).to(_1.CommerceProductFilesRoute);
    bind(TYPES.CommerceProductSettingsClient).to(_1.CommerceProductSettingsClient);
    bind(TYPES.CommerceProductSettingsRoute).to(_1.CommerceProductSettingsRoute);
    bind(TYPES.CommerceCouponClient).to(_1.CommerceCouponClient);
    bind(TYPES.CommerceCouponRoute).to(_1.CommerceCouponRoute);
    bind(TYPES.CommerceCouponUseClient).to(_1.CommerceCouponUseClient);
    bind(TYPES.CommerceCouponUseRoute).to(_1.CommerceCouponUseRoute);
    bind(TYPES.CommerceRoute).to(_1.CommerceRoute);
    bind(TYPES.CommerceClient).to(_1.CommerceClient);
    bind(TYPES.CommerceLookupsAddressTypeBatchRoute).to(_1.CommerceLookupsAddressTypeBatchRoute);
    bind(TYPES.CommerceLookupsAddressTypesBatchClient).to(_1.CommerceLookupsAddressTypesBatchClient);
    bind(TYPES.CommerceLookupsAddressTypeRoute).to(_1.CommerceLookupsAddressTypeRoute);
    bind(TYPES.CommerceLookupsAddressTypesClient).to(_1.CommerceLookupsAddressTypesClient);
    bind(TYPES.CommerceLookupsCountryBatchRoute).to(_1.CommerceLookupsCountryBatchRoute);
    bind(TYPES.CommerceLookupsCountryBatchClient).to(_1.CommerceLookupsCountryBatchClient);
    bind(TYPES.CommerceLookupsCountryRoute).to(_1.CommerceLookupsCountryRoute);
    bind(TYPES.CommerceLookupsCountryClient).to(_1.CommerceLookupsCountryClient);
    bind(TYPES.CommerceLookupsCountryStateBatchRoute).to(_1.CommerceLookupsCountryStateBatchRoute);
    bind(TYPES.CommerceLookupsCountryStateBatchClient).to(_1.CommerceLookupsCountryStateBatchClient);
    bind(TYPES.CommerceLookupsCountryStateRoute).to(_1.CommerceLookupsCountryStateRoute);
    bind(TYPES.CommerceLookupsCountryStateClient).to(_1.CommerceLookupsCountryStateClient);
    bind(TYPES.CommerceLookupsPaymentMethodBatchRoute).to(_1.CommerceLookupsPaymentMethodBatchRoute);
    bind(TYPES.CommerceLookupsPaymentMethodBatchClient).to(_1.CommerceLookupsPaymentMethodBatchClient);
    bind(TYPES.CommerceLookupsPaymentMethodRoute).to(_1.CommerceLookupsPaymentMethodRoute);
    bind(TYPES.CommerceLookupsPaymentMethodClient).to(_1.CommerceLookupsPaymentMethodClient);
    bind(TYPES.CommerceLookupsPaymentTransactionStatusBatchRoute).to(_1.CommerceLookupsPaymentTransactionStatusBatchRoute);
    bind(TYPES.CommerceLookupsPaymentTransactionStatusBatchClient).to(_1.CommerceLookupsPaymentTransactionStatusBatchClient);
    bind(TYPES.CommerceLookupsPaymentTransactionStatusRoute).to(_1.CommerceLookupsPaymentTransactionStatusRoute);
    bind(TYPES.CommerceLookupsPaymentTransactionStatusClient).to(_1.CommerceLookupsPaymentTransactionStatusClient);
    bind(TYPES.CommerceLookupsRecurringCyclePeriodTypeBatchRoute).to(_1.CommerceLookupsRecurringCyclePeriodTypeBatchRoute);
    bind(TYPES.CommerceLookupsRecurringCyclePeriodTypeBatchClient).to(_1.CommerceLookupsRecurringCyclePeriodTypeBatchClient);
    bind(TYPES.CommerceLookupsRecurringCyclePeriodTypeRoute).to(_1.CommerceLookupsRecurringCyclePeriodTypeRoute);
    bind(TYPES.CommerceLookupsRecurringCyclePeriodTypeClient).to(_1.CommerceLookupsRecurringCyclePeriodTypeClient);
    bind(TYPES.CommerceLookupsSubscriptionStatusBatchRoute).to(_1.CommerceLookupsSubscriptionStatusBatchRoute);
    bind(TYPES.CommerceLookupsSubscriptionStatusBatchClient).to(_1.CommerceLookupsSubscriptionStatusBatchClient);
    bind(TYPES.CommerceLookupsSubscriptionStatusRoute).to(_1.CommerceLookupsSubscriptionStatusRoute);
    bind(TYPES.CommerceLookupsSubscriptionStatusClient).to(_1.CommerceLookupsSubscriptionStatusClient);
    bind(TYPES.CommerceLookupsInvoiceStatusBatchRoute).to(_1.CommerceLookupsInvoiceStatusBatchRoute);
    bind(TYPES.CommerceLookupsInvoiceStatusRoute).to(_1.CommerceLookupsInvoiceStatusRoute);
    bind(TYPES.CommerceLookupsInvoiceStatusBatchClient).to(_1.CommerceLookupsInvoiceStatusBatchClient);
    bind(TYPES.CommerceLookupsInvoiceStatusClient).to(_1.CommerceLookupsInvoiceStatusClient);
    bind(TYPES.CommerceLookupsCouponTypeBatchRoute).to(_1.CommerceLookupsCouponTypeBatchRoute);
    bind(TYPES.CommerceLookupsCouponTypeRoute).to(_1.CommerceLookupsCouponTypeRoute);
    bind(TYPES.CommerceLookupsCouponTypesBatchClient).to(_1.CommerceLookupsCouponTypesBatchClient);
    bind(TYPES.CommerceLookupsCouponTypesClient).to(_1.CommerceLookupsCouponTypesClient);
    bind(TYPES.Lookups).to(_1.Lookups);
});
exports.diModule = diModule;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceRoute
 * @description Baasic Commerce Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Product Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceRoute, _super);
    function CommerceRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/subscriptions/{?customerId,systemName,searchQuery,plan,statuses,productId,firstName,lastName,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/subscriptions/{id}/{?embed,fields}';
        _this.validateVATRoute = 'commerce/vat-validations/{?countryCode,vatId}';
        _this.preprocessRoute = 'commerce/subscriptions/preprocess';
        _this.subscribeRoute = 'commerce/subscriptions';
        _this.cancelRoute = 'commerce/subscriptions/{systemName}/{id}/{?requestRefund,refundAmount}';
        return _this;
    }
    /**
     * Parses find commerce route which can be expanded with additional options. Supported items are:
     * - `customerId` - The customer identifier.
     * - `systemName` - The commerce payment gateway system name.
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `plan` - Product name.
     * - `statuses` - Subscription status unique identifier or abbreviation in CSV format.
     * - `productId` - Product unique identifier.
     * - `firstName` - Customer first name.
     * - `lastName` - Customer last name.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceRoute.get(id, options);
     **/
    CommerceRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses validate VAT route; this route doesn't expose any properties.
     * @method
     * @example commerceRoute.validateVAT({ countryCode: 'DE', vatId: 'DE999999999' });
     **/
    CommerceRoute.prototype.validateVAT = function (countryCode, vatId) {
        return _super.prototype.baseCreate.call(this, this.validateVATRoute, { countryCode: countryCode, vatId: vatId });
    };
    /**
     * Parses subscription pre-process commerce route; this URI template does not expose any additional options.
     * @method
     * @example commerceRoute.preprocess();
     **/
    CommerceRoute.prototype.preprocess = function () {
        return _super.prototype.baseCreate.call(this, this.preprocessRoute, {});
    };
    /**
     * Parses subscription commerce route; this URI template does not expose any additional options.
     * @method
     * @example commerceRoute.subscribe();
     **/
    CommerceRoute.prototype.subscribe = function () {
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, {});
    };
    /**
     * Parses cancel subscription commerce route; this URI template does not expose any additional options.
     * @method
     * @example commerceRoute.cancel({ systemName: '<system-name>' });
     **/
    CommerceRoute.prototype.cancel = function (data) {
        return _super.prototype.baseCreate.call(this, this.cancelRoute, data);
    };
    var _a;
    CommerceRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceRoute);
    return CommerceRoute;
}(common_1.BaseRoute));
exports.CommerceRoute = CommerceRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceClient
 * @description  Commerce Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceClient` uses `commerceRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(5);
var CommerceClient = /** @class */ (function () {
    function CommerceClient(commerceCustomerClient, commerceInvoiceClient, commerceProductClient, commerceProductFilesClient, commerceProductSettingsClient, commercePaymentTransactionClient, commerceCouponClient, commerceCouponUseClient, lookup, commerceRoute, apiClient) {
        this.commerceCustomerClient = commerceCustomerClient;
        this.commerceInvoiceClient = commerceInvoiceClient;
        this.commerceProductClient = commerceProductClient;
        this.commerceProductFilesClient = commerceProductFilesClient;
        this.commerceProductSettingsClient = commerceProductSettingsClient;
        this.commercePaymentTransactionClient = commercePaymentTransactionClient;
        this.commerceCouponClient = commerceCouponClient;
        this.commerceCouponUseClient = commerceCouponUseClient;
        this.lookup = lookup;
        this.commerceRoute = commerceRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceClient.prototype, "customers", {
        get: function () {
            return this.commerceCustomerClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceClient.prototype, "invoices", {
        get: function () {
            return this.commerceInvoiceClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceClient.prototype, "products", {
        get: function () {
            return this.commerceProductClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceClient.prototype, "files", {
        get: function () {
            return this.commerceProductFilesClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceClient.prototype, "settings", {
        get: function () {
            return this.commerceProductSettingsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceClient.prototype, "paymentTransactions", {
        get: function () {
            return this.commercePaymentTransactionClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceClient.prototype, "coupons", {
        get: function () {
            return this.commerceCouponClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceClient.prototype, "couponUses", {
        get: function () {
            return this.commerceCouponUseClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceClient.prototype, "lookups", {
        get: function () {
            return this.lookup;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    customerId: '<customer-id>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceClient.get('<id>', {})
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceClient.validateVAT({ countryCode: 'DE', vatId: 'DE999999999' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceClient.prototype.validateVAT = function (countryCode, vatId) {
        return this.apiClient.get(this.commerceRoute.validateVAT(countryCode, vatId));
    };
    /**
     * Returns a promise that is resolved once the subscribe pre-process commerce action has been performed; this action performes pre-subscribe operations such as getting client tokens etc.
     * @method
     * @example commerceClient.preprocess({
                    systemName : '<system-name>',
                    productId : '<product-id>',
                    customerId: '<id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceClient.prototype.preprocess = function (data) {
        return this.apiClient.post(this.routeDefinition.preprocess(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the subscribe commerce action has been performed; this action creates a new commerce subscription resource.
     * @method
     * @example commerceClient.subscribe({
                    systemName : '<system-name>',
                    productId : '<product-id>',
                    customer: {
                        id: '<id>',
                        firstName: '<first-name>',
                        lastName: '<last-name>'
                    }
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceClient.prototype.subscribe = function (data) {
        return this.apiClient.post(this.routeDefinition.subscribe(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the cancel subscription action has been performed. This action will remove a commerce subscription resource from the system if successfully completed. This route obtain routes from `commerceRoute` route template. Here is an example of how execute this action:
     * @method
     * @example	commerceClient.cancel({
                    systemName: '<system-name>',
                    id: '<subscription-id>',
                    requestRefund: <true/false>,
                    refundAmount: <refund-amount>
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceClient.prototype.cancel = function (data) {
        return this.apiClient.delete(this.routeDefinition.cancel(data));
    };
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    CommerceClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceCustomerClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CommerceInvoiceClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.CommerceProductClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.CommerceProductFilesClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.CommerceProductSettingsClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.CommercePaymentTransactionClient)),
        tslib_1.__param(6, inversify_1.inject(_1.TYPES.CommerceCouponClient)),
        tslib_1.__param(7, inversify_1.inject(_1.TYPES.CommerceCouponUseClient)),
        tslib_1.__param(8, inversify_1.inject(_1.TYPES.Lookups)),
        tslib_1.__param(9, inversify_1.inject(_1.TYPES.CommerceRoute)),
        tslib_1.__param(10, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceCustomerClient !== "undefined" && _1.CommerceCustomerClient) === "function" ? _a : Object, typeof (_b = typeof _1.CommerceInvoiceClient !== "undefined" && _1.CommerceInvoiceClient) === "function" ? _b : Object, typeof (_c = typeof _1.CommerceProductClient !== "undefined" && _1.CommerceProductClient) === "function" ? _c : Object, typeof (_d = typeof _1.CommerceProductFilesClient !== "undefined" && _1.CommerceProductFilesClient) === "function" ? _d : Object, typeof (_e = typeof _1.CommerceProductSettingsClient !== "undefined" && _1.CommerceProductSettingsClient) === "function" ? _e : Object, typeof (_f = typeof _1.CommercePaymentTransactionClient !== "undefined" && _1.CommercePaymentTransactionClient) === "function" ? _f : Object, typeof (_g = typeof _1.CommerceCouponClient !== "undefined" && _1.CommerceCouponClient) === "function" ? _g : Object, typeof (_h = typeof _1.CommerceCouponUseClient !== "undefined" && _1.CommerceCouponUseClient) === "function" ? _h : Object, typeof (_j = typeof _1.Lookups !== "undefined" && _1.Lookups) === "function" ? _j : Object, typeof (_k = typeof _1.CommerceRoute !== "undefined" && _1.CommerceRoute) === "function" ? _k : Object, typeof (_l = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _l : Object])
    ], CommerceClient);
    return CommerceClient;
}());
exports.CommerceClient = CommerceClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(461), exports);
tslib_1.__exportStar(__webpack_require__(462), exports);
tslib_1.__exportStar(__webpack_require__(463), exports);
tslib_1.__exportStar(__webpack_require__(464), exports);


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsAddressTypeBatchRoute
 * @description Baasic Commerce Lookups AddressType Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups AddressType Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceLookupsAddressTypeBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsAddressTypeBatchRoute, _super);
    function CommerceLookupsAddressTypeBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/address-types/batch';
        _this.updateRoute = 'commerce/lookups/address-types/batch';
        _this.deleteRoute = 'commerce/lookups/address-types/batch';
        return _this;
    }
    /**
     * Parses create commerce address type batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsAddressTypeRoute.create();
     */
    CommerceLookupsAddressTypeBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce address type batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsAddressTypeRoute.update();
     */
    CommerceLookupsAddressTypeBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce address type batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsAddressTypeRoute.remove();
     */
    CommerceLookupsAddressTypeBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsAddressTypeBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsAddressTypeBatchRoute);
    return CommerceLookupsAddressTypeBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsAddressTypeBatchRoute = CommerceLookupsAddressTypeBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsAddressTypeBatchClient
 * @description  Commerce Lookups Address Type Batch Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsAddressTypesBatchClient` uses `commerceLookupsAddressTypeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsAddressTypesBatchClient = /** @class */ (function () {
    function CommerceLookupsAddressTypesBatchClient(commerceLookupsAddressTypeBatchRoute, apiClient) {
        this.commerceLookupsAddressTypeBatchRoute = commerceLookupsAddressTypeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsAddressTypesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsAddressTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resources.
     * @method
     * @example commerceLookupsAddressTypeBatchClient.create([{
                     name : '<name>',
                     abrv: '<abbreviation>',
                     description: '<description>'
                    }])
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsAddressTypesBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates specified commerce resources.
     * @method
     * @example   commerceLookupsAddressTypeBatchClient.update(commerceAddressTypes)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
    **/
    CommerceLookupsAddressTypesBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove commerce action has been performed. This action will remove commerce resources from the system if successfully completed.
     * @method
     * @example commerceLookupsAddressTypeClient.remove(commerceAddressTypeIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsAddressTypesBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.commerceLookupsAddressTypeBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CommerceLookupsAddressTypesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsAddressTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsAddressTypeBatchRoute !== "undefined" && __1.CommerceLookupsAddressTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceLookupsAddressTypesBatchClient);
    return CommerceLookupsAddressTypesBatchClient;
}());
exports.CommerceLookupsAddressTypesBatchClient = CommerceLookupsAddressTypesBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsAddressTypeRoute
 * @description Baasic Commerce Lookups AddressType Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups AddressType Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceLookupsAddressTypeRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsAddressTypeRoute, _super);
    function CommerceLookupsAddressTypeRoute(commerceLookupsAddressTypeBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.commerceLookupsAddressTypeBatchRoute = commerceLookupsAddressTypeBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/address-types/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/lookups/address-types/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/lookups/address-types';
        _this.updateRoute = 'commerce/lookups/address-types/{id}';
        _this.deleteRoute = 'commerce/lookups/address-types/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsAddressTypeRoute.prototype, "batch", {
        get: function () {
            return this.commerceLookupsAddressTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce address type route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceLookupsAddressTypeRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsAddressTypeRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceLookupsAddressTypeRoute.get(id, options);
     **/
    CommerceLookupsAddressTypeRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce address type route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsAddressTypeRoute.create();
     **/
    CommerceLookupsAddressTypeRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce address type route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsAddressTypeRoute.update(data);
     **/
    CommerceLookupsAddressTypeRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete commerce address type route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsAddressTypeRoute.delete(data);
     **/
    CommerceLookupsAddressTypeRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsAddressTypeRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsAddressTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsAddressTypeBatchRoute !== "undefined" && __1.CommerceLookupsAddressTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsAddressTypeRoute);
    return CommerceLookupsAddressTypeRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsAddressTypeRoute = CommerceLookupsAddressTypeRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsAddressTypeClient
 * @description  Commerce Lookups Address Type Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsAddressTypesClient` uses `commerceLookupsAddressTypeRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsAddressTypesClient = /** @class */ (function () {
    function CommerceLookupsAddressTypesClient(commerceLookupsAddressTypeRoute, commerceLookupsAddressTypesBatchClient, apiClient) {
        this.commerceLookupsAddressTypeRoute = commerceLookupsAddressTypeRoute;
        this.commerceLookupsAddressTypesBatchClient = commerceLookupsAddressTypesBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsAddressTypesClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsAddressTypeRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsAddressTypesClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsAddressTypesBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsAddressTypeClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsAddressTypesClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsAddressTypeClient.get()
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CommerceLookupsAddressTypesClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsAddressTypeRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsAddressTypeClient.create({
                       name : '<name>',
                       abrv: '<abbreviation>',
                       description: '<description>'
                   })
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CommerceLookupsAddressTypesClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsAddressTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceAddressType);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceAddressType is a resource previously fetched using get action.
                    commerceAddressType.description = '<description>';
                    commerceLookupsAddressTypeClient.update(commerceAddressType)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsAddressTypesClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsAddressTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceAddressType);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceAddressType is a resource previously fetched using get action.
                    commerceLookupsAddressTypeClient.remove(commerceAddressType)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsAddressTypesClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsAddressTypesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsAddressTypeRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsAddressTypesBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsAddressTypeRoute !== "undefined" && __1.CommerceLookupsAddressTypeRoute) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsAddressTypesBatchClient !== "undefined" && __1.CommerceLookupsAddressTypesBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsAddressTypesClient);
    return CommerceLookupsAddressTypesClient;
}());
exports.CommerceLookupsAddressTypesClient = CommerceLookupsAddressTypesClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(466), exports);
tslib_1.__exportStar(__webpack_require__(467), exports);
tslib_1.__exportStar(__webpack_require__(468), exports);
tslib_1.__exportStar(__webpack_require__(469), exports);


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsCouponTypeBatchRoute
 * @description Baasic Commerce Lookups CouponType Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups CouponType Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceLookupsCouponTypeBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsCouponTypeBatchRoute, _super);
    function CommerceLookupsCouponTypeBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/address-types/batch';
        _this.updateRoute = 'commerce/lookups/address-types/batch';
        _this.deleteRoute = 'commerce/lookups/address-types/batch';
        return _this;
    }
    /**
     * Parses create commerce address type batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCouponTypeRoute.create();
     */
    CommerceLookupsCouponTypeBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce address type batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCouponTypeRoute.update();
     */
    CommerceLookupsCouponTypeBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce address type batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCouponTypeRoute.remove();
     */
    CommerceLookupsCouponTypeBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsCouponTypeBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsCouponTypeBatchRoute);
    return CommerceLookupsCouponTypeBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsCouponTypeBatchRoute = CommerceLookupsCouponTypeBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsCouponTypeBatchClient
 * @description  Commerce Lookups Address Type Batch Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsCouponTypesBatchClient` uses `commerceLookupsCouponTypeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsCouponTypesBatchClient = /** @class */ (function () {
    function CommerceLookupsCouponTypesBatchClient(commerceLookupsCouponTypeBatchRoute, apiClient) {
        this.commerceLookupsCouponTypeBatchRoute = commerceLookupsCouponTypeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsCouponTypesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsCouponTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resources.
     * @method
     * @example commerceLookupsCouponTypeBatchClient.create([{
                     name : '<name>',
                     abrv: '<abbreviation>',
                     description: '<description>'
                    }])
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsCouponTypesBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates specified commerce resources.
     * @method
     * @example   commerceLookupsCouponTypeBatchClient.update(commerceCouponTypes)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
    **/
    CommerceLookupsCouponTypesBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove commerce action has been performed. This action will remove commerce resources from the system if successfully completed.
     * @method
     * @example commerceLookupsCouponTypeClient.remove(commerceCouponTypeIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsCouponTypesBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.commerceLookupsCouponTypeBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CommerceLookupsCouponTypesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCouponTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCouponTypeBatchRoute !== "undefined" && __1.CommerceLookupsCouponTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceLookupsCouponTypesBatchClient);
    return CommerceLookupsCouponTypesBatchClient;
}());
exports.CommerceLookupsCouponTypesBatchClient = CommerceLookupsCouponTypesBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsCouponTypeRoute
 * @description Baasic Commerce Lookups CouponType Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups CouponType Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceLookupsCouponTypeRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsCouponTypeRoute, _super);
    function CommerceLookupsCouponTypeRoute(commerceLookupsCouponTypeBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.commerceLookupsCouponTypeBatchRoute = commerceLookupsCouponTypeBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/coupon-types/{?searchQuery,page,rpp,sort,embed}';
        _this.getRoute = 'commerce/lookups/coupon-types/{id}/{?embed}';
        _this.createRoute = 'commerce/lookups/coupon-types';
        _this.updateRoute = 'commerce/lookups/coupon-types/{id}';
        _this.deleteRoute = 'commerce/lookups/coupon-types/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsCouponTypeRoute.prototype, "batch", {
        get: function () {
            return this.commerceLookupsCouponTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce coupon type route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceLookupsCouponTypeRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsCouponTypeRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceLookupsCouponTypeRoute.get(id, options);
     **/
    CommerceLookupsCouponTypeRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce coupon type route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsCouponTypeRoute.create();
     **/
    CommerceLookupsCouponTypeRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce coupon type route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsCouponTypeRoute.update(data);
     **/
    CommerceLookupsCouponTypeRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete commerce coupon type route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsCouponTypeRoute.delete(data);
     **/
    CommerceLookupsCouponTypeRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsCouponTypeRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCouponTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCouponTypeBatchRoute !== "undefined" && __1.CommerceLookupsCouponTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsCouponTypeRoute);
    return CommerceLookupsCouponTypeRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsCouponTypeRoute = CommerceLookupsCouponTypeRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsCouponTypeClient
 * @description  Commerce Lookups Coupon Type Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsCouponTypesClient` uses `commerceLookupsCouponTypeRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsCouponTypesClient = /** @class */ (function () {
    function CommerceLookupsCouponTypesClient(commerceLookupsCouponTypeRoute, commerceLookupsCouponTypesBatchClient, apiClient) {
        this.commerceLookupsCouponTypeRoute = commerceLookupsCouponTypeRoute;
        this.commerceLookupsCouponTypesBatchClient = commerceLookupsCouponTypesBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsCouponTypesClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsCouponTypeRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsCouponTypesClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsCouponTypesBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsCouponTypeClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsCouponTypesClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsCouponTypeClient.get()
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CommerceLookupsCouponTypesClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsCouponTypeRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsCouponTypeClient.create({
                       name : '<name>',
                       abrv: '<abbreviation>',
                       description: '<description>'
                   })
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CommerceLookupsCouponTypesClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsCouponTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCouponType);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceCouponType is a resource previously fetched using get action.
                    commerceCouponType.description = '<description>';
                    commerceLookupsCouponTypeClient.update(commerceCouponType)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsCouponTypesClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsCouponTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCouponType);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceCouponType is a resource previously fetched using get action.
                    commerceLookupsCouponTypeClient.remove(commerceCouponType)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsCouponTypesClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsCouponTypesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCouponTypeRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsCouponTypesBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCouponTypeRoute !== "undefined" && __1.CommerceLookupsCouponTypeRoute) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsCouponTypesBatchClient !== "undefined" && __1.CommerceLookupsCouponTypesBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsCouponTypesClient);
    return CommerceLookupsCouponTypesClient;
}());
exports.CommerceLookupsCouponTypesClient = CommerceLookupsCouponTypesClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(471), exports);
tslib_1.__exportStar(__webpack_require__(472), exports);
tslib_1.__exportStar(__webpack_require__(473), exports);
tslib_1.__exportStar(__webpack_require__(474), exports);


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsCountryBatchRoute
 * @description Baasic Commerce Lookups Country Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceLookupsCountryBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsCountryBatchRoute, _super);
    function CommerceLookupsCountryBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/countries/batch';
        _this.updateRoute = 'commerce/lookups/countries/batch';
        _this.deleteRoute = 'commerce/lookups/countries/batch';
        return _this;
    }
    /**
     * Parses create commerce country batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCountryRoute.create();
     */
    CommerceLookupsCountryBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce country batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCountryRoute.update();
     */
    CommerceLookupsCountryBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce country batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCountryRoute.remove();
     */
    CommerceLookupsCountryBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsCountryBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsCountryBatchRoute);
    return CommerceLookupsCountryBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsCountryBatchRoute = CommerceLookupsCountryBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCountryBatchClient
 * @description  Commerce Country Batch Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCountryBatchClient` uses `commerceCountryBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsCountryBatchClient = /** @class */ (function () {
    function CommerceLookupsCountryBatchClient(commerceLookupsCountryBatchRoute, apiClient) {
        this.commerceLookupsCountryBatchRoute = commerceLookupsCountryBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsCountryBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsCountryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resources.
     * @method
     * @example commerceLookupsCountryClient.create([{
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsCountryBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates specified commerce resources.
     * @method
     * @example   commerceLookupsCountryClient.update(commerceCountries)
                      .then(function (data) {
                          // perform success action here
                      },
                       function (response, status, headers, config) {
                           // perform error handling here
                      });
   **/
    CommerceLookupsCountryBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove commerce action has been performed. This action will remove commerce resources from the system if successfully completed.
     * @method
     * @example commerceLookupsCountryClient.remove(commerceCountryIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CommerceLookupsCountryBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.commerceLookupsCountryBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CommerceLookupsCountryBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCountryBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCountryBatchRoute !== "undefined" && __1.CommerceLookupsCountryBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceLookupsCountryBatchClient);
    return CommerceLookupsCountryBatchClient;
}());
exports.CommerceLookupsCountryBatchClient = CommerceLookupsCountryBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsCountryRoute
 * @description Baasic Commerce Lookups Country Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceLookupsCountryRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsCountryRoute, _super);
    function CommerceLookupsCountryRoute(commerceCountryBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.commerceCountryBatchRoute = commerceCountryBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/countries/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/lookups/countries/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/lookups/countries';
        _this.updateRoute = 'commerce/lookups/countries/{id}';
        _this.deleteRoute = 'commerce/lookups/countries/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsCountryRoute.prototype, "batch", {
        get: function () {
            return this.commerceCountryBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce country route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceLookupsCountryRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsCountryRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceLookupsCountryRoute.get();
     **/
    CommerceLookupsCountryRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce country route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsCountryRoute.create();
     **/
    CommerceLookupsCountryRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
    * Parses update commerce country route; this URI template does not expose any additional options.
    * @method
    * @example commerceLookupsCountryRoute.update(data);
    **/
    CommerceLookupsCountryRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete commerce country route; this URI template does not expose any additional options.
    * @method
    * @example commerceLookupsCountryRoute.delete(data);
    **/
    CommerceLookupsCountryRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsCountryRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCountryBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCountryBatchRoute !== "undefined" && __1.CommerceLookupsCountryBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsCountryRoute);
    return CommerceLookupsCountryRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsCountryRoute = CommerceLookupsCountryRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCountryClient
 * @description  Commerce Country Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCountryClient` uses `commerceCountryRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsCountryClient = /** @class */ (function () {
    function CommerceLookupsCountryClient(commerceLookupsCountryRoute, commerceLookupsCountryBatchClient, apiClient) {
        this.commerceLookupsCountryRoute = commerceLookupsCountryRoute;
        this.commerceLookupsCountryBatchClient = commerceLookupsCountryBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsCountryClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsCountryRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsCountryClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsCountryBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsCountryClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>'
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    **/
    CommerceLookupsCountryClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsCountryClient.get('<country-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CommerceLookupsCountryClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsCountryRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsCountryClient.create({
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsCountryClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicCommerceCountryRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCountry);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceCountry is a resource previously fetched using get action.
                        commerceCountry.phoneCode = '<phone-code>';
                        commerceLookupsCountryClient.update(commerceCountry)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceLookupsCountryClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsCountryRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCountry);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceCountry is a resource previously fetched using get action.
                    commerceLookupsCountryClient.remove(commerceCountry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsCountryClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsCountryClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCountryRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsCountryBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCountryRoute !== "undefined" && __1.CommerceLookupsCountryRoute) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsCountryBatchClient !== "undefined" && __1.CommerceLookupsCountryBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsCountryClient);
    return CommerceLookupsCountryClient;
}());
exports.CommerceLookupsCountryClient = CommerceLookupsCountryClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(476), exports);
tslib_1.__exportStar(__webpack_require__(477), exports);
tslib_1.__exportStar(__webpack_require__(478), exports);
tslib_1.__exportStar(__webpack_require__(479), exports);


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsCountryStateBatchRoute
 * @description Baasic Commerce Lookups Country State Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country State Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceLookupsCountryStateBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsCountryStateBatchRoute, _super);
    function CommerceLookupsCountryStateBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/states/batch';
        _this.updateRoute = 'commerce/lookups/states/batch';
        _this.deleteRoute = 'commerce/lookups/states/batch';
        return _this;
    }
    /**
     * Parses create commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCountryStateBatchRoute.create();
     */
    CommerceLookupsCountryStateBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCountryStateBatchRoute.update();
     */
    CommerceLookupsCountryStateBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsCountryStateBatchRoute.remove();
     */
    CommerceLookupsCountryStateBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsCountryStateBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsCountryStateBatchRoute);
    return CommerceLookupsCountryStateBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsCountryStateBatchRoute = CommerceLookupsCountryStateBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCountryStateBatchClient
 * @description  Commerce Country State Batch Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCountryStateBatchClient` uses `commerceCountryStateBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsCountryStateBatchClient = /** @class */ (function () {
    function CommerceLookupsCountryStateBatchClient(commerceLookupsCountryStateBatchRoute, apiClient) {
        this.commerceLookupsCountryStateBatchRoute = commerceLookupsCountryStateBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsCountryStateBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsCountryStateBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resources.
     * @method
     * @example commerceLookupsCountryStateBatchClient.create([{
                    countryId: '<country-id>',
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsCountryStateBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates specified commerce resources.
     * @method
     * @example commerceLookupsCountryStateBatchClient.update(commerceCountryStates)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsCountryStateBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove commerce action has been performed. This action will remove commerce resources from the system if successfully completed.
     * @method
     * @example commerceLookupsCountryStateBatchClient.remove(commerceCountryStateIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CommerceLookupsCountryStateBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.commerceLookupsCountryStateBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CommerceLookupsCountryStateBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCountryStateBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCountryStateBatchRoute !== "undefined" && __1.CommerceLookupsCountryStateBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceLookupsCountryStateBatchClient);
    return CommerceLookupsCountryStateBatchClient;
}());
exports.CommerceLookupsCountryStateBatchClient = CommerceLookupsCountryStateBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsCountryRoute
 * @description Baasic Commerce Lookups Country Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceLookupsCountryStateRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsCountryStateRoute, _super);
    function CommerceLookupsCountryStateRoute(commerceCountryStateBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.commerceCountryStateBatchRoute = commerceCountryStateBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/states/{?countryId,searchQuery,page,rpp,sort,embed}';
        _this.getRoute = 'commerce/lookups/states/{id}/{?embed}';
        _this.createRoute = 'commerce/lookups/states';
        _this.updateRoute = 'commerce/lookups/states/{id}';
        _this.deleteRoute = 'commerce/lookups/states/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsCountryStateRoute.prototype, "batch", {
        get: function () {
            return this.commerceCountryStateBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce country state route which can be expanded with additional options. Supported items are:
     * - `countryId` - An identifier used to identify commerce country resource.
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceLookupsCountryStateRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsCountryStateRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get commerce country state route which can be expanded with additional options. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceLookupsCountryStateRoute.get(id, options);
     **/
    CommerceLookupsCountryStateRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce country state route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsCountryStateRoute.create();
     **/
    CommerceLookupsCountryStateRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce country state route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsCountryStateRoute.update(data);
     **/
    CommerceLookupsCountryStateRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete commerce country state route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsCountryStateRoute.delete(data);
     **/
    CommerceLookupsCountryStateRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsCountryStateRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCountryStateBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCountryStateBatchRoute !== "undefined" && __1.CommerceLookupsCountryStateBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsCountryStateRoute);
    return CommerceLookupsCountryStateRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsCountryStateRoute = CommerceLookupsCountryStateRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCountryStateClient
 * @description  Commerce Country State Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCountryStateClient` uses `commerceCountryStateRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsCountryStateClient = /** @class */ (function () {
    function CommerceLookupsCountryStateClient(commerceLookupsCountryStateRoute, commerceLookupsCountryStateBatchClient, apiClient) {
        this.commerceLookupsCountryStateRoute = commerceLookupsCountryStateRoute;
        this.commerceLookupsCountryStateBatchClient = commerceLookupsCountryStateBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsCountryStateClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsCountryStateRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsCountryStateClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsCountryStateBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsCountryStateClient.find({
                    countryId: '<country-id>'
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsCountryStateClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsCountryStateClient.get('<state-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsCountryStateClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsCountryStateRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsCountryStateClient.create({
                      countryId : '<country-id>',
                      name: '<name>',
                      abrv: '<abrv>',
                      description: '<description>'
                  })
                  .then(function (data) {
                      // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                  });
   **/
    CommerceLookupsCountryStateClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsCountryStateRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCountryState);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceCountryState is a resource previously fetched using get action.
                    commerceCountryState.description = '<description>';
                    commerceLookupsCountryStateClient.update(commerceCountryState)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsCountryStateClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsCountryStateRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCountryState);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceCountryState is a resource previously fetched using get action.
                   commerceLookupsCountryStateClient.remove(commerceCountryState)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
    **/
    CommerceLookupsCountryStateClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsCountryStateClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsCountryStateRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsCountryStateBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsCountryStateRoute !== "undefined" && __1.CommerceLookupsCountryStateRoute) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsCountryStateBatchClient !== "undefined" && __1.CommerceLookupsCountryStateBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsCountryStateClient);
    return CommerceLookupsCountryStateClient;
}());
exports.CommerceLookupsCountryStateClient = CommerceLookupsCountryStateClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(481), exports);
tslib_1.__exportStar(__webpack_require__(482), exports);
tslib_1.__exportStar(__webpack_require__(483), exports);
tslib_1.__exportStar(__webpack_require__(484), exports);


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsPaymentMethodBatchRoute
 * @description Baasic Commerce Lookups Payment Method Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country State Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceLookupsPaymentMethodBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsPaymentMethodBatchRoute, _super);
    function CommerceLookupsPaymentMethodBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/payment-methods/batch';
        _this.updateRoute = 'commerce/lookups/payment-methods/batch';
        _this.deleteRoute = 'commerce/lookups/payment-methods/batch';
        return _this;
    }
    /**
     * Parses create commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsPaymentMethodBatchRoute.create();
     */
    CommerceLookupsPaymentMethodBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsPaymentMethodBatchRoute.update();
     */
    CommerceLookupsPaymentMethodBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsPaymentMethodBatchRoute.remove();
     */
    CommerceLookupsPaymentMethodBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsPaymentMethodBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsPaymentMethodBatchRoute);
    return CommerceLookupsPaymentMethodBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsPaymentMethodBatchRoute = CommerceLookupsPaymentMethodBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commercePaymentMethodBatchClient
 * @description  Commerce Payment Method Batch Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commercePaymentMethodBatchClient` uses `commercePaymentMethodBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsPaymentMethodBatchClient = /** @class */ (function () {
    function CommerceLookupsPaymentMethodBatchClient(commerceLookupsPaymentMethodBatchRoute, apiClient) {
        this.commerceLookupsPaymentMethodBatchRoute = commerceLookupsPaymentMethodBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsPaymentMethodBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsPaymentMethodBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resources.
     * @method
     * @example commerceLookupsPaymentMethodBatchClient.create([{
                        name : '<name>',
                        abrv: '<abbreviation>',
                        description: '<description>',
                        published: '<published>'
                    }])
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsPaymentMethodBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates specified commerce resources.
     * @method
     * @example   commerceLookupsPaymentMethodBatchClient.update(commercePaymentMethods)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsPaymentMethodBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove commerce action has been performed. This action will remove commerce resources from the system if successfully completed.
     * @method
     * @example commerceLookupsPaymentMethodBatchClient.remove(commercePaymentMethodIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsPaymentMethodBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.commerceLookupsPaymentMethodBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CommerceLookupsPaymentMethodBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsPaymentMethodBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsPaymentMethodBatchRoute !== "undefined" && __1.CommerceLookupsPaymentMethodBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceLookupsPaymentMethodBatchClient);
    return CommerceLookupsPaymentMethodBatchClient;
}());
exports.CommerceLookupsPaymentMethodBatchClient = CommerceLookupsPaymentMethodBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsPaymentMethodRoute
 * @description Baasic Commerce Lookups PaymentMethod Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups PaymentMethod Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceLookupsPaymentMethodRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsPaymentMethodRoute, _super);
    function CommerceLookupsPaymentMethodRoute(basicCommerceLookupsPaymentMethodBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.basicCommerceLookupsPaymentMethodBatchRoute = basicCommerceLookupsPaymentMethodBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/payment-methods/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/lookups/payment-methods/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/lookups/payment-methods';
        _this.updateRoute = 'commerce/lookups/payment-methods/{id}';
        _this.deleteRoute = 'commerce/lookups/payment-methods/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsPaymentMethodRoute.prototype, "batch", {
        get: function () {
            return this.basicCommerceLookupsPaymentMethodBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce customer-payment-methods route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options.
     * @example commerceLookupsPaymentMethodRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsPaymentMethodRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceLookupsPaymentMethodRoute.get();
     **/
    CommerceLookupsPaymentMethodRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsPaymentMethodRoute.create();
     **/
    CommerceLookupsPaymentMethodRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsPaymentMethodRoute.update(data);
     **/
    CommerceLookupsPaymentMethodRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsPaymentMethodRoute.delete(data);
     **/
    CommerceLookupsPaymentMethodRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsPaymentMethodRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsPaymentMethodBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsPaymentMethodBatchRoute !== "undefined" && __1.CommerceLookupsPaymentMethodBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsPaymentMethodRoute);
    return CommerceLookupsPaymentMethodRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsPaymentMethodRoute = CommerceLookupsPaymentMethodRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsPaymentMethodClient
 * @description  Commerce Lookups PaymentMethod Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsPaymentMethodClient` uses `commerceLookupsPaymentMethodRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsPaymentMethodClient = /** @class */ (function () {
    function CommerceLookupsPaymentMethodClient(commerceLookupsPaymentMethodBatchClient, commerceLookupsPaymentMethodRoute, apiClient) {
        this.commerceLookupsPaymentMethodBatchClient = commerceLookupsPaymentMethodBatchClient;
        this.commerceLookupsPaymentMethodRoute = commerceLookupsPaymentMethodRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsPaymentMethodClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsPaymentMethodRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsPaymentMethodClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsPaymentMethodBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsPaymentTransactionStatusClient.find({
                        pageNumber : 1,
                        pageSize : 10,
                        orderBy : '<field>',
                        orderDirection : '<asc|desc>',
                        search : '<search-phrase>'
                    })
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsPaymentMethodClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsPaymentTransactionStatusClient.get()
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CommerceLookupsPaymentMethodClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsPaymentMethodRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsPaymentTransactionStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commercePaymentTransactionStatus);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commercePaymentTransactionStatus is a resource previously fetched using get action.
                        commercePaymentTransactionStatus.description = '<description>';
                        commerceLookupsPaymentTransactionStatusClient.update(commercePaymentTransactionStatus)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceLookupsPaymentMethodClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsPaymentTransactionStatusClient.create({
                        name : '<name>',
                        abrv: '<abbreviation>',
                        description: '<description>'
                    })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsPaymentMethodClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsPaymentTransactionStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commercePaymentTransactionStatus);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commercePaymentTransactionStatus is a resource previously fetched using get action.
                        commerceLookupsPaymentTransactionStatusClient.remove(commercePaymentTransactionStatus)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceLookupsPaymentMethodClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsPaymentMethodClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsPaymentMethodBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsPaymentMethodRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsPaymentMethodBatchClient !== "undefined" && __1.CommerceLookupsPaymentMethodBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsPaymentMethodRoute !== "undefined" && __1.CommerceLookupsPaymentMethodRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsPaymentMethodClient);
    return CommerceLookupsPaymentMethodClient;
}());
exports.CommerceLookupsPaymentMethodClient = CommerceLookupsPaymentMethodClient;
/**
 * @copyright(c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(486), exports);
tslib_1.__exportStar(__webpack_require__(487), exports);
tslib_1.__exportStar(__webpack_require__(488), exports);
tslib_1.__exportStar(__webpack_require__(489), exports);


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsPaymentTransactionStatusBatchRoute
 * @description Baasic Commerce Lookups Payment Method Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country State Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceLookupsPaymentTransactionStatusBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsPaymentTransactionStatusBatchRoute, _super);
    function CommerceLookupsPaymentTransactionStatusBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/payment-transaction-statuses/batch';
        _this.updateRoute = 'commerce/lookups/payment-transaction-statuses/batch';
        _this.deleteRoute = 'commerce/lookups/payment-transaction-statuses/batch';
        return _this;
    }
    /**
     * Parses create commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsPaymentTransactionStatusBatchRoute.create();
     */
    CommerceLookupsPaymentTransactionStatusBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsPaymentTransactionStatusBatchRoute.update();
     */
    CommerceLookupsPaymentTransactionStatusBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsPaymentTransactionStatusBatchRoute.remove();
     */
    CommerceLookupsPaymentTransactionStatusBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsPaymentTransactionStatusBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsPaymentTransactionStatusBatchRoute);
    return CommerceLookupsPaymentTransactionStatusBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsPaymentTransactionStatusBatchRoute = CommerceLookupsPaymentTransactionStatusBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commercePaymentTransactionStatusBatchClient
 * @description  Commerce Payment Method Batch Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commercePaymentTransactionStatusBatchClient` uses `commercePaymentTransactionStatusBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsPaymentTransactionStatusBatchClient = /** @class */ (function () {
    function CommerceLookupsPaymentTransactionStatusBatchClient(commerceLookupsPaymentTransactionStatusBatchRoute, apiClient) {
        this.commerceLookupsPaymentTransactionStatusBatchRoute = commerceLookupsPaymentTransactionStatusBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsPaymentTransactionStatusBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsPaymentTransactionStatusBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resources.
     * @method
     * @example commerceLookupsPaymentTransactionStatusBatchClient.create([{
                   name : '<name>',
                   abrv: '<abbreviation>',
                   description: '<description>'
               }])
               .then(function (data) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    **/
    CommerceLookupsPaymentTransactionStatusBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates specified commerce resources.
     * @method
     * @example commerceLookupsPaymentTransactionStatusBatchClient.update(commercePaymentTransactionStatuses)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsPaymentTransactionStatusBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove commerce action has been performed. This action will remove commerce resources from the system if successfully completed.
     * @method
     * @example commerceLookupsPaymentTransactionStatusBatchClient.remove(commercePaymentTransactionStatusIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsPaymentTransactionStatusBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.commerceLookupsPaymentTransactionStatusBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CommerceLookupsPaymentTransactionStatusBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsPaymentTransactionStatusBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsPaymentTransactionStatusBatchRoute !== "undefined" && __1.CommerceLookupsPaymentTransactionStatusBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceLookupsPaymentTransactionStatusBatchClient);
    return CommerceLookupsPaymentTransactionStatusBatchClient;
}());
exports.CommerceLookupsPaymentTransactionStatusBatchClient = CommerceLookupsPaymentTransactionStatusBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsPaymentTransactionStatusRoute
 * @description Baasic Commerce Lookups PaymentTransactionStatus Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups PaymentTransactionStatus Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceLookupsPaymentTransactionStatusRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsPaymentTransactionStatusRoute, _super);
    function CommerceLookupsPaymentTransactionStatusRoute(basicCommerceLookupsPaymentTransactionStatusBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.basicCommerceLookupsPaymentTransactionStatusBatchRoute = basicCommerceLookupsPaymentTransactionStatusBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/payment-transaction-statuses/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/lookups/payment-transaction-statuses/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/lookups/payment-transaction-statuses';
        _this.updateRoute = 'commerce/lookups/payment-transaction-statuses/{id}';
        _this.deleteRoute = 'commerce/lookups/payment-transaction-statuses/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsPaymentTransactionStatusRoute.prototype, "batch", {
        get: function () {
            return this.basicCommerceLookupsPaymentTransactionStatusBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce customer-payment-methods route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options.
     * @example commerceLookupsPaymentTransactionStatusRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsPaymentTransactionStatusRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceLookupsPaymentTransactionStatusRoute.get();
     **/
    CommerceLookupsPaymentTransactionStatusRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsPaymentTransactionStatusRoute.create();
     **/
    CommerceLookupsPaymentTransactionStatusRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsPaymentTransactionStatusRoute.update(data);
     **/
    CommerceLookupsPaymentTransactionStatusRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsPaymentTransactionStatusRoute.delete(data);
     **/
    CommerceLookupsPaymentTransactionStatusRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsPaymentTransactionStatusRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsPaymentTransactionStatusBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsPaymentTransactionStatusBatchRoute !== "undefined" && __1.CommerceLookupsPaymentTransactionStatusBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsPaymentTransactionStatusRoute);
    return CommerceLookupsPaymentTransactionStatusRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsPaymentTransactionStatusRoute = CommerceLookupsPaymentTransactionStatusRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsPaymentTransactionStatusClient
 * @description  Commerce Lookups PaymentTransactionStatus Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsPaymentTransactionStatusClient` uses `commerceLookupsPaymentTransactionStatusRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsPaymentTransactionStatusClient = /** @class */ (function () {
    function CommerceLookupsPaymentTransactionStatusClient(commerceLookupsPaymentTransactionStatusBatchClient, commerceLookupsPaymentTransactionStatusRoute, apiClient) {
        this.commerceLookupsPaymentTransactionStatusBatchClient = commerceLookupsPaymentTransactionStatusBatchClient;
        this.commerceLookupsPaymentTransactionStatusRoute = commerceLookupsPaymentTransactionStatusRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsPaymentTransactionStatusClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsPaymentTransactionStatusRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsPaymentTransactionStatusClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsPaymentTransactionStatusBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsPaymentTransactionStatusClient.find({
                        pageNumber : 1,
                        pageSize : 10,
                        orderBy : '<field>',
                        orderDirection : '<asc|desc>',
                        search : '<search-phrase>'
                    })
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsPaymentTransactionStatusClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsPaymentTransactionStatusClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsPaymentTransactionStatusClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsPaymentTransactionStatusRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsPaymentTransactionStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commercePaymentTransactionStatus);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commercePaymentTransactionStatus is a resource previously fetched using get action.
                    commercePaymentTransactionStatus.description = '<description>';
                    commerceLookupsPaymentTransactionStatusClient.update(commercePaymentTransactionStatus)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsPaymentTransactionStatusClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsPaymentTransactionStatusClient.create({
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsPaymentTransactionStatusClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsPaymentTransactionStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commercePaymentTransactionStatus);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commercePaymentTransactionStatus is a resource previously fetched using get action.
                        commerceLookupsPaymentTransactionStatusClient.remove(commercePaymentTransactionStatus)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceLookupsPaymentTransactionStatusClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsPaymentTransactionStatusClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsPaymentTransactionStatusBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsPaymentTransactionStatusRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsPaymentTransactionStatusBatchClient !== "undefined" && __1.CommerceLookupsPaymentTransactionStatusBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsPaymentTransactionStatusRoute !== "undefined" && __1.CommerceLookupsPaymentTransactionStatusRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsPaymentTransactionStatusClient);
    return CommerceLookupsPaymentTransactionStatusClient;
}());
exports.CommerceLookupsPaymentTransactionStatusClient = CommerceLookupsPaymentTransactionStatusClient;
/**
 * @copyright(c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(491), exports);
tslib_1.__exportStar(__webpack_require__(492), exports);
tslib_1.__exportStar(__webpack_require__(493), exports);
tslib_1.__exportStar(__webpack_require__(494), exports);


/***/ }),
/* 491 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsRecurringCyclePeriodTypeBatchRoute
 * @description Baasic Commerce Lookups Recurring Cycle Period Type Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country State Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceLookupsRecurringCyclePeriodTypeBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsRecurringCyclePeriodTypeBatchRoute, _super);
    function CommerceLookupsRecurringCyclePeriodTypeBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/recurring-cycle-period-types/batch';
        _this.updateRoute = 'commerce/lookups/recurring-cycle-period-types/batch';
        _this.deleteRoute = 'commerce/lookups/recurring-cycle-period-types/batch';
        return _this;
    }
    /**
     * Parses create commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeBatchRoute.create();
     */
    CommerceLookupsRecurringCyclePeriodTypeBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeBatchRoute.update();
     */
    CommerceLookupsRecurringCyclePeriodTypeBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeBatchRoute.remove();
     */
    CommerceLookupsRecurringCyclePeriodTypeBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsRecurringCyclePeriodTypeBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsRecurringCyclePeriodTypeBatchRoute);
    return CommerceLookupsRecurringCyclePeriodTypeBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsRecurringCyclePeriodTypeBatchRoute = CommerceLookupsRecurringCyclePeriodTypeBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 492 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceRecurringCyclePeriodTypeBatchClient
 * @description  Commerce Payment Method Batch Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceRecurringCyclePeriodTypeBatchClient` uses `commerceRecurringCyclePeriodTypeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsRecurringCyclePeriodTypeBatchClient = /** @class */ (function () {
    function CommerceLookupsRecurringCyclePeriodTypeBatchClient(commerceLookupsRecurringCyclePeriodTypeBatchRoute, apiClient) {
        this.commerceLookupsRecurringCyclePeriodTypeBatchRoute = commerceLookupsRecurringCyclePeriodTypeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsRecurringCyclePeriodTypeBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsRecurringCyclePeriodTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resources.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeBatchClient.create([{
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>',
                    monthFactor: '<month-factor'>
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsRecurringCyclePeriodTypeBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates specified commerce resources.
     * @method
     * @example   commerceLookupsRecurringCyclePeriodTypeBatchClient.update(commerceRecurringPeriodTypes)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsRecurringCyclePeriodTypeBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove commerce action has been performed. This action will remove commerce resources from the system if successfully completed.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeBatchClient.remove(commerceRecurringPeriodTypeIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsRecurringCyclePeriodTypeBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.commerceLookupsRecurringCyclePeriodTypeBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CommerceLookupsRecurringCyclePeriodTypeBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsRecurringCyclePeriodTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsRecurringCyclePeriodTypeBatchRoute !== "undefined" && __1.CommerceLookupsRecurringCyclePeriodTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceLookupsRecurringCyclePeriodTypeBatchClient);
    return CommerceLookupsRecurringCyclePeriodTypeBatchClient;
}());
exports.CommerceLookupsRecurringCyclePeriodTypeBatchClient = CommerceLookupsRecurringCyclePeriodTypeBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsRecurringCyclePeriodTypeRoute
 * @description Baasic Commerce Lookups RecurringCyclePeriodType Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups RecurringCyclePeriodType Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceLookupsRecurringCyclePeriodTypeRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsRecurringCyclePeriodTypeRoute, _super);
    function CommerceLookupsRecurringCyclePeriodTypeRoute(basicCommerceLookupsRecurringCyclePeriodTypeBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.basicCommerceLookupsRecurringCyclePeriodTypeBatchRoute = basicCommerceLookupsRecurringCyclePeriodTypeBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/recurring-cycle-period-types/{?searchQuery,page,rpp,sort,embed}';
        _this.getRoute = 'commerce/lookups/recurring-cycle-period-types/{id}/{?embed}';
        _this.createRoute = 'commerce/lookups/recurring-cycle-period-types';
        _this.updateRoute = 'commerce/lookups/recurring-cycle-period-types/{id}';
        _this.deleteRoute = 'commerce/lookups/recurring-cycle-period-types/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsRecurringCyclePeriodTypeRoute.prototype, "batch", {
        get: function () {
            return this.basicCommerceLookupsRecurringCyclePeriodTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce customer-payment-methods route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options.
     * @example commerceLookupsRecurringCyclePeriodTypeRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsRecurringCyclePeriodTypeRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeRoute.get();
     **/
    CommerceLookupsRecurringCyclePeriodTypeRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeRoute.create();
     **/
    CommerceLookupsRecurringCyclePeriodTypeRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeRoute.update(data);
     **/
    CommerceLookupsRecurringCyclePeriodTypeRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeRoute.delete(data);
     **/
    CommerceLookupsRecurringCyclePeriodTypeRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsRecurringCyclePeriodTypeRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsRecurringCyclePeriodTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsRecurringCyclePeriodTypeBatchRoute !== "undefined" && __1.CommerceLookupsRecurringCyclePeriodTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsRecurringCyclePeriodTypeRoute);
    return CommerceLookupsRecurringCyclePeriodTypeRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsRecurringCyclePeriodTypeRoute = CommerceLookupsRecurringCyclePeriodTypeRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 494 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsRecurringCyclePeriodTypeClient
 * @description  Commerce Lookups RecurringCyclePeriodType Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsRecurringCyclePeriodTypeClient` uses `commerceLookupsRecurringCyclePeriodTypeRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsRecurringCyclePeriodTypeClient = /** @class */ (function () {
    function CommerceLookupsRecurringCyclePeriodTypeClient(commerceLookupsRecurringCyclePeriodTypeBatchClient, commerceLookupsRecurringCyclePeriodTypeRoute, apiClient) {
        this.commerceLookupsRecurringCyclePeriodTypeBatchClient = commerceLookupsRecurringCyclePeriodTypeBatchClient;
        this.commerceLookupsRecurringCyclePeriodTypeRoute = commerceLookupsRecurringCyclePeriodTypeRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsRecurringCyclePeriodTypeClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsRecurringCyclePeriodTypeRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsRecurringCyclePeriodTypeClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsRecurringCyclePeriodTypeBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsRecurringCyclePeriodTypeClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeClient.get('<recurring-cycle-period-type-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsRecurringCyclePeriodTypeClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsRecurringCyclePeriodTypeRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsRecurringCyclePeriodTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceRecurringPeriodType);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceRecurringPeriodType is a resource previously fetched using get action.
                        commerceRecurringPeriodType.description = '<description>';
                        commerceLookupsRecurringCyclePeriodTypeClient.update(commerceRecurringPeriodType)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceLookupsRecurringCyclePeriodTypeClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsRecurringCyclePeriodTypeClient.create({
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>',
                    monthFactor: '<month-factor'>
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsRecurringCyclePeriodTypeClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsRecurringCyclePeriodTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceRecurringPeriodType);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceRecurringPeriodType is a resource previously fetched using get action.
                        commerceLookupsRecurringCyclePeriodTypeClient.remove(commerceRecurringPeriodType)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceLookupsRecurringCyclePeriodTypeClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsRecurringCyclePeriodTypeClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsRecurringCyclePeriodTypeBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsRecurringCyclePeriodTypeRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsRecurringCyclePeriodTypeBatchClient !== "undefined" && __1.CommerceLookupsRecurringCyclePeriodTypeBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsRecurringCyclePeriodTypeRoute !== "undefined" && __1.CommerceLookupsRecurringCyclePeriodTypeRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsRecurringCyclePeriodTypeClient);
    return CommerceLookupsRecurringCyclePeriodTypeClient;
}());
exports.CommerceLookupsRecurringCyclePeriodTypeClient = CommerceLookupsRecurringCyclePeriodTypeClient;
/**
 * @copyright(c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 495 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(496), exports);
tslib_1.__exportStar(__webpack_require__(497), exports);
tslib_1.__exportStar(__webpack_require__(498), exports);
tslib_1.__exportStar(__webpack_require__(499), exports);


/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsSubscriptionStatusBatchRoute
 * @description Baasic Commerce Lookups Subscription Status Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country State Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceLookupsSubscriptionStatusBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsSubscriptionStatusBatchRoute, _super);
    function CommerceLookupsSubscriptionStatusBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/subscription-statuses/batch';
        _this.updateRoute = 'commerce/lookups/subscription-statuses/batch';
        _this.deleteRoute = 'commerce/lookups/subscription-statuses/batch';
        return _this;
    }
    /**
     * Parses create commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsSubscriptionStatusBatchRoute.create();
     */
    CommerceLookupsSubscriptionStatusBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsSubscriptionStatusBatchRoute.update();
     */
    CommerceLookupsSubscriptionStatusBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsSubscriptionStatusBatchRoute.remove();
     */
    CommerceLookupsSubscriptionStatusBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsSubscriptionStatusBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsSubscriptionStatusBatchRoute);
    return CommerceLookupsSubscriptionStatusBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsSubscriptionStatusBatchRoute = CommerceLookupsSubscriptionStatusBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceSubscriptionStatusBatchClient
 * @description  Commerce Subscription Stauts Batch Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceSubscriptionStatusBatchClient` uses `commerceSubscriptionStatusBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsSubscriptionStatusBatchClient = /** @class */ (function () {
    function CommerceLookupsSubscriptionStatusBatchClient(commerceLookupsSubscriptionStatusBatchRoute, apiClient) {
        this.commerceLookupsSubscriptionStatusBatchRoute = commerceLookupsSubscriptionStatusBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsSubscriptionStatusBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsSubscriptionStatusBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resources.
     * @method
     * @example commerceLookupsSubscriptionStatusBatchClient.create([{
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    CommerceLookupsSubscriptionStatusBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates specified commerce resources.
     * @method
     * @example commerceLookupsSubscriptionStatusBatchClient.update(subscriptionStatuses)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsSubscriptionStatusBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove commerce action has been performed. This action will remove commerce resources from the system if successfully completed.
     * @method
     * @example commerceLookupsSubscriptionStatusBatchClient.remove(subscriptionStatusIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsSubscriptionStatusBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.commerceLookupsSubscriptionStatusBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CommerceLookupsSubscriptionStatusBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsSubscriptionStatusBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsSubscriptionStatusBatchRoute !== "undefined" && __1.CommerceLookupsSubscriptionStatusBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceLookupsSubscriptionStatusBatchClient);
    return CommerceLookupsSubscriptionStatusBatchClient;
}());
exports.CommerceLookupsSubscriptionStatusBatchClient = CommerceLookupsSubscriptionStatusBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsSubscriptionStatusRoute
 * @description Baasic Commerce Lookups SubscriptionStatus Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups SubscriptionStatus Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceLookupsSubscriptionStatusRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsSubscriptionStatusRoute, _super);
    function CommerceLookupsSubscriptionStatusRoute(basicCommerceLookupsSubscriptionStatusBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.basicCommerceLookupsSubscriptionStatusBatchRoute = basicCommerceLookupsSubscriptionStatusBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/subscription-statuses/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/lookups/subscription-statuses/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/lookups/subscription-statuses';
        _this.updateRoute = 'commerce/lookups/subscription-statuses/{id}';
        _this.deleteRoute = 'commerce/lookups/subscription-statuses/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsSubscriptionStatusRoute.prototype, "batch", {
        get: function () {
            return this.basicCommerceLookupsSubscriptionStatusBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce customer-payment-methods route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options.
     * @example commerceLookupsSubscriptionStatusRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsSubscriptionStatusRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceLookupsSubscriptionStatusRoute.get();
     **/
    CommerceLookupsSubscriptionStatusRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsSubscriptionStatusRoute.create();
     **/
    CommerceLookupsSubscriptionStatusRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsSubscriptionStatusRoute.update(data);
     **/
    CommerceLookupsSubscriptionStatusRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsSubscriptionStatusRoute.delete(data);
     **/
    CommerceLookupsSubscriptionStatusRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsSubscriptionStatusRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsSubscriptionStatusBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsSubscriptionStatusBatchRoute !== "undefined" && __1.CommerceLookupsSubscriptionStatusBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsSubscriptionStatusRoute);
    return CommerceLookupsSubscriptionStatusRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsSubscriptionStatusRoute = CommerceLookupsSubscriptionStatusRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsSubscriptionStatusClient
 * @description  Commerce Lookups SubscriptionStatus Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsSubscriptionStatusClient` uses `commerceLookupsSubscriptionStatusRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsSubscriptionStatusClient = /** @class */ (function () {
    function CommerceLookupsSubscriptionStatusClient(commerceLookupsSubscriptionStatusBatchClient, commerceLookupsSubscriptionStatusRoute, apiClient) {
        this.commerceLookupsSubscriptionStatusBatchClient = commerceLookupsSubscriptionStatusBatchClient;
        this.commerceLookupsSubscriptionStatusRoute = commerceLookupsSubscriptionStatusRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsSubscriptionStatusClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsSubscriptionStatusRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsSubscriptionStatusClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsSubscriptionStatusBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsSubscriptionStatusClient.find({
                        pageNumber : 1,
                        pageSize : 10,
                        orderBy : '<field>',
                        orderDirection : '<asc|desc>',
                        search : '<search-phrase>'
                    })
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsSubscriptionStatusClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsSubscriptionStatusClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsSubscriptionStatusClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsSubscriptionStatusRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsSubscriptionStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceSubscriptionStatus);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceSubscriptionStatus is a resource previously fetched using get action.
                    commerceSubscriptionStatus.description = '<description>';
                    commerceLookupsSubscriptionStatusClient.update(commerceSubscriptionStatus)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsSubscriptionStatusClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsSubscriptionStatusClient.create({
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsSubscriptionStatusClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsSubscriptionStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceSubscriptionStatus);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceSubscriptionStatus is a resource previously fetched using get action.
                    commerceLookupsSubscriptionStatusClient.remove(commerceSubscriptionStatus)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsSubscriptionStatusClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsSubscriptionStatusClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsSubscriptionStatusBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsSubscriptionStatusRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsSubscriptionStatusBatchClient !== "undefined" && __1.CommerceLookupsSubscriptionStatusBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsSubscriptionStatusRoute !== "undefined" && __1.CommerceLookupsSubscriptionStatusRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsSubscriptionStatusClient);
    return CommerceLookupsSubscriptionStatusClient;
}());
exports.CommerceLookupsSubscriptionStatusClient = CommerceLookupsSubscriptionStatusClient;
/**
 * @copyright(c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(501), exports);
tslib_1.__exportStar(__webpack_require__(502), exports);
tslib_1.__exportStar(__webpack_require__(503), exports);
tslib_1.__exportStar(__webpack_require__(504), exports);


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsInvoiceStatusBatchRoute
 * @description Baasic Commerce Lookups Invoice Status Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups Country State Batch Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceLookupsInvoiceStatusBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsInvoiceStatusBatchRoute, _super);
    function CommerceLookupsInvoiceStatusBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'commerce/lookups/invoice-statuses/batch';
        _this.updateRoute = 'commerce/lookups/invoice-statuses/batch';
        _this.deleteRoute = 'commerce/lookups/invoice-statuses/batch';
        return _this;
    }
    /**
     * Parses create commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsInvoiceStatusBatchRoute.create();
     */
    CommerceLookupsInvoiceStatusBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsInvoiceStatusBatchRoute.update();
     */
    CommerceLookupsInvoiceStatusBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove commerce country state batch route; this route does not expose any additional options
     * @method
     * @example commerceLookupsInvoiceStatusBatchRoute.remove();
     */
    CommerceLookupsInvoiceStatusBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CommerceLookupsInvoiceStatusBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceLookupsInvoiceStatusBatchRoute);
    return CommerceLookupsInvoiceStatusBatchRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsInvoiceStatusBatchRoute = CommerceLookupsInvoiceStatusBatchRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceInvoiceStatusBatchClient
 * @description  Commerce Invoice Stauts Batch Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceInvoiceStatusBatchClient` uses `commerceInvoiceStatusBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsInvoiceStatusBatchClient = /** @class */ (function () {
    function CommerceLookupsInvoiceStatusBatchClient(commerceLookupsInvoiceStatusBatchRoute, apiClient) {
        this.commerceLookupsInvoiceStatusBatchRoute = commerceLookupsInvoiceStatusBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsInvoiceStatusBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsInvoiceStatusBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resources.
     * @method
     * @example commerceLookupsInvoiceStatusBatchClient.create([{
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    CommerceLookupsInvoiceStatusBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates specified commerce resources.
     * @method
     * @example commerceLookupsInvoiceStatusBatchClient.update(InvoiceStatuses)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsInvoiceStatusBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove commerce action has been performed. This action will remove commerce resources from the system if successfully completed.
     * @method
     * @example commerceLookupsInvoiceStatusBatchClient.remove(InvoiceStatusIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsInvoiceStatusBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.commerceLookupsInvoiceStatusBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CommerceLookupsInvoiceStatusBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsInvoiceStatusBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsInvoiceStatusBatchRoute !== "undefined" && __1.CommerceLookupsInvoiceStatusBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceLookupsInvoiceStatusBatchClient);
    return CommerceLookupsInvoiceStatusBatchClient;
}());
exports.CommerceLookupsInvoiceStatusBatchClient = CommerceLookupsInvoiceStatusBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsInvoiceStatusRoute
 * @description Baasic Commerce Lookups InvoiceStatus Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Lookups InvoiceStatus Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceLookupsInvoiceStatusRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceLookupsInvoiceStatusRoute, _super);
    function CommerceLookupsInvoiceStatusRoute(basicCommerceLookupsInvoiceStatusBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.basicCommerceLookupsInvoiceStatusBatchRoute = basicCommerceLookupsInvoiceStatusBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/lookups/invoice-statuses/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/lookups/invoice-statuses/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/lookups/invoice-statuses';
        _this.updateRoute = 'commerce/lookups/invoice-statuses/{id}';
        _this.deleteRoute = 'commerce/lookups/invoice-statuses/{id}';
        return _this;
    }
    Object.defineProperty(CommerceLookupsInvoiceStatusRoute.prototype, "batch", {
        get: function () {
            return this.basicCommerceLookupsInvoiceStatusBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce customer-payment-methods route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options.
     * @example commerceLookupsInvoiceStatusRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceLookupsInvoiceStatusRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceLookupsInvoiceStatusRoute.get();
     **/
    CommerceLookupsInvoiceStatusRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsInvoiceStatusRoute.create();
     **/
    CommerceLookupsInvoiceStatusRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsInvoiceStatusRoute.update(data);
     **/
    CommerceLookupsInvoiceStatusRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete commerce payment method route; this URI template does not expose any additional options.
     * @method
     * @example commerceLookupsInvoiceStatusRoute.delete(data);
     **/
    CommerceLookupsInvoiceStatusRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceLookupsInvoiceStatusRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsInvoiceStatusBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsInvoiceStatusBatchRoute !== "undefined" && __1.CommerceLookupsInvoiceStatusBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceLookupsInvoiceStatusRoute);
    return CommerceLookupsInvoiceStatusRoute;
}(common_1.BaseRoute));
exports.CommerceLookupsInvoiceStatusRoute = CommerceLookupsInvoiceStatusRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 504 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceLookupsInvoiceStatusClient
 * @description  Commerce Lookups InvoiceStatus Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceLookupsInvoiceStatusClient` uses `commerceLookupsInvoiceStatusRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceLookupsInvoiceStatusClient = /** @class */ (function () {
    function CommerceLookupsInvoiceStatusClient(commerceLookupsInvoiceStatusBatchClient, commerceLookupsInvoiceStatusRoute, apiClient) {
        this.commerceLookupsInvoiceStatusBatchClient = commerceLookupsInvoiceStatusBatchClient;
        this.commerceLookupsInvoiceStatusRoute = commerceLookupsInvoiceStatusRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceLookupsInvoiceStatusClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceLookupsInvoiceStatusRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceLookupsInvoiceStatusClient.prototype, "batch", {
        get: function () {
            return this.commerceLookupsInvoiceStatusBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceLookupsInvoiceStatusClient.find({
                        pageNumber : 1,
                        pageSize : 10,
                        orderBy : '<field>',
                        orderDirection : '<asc|desc>',
                        search : '<search-phrase>'
                    })
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsInvoiceStatusClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceLookupsInvoiceStatusClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceLookupsInvoiceStatusClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceLookupsInvoiceStatusRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsInvoiceStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceInvoiceStatus);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceInvoiceStatus is a resource previously fetched using get action.
                    commerceInvoiceStatus.description = '<description>';
                    commerceLookupsInvoiceStatusClient.update(commerceInvoiceStatus)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsInvoiceStatusClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceLookupsInvoiceStatusClient.create({
                    name : '<name>',
                    abrv: '<abbreviation>',
                    description: '<description>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceLookupsInvoiceStatusClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceLookupsInvoiceStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceInvoiceStatus);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceInvoiceStatus is a resource previously fetched using get action.
                    commerceLookupsInvoiceStatusClient.remove(commerceInvoiceStatus)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceLookupsInvoiceStatusClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceLookupsInvoiceStatusClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsInvoiceStatusBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsInvoiceStatusRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceLookupsInvoiceStatusBatchClient !== "undefined" && __1.CommerceLookupsInvoiceStatusBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceLookupsInvoiceStatusRoute !== "undefined" && __1.CommerceLookupsInvoiceStatusRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceLookupsInvoiceStatusClient);
    return CommerceLookupsInvoiceStatusClient;
}());
exports.CommerceLookupsInvoiceStatusClient = CommerceLookupsInvoiceStatusClient;
/**
 * @copyright(c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 505 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var __1 = __webpack_require__(5);
var _1 = __webpack_require__(47);
var inversify_1 = __webpack_require__(1);
var Lookups = /** @class */ (function () {
    function Lookups(addressTypes, countries, countryStates, paymentMethods, paymentTransactionStatuses, recurringCyclePeriodTypes, subscriptionStatuses, invoiceStatuses, couponTypes) {
        this.addressTypes = addressTypes;
        this.countries = countries;
        this.countryStates = countryStates;
        this.paymentMethods = paymentMethods;
        this.paymentTransactionStatuses = paymentTransactionStatuses;
        this.recurringCyclePeriodTypes = recurringCyclePeriodTypes;
        this.subscriptionStatuses = subscriptionStatuses;
        this.invoiceStatuses = invoiceStatuses;
        this.couponTypes = couponTypes;
    }
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    Lookups = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceLookupsAddressTypesClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceLookupsCountryClient)),
        tslib_1.__param(2, inversify_1.inject(__1.TYPES.CommerceLookupsCountryStateClient)),
        tslib_1.__param(3, inversify_1.inject(__1.TYPES.CommerceLookupsPaymentMethodClient)),
        tslib_1.__param(4, inversify_1.inject(__1.TYPES.CommerceLookupsPaymentTransactionStatusClient)),
        tslib_1.__param(5, inversify_1.inject(__1.TYPES.CommerceLookupsRecurringCyclePeriodTypeClient)),
        tslib_1.__param(6, inversify_1.inject(__1.TYPES.CommerceLookupsSubscriptionStatusClient)),
        tslib_1.__param(7, inversify_1.inject(__1.TYPES.CommerceLookupsInvoiceStatusClient)),
        tslib_1.__param(8, inversify_1.inject(__1.TYPES.CommerceLookupsCouponTypesClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceLookupsAddressTypesClient !== "undefined" && _1.CommerceLookupsAddressTypesClient) === "function" ? _a : Object, typeof (_b = typeof _1.CommerceLookupsCountryClient !== "undefined" && _1.CommerceLookupsCountryClient) === "function" ? _b : Object, typeof (_c = typeof _1.CommerceLookupsCountryStateClient !== "undefined" && _1.CommerceLookupsCountryStateClient) === "function" ? _c : Object, typeof (_d = typeof _1.CommerceLookupsPaymentMethodClient !== "undefined" && _1.CommerceLookupsPaymentMethodClient) === "function" ? _d : Object, typeof (_e = typeof _1.CommerceLookupsPaymentTransactionStatusClient !== "undefined" && _1.CommerceLookupsPaymentTransactionStatusClient) === "function" ? _e : Object, typeof (_f = typeof _1.CommerceLookupsRecurringCyclePeriodTypeClient !== "undefined" && _1.CommerceLookupsRecurringCyclePeriodTypeClient) === "function" ? _f : Object, typeof (_g = typeof _1.CommerceLookupsSubscriptionStatusClient !== "undefined" && _1.CommerceLookupsSubscriptionStatusClient) === "function" ? _g : Object, typeof (_h = typeof _1.CommerceLookupsInvoiceStatusClient !== "undefined" && _1.CommerceLookupsInvoiceStatusClient) === "function" ? _h : Object, typeof (_j = typeof _1.CommerceLookupsCouponTypesClient !== "undefined" && _1.CommerceLookupsCouponTypesClient) === "function" ? _j : Object])
    ], Lookups);
    return Lookups;
}());
exports.Lookups = Lookups;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(507), exports);
tslib_1.__exportStar(__webpack_require__(508), exports);
tslib_1.__exportStar(__webpack_require__(509), exports);
tslib_1.__exportStar(__webpack_require__(510), exports);


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCustomerRoute
 * @description Baasic Commerce Customer Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Customer Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceCustomerRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceCustomerRoute, _super);
    function CommerceCustomerRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/customers/{systemName}/{?customerId,searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/customers/{systemName}/{id}/{?embed,fields}';
        _this.updateRoute = 'commerce/customers/{systemName}/{id}';
        _this.deleteRoute = 'commerce/customers/{systemName}/{id}';
        return _this;
    }
    /**
     * Parses find commerce customers route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceCustomerRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceCustomerRoute.prototype.find = function (options) {
        return this.baseFind(this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceCustomerRoute.get(id, options);
     **/
    CommerceCustomerRoute.prototype.get = function (id, options) {
        return this.baseGet(this.getRoute, id, options);
    };
    /**
     * Parses update route; this route doesn't expose any properties.
     * @method
     * @example commerceCustomerRoute.update(data);
     **/
    CommerceCustomerRoute.prototype.update = function (data) {
        return this.baseUpdate(this.updateRoute, data);
    };
    /**
     * Parses delete route; this route doesn't expose any properties.
     * @method
     * @example commerceCustomerRoute.delete(data);
     **/
    CommerceCustomerRoute.prototype.delete = function (data) {
        return this.baseDelete(this.deleteRoute, data);
    };
    var _a;
    CommerceCustomerRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceCustomerRoute);
    return CommerceCustomerRoute;
}(common_1.BaseRoute));
exports.CommerceCustomerRoute = CommerceCustomerRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCustomerClient
 * @description  Commerce Customer Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCustomerClient` uses `commerceCustomerRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceCustomerClient = /** @class */ (function () {
    function CommerceCustomerClient(commerceCustomerPaymentMethodClient, commerceCustomerRoute, apiClient) {
        this.commerceCustomerPaymentMethodClient = commerceCustomerPaymentMethodClient;
        this.commerceCustomerRoute = commerceCustomerRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceCustomerClient.prototype, "paymentMethods", {
        get: function () {
            return this.commerceCustomerPaymentMethodClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceCustomerClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceCustomerRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceCustomerClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceCustomerClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceCustomerClient.get(id)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceCustomerClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceCustomerRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceCustomerRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = apiClient.removeParams(commerceCustomer);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceCustomer is a resource previously fetched using get action.
                    commerceCustomer.isDefault : true;
                    commerceCustomerClient.update(commerceCustomer)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceCustomerClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceCustomerRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = apiClient.removeParams(commerceCustomer);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceCustomer is a resource previously fetched using get action.
                    commerceCustomerClient.remove(commerceCustomer)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceCustomerClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceCustomerClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceCustomerPaymentMethodClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceCustomerRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceCustomerPaymentMethodClient !== "undefined" && __1.CommerceCustomerPaymentMethodClient) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceCustomerRoute !== "undefined" && __1.CommerceCustomerRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceCustomerClient);
    return CommerceCustomerClient;
}());
exports.CommerceCustomerClient = CommerceCustomerClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCustomerPaymentMethodRoute
 * @description Baasic Commerce CustomerPaymentMethod Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce CustomerPaymentMethod Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceCustomerPaymentMethodRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceCustomerPaymentMethodRoute, _super);
    function CommerceCustomerPaymentMethodRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/customer-payment-methods/{systemName}/{?customerId,searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/customer-payment-methods/{systemName}/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/customer-payment-methods/{systemName}/';
        _this.updateRoute = 'commerce/customer-payment-methods/{systemName}/{id}';
        _this.deleteRoute = 'commerce/customer-payment-methods/{systemName}/{id}';
        return _this;
    }
    /**
     * Parses find commerce customer-payment-methods route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options.
     * @example commerceCustomerPaymentMethodRoute.find({searchQuery: '<search-phrase>'});                               **/
    CommerceCustomerPaymentMethodRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceCustomerPaymentMethodRoute.get(id, options);
     **/
    CommerceCustomerPaymentMethodRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce customer-payment-method route; this URI template does not expose any additional options.
     * @method
     * @example commerceCustomerPaymentMethodRoute.create();
     **/
    CommerceCustomerPaymentMethodRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update commerce customer-payment-method route; this URI template does not expose any additional options.
     * @method
     * @example commerceCustomerPaymentMethodRoute.update(data);
     **/
    CommerceCustomerPaymentMethodRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete commerce customer-payment-method route; this URI template does not expose any additional options.
    * @method
    * @example commerceCustomerPaymentMethodRoute.delete(data);
    **/
    CommerceCustomerPaymentMethodRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    CommerceCustomerPaymentMethodRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceCustomerPaymentMethodRoute);
    return CommerceCustomerPaymentMethodRoute;
}(common_1.BaseRoute));
exports.CommerceCustomerPaymentMethodRoute = CommerceCustomerPaymentMethodRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCustomerPaymentMethodClient
 * @description  Commerce CustomerPaymentMethod Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCustomerPaymentMethodClient` uses `commerceCustomerPaymentMethodRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceCustomerPaymentMethodClient = /** @class */ (function () {
    function CommerceCustomerPaymentMethodClient(commerceCustomerPaymentMethodRoute, apiClient) {
        this.commerceCustomerPaymentMethodRoute = commerceCustomerPaymentMethodRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceCustomerPaymentMethodClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceCustomerPaymentMethodRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example commerceCustomerPaymentMethodClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceCustomerPaymentMethodClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceCustomerPaymentMethodClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceCustomerPaymentMethodClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceCustomerPaymentMethodRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceCustomerPaymentMethodRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCustomerPaymentMethod);
     * var uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceCustomerPaymentMethod is a resource previously fetched using get action.
                        commerceCustomerPaymentMethod.isDefault : true;
                        commerceCustomerPaymentMethodClient.update(commerceCustomerPaymentMethod)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceCustomerPaymentMethodClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceCustomerPaymentMethodClient.create({
                    paymentMethodNonce : '<payment-method-nonce>',
                    customerId : '<customer-id>',
                    typeName : '<type-name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceCustomerPaymentMethodClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicCommerceCustomerPaymentMethodRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCustomerPaymentMethod);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceCustomerPaymentMethod is a resource previously fetched using get action.
                    commerceCustomerPaymentMethodClient.remove(commerceCustomerPaymentMethod)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceCustomerPaymentMethodClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    CommerceCustomerPaymentMethodClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceCustomerPaymentMethodRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceCustomerPaymentMethodRoute !== "undefined" && __1.CommerceCustomerPaymentMethodRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceCustomerPaymentMethodClient);
    return CommerceCustomerPaymentMethodClient;
}());
exports.CommerceCustomerPaymentMethodClient = CommerceCustomerPaymentMethodClient;
/**
 * @copyright(c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(512), exports);
tslib_1.__exportStar(__webpack_require__(513), exports);
tslib_1.__exportStar(__webpack_require__(514), exports);
tslib_1.__exportStar(__webpack_require__(515), exports);


/***/ }),
/* 512 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceInvoiceStreamsRoute
 * @description Baasic Commerce Invoice Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Invoice Streams Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceInvoiceStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceInvoiceStreamsRoute, _super);
    function CommerceInvoiceStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'commerce/invoice-streams/{id}';
        return _this;
    }
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceInvoiceStremsRoute.get(data);
     **/
    CommerceInvoiceStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    var _a;
    CommerceInvoiceStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceInvoiceStreamsRoute);
    return CommerceInvoiceStreamsRoute;
}(common_1.BaseRoute));
exports.CommerceInvoiceStreamsRoute = CommerceInvoiceStreamsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceInvoiceStreamsClient
 * @description  Commerce Invoice Streams Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceInvoiceStreamsClient` uses `commerceInvoiceStreamsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceInvoiceStreamsClient = /** @class */ (function () {
    function CommerceInvoiceStreamsClient(commerceInvoiceStreamsRoute, apiClient) {
        this.commerceInvoiceStreamsRoute = commerceInvoiceStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceInvoiceStreamsClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceInvoiceStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the invoice stream if successfully completed.
     * @method
     * @example // commerceInvoice is a resource previously fetched using get action.
                    commerceInvoiceStreamsClient.get({id: commerceInvoice.id})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceInvoiceStreamsClient.prototype.get = function (data) {
        return this.apiClient.get(this.routeDefinition.get(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the invoice stream as a blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @example // Request the original blob
                        commerceInvoiceClient.getBlobl({id: commerceInvoice.id})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceInvoiceStreamsClient.prototype.getBlob = function (data) {
        return this.apiClient.request({
            url: this.commerceInvoiceStreamsRoute.get(data),
            responseType: 'blob',
            headers: { 'Accept': 'application/octet-stream' },
            method: 'GET'
        });
    };
    var _a, _b;
    CommerceInvoiceStreamsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceInvoiceStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceInvoiceStreamsRoute !== "undefined" && __1.CommerceInvoiceStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceInvoiceStreamsClient);
    return CommerceInvoiceStreamsClient;
}());
exports.CommerceInvoiceStreamsClient = CommerceInvoiceStreamsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 514 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceInvoiceRoute
 * @description Baasic Commerce Invoice Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Invoice Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceInvoiceRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceInvoiceRoute, _super);
    function CommerceInvoiceRoute(commerceInvoiceStreamsRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.commerceInvoiceStreamsRoute = commerceInvoiceStreamsRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/invoices/{?customerId,invoiceStatusId,subscriptionId,dateCreatedMin,dateCreatedMax,searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/invoices/{id}/{?embed,fields}';
        _this.updateRoute = 'commerce/invoices/{id}';
        _this.deleteRoute = 'commerce/invoices/{id}';
        return _this;
    }
    Object.defineProperty(CommerceInvoiceRoute.prototype, "streams", {
        get: function () {
            return this.commerceInvoiceStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find commerce invoice route which can be expanded with additional options. Supported items are:
     * - `customerId` - The customer identifier.
     * - `invoiceStatusId` - A invoice status unique identifier.
     * - `subscriptionId` - A subscription unique identifier.
     * - `dateCreatedMin` - A date created minimum date filter.
     * - `dateCreatedMax` - A date created maximum date filter.
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceInvoiceRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceInvoiceRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceInvoiceRoute.get(id, options);
     **/
    CommerceInvoiceRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this route doesn't expose any properties.
     * @method
     * @example commerceInvoiceRoute.update(data);
     **/
    CommerceInvoiceRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this route doesn't expose any properties.
     * @method
     * @example commerceInvoiceRoute.delete(data);
     **/
    CommerceInvoiceRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CommerceInvoiceRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceInvoiceStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceInvoiceStreamsRoute !== "undefined" && __1.CommerceInvoiceStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceInvoiceRoute);
    return CommerceInvoiceRoute;
}(common_1.BaseRoute));
exports.CommerceInvoiceRoute = CommerceInvoiceRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 515 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceInvoiceClient
 * @description  Commerce Invoice Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceInvoiceClient` uses `commerceInvoiceRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceInvoiceClient = /** @class */ (function () {
    function CommerceInvoiceClient(commerceInvoiceRoute, commerceInvoiceStreamsClient, apiClient) {
        this.commerceInvoiceRoute = commerceInvoiceRoute;
        this.commerceInvoiceStreamsClient = commerceInvoiceStreamsClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceInvoiceClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceInvoiceRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceInvoiceClient.prototype, "streams", {
        get: function () {
            return this.commerceInvoiceStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceInvoiceClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceInvoiceClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceInvoiceClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommerceInvoiceClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceInvoiceRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceInvoiceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceInvoice);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceInvoice is a resource previously fetched using get action.
                    commerceInvoice.invoiceStatusId : '<new-invoice-status-id>';
                    commerceInvoiceClient.update(commerceInvoice)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceInvoiceClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceInvoiceRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceInvoice);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceInvoice is a resource previously fetched using get action.
                        commerceInvoiceClient.remove(commerceInvoice)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceInvoiceClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CommerceInvoiceClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceInvoiceRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceInvoiceStreamsClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceInvoiceRoute !== "undefined" && __1.CommerceInvoiceRoute) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceInvoiceStreamsClient !== "undefined" && __1.CommerceInvoiceStreamsClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceInvoiceClient);
    return CommerceInvoiceClient;
}());
exports.CommerceInvoiceClient = CommerceInvoiceClient;


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(517), exports);
tslib_1.__exportStar(__webpack_require__(518), exports);


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commercePaymentTransactionRoute
 * @description Baasic Commerce PaymentTransaction Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce PaymentTransaction Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommercePaymentTransactionRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommercePaymentTransactionRoute, _super);
    function CommercePaymentTransactionRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/payment-transactions/{?customerId,searchQuery,invoiceStatusId,subscriptionId,paymentMethodId,firstName,lastName,transactionStatuses,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/payment-transactions/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/payment-transactions';
        _this.updateRoute = 'commerce/payment-transactions/{id}';
        _this.deleteRoute = 'commerce/payment-transactions/{id}';
        return _this;
    }
    /**
     * Parses find commerce payment transaction route which can be expanded with additional options. Supported items are:
     * - `customerId` - A customer unique identifier.
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `invoiceStatusId` - A invoice status unique identifier.
     * - `subscriptionId` - A subscription unique identifier.
     * - `paymentMethodId` - A payment method unique identifier.
     * - `firstName` - A customer first name.
     * - `lastName` - A customer last name.
     * - `transactionStatuses` - A transaction statuses in CSV format.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commercePaymentTransactionRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommercePaymentTransactionRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commercePaymentTransactionRoute.get(id, options);
     **/
    CommercePaymentTransactionRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this route doesn't expose any properties.
     * @method
     * @example commercePaymentTransactionRoute.create();
     **/
    CommercePaymentTransactionRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this route doesn't expose any properties.
     * @method
     * @example commercePaymentTransactionRoute.update(data);
     **/
    CommercePaymentTransactionRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this route doesn't expose any properties.
     * @method
     * @example commercePaymentTransactionRoute.delete(data);
     **/
    CommercePaymentTransactionRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    CommercePaymentTransactionRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommercePaymentTransactionRoute);
    return CommercePaymentTransactionRoute;
}(common_1.BaseRoute));
exports.CommercePaymentTransactionRoute = CommercePaymentTransactionRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commercePaymentTransactionClient
 * @description  Commerce PaymentTransaction Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commercePaymentTransactionClient` uses `commercePaymentTransactionRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommercePaymentTransactionClient = /** @class */ (function () {
    function CommercePaymentTransactionClient(commercePaymentTransactionRoute, apiClient) {
        this.commercePaymentTransactionRoute = commercePaymentTransactionRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommercePaymentTransactionClient.prototype, "routeDefinition", {
        get: function () {
            return this.commercePaymentTransactionRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commercePaymentTransactionClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommercePaymentTransactionClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commercePaymentTransactionClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommercePaymentTransactionClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commercePaymentTransactionRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create action has been performed. Success response returns the commerce resource.
     * @method
     * @example commercePaymentTransactionClient.create(data)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CommercePaymentTransactionClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commercePaymentTransactionRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commercePaymentTransaction);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commercePaymentTransaction is a resource previously fetched using get action.
                        commercePaymentTransaction.amount : 100;
                        commercePaymentTransactionClient.update(commercePaymentTransaction)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommercePaymentTransactionClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commercePaymentTransactionRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commercePaymentTransaction);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commercePaymentTransaction is a resource previously fetched using get action.
                        commercePaymentTransactionClient.remove(commercePaymentTransaction)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommercePaymentTransactionClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    CommercePaymentTransactionClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommercePaymentTransactionRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommercePaymentTransactionRoute !== "undefined" && __1.CommercePaymentTransactionRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommercePaymentTransactionClient);
    return CommercePaymentTransactionClient;
}());
exports.CommercePaymentTransactionClient = CommercePaymentTransactionClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(520), exports);
tslib_1.__exportStar(__webpack_require__(521), exports);


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductRoute
 * @description Baasic Commerce Product Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Product Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceProductRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductRoute, _super);
    function CommerceProductRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/products/{?searchQuery,page,rpp,sort,embed,fields,productCategoryIds,productCategoryAbrvs}';
        _this.getRoute = 'commerce/products/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/products';
        _this.updateRoute = 'commerce/products/{id}';
        _this.deleteRoute = 'commerce/products/{id}';
        return _this;
    }
    /**
     * Parses find commerce product route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `productCategoryIds` - A list of product category ids.
     * - `productCategoryAbrvs` - A list of product category abbreviations.
     * @method
     * @example commerceProductRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceProductRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceProductRoute.get(id, options);
     **/
    CommerceProductRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce product route; this URI template does not expose any additional options.
     * @method
     * @example commerceProductRoute.create();
     **/
    CommerceProductRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce product route; this URI template does not expose any additional options.
     * @method
     * @example commerceProductRoute.update(data);
     **/
    CommerceProductRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete commerce product route; this URI template does not expose any additional options.
    * @method
    * @example commerceProductRoute.delete(data);
    **/
    CommerceProductRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    CommerceProductRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceProductRoute);
    return CommerceProductRoute;
}(common_1.BaseRoute));
exports.CommerceProductRoute = CommerceProductRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductClient
 * @description  Commerce Product Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceProductClient` uses `commerceProductRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceProductClient = /** @class */ (function () {
    function CommerceProductClient(commerceProductRoute, apiClient) {
        this.commerceProductRoute = commerceProductRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceProductRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceProductClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>',
                   productCategoryIds : [''],
                   productCategoryAbrvs: ['']
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    **/
    CommerceProductClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceProductClient.get()
                      .then(function (data) {
                          // perform success action here
                      },
                       function (response, status, headers, config) {
                           // perform error handling here
                      });
   **/
    CommerceProductClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceProductRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceProductClient.create({
                    name : '<product-name>',
                    slug : '<slug>',
                    shortDescription : '<short-description>',
                    recurringCyclePeriodTypeId: '<recurring-cycle-period-type-id>'
                    planId : '<plan-id>',
                    price: 100,
                    published: true
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceProductClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceProductRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceProduct);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceProduct is a resource previously fetched using get action.
                        commerceProduct.shortDescription : '<short-description>';
                        commerceProductClient.update(commerceProduct)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceProductClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceProductRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceProduct);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceProduct is a resource previously fetched using get action.
                    commerceProductClient.remove(commerceProduct)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceProductClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    CommerceProductClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceProductRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceProductRoute !== "undefined" && __1.CommerceProductRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceProductClient);
    return CommerceProductClient;
}());
exports.CommerceProductClient = CommerceProductClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(523), exports);
tslib_1.__exportStar(__webpack_require__(524), exports);
tslib_1.__exportStar(__webpack_require__(525), exports);
tslib_1.__exportStar(__webpack_require__(526), exports);
tslib_1.__exportStar(__webpack_require__(527), exports);
tslib_1.__exportStar(__webpack_require__(528), exports);
tslib_1.__exportStar(__webpack_require__(529), exports);
tslib_1.__exportStar(__webpack_require__(530), exports);
tslib_1.__exportStar(__webpack_require__(531), exports);


/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductFilesStreamsRoute
 * @description Baasic Product Files Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic product Files Streams Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceProductFilesStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductFilesStreamsRoute, _super);
    function CommerceProductFilesStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'commerce/product-file-streams/{id}/{?width,height}';
        _this.createRoute = 'commerce/product-file-streams/{filename}/{?productId}';
        _this.updateRoute = 'commerce/product-file-streams/{id}/{?width,height}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id of desired file stream. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * @method
     * @param data Product file id of the original product file used to identify stream that needs to be retrieved from the system.
     * @example productFilesRoute.get({id: '<filename>'});
     **/
    CommerceProductFilesStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the filename which indicates where the stream will be saved.
     * @method
     * @param data Product file that needs to be saved into the system.
     * @example productFilesRoute.create({filename: '<filename>'});
     **/
    CommerceProductFilesStreamsRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this route should be expanded with the id of the previously saved resource. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @param data Product file used to identify stream that needs to be updated.
     * @example productFilesRoute.update({id: '<filename>'});
     **/
    CommerceProductFilesStreamsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    CommerceProductFilesStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceProductFilesStreamsRoute);
    return CommerceProductFilesStreamsRoute;
}(common_1.BaseRoute));
exports.CommerceProductFilesStreamsRoute = CommerceProductFilesStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductFilesStreamsClient
 * @description  Product Files Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(5);
var CommerceProductFilesStreamsClient = /** @class */ (function () {
    function CommerceProductFilesStreamsClient(productFilesStreamsRoute, apiClient) {
        this.productFilesStreamsRoute = productFilesStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductFilesStreamsClient.prototype, "routeDefinition", {
        get: function () {
            return this.productFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a stream of the derived resource. Otherwise, stream of the original file resource will be retrieved.
     * @method
     * @param data Product file id of the original product file used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original file stream
                    productFilesStreamsClient.get({id: '<file-id>'})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });

                // Request derived file stream
                        productFilesStreamsClient.get({id: '<file-id>', width: <width>, height: <height>})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceProductFilesStreamsClient.prototype.get = function (data) {
        return this.apiClient.get(this.routeDefinition.get(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a blob of the derived file resource. Otherwise, blob of the original file resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param data Product file id of the original product file used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original blob
                    productFilesStreamsClient.getBlob('<file-id>')
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });

                // Request derived blob
                        productFilesStreamsClient.getBlob({
                            id: '<file-id>',
                            width: <width>,
                            height: <height>
                        })
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    CommerceProductFilesStreamsClient.prototype.getBlob = function (data) {
        return this.apiClient.request({
            url: this.productFilesStreamsRoute.get(data),
            responseType: 'blob',
            headers: { 'Accept': 'application/octet-stream' },
            method: 'GET'
        });
    };
    /**
     * Returns a promise that is resolved once the update file stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of file stream data type).
     * @method
     * @param data Product file used to identify stream that needs to be updated.
     * @param stream
     * @returns A promise that is resolved once the update file stream action has been performed.
     * @example // Update original file stream
                    productFilesStreamsClient.update('<file-id>', <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
                // Update derived file stream
                    productFilesStreamsClient.update({id: '<file-id>', width: <width>, height: <height>}, <file-stream>)
                        .then(function (data) {
                            //  perform success action here
                       },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    CommerceProductFilesStreamsClient.prototype.update = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.productFilesStreamsRoute.update(data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the create file stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param data Product file that needs to be saved into the system.
     * @param stream
     * @returns A promise that is resolved once the create file stream action has been performed.
     * @example productFilesStreamsClient.create('<file-id>', <blob>)
                   .then(function (data) {
                        // perform success action her
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    CommerceProductFilesStreamsClient.prototype.create = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.productFilesStreamsRoute.create(data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    CommerceProductFilesStreamsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductFilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductFilesStreamsRoute !== "undefined" && _1.CommerceProductFilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceProductFilesStreamsClient);
    return CommerceProductFilesStreamsClient;
}());
exports.CommerceProductFilesStreamsClient = CommerceProductFilesStreamsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductFilesBatchRoute
 * @description Baasic Product Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic product Files Batch Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceProductFilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductFilesBatchRoute, _super);
    function CommerceProductFilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.unlinkRoute = 'commerce/product-files/batch/unlink';
        _this.updateRoute = 'commerce/product-files/batch';
        _this.linkRoute = 'commerce/product-files/batch/link';
        return _this;
    }
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @example CommerceProductFilesBatchRoute.unlink();
     **/
    CommerceProductFilesBatchRoute.prototype.unlink = function () {
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example CommerceProductFilesStreamsRoute.update();
     **/
    CommerceProductFilesBatchRoute.prototype.update = function () {
        return _super.prototype.baseCreate.call(this, this.updateRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example CommerceProductFilesStreamsRoute.link();
     **/
    CommerceProductFilesBatchRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    var _a;
    CommerceProductFilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceProductFilesBatchRoute);
    return CommerceProductFilesBatchRoute;
}(common_1.BaseRoute));
exports.CommerceProductFilesBatchRoute = CommerceProductFilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductFilesBatchClient
 * @description  Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(5);
var CommerceProductFilesBatchClient = /** @class */ (function () {
    function CommerceProductFilesBatchClient(productFilesBatchRoute, apiClient) {
        this.productFilesBatchRoute = productFilesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductFilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.productFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will remove just derived resource. Otherwise, specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param data Collection of product files that needs to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                   productFilesBatchClient.unlink([{ id: '<file-id>' }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
               // Remove derived file resources
                   productFilesBatchClient.unlink([{ id: '<file-id>', fileFormat: { width: <width>, height: <height> } }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    CommerceProductFilesBatchClient.prototype.unlink = function (data) {
        return this.apiClient.delete(this.productFilesBatchRoute.unlink(), undefined, data);
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param data A collection of product files objects used to update specified product files.
     * @returns A promise that is resolved once the update action has been performed.
     * @example productFilesClient.batch.update(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductFilesBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param data A collection of product file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example productFilesClient.batch.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductFilesBatchClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    CommerceProductFilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductFilesBatchRoute !== "undefined" && _1.CommerceProductFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceProductFilesBatchClient);
    return CommerceProductFilesBatchClient;
}());
exports.CommerceProductFilesBatchClient = CommerceProductFilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductFilesRoute
 * @description Baasic Product Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Product Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(5);
var CommerceProductFilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductFilesRoute, _super);
    function CommerceProductFilesRoute(productFilesStreamsRoute, productFilesBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.productFilesStreamsRoute = productFilesStreamsRoute;
        _this.productFilesBatchRoute = productFilesBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/product-files/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/product-files/{id}/{?embed,fields}';
        _this.linkRoute = 'commerce/product-files/link';
        _this.unlinkRoute = 'commerce/product-files/unlink/{id}';
        _this.updateRoute = 'commerce/product-files/{id}';
        return _this;
    }
    Object.defineProperty(CommerceProductFilesRoute.prototype, "streams", {
        get: function () {
            return this.productFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceProductFilesRoute.prototype, "batch", {
        get: function () {
            return this.productFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example ommerceProductFilesRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceProductFilesRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param id Product file id which uniquely identifies product resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example ommerceProductFilesRoute.get({id: '<file-id>'});
     **/
    CommerceProductFilesRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @example commerceProductFilesRoute.link();
     **/
    CommerceProductFilesRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @example CommerceProductFilesRoute.unlink(data);
     **/
    CommerceProductFilesRoute.prototype.unlink = function (data, options) {
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data, options, 'unlink');
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example ommerceProductFilesRoute.update(data);
     **/
    CommerceProductFilesRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b, _c;
    CommerceProductFilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductFilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CommerceProductFilesBatchRoute)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductFilesStreamsRoute !== "undefined" && _1.CommerceProductFilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.CommerceProductFilesBatchRoute !== "undefined" && _1.CommerceProductFilesBatchRoute) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _c : Object])
    ], CommerceProductFilesRoute);
    return CommerceProductFilesRoute;
}(common_1.BaseRoute));
exports.CommerceProductFilesRoute = CommerceProductFilesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductFilesClient
 * @description  Files Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(5);
var CommerceProductFilesClient = /** @class */ (function () {
    function CommerceProductFilesClient(productFilesRoute, productFilesStreamsClient, productFilesBatchClient, apiClient) {
        this.productFilesRoute = productFilesRoute;
        this.productFilesStreamsClient = productFilesStreamsClient;
        this.productFilesBatchClient = productFilesBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductFilesClient.prototype, "routeDefinition", {
        get: function () {
            return this.productFilesRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceProductFilesClient.prototype, "streams", {
        get: function () {
            return this.productFilesStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceProductFilesClient.prototype, "batch", {
        get: function () {
            return this.productFilesBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of file resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example productFilesClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    CommerceProductFilesClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested file resource.
     * @method
     * @param id Product file id which uniquely identifies product resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example productFilesClient.get('<file-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    CommerceProductFilesClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.productFilesRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove one or many file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicProductFilesRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink').href;
     * ```
     * @method
     * @param data Product file object.
     * @param options options object.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action. The following action will remove the original file resource and all accompanying derived file resources.
                    productFilesRoute.remove(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    CommerceProductFilesClient.prototype.unlink = function (data, options) {
        if (!options) {
            options = {};
        }
        return this.apiClient.delete(this.productFilesRoute.unlink(data, options));
    };
    /**
     * Returns a promise that is resolved once the update file action has been performed; this action will update a file resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicProductFilesRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     ```
     let params = modelMapper.updateParams(fileEntry);
     let uri = params['model'].links('put').href;
     ```
     * @method
     * @param data Product file object that need to be updated in the system.
     * @returns A promise that is resolved once the update file action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                   fileEntry.description = '<description>';
                   productFilesClient.update(fileEntry)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    CommerceProductFilesClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.update(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resource from other modules into the Product Files module (For example: file resources from the Media Vault module can be linked directly into the Product Files module).
     * @method
     * @param data Product file object.
     * @returns A promise that is resolved once the link action has been performed.
     * @example productFilesClient.link(fileObject)
                    .then(function (response, status, headers, config) {
                        // perform success handling here
                    },
                        function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductFilesClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c, _d;
    CommerceProductFilesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductFilesRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CommerceProductFilesStreamsClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.CommerceProductFilesBatchClient)),
        tslib_1.__param(3, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductFilesRoute !== "undefined" && _1.CommerceProductFilesRoute) === "function" ? _a : Object, typeof (_b = typeof _1.CommerceProductFilesStreamsClient !== "undefined" && _1.CommerceProductFilesStreamsClient) === "function" ? _b : Object, typeof (_c = typeof _1.CommerceProductFilesBatchClient !== "undefined" && _1.CommerceProductFilesBatchClient) === "function" ? _c : Object, typeof (_d = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _d : Object])
    ], CommerceProductFilesClient);
    return CommerceProductFilesClient;
}());
exports.CommerceProductFilesClient = CommerceProductFilesClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
* @module commerceProductSettingsRoute
* @description Baasic Product Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic product Settings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceProductSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductSettingsRoute, _super);
    function CommerceProductSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'commerce/product-settings/{?embed,fields}';
        _this.updateRoute = 'commerce/product-settings/{id}';
        return _this;
    }
    /**
     * Parses get product settings route; this URI template doesn't expose any additional properties.
     * @method
     * @param options Options object that contains embed data.
     * @example productSettingsRoute.get(options);
     **/
    CommerceProductSettingsRoute.prototype.get = function (options) {
        return _super.prototype.baseGet.call(this, this.getRoute, undefined, options);
    };
    /**
     * Parses update product settings route; this URI template doesn't expose any additional properties.
     * @method
     * @param options Options object that contains embed data.
     * @example productSettingsRoute.update(data);
     **/
    CommerceProductSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    CommerceProductSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceProductSettingsRoute);
    return CommerceProductSettingsRoute;
}(common_1.BaseRoute));
exports.CommerceProductSettingsRoute = CommerceProductSettingsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 530 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductSettingsClient
 * @description  Product Settings Client provides an easy way to consume  Product Settings REST API end-points. In order to obtain needed routes `productSettingsClient` uses `productSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(5);
var CommerceProductSettingsClient = /** @class */ (function () {
    function CommerceProductSettingsClient(productSettingsRoute, apiClient) {
        this.productSettingsRoute = productSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductSettingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `baasicProductSettingsRouteService`.
         * @method
         * @example productSettingsClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.productSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the product settings.
     * @method
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example productSettingsClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductSettingsClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update product settings action has been performed; this action updates product settings. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `productSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(productSettings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the update product settings action has been performed.
     * @example // productSettings is a resource previously fetched using get action.
                    productSettings.allowArchive = true;
                    productSettingsClient.update(productSettings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    CommerceProductSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.update(data));
    };
    var _a, _b;
    CommerceProductSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductSettingsRoute !== "undefined" && _1.CommerceProductSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceProductSettingsClient);
    return CommerceProductSettingsClient;
}());
exports.CommerceProductSettingsClient = CommerceProductSettingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(532), exports);
tslib_1.__exportStar(__webpack_require__(533), exports);
tslib_1.__exportStar(__webpack_require__(534), exports);
tslib_1.__exportStar(__webpack_require__(535), exports);


/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductInstanceFilesBatchRoute
 * @description Baasic Product Instance Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Product Files Batch Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CommerceProductInstanceFilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductInstanceFilesBatchRoute, _super);
    function CommerceProductInstanceFilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.unlinkRoute = 'products/{productId}/files/batch/unlink';
        _this.updateRoute = 'products/{productId}/files/batch';
        _this.linkRoute = 'products/{productId}/files/batch/link';
        return _this;
    }
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param productId Product file id of the original product file used to identify product files on which delete action should be performed.
     * @example productInstanceFilesBatchRoute.unlink(productId);
     **/
    CommerceProductInstanceFilesBatchRoute.prototype.unlink = function (productId) {
        var params = { productId: productId };
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param productId Product id which uniquely identifies product whose product file need to be updated.
     * @example productInstanceFilesStreamsRoute.update(productId);
     **/
    CommerceProductInstanceFilesBatchRoute.prototype.update = function (productId) {
        var params = { productId: productId };
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param productId Product slug or id which uniquely identifies product whose product files need to be linked.
     * @example productInstanceFilesStreamsRoute.link(productId);
     **/
    CommerceProductInstanceFilesBatchRoute.prototype.link = function (productId) {
        var params = { productId: productId };
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    var _a;
    CommerceProductInstanceFilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceProductInstanceFilesBatchRoute);
    return CommerceProductInstanceFilesBatchRoute;
}(common_1.BaseRoute));
exports.CommerceProductInstanceFilesBatchRoute = CommerceProductInstanceFilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductInstanceFilesBatchClient
 * @description  Product Instance Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(5);
var CommerceProductInstanceFilesBatchClient = /** @class */ (function () {
    function CommerceProductInstanceFilesBatchClient(productInstanceFilesBatchRoute, apiClient) {
        this.productInstanceFilesBatchRoute = productInstanceFilesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductInstanceFilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.productInstanceFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param productId Product file id of the original product file used to identify product files on which delete action should be performed.
     * @param data Collection of product delete requests which uniquely identifies product files that need to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                   productInstanceFilesBatchClient.unlink([{ id: '<file-id>' }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    CommerceProductInstanceFilesBatchClient.prototype.unlink = function (productId, data) {
        return this.apiClient.delete(this.productInstanceFilesBatchRoute.unlink(productId), undefined, data);
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param productId Product id which uniquely identifies product whose product file need to be updated.
     * @param data Product file object that need to be updated in the system.
     * @returns A promise that is resolved once the update action has been performed.
     * @example productInstanceFilesBatchClient.update('<product-id>', files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductInstanceFilesBatchClient.prototype.update = function (productId, data) {
        return this.apiClient.put(this.routeDefinition.update(productId), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param productId Product slug or id which uniquely identifies product whose product files need to be linked.
     * @param data A collection of product file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example productInstanceFilesBatchClient.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductInstanceFilesBatchClient.prototype.link = function (productId, data) {
        return this.apiClient.post(this.routeDefinition.link(productId), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    CommerceProductInstanceFilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CommerceProductInstanceFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CommerceProductInstanceFilesBatchRoute !== "undefined" && _1.CommerceProductInstanceFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceProductInstanceFilesBatchClient);
    return CommerceProductInstanceFilesBatchClient;
}());
exports.CommerceProductInstanceFilesBatchClient = CommerceProductInstanceFilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductInstanceFilesRoute
 * @description Baasic Product Instance Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Product Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var __1 = __webpack_require__(5);
var CommerceProductInstanceFilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceProductInstanceFilesRoute, _super);
    function CommerceProductInstanceFilesRoute(productInstanceFilesBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.productInstanceFilesBatchRoute = productInstanceFilesBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'products/{productId}/files/{?searchQuery,ids,from,to,page,rpp,sort,embed,fields}';
        _this.getRoute = 'products/{productId}/files/{id}/{?embed,fields}';
        _this.linkRoute = 'products/{productId}/files/link';
        _this.unlinkRoute = 'products/{productId}/files/unlink/{id}';
        _this.unlinkByProductRoute = 'products/{productId}/files/unlink';
        _this.updateRoute = 'products/{productId}/files/{id}';
        return _this;
    }
    Object.defineProperty(CommerceProductInstanceFilesRoute.prototype, "batch", {
        get: function () {
            return this.productInstanceFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param productId Product slug or id which uniquely identifies product whose product files need to be retrieved.
     * @param options Query resource options object.
     * @example productInstanceFilesRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceProductInstanceFilesRoute.prototype.find = function (productId, options) {
        var params = this.modelMapper.findParams(options);
        params.productId = productId;
        return _super.prototype.baseGet.call(this, this.findRoute, params);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param productId Product id which uniquely identifies product whose product files need to be retrieved.
     * @param id Product file id which uniquely identifies product file that needs to be retrieved.
     * @param options options object that contains embed data.
     * @example productInstanceFilesRoute.get({id: '<file-id>'});
     **/
    CommerceProductInstanceFilesRoute.prototype.get = function (productId, id, options) {
        var params = this.utility.extend({}, options);
        params.productId = productId;
        params.id = id;
        return _super.prototype.baseGet.call(this, this.getRoute, params);
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @param productId Product id which uniquely identifies product whose product files need to be deleted.
     * @param data
     * @param options
     * @example productInstanceFilesRoute.link();
     **/
    CommerceProductInstanceFilesRoute.prototype.link = function (productId, data) {
        var params = this.utility.extend({}, data);
        params.productId = productId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @param productId Product id which uniquely identifies gallery whose gallery files need to be deleted.
     * @param data
     * @param options
     * @example productFilesRoute.unlink(data);
     **/
    CommerceProductInstanceFilesRoute.prototype.unlink = function (productId, data, options) {
        if (!options) {
            options = {};
        }
        var params = this.modelMapper.removeParams(data);
        params.productId = productId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params, options, 'unlink');
    };
    /**
     * Parses unlink by Product route; this URI template does not expose any additional options.
     * @method
     * @param productId Product id which uniquely identifies product whose product files need to be deleted.
     * @param data
     * @param options
     * @example productFilesRoute.unlinkByProduct(data);
     **/
    CommerceProductInstanceFilesRoute.prototype.unlinkByProduct = function (productId, options) {
        return _super.prototype.baseDelete.call(this, this.unlinkByProductRoute, productId, options, 'unlink-by-product');
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example productInstanceFilesRoute.update(data);
     **/
    CommerceProductInstanceFilesRoute.prototype.update = function (productId, data) {
        var params = this.modelMapper.updateParams(data);
        params.productId = productId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    var _a, _b;
    CommerceProductInstanceFilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceProductInstanceFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceProductInstanceFilesBatchRoute !== "undefined" && __1.CommerceProductInstanceFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], CommerceProductInstanceFilesRoute);
    return CommerceProductInstanceFilesRoute;
}(common_1.BaseRoute));
exports.CommerceProductInstanceFilesRoute = CommerceProductInstanceFilesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceProductInstanceFilesClient
 * @description  Product Instance Files Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceProductInstanceFilesClient = /** @class */ (function () {
    function CommerceProductInstanceFilesClient(ProductInstanceFilesRoute, ProductInstanceFilesBatchClient, apiClient) {
        this.ProductInstanceFilesRoute = ProductInstanceFilesRoute;
        this.ProductInstanceFilesBatchClient = ProductInstanceFilesBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceProductInstanceFilesClient.prototype, "routeDefinition", {
        get: function () {
            return this.ProductInstanceFilesRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CommerceProductInstanceFilesClient.prototype, "batch", {
        get: function () {
            return this.ProductInstanceFilesBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of file resources matching the given criteria.
     * @method
     * @param productId Productslug or id which uniquely identifies product whose product files need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example productInstanceFilesClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    ids: '1,2,3',
                    from: '',
                    to: '',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    CommerceProductInstanceFilesClient.prototype.find = function (productId, options) {
        return this.apiClient.get(this.ProductInstanceFilesRoute.find(productId, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested file resource.
     * @method
     * @param productId Product slug or id which uniquely identifies product whose product files need to be retrieved.
     * @param id Productfile id which uniquely identifies product file that needs to be retrieved.
     * @param options options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example productInstanceFilesClient.get('<file-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    CommerceProductInstanceFilesClient.prototype.get = function (productId, id, options) {
        return this.apiClient.get(this.ProductInstanceFilesRoute.get(productId, id, options));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove one or many file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicProductFilesRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink').href;
     * ```
     * @method
     * @param productId Product slug or id which uniquely identifies product whose product files need to be deleted.
     * @param data
     * @param options
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action. The following action will unlink the original file resource and all accompanying derived file resources.
                    productInstanceFilesClient.unlink(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    CommerceProductInstanceFilesClient.prototype.unlink = function (productId, data, options) {
        return this.apiClient.delete(this.ProductInstanceFilesRoute.unlink(productId, data, options));
    };
    /**
     * Returns a promise that is resolved once the unlink by product action has been performed. This action will remove all file resources from the system related to the requested Product if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicProductService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink-by-product').href;
     * ```
     * @method
     * @param productId Productslug or id which uniquely identifies product whose product files need to be deleted.
     * @param data
     * @param options
     * @returns A promise that is resolved once the unlink by product action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                    productInstanceFilesClient.unlinkByProduct(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceProductInstanceFilesClient.prototype.unlinkByProduct = function (productId, options) {
        return this.apiClient.delete(this.ProductInstanceFilesRoute.unlinkByProduct(productId, options));
    };
    /**
     * Returns a promise that is resolved once the update file action has been performed; this action will update a file resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicProductFilesRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     ```
     let params = modelMapper.updateParams(fileEntry);
     let uri = params['model'].links('put').href;
     ```
     * @method
     * @param productId An Product object used to update specified product resource.
     * @param data ProductFile object used to update specific product file data in the system.
     * @returns A promise that is resolved once the update file action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                   fileEntry.description = '<description>';
                   ProductInstanceFilesClient.update(fileEntry)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    CommerceProductInstanceFilesClient.prototype.update = function (productId, data) {
        return this.apiClient.put(this.routeDefinition.update(productId, data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resource from other modules into the ProductFiles module (For example: file resources from the Media Vault module can be linked directly into the ProductFiles module).
     * @method
     * @param productId Product id which uniquely identifies product whose product files need to be linked.
     * @param data A Product file object that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example ProductInstanceFilesClient.link(fileObject)
                    .then(function (response, status, headers, config) {
                        // perform success handling here
                    },
                        function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    CommerceProductInstanceFilesClient.prototype.link = function (productId, data) {
        return this.apiClient.post(this.routeDefinition.link(productId, data), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c;
    CommerceProductInstanceFilesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceProductInstanceFilesRoute)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CommerceProductInstanceFilesBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceProductInstanceFilesRoute !== "undefined" && __1.CommerceProductInstanceFilesRoute) === "function" ? _a : Object, typeof (_b = typeof __1.CommerceProductInstanceFilesBatchClient !== "undefined" && __1.CommerceProductInstanceFilesBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CommerceProductInstanceFilesClient);
    return CommerceProductInstanceFilesClient;
}());
exports.CommerceProductInstanceFilesClient = CommerceProductInstanceFilesClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(537), exports);
tslib_1.__exportStar(__webpack_require__(538), exports);


/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCouponRoute
 * @description Baasic Commerce Coupon Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Coupon Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceCouponRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceCouponRoute, _super);
    function CommerceCouponRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/coupons/{?searchQuery,page,rpp,sort,embed,fields,productId,productCategoryId,active}';
        _this.getRoute = 'commerce/coupons/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/coupons';
        _this.updateRoute = 'commerce/coupons/{id}';
        _this.deleteRoute = 'commerce/coupons/{id}';
        _this.findCouponUseRoute = 'commerce/coupons/{id}/uses/{?embed,fields}';
        return _this;
    }
    /**
     * Parses find commerce coupon route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `productId` - A product id.
     * - `productCategoryId` - A product category id.
     * - `active` - flag is coupon active or not
     * @method
     * @example commerceCouponRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceCouponRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceCouponRoute.get(id, options);
     **/
    CommerceCouponRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce coupon route; this URI template does not expose any additional options.
     * @method
     * @example commerceCouponRoute.create();
     **/
    CommerceCouponRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce coupon route; this URI template does not expose any additional options.
     * @method
     * @example commerceCouponRoute.update(data);
     **/
    CommerceCouponRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete commerce coupon route; this URI template does not expose any additional options.
    * @method
    * @example commerceCouponRoute.delete(data);
    **/
    CommerceCouponRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses find route; this route doesn't expose any properties.
     * @method
     * @example commerceCouponRoute.findCouponUses(couponId, options);
     **/
    CommerceCouponRoute.prototype.findCouponUses = function (couponId, options) {
        return _super.prototype.baseGet.call(this, this.findCouponUseRoute, couponId, options);
    };
    var _a;
    CommerceCouponRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceCouponRoute);
    return CommerceCouponRoute;
}(common_1.BaseRoute));
exports.CommerceCouponRoute = CommerceCouponRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCouponClient
 * @description  Commerce Coupon Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCouponClient` uses `commerceCouponRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceCouponClient = /** @class */ (function () {
    function CommerceCouponClient(commerceCouponRoute, apiClient) {
        this.commerceCouponRoute = commerceCouponRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceCouponClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceCouponRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceCouponClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>',
                   couponCategoryId : '',
                   categoryAbrv: ''
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    **/
    CommerceCouponClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceCouponClient.get()
                      .then(function (data) {
                          // perform success action here
                      },
                       function (response, status, headers, config) {
                           // perform error handling here
                      });
   **/
    CommerceCouponClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceCouponRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceCouponClient.create({
                    name : '<coupon-name>',
                    slug : '<slug>',
                    shortDescription : '<short-description>',
                    recurringCyclePeriodTypeId: '<recurring-cycle-period-type-id>'
                    planId : '<plan-id>',
                    price: 100,
                    published: true
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceCouponClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceCouponRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCoupon);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceCoupon is a resource previously fetched using get action.
                        commerceCoupon.shortDescription : '<short-description>';
                        commerceCouponClient.update(commerceCoupon)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceCouponClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceCouponRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCoupon);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceCoupon is a resource previously fetched using get action.
                    commerceCouponClient.remove(commerceCoupon)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceCouponClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /* Coupon Uses per Coupon */
    /**
 * Returns a promise that is resolved once the get action has been performed. Success response returns the coupon uses per coupon resource.
 * @method
 * @example commerceCouponClient.findCouponUses()
                  .then(function (data) {
                      // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                  });
**/
    CommerceCouponClient.prototype.findCouponUses = function (couponId, options) {
        return this.apiClient.get(this.routeDefinition.findCouponUses(couponId, options));
    };
    var _a, _b;
    CommerceCouponClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceCouponRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceCouponRoute !== "undefined" && __1.CommerceCouponRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceCouponClient);
    return CommerceCouponClient;
}());
exports.CommerceCouponClient = CommerceCouponClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(540), exports);
tslib_1.__exportStar(__webpack_require__(541), exports);


/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCouponUseRoute
 * @description Baasic Commerce Coupon Use Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Coupon Use Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CommerceCouponUseRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceCouponUseRoute, _super);
    function CommerceCouponUseRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/coupon-uses/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/coupon-uses/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/coupon-uses';
        _this.updateRoute = 'commerce/coupon-uses/{id}';
        _this.deleteRoute = 'commerce/coupon-uses/{id}';
        return _this;
    }
    /**
     * Parses find commerce coupon route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceCouponUseRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceCouponUseRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceCouponUseRoute.get(id, options);
     **/
    CommerceCouponUseRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce coupon route; this URI template does not expose any additional options.
     * @method
     * @example commerceCouponUseRoute.create();
     **/
    CommerceCouponUseRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce coupon route; this URI template does not expose any additional options.
     * @method
     * @example commerceCouponUseRoute.update(data);
     **/
    CommerceCouponUseRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete commerce coupon route; this URI template does not expose any additional options.
    * @method
    * @example commerceCouponUseRoute.delete(data);
    **/
    CommerceCouponUseRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    CommerceCouponUseRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceCouponUseRoute);
    return CommerceCouponUseRoute;
}(common_1.BaseRoute));
exports.CommerceCouponUseRoute = CommerceCouponUseRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceCouponUseClient
 * @description  Commerce Coupon Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceCouponUseClient` uses `commerceCouponRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceCouponUseClient = /** @class */ (function () {
    function CommerceCouponUseClient(commerceCouponUseRoute, apiClient) {
        this.commerceCouponUseRoute = commerceCouponUseRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceCouponUseClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceCouponUseRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceCouponUseClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>',
                   couponCategoryId : '',
                   categoryAbrv: ''
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    **/
    CommerceCouponUseClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceCouponUseClient.get()
                      .then(function (data) {
                          // perform success action here
                      },
                       function (response, status, headers, config) {
                           // perform error handling here
                      });
   **/
    CommerceCouponUseClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceCouponUseClient.create({
                    name : '<coupon-name>',
                    slug : '<slug>',
                    shortDescription : '<short-description>',
                    recurringCyclePeriodTypeId: '<recurring-cycle-period-type-id>'
                    planId : '<plan-id>',
                    price: 100,
                    published: true
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceCouponUseClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceCouponRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCoupon);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceCoupon is a resource previously fetched using get action.
                        commerceCoupon.shortDescription : '<short-description>';
                        commerceCouponUseClient.update(commerceCoupon)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceCouponUseClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceCouponRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceCoupon);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceCoupon is a resource previously fetched using get action.
                    commerceCouponUseClient.remove(commerceCoupon)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceCouponUseClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    CommerceCouponUseClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceCouponUseRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceCouponUseRoute !== "undefined" && __1.CommerceCouponUseRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceCouponUseClient);
    return CommerceCouponUseClient;
}());
exports.CommerceCouponUseClient = CommerceCouponUseClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(543), exports);
tslib_1.__exportStar(__webpack_require__(544), exports);
tslib_1.__exportStar(__webpack_require__(545), exports);
tslib_1.__exportStar(__webpack_require__(546), exports);
tslib_1.__exportStar(__webpack_require__(547), exports);
tslib_1.__exportStar(__webpack_require__(548), exports);


/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(550), exports);
tslib_1.__exportStar(__webpack_require__(551), exports);


/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceAddOnRoute
 * @description Baasic Commerce AddOn Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Commerce Product Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
//import {IProductOptions} from '../contracts';
var CommerceAddOnRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CommerceAddOnRoute, _super);
    function CommerceAddOnRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'commerce/addons/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/addons/{id}/{?embed,fields}';
        _this.createRoute = 'commerce/addons';
        _this.updateRoute = 'commerce/addons/{id}';
        _this.deleteRoute = 'commerce/addons/{id}';
        return _this;
    }
    /**
     * Parses find commerce AddOn route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify commerce resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain commerce subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the commerce property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example commerceAddOnRoute.find({searchQuery: '<search-phrase>'});
     **/
    CommerceAddOnRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @example commerceAddOnRoute.get(id, options);
     **/
    CommerceAddOnRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create commerce product route; this URI template does not expose any additional options.
     * @method
     * @example commerceAddOnRoute.create();
     **/
    CommerceAddOnRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update commerce product route; this URI template does not expose any additional options.
     * @method
     * @example commerceAddOnRoute.update(data);
     **/
    CommerceAddOnRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses delete commerce product route; this URI template does not expose any additional options.
    * @method
    * @example commerceAddOnRoute.delete(data);
    **/
    CommerceAddOnRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    CommerceAddOnRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CommerceAddOnRoute);
    return CommerceAddOnRoute;
}(common_1.BaseRoute));
exports.CommerceAddOnRoute = CommerceAddOnRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module commerceAddOnClient
 * @description  Commerce Product Client provides an easy way to consume  Commerce REST API end-points. In order to obtain a needed routes `commerceProductClient` uses `commerceProductRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(5);
var CommerceAddOnClient = /** @class */ (function () {
    function CommerceAddOnClient(commerceAddOnRoute, apiClient) {
        this.commerceAddOnRoute = commerceAddOnRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CommerceAddOnClient.prototype, "routeDefinition", {
        get: function () {
            return this.commerceAddOnRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of commerce resources matching the given criteria.
     * @method
     * @example commerceAddOnClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>',
                   productCategoryId : '',
                   productCategoryAbrv: ''
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    **/
    CommerceAddOnClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the commerce resource.
     * @method
     * @example commerceAddOnClient.get()
                      .then(function (data) {
                          // perform success action here
                      },
                       function (response, status, headers, config) {
                           // perform error handling here
                      });
   **/
    CommerceAddOnClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.commerceAddOnRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create commerce action has been performed; this action creates a new commerce resource.
     * @method
     * @example commerceAddOnClient.create({
                    name : '<product-name>',
                    slug : '<slug>',
                    shortDescription : '<short-description>',
                    recurringCyclePeriodTypeId: '<recurring-cycle-period-type-id>'
                    planId : '<plan-id>',
                    price: 100,
                    published: true
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CommerceAddOnClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update commerce action has been performed; this action updates a commerce resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceProductRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceProduct);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @example // commerceProduct is a resource previously fetched using get action.
                        commerceProduct.shortDescription : '<short-description>';
                        commerceAddOnClient.update(commerceProduct)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    CommerceAddOnClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a commerce resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `commerceProductRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(commerceProduct);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // commerceProduct is a resource previously fetched using get action.
                    commerceAddOnClient.remove(commerceProduct)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CommerceAddOnClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    CommerceAddOnClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CommerceAddOnRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CommerceAddOnRoute !== "undefined" && __1.CommerceAddOnRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CommerceAddOnClient);
    return CommerceAddOnClient;
}());
exports.CommerceAddOnClient = CommerceAddOnClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(7);
var TYPES = {
    CalendarLookups: Symbol("CalendarLookups"),
    CalendarACLClient: Symbol("CalendarACLClient"),
    CalendarACLRoute: Symbol("CalendarACLRoute"),
    CalendarEventRsvpAttendeeBatchClient: Symbol("CalendarEventRsvpAttendeeBatchClient"),
    CalendarEventRsvpAttendeeBatchRoute: Symbol("CalendarEventRsvpAttendeeBatchRoute"),
    CalendarEventRsvpAttendeeClient: Symbol("CalendarEventRsvpAttendeeClient"),
    CalendarEventRsvpAttendeeRoute: Symbol("CalendarEventRsvpAttendeeRoute"),
    CalendarRsvpAttendeeBatchClient: Symbol("CalendarRsvpAttendeeBatchClient"),
    CalendarRsvpAttendeeBatchRoute: Symbol("CalendarRsvpAttendeeBatchRoute"),
    CalendarRsvpAttendeeClient: Symbol("CalendarRsvpAttendeeClient"),
    CalendarRsvpAttendeeRoute: Symbol("CalendarRsvpAttendeeRoute"),
    CalendarEventsClient: Symbol("CalendarEventsClient"),
    CalendarEventsRoute: Symbol("CalendarEventsRoute"),
    CalendarBatchClient: Symbol("CalendarBatchClient"),
    CalendarBatchRoute: Symbol("CalendarBatchRoute"),
    CalendarClient: Symbol("CalendarClient"),
    CalendarRoute: Symbol("CalendarRoute"),
    CalendarRsvpBatchClient: Symbol("CalendarRsvpBatchClient"),
    CalendarRsvpBatchRoute: Symbol("CalendarRsvpBatchRoute"),
    CalendarRsvpClient: Symbol("CalendarRsvpClient"),
    CalendarRsvpRoute: Symbol("CalendarRsvpRoute"),
    CalendarEventBatchClient: Symbol("CalendarEventBatchClient"),
    CalendarEventBatchRoute: Symbol("CalendarEventBatchRoute"),
    CalendarEventClient: Symbol("CalendarEventClient"),
    CalendarEventRoute: Symbol("CalendarEventRoute"),
    CalendarEventRsvpBatchClient: Symbol("CalendarEventRsvpBatchClient"),
    CalendarEventRsvpBatchRoute: Symbol("CalendarEventRsvpBatchRoute"),
    CalendarEventRsvpClient: Symbol("CalendarEventRsvpClient"),
    CalendarEventRsvpRoute: Symbol("CalendarEventRsvpRoute"),
    CalendarEventRsvpInvitationTypeBatchClient: Symbol("CalendarEventRsvpInvitationTypeBatchClient"),
    CalendarEventRsvpInvitationTypeBatchRoute: Symbol("CalendarEventRsvpInvitationTypeBatchRoute"),
    CalendarEventRsvpInvitationTypeClient: Symbol("CalendarEventRsvpInvitationTypeClient"),
    CalendarEventRsvpInvitationTypeRoute: Symbol("CalendarEventRsvpInvitationTypeRoute"),
    CalendarEventRsvpAttendeeStatusBatchClient: Symbol("CalendarEventRsvpAttendeeStatusBatchClient"),
    CalendarEventRsvpAttendeeStatusBatchRoute: Symbol("CalendarEventRsvpAttendeeStatusBatchRoute"),
    CalendarEventRsvpAttendeeStatusClient: Symbol("CalendarEventRsvpAttendeeStatusClient"),
    CalendarEventRsvpAttendeeStatusRoute: Symbol("CalendarEventRsvpAttendeeStatusRoute"),
    CalendarEventStatusBatchClient: Symbol("CalendarEventStatusBatchClient"),
    CalendarEventStatusBatchRoute: Symbol("CalendarEventStatusBatchRoute"),
    CalendarEventStatusClient: Symbol("CalendarEventStatusClient"),
    CalendarEventStatusRoute: Symbol("CalendarEventStatusRoute"),
    CalendarEventTypeBatchClient: Symbol("CalendarEventTypeBatchClient"),
    CalendarEventTypeBatchRoute: Symbol("CalendarEventTypeBatchRoute"),
    CalendarEventTypeClient: Symbol("CalendarEventTypeClient"),
    CalendarEventTypeRoute: Symbol("CalendarEventTypeRoute"),
    Root: Symbol("Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.CalendarLookups).to(_1.CalendarLookups);
    bind(TYPES.CalendarACLRoute).to(_1.CalendarACLRoute);
    bind(TYPES.CalendarACLClient).to(_1.CalendarACLClient);
    bind(TYPES.CalendarEventRsvpAttendeeBatchClient).to(_1.CalendarEventRsvpAttendeeBatchClient);
    bind(TYPES.CalendarEventRsvpAttendeeBatchRoute).to(_1.CalendarEventRsvpAttendeeBatchRoute);
    bind(TYPES.CalendarEventRsvpAttendeeClient).to(_1.CalendarEventRsvpAttendeeClient);
    bind(TYPES.CalendarEventRsvpAttendeeRoute).to(_1.CalendarEventRsvpAttendeeRoute);
    bind(TYPES.CalendarRsvpAttendeeBatchClient).to(_1.CalendarRsvpAttendeeBatchClient);
    bind(TYPES.CalendarRsvpAttendeeBatchRoute).to(_1.CalendarRsvpAttendeeBatchRoute);
    bind(TYPES.CalendarRsvpAttendeeClient).to(_1.CalendarRsvpAttendeeClient);
    bind(TYPES.CalendarRsvpAttendeeRoute).to(_1.CalendarRsvpAttendeeRoute);
    bind(TYPES.CalendarEventsClient).to(_1.CalendarEventsClient);
    bind(TYPES.CalendarEventsRoute).to(_1.CalendarEventsRoute);
    bind(TYPES.CalendarBatchClient).to(_1.CalendarBatchClient);
    bind(TYPES.CalendarBatchRoute).to(_1.CalendarBatchRoute);
    bind(TYPES.CalendarClient).to(_1.CalendarClient);
    bind(TYPES.CalendarRoute).to(_1.CalendarRoute);
    bind(TYPES.CalendarRsvpBatchClient).to(_1.CalendarRsvpBatchClient);
    bind(TYPES.CalendarRsvpBatchRoute).to(_1.CalendarRsvpBatchRoute);
    bind(TYPES.CalendarRsvpClient).to(_1.CalendarRsvpClient);
    bind(TYPES.CalendarRsvpRoute).to(_1.CalendarRsvpRoute);
    bind(TYPES.CalendarEventBatchRoute).to(_1.CalendarEventBatchRoute);
    bind(TYPES.CalendarEventBatchClient).to(_1.CalendarEventBatchClient);
    bind(TYPES.CalendarEventRoute).to(_1.CalendarEventRoute);
    bind(TYPES.CalendarEventClient).to(_1.CalendarEventClient);
    bind(TYPES.CalendarEventRsvpAttendeeStatusBatchClient).to(_1.CalendarEventRsvpAttendeeStatusBatchClient);
    bind(TYPES.CalendarEventRsvpAttendeeStatusBatchRoute).to(_1.CalendarEventRsvpAttendeeStatusBatchRoute);
    bind(TYPES.CalendarEventRsvpAttendeeStatusClient).to(_1.CalendarEventRsvpAttendeeStatusClient);
    bind(TYPES.CalendarEventRsvpAttendeeStatusRoute).to(_1.CalendarEventRsvpAttendeeStatusRoute);
    bind(TYPES.CalendarEventRsvpBatchClient).to(_1.CalendarEventRsvpBatchClient);
    bind(TYPES.CalendarEventRsvpBatchRoute).to(_1.CalendarEventRsvpBatchRoute);
    bind(TYPES.CalendarEventRsvpClient).to(_1.CalendarEventRsvpClient);
    bind(TYPES.CalendarEventRsvpRoute).to(_1.CalendarEventRsvpRoute);
    bind(TYPES.CalendarEventRsvpInvitationTypeBatchClient).to(_1.CalendarEventRsvpInvitationTypeBatchClient);
    bind(TYPES.CalendarEventRsvpInvitationTypeBatchRoute).to(_1.CalendarEventRsvpInvitationTypeBatchRoute);
    bind(TYPES.CalendarEventRsvpInvitationTypeClient).to(_1.CalendarEventRsvpInvitationTypeClient);
    bind(TYPES.CalendarEventRsvpInvitationTypeRoute).to(_1.CalendarEventRsvpInvitationTypeRoute);
    bind(TYPES.CalendarEventStatusBatchClient).to(_1.CalendarEventStatusBatchClient);
    bind(TYPES.CalendarEventStatusBatchRoute).to(_1.CalendarEventStatusBatchRoute);
    bind(TYPES.CalendarEventStatusClient).to(_1.CalendarEventStatusClient);
    bind(TYPES.CalendarEventStatusRoute).to(_1.CalendarEventStatusRoute);
    bind(TYPES.CalendarEventTypeBatchClient).to(_1.CalendarEventTypeBatchClient);
    bind(TYPES.CalendarEventTypeBatchRoute).to(_1.CalendarEventTypeBatchRoute);
    bind(TYPES.CalendarEventTypeClient).to(_1.CalendarEventTypeClient);
    bind(TYPES.CalendarEventTypeRoute).to(_1.CalendarEventTypeRoute);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;


/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(554), exports);
tslib_1.__exportStar(__webpack_require__(555), exports);
tslib_1.__exportStar(__webpack_require__(556), exports);
tslib_1.__exportStar(__webpack_require__(557), exports);
tslib_1.__exportStar(__webpack_require__(558), exports);
tslib_1.__exportStar(__webpack_require__(559), exports);
tslib_1.__exportStar(__webpack_require__(560), exports);
tslib_1.__exportStar(__webpack_require__(561), exports);
tslib_1.__exportStar(__webpack_require__(562), exports);
tslib_1.__exportStar(__webpack_require__(570), exports);
tslib_1.__exportStar(__webpack_require__(575), exports);


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(563), exports);
tslib_1.__exportStar(__webpack_require__(564), exports);
tslib_1.__exportStar(__webpack_require__(565), exports);
tslib_1.__exportStar(__webpack_require__(566), exports);
tslib_1.__exportStar(__webpack_require__(567), exports);
tslib_1.__exportStar(__webpack_require__(568), exports);
tslib_1.__exportStar(__webpack_require__(569), exports);


/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(571), exports);
tslib_1.__exportStar(__webpack_require__(572), exports);
tslib_1.__exportStar(__webpack_require__(573), exports);
tslib_1.__exportStar(__webpack_require__(574), exports);


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(577), exports);
tslib_1.__exportStar(__webpack_require__(578), exports);


/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarACLClient
 * @description  Calendar ACL Client provides an easy way to consume Calendar REST API end-points. In order to obtain a needed routes `calendarACLClient` uses `calendarACLRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarACLClient = /** @class */ (function () {
    function CalendarACLClient(calendarACLRoute, apiClient) {
        this.calendarACLRoute = calendarACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified calendar resource.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarClient.get({id: '<id>'})
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed, this action creates new ACL policy for the specified calendar resource.
     * @method
     * @param options ACL options object.
     * @example let options = {id : '<id>'};
                let aclObj =  {  actionId: '<action-id'>,  roleId: '<roleId>',  userId: '<userId>' };
                options[baasicConstants.modelPropertyName] = aclObj;
                calendarACLClient.update(options)
                .then(function (data) {
                    // perform success action here
                },
                    function (response, status, headers, config) {
                        // perform error handling here
                });
     */
    CalendarACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and calendar resource.
     * @method
     * @param id User calendar data id which uniquely identifies user calendar data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user calendar data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @returns A promise that is resolved once the removeByUser action has been performed.
     * @example calendarACLClient.removeByUser('<id>', '<access-action>', '<username>')
                .then(function (data) {
                    // perform success action here
                },
                    function (response, status, headers, config) {
                        // perform error handling here
                });
     */
    CalendarACLClient.prototype.removeByUser = function (id, action, user, data) {
        return this.apiClient.delete(this.calendarACLRoute.deleteByUser(id, action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and calendar resource.
     * @method
     * @param id User calendar data id which uniquely identifies user calendar data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user calendar data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @returns A promise that is resolved once the removeByRole action has been performed.
     * @example calendarACLClient.removeByRole('<id>', '<access-action>', '<role-name>')
                .then(function (data) {
                    // perform success action here
                },
                    function (response, status, headers, config) {
                        // perform error handling here
                });
     */
    CalendarACLClient.prototype.removeByRole = function (id, action, role, data) {
        return this.apiClient.delete(this.calendarACLRoute.deleteByRole(id, action, role, data));
    };
    var _a, _b;
    CalendarACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarACLRoute !== "undefined" && __1.CalendarACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarACLClient);
    return CalendarACLClient;
}());
exports.CalendarACLClient = CalendarACLClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarACLRoute
 * @description Baasic Calendar ACL Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Calendar ACL Route Definition to obtain a needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarACLRoute, _super);
    function CalendarACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'calendars/{id}/acl';
        _this.updateRoute = 'calendars/{id}/acl';
        _this.deleteByUserRoute = 'calendars/{id}/acl/actions/{accessAction}/users/{userName}';
        _this.deleteByRoleRoute = 'calendars/{id}/acl/actions/{accessAction}/roles/{role}';
        return _this;
    }
    /**
     * Parses get calendar acl route; this URI template should be expanded with the Id of the calnedar.
     * @method
     * @param options ACL options object.
     * @example calendarACLRoute.get({id: '<id>'});
     */
    CalendarACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update calendar acl route; this URI template should be expanded with the Id of the calnedar.
     * @method
     * @param options ACL options object.
     * @example calendarACLRoute.update({id: '<id>'});
     */
    CalendarACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    /**
     * Parses deleteByUser calendar acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the user calnedar data resource.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and calendar resource.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param id user calnedar data id which uniquely identifies user calnedar data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user calnedar data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @example calendarACLRoute.deleteByUser({
                    id: '<id>',
                    accessAction: '<access-action>',
                    user: '<username>'
                });
     */
    CalendarACLRoute.prototype.deleteByUser = function (id, action, user, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.userName = user;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByUser calendar acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the calendar.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and calendar resource.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param id User calendar data id which uniquely identifies user calendar data resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user calendar data resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data ACL Policy object used to delete specified item in the system.
     * @example calendarACLRoute.deleteByRole({ id: '<id>', accessAction: '<access-action>', role: '<role-name>'});
     */
    CalendarACLRoute.prototype.deleteByRole = function (id, action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.id = id;
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    CalendarACLRoute.prototype.updateParams = function (data) {
        var params = this.utility.extend({}, data);
        return params[this.modelMapper.modelPropertyName];
    };
    var _a;
    CalendarACLRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarACLRoute);
    return CalendarACLRoute;
}(common_1.BaseRoute));
exports.CalendarACLRoute = CalendarACLRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
  - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
  - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
  - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(580), exports);
tslib_1.__exportStar(__webpack_require__(581), exports);
tslib_1.__exportStar(__webpack_require__(582), exports);
tslib_1.__exportStar(__webpack_require__(583), exports);


/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventBatchRoute
 * @description BaasicCalendarEventBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CalendarEventBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventBatchRoute, _super);
    function CalendarEventBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendar-events/batch';
        _this.updateRoute = 'calendar-events/batch';
        _this.deleteRoute = 'calendar-events/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventBatchRoute.create();
     */
    CalendarEventBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventBatchRoute.update();
     */
    CalendarEventBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventBatchRoute.delete();
     */
    CalendarEventBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarEventBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventBatchRoute);
    return CalendarEventBatchRoute;
}(common_1.BaseRoute));
exports.CalendarEventBatchRoute = CalendarEventBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventBatchClient
 * @description  CalendarEventBatchClient provides an easy way to consume CalendarEventBatch REST API end-points. In order to obtain needed routes `calendarEventBatchClient` uses `calendarEventBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventBatchClient = /** @class */ (function () {
    function CalendarEventBatchClient(calendarEventBatchRoute, apiClient) {
        this.calendarEventBatchRoute = calendarEventBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create CalendarEvents action has been performed. This action creates new CalendarEvent resources.
     * @method
     * @param data CalendarEvent objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEvents action has been performed.
     * @example calendarEventBatchClient.create([{
                    author: <user-info>,
                    authorId: '<author-id>',
                    calendar: <calendar>,
                    calendarId: '<calendar-id>',
                    description: '<description>',
                    detail: <calendar-event-detail>,
                    endTime: '<end-time>',
                    isAllDay: <true|false>,
                    isRecurring: <true|false>,
                    json: '<json>',
                    startTime: '<start-time>',
                    title: '<title'>
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEvents action has been performed; this action updates CalendarEvent resources.
     * @method
     * @param data CalendarEvent objects used to update specified CalendarEvent resources.
     * @returns A promise that is resolved once the update CalendarEvents action has been performed.
     * @example calendarEvents are resources previously fetched using get action.
                calendarEventBatchClient.update(calendarEvents)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove CalendarEvent resources from the system if successfully completed.
     * @method
     * @param data CalendarEvent Ids which uniquely identify CalendarEvent resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventIds are identifiers which uniquely identify CalendarEvent resources.
                calendarEventBatchClient.remove(calendarEventIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarEventBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventBatchRoute !== "undefined" && __1.CalendarEventBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarEventBatchClient);
    return CalendarEventBatchClient;
}());
exports.CalendarEventBatchClient = CalendarEventBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRoute
 * @description BaasicCalendarEventRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarEventRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRoute, _super);
    function CalendarEventRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendar-events/{?searchQuery,page,rpp,sort,embed,fields,ids,ownerIds,calendarIds,calendarNames,statusIds,typeIds,from,to}';
        _this.getRoute = 'calendar-events/{id}/{?embed,fields}';
        _this.getByEmailOrFullNameRoute = 'calendar-events/{id}/{emailOrFullName}';
        _this.createRoute = 'calendar-events';
        _this.updateRoute = 'calendar-events/{id}';
        _this.deleteRoute = 'calendar-events/{id}';
        _this.purgeRoute = 'calendar-events/{id}/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarEventOptions. Supported items are:
     * - `searchQuery` - A string referencing CalendarEvent properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEvent subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEvent property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `ids` - CalendarEvent ids which uniquely identify CalendarEvent resources that need to be retrieved.
     * - `ownerIds` - Owner ids which uniquely identify event owners used for filtering.
     * - `calendarIds` - Calendar ids which uniquely identify Calendar resources used for filtering.
     * - `calendarNames` - Calendar names which identify Calendar resources used for filtering.
     * - `statusIds` - CalendarEventStatus ids which uniquely idendify CalendarEventStatuses used for filtering.
     * - `typeIds` - CalendarEventType ids which uniquely identify CalendarEventTypes used for filtering.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * @method
     * @param options Query resource GetCalendarEventOptions object.
     * @example calendarEventRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarEventRoute.prototype.find = function (options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get route which must be expanded with the identifier of the previously created CalendarEvent resource. This route can be expanded using additional GetRequestOptions. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEvent id which uniquely identifies CalendarEvent resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example calendarEventRoute.get(id);
     */
    CalendarEventRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses getByEmailOrFullName route which must be expanded with the identifier of the previously created CalendarEvent resource
     * The route must also be expanded with the identifier of the previously created CalendarResource and the email/FullName.
     * @param id CalendarEvent identifier which uniquely identifies previously created CalendarEvent resource.
     * @param emailOrFullName Email or full name.
     * @param options Query resource options object.
     * @example calendarEventRoute.get(id, email@example.com, options);
     */
    CalendarEventRoute.prototype.getByEmailOrFullName = function (id, emailOrFullName, options) {
        var params = this.modelMapper.getParams(options);
        params.emailOrFullName = emailOrFullName;
        return _super.prototype.baseGet.call(this, this.getByEmailOrFullNameRoute, id, params);
    };
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object that needs to be inserted into the system.
     * @example calendarEventRoute.create(data);
     */
    CalendarEventRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object used to update specified CalendarEvent resource.
     * @example calendarEventRoute.update(data);
     */
    CalendarEventRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object that will be deleted from the system.
     * @example calendarEventRoute.delete(data);
     */
    CalendarEventRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @param calendarId CalendarId identifier that uniquely identifies a calendar resource that will have all of it's events purged.
     * @example calendarEventRoute.purge(calendar);
     */
    CalendarEventRoute.prototype.purge = function (calendarId) {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, calendarId);
    };
    CalendarEventRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarEventRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarEventRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRoute);
    return CalendarEventRoute;
}(common_1.BaseRoute));
exports.CalendarEventRoute = CalendarEventRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventClient
 * @description  CalendarEvent Client provides an easy way to consume CalendarEvent REST API end-points. In order to obtain needed routes `calendarEventClient` uses `calendarEventRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventClient = /** @class */ (function () {
    function CalendarEventClient(calendarEventBatchClient, calendarEventRoute, apiClient) {
        this.calendarEventBatchClient = calendarEventBatchClient;
        this.calendarEventRoute = calendarEventRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventClient.prototype, "batch", {
        get: function () {
            return this.calendarEventBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEvent resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarEventOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <event-identifiers>,
                    ownerIds: <event-owner-identifiers>,
                    calendarIds: <calendars-identifiers>,
                    calendarNames: <calendar-names>,
                    statusIds: <event-status-identifiers>,
                    typeIds: <event-type-identifiers>,
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEvent resource.
     * @method
     * @param id CalendarEvent id which uniquely identifies CalendarEvent resource that needs to be retrieved.
     * @param options Query resource GetRequstOptions object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventClient.get(id)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the getByEmailOrFullName action has been performed. Success response returns the CalendarEvent resource
     * @method
     * @param id CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param emailOrFullName Email or full name.
     * @param securityToken Security Token.
     * @param options Query resource options object
     * @example calendarEventClient.get(id, email@example.com)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventClient.prototype.getByEmailOrFullName = function (id, emailOrFullName, securityToken, options) {
        var headers;
        headers['securityToken'] = securityToken;
        return this.apiClient.get(this.routeDefinition.getByEmailOrFullName(id, emailOrFullName, options), headers);
    };
    /**
     * Returns a promise that is resolved once the create CalendarEvent action has been performed. This action creates a new CalendarEvent resource.
     * @method
     * @param data A CalendarEvent object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEvent action has been performed.
     * @example calendarEventClient.create({
                    author: <user-info>,
                    authorId: '<author-id>',
                    calendar: <calendar>,
                    calendarId: '<calendar-id>',
                    description: '<description>',
                    detail: <calendar-event-detail>,
                    endTime: '<end-time>',
                    isAllDay: <true|false>,
                    isRecurring: <true|false>,
                    json: '<json>',
                    startTime: '<start-time>',
                    title: '<title'>
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEvent action has been performed. This action updates a CalendarEvent resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEvent);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A Calendar Event  object used to update specified CalendarEvent resource.
     * @returns A promise that is resolved once the update CalendarEvent action has been performed.
     * @example calendarEvent is a resource previously fetched using get action.
                calendarEvent.title = '<title>';
                calendarEventClient.update(calendarEvent)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEvent resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEvent);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEvent object used to delete specified CalendarEvent resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEvent is a resource previously fetched using get action.
                calendarEventClient.remove(calendarEvent)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEvent resources from the system if succesfully completed.
     * @method
     * @param calendarId Calendar identifier which uniquely identifies a calendar resource which will have its Events purged.
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarEventClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventClient.prototype.purge = function (calendarId) {
        return this.apiClient.delete(this.routeDefinition.purge(calendarId));
    };
    var _a, _b, _c;
    CalendarEventClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventBatchClient !== "undefined" && __1.CalendarEventBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventRoute !== "undefined" && __1.CalendarEventRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventClient);
    return CalendarEventClient;
}());
exports.CalendarEventClient = CalendarEventClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(585), exports);
tslib_1.__exportStar(__webpack_require__(590), exports);
tslib_1.__exportStar(__webpack_require__(595), exports);


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(586), exports);
tslib_1.__exportStar(__webpack_require__(587), exports);
tslib_1.__exportStar(__webpack_require__(588), exports);
tslib_1.__exportStar(__webpack_require__(589), exports);


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarRsvpAttendeeBatchClient
 * @description  CalendarRsvpAttendeeBatchClient provides an easy way to consume CalendarRsvpAttendeeBatch REST API end-points. In order to obtain needed routes `calendarRsvpAttendeeBatchClient` uses `calendarRsvpAttendeeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarRsvpAttendeeBatchClient = /** @class */ (function () {
    function CalendarRsvpAttendeeBatchClient(calendarRsvpAttendeeBatchRoute, apiClient) {
        this.calendarRsvpAttendeeBatchRoute = calendarRsvpAttendeeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarRsvpAttendeeBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarRsvpAttendeeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the link CalendarEvenAttendees action has been performed; this action links new CalendarEventAttendee resources to the calendarEvent.
     * @method
     * @param data CalendarEventAttendee objects that need to be inserted into the system.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @returns A promise that is resolved once the link CalendarEventAttendees action has been performed.
     * @example calendarRsvpAttendeeBatchClient.link(calendarId, eventId, [{
                    AttendeeStatus: <calendar-evetn-attendee-status>,
                    AttendeeStatusId '<attendee-status-id>',
                    DateCreated: '<date-created>',
                    DateUpdated: '<date-updated>',
                    Email: '<email>',
                    EventID: '<calendar-event-id>',
                    FullName: '<full-name>',
                    Id: '<id>',
                    InvitationType: <calendar-event-invitation-type>,
                    InvitationTypeId: '<invitation-type-id>',
                    Json: '<json>',
                    Slots: <slots>,
                    SlotsRequested: <slots-requested>,
                    User: <user-profile>,
                    UserID: '<user-id>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeBatchClient.prototype.link = function (calendarId, eventId, data) {
        return this.apiClient.post(this.routeDefinition.link(calendarId, eventId), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendees action has been performed; this action updates CalendarEventAttendee resources.
     * @method
     * @param data CalendarEventAttendee objects used to update specified CalendarEventAttendee resources.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @returns A promise that is resolved once the update CalendarEventAttendees action has been performed.
     * @example calendarEventAttendees are resources previously fetched using get action.
                calendarRsvpAttendeeBatchClient.update(calendarId, eventId, calendarEventAttendees)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeBatchClient.prototype.update = function (calendarId, eventId, data) {
        return this.apiClient.put(this.routeDefinition.update(calendarId, eventId), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will unlink CalendarEventAttendee resources from the specified calendarEvent if successfully completed.
     * @method
     * @param data CalendarEventAttendee Ids which uniquely identify CalendarEventAttendee resources to be deleted.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example calendarEventAttendeeIds are identifiers which uniquely identify CalendarEventAttendee resources.
                calendarRsvpAttendeeBatchClient.unlink(calendarId, eventId, calendarEventAttendeeIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeBatchClient.prototype.unlink = function (calendarId, eventId, data) {
        return this.apiClient.delete(this.routeDefinition.unlink(calendarId, eventId), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarRsvpAttendeeBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarRsvpAttendeeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarRsvpAttendeeBatchRoute !== "undefined" && __1.CalendarRsvpAttendeeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarRsvpAttendeeBatchClient);
    return CalendarRsvpAttendeeBatchClient;
}());
exports.CalendarRsvpAttendeeBatchClient = CalendarRsvpAttendeeBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarRsvpAttendeeBatchRoute
 * @description BaasicCalendarRsvpAttendeeBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarRsvpAttendeeBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CalendarRsvpAttendeeBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarRsvpAttendeeBatchRoute, _super);
    function CalendarRsvpAttendeeBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.linkRoute = 'calendars/{calendarId}/events/{eventId}/attendees/batch';
        _this.updateRoute = 'calendars/{calendarId}/events/{eventId}/attendees/batch';
        _this.unlinkRoute = 'calendars/{calendarId}/events/{eventId}/attendees/batch';
        return _this;
    }
    /**
     * Parses link route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @example calendarRsvpAttendeeBatchRoute.link(calendarId, eventId);
     */
    CalendarRsvpAttendeeBatchRoute.prototype.link = function (calendarId, eventId) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @example calendarRsvpAttendeeBatchRoute.update();
     */
    CalendarRsvpAttendeeBatchRoute.prototype.update = function (calendarId, eventId) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @example calendarRsvpAttendeeBatchRoute.unlink(calendarId, eventId);
     */
    CalendarRsvpAttendeeBatchRoute.prototype.unlink = function (calendarId, eventId) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params);
    };
    var _a;
    CalendarRsvpAttendeeBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarRsvpAttendeeBatchRoute);
    return CalendarRsvpAttendeeBatchRoute;
}(common_1.BaseRoute));
exports.CalendarRsvpAttendeeBatchRoute = CalendarRsvpAttendeeBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarRsvpAttendeeClient
 * @description  CalendarRsvpAttendeeClient provides an easy way to consume CalendarRsvpAttendee REST API end-points. In order to obtain needed routes `calendarRsvpAttendeeClient` uses `calendarRsvpAttendeeRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarRsvpAttendeeClient = /** @class */ (function () {
    function CalendarRsvpAttendeeClient(calendarRsvpAttendeeBatchClient, calendarRsvpAttendeeRoute, apiClient) {
        this.calendarRsvpAttendeeBatchClient = calendarRsvpAttendeeBatchClient;
        this.calendarRsvpAttendeeRoute = calendarRsvpAttendeeRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarRsvpAttendeeClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarRsvpAttendeeRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarRsvpAttendeeClient.prototype, "batch", {
        get: function () {
            return this.calendarRsvpAttendeeBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventAttendee resources matching the given criteria.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param options Query resource GetCalendarLookupOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarRsvpAttendeeClient.find(calendarId, eventId, {
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: '<ids>',
                    userIds: '<user-ids>',
                    emails: '<emails>',
                    fullNames: '<full-names>',
                    invitationTypeIds: '<invitation-type-ids>',
                    from: <from-date>,
                    to: <to-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.find = function (calendarId, eventId, options) {
        return this.apiClient.get(this.routeDefinition.find(calendarId, eventId, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventAttendee resource.
     * @method
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource that needs to be retrieved.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param options Query resource GetRequestOptions object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarRsvpAttendeeClient.get(calendarId,eventId, id)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.get = function (calendarId, eventId, id, options) {
        return this.apiClient.get(this.routeDefinition.get(calendarId, eventId, id, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventAttendee resource.
     * @method
     * @param calendarId Calendar Id which uniquely identifies a Calendar resource.
     * @param eventId CalendarEvent Id which uniquely identifies a calendarEvent resource
     * @param emailOrFullName Email or full name which identify a CalendarEventRsvpAttendee resource.
     * @param options Query resource options object.
     * @example calendarRsvpAttendeeRoute.getByEmailOrFullName(calendarId, eventId, fullname);
     */
    CalendarRsvpAttendeeClient.prototype.getByEmailOrFullName = function (calendarId, eventId, emailOrFullName, options) {
        return this.apiClient.get(this.routeDefinition.getByEmailOrFullName(calendarId, eventId, emailOrFullName, options));
    };
    /**
     * Returns a promise that is resolved once the link CalendarEventAttendee action has been performed; this action links a new CalendarEventAttendee resource to a specified calendarEvent.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param data A CalendarEventAttendee object that needs to be inserted into the system.
     * @returns A promise that is resolved once the link CalendarEventAttendee action has been performed.
     * @example calendarRsvpAttendeeClient.link(calendarId, eventId, {
                    AttendeeStatus: <calendar-evetn-attendee-status>,
                    AttendeeStatusId '<attendee-status-id>',
                    DateCreated: '<date-created>',
                    DateUpdated: '<date-updated>',
                    Email: '<email>',
                    EventID: '<calendar-event-id>',
                    FullName: '<full-name>',
                    Id: '<id>',
                    InvitationType: <calendar-event-invitation-type>,
                    InvitationTypeId: '<invitation-type-id>',
                    Json: '<json>',
                    Slots: <slots>,
                    SlotsRequested: <slots-requested>,
                    User: <user-profile>,
                    UserID: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.link = function (calendarId, eventId, data) {
        return this.apiClient.post(this.routeDefinition.link(eventId, calendarId, data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendee action has been performed. This action updates a CalendarEventAttendee resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventAttendee);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventAttendee object used to update specified CalendarEventAttendee resource.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @returns A promise that is resolved once the update CalendarEventAttendee action has been performed.
     * @example calendarEventAttendee is a resource previously fetched using get action.
                calendarEventAttendee.name = '<name>';
                calendarRsvpAttendeeClient.update(calendarEventAttendee)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.update = function (calendarId, eventId, data) {
        return this.apiClient.put(this.routeDefinition.update(calendarId, eventId, data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendee Status action has been performed. This action updates a CalendarEventAttendee resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventAttendee);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @param statusId CalendarEventAttendeeStatus id which uniquely identifies CalendarEventAttendeeStatus resource.
     * @returns A promise that is resolved once the update CalendarEventAttendee action has been performed.
     * @example calendarRsvpAttendeeClient.updateStatus(calendarid, eventid, id, statusid)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.updateStatus = function (calendarId, eventId, id, statusId) {
        return this.apiClient.put(this.routeDefinition.updateStatus(calendarId, eventId, id, statusId), {});
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendee Status action has been performed. This action updates a CalendarEventAttendee resource.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniqely identifies CalendarEvent resource.
     * @param emailOrFullName Email or FullName.
     * @param securityToken Security token.
     * @param statusId CalendarEventAttendeeStatus id which uniquely identifies CalendarEventAttendeeStatus resource.
     * @example calendarRsvpAttendeeClient.update(calendarId, eventId, email, statusId);
     */
    CalendarRsvpAttendeeClient.prototype.updateStatusEmailOrFullName = function (calendarId, eventId, emailOrFullName, securityToken, statusId) {
        var headers;
        headers['securityToken'] = securityToken;
        return this.apiClient.put(this.routeDefinition.updateStatusEmailOrFullName(calendarId, eventId, emailOrFullName, statusId), {}, headers);
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will unlink a CalendarEventAttendee resource from the CalendarEvent if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventAttendee);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventAttendee object used to delete specified CalendarEventAttendee resource.
     * @param eventId CalendarEvent id which uniquely identifies CaledndarEvent resource.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example calendarEventAttendee is a resource previously fetched using get action.
                calendarRsvpAttendeeClient.unlink(calendarEventType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.unlink = function (calendarId, eventId, data) {
        return this.apiClient.delete(this.routeDefinition.unlink(calendarId, eventId, data));
    };
    /**
     * Returns a promise that is resolved once the subscribe action has been performed. This action creates CalendarEventAttendee subscriotion to CalendarEvent changes.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example calendarRsvpattendeeClient.subscribe(calendarId, eventId, attendeeId)
                .then( function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.subscribe = function (calendarId, eventId, id) {
        return this.apiClient.post(this.routeDefinition.subscribe(eventId, calendarId, id), {});
    };
    /**
     * Returns a promise that is resolved once the unsubscribe action has been performed. This action removes CalendarEventAttendee subscriotion to CalendarEvent changes.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example calendarRsvpattendeeClient.unsubscribe(calendarId, eventId, attendeeId)
                .then( function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.unsubscribe = function (calendarId, eventId, id) {
        return this.apiClient.delete(this.routeDefinition.unsubscribe(eventId, calendarId, id));
    };
    /**
     * Returns a promise that is resolved once the subscribeEmail action has been performed. This action creates CalendarEventAttendee subscriotion to CalendarEvent changes.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param email CalendarEventAttendee email which identifies CalendarEventAttendee resource.
     * @returns A promise that is resolved once the subscribeEmail action has been performed.
     * @example calendarRsvpattendeeClient.subscribeEmail(calendarId, eventId, attendeeEmail)
                .then( function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.subscribeEmail = function (calendarId, eventId, email) {
        return this.apiClient.post(this.routeDefinition.subscribeEmail(eventId, calendarId, email), {});
    };
    /**
     * Returns a promise that is resolved once the unsubscribeEmail action has been performed. This action removes CalendarEventAttendee subscriotion to CalendarEvent changes.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param email CalendarEventAttendee email which identifies CalendarEventAttendee resource.
     * @returns A promise that is resolved once the subscribeEmail action has been performed.
     * @example calendarRsvpattendeeClient.unsubscribeEmail(calendarId, eventId, attendeeEmail)
                .then( function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.unsubscribeEmail = function (calendarId, eventId, id) {
        return this.apiClient.delete(this.routeDefinition.unsubscribe(eventId, calendarId, id));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventAttendee resources for the given event from the system if succesfully completed.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource that will have it's attendees purged.
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarRsvpAttendeeClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpAttendeeClient.prototype.purge = function (calendarId, eventId) {
        return this.apiClient.delete(this.routeDefinition.purge(calendarId, eventId));
    };
    var _a, _b, _c;
    CalendarRsvpAttendeeClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarRsvpAttendeeBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarRsvpAttendeeRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarRsvpAttendeeBatchClient !== "undefined" && __1.CalendarRsvpAttendeeBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarRsvpAttendeeRoute !== "undefined" && __1.CalendarRsvpAttendeeRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarRsvpAttendeeClient);
    return CalendarRsvpAttendeeClient;
}());
exports.CalendarRsvpAttendeeClient = CalendarRsvpAttendeeClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarRsvpAttendeeRoute
 * @description BaasicCalendarRsvpAttendeeRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarRsvpAttendeeRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarRsvpAttendeeRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarRsvpAttendeeRoute, _super);
    function CalendarRsvpAttendeeRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{?searchQuery,page,rpp,sort,embed,fields,ids,userIds,emails,fullNames,invitationTypeIds,from,to}';
        _this.getRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{id}';
        _this.getByEmailOrFullNameRoute = 'calendars/{calendarId}/events/{eventId}/attendees/emails/{emailOrFullName}';
        _this.linkRoute = 'calendars/{calendarId}/events/{eventId}/attendees';
        _this.updateRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{id}';
        _this.updateStatusRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{id}/status/{attendeeStatusId}';
        _this.updateStatusByEmailOrFullNameRoute = 'calendars/{calendarId}/events/{eventId}/attendees/emails/{emailOrFullName}/status/{attendeeStatusId}';
        _this.unlinkRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{id}';
        _this.purgeRoute = 'calendars/{calendarId}/events/{eventId}/attendees/purge';
        _this.subscribeEmailRoute = 'calendars/{calendarId}/events/{eventId}/emails/{email}/subscribe';
        _this.unsubscribeEmailRoute = 'calendars/{calendarId}/events/{eventId}/emails/{email}/unsubscribe';
        _this.subscribeRoute = 'calendars/{calendarId}/events/{eventId}/emails/{email}/subscribe';
        _this.unsubscribeRoute = 'calendars/{calendarId}/events/{eventId}/attendees/{id}/unsubscribe';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarLookupOptions. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventAttendee properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventAttendee subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventAttendee property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `ids` - CalendarEventAttendee ids which uniquely identify CalendarEventAttendee resources that need to be retrieved.
     * - `userIds` - CalendarEventAttende userIds which identify CalendarEventAttendee resources.
     * - `emails` - CalendarEventAttendee emails which identify CalendarEventAttendee resources.
     * - `fullNames` - CalendarEventAttendee full names which identify CalendarEventAttendee resources.
     * - `invitationTypeIds` - invitationTypeIds which identify CalendarEventAttendee resources.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date.
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * @method
     * @param options Query resource GetCalendarLookupOptions object.
     * @param calendarId Calendar identifier which uniquely identifies a calendar resource.
     * @param eventId calendarEvent identifier which uniquely identifies a CalendarEvent resource.
     * @example calendarRsvpAttendeeRoute.find(calendarid, eventid, {searchQuery: '<search-phrase>'});
     */
    CalendarRsvpAttendeeRoute.prototype.find = function (calendarId, eventId, options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        var params = this.modelMapper.findParams(opt);
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseFind.call(this, this.findRoute, params);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventAttendee resource in the system. The route can be expanded using additional GetRequestOptions. Supported items are
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource that needs to be retrieved.
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param options Query resource GetRequestOptions object.
     * @example calendarRsvpAttendeeRoute.get(calendarId, eventId, id);
     */
    CalendarRsvpAttendeeRoute.prototype.get = function (calendarId, eventId, id, options) {
        var params = this.modelMapper.getParams(options);
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseGet.call(this, this.getRoute, id, params);
    };
    /**
     * @method
     * @param calendarId Calendar Id which uniquely identifies a Calendar resource.
     * @param eventId CalendarEvent Id which uniquely identifies a calendarEvent resource
     * @param emailOrFullName Email or full name which identify a CalendarEventRsvpAttendee resource.
     * @param options Query resource options ovject.
     * @example calendarRsvpAttendeeRoute.getByEmailOrFullName(calendarId, eventId, fullname);
     */
    CalendarRsvpAttendeeRoute.prototype.getByEmailOrFullName = function (calendarId, eventId, emailOrFullName, options) {
        var params = this.modelMapper.getParams(options);
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.emailOrFullName = emailOrFullName;
        return _super.prototype.baseGet.call(this, this.getByEmailOrFullNameRoute, {}, params);
    };
    /**
     * Parses link route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies a CalendarEvent resource
     * @param data A CalendarEventAttendee object that needs to be inserted into the system.
     * @example calendarRsvpAttendeeRoute.link(calendarId, eventId, data);
     */
    CalendarRsvpAttendeeRoute.prototype.link = function (calendarId, eventId, data) {
        var params = this.modelMapper.createParams(data);
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @example calendarRsvpAttendeeRoute.purge(calendarId, eventId);
     */
    CalendarRsvpAttendeeRoute.prototype.purge = function (calendarId, eventId) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseDelete.call(this, this.purgeRoute, params);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param data A CalendarEventAttendee object used to update specified CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.update(calendarId, eventId, data);
     */
    CalendarRsvpAttendeeRoute.prototype.update = function (calendarId, eventId, data) {
        var params = this.modelMapper.updateParams(data);
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    /**
     * Parses update Status route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @param statusId CalendarEventAttendeeStatus id which uniquely identifies CalendarEventAttendeeStatus resource.
     * @example calendarRsvpAttendeeRoute.updateStatus(calendarId, eventId, id, statusId);
     */
    CalendarRsvpAttendeeRoute.prototype.updateStatus = function (calendarId, eventId, id, statusId) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.id = id;
        params.attendeeStatusId = statusId;
        return _super.prototype.baseUpdate.call(this, this.updateStatusRoute, params);
    };
    /**
     * Parses update status email or name route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniqely identifies CalendarEvent resource.
     * @param emailOrFullName Email or FullName
     * @param statusId CalendarEventAttendeeStatus id which uniquely identifies CalendarEventAttendeeStatus resource.
     * @example calendarRsvpAttendeeRoute.update(calendarId, eventId, email, statusId);
     */
    CalendarRsvpAttendeeRoute.prototype.updateStatusEmailOrFullName = function (calendarId, eventId, emailOrFullName, statusId) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.emailOrFullName = emailOrFullName;
        params.statusId = statusId;
        return _super.prototype.baseUpdate.call(this, this.updateStatusByEmailOrFullNameRoute, params);
    };
    /**
     * Parses unlink route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param data A CalendarEventAttendee object used to unlink specified CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.delete(calendarId, eventId, data);
     */
    CalendarRsvpAttendeeRoute.prototype.unlink = function (calendarId, eventId, data) {
        var params = this.modelMapper.removeParams(data);
        params.calendarId = calendarId;
        params.eventId = eventId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params);
    };
    /**
     * Parses subscribe route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.subscribe(calendarId, eventId, attendeeId);
     */
    CalendarRsvpAttendeeRoute.prototype.subscribe = function (calendarId, eventId, id) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, params);
    };
    /**
     * Parses unsubscribe route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.unsubscribe(calendarId, eventId, attendeeId);
     */
    CalendarRsvpAttendeeRoute.prototype.unsubscribe = function (calendarId, eventId, id) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.unsubscribeRoute, params);
    };
    /**
     * Parses subscribeEmail route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param email CalendarEventAttendee email which identifies CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.subscribe(calendarId, eventId, attendeeId);
     */
    CalendarRsvpAttendeeRoute.prototype.subscribeEmail = function (calendarId, eventId, email) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.email = email;
        return _super.prototype.baseCreate.call(this, this.subscribeEmailRoute, params);
    };
    /**
     * Parses unsubscribeEmail route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniqely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param email CalendarEventAttendee email which identifies CalendarEventAttendee resource.
     * @example calendarRsvpAttendeeRoute.unsubscribe(calendarId, eventId, attendeeId);
     */
    CalendarRsvpAttendeeRoute.prototype.unsubscribeEmail = function (calendarId, eventId, email) {
        var params = {};
        params.calendarId = calendarId;
        params.eventId = eventId;
        params.email = email;
        return _super.prototype.baseCreate.call(this, this.unsubscribeEmailRoute, params);
    };
    CalendarRsvpAttendeeRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarRsvpAttendeeRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarRsvpAttendeeRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarRsvpAttendeeRoute);
    return CalendarRsvpAttendeeRoute;
}(common_1.BaseRoute));
exports.CalendarRsvpAttendeeRoute = CalendarRsvpAttendeeRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(591), exports);
tslib_1.__exportStar(__webpack_require__(592), exports);
tslib_1.__exportStar(__webpack_require__(593), exports);
tslib_1.__exportStar(__webpack_require__(594), exports);


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarRsvpBatchClient
 * @description  CalendarRsvpBatchClient provides an easy way to consume CalendarRsvpBatch REST API end-points. In order to obtain needed routes `calendarRsvpBatchClient` uses `calendarRsvpBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarRsvpBatchClient = /** @class */ (function () {
    function CalendarRsvpBatchClient(calendarRsvpBatchRoute, apiClient) {
        this.calendarRsvpBatchRoute = calendarRsvpBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarRsvpBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarRsvpBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the link CalendarEventRsvps action has been performed; this action links CalendarEventRsvp resources to the specified calendar.
     * @method
     * @param data CalendarEventRsvp objects that need to be inserted into the system.
     * @param calendarId Calendar identifier which uniquely identifies calendar resource that will have its EventRsvp objects craeted
     * @returns A promise that is resolved once the link CalendarEventRsvps action has been performed.
     * @example calendarRsvpBatchClient.link( calendarId, [{
                    InvitationOnly: <true|false>,
                    InvitationType: <calendar-rsvp-invitation-type>,
                    InvitationTypeId: '<invitation-type-id>',
                    Json: '<json>',
                    MaxSlots: <max-slots>,
                    MinSlots: <min-slots>,
                    RegistrationCloseDate: '<registration-close-date>',
                    TotalSlots: <total-slots>
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpBatchClient.prototype.link = function (calendarId, data) {
        return this.apiClient.post(this.routeDefinition.link(calendarId), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvps action has been performed; this action updates CalendarEventRsvp resources.
     * @method
     * @param data CalendarEventRsvp objects used to update specified CalendarEventRsvp resources.
     * @param calendarId Calendar identifier that uniquely identifies calendar resource that will have it's CalendarEventRsvp's updated.
     * @returns A promise that is resolved once the update CalendarEventRsvps action has been performed.
     * @example calendarEventRsvps are resources previously fetched using get action.
                calendarRsvpBatchClient.update(calendar, calendarEventRsvps)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpBatchClient.prototype.update = function (calendarId, data) {
        return this.apiClient.put(this.routeDefinition.update(calendarId), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will unlink CalendarEventRsvp resources from the specified calendar if successfully completed.
     * @method
     * @param data CalendarEventRsvp Ids which uniquely identify CalendarEventRsvp resources to be deleted.
     * @param calendarId Calendar identifier that uniquely identifies a calendar resource that will have it's calendarEventRsvp's deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventRsvpIds are identifiers which uniquely identify CalendarEventRsvp resources.
                calendarRsvpBatchClient.unlink(calendar, calendarEventRsvpIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpBatchClient.prototype.unlink = function (calendarId, data) {
        return this.apiClient.delete(this.routeDefinition.unlink(calendarId), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarRsvpBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarRsvpBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarRsvpBatchRoute !== "undefined" && __1.CalendarRsvpBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarRsvpBatchClient);
    return CalendarRsvpBatchClient;
}());
exports.CalendarRsvpBatchClient = CalendarRsvpBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarRsvpBatchRoute
 * @description BaasicCalendarRsvpBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarRsvpBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CalendarRsvpBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarRsvpBatchRoute, _super);
    function CalendarRsvpBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.linkRoute = 'calendars/{calendarId}/rsvp-details/batch';
        _this.updateRoute = 'calendars/{calendarId}/rsvp-details/batch';
        _this.unlinkRoute = 'calendars/{calendarId}/rsvp-details/batch';
        return _this;
    }
    /**
     * Parses link route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpBatchRoute.link(calendarId);
     */
    CalendarRsvpBatchRoute.prototype.link = function (calendarId) {
        var params = {};
        params.calendarId = calendarId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpBatchRoute.update(calendarId);
     */
    CalendarRsvpBatchRoute.prototype.update = function (calendarId) {
        var params = {};
        params.calendarId = calendarId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    /**
     * Parses unlink route. This URI template does not expose any additional options.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpBatchRoute.unlink(calendarId);
     */
    CalendarRsvpBatchRoute.prototype.unlink = function (calendarId) {
        var params = {};
        params.calendarId = calendarId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params);
    };
    var _a;
    CalendarRsvpBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarRsvpBatchRoute);
    return CalendarRsvpBatchRoute;
}(common_1.BaseRoute));
exports.CalendarRsvpBatchRoute = CalendarRsvpBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarRsvpClient
 * @description  CalendarRsvpClient provides an easy way to consume CalendarRsvp REST API end-points. In order to obtain needed routes `calendarRsvpClient` uses `calendarRsvpRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarRsvpClient = /** @class */ (function () {
    function CalendarRsvpClient(calendarRsvpBatchClient, calendarRsvpRoute, apiClient) {
        this.calendarRsvpBatchClient = calendarRsvpBatchClient;
        this.calendarRsvpRoute = calendarRsvpRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarRsvpClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarRsvpRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarRsvpClient.prototype, "batch", {
        get: function () {
            return this.calendarRsvpBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventRsvp resources matching the given criteria.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @param options Query resource GetCalendarOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarRsvpClient.find(calendarId, {
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: '<ids>',
                    InvitationTypeIds: '<invitation-type-ids>',
                    InvitationOnly: <true|false>,
                    statusIds: '<status-ids>',
                    from: '<from-date>',
                    to: '<to-date>',
                    registrationCloseFrom: '<registration-start-date>',
                    registrationCloseTo: '<registration-end-date>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpClient.prototype.find = function (calendarId, options) {
        return this.apiClient.get(this.routeDefinition.find(calendarId, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventRsvp resource.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @param id CalendarEventRsvp id which uniquely identifies CalendarEventRsvp resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarRsvpClient.get()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpClient.prototype.get = function (calendarId, id, options) {
        return this.apiClient.get(this.routeDefinition.get(calendarId, id, options));
    };
    /**
     * Returns a promise that is resolved once the link CalendarEventRsvp action has been performed; this action links the CalendarEventRsvp to the calendarEvent resource.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @param data A CalendarEventRsvp object that needs to be inserted into the system.
     * @returns A promise that is resolved once the link CalendarEventRsvp action has been performed.
     * @example calendarRsvpClient.link(calendarId, {
                    InvitationOnly: <true|false>,
                    InvitationType: <calendar-rsvp-invitation-type>,
                    InvitationTypeId: '<invitation-type-id>',
                    Json: '<json>',
                    MaxSlots: <max-slots>,
                    MinSlots: <min-slots>,
                    RegistrationCloseDate: '<registration-close-date>',
                    TotalSlots: <total-slots>
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpClient.prototype.link = function (calendarId, data) {
        return this.apiClient.post(this.routeDefinition.link(calendarId, data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvp action has been performed; this action updates a CalendarEventRsvp resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarRsvpRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvp);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @param data A CalendarEventrSVP object used to update specified CalendarEventRsvp resource.
     * @returns A promise that is resolved once the update CalendarEventRsvp action has been performed.
     * @example calendarEventRsvp is a resource previously fetched using get action.
                calendarEventRsvp.name = '<name>';
                calendarRsvpClient.update(calendarEventRsvp)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpClient.prototype.update = function (calendarId, data) {
        return this.apiClient.put(this.routeDefinition.update(calendarId, data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will unlink a CalendarEventRsvp from the CalendarEvent if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarRsvpRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvp);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @param data An calendarEventRsvp object used to delete specified CalendarEventRsvp resource.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example calendarEventRsvp is a resource previously fetched using get action.
                calendarRsvpClient.unlink(calendarId, calendarEventRsvp)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpClient.prototype.unlink = function (calendarId, data) {
        return this.apiClient.delete(this.routeDefinition.unlink(calendarId, data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventRsvp resources from the system if succesfully completed.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @param data A CalendarEvent object that will have it's rsvp's purged
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarRsvpClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarRsvpClient.prototype.purge = function (calendarId, data) {
        return this.apiClient.delete(this.routeDefinition.purge(calendarId, data));
    };
    var _a, _b, _c;
    CalendarRsvpClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarRsvpBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarRsvpRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarRsvpBatchClient !== "undefined" && __1.CalendarRsvpBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarRsvpRoute !== "undefined" && __1.CalendarRsvpRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarRsvpClient);
    return CalendarRsvpClient;
}());
exports.CalendarRsvpClient = CalendarRsvpClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarRsvpRoute
 * @description BaasicCalendarRsvpRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarRsvpRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarRsvpRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarRsvpRoute, _super);
    function CalendarRsvpRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendars/{calendarId}/rsvp-details/{?searchQuery,page,rpp,sort,embed,fields,ids,invitationTypeIds,invitationOnly,statusIds,typeIds,registrationCloseFrom,registrationCloseTo,from,to}';
        _this.getRoute = 'calendars/{calendarId}/rsvp-details/{id}';
        _this.linkRoute = 'calendars/{calendarId}/rsvp-details';
        _this.updateRoute = 'calendars/{calendarId}/rsvp-details/{id}';
        _this.unlinkRoute = 'calendars/{calendarId}/rsvp-details/{id}';
        _this.purgeRoute = 'calendars/{calendarId}/rsvp-details/{id}/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarOptions. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventRsvp properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventRsvp subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventRsvp property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `ids` - CalendarRsvp ids which uniquely identify CalendarRsvp resources that need to be retrieved.
     * - `invitationTypeIds` - InvatationType ids which uniquely identify CalendarEventRsvpInvitationType resources used for filtering.
     * - `invitationOnly` - A value used to filter events which are invitation-only.
     * - `statusIds` - CalendarEventStatus ids which uniquely identify CalendarEventStatus resources used for filtering.
     * - `typeIds` - CalendarEventType ids which uniquely identify CalendarEventType resources used for filtering.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * - `registrationCloseFrom` - A value used to filter eventRsvps where registration is open from this date.
     * - `registrationCloseTo` - A value used to filter eventRsvps where registration is closed to this date,
     * @method
     * @param calendarId calendarId which uniquely identifies Calendar resource.
     * @param options Query resource GetCalendarOptions object.
     * @example calendarRsvpRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarRsvpRoute.prototype.find = function (calendarId, options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
            opt.registrationCloseFrom = this.getRegistrationCloseFromDate(opt);
            opt.registrationCloseTo = this.getRegistrationCloseToDate(opt);
        }
        else {
            opt = {};
        }
        var params = this.modelMapper.findParams(opt);
        params.calendarId = calendarId;
        return _super.prototype.baseFind.call(this, this.findRoute, params);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventRsvp resource. This route can be expanded using additional GetRequestOptions. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventRsvp id which uniquely identifies CalendarEventRsvp resource that needs to be retrieved.
     * @param options Query resource options object.
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpRoute.get(id, options);
     */
    CalendarRsvpRoute.prototype.get = function (calendarId, id, options) {
        var params = this.modelMapper.getParams(options);
        params.calendarId = calendarId;
        return _super.prototype.baseGet.call(this, this.getRoute, id, params);
    };
    /**
     * Parses link route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvp object that needs to be inserted into the system.
     * @param calendarId Calendar Id which uniquely identifies Calendar resource.
     * @example calendarRsvpRoute.link(data);
     */
    CalendarRsvpRoute.prototype.link = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvp object used to update specified CalendarEventRsvp resource.
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpRoute.update(data);
     */
    CalendarRsvpRoute.prototype.update = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    /**
     * Parses unlink route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object used to unlink specified CalendarEvent resource.
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpRoute.unlink(data);
     */
    CalendarRsvpRoute.prototype.unlink = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object that will have its rsvp's purged
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @example calendarRsvpRoute.purge(data);
     */
    CalendarRsvpRoute.prototype.purge = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        return _super.prototype.baseDelete.call(this, this.purgeRoute, params);
    };
    CalendarRsvpRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarRsvpRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    CalendarRsvpRoute.prototype.getRegistrationCloseFromDate = function (options) {
        if (!this.utility.isUndefined(options.registrationCloseFrom) && options.registrationCloseFrom !== null) {
            return options.registrationCloseFrom.toISOString();
        }
        return undefined;
    };
    CalendarRsvpRoute.prototype.getRegistrationCloseToDate = function (options) {
        if (!this.utility.isUndefined(options.registrationCloseTo) && options.registrationCloseTo !== null) {
            return options.registrationCloseTo.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarRsvpRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarRsvpRoute);
    return CalendarRsvpRoute;
}(common_1.BaseRoute));
exports.CalendarRsvpRoute = CalendarRsvpRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(596), exports);
tslib_1.__exportStar(__webpack_require__(597), exports);


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventsClient
 * @description  CalendarEvents Client provides an easy way to consume CalendarEvents REST API end-points. In order to obtain needed routes `calendarEventsClient` uses `calendarEventsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventsClient = /** @class */ (function () {
    function CalendarEventsClient(calendarEventsRoute, apiClient) {
        this.calendarEventsRoute = calendarEventsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventsClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEvent resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarEventOptions object.
     * @param calendarId Calendar Id which uniquely identifies Calendar resource.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventsClient.find(calendarId, {
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <event-identifiers>,
                    ownerIds: <event-owner-identifiers>,
                    statusIds: <event-status-identifiers>,
                    typeIds: <event-type-identifiers>,
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventsClient.prototype.find = function (calendarId, options) {
        return this.apiClient.get(this.routeDefinition.find(calendarId, options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEvent resource.
     * @method
     * @param calendarId Calendar Id which uniquely identifies Calendar resource.
     * @param id CalendarEvent id which uniquely identifies CalendarEvent resource that needs to be retrieved.
     * @param options Query resource GetRequstOptions object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventsClient.get(calendarId, id)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventsClient.prototype.get = function (calendarId, id, options) {
        return this.apiClient.get(this.routeDefinition.get(calendarId, id, options));
    };
    /**
     * Returns a promise that is resolved once the getByEmailOrFullName action has been performed. Success response returns the CalendarEvent resource
     * @method
     * @param calendarId calendarId which uniquely identifies Calendar resource.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @param emailOrFullName Email or full name.
     * @param securityToken Security token.
     * @param options Query resource options object.
     * @example calendarEventsClient.get(calendarId, id, email@example.com)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventsClient.prototype.getByEmailOrFullName = function (calendarId, eventId, emailOrFullName, securityToken, options) {
        var headers;
        headers['securityToken'] = securityToken;
        return this.apiClient.get(this.routeDefinition.getByEmailOrFullName(calendarId, eventId, emailOrFullName, options), headers);
    };
    /**
     * Returns a promise that is resolved once the link CalendarEvent action has been performed. This action links an existing calendarEvent resource with an existing Calendar resource.
     * @method
     * @param calendarId Calendar id which uniquely identifies the calendar resource to be linked.
     * @param data A calendarEvent resource to be linked.
     * @returns A promise that is resolved once the create CalendarEvent action has been performed.
     * @example calendarEventsClient.link(calendarId, event)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventsClient.prototype.link = function (calendarId, data) {
        return this.apiClient.post(this.routeDefinition.link(calendarId, data), {});
    };
    /**
     * Returns a promise that is resolved once the update CalendarEvent action has been performed. This action updates a CalendarEvent resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEvent);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A Calendar Event  object used to update specified CalendarEvent resource.
     * @param calendarId calendarId which uniquely identifies Calendar resource.
     * @returns A promise that is resolved once the update CalendarEvent action has been performed.
     * @example calendarEvent is a resource previously fetched using get action.
                calendarEvent.title = '<title>';
                calendarEventsClient.update(calendarid, calendarEvent)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventsClient.prototype.update = function (calendarId, data) {
        return this.apiClient.put(this.routeDefinition.update(calendarId, data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will unlink a CalendarEvent resource from the specified calendar if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEvent);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data A calendarEvent resource to be unlinked.
     * @param eventId CalendarEvent id which uniquely identifies CalendarEvent resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventsClient.unlink(calendarid, data)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventsClient.prototype.unlink = function (calendarId, data) {
        return this.apiClient.delete(this.routeDefinition.unlink(calendarId, data));
    };
    var _a, _b;
    CalendarEventsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventsRoute !== "undefined" && __1.CalendarEventsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarEventsClient);
    return CalendarEventsClient;
}());
exports.CalendarEventsClient = CalendarEventsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventsRoute
 * @description BaasicCalendarEventsRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventsRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarEventsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventsRoute, _super);
    function CalendarEventsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendars/{calendarId}/events/{?searchQuery,page,rpp,sort,embed,fields,ids,ownerIds,statusIds,typeIds,from,to}';
        _this.getRoute = 'calendars/{calendarId}/events/{id}/{?embed,fields}';
        _this.getByEmailOrFullNameRoute = 'calendars/{calendarId}/events/{id}/emails/{emailOrFullName}';
        _this.linkRoute = 'calendars/{calendarId}/events/{id}';
        _this.updateRoute = 'calendars/{calendarId}/events/{id}';
        _this.unlinkRoute = 'calendars/{calendarId}/events/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarEventOptions. Supported items are:
     * - `searchQuery` - A string referencing CalendarEvent properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEvent subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEvent property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `ids` - CalendarEvent ids which uniquely identify CalendarEvent resources that need to be retrieved.
     * - `ownerIds` - Owner ids which uniquely identify event owners used for filtering.
     * - `statusIds` - CalendarEventStatus ids which uniquely idendify CalendarEventStatuses used for filtering.
     * - `typeIds` - CalendarEventType ids which uniquely identify CalendarEventTypes used for filtering.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * @method
     * @param calendarId Calendar identifier which uniquely identifies a calendar resource.
     * @param options Query resource GetCalendarEventsOptions object.
     * @example calendarEventsRoute.find(calendarId, {searchQuery: '<search-phrase>'});
     */
    CalendarEventsRoute.prototype.find = function (calendarId, options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        var params = this.modelMapper.findParams(opt);
        params.calendarId = calendarId;
        return _super.prototype.baseFind.call(this, this.findRoute, params);
    };
    /**
     * Parses get route which must be expanded with the identifier of the previously created CalendarEvent resource. This route can be expanded using additional GetRequestOptions. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param calendarId Calendar id which uniquely identifies Calendar resource.
     * @param id CalendarEvent id which uniquely identifies CalendarEvent resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example calendarEventsRoute.get(id);
     */
    CalendarEventsRoute.prototype.get = function (calendarId, id, options) {
        var params = this.modelMapper.getParams(options);
        params.calendarId = calendarId;
        return _super.prototype.baseGet.call(this, this.getRoute, id, params);
    };
    /**
     * Parses getByEmailOrFullName route which must be expanded with the identifier of the previously created CalendarEvent resource
     * The route must also be expanded with the identifier of the previously created CalendarResource and the email/FullName.
     * @param calendarId Calendar identifier which uniquely identifies previously created calendar resource.
     * @param id CalendarEvent identifier which uniquely identifies previously created CalendarEvent resource.
     * @param emailOrFullName Email or full name.
     * @param options Query resource options object.
     * @example calendarEventsRoute.get(calendarId, id, email@example.com, options);
     */
    CalendarEventsRoute.prototype.getByEmailOrFullName = function (calendarId, id, emailOrFullName, options) {
        var params = this.modelMapper.getParams(options);
        params.calendarId = calendarId;
        params.emailOrFullName = emailOrFullName;
        return _super.prototype.baseGet.call(this, this.getByEmailOrFullNameRoute, id, params);
    };
    /**
     * Parses link route. This URI template does not expose any additional options.
     * @method
     * @param data A calendarEvent resource to be linked.
     * @param calendarId A calendar identifier which uniquely identifies a calendar resource.
     * @example calendarEventsRoute.create(calendarid, eventid);
     */
    CalendarEventsRoute.prototype.link = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        params.eventId = data.id;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEvent object used to update specified CalendarEvent resource.
     * @param calendarId A calendar identifier which uniquely identifies a calendar resourse.
     * @example calendarEventsRoute.update(calendarid, data);
     */
    CalendarEventsRoute.prototype.update = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        return _super.prototype.baseUpdate.call(this, this.updateRoute, params);
    };
    /**
     * Parses unlink route. This URI template does not expose any additional options.
     * @method
     * @param data A calendarEvent resource to be unlinked.
     * @param calendarId A calendar identifier which uniquely identifies a calendar resourse.
     * @example calendarEventsRoute.unlink(calendarid, eventid);
     */
    CalendarEventsRoute.prototype.unlink = function (calendarId, data) {
        var params = this.utility.extend({}, data);
        params.calendarId = calendarId;
        params.eventId = data.id;
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, params);
    };
    CalendarEventsRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarEventsRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarEventsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventsRoute);
    return CalendarEventsRoute;
}(common_1.BaseRoute));
exports.CalendarEventsRoute = CalendarEventsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(599), exports);
tslib_1.__exportStar(__webpack_require__(600), exports);
tslib_1.__exportStar(__webpack_require__(601), exports);
tslib_1.__exportStar(__webpack_require__(602), exports);


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpBatchClient
 * @description  CalendarEventRsvpBatchClient provides an easy way to consume CalendarEventRsvpBatch REST API end-points. In order to obtain needed routes `calendarEventRsvpBatchClient` uses `calendarEventRsvpBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventRsvpBatchClient = /** @class */ (function () {
    function CalendarEventRsvpBatchClient(calendarEventRsvpBatchRoute, apiClient) {
        this.calendarEventRsvpBatchRoute = calendarEventRsvpBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create CalendarEventRsvps action has been performed; this action creates new CalendarEventRsvp resources.
     * @method
     * @param data CalendarEventRsvp objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventRsvps action has been performed.
     * @example calendarEventRsvpBatchClient.create([{
                    InvitationOnly: <true|false>,
                    InvitationType: <invitation-type>,
                    InvitationTypeId: '<id>',
                    Json: '<json>',
                    MaxSlots: 50,
                    MinSlots: 10,
                    RegistrationCloseDate?: '<close-date>',
                    TotalSlots: 65,
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    CalendarEventRsvpBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvps action has been performed; this action updates CalendarEventRsvp resources.
     * @method
     * @param data CalendarEventRsvp objects used to update specified CalendarEventRsvp resources.
     * @returns A promise that is resolved once the update CalendarEventRsvps action has been performed.
     * @example calendarEventRsvps are resources previously fetched using get action.
                calendarEventRsvpBatchClient.update(calendarEventRsvps)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove CalendarEventRsvp resources from the system if successfully completed.
     * @method
     * @param data CalendarEventRsvp Ids which uniquely identify CalendarEventRsvp resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventRsvpIds are identifiers which uniquely identify CalendarEventRsvp resources.
                calendarEventRsvpBatchClient.remove(calendarEventRsvpIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarEventRsvpBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpBatchRoute !== "undefined" && __1.CalendarEventRsvpBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarEventRsvpBatchClient);
    return CalendarEventRsvpBatchClient;
}());
exports.CalendarEventRsvpBatchClient = CalendarEventRsvpBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpBatchRoute
 * @description BaasicCalendarEventRsvpBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRsvpBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CalendarEventRsvpBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRsvpBatchRoute, _super);
    function CalendarEventRsvpBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendar-rsvp-details/batch';
        _this.updateRoute = 'calendar-rsvp-details/batch';
        _this.deleteRoute = 'calendar-rsvp-details/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpBatchRoute.create();
     */
    CalendarEventRsvpBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpBatchRoute.update();
     */
    CalendarEventRsvpBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpBatchRoute.delete();
     */
    CalendarEventRsvpBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarEventRsvpBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRsvpBatchRoute);
    return CalendarEventRsvpBatchRoute;
}(common_1.BaseRoute));
exports.CalendarEventRsvpBatchRoute = CalendarEventRsvpBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpClient
 * @description  CalendarEventRsvp Client provides an easy way to consume CalendarEventRsvp REST API end-points. In order to obtain needed routes `calendarEventRsvpClient` uses `calendarEventRsvpRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventRsvpClient = /** @class */ (function () {
    function CalendarEventRsvpClient(calendarEventRsvpBatchClient, calendarEventRsvpRoute, apiClient) {
        this.calendarEventRsvpBatchClient = calendarEventRsvpBatchClient;
        this.calendarEventRsvpRoute = calendarEventRsvpRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventRsvpClient.prototype, "batch", {
        get: function () {
            return this.calendarEventRsvpBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventRsvp resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarEventRsvpOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventRsvpClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <identifiers>,
                    calendarIds: <calendar-ids>,
                    calendarNames: <calendar-names>,
                    invitationTypeIds: <invitation-type-ids>,
                    invitationOnly: <true|false>,
                    statudIds: <status-ids>
                    typeIds: <type-ids>,
                    from: <start-date>,
                    to: <end-date>,
                    registrationCloseFrom: <registration-from-date>,
                    registrationCloseTo: <registration-to-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    CalendarEventRsvpClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventRsvp resource.
     * @method
     * @param id CalendarEventRsvp id which uniquely identifies CalendarEventRsvp resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventRsvpClient.get(id)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create CalendarEventRsvp action has been performed. This action creates a new CalendarEventRsvp resource.
     * @method
     * @param data A CalendarEventRsvp object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventRsvp action has been performed.
     * @example calendarEventRsvpClient.create({
                    InvitationOnly: <true|false>,
                    InvitationType: <calendar-rsvp-invitation-type>,
                    InvitationTypeId: '<invitation-type-id>',
                    Json: '<json>',
                    MaxSlots: <max-slots>,
                    MinSlots: <min-slots>,
                    RegistrationCloseDate: '<registration-close-date>',
                    TotalSlots: <total-slots>
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvp action has been performed. This action updates a CalendarEventRsvp resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRsvpRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvp);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventRsvp object used to update specified CalendarEventRsvp resource.
     * @returns A promise that is resolved once the update CalendarEventRsvp action has been performed.
     * @example calendarEventRsvp is a resource previously fetched using get action.
                calendarEventRsvp.MinSlots = '<min-slots>';
                calendarEventRsvpClient.update(calendarEventRsvp)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEventRsvp resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRsvpRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvp);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventRsvp object used to delete specified CalendarEventRsvp resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventRsvp is a resource previously fetched using get action.
                calendarEventRsvpClient.remove(calendarEventRsvp)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventRsvp resources for the specified CalendarEvent from the system if succesfully completed.
     * @method
     * @param data A CalendarEvent object that will have it's CalendarEventRsvps purged.
     * @example calendarEventRsvpClient.purge(calendarEvent)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                })
     */
    CalendarEventRsvpClient.prototype.purge = function (data) {
        return this.apiClient.delete(this.routeDefinition.purge(data));
    };
    var _a, _b, _c;
    CalendarEventRsvpClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventRsvpRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpBatchClient !== "undefined" && __1.CalendarEventRsvpBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventRsvpRoute !== "undefined" && __1.CalendarEventRsvpRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventRsvpClient);
    return CalendarEventRsvpClient;
}());
exports.CalendarEventRsvpClient = CalendarEventRsvpClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpRoute
 * @description BaasicCalendarEventRsvpRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRsvpRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarEventRsvpRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRsvpRoute, _super);
    function CalendarEventRsvpRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendar-rsvp-details/{?searchQuery,page,rpp,sort,embed,fields,ids,calendarIds,calendarNames,invitationTypeIds,invitationOnly,statusIds,typeIds,from,to,registrationCloseFrom,registrationCloseTo}';
        _this.getRoute = 'calendar-rsvp-details/{id}/{?embed,fields}';
        _this.createRoute = 'calendar-rsvp-details';
        _this.updateRoute = 'calendar-rsvp-details/{id}';
        _this.deleteRoute = 'calendar-rsvp-details/{id}';
        _this.purgeRoute = 'calendar-rsvp-details/{id}/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventRsvp properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventRsvp subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventRsvp property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `ids` - CalendarEventRsvp ids which uniquely identify CalendarEventRsvp resources that need to be retrieved.
     * - `calendarIds` - Calendar ids which uniquely identify Calendar resources used for filtering.
     * - `calendarNames` - Calendar names which identify Calendar resources used for filtering.
     * - `invitationTypeIds` - CalendarEventRsvpInvitationType ids which uniquely identify CalendarEventRsvpInvitationType resources used for filtering.
     * - `invitationOnly` - A value used to filter events which are invitation-only.
     * - `statusIds` -  CalendarEventStatus ids which uniquely identify CalendarEventStatus resources used for filtering.
     * - `typeIds` -  CalendarEventType ids which uniquely identify CalendarEventType resources used for filtering.
     * - `from` - A value used to filter eventRsvps starting from this date.
     * - `to` - A value used to filter eventRsvps ending to this date.
     * - `registrationCloseFrom` - A value used to filter eventRsvps where registration is open from this date.
     * - `registrationCloseTo` - A value used to filter eventRsvps where registration is closed to this date,
     * @method
     * @param options Query resource GetCalendarEventRsvpOptions object.
     * @example calendarEventRsvpRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarEventRsvpRoute.prototype.find = function (options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
            opt.registrationCloseFrom = this.getRegistrationCloseFromDate(opt);
            opt.registrationCloseTo = this.getRegistrationCloseToDate(opt);
        }
        else {
            opt = {};
        }
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventRsvp resource. This route can be expanded using additional GetRequestOptions. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventRsvp id which uniquely identifies CalendarEventRsvp resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @example calendarEventRsvpRoute.get(id);
     */
    CalendarEventRsvpRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvp object that needs to be inserted into the system.
     * @example calendarEventRsvpRoute.create(data);
     */
    CalendarEventRsvpRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvp object used to update specified CalendarEventRsvp resource.
     * @example calendarEventRsvpRoute.update(data);
     */
    CalendarEventRsvpRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvp object used to delete specified CalendarEventRsvp resource.
     * @example calendarEventRsvpRoute.delete(data);
     */
    CalendarEventRsvpRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses purge Route which must be expanded with the previously created CalendarEvent resource. This route does not expose any additional options.
     * @param data A CalendarEvent object that will have it's CalendarEventRsvps purged.
     * @example calendarEventRsvpRoute.purge(calendarEvent)
     */
    CalendarEventRsvpRoute.prototype.purge = function (data) {
        return _super.prototype.parse.call(this, this.purgeRoute);
    };
    CalendarEventRsvpRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarEventRsvpRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    CalendarEventRsvpRoute.prototype.getRegistrationCloseFromDate = function (options) {
        if (!this.utility.isUndefined(options.registrationCloseFrom) && options.registrationCloseFrom !== null) {
            return options.registrationCloseFrom.toISOString();
        }
        return undefined;
    };
    CalendarEventRsvpRoute.prototype.getRegistrationCloseToDate = function (options) {
        if (!this.utility.isUndefined(options.registrationCloseTo) && options.registrationCloseTo !== null) {
            return options.registrationCloseTo.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarEventRsvpRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRsvpRoute);
    return CalendarEventRsvpRoute;
}(common_1.BaseRoute));
exports.CalendarEventRsvpRoute = CalendarEventRsvpRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(604), exports);
tslib_1.__exportStar(__webpack_require__(605), exports);
tslib_1.__exportStar(__webpack_require__(606), exports);
tslib_1.__exportStar(__webpack_require__(607), exports);


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpAttendeeBatchClient
 * @description  CalendarEventRsvpAttendeeBatchClient provides an easy way to consume CalendarEventRsvpAttendeeBatch REST API end-points. In order to obtain needed routes `calendarEventRsvpAttendeeBatchClient` uses `calendarEventRsvpAttendeeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventRsvpAttendeeBatchClient = /** @class */ (function () {
    function CalendarEventRsvpAttendeeBatchClient(calendarEventRsvpAttendeeBatchRoute, apiClient) {
        this.calendarEventRsvpAttendeeBatchRoute = calendarEventRsvpAttendeeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpAttendeeBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpAttendeeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create CalendarEvenAttendees action has been performed; this action creates new CalendarEventAttendee resources.
     * @method
     * @param data CalendarEventAttendee objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventAttendees action has been performed.
     * @example calendarEventRsvpAttendeeBatchClient.create([{
                    AttendeeStatus: <calendar-evetn-attendee-status>,
                    AttendeeStatusId '<attendee-status-id>',
                    DateCreated: '<date-created>',
                    DateUpdated: '<date-updated>',
                    Email: '<email>',
                    EventID: '<calendar-event-id>',
                    FullName: '<full-name>',
                    Id: '<id>',
                    InvitationType: <calendar-event-invitation-type>,
                    InvitationTypeId: '<invitation-type-id>',
                    Json: '<json>',
                    Slots: <slots>,
                    SlotsRequested: <slots-requested>,
                    User: <user-profile>,
                    UserID: '<user-id>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendees action has been performed; this action updates CalendarEventAttendee resources.
     * @method
     * @param data CalendarEventAttendee objects used to update specified CalendarEventAttendee resources.
     * @returns A promise that is resolved once the update CalendarEventAttendees action has been performed.
     * @example calendarEventAttendees are resources previously fetched using get action.
                calendarEventRsvpAttendeeBatchClient.update(calendarEventAttendees)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove CalendarEventAttendee resources from the system if successfully completed.
     * @method
     * @param data CalendarEventAttendee Ids which uniquely identify CalendarEventAttendee resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventAttendeeIds are identifiers which uniquely identify CalendarEventAttendee resources.
                calendarEventRsvpAttendeeBatchClient.remove(calendarEventAttendeeIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarEventRsvpAttendeeBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpAttendeeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpAttendeeBatchRoute !== "undefined" && __1.CalendarEventRsvpAttendeeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarEventRsvpAttendeeBatchClient);
    return CalendarEventRsvpAttendeeBatchClient;
}());
exports.CalendarEventRsvpAttendeeBatchClient = CalendarEventRsvpAttendeeBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpAttendeeBatchRoute
 * @description BaasicCalendarEventRsvpAttendeeBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRsvpAtendeeBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CalendarEventRsvpAttendeeBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRsvpAttendeeBatchRoute, _super);
    function CalendarEventRsvpAttendeeBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendar-event-attendees/batch';
        _this.updateRoute = 'calendar-event-attendees/batch';
        _this.deleteRoute = 'calendar-event-attendees/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeBatchRoute.create();
     */
    CalendarEventRsvpAttendeeBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeBatchRoute.update();
     */
    CalendarEventRsvpAttendeeBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeBatchRoute.delete();
     */
    CalendarEventRsvpAttendeeBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarEventRsvpAttendeeBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRsvpAttendeeBatchRoute);
    return CalendarEventRsvpAttendeeBatchRoute;
}(common_1.BaseRoute));
exports.CalendarEventRsvpAttendeeBatchRoute = CalendarEventRsvpAttendeeBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpAttendeeClient
 * @description  CalendarEventRsvpAttendee Client provides an easy way to consume CalendarEventRsvpAttendee REST API end-points. In order to obtain needed routes `calendarEventRsvpAttendeeClient` uses `calendarEventRsvpAttendeeRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventRsvpAttendeeClient = /** @class */ (function () {
    function CalendarEventRsvpAttendeeClient(calendarEventRsvpAttendeeBatchClient, calendarEventRsvpAttendeeRoute, apiClient) {
        this.calendarEventRsvpAttendeeBatchClient = calendarEventRsvpAttendeeBatchClient;
        this.calendarEventRsvpAttendeeRoute = calendarEventRsvpAttendeeRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpAttendeeClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpAttendeeRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventRsvpAttendeeClient.prototype, "batch", {
        get: function () {
            return this.calendarEventRsvpAttendeeBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventAttendee resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarLookupOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventRsvpAttendeeClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    calendarIds: '<calendar-ids>',
                    calendarNames: '<calendar-names>',
                    eventIds: '<event-ids>',
                    invitationTypeIds: '<invitation-type-ids>',
                    attendeeStatusIds: '<attendee-status-ids>',
                    userIds: '<user-ids>',
                    slotDifference: <true|false>,
                    emails: '<e-mails>',
                    ids: '<identifiers>',
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventAttendee resource.
     * @method
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventRsvpAttendeeClient.get()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create CalendarEventAttendee action has been performed; this action creates a new CalendarEventAttendee resource.
     * @method
     * @param data A CalendarEventAttendee object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventAttendee action has been performed.
     * @example calendarEventRsvpAttendeeClient.create({
                    AttendeeStatus: <calendar-evetn-attendee-status>,
                    AttendeeStatusId '<attendee-status-id>',
                    DateCreated: '<date-created>',
                    DateUpdated: '<date-updated>',
                    Email: '<email>',
                    EventID: '<calendar-event-id>',
                    FullName: '<full-name>',
                    Id: '<id>',
                    InvitationType: <calendar-event-invitation-type>,
                    InvitationTypeId: '<invitation-type-id>',
                    Json: '<json>',
                    Slots: <slots>,
                    SlotsRequested: <slots-requested>,
                    User: <user-profile>,
                    UserID: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendee action has been performed. This action updates a CalendarEventAttendee resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventAttendee);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventAttendee object used to update specified CalendarEventAttendee resource.
     * @returns A promise that is resolved once the update CalendarEventAttendee action has been performed.
     * @example calendarEventAttendee is a resource previously fetched using get action.
                calendarEventAttendee.name = '<name>';
                calendarEventRsvpAttendeeClient.update(calendarEventAttendee)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendee Status action has been performed. This action updates a CalendarEventAttendee resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventAttendee);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param id CalendarEventAttendee id which uniquely identifies a CalendarEventAttendee resource.
     * @param statusId CalendarEventAttendeeStatus id which uniquely identifies a CalendarEventAttendeeStatus resource.
     * @returns A promise that is resolved once the update CalendarEventAttendee action has been performed.
     * @example calendarEventRsvpAttendeeClient.updateStatus(id, statusId)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeClient.prototype.updateStatus = function (id, statusId) {
        return this.apiClient.put(this.routeDefinition.updateStatus(id, statusId), {});
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventAttendee Status Email or FullName action has been performed. This action updates a CalendarEventAttendee resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventAttendee);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param id CalendarEventRsvpAttendee id which uniquely identifies a CalendarEventRsvpattendee resource.
     * @param emailOrFullName Email or full name
     * @param statusId CalendarEventAttendeeStatus id which uniquely identifies a CalendarEventRsvpAttendeeStatus resource.
     * @param securityToken Security Token.
     * @returns A promise that is resolved once the update CalendarEventAttendee action has been performed.
     * @example calendarEventRsvpAttendeeClient.updateStatusEmailOrFullName(id, email, statusId)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeClient.prototype.updateStatusEmailorFullName = function (id, emailOrFullName, statusId, securityToken) {
        var headers;
        headers['securityToken'] = securityToken;
        return this.apiClient.put(this.routeDefinition.updateStatusEmailOrFullName(id, emailOrFullName, statusId), {}, headers);
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEventAttendee resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventAttendee);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventAttendee object used to delete specified CalendarEventAttendee resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventAttendee is a resource previously fetched using get action.
                calendarEventRsvpAttendeeClient.remove(calendarEventType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    CalendarEventRsvpAttendeeClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventAttendee resources for the given event from the system if succesfully completed.
     * @method
     * @param event CalendarEvent resource that will have it's attendees purged.
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarEventRsvpAttendeeClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeClient.prototype.purge = function (event) {
        return this.apiClient.delete(this.routeDefinition.purge(event));
    };
    /**
     * Returns a promise that is resolved once the subscribe action has been performed. This action creates CalendarEventAttendee subscription to CalendarEvent changes.
     * @method
     * @param id CalendarEventAttendee identifier which uniquely identifies a CalendarEventAttendee resource.
     * @returns A promise that is resolved once the subscribe action has been performed.
     * @example calendarEventRsvpAttendeeClient.subscribe(attendeeId)
                .then(function (data) {
                    //perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeClient.prototype.subscribe = function (id) {
        return this.apiClient.post(this.routeDefinition.subscribe(id), {});
    };
    /**
     * Returns a promise that is resolved once the unsubscribe action has been performed. This action removes CalendarEventAttendee subscriotion to CalendarEvent changes.
     * @method
     * @param id CalendarEventAttendee identifier which uniquely identifies a CalendarEventAttendee resource.
     * @returns A promise that is resolved once the unsubscribe action has been performed.
     * @example calendarEventRsvpAttendeeClient.unsubscribe(attendeeId)
                .then(function (data) {
                    //perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeClient.prototype.unsubscribe = function (id) {
        return this.apiClient.delete(this.routeDefinition.unsubscribe(id));
    };
    var _a, _b, _c;
    CalendarEventRsvpAttendeeClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpAttendeeBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventRsvpAttendeeRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpAttendeeBatchClient !== "undefined" && __1.CalendarEventRsvpAttendeeBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventRsvpAttendeeRoute !== "undefined" && __1.CalendarEventRsvpAttendeeRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventRsvpAttendeeClient);
    return CalendarEventRsvpAttendeeClient;
}());
exports.CalendarEventRsvpAttendeeClient = CalendarEventRsvpAttendeeClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpAttendeeRoute
 * @description BaasicCalendarEventRsvpAttendeeRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRsvpAttendeeRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarEventRsvpAttendeeRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRsvpAttendeeRoute, _super);
    function CalendarEventRsvpAttendeeRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendar-event-attendees/{?searchQuery,page,rpp,sort,embed,fields,calendarIds,calendarNames,eventIds,invitationTypeIds,attendeeStatusIds,userIds,slotDifference,emails,from,to,ids}';
        _this.getRoute = 'calendar-event-attendees/{id}/{?embed,fields}';
        _this.createRoute = 'calendar-event-attendees';
        _this.updateRoute = 'calendar-event-attendees/{id}';
        _this.deleteRoute = 'calendar-event-attendees/{id}';
        _this.purgeRoute = 'calendar-event-attendees/{id}/purge';
        _this.updateStatusRoute = 'calendar-event-attendees/{id}/status/{attendeeStatusId}';
        _this.updateStatusEmailOrFullNameRoute = 'calendar-event-attendees/{id}/user/{emailOrFullName}/status/{attendeeStatusId}';
        _this.subscribeRoute = "calendar-event-attendees/{id}/subscribe";
        _this.unsubscribeRoute = "calendar-event-attendees/{id}/unsubscribe";
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarLookupOptions. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventAttendee properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventAttendee subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventAttendee property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `calendarIds` - calendar ids which identify CalendarEventAttendee resources.
     * - `calendarNames` - calendar names which identify CalendarEventAttendee resources.
     * - `eventIds` - eventIds which identify CalendarEventAttendee resources.
     * - `invitationTypeIds` - invitationTypeIds which identify CalendarEventAttendee resources.
     * - `attendeeStatusIds` - statusIds which identify CalendarEventAttendee resources.
     * - `userIds` - CalendarEventAttende userIds which identify CalendarEventAttendee resources.
     * - `slotDifference` - Slot difference.
     * - `emails` - CalendarEventAttendee emails which identify CalendarEventAttendee resources.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date.
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * - `ids` - CalendarEventAttendee ids which uniquely identify CalendarEventAttendee resources that need to be retrieved.
     * @method
     * @param options Query resource GetCalendarLookupOptions object.
     * @example calendarEventRsvpAttendeeRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarEventRsvpAttendeeRoute.prototype.find = function (options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventAttendee resource in the system. The route can be expanded using additional GetRequestOptions. Supported items are
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventAttendee id which uniquely identifies CalendarEventAttendee resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @example calendarEventRsvpAttendeeRoute.get(id);
     */
    CalendarEventRsvpAttendeeRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventAttendee object that needs to be inserted into the system.
     * @example calendarEventRsvpAttendeeRoute.create(data);
     */
    CalendarEventRsvpAttendeeRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventAttendee object used to update specified CalendarEventAttendee resource.
     * @example calendarEventRsvpAttendeeRoute.update(data);
     */
    CalendarEventRsvpAttendeeRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
    * Parses update status email or name route. This URI template does not expose any additional options.
    * @method
    * @param id A CalendarEventAttendee identifier which uniquely identifies CalendarEventAttendee resource.
    * @param statusId A calendarEventAttendeeStatus identifier which uniquely identifies CalendarEventAttendee resource.
    * @example calendarEventRsvpAttendeeRoute.update(id, statusId);
    */
    CalendarEventRsvpAttendeeRoute.prototype.updateStatus = function (id, statusId) {
        var params = {};
        params.id = id;
        params.attendeeStatusId = statusId;
        return _super.prototype.baseUpdate.call(this, this.updateStatusRoute, params);
    };
    /**
    * Parses update status email or name route. This URI template does not expose any additional options.
    * @method
    * @param id A CalendarEventAttendee identifier which uniquely identifies CalendarEventAttendee resource.
    * @param emailOrFullName Email or full name
    * @param statusId A calendarEventAttendeeStatus identifier which uniquely identifies CalendarEventAttendee resource.
    * @example calendarEventRsvpAttendeeRoute.update(id, email, statusId);
    */
    CalendarEventRsvpAttendeeRoute.prototype.updateStatusEmailOrFullName = function (id, emailOrFullName, statusId) {
        var params = {};
        params.id = id;
        params.attendeeStatusId = statusId;
        params.emailOrFullName = emailOrFullName;
        return _super.prototype.baseUpdate.call(this, this.updateStatusEmailOrFullNameRoute, params);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventAttendee object used to delete specified CalendarEventAttendee resource.
     * @example calendarEventRsvpAttendeeRoute.delete(data);
     */
    CalendarEventRsvpAttendeeRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses subscribe route. This URI template does not expose any additional options.
     * @method
     * @param id CalendarEventAttendee id which uniquely identifies a CalendarEventAttendee resource.
     * @example calendarEventRsvpAttendeeRoute.subscribe(attendeeId);
     */
    CalendarEventRsvpAttendeeRoute.prototype.subscribe = function (id) {
        var params = {};
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.subscribeRoute, params);
    };
    /**
     * Parses unsubscribe route. This URI template does not expose any additional options.
     * @method
     * @param id CalendarEventAttendee id which uniquely identifies a CalendarEventAttendee resource.
     * @example calendarEventRsvpAttendeeRoute.unsubscribe(attendeeId);
     */
    CalendarEventRsvpAttendeeRoute.prototype.unsubscribe = function (id) {
        var params = {};
        params.id = id;
        return _super.prototype.baseDelete.call(this, this.unsubscribeRoute, params);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeRoute.purge();
     */
    CalendarEventRsvpAttendeeRoute.prototype.purge = function (event) {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, event);
    };
    CalendarEventRsvpAttendeeRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarEventRsvpAttendeeRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarEventRsvpAttendeeRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRsvpAttendeeRoute);
    return CalendarEventRsvpAttendeeRoute;
}(common_1.BaseRoute));
exports.CalendarEventRsvpAttendeeRoute = CalendarEventRsvpAttendeeRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(609), exports);
tslib_1.__exportStar(__webpack_require__(610), exports);
tslib_1.__exportStar(__webpack_require__(611), exports);
tslib_1.__exportStar(__webpack_require__(612), exports);


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpInvitationTypeBatchClient
 * @description  CalendarEventRsvpInvitationTypeBatchClient provides an easy way to consume CalendarEventRsvpInvitationTypeBatch REST API end-points. In order to obtain needed routes `calendarEventRsvpInvitationTypeBatchClient` uses `calendarEventRsvpInvitationTypeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventRsvpInvitationTypeBatchClient = /** @class */ (function () {
    function CalendarEventRsvpInvitationTypeBatchClient(calendarEventRsvpInvitationTypeBatchRoute, apiClient) {
        this.calendarEventRsvpInvitationTypeBatchRoute = calendarEventRsvpInvitationTypeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpInvitationTypeBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpInvitationTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create CalendarEventRsvpAttendeeInvitationTypes action has been performed; this action creates new CalendarEventRsvpAttendeeInvitationType resources.
     * @method
     * @param data CalendarEventRsvpAttendeeInvitationType objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventRsvpAttendeeInvitationTypes action has been performed.
     * @example calendarEventRsvpInvitationTypeBatchClient.create([{
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvpAttendeeInvitationTypes action has been performed; this action updates CalendarEventRsvpAttendeeInvitationType resources.
     * @method
     * @param data CalendarEventRsvpAttendeeInvitationType objects used to update specified CalendarEventRsvpAttendeeInvitationType resources.
     * @returns A promise that is resolved once the update CalendarEventRsvpAttendeeInvitationTypes action has been performed.
     * @example calendarEventRsvpAttendeeInvitationTypes are resources previously fetched using get action.
                calendarEventRsvpInvitationTypeBatchClient.update(calendarEventRsvpAttendeeInvitationTypes)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove CalendarEventRsvpInvitationType resources from the system if successfully completed.
     * @method
     * @param data CalendarEventRsvpAttendeeInvitationType Ids which uniquely identify CalendarEventRsvpAttendeeInvitationType resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventRsvpAttendeeInvitationTypeIds are identifiers which uniquely identify CalendarEventRsvpAttendeeInvitationType resources.
                calendarEventRsvpInvitationTypeBatchClient.remove(calendarEventRsvpAttendeeInvitationTypeIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarEventRsvpInvitationTypeBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpInvitationTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpInvitationTypeBatchRoute !== "undefined" && __1.CalendarEventRsvpInvitationTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarEventRsvpInvitationTypeBatchClient);
    return CalendarEventRsvpInvitationTypeBatchClient;
}());
exports.CalendarEventRsvpInvitationTypeBatchClient = CalendarEventRsvpInvitationTypeBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpInvitationTypeBatchRoute
 * @description BaasicCalendarEventRsvpInvitationTypeBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEvantRsvpInvitationTypeBatchRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CalendarEventRsvpInvitationTypeBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRsvpInvitationTypeBatchRoute, _super);
    function CalendarEventRsvpInvitationTypeBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendar-lookups/rsvp-invitation-types/batch';
        _this.updateRoute = 'calendar-lookups/rsvp-invitation-types/batch';
        _this.deleteRoute = 'calendar-lookups/rsvp-invitation-types/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpInvitationTypeBatchRoute.create();
     */
    CalendarEventRsvpInvitationTypeBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpInvitationTypeBatchRoute.update();
     */
    CalendarEventRsvpInvitationTypeBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delete route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpInvitationTypeBatchRoute.delete();
     */
    CalendarEventRsvpInvitationTypeBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarEventRsvpInvitationTypeBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRsvpInvitationTypeBatchRoute);
    return CalendarEventRsvpInvitationTypeBatchRoute;
}(common_1.BaseRoute));
exports.CalendarEventRsvpInvitationTypeBatchRoute = CalendarEventRsvpInvitationTypeBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpInvitationTypeClient
 * @description  CalendarEventRsvpInvitationTypeClient provides an easy way to consume CalendarEventRsvpInvitationType REST API end-points. In order to obtain needed routes `calendarEventRsvpInvitationTypeClient` uses `calendarEventRsvpInvitationTypeRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventRsvpInvitationTypeClient = /** @class */ (function () {
    function CalendarEventRsvpInvitationTypeClient(calendarEventRsvpInvitationTypeBatchClient, calendarEventRsvpInvitationTypeRoute, apiClient) {
        this.calendarEventRsvpInvitationTypeBatchClient = calendarEventRsvpInvitationTypeBatchClient;
        this.calendarEventRsvpInvitationTypeRoute = calendarEventRsvpInvitationTypeRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpInvitationTypeClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpInvitationTypeRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventRsvpInvitationTypeClient.prototype, "batch", {
        get: function () {
            return this.calendarEventRsvpInvitationTypeBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventRsvpAttendeeInvitationType resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventRsvpInvitationTypeClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <identifiers>,
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventRsvpAttendeeInvitationType resource.
     * @method
     * @param id CalendarEventRsvpAttendeeInvitationType id which uniquely identifies CalendarEventRsvpAttendeeInvitationType resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventRsvpInvitationTypeClient.get(id)
                    .then(function (data) {
                        // perform success action here
                    },
                    function (response, status, headers, config) {
                        // perform error handling here
                    });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create CalendarEventRsvpAttendeeInvitationType action has been performed; this action creates a new CalendarEventRsvpAttendeeInvitationType resource.
     * @method
     * @param data A CalendarEventRsvpAttendeeInvitationType object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventRsvpAttendeeInvitationType action has been performed.
     * @example calendarEventRsvpInvitationTypeClient.create({
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvpAttendeeInvitationType action has been performed; this action updates a CalendarEventRsvpAttendeeInvitationType resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRsvpInvitationTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvpAttendeeInvitationType);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventRsvpAttendeeInvitationType object used to update specified CalendarEventRsvpAttendeeInvitationType resource.
     * @returns A promise that is resolved once the update CalendarEventRsvpAttendeeInvitationType action has been performed.
     * @example calendarEventRsvpAttendeeInvitationType is a resource previously fetched using get action.
                calendarEventRsvpAttendeeInvitationType.name = '<name>';
                calendarEventRsvpInvitationTypeClient.update(calendarEventRsvpAttendeeInvitationType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEventRsvpAttendeeInvitationType resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRsvpAttendeeInvitationTyleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvpAttendeeInvitationType);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventRsvpAttendeeInvitationType object used to delete specified CalendarEventRsvpAttendeeInvitationType resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventRsvpAttendeeInvitationType is a resource previously fetched using get action.
                calendarEventRsvpInvitationType.remove(calendarEventRsvpAttendeeInvitationType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventRsvpAttendeeInvitationType resources from the system if succesfully completed.
     * @method
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarEventRsvpInvitationTypeClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpInvitationTypeClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c;
    CalendarEventRsvpInvitationTypeClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpInvitationTypeBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventRsvpInvitationTypeRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpInvitationTypeBatchClient !== "undefined" && __1.CalendarEventRsvpInvitationTypeBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventRsvpInvitationTypeRoute !== "undefined" && __1.CalendarEventRsvpInvitationTypeRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventRsvpInvitationTypeClient);
    return CalendarEventRsvpInvitationTypeClient;
}());
exports.CalendarEventRsvpInvitationTypeClient = CalendarEventRsvpInvitationTypeClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpInvitationTypeRoute
 * @description BaasicCalendarEventRsvpInvitationTypeRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRsvpInvitationTypeRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarEventRsvpInvitationTypeRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRsvpInvitationTypeRoute, _super);
    function CalendarEventRsvpInvitationTypeRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendar-lookups/rsvp-invitation-types/{?searchQuery,page,rpp,sort,embed,fields,from,to,ids}';
        _this.getRoute = 'calendar-lookups/rsvp-invitation-types/{id}/{?embed,fields}';
        _this.createRoute = 'calendar-lookups/rsvp-invitation-types';
        _this.updateRoute = 'calendar-lookups/rsvp-invitation-types/{id}';
        _this.deleteRoute = 'calendar-lookups/rsvp-invitation-types/{id}';
        _this.purgeRoute = 'calendar-lookups/rsvp-invitation-types/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventRsvpAttendeeInvitationType properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventRsvpAttendeeInvitationType subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventRsvpAttendeeInvitationType property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use events starting from this date
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use events ending to this date.
     * - `ids` - CalendarEventRsvpAttendeeInvitationType ids which uniquely identify CalendarEventRsvpAttendeeInvitationType resources that need to be retrieved.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @example calendarEventRsvpInvitationTypeRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarEventRsvpInvitationTypeRoute.prototype.find = function (options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventRsvpAttendeeInvitationType resource. The route can be expanded using additional options. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventRsvpAttendeeInvitationType id which uniquely identifies CalendarEventRsvpInvitationType resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example calendarEventRsvpInvitationTypeRoute.get(id);
     */
    CalendarEventRsvpInvitationTypeRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvpInvitationType object that needs to be inserted into the system.
     * @example calendarEventRsvpInvitationTypeRoute.create(data);
     */
    CalendarEventRsvpInvitationTypeRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvpInvitationType object used to update specified CalendarEventRsvpInvitationType resource.
     * @example calendarEventRsvpInvitationTypeRoute.update(data);
     */
    CalendarEventRsvpInvitationTypeRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvpInvitationType object used to delete specified CalendarEventRsvpInvitationType resource.
     * @example calendarEventRsvpInvitationTypeRoute.delete(data);
     */
    CalendarEventRsvpInvitationTypeRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpInvitationTypeRoute.purge();
     */
    CalendarEventRsvpInvitationTypeRoute.prototype.purge = function () {
        return _super.prototype.parse.call(this, this.purgeRoute);
    };
    CalendarEventRsvpInvitationTypeRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarEventRsvpInvitationTypeRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarEventRsvpInvitationTypeRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRsvpInvitationTypeRoute);
    return CalendarEventRsvpInvitationTypeRoute;
}(common_1.BaseRoute));
exports.CalendarEventRsvpInvitationTypeRoute = CalendarEventRsvpInvitationTypeRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(614), exports);
tslib_1.__exportStar(__webpack_require__(615), exports);
tslib_1.__exportStar(__webpack_require__(616), exports);
tslib_1.__exportStar(__webpack_require__(617), exports);


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpAttendeeStatusBatchClient
 * @description  CalendarEventRsvpAttendeeStatusBatchClient provides an easy way to consume CalendarEventRsvpAttendeeStatusBatch REST API end-points. In order to obtain needed routes `calendarEventRsvpAttendeeStatusBatchClient` uses `calendarEventRsvpAttendeeStatusBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventRsvpAttendeeStatusBatchClient = /** @class */ (function () {
    function CalendarEventRsvpAttendeeStatusBatchClient(calendarEventRsvpAttendeeStatusBatchRoute, apiClient) {
        this.calendarEventRsvpAttendeeStatusBatchRoute = calendarEventRsvpAttendeeStatusBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpAttendeeStatusBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpAttendeeStatusBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create CalendarEventRsvpAttendeeStatuses action has been performed. This action creates new CalendarEventRsvpAttendeeStatus resources.
     * @method
     * @param data CalendarEventRsvpAttendeeStatus objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventRsvpAttendeeStatuses action has been performed.
     * @example calendarEventRsvpAttendeeStatusBatchClient.create([{
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvpAttendeeStatuses action has been performed. This action updates CalendarEventRsvpAttendeeStatus resources.
     * @method
     * @param data CalendarEventRsvpAttendeeStatus objects used to update specified CalendarEventRsvpAttendeeStatus resources.
     * @returns A promise that is resolved once the update CalendarEventRsvpAttendeeStatuses action has been performed.
     * @example calendarEventRsvpAttendeeStatuses are resources previously fetched using get action.
                calendarEventRsvpAttendeeStatusBatchClient.update(calendarEventRsvpAttendeeStatuses)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove CalendarEventRsvpAttendeeStatus resources from the system if successfully completed.
     * @method
     * @param data CalendarEventRsvpAttendeeStatus Ids which uniquely identify CalendarEventRsvpAttendeeStatus resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventRsvpAttendeeStatusIds are identifiers which uniquely identify CalendarEventRsvpAttendeeStatus resources.
                calendarEventRsvpAttendeeStatusBatchClient.remove(calendarEventRsvpAttendeeStatusIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarEventRsvpAttendeeStatusBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpAttendeeStatusBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpAttendeeStatusBatchRoute !== "undefined" && __1.CalendarEventRsvpAttendeeStatusBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarEventRsvpAttendeeStatusBatchClient);
    return CalendarEventRsvpAttendeeStatusBatchClient;
}());
exports.CalendarEventRsvpAttendeeStatusBatchClient = CalendarEventRsvpAttendeeStatusBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpAttendeeStatusBatchRoute
 * @description BaasicCalendarEventRsvpAttendeeStatusBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRsvpAtendeeStatusBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CalendarEventRsvpAttendeeStatusBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRsvpAttendeeStatusBatchRoute, _super);
    function CalendarEventRsvpAttendeeStatusBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendar-lookups/rsvp-attendee-statuses/batch';
        _this.updateRoute = 'calendar-lookups/rsvp-attendee-statuses/batch';
        _this.deleteRoute = 'calendar-lookups/rsvp-attendee-statuses/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeStatusBatchRoute.create();
     */
    CalendarEventRsvpAttendeeStatusBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeStatusBatchRoute.update();
     */
    CalendarEventRsvpAttendeeStatusBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeStatusBatchRoute.delete();
     */
    CalendarEventRsvpAttendeeStatusBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarEventRsvpAttendeeStatusBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRsvpAttendeeStatusBatchRoute);
    return CalendarEventRsvpAttendeeStatusBatchRoute;
}(common_1.BaseRoute));
exports.CalendarEventRsvpAttendeeStatusBatchRoute = CalendarEventRsvpAttendeeStatusBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpAttendeeStatusClient
 * @description  CalendarEventRsvpAttendeeStatus Client provides an easy way to consume CalendarEventRsvpAttendeeStatus REST API end-points. In order to obtain needed routes `calendarEventRsvpAttendeeStatusClient` uses `calendarEventRsvpAttendeeStatusRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventRsvpAttendeeStatusClient = /** @class */ (function () {
    function CalendarEventRsvpAttendeeStatusClient(calendarEventRsvpAttendeeStatusBatchclient, calendarEventRsvpAttendeeStatusRoute, apiClient) {
        this.calendarEventRsvpAttendeeStatusBatchclient = calendarEventRsvpAttendeeStatusBatchclient;
        this.calendarEventRsvpAttendeeStatusRoute = calendarEventRsvpAttendeeStatusRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventRsvpAttendeeStatusClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventRsvpAttendeeStatusRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventRsvpAttendeeStatusClient.prototype, "batch", {
        get: function () {
            return this.calendarEventRsvpAttendeeStatusBatchclient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventRsvpAttendeeStatus resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventRsvpAttendeeStatusClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <identifiers>,
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventRsvpAttendeeStatus resource.
     * @method
     * @param id CalendarEventRsvpAttendeeStatus id which uniquely identifies CalendarEventRsvpAttendeeStatus resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventRsvpAttendeeStatusClient.get()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create CalendarEventRsvpAttendeeStatus action has been performed. This action creates a new CalendarEventRsvpAttendeeStatus resource.
     * @method
     * @param data A CalendarEventRsvpAttendeeStatus object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventRsvpAttendeeStatus action has been performed.
     * @example calendarEventRsvpAttendeeStatusClient.create({
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventRsvpAttendeeStatus action has been performed. This action updates a CalendarEventRsvpAttendeeStatus resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRsvpAttendeeStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvpAttendeeStatus);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventRsvpAttendeeStatus object used to update specified CalendarEventRsvpAttendeeStatus resource.
     * @returns A promise that is resolved once the update CalendarEventRsvpAttendeeStatus action has been performed.
     * @example calendarEventRsvpAttendeeStatus is a resource previously fetched using get action.
                calendarEventRsvpAttendeeStatus.name = '<name>';
                calendarEventRsvpAttendeeStatusClient.update(calendarEventRsvpAttendeeStatus)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEventRsvpAttendeeStatus resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRsvpAttendeeStatusRsvpAttendeeStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventRsvpAttendeeStatus);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventRsvpAttendeeStatus object used to delete specified CalendarEventRsvpAttendeeStatus resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventRsvpAttendeeStatus is a resource previously fetched using get action.
                calendarEventRsvpAttendeeStatusClient.remove(calendarEventRsvpAttendeeStatus)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventRsvpAttendeeStatus resources from the system if succesfully completed.
     * @method
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarEventRsvpAttendeeStatusClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventRsvpAttendeeStatusClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c;
    CalendarEventRsvpAttendeeStatusClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpAttendeeStatusBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventRsvpAttendeeStatusRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventRsvpAttendeeStatusBatchClient !== "undefined" && __1.CalendarEventRsvpAttendeeStatusBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventRsvpAttendeeStatusRoute !== "undefined" && __1.CalendarEventRsvpAttendeeStatusRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventRsvpAttendeeStatusClient);
    return CalendarEventRsvpAttendeeStatusClient;
}());
exports.CalendarEventRsvpAttendeeStatusClient = CalendarEventRsvpAttendeeStatusClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventRsvpAttendeeStatusRoute
 * @description BaasicCalendarEventRsvpAttendeeStatusRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventRsvpAttendeeStatusRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarEventRsvpAttendeeStatusRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventRsvpAttendeeStatusRoute, _super);
    function CalendarEventRsvpAttendeeStatusRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendar-lookups/rsvp-attendee-statuses/{?searchQuery,page,rpp,sort,embed,fields,from,to,ids}';
        _this.getRoute = 'calendar-lookups/rsvp-attendee-statuses/{id}/{?embed,fields}';
        _this.createRoute = 'calendar-lookups/rsvp-attendee-statuses';
        _this.updateRoute = 'calendar-lookups/rsvp-attendee-statuses/{id}';
        _this.deleteRoute = 'calendar-lookups/rsvp-attendee-statuses/{id}';
        _this.purgeRoute = 'calendar-lookups/rsvp-attendee-statuses/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarOptions. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventRsvpAttendeeStatus properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventRsvpAttendeeStatus subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventRsvpAttendeeStatus property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * - `ids` - CalendarEventRsvpAttendeeStatus ids which uniquely identify CalendarEventRsvpAttendeeStatus resources that need to be retrieved.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @example calendarEventRsvpAttendeeStatusRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarEventRsvpAttendeeStatusRoute.prototype.find = function (options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventRsvpAttendeeStatus resource. This route can be expanded using additional GetRequestOptions. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventRsvpAttendeeStatus id which uniquely identifies CalendarEventRsvpAttendeeStatus resource that needs to be retrieved.
     * @param options Query resource GEtRequestOptions object.
     * @example calendarEventRsvpAttendeeStatusRoute.get(id);
     */
    CalendarEventRsvpAttendeeStatusRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvpAttendeeStatus object that needs to be inserted into the system.
     * @example calendarEventRsvpAttendeeStatusRoute.create(data);
     */
    CalendarEventRsvpAttendeeStatusRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvpAttendeeStatus object used to update specified CalendarEventRsvpAttendeeStatus resource.
     * @example calendarEventRsvpAttendeeStatusRoute.update(data);
     */
    CalendarEventRsvpAttendeeStatusRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventRsvpAttendeeStatus object used to delete specified CalendarEventRsvpAttendeeStatus resource.
     * @example calendarEventRsvpAttendeeStatusRoute.delete(data);
     */
    CalendarEventRsvpAttendeeStatusRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventRsvpAttendeeStatusRoute.purge();
     */
    CalendarEventRsvpAttendeeStatusRoute.prototype.purge = function () {
        return _super.prototype.parse.call(this, this.purgeRoute);
    };
    CalendarEventRsvpAttendeeStatusRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarEventRsvpAttendeeStatusRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarEventRsvpAttendeeStatusRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventRsvpAttendeeStatusRoute);
    return CalendarEventRsvpAttendeeStatusRoute;
}(common_1.BaseRoute));
exports.CalendarEventRsvpAttendeeStatusRoute = CalendarEventRsvpAttendeeStatusRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(619), exports);
tslib_1.__exportStar(__webpack_require__(620), exports);
tslib_1.__exportStar(__webpack_require__(621), exports);
tslib_1.__exportStar(__webpack_require__(622), exports);


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventStatusBatchClient
 * @description  CalendarEventStatusBatchClient provides an easy way to consume CalendarEventStatusBatch REST API end-points. In order to obtain needed routes `calendarEventStatusBatchClient` uses `calendarEventStatusBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventStatusBatchClient = /** @class */ (function () {
    function CalendarEventStatusBatchClient(calendarEventStatusBatchRoute, apiClient) {
        this.calendarEventStatusBatchRoute = calendarEventStatusBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventStatusBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventStatusBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create CalendarEventStatuses action has been performed. This action creates new CalendarEventStatus resources.
     * @method
     * @param data CalendarEventStatus objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventStatuses action has been performed.
     * @example calendarEventStatusBatchClient.create([{
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventStatuses action has been performed. This action updates CalendarEventStatuse resources.
     * @method
     * @param data CalendarEventStatus objects used to update specified CalendarEventStatus resources.
     * @returns A promise that is resolved once the update CalendarEventStatuses action has been performed.
     * @example calendarEventStatuses are resources previously fetched using get action.
                calendarEventStatusBatchClient.update(calendarEventStatuses)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove CalendarEventStatus resources from the system if successfully completed.
     * @method
     * @param data CalendarEventStatus Ids which uniquely identify CalendarEventStatus resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventStatusIds are identifiers which uniquely identify CalendarEventStatus resources.
                calendarEventStatusBatchClient.remove(calendarEventStatusIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarEventStatusBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventStatusBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventStatusBatchRoute !== "undefined" && __1.CalendarEventStatusBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarEventStatusBatchClient);
    return CalendarEventStatusBatchClient;
}());
exports.CalendarEventStatusBatchClient = CalendarEventStatusBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventStatusBatchRoute
 * @description BaasicCalendarEventStatusBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEvantStatusBatchRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CalendarEventStatusBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventStatusBatchRoute, _super);
    function CalendarEventStatusBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendar-lookups/statuses/batch';
        _this.updateRoute = 'calendar-lookups/statuses/batch';
        _this.deleteRoute = 'calendar-lookups/statuses/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventStatusBatchRoute.create();
     */
    CalendarEventStatusBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventStatusBatchRoute.update();
     */
    CalendarEventStatusBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventStatusBatchRoute.delete();
     */
    CalendarEventStatusBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarEventStatusBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventStatusBatchRoute);
    return CalendarEventStatusBatchRoute;
}(common_1.BaseRoute));
exports.CalendarEventStatusBatchRoute = CalendarEventStatusBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventStatusClient
 * @description  CalendarEventStatusClient provides an easy way to consume CalendarEventStatus REST API end-points. In order to obtain needed routes `calendarEventStatusClient` uses `calendarEventStatusRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventStatusClient = /** @class */ (function () {
    function CalendarEventStatusClient(calendarEventStatusBatchClient, calendarEventStatusRoute, apiClient) {
        this.calendarEventStatusBatchClient = calendarEventStatusBatchClient;
        this.calendarEventStatusRoute = calendarEventStatusRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventStatusClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventStatusRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventStatusClient.prototype, "batch", {
        get: function () {
            return this.calendarEventStatusBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventStatus resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventStatusClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <identifiers>,
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventStatus resource.
     * @method
     * @param id CalendarEventStatus id which uniquely identifies CalendarEventStatus resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventStatusClient.get()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create CalendarEventStatus action has been performed; this action creates a new CalendarEventStatus resource.
     * @method
     * @param data A CalendarEventStatus object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventStatus action has been performed.
     * @example calendarEventStatusClient.create({
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventStatus action has been performed. This action updates a CalendarEventStatus resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventStatus);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventStatus object used to update specified CalendarEventStatus resource.
     * @returns A promise that is resolved once the update CalendarEventStatus action has been performed.
     * @example calendarEventStatus is a resource previously fetched using get action.
                calendarEventStatus.name = '<name>';
                calendarEventStatusClient.update(calendarEventStatus)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEventStatus resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventStatus);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventStatus object used to delete specified CalendarEventStatus resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventStatus is a resource previously fetched using get action.
                calendarEventStatusClient.remove(calendarEventType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventStatus resources from the system if succesfully completed.
     * @method
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarEventStatusClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventStatusClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c;
    CalendarEventStatusClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventStatusBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventStatusRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventStatusBatchClient !== "undefined" && __1.CalendarEventStatusBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventStatusRoute !== "undefined" && __1.CalendarEventStatusRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventStatusClient);
    return CalendarEventStatusClient;
}());
exports.CalendarEventStatusClient = CalendarEventStatusClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventStatusRoute
 * @description BaasicCalendarEventStatusRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventStatusRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarEventStatusRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventStatusRoute, _super);
    function CalendarEventStatusRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendar-lookups/statuses/{?searchQuery,page,rpp,sort,embed,fields,from,to,ids}';
        _this.getRoute = 'calendar-lookups/statuses/{id}/{?embed,fields}';
        _this.createRoute = 'calendar-lookups/statuses';
        _this.updateRoute = 'calendar-lookups/statuses/{id}';
        _this.deleteRoute = 'calendar-lookups/statuses/{id}';
        _this.purgeRoute = 'calendar-lookups/statuses/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventStatus properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventStatus subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventStatus property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use events starting from this date
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use events ending to this date.
     * - `ids` - CalendarEventStatus ids which uniquely identify CalendarEventStatus resources that need to be retrieved
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @example calendarEventStatusRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarEventStatusRoute.prototype.find = function (options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventStatus resource. The route can be expanded using additional options. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventStatus id which uniquely identifies CalendarEventStatus resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @example calendarEventStatusRoute.get(id);
     */
    CalendarEventStatusRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventStatus object that needs to be inserted into the system.
     * @example calendarEventStatusRoute.create(data);
     */
    CalendarEventStatusRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventStatus object used to update specified CalendarEventStatus resource.
     * @example calendarEventStatusRoute.update(data);
     */
    CalendarEventStatusRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventStatus object used to delete specified CalendarEventStatus resource.
     * @example calendarEventStatusRoute.delete(data);
     */
    CalendarEventStatusRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventStatusRoute.purge();
     */
    CalendarEventStatusRoute.prototype.purge = function () {
        return _super.prototype.parse.call(this, this.purgeRoute);
    };
    CalendarEventStatusRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarEventStatusRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarEventStatusRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventStatusRoute);
    return CalendarEventStatusRoute;
}(common_1.BaseRoute));
exports.CalendarEventStatusRoute = CalendarEventStatusRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(624), exports);
tslib_1.__exportStar(__webpack_require__(625), exports);
tslib_1.__exportStar(__webpack_require__(626), exports);
tslib_1.__exportStar(__webpack_require__(627), exports);


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventTypeBatchClient
 * @description  CalendarEventTypeBatchClient provides an easy way to consume CalendarEventTypeBatch REST API end-points. In order to obtain needed routes `calendarEventTypeBatchClient` uses `calendarEventTypeBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventTypeBatchClient = /** @class */ (function () {
    function CalendarEventTypeBatchClient(calendarEventTypeBatchRoute, apiClient) {
        this.calendarEventTypeBatchRoute = calendarEventTypeBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventTypeBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventTypeBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create CalendarEventTypes action has been performed; this action creates new CalendarEventType resources.
     * @method
     * @param data CalendarEventType objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventTypes action has been performed.
     * @example calendarEventTypeBatchClient.create([{
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventTypes action has been performed; this action updates CalendarEventType resources.
     * @method
     * @param data CalendarEventType objects used to update specified CalendarEventType resources.
     * @returns A promise that is resolved once the update CalendarEventTypes action has been performed.
     * @example calendarEventTypes are resources previously fetched using get action.
                calendarEventTypeBatchClient.update(calendarEventTypes)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
    */
    CalendarEventTypeBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove CalendarEventType resources from the system if successfully completed.
     * @method
     * @param data CalendarEventType Ids which uniquely identify CalendarEventType resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventTypeIds are identifiers which uniquely identify CalendarEventType resources.
                calendarEventTypeBatchClient.remove(calendarEventTypeIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarEventTypeBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventTypeBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventTypeBatchRoute !== "undefined" && __1.CalendarEventTypeBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarEventTypeBatchClient);
    return CalendarEventTypeBatchClient;
}());
exports.CalendarEventTypeBatchClient = CalendarEventTypeBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventTypeBatchRoute
 * @description BaasicCalendarEventTypeBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventTypeBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CalendarEventTypeBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventTypeBatchRoute, _super);
    function CalendarEventTypeBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendar-lookups/types/batch';
        _this.updateRoute = 'calendar-lookups/types/batch';
        _this.deleteRoute = 'calendar-lookups/types/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventTypeBatchRoute.create();
     */
    CalendarEventTypeBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventTypeBatchRoute.update();
     */
    CalendarEventTypeBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventTypeBatchRoute.delete();
     */
    CalendarEventTypeBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarEventTypeBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventTypeBatchRoute);
    return CalendarEventTypeBatchRoute;
}(common_1.BaseRoute));
exports.CalendarEventTypeBatchRoute = CalendarEventTypeBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventTypeClient
 * @description  CalendarEventType Client provides an easy way to consume CalendarEventType REST API end-points. In order to obtain needed routes `calendarEventTypeClient` uses `calendarEventTypeRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var __1 = __webpack_require__(7);
var CalendarEventTypeClient = /** @class */ (function () {
    function CalendarEventTypeClient(calendarEventTypeBatchClient, calendarEventTypeRoute, apiClient) {
        this.calendarEventTypeBatchClient = calendarEventTypeBatchClient;
        this.calendarEventTypeRoute = calendarEventTypeRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarEventTypeClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarEventTypeRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarEventTypeClient.prototype, "batch", {
        get: function () {
            return this.calendarEventTypeBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of CalendarEventType resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarEventTypeClient.find({
                    pageNumber: 1,
                    pageSize: 10,
                    orderBy: '<field>',
                    orderDirection: '<asc|desc>',
                    search: '<search-phrase>',
                    ids: <identifiers>,
                    from: <start-date>,
                    to: <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the CalendarEventType resource.
     * @method
     * @param id CalendarEventType id which uniquely identifies CalendarEventType resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarEventTypeClient.get(id)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create CalendarEventType action has been performed. This action creates a new CalendarEventType resource.
     * @method
     * @param data A CalendarEventType object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create CalendarEventType action has been performed.
     * @example calendarEventTypeClient.create({
                    abrv: '<abrv>',
                    json: '<json>',
                    name: '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update CalendarEventType action has been performed. This action updates a CalendarEventType resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventType);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A CalendarEventType object used to update specified CalendarEventType resource.
     * @returns A promise that is resolved once the update CalendarEventType action has been performed.
     * @example calendarEventType is a resource previously fetched using get action.
                calendarEventType.name = '<name>';
                calendarEventTypeClient.update(calendarEventType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a CalendarEventType resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventTypeRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendarEventType);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendarEventType object used to delete specified CalendarEventType resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarEventType is a resource previously fetched using get action.
                calendarEventTypeClient.remove(calendarEventType)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all CalendarEventType resources from the system if succesfully completed.
     * @method
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarEventTypeClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarEventTypeClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c;
    CalendarEventTypeClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventTypeBatchClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventTypeRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof __1.CalendarEventTypeBatchClient !== "undefined" && __1.CalendarEventTypeBatchClient) === "function" ? _a : Object, typeof (_b = typeof __1.CalendarEventTypeRoute !== "undefined" && __1.CalendarEventTypeRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CalendarEventTypeClient);
    return CalendarEventTypeClient;
}());
exports.CalendarEventTypeClient = CalendarEventTypeClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarEventTypeRoute
 * @description BaasicCalendarEventTypeRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarEventTypeRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarEventTypeRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarEventTypeRoute, _super);
    function CalendarEventTypeRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendar-lookups/types/{?searchQuery,page,rpp,sort,embed,fields,from,to,ids}';
        _this.getRoute = 'calendar-lookups/types/{id}/{?embed,fields}';
        _this.createRoute = 'calendar-lookups/types';
        _this.updateRoute = 'calendar-lookups/types/{id}';
        _this.deleteRoute = 'calendar-lookups/types/{id}';
        _this.purgeRoute = 'calendar-lookups/types/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarOptions. Supported items are:
     * - `searchQuery` - A string referencing CalendarEventType properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain CalendarEventType subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the CalendarEventType property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date.
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * - `ids` - CalendarEventType ids which uniquely identify CalendarEventType resources that need to be retrieved.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @example calendarEventTypeRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarEventTypeRoute.prototype.find = function (options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created CalendarEventType resource in the system. The route can be expanded using additional GetRequestOptions. Supported items are
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id CalendarEventType id which uniquely identifies CalendarEventType resource that needs to be retrieved.
     * @param options Query resource GetRequestOptions object.
     * @example calendarEventTypeRoute.get(id);
     */
    CalendarEventTypeRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventType object that needs to be inserted into the system.
     * @example calendarEventTypeRoute.create(data);
     */
    CalendarEventTypeRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventType object used to update specified CalendarEventType resource.
     * @example calendarEventTypeRoute.update(data);
     */
    CalendarEventTypeRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param data A CalendarEventType object used to delete specified CalendarEventType resource.
     * @example calendarEventTypeRoute.delete(data);
     */
    CalendarEventTypeRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @example calendarEventTypeRoute.purge();
     */
    CalendarEventTypeRoute.prototype.purge = function () {
        return _super.prototype.parse.call(this, this.purgeRoute);
    };
    CalendarEventTypeRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarEventTypeRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarEventTypeRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarEventTypeRoute);
    return CalendarEventTypeRoute;
}(common_1.BaseRoute));
exports.CalendarEventTypeRoute = CalendarEventTypeRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var __1 = __webpack_require__(7);
var _1 = __webpack_require__(48);
var inversify_1 = __webpack_require__(1);
var CalendarLookups = /** @class */ (function () {
    function CalendarLookups(rsvpInvitationType, rsvpAttendeeStatus, eventStatus, eventType) {
        this.rsvpInvitationType = rsvpInvitationType;
        this.rsvpAttendeeStatus = rsvpAttendeeStatus;
        this.eventStatus = eventStatus;
        this.eventType = eventType;
    }
    var _a, _b, _c, _d;
    CalendarLookups = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(__1.TYPES.CalendarEventRsvpInvitationTypeClient)),
        tslib_1.__param(1, inversify_1.inject(__1.TYPES.CalendarEventRsvpAttendeeStatusClient)),
        tslib_1.__param(2, inversify_1.inject(__1.TYPES.CalendarEventStatusClient)),
        tslib_1.__param(3, inversify_1.inject(__1.TYPES.CalendarEventTypeClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CalendarEventRsvpInvitationTypeClient !== "undefined" && _1.CalendarEventRsvpInvitationTypeClient) === "function" ? _a : Object, typeof (_b = typeof _1.CalendarEventRsvpAttendeeStatusClient !== "undefined" && _1.CalendarEventRsvpAttendeeStatusClient) === "function" ? _b : Object, typeof (_c = typeof _1.CalendarEventStatusClient !== "undefined" && _1.CalendarEventStatusClient) === "function" ? _c : Object, typeof (_d = typeof _1.CalendarEventTypeClient !== "undefined" && _1.CalendarEventTypeClient) === "function" ? _d : Object])
    ], CalendarLookups);
    return CalendarLookups;
}());
exports.CalendarLookups = CalendarLookups;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarBatchClient
 * @description  CalendarBatchClient provides an easy way to consume CalendarBatch REST API end-points. In order to obtain needed routes `calendarBatchClient` uses `calendarBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(7);
var CalendarBatchClient = /** @class */ (function () {
    function CalendarBatchClient(calendarBatchRoute, apiClient) {
        this.calendarBatchRoute = calendarBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create Calendars action has been performed; this action creates new Calendar resources.
     * @method
     * @param data Calendar objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create Calendars action has been performed.
     * @example calendarBatchClient.create([{
                    abrv: '<abrv>',
                    description: '<description>',
                    json: '<json>',
                    name: '<name>',
                    owner: <user-info>,
                    ownerId: '<owner-id>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update Calendars action has been performed; this action updates Calendar resources.
     * @method
     * @param data Calendar objects used to update specified Calendar resources.
     * @returns A promise that is resolved once the update Calendars action has been performed.
     * @example calendars are resources previously fetched using get action.
                calendarBatchClient.update(calendars)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove Calendar resources from the system if successfully completed.
     * @method
     * @param data Calendar Ids which uniquely identify Calendar resources to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendarIds are identifiers which uniquely identify Calendar resources.
                calendarBatchClient.remove(calendarIds)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteParams(data));
    };
    var _a, _b;
    CalendarBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CalendarBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CalendarBatchRoute !== "undefined" && _1.CalendarBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CalendarBatchClient);
    return CalendarBatchClient;
}());
exports.CalendarBatchClient = CalendarBatchClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarBatchRoute
 * @description BaasicCalendarBatchRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarBatch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CalendarBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarBatchRoute, _super);
    function CalendarBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'calendars/batch';
        _this.updateRoute = 'calendars/batch';
        _this.deleteRoute = 'calendars/batch';
        return _this;
    }
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @example calendarBatchRoute.create();
     */
    CalendarBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @example calendarBatchRoute.update();
     */
    CalendarBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @example calendarBatchRoute.delete();
     */
    CalendarBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CalendarBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarBatchRoute);
    return CalendarBatchRoute;
}(common_1.BaseRoute));
exports.CalendarBatchRoute = CalendarBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarClient
 * @description  Calendar Client provides an easy way to consume Calendar REST API end-points. In order to obtain needed routes `calendarClient` uses `calendarRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(7);
var CalendarClient = /** @class */ (function () {
    function CalendarClient(calendarRsvpAttendeeClient, calendarRsvpClient, calendarEventsClient, calendarBatchClient, calendarRoute, apiClient) {
        this.calendarRsvpAttendeeClient = calendarRsvpAttendeeClient;
        this.calendarRsvpClient = calendarRsvpClient;
        this.calendarEventsClient = calendarEventsClient;
        this.calendarBatchClient = calendarBatchClient;
        this.calendarRoute = calendarRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CalendarClient.prototype, "routeDefinition", {
        get: function () {
            return this.calendarRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarClient.prototype, "batch", {
        get: function () {
            return this.calendarBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarClient.prototype, "events", {
        get: function () {
            return this.calendarEventsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarClient.prototype, "eventRsvp", {
        get: function () {
            return this.calendarRsvpClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CalendarClient.prototype, "eventAttendee", {
        get: function () {
            return this.calendarRsvpAttendeeClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of Calendar resources matching the given criteria.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example calendarClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>',
                    ids : <identifiers>,
                    ownerIds: <identifiers>,
                    from : <start-date>,
                    to : <end-date>
                })
                .then(function (collection) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the Calendar resource.
     * @method
     * @param id Calendar id which uniquely identifies Calendar resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example calendarClient.get()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create Calendar action has been performed; this action creates a new Calendar resource.
     * @method
     * @param data A Calendar object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create Calendar action has been performed.
     * @example calendarClient.create({
                    abrv: '<abrv>',
                    description: '<description>',
                    json: '<json>',
                    name: '<name>',
                    owner: <user-info>,
                    ownerId: '<owner-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update Calendar action has been performed. This action updates a Calendar resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendar);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A Calendar object used to update specified Calendar resource.
     * @returns A promise that is resolved once the update Calendar action has been performed.
     * @example calendar is a resource previously fetched using get action.
                calendar.name = '<name>';
                calendarClient.update(calendar)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a Calendar resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `calendarEventRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(calendar);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An calendart object used to delete specified Calendar resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example calendar is a resource previously fetched using get action.
                calendarClient.remove(calendar)
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all Calendar resources from the system if succesfully completed.
     * @method
     * @returns A promise that is resolved once the purge action has been performed.
     * @example calendarClient.purge()
                .then(function (data) {
                    // perform success action here
                },
                function (response, status, headers, config) {
                    // perform error handling here
                });
     */
    CalendarClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c, _d, _e, _f;
    CalendarClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CalendarRsvpAttendeeClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CalendarRsvpClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.CalendarEventsClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.CalendarBatchClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.CalendarRoute)),
        tslib_1.__param(5, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CalendarRsvpAttendeeClient !== "undefined" && _1.CalendarRsvpAttendeeClient) === "function" ? _a : Object, typeof (_b = typeof _1.CalendarRsvpClient !== "undefined" && _1.CalendarRsvpClient) === "function" ? _b : Object, typeof (_c = typeof _1.CalendarEventsClient !== "undefined" && _1.CalendarEventsClient) === "function" ? _c : Object, typeof (_d = typeof _1.CalendarBatchClient !== "undefined" && _1.CalendarBatchClient) === "function" ? _d : Object, typeof (_e = typeof _1.CalendarRoute !== "undefined" && _1.CalendarRoute) === "function" ? _e : Object, typeof (_f = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _f : Object])
    ], CalendarClient);
    return CalendarClient;
}());
exports.CalendarClient = CalendarClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module calendarRoute
 * @description BaasicCalendarRoute Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicCalendarRoute Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var CalendarRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CalendarRoute, _super);
    function CalendarRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'calendars/{?searchQuery,page,rpp,sort,embed,fields,from,to,ids,ownerIds}';
        _this.getRoute = 'calendars/{id}/{?embed,fields}';
        _this.createRoute = 'calendars';
        _this.updateRoute = 'calendars/{id}';
        _this.deleteRoute = 'calendars/{id}';
        _this.purgeRoute = 'calendars/purge';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional GetCalendarOptions. Supported items are:
     * - `searchQuery` - A string referencing Calendar properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain Calendar subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the Calendar property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `from` - Fluent syntax for 'From' date. Used to limit the dataset to only use resources starting from this date
     * - `to` - Fluent syntax for 'To' date. Used to limit the dataset to only use resources ending to this date.
     * - `ownerIds` - Used to limit the dataset to only use resources beloging to specified owners.
     * @method
     * @param options Query resource GetCalendarOptions object.
     * @example calendarRoute.find({searchQuery: '<search-phrase>'});
     */
    CalendarRoute.prototype.find = function (options) {
        var opt;
        if (options) {
            opt = options;
            opt.to = this.getToDate(opt);
            opt.from = this.getFromDate(opt);
        }
        else {
            opt = {};
        }
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get route which must be expanded with the id of the previously created Calendar resource. This route can be expanded with additional eEtRequestOptions. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id Calendar id which uniquely identifies Calendar resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example calendarRoute.get(id);
     */
    CalendarRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route. This URI template does not expose any additional options.
     * @method
     * @param data A Calendar object that needs to be inserted into the system.
     * @example calendarRoute.create(data);
     */
    CalendarRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route. This URI template does not expose any additional options.
     * @method
     * @param data A Calendar object used to update specified Calendar resource.
     * @example calendarRoute.update(data);
     */
    CalendarRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route. This URI template does not expose any additional options.
     * @method
     * @param data A Calendar object used to delete specified Calendar resource.
     * @example calendarRoute.delete(data);
     */
    CalendarRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses purge route. This URI template does not expose any additional options.
     * @method
     * @example calendarRoute.purge();
     */
    CalendarRoute.prototype.purge = function () {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, {});
    };
    CalendarRoute.prototype.getToDate = function (options) {
        if (!this.utility.isUndefined(options.to) && options.to !== null) {
            return options.to.toISOString();
        }
        return undefined;
    };
    CalendarRoute.prototype.getFromDate = function (options) {
        if (!this.utility.isUndefined(options.from) && options.from !== null) {
            return options.from.toISOString();
        }
        return undefined;
    };
    var _a;
    CalendarRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CalendarRoute);
    return CalendarRoute;
}(common_1.BaseRoute));
exports.CalendarRoute = CalendarRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(7);
var inversify_1 = __webpack_require__(1);
var Root = /** @class */ (function () {
    function Root(lookups, ACL, attendee, calendar, event, rsvp) {
        this.lookups = lookups;
        this.ACL = ACL;
        this.attendee = attendee;
        this.calendar = calendar;
        this.event = event;
        this.rsvp = rsvp;
    }
    var _a, _b, _c, _d, _e, _f;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CalendarLookups)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CalendarACLClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.CalendarEventRsvpAttendeeClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.CalendarClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.CalendarEventClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.CalendarEventRsvpClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CalendarLookups !== "undefined" && _1.CalendarLookups) === "function" ? _a : Object, typeof (_b = typeof _1.CalendarACLClient !== "undefined" && _1.CalendarACLClient) === "function" ? _b : Object, typeof (_c = typeof _1.CalendarEventRsvpAttendeeClient !== "undefined" && _1.CalendarEventRsvpAttendeeClient) === "function" ? _c : Object, typeof (_d = typeof _1.CalendarClient !== "undefined" && _1.CalendarClient) === "function" ? _d : Object, typeof (_e = typeof _1.CalendarEventClient !== "undefined" && _1.CalendarEventClient) === "function" ? _e : Object, typeof (_f = typeof _1.CalendarEventRsvpClient !== "undefined" && _1.CalendarEventRsvpClient) === "function" ? _f : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;


/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(27);
var TYPES = {
    ShoppingCartItemClient: Symbol("ShoppingCartItemClient"),
    ShoppingCartPaymentClient: Symbol("ShoppingCartPaymentClient"),
    ShoppingCartItemBatchClient: Symbol("ShoppingCartItemBatchClient"),
    ShoppingCartItemRoute: Symbol("ShoppingCartItemRoute"),
    ShoppingCartPaymentRoute: Symbol("ShoppingCartPaymentRoute"),
    ShoppingCartItemBatchRoute: Symbol("ShoppingCartItemBatchRoute"),
    Root: Symbol("Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ShoppingCartItemClient).to(_1.ShoppingCartItemClient);
    bind(TYPES.ShoppingCartPaymentClient).to(_1.ShoppingCartPaymentClient);
    bind(TYPES.ShoppingCartItemBatchClient).to(_1.ShoppingCartItemBatchClient);
    bind(TYPES.ShoppingCartItemRoute).to(_1.ShoppingCartItemRoute);
    bind(TYPES.ShoppingCartPaymentRoute).to(_1.ShoppingCartPaymentRoute);
    bind(TYPES.ShoppingCartItemBatchRoute).to(_1.ShoppingCartItemBatchRoute);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module ShoppingCartItemRoute
 * @description Baasic Shopping Cart Item Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicShopping Cart Item Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(27);
var contracts_1 = __webpack_require__(3);
var ShoppingCartItemRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ShoppingCartItemRoute, _super);
    function ShoppingCartItemRoute(appOptions, shoppingCartItemBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.shoppingCartItemBatchRoute = shoppingCartItemBatchRoute;
        _this.findRoute = 'commerce/carts/items/{?searchQuery,userId,ids,from,to,page,rpp,sort,embed,fields}';
        _this.findByUserIdRoute = 'commerce/carts/users/{userId}/products/{?page,rpp,sort,embed,fields}';
        _this.getRoute = 'commerce/carts/items/{id}/{?embed,fields}';
        _this.getbyUserIdAndProductIdRoute = 'commerce/carts/users/{userId}/products/{productId}/{?embed,fields}';
        _this.updateRoute = 'commerce/carts/items/{id}';
        _this.updateByUserIdAndProductIdRoute = 'commerce/carts/users/{userId}/products/{productId}';
        _this.deleteRoute = 'commerce/carts/items/{id}';
        _this.deleteByUserIdAndProductIdRoute = 'commerce/carts/users/{userId}/products/{productId}';
        _this.deleteByUserIdRoute = 'commerce/carts/users/{userId}/empty';
        _this.createRoute = 'commerce/carts/items';
        _this.createByUserIdAndProductIdRoute = 'commerce/carts/users/{userId}/products/{productId}';
        _this.purgeRoute = 'commerce/carts/purge';
        return _this;
    }
    Object.defineProperty(ShoppingCartItemRoute.prototype, "batch", {
        get: function () {
            return this.shoppingCartItemBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses delete route; this route should be expanded with the Id of shopping cart item resource.
     * @method
     * @param id Shopping Cart Id of specific Shopping Cart item resource in the system.
     * @example shoppingCartItemRoute.delete(<id>);
     **/
    ShoppingCartItemRoute.prototype.delete = function (id) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, id);
    };
    /**
     * Parses delete route; this route should be expanded with the Id of shopping cart item resource.
     * @method
     * @param userId User Id of the User resource that the Shopping Cart resource in the system bellongs to.
     * @param productId Product Id of the Product resource that the Shopping Cart resource in the system is linked to.
     * @example shoppingCartItemRoute.delete(<user-id>, <product-id>);
     **/
    ShoppingCartItemRoute.prototype.deleteByUserIdAndProductId = function (userId, productId) {
        var data = {
            userId: userId,
            productId: productId
        };
        return _super.prototype.baseDelete.call(this, this.deleteByUserIdAndProductIdRoute, data);
    };
    /**
    * Parses delete route; this route should be expanded with the userId.
    * @method
    * @param userId User Id of the User resource that the Shopping Cart resource in the system bellongs to.
         * @example shoppingCartItemRoute.deleteByUserId(<user-id>);
    **/
    ShoppingCartItemRoute.prototype.deleteByUserId = function (userId) {
        var data = {
            userId: userId
        };
        return _super.prototype.baseDelete.call(this, this.deleteByUserIdRoute, data);
    };
    /**
    * Parses create route; this URI template doesnt support any additional options.
    * @method
    * @example shoppingCartItemRoute.create();
    **/
    ShoppingCartItemRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
    * Parses create route; this URI template doesnt support any additional options.
    * @method
    * @param data An shopping cart item  object that needs to be inserted into the system.
    * @example shoppingCartItemRoute.create(data);
    **/
    ShoppingCartItemRoute.prototype.createByUserIdAndProductId = function (data) {
        return _super.prototype.baseCreate.call(this, this.createByUserIdAndProductIdRoute, data);
    };
    /**
     * Parses purge route; this URI template does not expose any additional options.
     * @method
     * @example shoppingCartItemRoute.purge();
     **/
    ShoppingCartItemRoute.prototype.purge = function () {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, {});
    };
    var _a, _b;
    ShoppingCartItemRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ShoppingCartItemBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.ShoppingCartItemBatchRoute !== "undefined" && _1.ShoppingCartItemBatchRoute) === "function" ? _b : Object])
    ], ShoppingCartItemRoute);
    return ShoppingCartItemRoute;
}(common_1.BaseRoute));
exports.ShoppingCartItemRoute = ShoppingCartItemRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module shoppingCartPaymentRoute
 * @description Baasic Shopping Cart Payment Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Shopping Cart Payment Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ShoppingCartPaymentRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ShoppingCartPaymentRoute, _super);
    function ShoppingCartPaymentRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.calculateSummaryRoute = 'commerce/carts/users/{customerId}/summary';
        _this.processCartRoute = 'commerce/carts/users/{customerId}/payment';
        return _this;
    }
    /**
     * Parses claculate summary route; this URI template does not expose any additional options.
     * @method
     * @example shoppingCartPaymentRoute.calculateSummaryRoute();
     **/
    ShoppingCartPaymentRoute.prototype.calculateSummary = function (data) {
        return _super.prototype.baseCreate.call(this, this.calculateSummaryRoute, data);
    };
    /**
     * Parses process Route; this URI template does not expose any additional options.
     * @method
     * @example shoppingCartPaymentRoute.processCart();
     **/
    ShoppingCartPaymentRoute.prototype.processCart = function (data) {
        return _super.prototype.baseCreate.call(this, this.processCartRoute, data);
    };
    var _a;
    ShoppingCartPaymentRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ShoppingCartPaymentRoute);
    return ShoppingCartPaymentRoute;
}(common_1.BaseRoute));
exports.ShoppingCartPaymentRoute = ShoppingCartPaymentRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module shoppingCartItemBatchRoute
 * @description Baasic Shopping Cart Item Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Shopping Cart Item Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ShoppingCartItemBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ShoppingCartItemBatchRoute, _super);
    function ShoppingCartItemBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.updateRoute = 'commerce/carts/items/batch';
        _this.deleteRoute = 'commerce/carts/items/batch';
        _this.createRoute = 'commerce/carts/items/batch';
        return _this;
    }
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example shoppingCartItemBatchRoute.update();
     **/
    ShoppingCartItemBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example shoppingCartItemBatchRoute.create();
     **/
    ShoppingCartItemBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example shoppingCartItemBatchRoute.delete();
     **/
    ShoppingCartItemBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    ShoppingCartItemBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ShoppingCartItemBatchRoute);
    return ShoppingCartItemBatchRoute;
}(common_1.BaseRoute));
exports.ShoppingCartItemBatchRoute = ShoppingCartItemBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module shoppingCartClient
 * @description Shopping Cart Item Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use BaasicShopping Cart Item Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(27);
var ShoppingCartItemClient = /** @class */ (function () {
    function ShoppingCartItemClient(shoppingCartItemRoute, apiClient, shoppingCartItemBatchClient) {
        this.shoppingCartItemRoute = shoppingCartItemRoute;
        this.apiClient = apiClient;
        this.shoppingCartItemBatchClient = shoppingCartItemBatchClient;
    }
    Object.defineProperty(ShoppingCartItemClient.prototype, "routeDefinition", {
        get: function () {
            return this.shoppingCartItemRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShoppingCartItemClient.prototype, "batch", {
        get: function () {
            return this.shoppingCartItemBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove one shopping cart item resources from the system if successfully completed. Specified shopping cart item and all accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicShoppingCartItemRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(shoppingCartItem);
     * let uri = params['id'].links('delete').href;
     * ```
     * @method
     * @param id Shopping Cart Item id used to delete specific Shopping Cart Item resource from the system.
     * @example // id is a shopping cart item resource id previously fetched using get action. The following action will remove the original shopping cart item resource and all accompanying derived shopping cart item resources.
                   shoppingCartClient.remove(id)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
    **/
    ShoppingCartItemClient.prototype.remove = function (id) {
        return this.apiClient.delete(this.routeDefinition.delete(id));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove one shopping cart item resources from the system if successfully completed. Specified shopping cart item and all accompanying derived resources will be removed from the system.
     *
     * @method
     * @param userId User Id from the User that the Shopping Cart Item resource from the system belongs to.
     * @param productId Product id from the Product that the Shopping Cart Item contains.
     * @example // The following action will remove the original shopping cart item resource and all accompanying derived shopping cart item resources.
                   shoppingCartClient.removeByUserIdAndProductId(userId, productId)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                            // perform error handling here
                       });
    **/
    ShoppingCartItemClient.prototype.removeByUserIdAndProductId = function (userId, productId) {
        return this.apiClient.delete(this.routeDefinition.deleteByUserIdAndProductId(userId, productId));
    };
    /**
         * Returns a promise that is resolved once the remove action has been performed. This action will remove all shopping cart item resources for a given userId from the system if successfully completed.
         *
         * @method
         * @param userId User Id from the User that the Shopping Cart Item resource from the system belongs to.
         * @example // The following action will remove the original shopping cart item resource and all accompanying derived shopping cart item resources.
                       shoppingCartClient.removeByUserIdAndProductId(userId)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
        **/
    ShoppingCartItemClient.prototype.removeByUserId = function (userId) {
        return this.apiClient.delete(this.routeDefinition.deleteByUserId(userId));
    };
    /**
     * Returns a promise that is resolved once the create shopping cart item action has been performed; this action creates a new shopping cart item.
     * @method
     * @param data Shopping Cart Item object.
     * @returns A promise that is resolved once the create shopping cart item action has been performed.
     * @example shoppingCartClient.create(shoppingCartItem)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ShoppingCartItemClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the create shopping cart item action has been performed; this action creates a new shopping cart item.
     * @method
     * @param data Shopping Cart Item object.
     * @returns A promise that is resolved once the create shopping cart item action has been performed.
     * @example shoppingCartClient.createByUserIdAndProductId(shoppingCartItem)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    ShoppingCartItemClient.prototype.createByUserIdAndProductId = function (userId, productId, string, data) {
        data.userId = userId;
        data.productId = productId;
        return this.apiClient.post(this.routeDefinition.createByUserIdAndProductId(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the purge action has been performed. This action will remove all shopping cart item resources from the system if successfully completed.
     * @method
     * @example // Remove original shopping cart item resources
                        shoppingCartClient.purge()
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    ShoppingCartItemClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b, _c;
    ShoppingCartItemClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ShoppingCartItemRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.ShoppingCartItemBatchClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ShoppingCartItemRoute !== "undefined" && _1.ShoppingCartItemRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof _1.ShoppingCartItemBatchClient !== "undefined" && _1.ShoppingCartItemBatchClient) === "function" ? _c : Object])
    ], ShoppingCartItemClient);
    return ShoppingCartItemClient;
}());
exports.ShoppingCartItemClient = ShoppingCartItemClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module shoppingCartPaymentClient
 * @description  Shopping Cart Payment Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Shopping Cart Payment Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(27);
var ShoppingCartPaymentClient = /** @class */ (function () {
    function ShoppingCartPaymentClient(shoppingCartPaymentRoute, apiClient) {
        this.shoppingCartPaymentRoute = shoppingCartPaymentRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ShoppingCartPaymentClient.prototype, "routeDefinition", {
        get: function () {
            return this.shoppingCartPaymentRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the calculateSummary action has been performed; this action calculateSummarys specified shopping cart item resources.
     * @method
     * @param data A collection of shopping cart item objects used to calculateSummary specified shopping cart item resources.
     * @returns A promise that is resolved once the calculateSummary action has been performed.
     * @example shoppingCartPaymentClient.calculateSummary(file)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    ShoppingCartPaymentClient.prototype.calculateSummary = function (data) {
        return this.apiClient.post(this.routeDefinition.calculateSummary(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the processCart action has been performed. This action will processCart shopping cart item resources from the system if successfully completed. Specified shopping cart items and all accompanying derived resources will be processCartd from the system.
     * @method
     * @param ids Collection of shopping cart item Id which uniquely identifies shopping cart item resources that need to be deleted.
     * @example // Remove original shopping cart item resources
                        shoppingCartPaymentClient.processCart(cartPaymentRequest)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    ShoppingCartPaymentClient.prototype.processCart = function (data) {
        return this.apiClient.post(this.routeDefinition.processCart(data), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    ShoppingCartPaymentClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ShoppingCartPaymentRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ShoppingCartPaymentRoute !== "undefined" && _1.ShoppingCartPaymentRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ShoppingCartPaymentClient);
    return ShoppingCartPaymentClient;
}());
exports.ShoppingCartPaymentClient = ShoppingCartPaymentClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 640 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module shoppingCartItemsBatchClient
 * @description  Shopping Cart Item Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Shopping Cart Item Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(27);
var ShoppingCartItemBatchClient = /** @class */ (function () {
    function ShoppingCartItemBatchClient(shoppingCartItemBatchRoute, apiClient) {
        this.shoppingCartItemBatchRoute = shoppingCartItemBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ShoppingCartItemBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.shoppingCartItemBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified shopping cart item resources.
     * @method
     * @param data A collection of shopping cart item objects used to update specified shopping cart item resources.
     * @returns A promise that is resolved once the update action has been performed.
     * @example shoppingCartItemsBatchClient.update(files)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    ShoppingCartItemBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove shopping cart item resources from the system if successfully completed. Specified shopping cart items and all accompanying derived resources will be removed from the system.
     * @method
     * @param ids Collection of shopping cart item Id which uniquely identifies shopping cart item resources that need to be deleted.
     * @example // Remove original shopping cart item resources
                        shoppingCartItemsBatchClient.remove([<shopping-cart-item-id>])
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    ShoppingCartItemBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.shoppingCartItemBatchRoute.delete(), undefined, ids);
    };
    /**
    * Returns a promise that is resolved once the create action has been performed; this action creates specified shopping cart item resources.
    * @method
    * @param data A collection of shopping cart item objects used to create specified shopping cart item resources.
    * @returns A promise that is resolved once the create action has been performed.
    * @example shoppingCartItemsBatchClient.create(files)
                  .then(function (data) {
                      // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                  });
   **/
    ShoppingCartItemBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    ShoppingCartItemBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ShoppingCartItemBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ShoppingCartItemBatchRoute !== "undefined" && _1.ShoppingCartItemBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ShoppingCartItemBatchClient);
    return ShoppingCartItemBatchClient;
}());
exports.ShoppingCartItemBatchClient = ShoppingCartItemBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 641 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(642), exports);
tslib_1.__exportStar(__webpack_require__(643), exports);
tslib_1.__exportStar(__webpack_require__(644), exports);
tslib_1.__exportStar(__webpack_require__(645), exports);
tslib_1.__exportStar(__webpack_require__(646), exports);
tslib_1.__exportStar(__webpack_require__(647), exports);
tslib_1.__exportStar(__webpack_require__(648), exports);
tslib_1.__exportStar(__webpack_require__(649), exports);


/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 643 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 650 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(27);
var inversify_1 = __webpack_require__(1);
var Root = /** @class */ (function () {
    function Root(items, payment) {
        this.items = items;
        this.payment = payment;
    }
    var _a, _b;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ShoppingCartItemClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.ShoppingCartPaymentClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ShoppingCartItemClient !== "undefined" && _1.ShoppingCartItemClient) === "function" ? _a : Object, typeof (_b = typeof _1.ShoppingCartPaymentClient !== "undefined" && _1.ShoppingCartPaymentClient) === "function" ? _b : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(17);
var TYPES = {
    BlogClient: Symbol("BlogClient"),
    BlogRoute: Symbol("BlogRoute"),
    BlogPostRoute: Symbol("BlogPostRoute"),
    BlogPostClient: Symbol("BlogPostClient"),
    BlogTagClient: Symbol("BlogTagClient"),
    BlogTagRoute: Symbol("BlogTagRoute"),
    BlogPostCommentRoute: Symbol("BlogPostCommentRoute"),
    BlogPostCommentClient: Symbol("BlogPostCommentClient"),
    BlogPostFilesStreamsRoute: Symbol("BlogPostFilesStreamsRoute"),
    BlogPostFilesStreamsClient: Symbol("BlogPostFilesStreamsClient"),
    BlogPostFilesBatchRoute: Symbol("BlogPostFilesBatchRoute"),
    BlogPostFilesBatchClient: Symbol("BlogPostFilesBatchClient"),
    BlogPostFilesRoute: Symbol("BlogPostFilesRoute"),
    BlogPostFilesClient: Symbol("BlogPostFilesClient"),
    BlogPostStatusRoute: Symbol("BlogPostStatusRoute"),
    BlogPostStatusClient: Symbol("BlogPostStatusClient"),
    Root: Symbol("Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.BlogClient).to(_1.BlogClient);
    bind(TYPES.BlogRoute).to(_1.BlogRoute);
    bind(TYPES.BlogPostRoute).to(_1.BlogPostRoute);
    bind(TYPES.BlogPostClient).to(_1.BlogPostClient);
    bind(TYPES.BlogTagRoute).to(_1.BlogTagRoute);
    bind(TYPES.BlogTagClient).to(_1.BlogTagClient);
    bind(TYPES.BlogPostCommentRoute).to(_1.BlogPostCommentRoute);
    bind(TYPES.BlogPostCommentClient).to(_1.BlogPostCommentClient);
    bind(TYPES.BlogPostFilesStreamsRoute).to(_1.BlogPostFilesStreamsRoute);
    bind(TYPES.BlogPostFilesStreamsClient).to(_1.BlogPostFilesStreamsClient);
    bind(TYPES.BlogPostFilesBatchRoute).to(_1.BlogPostFilesBatchRoute);
    bind(TYPES.BlogPostFilesBatchClient).to(_1.BlogPostFilesBatchClient);
    bind(TYPES.BlogPostFilesRoute).to(_1.BlogPostFilesRoute);
    bind(TYPES.BlogPostFilesClient).to(_1.BlogPostFilesClient);
    bind(TYPES.BlogPostStatusRoute).to(_1.BlogPostStatusRoute);
    bind(TYPES.BlogPostStatusClient).to(_1.BlogPostStatusClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;


/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var BaasicBlogPostUtility = /** @class */ (function () {
    function BaasicBlogPostUtility() {
        this.utility = new common_1.Utility();
    }
    BaasicBlogPostUtility.prototype.replaceDiacritics = function (str) {
        for (var letter in common_1.ALPHABET) {
            str = str.replace(common_1.ALPHABET[letter], letter);
        }
        return str;
    };
    BaasicBlogPostUtility.prototype.toSlug = function (str) {
        if (this.utility.isUndefined(str) || str === null || str === '') {
            return str;
        }
        str = this.replaceDiacritics(str);
        str = str.toLowerCase();
        str = str.replace(/[^a-z0-9]+/g, '-');
        str = str.replace(/^-|-$/g, '');
        return str;
    };
    BaasicBlogPostUtility.prototype.updateSlug = function (resource) {
        var newSlug = this.toSlug(resource.slug);
        if (this.utility.isUndefined(newSlug) || newSlug === null || newSlug === '') {
            newSlug = this.toSlug(resource.title);
        }
        if (!this.utility.isUndefined(newSlug) || newSlug !== null || newSlug !== '') {
            if (resource.slug !== newSlug) {
                resource.slug = newSlug;
            }
        }
    };
    return BaasicBlogPostUtility;
}());
exports.BaasicBlogPostUtility = BaasicBlogPostUtility;


/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostStatusRoute
 * @description Baasic Blog Post Status Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Blog Post Status Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var BlogPostStatusRoute = /** @class */ (function (_super) {
    tslib_1.__extends(BlogPostStatusRoute, _super);
    function BlogPostStatusRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'loookups/blog-post-statuses/{?searchQuery,ids,from,to,page,rpp,sort,embed,fields}';
        _this.getRoute = 'loookups/blog-post-statuses/{id}/{?embed,fields}';
        _this.purgeRoute = 'loookups/blog-post-statuses/purge';
        _this.createRoute = 'loookups/blog-post-statuses';
        _this.updateRoute = 'loookups/blog-post-statuses/{id}';
        _this.deleteRoute = 'loookups/blog-post-statuses/{id}';
        return _this;
    }
    /**
     * Parses find blog post status route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing blog properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain blog subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the blog property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `startDate` - A value used to specify the blog creation, publish or archive date date starting from which blog resource collection should be returned.
     * - `endDate` - A value used to specify the blog creation, publish or archive date until (and including) which blog resource collection should be returned.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @example blogPostStatusRoute.find.expand({searchQuery: '<search-phrase>'});
     **/
    BlogPostStatusRoute.prototype.find = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get blog route which must be expanded with the Id of the previously created blog resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id blog slug or id which uniquely identifies blog resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @example blogPostStatusRoute.get({id: '<blog-id>'});
     **/
    BlogPostStatusRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses purge blog route, this URI template doesn't expose any additional properties.
     * @method
     * @example blogPostStatusRoute.purge();
     **/
    BlogPostStatusRoute.prototype.purge = function () {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, {});
    };
    /**
     * Parses create blog post status route; this URI template doesn't expose any additional properties.
     * @method
     * @example blogPostStatusRoute.create();
     **/
    BlogPostStatusRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update blog post status route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blog post status object that needs to be updated into the system.
     * @example blogPostStatusRoute.update(data);
     **/
    BlogPostStatusRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete blog post status route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blog post status object that needs to be removed from the system.
     * @example blogPostStatusRoute.delete(data);
     **/
    BlogPostStatusRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    BlogPostStatusRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], BlogPostStatusRoute);
    return BlogPostStatusRoute;
}(common_1.BaseRoute));
exports.BlogPostStatusRoute = BlogPostStatusRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostStatusClient
 * @description  Blog Post Status Client provides an easy way to consume  Blogs REST API end-points. In order to obtain needed routes `blogPostStatusClient` uses `blogPostStatusRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(17);
var BlogPostStatusClient = /** @class */ (function () {
    function BlogPostStatusClient(blogPostStatusRoute, apiClient) {
        this.blogPostStatusRoute = blogPostStatusRoute;
        this.apiClient = apiClient;
        this.utility = new common_1.Utility();
    }
    Object.defineProperty(BlogPostStatusClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `blogPostStatusRoute`.
         * @method
         * @example blogPostStatusClient.routeDefinition.get();
         **/
        get: function () {
            return this.blogPostStatusRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of blog post statuses resources matching the given criteria.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @returns A promise that is resolved once the find action has been performed.
     * @example blogPostStatusClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    BlogPostStatusClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a single article resource.
     * @method
     * @param id Blog slug or id which uniquely identifies article resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @returns a promise that is resolved once the get action has been performed.
     * @example articleClient.get('<article-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    BlogPostStatusClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create blog post status action has been performed, this action creates a new blog post status resource.
     * @method
     * @param data An blog post status object that needs to be inserted into the system.
     * @returns a promise that is resolved once the create blog post status action has been performed.
     * @example blogPostStatusClient.create({
                    name : '<name>',
                    abrv : '<abrv>',
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    BlogPostStatusClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blog post status action has been performed; this action updates an blog post status resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPostStatus);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPostStatus object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPostStatus action has been performed.
     * @example // blogPostStatus is a resource previously fetched using get action.
                    blogPostStatus.name = '<name>';
                    blogPostStatusClient.update(blogPostStatus)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostStatusClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove blog post status action has been performed. If the action is successfully completed, the blogPostStatus resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostStatusRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(article);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An blogPostStatus object that needs to be removed from the system.
     * @returns A promise that is resolved once the remove blogPostStatus action has been performed.
     * @example // blogPostStatus is a resource previously fetched using get action.
                    blogPostStatusClient.remove(blogPostStatus)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostStatusClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge blogPostStatus action has been performed. Please note that all blogPostStatus resources will be deleted from the system once the action is successfully completed and therefore it can only be executed by user assigned to account owner role.
     * @method
     * @example blogPostStatusClient.purge()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    BlogPostStatusClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b;
    BlogPostStatusClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogPostStatusRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogPostStatusRoute !== "undefined" && _1.BlogPostStatusRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], BlogPostStatusClient);
    return BlogPostStatusClient;
}());
exports.BlogPostStatusClient = BlogPostStatusClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostRoute
 * @description Baasic Blog Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic blogPost Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var BlogPostRoute = /** @class */ (function (_super) {
    tslib_1.__extends(BlogPostRoute, _super);
    function BlogPostRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'blog/blog-posts/{?searchQuery,ids,from,to,publishedFrom,publishedTo,url,template,blogPostPostStatusIds,languageIds,blogPostSlugs,tagSlugs,page,rpp,sort,embed,fields}';
        _this.getRoute = 'blog/blog-posts/{id}/{?embed,fields}';
        _this.purgeRoute = 'blog/blog-posts/purge';
        _this.createRoute = 'blog/blog-posts';
        _this.updateRoute = 'blog/blog-posts/{id}';
        _this.publishRoute = 'blog/blog-posts/{id}/publish';
        _this.rejectRoute = 'blog/blog-posts/{id}/reject';
        _this.reviewPendingRoute = 'blog/blog-posts/{id}/review-pending';
        _this.unpublishRoute = 'blog/blog-posts/{id}/unpublish';
        _this.archiveRoute = 'blog/blog-posts/{id}/archive';
        _this.draftRoute = 'blog/blog-posts/{id}/draft';
        _this.deleteRoute = 'blog/blog-posts/{id}';
        return _this;
    }
    /**
     * Parses find blogPost route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing blogPost properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain blogPost subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the blogPost property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `startDate` - A value used to specify the blogPost creation, publish or archive date date starting from which blogPost resource collection should be returned.
     * - `endDate` - A value used to specify the blogPost creation, publish or archive date until (and including) which blogPost resource collection should be returned.
     * - `statuses` - Comma separated list of blogPost statuses that specify where search should be done (Allowed statuses: Published, Draft and Archived).
     * - `tags` - A value used to restrict the search to blogPost resources with these tags. Multiple tags should be comma separated.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @example blogPostRoute.find.expand({searchQuery: '<search-phrase>'});
     **/
    BlogPostRoute.prototype.find = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get blogPost route which must be expanded with the Id of the previously created blogPost resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id blogPost slug or id which uniquely identifies blogPost resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @example blogPostRoute.get({id: '<blogPost-id>'});
     **/
    BlogPostRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses publish blog post route which must be expanded with the Id of the previously created blog post resource in the system.
     * @method
     * @param data An blog post object.
     * @example blogPostRoute.publish.expand({id: '<blog-post-id>'});
     **/
    BlogPostRoute.prototype.publish = function (data) {
        return _super.prototype.baseUpdate.call(this, this.publishRoute, data);
    };
    /**
     * Parses unpublish blog post route which must be expanded with the Id of the previously created blog post resource in the system.
     * @method
     * @param data An blog post object.
     * @example blogPostRoute.unpublish.expand({id: '<blog-post-id>'});
     **/
    BlogPostRoute.prototype.unPublish = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unpublishRoute, data);
    };
    /**
     * Parses draft blog post route which must be expanded with the Id of the previously created blog post resource in the system.
     * @method
     * @param data An blog post object.
     * @example blogPostRoute.draft.expand({id: '<blog-post-id>'});
     **/
    BlogPostRoute.prototype.draft = function (data) {
        return _super.prototype.baseUpdate.call(this, this.draftRoute, data);
    };
    /**
     * Parses reject blog post route which must be expanded with the Id of the previously created blog post resource in the system.
     * @method
     * @param data An blog post object.
     * @example blogPostRoute.reject.expand({id: '<blog-post-id>'});
     **/
    BlogPostRoute.prototype.reject = function (data) {
        return _super.prototype.baseUpdate.call(this, this.rejectRoute, data);
    };
    /**
     * Parses archive blog post route which must be expanded with the Id of the previously created blog post resource in the system.
     * @method
     * @param data An blog post object.
     * @example blogPostRoute.archive.expand({id: '<blog-post-id>'});
     **/
    BlogPostRoute.prototype.archive = function (data) {
        return _super.prototype.baseUpdate.call(this, this.archiveRoute, data);
    };
    /**
     * Parses review pending blog post route which must be expanded with the Id of the previously created blog post resource in the system.
     * @method
     * @param data An blog post object.
     * @example blogPostRoute.reviewPending.expand({id: '<blog-post-id>'});
     **/
    BlogPostRoute.prototype.reviewPending = function (data) {
        return _super.prototype.baseUpdate.call(this, this.reviewPendingRoute, data);
    };
    /**
     * Parses purge blogPost route, this URI template doesn't expose any additional properties.
     * @method
     * @example blogPostRoute.purge();
     **/
    BlogPostRoute.prototype.purge = function () {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, {});
    };
    /**
     * Parses create blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @example blogPostRoute.create();
     **/
    BlogPostRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be updated into the system.
     * @example blogPostRoute.update(data);
     **/
    BlogPostRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be removed from the system.
     * @example blogPostRoute.delete(data);
     **/
    BlogPostRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    BlogPostRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], BlogPostRoute);
    return BlogPostRoute;
}(common_1.BaseRoute));
exports.BlogPostRoute = BlogPostRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module IBlogPostClient
 * @description  Blogs Client provides an easy way to consume  Blogs REST API end-points. In order to obtain needed routes `IBlogPostClient` uses `blogPostRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var common_1 = __webpack_require__(2);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(17);
var BlogPostClient = /** @class */ (function () {
    function BlogPostClient(blogRoute, apiClient) {
        this.blogRoute = blogRoute;
        this.apiClient = apiClient;
        this.utility = new common_1.Utility();
        this.blogPostUtility = new _1.BaasicBlogPostUtility();
    }
    Object.defineProperty(BlogPostClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `IBlogPostRoute`.
         * @method
         * @example IBlogPostClient.routeDefinition.get();
         **/
        get: function () {
            return this.blogRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of blogPost resources matching the given criteria.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @returns A promise that is resolved once the find action has been performed.
     * @example IBlogPostClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    BlogPostClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a single blogPost resource.
     * @method
     * @param id Blog slug or id which uniquely identifies blogPost resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @returns a promise that is resolved once the get action has been performed.
     * @example IBlogPostClient.get('<blogPost-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    BlogPostClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create blogPost action has been performed, this action creates a new blogPost resource.
     * @method
     * @param data An blogPost object that needs to be inserted into the system.
     * @returns a promise that is resolved once the create blogPost action has been performed.
     * @example IBlogPostClient.create({
                    publishDate : new Date(),
                    title : '<title>',
                    content : '<content>',
                    slug : '',
                    status : baasicBlogService.statuses.draft,
                    $tags : ['<tag1>', '<tag2>']
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    BlogPostClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPost action has been performed; this action updates an blogPost resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPost);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPost object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPost action has been performed.
     * @example // blogPost is a resource previously fetched using get action.
                    blogPost.title = '<title>';
                    IBlogPostClient.update(blogPost)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPost action has been performed; this action updates an blogPost resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPost);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPost object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPost action has been performed.
     * @example // blogPost is a resource previously fetched using get action.
                    blogPost.title = '<title>';
                    IBlogPostClient.publish(blogPost)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostClient.prototype.publish = function (data) {
        return this.apiClient.put(this.routeDefinition.publish(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPost action has been performed; this action updates an blogPost resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPost);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPost object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPost action has been performed.
     * @example // blogPost is a resource previously fetched using get action.
                    blogPost.title = '<title>';
                    IBlogPostClient.unPublish(blogPost)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostClient.prototype.unPublish = function (data) {
        return this.apiClient.put(this.routeDefinition.unPublish(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPost action has been performed; this action updates an blogPost resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPost);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPost object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPost action has been performed.
     * @example // blogPost is a resource previously fetched using get action.
                    blogPost.title = '<title>';
                    IBlogPostClient.draft(blogPost)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostClient.prototype.draft = function (data) {
        return this.apiClient.put(this.routeDefinition.draft(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPost action has been performed; this action updates an blogPost resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPost);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPost object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPost action has been performed.
     * @example // blogPost is a resource previously fetched using get action.
                    blogPost.title = '<title>';
                    IBlogPostClient.reject(blogPost)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostClient.prototype.reject = function (data) {
        return this.apiClient.put(this.routeDefinition.reject(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPost action has been performed; this action updates an blogPost resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPost);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPost object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPost action has been performed.
     * @example // blogPost is a resource previously fetched using get action.
                    blogPost.title = '<title>';
                    IBlogPostClient.archive(blogPost)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostClient.prototype.archive = function (data) {
        return this.apiClient.put(this.routeDefinition.archive(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPost action has been performed; this action updates an blogPost resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPost);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPost object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPost action has been performed.
     * @example // blogPost is a resource previously fetched using get action.
                    blogPost.title = '<title>';
                    IBlogPostClient.reviewPending(blogPost)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostClient.prototype.reviewPending = function (data) {
        return this.apiClient.put(this.routeDefinition.reviewPending(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove blogPost action has been performed. If the action is successfully completed, the blogPost resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(blogPost);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An blogPost object that needs to be removed from the system.
     * @returns A promise that is resolved once the remove blogPost action has been performed.
     * @example // blogPost is a resource previously fetched using get action.
                    IBlogPostClient.remove(blogPost)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge blogPosts action has been performed. Please note that all blogPost resources will be deleted from the system once the action is successfully completed and therefore it can only be executed by user assigned to account owner role.
     * @method
     * @example IBlogPostClient.purge()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    BlogPostClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b;
    BlogPostClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogPostRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogPostRoute !== "undefined" && _1.BlogPostRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], BlogPostClient);
    return BlogPostClient;
}());
exports.BlogPostClient = BlogPostClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogTagRoute
 * @description Baasic Blog Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic blog Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var BlogTagRoute = /** @class */ (function (_super) {
    tslib_1.__extends(BlogTagRoute, _super);
    function BlogTagRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'blog/blog-tags/{?searchQuery,ids,from,to,blogIds,blogSlugs,from,to,page,rpp,sort,embed,fields}';
        _this.getRoute = 'blog/blog-tags/{id}/{?embed,fields}';
        _this.purgeRoute = 'blog/blog-tags/purge';
        _this.createRoute = 'blog/blog-tags';
        _this.updateRoute = 'blog/blog-tags/{id}';
        _this.deleteRoute = 'blog/blog-tags/{id}';
        return _this;
    }
    /**
     * Parses find blog route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing blog properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain blog subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the blog property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `startDate` - A value used to specify the blog creation, publish or archive date date starting from which blog resource collection should be returned.
     * - `endDate` - A value used to specify the blog creation, publish or archive date until (and including) which blog resource collection should be returned.
     * - `statuses` - Comma separated list of blog statuses that specify where search should be done (Allowed statuses: Published, Draft and Archived).
     * - `tags` - A value used to restrict the search to blog resources with these tags. Multiple tags should be comma separated.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @example blogTagRoute.find.expand({searchQuery: '<search-phrase>'});
     **/
    BlogTagRoute.prototype.find = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get blog route which must be expanded with the Id of the previously created blog resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id blog slug or id which uniquely identifies blog resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @example blogTagRoute.get({id: '<blog-id>'});
     **/
    BlogTagRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses purge blog route, this URI template doesn't expose any additional properties.
     * @method
     * @example blogTagRoute.purge();
     **/
    BlogTagRoute.prototype.purge = function () {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, {});
    };
    /**
     * Parses create blog route; this URI template doesn't expose any additional properties.
     * @method
     * @example blogTagRoute.create();
     **/
    BlogTagRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update blog route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blog object that needs to be updated into the system.
     * @example blogTagRoute.update(data);
     **/
    BlogTagRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete blog route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blog object that needs to be removed from the system.
     * @example blogTagRoute.delete(data);
     **/
    BlogTagRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    BlogTagRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], BlogTagRoute);
    return BlogTagRoute;
}(common_1.BaseRoute));
exports.BlogTagRoute = BlogTagRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogTagClient
 * @description  Blogs Client provides an easy way to consume  Blogs REST API end-points. In order to obtain needed routes `blogTagClient` uses `articleRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var common_1 = __webpack_require__(2);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(17);
var BlogTagClient = /** @class */ (function () {
    function BlogTagClient(blogRoute, apiClient) {
        this.blogRoute = blogRoute;
        this.apiClient = apiClient;
        this.utility = new common_1.Utility();
    }
    Object.defineProperty(BlogTagClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `blogTagRoute`.
         * @method
         * @example blogTagClient.routeDefinition.get();
         **/
        get: function () {
            return this.blogRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article resources matching the given criteria.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @returns A promise that is resolved once the find action has been performed.
     * @example blogTagClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    BlogTagClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a single article resource.
     * @method
     * @param id Blog slug or id which uniquely identifies article resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @returns a promise that is resolved once the get action has been performed.
     * @example blogTagClient.get('<article-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    BlogTagClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create article action has been performed, this action creates a new article resource.
     * @method
     * @param data An article object that needs to be inserted into the system.
     * @returns a promise that is resolved once the create article action has been performed.
     * @example blogTagClient.create({
                    publishDate : new Date(),
                    title : '<title>',
                    content : '<content>',
                    slug : '',
                    status : baasicBlogService.statuses.draft,
                    $tags : ['<tag1>', '<tag2>']
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    BlogTagClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update article action has been performed; this action updates an article resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(article);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An article object that needs to be updated into the system.
     * @returns A promise that is resolved once the update article action has been performed.
     * @example // article is a resource previously fetched using get action.
                    article.title = '<title>';
                    blogTagClient.update(article)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogTagClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove article action has been performed. If the action is successfully completed, the article resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(article);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An article object that needs to be removed from the system.
     * @returns A promise that is resolved once the remove article action has been performed.
     * @example // article is a resource previously fetched using get action.
                    blogTagClient.remove(article)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogTagClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge articles action has been performed. Please note that all article resources will be deleted from the system once the action is successfully completed and therefore it can only be executed by user assigned to account owner role.
     * @method
     * @example blogTagClient.purge()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    BlogTagClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b;
    BlogTagClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogTagRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogTagRoute !== "undefined" && _1.BlogTagRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], BlogTagClient);
    return BlogTagClient;
}());
exports.BlogTagClient = BlogTagClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostCommentRoute
 * @description Baasic Blog Comment Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic blogPost Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var BlogPostCommentRoute = /** @class */ (function (_super) {
    tslib_1.__extends(BlogPostCommentRoute, _super);
    function BlogPostCommentRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'blog/blog-post-comments/{?searchQuery,ids,from,to,publishedFrom,publishedTo,url,template,blogPostPostStatusIds,languageIds,blogPostSlugs,tagSlugs,page,rpp,sort,embed,fields}';
        _this.getRoute = 'blog/blog-post-comments/{id}/{?embed,fields}';
        _this.purgeRoute = 'blog/blog-post-comments/purge';
        _this.createRoute = 'blog/blog-post-comments';
        _this.updateRoute = 'blog/blog-post-comments/{id}';
        _this.deleteRoute = 'blog/blog-post-comments/{id}';
        _this.approveRoute = 'blog/blog-post-comments/{id}/approve';
        _this.flagRoute = 'blog/blog-post-comments/{id}/flag';
        _this.spamRoute = 'blog/blog-post-comments/{id}/spam';
        _this.reportRoute = 'blog/blog-post-comments/{id}/report';
        _this.unapproveRoute = 'blog/blog-post-comments/{id}/unapprove';
        _this.unflagRoute = 'blog/blog-post-comments/{id}/unflag';
        _this.unspamRoute = 'blog/blog-post-comments/{id}/unspam';
        _this.unreportRoute = 'blog/blog-post-comments/{id}/unreport';
        return _this;
    }
    /**
     * Parses find blogPost route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing blogPost properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain blogPost subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the blogPost property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `startDate` - A value used to specify the blogPost creation, publish or archive date date starting from which blogPost resource collection should be returned.
     * - `endDate` - A value used to specify the blogPost creation, publish or archive date until (and including) which blogPost resource collection should be returned.
     * - `statuses` - Comma separated list of blogPost statuses that specify where search should be done (Allowed statuses: Published, Draft and Archived).
     * - `tags` - A value used to restrict the search to blogPost resources with these tags. Multiple tags should be comma separated.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @example blogPostCommentRoute.find.expand({searchQuery: '<search-phrase>'});
     **/
    BlogPostCommentRoute.prototype.find = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get blogPost route which must be expanded with the Id of the previously created blogPost resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id blogPost slug or id which uniquely identifies blogPost resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @example blogPostCommentRoute.get({id: '<blogPost-id>'});
     **/
    BlogPostCommentRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses purge blogPost route, this URI template doesn't expose any additional properties.
     * @method
     * @example blogPostCommentRoute.purge();
     **/
    BlogPostCommentRoute.prototype.purge = function () {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, {});
    };
    /**
     * Parses create blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @example blogPostCommentRoute.create();
     **/
    BlogPostCommentRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be updated into the system.
     * @example blogPostCommentRoute.update(data);
     **/
    BlogPostCommentRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be removed from the system.
     * @example blogPostCommentRoute.delete(data);
     **/
    BlogPostCommentRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses approve blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be approved into the system.
     * @example blogPostCommentRoute.approve(data);
     **/
    BlogPostCommentRoute.prototype.approve = function (data) {
        return _super.prototype.baseUpdate.call(this, this.approveRoute, data);
    };
    /**
     * Parses flag blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be flaged into the system.
     * @example blogPostCommentRoute.flag(data);
     **/
    BlogPostCommentRoute.prototype.flag = function (data) {
        return _super.prototype.baseUpdate.call(this, this.flagRoute, data);
    };
    /**
     * Parses spam blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be marked as spam into the system.
     * @example blogPostCommentRoute.spam(data);
     **/
    BlogPostCommentRoute.prototype.spam = function (data) {
        return _super.prototype.baseUpdate.call(this, this.spamRoute, data);
    };
    /**
     * Parses report blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be reported into the system.
     * @example blogPostCommentRoute.report(data);
     **/
    BlogPostCommentRoute.prototype.report = function (data) {
        return _super.prototype.baseUpdate.call(this, this.reportRoute, data);
    };
    /**
     * Parses unapprove blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be unapproved into the system.
     * @example blogPostCommentRoute.unapprove(data);
     **/
    BlogPostCommentRoute.prototype.unapprove = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unapproveRoute, data);
    };
    /**
     * Parses unflag blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be unflaged into the system.
     * @example blogPostCommentRoute.unflag(data);
     **/
    BlogPostCommentRoute.prototype.unflag = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unflagRoute, data);
    };
    /**
     * Parses unspam blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be unspamed into the system.
     * @example blogPostCommentRoute.unspam(data);
     **/
    BlogPostCommentRoute.prototype.unspam = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unspamRoute, data);
    };
    /**
     * Parses unreport blogPost route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blogPost object that needs to be unreported into the system.
     * @example blogPostCommentRoute.unreport(data);
     **/
    BlogPostCommentRoute.prototype.unreport = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unreportRoute, data);
    };
    var _a;
    BlogPostCommentRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], BlogPostCommentRoute);
    return BlogPostCommentRoute;
}(common_1.BaseRoute));
exports.BlogPostCommentRoute = BlogPostCommentRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostCommentClient
 * @description  Blogs Post Comment Client provides an easy way to consume  Blogs REST API end-points. In order to obtain needed routes `blogPostCommentClient` uses `blogPostCommentRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var common_1 = __webpack_require__(2);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(17);
var BlogPostCommentClient = /** @class */ (function () {
    function BlogPostCommentClient(blogRoute, apiClient) {
        this.blogRoute = blogRoute;
        this.apiClient = apiClient;
        this.utility = new common_1.Utility();
    }
    Object.defineProperty(BlogPostCommentClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `blogPostCommentRoute`.
         * @method
         * @example blogPostCommentClient.routeDefinition.get();
         **/
        get: function () {
            return this.blogRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of blogPostComment resources matching the given criteria.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @returns A promise that is resolved once the find action has been performed.
     * @example blogPostCommentClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    BlogPostCommentClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a single blogPostComment resource.
     * @method
     * @param id Blog slug or id which uniquely identifies blogPostComment resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @returns a promise that is resolved once the get action has been performed.
     * @example blogPostCommentClient.get('<blogPostComment-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    BlogPostCommentClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create blogPostComment action has been performed, this action creates a new blogPostComment resource.
     * @method
     * @param data An blogPostComment object that needs to be inserted into the system.
     * @returns a promise that is resolved once the create blogPostComment action has been performed.
     * @example blogPostCommentClient.create({
                    publishDate : new Date(),
                    title : '<title>',
                    content : '<content>',
                    slug : '',
                    status : baasicBlogService.statuses.draft,
                    $tags : ['<tag1>', '<tag2>']
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    BlogPostCommentClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPostComment action has been performed; this action updates an blogPostComment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostCommentRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPostComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPostComment object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPostComment action has been performed.
     * @example // blogPostComment is a resource previously fetched using get action.
                    blogPostComment.title = '<title>';
                    blogPostCommentClient.update(blogPostComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostCommentClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove blogPostComment action has been performed. If the action is successfully completed, the blogPostComment resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostCommentRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(blogPostComment);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An blogPostComment object that needs to be removed from the system.
     * @returns A promise that is resolved once the remove blogPostComment action has been performed.
     * @example // blogPostComment is a resource previously fetched using get action.
                    blogPostCommentClient.remove(blogPostComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostCommentClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPostComment action has been performed; this action updates an blogPostComment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPostComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPostComment object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPostComment action has been performed.
     * @example // blogPostComment is a resource previously fetched using get action.
                    blogPostComment.comment = '<comment>';
                    BlogPostCommentClient.approve(blogPostComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostCommentClient.prototype.approve = function (data) {
        return this.apiClient.put(this.routeDefinition.approve(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPostComment action has been performed; this action updates an blogPostComment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPostComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPostComment object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPostComment action has been performed.
     * @example // blogPostComment is a resource previously fetched using get action.
                    blogPostComment.comment = '<comment>';
                    BlogPostCommentClient.unapprove(blogPostComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostCommentClient.prototype.unapprove = function (data) {
        return this.apiClient.put(this.routeDefinition.unapprove(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPostComment action has been performed; this action updates an blogPostComment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPostComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPostComment object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPostComment action has been performed.
     * @example // blogPostComment is a resource previously fetched using get action.
                    blogPostComment.comment = '<comment>';
                    BlogPostCommentClient.spam(blogPostComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostCommentClient.prototype.spam = function (data) {
        return this.apiClient.put(this.routeDefinition.spam(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPostComment action has been performed; this action updates an blogPostComment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPostComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPostComment object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPostComment action has been performed.
     * @example // blogPostComment is a resource previously fetched using get action.
                    blogPostComment.comment = '<comment>';
                    BlogPostCommentClient.unspam(blogPostComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostCommentClient.prototype.unspam = function (data) {
        return this.apiClient.put(this.routeDefinition.unspam(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPostComment action has been performed; this action updates an blogPostComment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPostComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPostComment object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPostComment action has been performed.
     * @example // blogPostComment is a resource previously fetched using get action.
                    blogPostComment.comment = '<comment>';
                    BlogPostCommentClient.report(blogPostComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostCommentClient.prototype.report = function (data) {
        return this.apiClient.put(this.routeDefinition.report(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPostComment action has been performed; this action updates an blogPostComment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPostComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPostComment object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPostComment action has been performed.
     * @example // blogPostComment is a resource previously fetched using get action.
                    blogPostComment.comment = '<comment>';
                    BlogPostCommentClient.unreport(blogPostComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostCommentClient.prototype.unreport = function (data) {
        return this.apiClient.put(this.routeDefinition.unreport(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPostComment action has been performed; this action updates an blogPostComment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPostComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPostComment object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPostComment action has been performed.
     * @example // blogPostComment is a resource previously fetched using get action.
                    blogPostComment.comment = '<comment>';
                    BlogPostCommentClient.flag(blogPostComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostCommentClient.prototype.flag = function (data) {
        return this.apiClient.put(this.routeDefinition.flag(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the update blogPostComment action has been performed; this action updates an blogPostComment resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `blogPostRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(blogPostComment);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An blogPostComment object that needs to be updated into the system.
     * @returns A promise that is resolved once the update blogPostComment action has been performed.
     * @example // blogPostComment is a resource previously fetched using get action.
                    blogPostComment.comment = '<comment>';
                    BlogPostCommentClient.unflag(blogPostComment)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogPostCommentClient.prototype.unflag = function (data) {
        return this.apiClient.put(this.routeDefinition.unflag(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the purge blogPostComments action has been performed. Please note that all blogPostComment resources will be deleted from the system once the action is successfully completed and therefore it can only be executed by user assigned to account owner role.
     * @method
     * @example blogPostCommentClient.purge()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    BlogPostCommentClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b;
    BlogPostCommentClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogPostCommentRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogPostCommentRoute !== "undefined" && _1.BlogPostCommentRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], BlogPostCommentClient);
    return BlogPostCommentClient;
}());
exports.BlogPostCommentClient = BlogPostCommentClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostFilesStreamsRoute
 * @description Baasic Blog Post Files Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Streams Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var BlogPostFilesStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(BlogPostFilesStreamsRoute, _super);
    function BlogPostFilesStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'blog/blog-post-file-streams/{id}/{?width,height,t}';
        _this.createRoute = 'blog/blog-post-file-streams/{filename}/{?articleId}';
        _this.updateRoute = 'blog/blog-post-file-streams/{id}/{?width,height}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id of desired file stream. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @param data BlogPost file id of the original blogPost file used to identify stream that needs to be retrieved from the system.
     * @example blogPostFilesRoute.get({id: '<filename>'});
     **/
    BlogPostFilesStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the filename which indicates where the stream will be saved.
     * @method
     * @param data blogPost file that needs to be saved into the system.
     * @example blogPostFilesRoute.create({filename: '<filename>'});
     **/
    BlogPostFilesStreamsRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this route should be expanded with the id of the previously saved resource. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @param data blogPost file used to identify stream that needs to be updated.
     * @example blogPostFilesRoute.update({id: '<filename>'});
     **/
    BlogPostFilesStreamsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    BlogPostFilesStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], BlogPostFilesStreamsRoute);
    return BlogPostFilesStreamsRoute;
}(common_1.BaseRoute));
exports.BlogPostFilesStreamsRoute = BlogPostFilesStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostFilesStreamsClient
 * @description  Blog Post Files Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(17);
var BlogPostFilesStreamsClient = /** @class */ (function () {
    function BlogPostFilesStreamsClient(blogPostFilesStreamsRoute, apiClient) {
        this.blogPostFilesStreamsRoute = blogPostFilesStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(BlogPostFilesStreamsClient.prototype, "routeDefinition", {
        get: function () {
            return this.blogPostFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a stream of the derived resource. Otherwise, stream of the original file resource will be retrieved.
     * @method
     * @param data Blog Post file id of the original blogPost file used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original file stream
                    blogPostFileStreamClient.get({id: '<file-id>'})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });

                // Request derived file stream
                        blogPostFileStreamClient.get({id: '<file-id>', width: <width>, height: <height>, t: <timestamp>})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    BlogPostFilesStreamsClient.prototype.get = function (data) {
        return this.apiClient.get(this.routeDefinition.get(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a blob of the derived file resource. Otherwise, blob of the original file resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param data Article file id of the original blogPost file used to identify stream that needs to be retrieved from the system.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original blob
                    blogPostFileStreamClient.getBlob('<file-id>')
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });

                // Request derived blob
                        blogPostFileStreamClient.getBlob({
                            id: '<file-id>',
                            width: <width>,
                            height: <height>,
                            t: <timestamp>
                        })
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    BlogPostFilesStreamsClient.prototype.getBlob = function (data) {
        return this.apiClient.request({
            url: this.blogPostFilesStreamsRoute.get(data),
            responseType: 'blob',
            headers: { 'Accept': 'application/octet-stream' },
            method: 'GET'
        });
    };
    /**
     * Returns a promise that is resolved once the update file stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of file stream data type).
     * @method
     * @param data blogPost file used to identify stream that needs to be updated.
     * @param stream
     * @returns A promise that is resolved once the update file stream action has been performed.
     * @example // Update original file stream
                    blogPostFileStreamClient.update('<file-id>', <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
                // Update derived file stream
                    blogPostFileStreamClient.update({id: '<file-id>', width: <width>, height: <height>}, <file-stream>)
                        .then(function (data) {
                            //  perform success action here
                       },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    BlogPostFilesStreamsClient.prototype.update = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.blogPostFilesStreamsRoute.update(data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the create file stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param data blogPost file that needs to be saved into the system.
     * @param stream
     * @returns A promise that is resolved once the create file stream action has been performed.
     * @example blogPostFileStreamClient.create('<file-id>', <blob>)
                   .then(function (data) {
                        // perform success action her
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    BlogPostFilesStreamsClient.prototype.create = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.blogPostFilesStreamsRoute.create(data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    BlogPostFilesStreamsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogPostFilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogPostFilesStreamsRoute !== "undefined" && _1.BlogPostFilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], BlogPostFilesStreamsClient);
    return BlogPostFilesStreamsClient;
}());
exports.BlogPostFilesStreamsClient = BlogPostFilesStreamsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostFilesBatchRoute
 * @description Baasic Blog Post Files Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Batch Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var BlogPostFilesBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(BlogPostFilesBatchRoute, _super);
    function BlogPostFilesBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.unlinkRoute = 'blog/blog-post-files/batch/unlink';
        _this.updateRoute = 'blog/blog-post-files/batch';
        _this.linkRoute = 'blog/blog-post-files/batch/link';
        return _this;
    }
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @example blogPostFilesBatchRoute.unlink();
     **/
    BlogPostFilesBatchRoute.prototype.unlink = function () {
        return _super.prototype.baseCreate.call(this, this.unlinkRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example blogPostFilesBatchRoute.update();
     **/
    BlogPostFilesBatchRoute.prototype.update = function () {
        return _super.prototype.baseCreate.call(this, this.updateRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example blogPostFilesBatchRoute.link();
     **/
    BlogPostFilesBatchRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    var _a;
    BlogPostFilesBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], BlogPostFilesBatchRoute);
    return BlogPostFilesBatchRoute;
}(common_1.BaseRoute));
exports.BlogPostFilesBatchRoute = BlogPostFilesBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostFilesBatchClient
 * @description  Blog Post Files Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(17);
var BlogPostFilesBatchClient = /** @class */ (function () {
    function BlogPostFilesBatchClient(blogPostFilesBatchRoute, apiClient) {
        this.blogPostFilesBatchRoute = blogPostFilesBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(BlogPostFilesBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.blogPostFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove file resources from the system if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will remove just derived resource. Otherwise, specified file and all its accompanying derived resources will be removed from the system.
     * @method
     * @param data Collection of article files that needs to be deleted.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // Remove original file resources
                   blogPostFilesBatchClient.unlink([{ id: '<file-id>' }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
               // Remove derived file resources
                   blogPostFilesBatchClient.unlink([{ id: '<file-id>', fileFormat: { width: <width>, height: <height> } }])
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    BlogPostFilesBatchClient.prototype.unlink = function (data) {
        return this.apiClient.delete(this.blogPostFilesBatchRoute.unlink(), undefined, data);
    };
    /**
     * Returns a promise that is resolved once the update action has been performed; this action updates specified file resources.
     * @method
     * @param data A collection of article files objects used to update specified article files.
     * @returns A promise that is resolved once the update action has been performed.
     * @example blogPostFilesBatchClient.update(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    BlogPostFilesBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resources from other modules into the Files module (For example: file resources from the Media Vault module can be linked directly into the Files module).
     * @method
     * @param data A collection of article file objects that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example blogPostFilesBatchClient.link(files)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    BlogPostFilesBatchClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    BlogPostFilesBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogPostFilesBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogPostFilesBatchRoute !== "undefined" && _1.BlogPostFilesBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], BlogPostFilesBatchClient);
    return BlogPostFilesBatchClient;
}());
exports.BlogPostFilesBatchClient = BlogPostFilesBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostFilesRoute
 * @description Baasic Blog Post Files Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Article Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(17);
var BlogPostFilesRoute = /** @class */ (function (_super) {
    tslib_1.__extends(BlogPostFilesRoute, _super);
    function BlogPostFilesRoute(blogPostFilesStreamsRoute, blogPostFilesBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.blogPostFilesStreamsRoute = blogPostFilesStreamsRoute;
        _this.blogPostFilesBatchRoute = blogPostFilesBatchRoute;
        _this.appOptions = appOptions;
        _this.findRoute = 'blog/blog-post-files/{?searchQuery,ids,blogPostIds,fileIds,from,to,rpp,sort,embed,fields}';
        _this.getRoute = 'blog/blog-post-files/{id}/{?embed,fields}';
        _this.linkRoute = 'blog/blog-post-files/link';
        _this.unlinkRoute = 'blog/blog-post-files/unlink/{id}';
        _this.updateRoute = 'blog/blog-post-files/{id}';
        return _this;
    }
    Object.defineProperty(BlogPostFilesRoute.prototype, "streams", {
        get: function () {
            return this.blogPostFilesStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlogPostFilesRoute.prototype, "batch", {
        get: function () {
            return this.blogPostFilesBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing file properties using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain file subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the file property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example blogPostFilesRoute.find({searchQuery: '<search-phrase>'});
     **/
    BlogPostFilesRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route should be expanded with the Id of the file resource.
     * @method
     * @param id Article file id which uniquely identifies article resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @example blogPostFilesRoute.get({id: '<file-id>'});
     **/
    BlogPostFilesRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses link route; this URI template does not expose any additional options.
     * @method
     * @example blogPostFilesRoute.link();
     **/
    BlogPostFilesRoute.prototype.link = function () {
        return _super.prototype.baseCreate.call(this, this.linkRoute, {});
    };
    /**
     * Parses unlink route; this URI template does not expose any additional options.
     * @method
     * @example blogPostFilesRoute.unlink(data);
     **/
    BlogPostFilesRoute.prototype.unlink = function (data, options) {
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data, options, 'unlink');
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example blogPostFilesRoute.update(data);
     **/
    BlogPostFilesRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b, _c;
    BlogPostFilesRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogPostFilesStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.BlogPostFilesBatchRoute)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogPostFilesStreamsRoute !== "undefined" && _1.BlogPostFilesStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.BlogPostFilesBatchRoute !== "undefined" && _1.BlogPostFilesBatchRoute) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _c : Object])
    ], BlogPostFilesRoute);
    return BlogPostFilesRoute;
}(common_1.BaseRoute));
exports.BlogPostFilesRoute = BlogPostFilesRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogPostFilesClient
 * @description  Blog Post Files Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Files Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(17);
var BlogPostFilesClient = /** @class */ (function () {
    function BlogPostFilesClient(blogPostFilesRoute, blogPostFilesStreamsClient, BlogPostFilesBatchClient, apiClient) {
        this.blogPostFilesRoute = blogPostFilesRoute;
        this.blogPostFilesStreamsClient = blogPostFilesStreamsClient;
        this.BlogPostFilesBatchClient = BlogPostFilesBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(BlogPostFilesClient.prototype, "routeDefinition", {
        get: function () {
            return this.blogPostFilesRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlogPostFilesClient.prototype, "streams", {
        get: function () {
            return this.blogPostFilesStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BlogPostFilesClient.prototype, "batch", {
        get: function () {
            return this.BlogPostFilesBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of file resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example blogPostFilesClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    BlogPostFilesClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested file resource.
     * @method
     * @param id BlogPost file id which uniquely identifies blogPost resource that needs to be retrieved.
     * @param options Options object that contains embed data.
     * @returns A promise that is resolved once the get action has been performed.
     * @example blogPostFilesClient.get('<file-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                       // perform error handling here
                   });
    **/
    BlogPostFilesClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.blogPostFilesRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove one or many file resources from the system if successfully completed. Specified file and all its accompanying derived resources will be removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply baasicBlogPostFilesRouteService route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink').href;
     * ```
     * @method
     * @param data BlogPost file object.
     * @param options options object.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action. The following action will remove the original file resource and all accompanying derived file resources.
                    blogPostFilesRoute.remove(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    BlogPostFilesClient.prototype.unlink = function (data, options) {
        if (!options) {
            options = {};
        }
        return this.apiClient.delete(this.blogPostFilesRoute.unlink(data, options));
    };
    /**
     * Returns a promise that is resolved once the update file action has been performed; this action will update a file resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicBlogPostFilesRouteService` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     ```
     let params = modelMapper.updateParams(fileEntry);
     let uri = params['model'].links('put').href;
     ```
     * @method
     * @param data BlogPost file object that need to be updated in the system.
     * @returns A promise that is resolved once the update file action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                   fileEntry.description = '<description>';
                   blogPostFilesClient.update(fileEntry)
                       .then(function (data) {
                           // perform success action here
                       },
                        function (response, status, headers, config) {
                           // perform error handling here
                       });
    **/
    BlogPostFilesClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resource from other modules into the BlogPost Files module (For example: file resources from the Media Vault module can be linked directly into the BlogPost Files module).
     * @method
     * @param data BlogPost file object.
     * @returns A promise that is resolved once the link action has been performed.
     * @example blogPostFilesClient.link(fileObject)
                    .then(function (response, status, headers, config) {
                        // perform success handling here
                    },
                        function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    BlogPostFilesClient.prototype.link = function (data) {
        return this.apiClient.post(this.routeDefinition.link(), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c, _d;
    BlogPostFilesClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogPostFilesRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.BlogPostFilesStreamsClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.BlogPostFilesBatchClient)),
        tslib_1.__param(3, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogPostFilesRoute !== "undefined" && _1.BlogPostFilesRoute) === "function" ? _a : Object, typeof (_b = typeof _1.BlogPostFilesStreamsClient !== "undefined" && _1.BlogPostFilesStreamsClient) === "function" ? _b : Object, typeof (_c = typeof _1.BlogPostFilesBatchClient !== "undefined" && _1.BlogPostFilesBatchClient) === "function" ? _c : Object, typeof (_d = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _d : Object])
    ], BlogPostFilesClient);
    return BlogPostFilesClient;
}());
exports.BlogPostFilesClient = BlogPostFilesClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogRoute
 * @description Baasic Blog Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic blog Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var BlogRoute = /** @class */ (function (_super) {
    tslib_1.__extends(BlogRoute, _super);
    function BlogRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'blog/blogs/{?searchQuery,ids,from,to,languageIds,abrv,page,rpp,sort,embed,fields}';
        _this.getRoute = 'blog/blogs/{id}/{?embed,fields}';
        _this.purgeRoute = 'blog/blogs/purge';
        _this.createRoute = 'blog/blogs';
        _this.updateRoute = 'blog/blogs/{id}';
        _this.deleteRoute = 'blog/blogs/{id}';
        return _this;
    }
    /**
     * Parses find blog route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing blog properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain blog subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the blog property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * - `startDate` - A value used to specify the blog creation, publish or archive date date starting from which blog resource collection should be returned.
     * - `endDate` - A value used to specify the blog creation, publish or archive date until (and including) which blog resource collection should be returned.
     * - `statuses` - Comma separated list of blog statuses that specify where search should be done (Allowed statuses: Published, Draft and Archived).
     * - `tags` - A value used to restrict the search to blog resources with these tags. Multiple tags should be comma separated.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @example blogRoute.find.expand({searchQuery: '<search-phrase>'});
     **/
    BlogRoute.prototype.find = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.findRoute, opt);
    };
    /**
     * Parses get blog route which must be expanded with the Id of the previously created blog resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param id blog slug or id which uniquely identifies blog resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @example blogRoute.get({id: '<blog-id>'});
     **/
    BlogRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses purge blog route, this URI template doesn't expose any additional properties.
     * @method
     * @example blogRoute.purge();
     **/
    BlogRoute.prototype.purge = function () {
        return _super.prototype.baseDelete.call(this, this.purgeRoute, {});
    };
    /**
     * Parses create blog route; this URI template doesn't expose any additional properties.
     * @method
     * @example blogRoute.create();
     **/
    BlogRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update blog route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blog object that needs to be updated into the system.
     * @example blogRoute.update(data);
     **/
    BlogRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete blog route; this URI template doesn't expose any additional properties.
     * @method
     * @param data An blog object that needs to be removed from the system.
     * @example blogRoute.delete(data);
     **/
    BlogRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    BlogRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], BlogRoute);
    return BlogRoute;
}(common_1.BaseRoute));
exports.BlogRoute = BlogRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
*/


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module blogClient
 * @description  Blogs Client provides an easy way to consume  Blogs REST API end-points. In order to obtain needed routes `articleClient` uses `articleRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var common_1 = __webpack_require__(2);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(17);
var BlogClient = /** @class */ (function () {
    function BlogClient(blogRoute, apiClient) {
        this.blogRoute = blogRoute;
        this.apiClient = apiClient;
        this.utility = new common_1.Utility();
    }
    Object.defineProperty(BlogClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `blogRoute`.
         * @method
         * @example blogClient.routeDefinition.get();
         **/
        get: function () {
            return this.blogRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of article resources matching the given criteria.
     * @method
     * @param options A promise that is resolved once the find action has been performed.
     * @returns A promise that is resolved once the find action has been performed.
     * @example articleClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    BlogClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a single article resource.
     * @method
     * @param id Blog slug or id which uniquely identifies article resource that needs to be retrieved.
     * @param options Options object that contains embed items.
     * @returns a promise that is resolved once the get action has been performed.
     * @example articleClient.get('<article-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    BlogClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create article action has been performed, this action creates a new article resource.
     * @method
     * @param data An article object that needs to be inserted into the system.
     * @returns a promise that is resolved once the create article action has been performed.
     * @example articleClient.create({
                    publishDate : new Date(),
                    title : '<title>',
                    content : '<content>',
                    slug : '',
                    status : baasicBlogService.statuses.draft,
                    $tags : ['<tag1>', '<tag2>']
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    BlogClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update article action has been performed; this action updates an article resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(article);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An article object that needs to be updated into the system.
     * @returns A promise that is resolved once the update article action has been performed.
     * @example // article is a resource previously fetched using get action.
                    article.title = '<title>';
                    articleClient.update(article)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove article action has been performed. If the action is successfully completed, the article resource will be permanently removed from the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `articleRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(article);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An article object that needs to be removed from the system.
     * @returns A promise that is resolved once the remove article action has been performed.
     * @example // article is a resource previously fetched using get action.
                    articleClient.remove(article)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    BlogClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the purge articles action has been performed. Please note that all article resources will be deleted from the system once the action is successfully completed and therefore it can only be executed by user assigned to account owner role.
     * @method
     * @example articleClient.purge()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    BlogClient.prototype.purge = function () {
        return this.apiClient.delete(this.routeDefinition.purge());
    };
    var _a, _b;
    BlogClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogRoute !== "undefined" && _1.BlogRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], BlogClient);
    return BlogClient;
}());
exports.BlogClient = BlogClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(17);
var inversify_1 = __webpack_require__(1);
var Root = /** @class */ (function () {
    function Root(blogs, blogPosts, comments, files, tags, statuses) {
        this.blogs = blogs;
        this.blogPosts = blogPosts;
        this.comments = comments;
        this.files = files;
        this.tags = tags;
        this.statuses = statuses;
    }
    var _a, _b, _c, _d, _e, _f;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.BlogClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.BlogPostClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.BlogPostCommentClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.BlogPostFilesClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.BlogTagClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.BlogPostStatusClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.BlogClient !== "undefined" && _1.BlogClient) === "function" ? _a : Object, typeof (_b = typeof _1.BlogPostClient !== "undefined" && _1.BlogPostClient) === "function" ? _b : Object, typeof (_c = typeof _1.BlogPostCommentClient !== "undefined" && _1.BlogPostCommentClient) === "function" ? _c : Object, typeof (_d = typeof _1.BlogPostFilesClient !== "undefined" && _1.BlogPostFilesClient) === "function" ? _d : Object, typeof (_e = typeof _1.BlogTagClient !== "undefined" && _1.BlogTagClient) === "function" ? _e : Object, typeof (_f = typeof _1.BlogPostStatusClient !== "undefined" && _1.BlogPostStatusClient) === "function" ? _f : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var core_1 = __webpack_require__(32);
var __1 = __webpack_require__(34);
var httpApi_1 = __webpack_require__(4);
var modules = __webpack_require__(671);
var BaasicPlatform = /** @class */ (function () {
    function BaasicPlatform(options) {
        this.options = options;
        this.utility = new common_1.Utility();
        var opt = {};
        if (options) {
            opt = options;
        }
        this.settings = this.utility.extendAs({}, BaasicPlatform.defaultSettings, opt);
        this.diModule = new __1.DIModule();
        this.diModule.init(this, [common_1.commonDIModule, core_1.coreDIModule, httpApi_1.httpDIModule, modules]);
        this.tokenHandler = this.diModule.kernel.get(contracts_1.TYPES.ITokenHandler);
        this.userHandler = this.diModule.kernel.get(contracts_1.TYPES.IUserHandler);
        this.eventHandler = this.diModule.kernel.get(contracts_1.TYPES.IEventHandler);
        this.apiClient = this.diModule.kernel.get(httpApi_1.httpTYPES.ApiClient);
        this.membershipModule = this.diModule.kernel.get(modules.Membership.TYPES.Root);
        //Modules
        this.applicationSettingModule = this.diModule.kernel.get(modules.ApplicationSettings.TYPES.ApplicationSettingsClient);
        this.userProfileModule = this.diModule.kernel.get(modules.UserProfile.TYPES.Root);
        this.notificationModule = this.diModule.kernel.get(modules.Notifications.TYPES.NotificationsClient);
        this.maintenanceModule = this.diModule.kernel.get(modules.Maintenance.TYPES.Root);
    }
    BaasicPlatform.prototype.getAccessToken = function () {
        return this.tokenHandler.get(contracts_1.TokenTypes.Access);
    };
    BaasicPlatform.prototype.updateAccessToken = function (value) {
        this.tokenHandler.store(value);
    };
    BaasicPlatform.prototype.getApiKey = function () {
        return 'platform';
    };
    BaasicPlatform.prototype.getApiUrl = function () {
        return this.settings.apiUrl;
    };
    BaasicPlatform.prototype.getUser = function () {
        return this.userHandler.getUser();
    };
    BaasicPlatform.prototype.setUser = function (userInfo) {
        this.userHandler.setUser(userInfo);
    };
    BaasicPlatform.defaultSettings = {
        useSSL: true,
        apiRootUrl: 'api.baasic.com',
        apiVersion: 'v1',
        enableHALJSON: false
    };
    return BaasicPlatform;
}());
exports.BaasicPlatform = BaasicPlatform;


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ApplicationSettings = __webpack_require__(31);
exports.ApplicationSettings = ApplicationSettings;
var Membership = __webpack_require__(16);
exports.Membership = Membership;
var UserProfile = __webpack_require__(12);
exports.UserProfile = UserProfile;
var Notifications = __webpack_require__(11);
exports.Notifications = Notifications;
var Maintenance = __webpack_require__(33);
exports.Maintenance = Maintenance;


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(31);
var TYPES = {
    ApplicationSettingsClient: Symbol("ApplicationSettingsClient"),
    ApplicationSettingsRoute: Symbol("ApplicationSettingsRoute"),
    SettingsClient: Symbol("SettingsClient"),
    SettingsRoute: Symbol("SettingsRoute"),
    VersionClient: Symbol("VersionClient"),
    VersionRoute: Symbol("VersionRoute"),
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.ApplicationSettingsRoute).to(_1.ApplicationSettingsRoute);
    bind(TYPES.ApplicationSettingsClient).to(_1.ApplicationSettingsClient);
    bind(TYPES.SettingsClient).to(_1.SettingsClient);
    bind(TYPES.SettingsRoute).to(_1.SettingsRoute);
    bind(TYPES.VersionClient).to(_1.VersionClient);
    bind(TYPES.VersionRoute).to(_1.VersionRoute);
});
exports.diModule = diModule;


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module applicationSettingsRoute
 * @description Baasic Application Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Application Settings Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var ApplicationSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(ApplicationSettingsRoute, _super);
    function ApplicationSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Application activate route with route and query parameters.
         **/
        _this.activateRoute = 'applications/{id}/activate';
        /**
         * Application activate route with route and query parameters.
         **/
        _this.deactivateRoute = 'applications/{id}/deactivate';
        /**
         * Application delete route with route and query parameters.
         **/
        _this.deleteRoute = 'applications/{id}';
        /**
         * Application find route with route and query parameters.
         **/
        _this.findRoute = 'applications/{?searchQuery,page,rpp,sort,embed,fields}';
        /**
        * Get route with route and query parameters.
        **/
        _this.getRoute = 'applications/{id}';
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'applications';
        /**
        * Update route with route and query parameters.
        **/
        _this.updateRoute = 'applications/{id}';
        return _this;
    }
    /**
     * Parses activation route; route should be expanded with the `id` which uniquely identifies the application that needs to be activated.
     * @method
     * @param data Id which uniquely identifies application that needs to be activated.
     * @example applicationRoute.activate({id: '<identifier>'});
     **/
    ApplicationSettingsRoute.prototype.activate = function (data) {
        var params = this.modelMapper.getParams(data, undefined, 'id');
        return _super.prototype.baseCreate.call(this, this.activateRoute, params);
    };
    /**
     * Parses deactivation route; route should be expanded with the `id` which uniquely identifies the application that needs to be deactivated.
     * @method
     * @param data Id which uniquely identifies application that needs to be deactivated.
     * @example applicationRoute.deactivate({id: '<identifier>'});
     **/
    ApplicationSettingsRoute.prototype.deactivate = function (data) {
        var params = this.modelMapper.getParams(data, undefined, 'id');
        return _super.prototype.baseCreate.call(this, this.deactivateRoute, params);
    };
    /**
  * Parses get application route which must be expanded with the identifier of the previously created application resource in the system.
  * @method
  * @example applicationRoute.get(id)
  **/
    ApplicationSettingsRoute.prototype.get = function (id) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, {});
    };
    /**
     * Parses delete application route.
     * @method
     * @param data A application object used to delete specified application resource.
     * @example applicationRoute.delete(data);
     */
    ApplicationSettingsRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses find application route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing application properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain application subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the application property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example applicationRoute.find({searchQuery: '<search-phrase>'});
     **/
    ApplicationSettingsRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses create application route, this URI template does not expose any additional options.
     * @method
     * @example applicationRoute.create();
     **/
    ApplicationSettingsRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update application route.
     * @method
     * @param data A application object used to update specified application resource.
     * @example applicationRoute.update(data);
     */
    ApplicationSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    ApplicationSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], ApplicationSettingsRoute);
    return ApplicationSettingsRoute;
}(common_1.BaseRoute));
exports.ApplicationSettingsRoute = ApplicationSettingsRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module applicationSettingsClient
 * @description  Application Settings Client provides an easy way to consume  Application Settings REST API end-points. In order to obtain needed routes `applicationSettingsClient` uses `applicationSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(31);
var ApplicationSettingsClient = /** @class */ (function () {
    function ApplicationSettingsClient(applicationSettingsRoute, apiClient) {
        this.applicationSettingsRoute = applicationSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(ApplicationSettingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `applicationSettingsRoute`.
         * @method
         * @example ApplicationSettingsClient.routeDefinition.get(options)
         **/
        get: function () {
            return this.applicationSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of application resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @example applicationClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ApplicationSettingsClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified application resource.
     * @method
     * @param id A application identifier.
     * @param options Query resources options.
     * @returns A promise that is resolved once the get action has been performed.
     * @example applicationClient.get({
                    id : '<id>',
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ApplicationSettingsClient.prototype.get = function (id) {
        return this.apiClient.get(this.routeDefinition.get(id));
    };
    /**
     * Returns a promise that is resolved once the create application action has been performed; this action creates a new application.
     * @method
     * @param data An application object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create application action has been performed.
     * @example applicationClient.create({
                    email : '<email>',
                    password : '<password>',
                    name : '<name>',
                    identifier : '<identifier>',
                    additionalProperty: '<additional-property>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    ApplicationSettingsClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update application action has been performed; this action updates a application.
     * @param data A application object used to update specified application resource.
     * @returns A promise that is resolved once the update application action has been performed.
     * @method
     * @example  applicationClient.update(application)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ApplicationSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove application action has been performed. This action will remove a application from the system if successfully completed.
     * @method
     * @param data  A application object used to delete specified application resource.
     * @returns A promise that is resolved once the remove application action has been performed.
     * @example applicationClient.remove(application)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ApplicationSettingsClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update application activate action has been performed; this action activates a application.
     * @param data A application object used to activate specified application resource.
     * @returns A promise that is resolved once the activate application action has been performed.
     * @method
     * @example  applicationClient.activate(id)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ApplicationSettingsClient.prototype.activate = function (id) {
        return this.apiClient.put(this.routeDefinition.activate(id), {});
    };
    /**
     * Returns a promise that is resolved once the deactivate application action has been performed; this action deactivate a application.
     * @param data A application object used to deactivate specified application resource.
     * @returns A promise that is resolved once the deactivate application action has been performed.
     * @method
     * @example  applicationClient.deactivate(id)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    ApplicationSettingsClient.prototype.deactivate = function (id) {
        return this.apiClient.put(this.routeDefinition.deactivate(id), {});
    };
    var _a, _b;
    ApplicationSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.ApplicationSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.ApplicationSettingsRoute !== "undefined" && _1.ApplicationSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], ApplicationSettingsClient);
    return ApplicationSettingsClient;
}());
exports.ApplicationSettingsClient = ApplicationSettingsClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* globals module */
/**
 * @module settingsRoute
 * @description Baasic Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Settings Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var SettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(SettingsRoute, _super);
    function SettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Settings route with route and query parameters.
         **/
        _this.getRoute = 'settings';
        /**
         * Settings route with route and query parameters.
         **/
        _this.updateRoute = 'settings';
        return _this;
    }
    /**
     * Parses get version route.
     * @method
     * @example versionRoute.get()
     **/
    SettingsRoute.prototype.get = function () {
        return _super.prototype.baseGet.call(this, this.getRoute);
    };
    /**
     * Parses update settings route.
     * @method
     * @param data A settings object used to update specified settings resource.
     * @example settingsRoute.update(data);
     */
    SettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    SettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], SettingsRoute);
    return SettingsRoute;
}(common_1.BaseRoute));
exports.SettingsRoute = SettingsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module settingsClient
 * @description  Settings Client provides an easy way to consume  Password Recovery REST API end-points. In order to obtain needed routes `settingsClient` uses `settingsRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(31);
var SettingsClient = /** @class */ (function () {
    function SettingsClient(settingsRoute, apiClient) {
        this.settingsRoute = settingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(SettingsClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `settingsRoute`.
         * @method
         **/
        get: function () {
            return this.settingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the application settings.
     * @method
     * @returns A promise that is resolved once the get action has been performed.
     * @example settingsClient.get()
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    SettingsClient.prototype.get = function () {
        return this.apiClient.get(this.routeDefinition.get());
    };
    /**
     * Returns a promise that is resolved once the update application setting action has been performed; this action updates a application seting.
     * @param data A setting object used to update specified setting resource.
     * @returns A promise that is resolved once the update setting action has been performed.
     * @method
     * @example settingsClient.update(data)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    SettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    SettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.SettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.SettingsRoute !== "undefined" && _1.SettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], SettingsClient);
    return SettingsClient;
}());
exports.SettingsClient = SettingsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* globals module */
/**
 * @module versionRoute
 * @description Baasic Version Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Version Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var VersionRoute = /** @class */ (function (_super) {
    tslib_1.__extends(VersionRoute, _super);
    function VersionRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Versions route with route and query parameters.
         **/
        _this.getRoute = 'versions';
        return _this;
    }
    /**
     * Parses get version route.
     * @method
     * @example versionRoute.get()
     **/
    VersionRoute.prototype.get = function () {
        return _super.prototype.baseGet.call(this, this.getRoute, null, {});
    };
    var _a;
    VersionRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], VersionRoute);
    return VersionRoute;
}(common_1.BaseRoute));
exports.VersionRoute = VersionRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module versionClient
 * @description  Version Client provides an easy way to consume  Password Recovery REST API end-points. In order to obtain needed routes `versionClient` uses `versionRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(31);
var VersionClient = /** @class */ (function () {
    function VersionClient(versionRoute, apiClient) {
        this.versionRoute = versionRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(VersionClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `versionRoute`.
         * @method
         **/
        get: function () {
            return this.versionRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the all application module versions.
     * @method
     * @returns A promise that is resolved once the get action has been performed.
     * @example versionClient.get()
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    VersionClient.prototype.get = function () {
        return this.apiClient.get(this.routeDefinition.get());
    };
    var _a, _b;
    VersionClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.VersionRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.VersionRoute !== "undefined" && _1.VersionRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], VersionClient);
    return VersionClient;
}());
exports.VersionClient = VersionClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(680), exports);
tslib_1.__exportStar(__webpack_require__(681), exports);
tslib_1.__exportStar(__webpack_require__(682), exports);
tslib_1.__exportStar(__webpack_require__(683), exports);
tslib_1.__exportStar(__webpack_require__(684), exports);


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(16);
var TYPES = {
    LoginRoute: Symbol("LoginRoute"),
    LoginClient: Symbol("LoginClient"),
    LoginSocialRoute: Symbol("LoginSocialRoute"),
    LoginSocialClient: Symbol("LoginSocialClient"),
    PasswordRecoveryClient: Symbol("PasswordRecoveryClient"),
    PasswordRecoveryRoute: Symbol("PasswordRecoveryRoute"),
    RegisterClient: Symbol("RegisterClient"),
    RegisterRoute: Symbol("RegisterRoute"),
    RoleBatchClient: Symbol("RoleBatchClient"),
    RoleBatchRoute: Symbol("RoleBatchRoute"),
    RoleClient: Symbol("RoleClient"),
    RoleRoute: Symbol("RoleRoute"),
    UserClient: Symbol("UserClient"),
    UserRoute: Symbol("UserRoute"),
    LookupRoute: Symbol("LookupRoute"),
    LookupClient: Symbol("LookupClient"),
    PermissionRoute: Symbol("PermissionRoute"),
    PermissionClient: Symbol("PermissionClient"),
    Root: Symbol("Membership-Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.LoginSocialRoute).to(_1.LoginSocialRoute);
    bind(TYPES.LoginSocialClient).to(_1.LoginSocialClient);
    bind(TYPES.LoginRoute).to(_1.LoginRoute);
    bind(TYPES.LoginClient).to(_1.LoginClient);
    bind(TYPES.PasswordRecoveryRoute).to(_1.PasswordRecoveryRoute);
    bind(TYPES.PasswordRecoveryClient).to(_1.PasswordRecoveryClient);
    bind(TYPES.RegisterRoute).to(_1.RegisterRoute);
    bind(TYPES.RegisterClient).to(_1.RegisterClient);
    bind(TYPES.RoleBatchRoute).to(_1.RoleBatchRoute);
    bind(TYPES.RoleBatchClient).to(_1.RoleBatchClient);
    bind(TYPES.RoleRoute).to(_1.RoleRoute);
    bind(TYPES.RoleClient).to(_1.RoleClient);
    bind(TYPES.UserRoute).to(_1.UserRoute);
    bind(TYPES.UserClient).to(_1.UserClient);
    bind(TYPES.LookupRoute).to(_1.LookupRoute);
    bind(TYPES.LookupClient).to(_1.LookupClient);
    bind(TYPES.PermissionRoute).to(_1.PermissionRoute);
    bind(TYPES.PermissionClient).to(_1.PermissionClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module loginSocialRoute
 * @description Baasic Login Social Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Login Social Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var LoginSocialRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LoginSocialRoute, _super);
    function LoginSocialRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Social login get route with route and query parameters.
        **/
        _this.getRoute = 'login/social/{provider}/{?returnUrl}';
        /**
        * Social login post route with route and query parameters.
        **/
        _this.postRoute = 'login/social/{provider}/{?embed,fields,options}';
        return _this;
    }
    /**
     * Parses get social login route which can be expanded with additional items. Supported items are:
     * - `provider` - Provider name or Id for which the login URL should be generated.
     * - `returnUrl` - Redirect Uri for the provider which will be used when the user is redirected back to the application.
     * @method
     * @param provider Provider name or id for which the login URL should be generated.
     * @param returnUrl Redirect Uri for the provider which will be used when the user is redirected back to the application.
     * @example loginSocialRoute.get({   provider : '<provider>',   returnUrl: '<returnUrl>' });
     **/
    LoginSocialRoute.prototype.get = function (provider, returnUrl) {
        var params = {
            provider: provider,
            returnUrl: returnUrl
        };
        return _super.prototype.baseFind.call(this, this.getRoute, params);
    };
    /**
     * Parses post social login route which can be expanded with additional items. Supported items are:
     * - `provider` - Provider name or Id being used to login with.
     * @method
     * @example loginSocialClient.post({ provider : '<provider>' });
     **/
    LoginSocialRoute.prototype.post = function (provider, options) {
        return _super.prototype.baseCreate.call(this, this.postRoute, { provider: provider, options: options });
    };
    var _a;
    LoginSocialRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], LoginSocialRoute);
    return LoginSocialRoute;
}(common_1.BaseRoute));
exports.LoginSocialRoute = LoginSocialRoute;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module loginSocialClient
 * @description  Login Social Client provides an easy way to consume  Application Registration REST API end-points. In order to obtain needed routes `loginSocialClient` uses `loginSocialRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(16);
var LoginSocialClient = /** @class */ (function () {
    function LoginSocialClient(loginSocialRoute, tokenHandler, apiClient) {
        this.loginSocialRoute = loginSocialRoute;
        this.tokenHandler = tokenHandler;
        this.apiClient = apiClient;
    }
    Object.defineProperty(LoginSocialClient.prototype, "routeDefinition", {
        get: function () {
            return this.loginSocialRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a resolved social login provider Url.
     * @method
     * @param provider Provider name or id for which the login URL should be generated.
     * @param returnUrl Redirect Uri for the provider which will be used when the user is redirected back to the application.
     * @returns A promise that is resolved once the get action has been performed.
     * @example loginSocialClient.get('<provider>', '<returnUrl>')
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    LoginSocialClient.prototype.get = function (provider, returnUrl) {
        return this.apiClient.get(this.loginSocialRoute.get(provider, returnUrl));
    };
    /**
     * Returns a promise that is resolved once the post action has been performed. This action logs user into the application and success response returns the token resource.
     * @method
     * @param provider Provider name or Id which uniquely identifies social login for which access token should be issued.
     * @param data Object used to identify social login information.
     * @param options Comma separated list of additional options defining token behavior. Supported values are: "session" and "sliding".
     * @example let postData = {
                    email : '<email>',
                    code:'<code>',
                    activationUrl : '<activationUrl>',
                    oAuthToken : '<oAuthToken>',
                    oAuthVerifier : '<oAuthVerifier>',
                    password : '<password>',
                    returnUrl : '<returnUrl>'
                };
                loginSocialClient.post('<provider>', postData)
                    .then(function (collection) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    LoginSocialClient.prototype.post = function (provider, data, options) {
        var params = { provider: provider };
        if (options) {
            params.options = options;
        }
        var self = this;
        return this.apiClient.createPromise(function (resolve, reject) {
            self.apiClient.post(self.loginSocialRoute.post(provider, options), self.loginSocialRoute.createParams(data), { 'Content-Type': 'application/json; charset=UTF-8' })
                .then(function (data) {
                if (data) {
                    var token = {
                        token: data.data.access_token,
                        expires_in: data.data.expires_in,
                        sliding_window: data.data.sliding_window,
                        tokenUrl: data.data.access_url_token,
                        type: data.data.token_type
                    };
                    self.tokenHandler.store(token);
                }
                resolve(data);
            }, function (data) {
                reject(data);
            });
        });
    };
    LoginSocialClient.prototype.parseResponse = function (provider, returnUrl) {
        var params = this.parseUrlParams();
        var result = {};
        switch (provider) {
            case 'twitter':
                /** jshint camelcase: false*/
                result.oAuthToken = params.oauth_token;
                result.oAuthVerifier = params.oauth_verifier;
                break;
            default:
                result.code = params.code;
                result.returnUrl = returnUrl;
                break;
        }
        return result;
    };
    // Getting query string values in javascript: http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    LoginSocialClient.prototype.parseUrlParams = function () {
        var urlParams;
        var match, pl = /\+/g, search = /([^&=]+)=?([^&]*)/g, decode = function (s) { return decodeURIComponent(s.replace(pl, ' ')); }, query = window.location.search.substring(1);
        urlParams = {};
        /* jshint -W084*/
        while (match = search.exec(query)) {
            urlParams[decode(match[1])] = decode(match[2]);
        }
        return urlParams;
    };
    var _a, _b, _c;
    LoginSocialClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LoginSocialRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.ITokenHandler)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LoginSocialRoute !== "undefined" && _1.LoginSocialRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.ITokenHandler !== "undefined" && contracts_1.ITokenHandler) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], LoginSocialClient);
    return LoginSocialClient;
}());
exports.LoginSocialClient = LoginSocialClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* globals module */
/**
 * @module loginRoute
 * @description Baasic Platform Login Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Login Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var LoginRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LoginRoute, _super);
    function LoginRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Login route with route and query parameters.
         **/
        _this.loginRoute = 'dashboard/login/{?embed,fields,options}';
        return _this;
    }
    /**
     * Parses login route which can be expanded with additional options. Supported items are:
     * - `options` - Comma separated list of options used to setup authentication token with cookie session. Supported values are: "session" and "sliding".
     * @method
     * @example loginRoute.login( {options: 'sliding'});
     **/
    LoginRoute.prototype.login = function (options) {
        return _super.prototype.baseCreate.call(this, this.loginRoute, options);
    };
    var _a;
    LoginRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], LoginRoute);
    return LoginRoute;
}(common_1.BaseRoute));
exports.LoginRoute = LoginRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module loginClient
 * @description  Login Client provides an easy way to consume  Application Registration REST API end-points. In order to obtain needed routes `loginClient` uses `loginRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(16);
var LoginClient = /** @class */ (function () {
    function LoginClient(loginRoute, tokenHandler, apiClient) {
        this.loginRoute = loginRoute;
        this.tokenHandler = tokenHandler;
        this.apiClient = apiClient;
        this.utility = new common_1.Utility();
    }
    Object.defineProperty(LoginClient.prototype, "routeDefinition", {
        get: function () {
            return this.loginRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the login action has been performed. This action logs user into the application and success response returns the token resource.
     * @method
     * @example loginClient.login({
                    username : '<username>',
                    password : '<password>',
                    options : ['session', 'sliding']
                })
                .then(function (data) {
                    // perform success actions here
                },
                 function (data, status) {
                     // perform error handling here
                })
                .finally (function () {});
     **/
    LoginClient.prototype.login = function (data) {
        var settings = this.utility.extend({}, data);
        if (settings.options) {
            var options = settings.options;
            if (options instanceof Array) {
                settings.options = options.join();
            }
        }
        var loginData = this.transformData({
            grant_type: 'password',
            username: settings.username,
            password: settings.password
        });
        var self = this;
        return this.apiClient.createPromise(function (resolve, reject) {
            self.apiClient.post(self.loginRoute.login(settings), loginData, { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' })
                .then(function (data) {
                var token = {
                    token: data.data.access_token,
                    expires_in: data.data.expires_in,
                    sliding_window: data.data.sliding_window,
                    tokenUrl: data.data.access_url_token,
                    type: data.data.token_type
                };
                self.tokenHandler.store(token);
                resolve(data);
            }, function (data) {
                reject(data);
            });
        });
    };
    /**
     * Returns a promise that is resolved once the loadUserData action has been performed. This action retrieves the account information of the currently logged in user. Retrieved account information will contain permission collection which identifies access policies assigned to the user and application sections.
     * @method
     * @example loginClient.loadUserData()
                    .then(function (data) {
                        // perform success actions here
                    },
                     function (data) {
                         // perform error handling here
                    })
                    .finally (function () {});
     */
    LoginClient.prototype.loadUserData = function (data) {
        data = data || {};
        return this.apiClient.get(this.loginRoute.login(data), { 'Accept': 'application/json; charset=UTF-8' });
    };
    /**
     * Returns a promise that is resolved once the logout action has been performed. This action invalidates user token logging the user out of the system.
     * @method
     * @param token Authentication token which uniquely identifies user that needs to be logged out from the system.
     * @param type Token type.
     * @returns A promise that is resolved once the logout action has been performed.
     * @example let token = baasicAuthorizationService.getAccessToken();
                loginClient.logout(token.access_token, token.token_type)
                .then(function (data) {
                    // perform success handling here
                }, function() {
                    // perform error handling here
                })
                .finally (function () {});
     */
    LoginClient.prototype.logout = function (token, type) {
        var data = {
            token: token,
            type: type
        };
        var self = this;
        return this.apiClient.createPromise(function (resolve, reject) {
            self.apiClient.delete(self.loginRoute.login({}), null, data)
                .then(function (result) {
                self.tokenHandler.store(null);
                resolve(result);
            }, function (result) {
                reject(result);
            });
        });
    };
    /**
     * Returns a promise that is resolved once the refresh token action has been performed. This action refreshes user token.
     * @method
     * @param token Authentication token which uniquely identifies user that needs to be logged out from the system.
     * @param type Token type.
     * @returns A promise that is resolved once the refresh token action has been performed.
     * @example let token = baasicAuthorizationService.getAccessToken();
                loginClient.refresh(token.access_token, token.token_type)
                .then(function (data) {
                    // perform success handling here
                }, function() {
                    // perform error handling here
                })
                .finally (function () {});
    */
    LoginClient.prototype.refresh = function (token, type) {
        var data = {
            token: token,
            type: type
        };
        var self = this;
        return this.apiClient.createPromise(function (resolve, reject) {
            self.apiClient.put(self.loginRoute.login({}), null, data)
                .then(function (result) {
                var token = {
                    token: result.data.access_token,
                    expires_in: result.data.expires_in,
                    sliding_window: result.data.sliding_window,
                    tokenUrl: result.data.access_url_token,
                    type: result.data.token_type
                };
                self.tokenHandler.store(token);
                resolve(result);
            }, function (result) {
                reject(result);
            });
        });
    };
    /**
     * Returns url encoded form data.
     */
    LoginClient.prototype.transformData = function (data) {
        var items = [];
        for (var key in data) {
            items.push([encodeURIComponent(key), encodeURIComponent(data[key])].join('='));
        }
        return items.join('&');
    };
    var _a, _b, _c;
    LoginClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LoginRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.ITokenHandler)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LoginRoute !== "undefined" && _1.LoginRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.ITokenHandler !== "undefined" && contracts_1.ITokenHandler) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], LoginClient);
    return LoginClient;
}());
exports.LoginClient = LoginClient;
/**
 * @overview
  ***Notes:**
  - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
  - All end-point objects are transformed by the associated route definition.
  */ 


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* globals module */
/**
 * @module passwordRecoveryRoute
 * @description Baasic Platform Password Recovery Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Recover Password Recovery Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var PasswordRecoveryRoute = /** @class */ (function (_super) {
    tslib_1.__extends(PasswordRecoveryRoute, _super);
    function PasswordRecoveryRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Password recovery route with route and query parameters.
        **/
        _this.passwordRecoveryRoute = 'recover-password';
        return _this;
    }
    /**
     * Parses recover-password route, recover-password route doesn't expose any additional properties.
     * @method
     * @example passwordRecoveryRoute.passwordRecovery();
     **/
    PasswordRecoveryRoute.prototype.passwordRecovery = function () {
        return _super.prototype.baseCreate.call(this, this.passwordRecoveryRoute, {});
    };
    /**
     * Parses recover-password change route, recover-password change route doesn't expose any additional properties.
     * @method
     * @example passwordRecoveryRoute.passwordChange();
     **/
    PasswordRecoveryRoute.prototype.passwordChange = function () {
        return _super.prototype.baseCreate.call(this, this.passwordRecoveryRoute + '/change', {});
    };
    var _a;
    PasswordRecoveryRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], PasswordRecoveryRoute);
    return PasswordRecoveryRoute;
}(common_1.BaseRoute));
exports.PasswordRecoveryRoute = PasswordRecoveryRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module passwordRecoveryClient
 * @description  Password Recovery Client provides an easy way to consume  Password Recovery REST API end-points. In order to obtain needed routes `passwordRecoveryClient` uses `passwordRecoveryRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(16);
var PasswordRecoveryClient = /** @class */ (function () {
    function PasswordRecoveryClient(passwordRecoveryRoute, apiClient) {
        this.passwordRecoveryRoute = passwordRecoveryRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(PasswordRecoveryClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `passwordRecoveryRoute`.
         * @method
         **/
        get: function () {
            return this.passwordRecoveryRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the password change action is completed. This updates user's password selection.
     * @method
     * @param data Password recovery object used to update user's current password selection.
     * @example passwordRecoveryClient.change({
                    newPassword : '<new-password>'
                })
                .then(function () {
                    // perform success action here
                },
                 function (data) {
                    // perform error handling here
                })
                .finally (function () {});
     */
    PasswordRecoveryClient.prototype.change = function (data) {
        return this.apiClient.put(this.routeDefinition.passwordChange(), data);
    };
    /**
     * Returns a promise that is resolved once the password recovery requestReset action is completed. This action initiates the password recovery process for the user.
     * @method
     * @param data A password recovery object which contains parameters required for the password retrieval request.
     * @example passwordRecoveryClient.requestReset({
                    challengeIdentifier : '<challenge-identifier>',
                    challengeResponse : '<challenge-response>',
                    recoverUrl : '<recover-url>',
                    username : '<username>'
                })
                .then(function () {
                    // perform success action here
                },
                 function (data) {
                    // perform error handling here
                })
                .finally (function () {});
     */
    PasswordRecoveryClient.prototype.requestReset = function (data) {
        return this.apiClient.post(this.routeDefinition.passwordRecovery(), data);
    };
    /**
     * Returns a promise that is resolved once the password reset action is completed. This updates user's password selection.
     * @method
     * @param data Password recovery object used to update user's current password selection.
     * @example passwordRecoveryClient.reset({
                    newPassword : '<new-password>',
                    passwordRecoveryToken : '<password-recovery-token>'
                })
                .then(function () {
                    // perform success action here
                },
                 function (data) {
                    // perform error handling here
                })
                .finally (function () {});
     */
    PasswordRecoveryClient.prototype.reset = function (data) {
        return this.apiClient.put(this.routeDefinition.passwordRecovery(), data);
    };
    var _a, _b;
    PasswordRecoveryClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.PasswordRecoveryRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.PasswordRecoveryRoute !== "undefined" && _1.PasswordRecoveryRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], PasswordRecoveryClient);
    return PasswordRecoveryClient;
}());
exports.PasswordRecoveryClient = PasswordRecoveryClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* globals module */
/**
 * @module registerRoute
 * @description Baasic Register Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Register Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var RegisterRoute = /** @class */ (function (_super) {
    tslib_1.__extends(RegisterRoute, _super);
    function RegisterRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'register';
        /**
        * Activate route with route and query parameters.
        **/
        _this.activateRoute = 'activate/{activationToken}/';
        /**
        * Recovery route with route and query parameters.
        **/
        _this.recoveryRoute = 'recovery/{email}/';
        return _this;
    }
    /**
     * Parses register route, this route doesn't support any additional properties.
     * @method
     * @example registerRoute.create();
     **/
    RegisterRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses activation route; route should be expanded with the `activationToken` which uniquely identifies the user account that needs to be activated.
     * @method
     * @param data Security code which uniquely identifies user account that needs to be activated.
     * @example registerRoute.activate({activationToken: '<activation-token>'});
     **/
    RegisterRoute.prototype.activate = function (data) {
        var params = this.modelMapper.getParams(data, undefined, 'activationToken');
        return _super.prototype.baseCreate.call(this, this.activateRoute, params);
    };
    /**
     * Parses recovery route; route should be expanded with the `email` which uniquely identifies the user account that needs email recovery to be resent.
     * @method
     * @param data User email which uniquely identifies user account that needs password recovery resent.
     * @example registerRoute.recovery({email: '<email>'});
     **/
    RegisterRoute.prototype.recovery = function (data) {
        var params = this.modelMapper.getParams(data, undefined, 'email');
        return _super.prototype.baseCreate.call(this, this.recoveryRoute, params);
    };
    var _a;
    RegisterRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], RegisterRoute);
    return RegisterRoute;
}(common_1.BaseRoute));
exports.RegisterRoute = RegisterRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module registerClient
 * @description  Register Client provides an easy way to consume  Password Recovery REST API end-points. In order to obtain needed routes `registerClient` uses `registerRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(16);
var RegisterClient = /** @class */ (function () {
    function RegisterClient(registerRoute, apiClient, tokenHandler) {
        this.registerRoute = registerRoute;
        this.apiClient = apiClient;
        this.tokenHandler = tokenHandler;
    }
    Object.defineProperty(RegisterClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `registerRoute`.
         * @method
         **/
        get: function () {
            return this.registerRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the register create has been performed. This action will create a new user if completed successfully. Created user is not approved immediately, instead an activation e-mail is sent to the user.
     * @param data A user account object that needs to be inserted into the system.
     * @method
     * @example registerClient.create({
                    activationUrl : '<activation-url>',
                    challengeIdentifier : '<challenge-identifier>',
                    challengeResponse : '<challenge-response>',
                    email : '<email>',
                    password : '<password>',
                    username : '<username>'
                })
                .success(function (data) {
                    // perform success actions here
                }).error(function (data, status) {
                    // perform error handling here
                })
                .finally (function () {});
     **/
    RegisterClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the account activation action has been performed; this action activates a user account and success response returns the token resource.
     * @param data Security code which uniquely identifies user account that needs to be activated.
     * @returns A promise that is resolved once the account activation action has been performed.
     * @method
     * @example registerClient.activate({
                   activationToken : '<activation-token>'
               })
               .then(function (data) {
                   // perform success actions here
               },
                function (data, status) {
                   // perform error handling here
               })
               .finally (function () {});
    **/
    RegisterClient.prototype.activate = function (data) {
        var self = this;
        var promise = this.apiClient.put(this.registerRoute.activate(data), data);
        promise.then(function (data) {
            var token = {
                token: data.data.access_token,
                expires_in: data.data.expires_in,
                sliding_window: data.data.sliding_window,
                tokenUrl: data.data.access_url_token,
                type: data.data.token_type
            };
            self.tokenHandler.store(token);
            return data;
        });
        return promise;
    };
    /**
     * Returns a promise that is resolved once the account recovery action has been performed; this action resends password recovery to user.
     * @param data Email which uniquely identifies user account that needs recovery email resent.
     * @returns A promise that is resolved once the recovery action has been performed.
     * @method
     * @example registerClient.recovery({
                   email : '<email>',
                   activationUrl: '<activation-url>',
                   challengeResponse: '<challenge-response>'
               })
               .then(function (data) {
                   // perform success actions here
               },
                function (data, status) {
                   // perform error handling here
               })
               .finally (function () {});
    **/
    RegisterClient.prototype.recovery = function (data) {
        var self = this;
        return this.apiClient.put(this.registerRoute.recovery(data.email), data);
    };
    var _a, _b, _c;
    RegisterClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.RegisterRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.ITokenHandler)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.RegisterRoute !== "undefined" && _1.RegisterRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof contracts_1.ITokenHandler !== "undefined" && contracts_1.ITokenHandler) === "function" ? _c : Object])
    ], RegisterClient);
    return RegisterClient;
}());
exports.RegisterClient = RegisterClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module roleRoute
 * @description Baasic Role Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Role Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var RoleBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(RoleBatchRoute, _super);
    function RoleBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'lookups/roles/batch';
        /**
        * Update route with route and query parameters.
        **/
        _this.updateRoute = 'lookups/roles/batch';
        /**
        * Delete route with route and query parameters.
        **/
        _this.removeRoute = 'lookups/roles/batch';
        return _this;
    }
    /**
     * Parses create batch roles route; this URI template does not expose any additional options.
     * @method
     * @example roleBatchRoute.create();
     **/
    RoleBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update batch roles route.
     * @method
     * @param data A role object used to update specified role resource.
     * @example roleBatchRoute.update(data);
     */
    RoleBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses delete batch roles route.
     * @method
     * @param data A role object used to delete specified role resource.
     * @example roleBatchRoute.delete(data);
     */
    RoleBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.removeRoute, {});
    };
    var _a;
    RoleBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], RoleBatchRoute);
    return RoleBatchRoute;
}(common_1.BaseRoute));
exports.RoleBatchRoute = RoleBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module roleBatchClient
 * @description  Role Batch Client provides an easy way to consume  Role REST API end-points. In order to obtain needed routes `roleBatchClient` uses `roleBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(16);
var RoleBatchClient = /** @class */ (function () {
    function RoleBatchClient(roleBatchRoute, apiClient) {
        this.roleBatchRoute = roleBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(RoleBatchClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `roleRoute`.
         * @method
         * @example roleBatchClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.roleBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create action has been performed; this action creates a role.
     * @method
     * @param data A role object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create action has beend performed.
     * @example roleBatchClient.create({
                    description : '<description>',
                    name : '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    RoleBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update role action has been performed; this action updates a role. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `roleClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(role);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A role object used to update specified role resource.
     * @returns A promise that is resolved once the update role action has been performed.
     * @example // role is a resource previously fetched using get action.
                    role.name = '<new-name>';
                    roleBatchClient.update(role)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    RoleBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove role action has been performed. This action will remove a role from the system, if completed successfully. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `roleClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(role);
     * let uri = params['model'].links('delete').href; ```
     * @param data A role object used to delete specified role resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example // Role is a resource previously fetched using get action.
                    roleBatchClient.remove(role)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    RoleBatchClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(), undefined, this.routeDefinition.deleteBatchParams(data));
    };
    var _a, _b;
    RoleBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.RoleBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.RoleBatchRoute !== "undefined" && _1.RoleBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], RoleBatchClient);
    return RoleBatchClient;
}());
exports.RoleBatchClient = RoleBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module roleRoute
 * @description Baasic Role Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Role Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(16);
var RoleRoute = /** @class */ (function (_super) {
    tslib_1.__extends(RoleRoute, _super);
    function RoleRoute(appOptions, roleBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.roleBatchRoute = roleBatchRoute;
        /**
        * Find route with route and query parameters.
        **/
        _this.findRoute = 'lookups/roles/{?searchQuery,page,rpp,sort,embed,fields}';
        /**
        * Get route with route and query parameters.
        **/
        _this.getRoute = 'lookups/roles/{id}/{?embed,fields}';
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'lookups/roles';
        /**
        * Update route with route and query parameters.
        **/
        _this.updateRoute = 'lookups/roles/{id}';
        /**
        * Remove route with route and query parameters.
        **/
        _this.removeRoute = 'lookups/roles/{id}';
        return _this;
    }
    Object.defineProperty(RoleRoute.prototype, "batch", {
        /**
         * Provides direct access to 'roleBatchRoute'
         * @method
        **/
        get: function () {
            return this.roleBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find role route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify role resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain role subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the role property to sort the result collection by.
     * @method
     * @param options Query resource options object.
     * @example roleRoute.find({searchQuery: '<search-phrase>'});
     **/
    RoleRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get role route which should be expanded with the role Id. Note that the role Id is the primary key of the role.
     * @method
     * @param id Role unique indentifer.
     * @param options Query resource options object.
     * @example roleRoute.get().expand({id: '<role-id>'});
     **/
    RoleRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create role route; this URI template does not expose any additional options.
     * @method
     * @example roleRoute.create();
     **/
    RoleRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update role route.
     * @method
     * @param data A role object used to update specified role resource.
     * @example roleRoute.update(data);
     */
    RoleRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete role route.
     * @method
     * @param data A role object used to delete specified role resource.
     * @example roleRoute.delete(data);
     */
    RoleRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.removeRoute, data);
    };
    var _a, _b;
    RoleRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.RoleBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.RoleBatchRoute !== "undefined" && _1.RoleBatchRoute) === "function" ? _b : Object])
    ], RoleRoute);
    return RoleRoute;
}(common_1.BaseRoute));
exports.RoleRoute = RoleRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module roleClient
 * @description  Role Client provides an easy way to consume  Role REST API end-points. In order to obtain needed routes `roleClient` uses `roleRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(16);
var RoleClient = /** @class */ (function () {
    function RoleClient(roleBatchClient, roleRoute, apiClient) {
        this.roleBatchClient = roleBatchClient;
        this.roleRoute = roleRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(RoleClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `roleRoute`.
         * @method
         * @example roleClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.roleRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RoleClient.prototype, "batch", {
        /**
         * Provides direct access to `roleBatchClient`.
         * @method
         **/
        get: function () {
            return this.roleBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of role resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has beend performed.
     * @example roleClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    RoleClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified role resource.
     * @param id Role unique indentifer.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @method
     * @example roleClient.get('<role-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    RoleClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.roleRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create action has been performed; this action creates a role.
     * @method
     * @param data A role object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create action has beend performed.
     * @example roleClient.create({
                    description : '<description>',
                    name : '<name>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    RoleClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update role action has been performed; this action updates a role. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `roleClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(role);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A role object used to update specified role resource.
     * @returns A promise that is resolved once the update role action has been performed.
     * @example // role is a resource previously fetched using get action.
                    role.name = '<new-name>';
                    roleClient.update(role)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    RoleClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove role action has been performed. This action will remove a role from the system, if completed successfully. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `roleClient` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(role);
     * let uri = params['model'].links('delete').href; ```
     * @param data A role object used to delete specified role resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example // Role is a resource previously fetched using get action.
                    roleClient.remove(role)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    RoleClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    RoleClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.RoleBatchClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.RoleRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.RoleBatchClient !== "undefined" && _1.RoleBatchClient) === "function" ? _a : Object, typeof (_b = typeof _1.RoleRoute !== "undefined" && _1.RoleRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], RoleClient);
    return RoleClient;
}());
exports.RoleClient = RoleClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userRoute
 * @description Baasic User Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var UserRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserRoute, _super);
    function UserRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Find route with route and query parameters.
        **/
        _this.findRoute = 'users/{?searchQuery,page,rpp,sort,embed,fields}';
        /**
        * Get route with route and query parameters.
        **/
        _this.getRoute = 'users/{username}/{?embed,fields}';
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'users';
        /**
        * Update route with route and query parameters.
        **/
        _this.updateRoute = 'users/{id}';
        /**
        * Delete route with route and query parameters.
        **/
        _this.deleteRoute = 'users/{id}';
        /**
        * Exists route with route and query parameters.
        **/
        _this.existsRoute = 'users/{username}/exists/';
        /**
        * Change password route with route and query parameters.
        **/
        _this.changePasswordRoute = 'users/{username}/change-password';
        /**
        * Unlock route with route and query parameters.
        **/
        _this.unlockRoute = 'users/{id}/unlock';
        /**
        * Lock route with route and query parameters.
        **/
        _this.lockRoute = 'users/{id}/lock';
        /**
        * Approve route with route and query parameters.
        **/
        _this.approveRoute = 'users/{id}/approve';
        /**
        * Disapprove route with route and query parameters.
        **/
        _this.disapproveRoute = 'users/{id}/disapprove';
        return _this;
    }
    /**
     * Parses find user route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example userRoute.find({searchQuery: '<search-phrase>'});
     **/
    UserRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get user route which must be expanded with the username of the previously created user resource in the system. Additional expand supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example userRoute.get({username: '<username>'})
     **/
    UserRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options, 'username');
    };
    /**
     * Parses create user route, this URI template does not expose any additional options.
     * @method
     * @example userRoute.create();
     **/
    UserRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    UserRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    UserRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses user exists route; URI template should be expanded with the username whose availability you'd like to check.
     * @method
     * @param username A username which uniquely identifies an application user.
     * @example userRoute.exists({username: '<username>'});
     **/
    UserRoute.prototype.exists = function (username, options) {
        return _super.prototype.baseGet.call(this, this.existsRoute, username, options, 'username');
    };
    /**
     * Parses change password route, URI template should be expanded with the username of the user resource whose password should be updated.
     * @method
     * @param username A username or id which uniquely identifies user resource.
     * @example userRoute.changePassword({username: '<username>'});
     **/
    UserRoute.prototype.changePassword = function (username) {
        return _super.prototype.baseUpdate.call(this, this.changePasswordRoute, { username: username });
    };
    UserRoute.prototype.unlock = function (data) {
        return _super.prototype.baseUpdate.call(this, this.unlockRoute, data, null, 'unlock');
    };
    UserRoute.prototype.lock = function (data) {
        return _super.prototype.baseUpdate.call(this, 'users/{id}/lock', data, null, 'lock');
    };
    UserRoute.prototype.approve = function (data) {
        return _super.prototype.baseUpdate.call(this, this.approveRoute, data, null, 'approve');
    };
    UserRoute.prototype.disapprove = function (data) {
        return _super.prototype.baseUpdate.call(this, this.disapproveRoute, data, null, 'disapprove');
    };
    var _a;
    UserRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserRoute);
    return UserRoute;
}(common_1.BaseRoute));
exports.UserRoute = UserRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userClient
 * @description  User Client provides an easy way to consume  User REST API end-points. In order to obtain needed routes `userClient` uses `userRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(16);
var UserClient = /** @class */ (function () {
    function UserClient(userRoute, apiClient) {
        this.userRoute = userRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `userRoute`.
         * @method
         * @example userClient.routeDefinition.get();
         **/
        get: function () {
            return this.userRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the exists action has been performed. This action checks if user exists in the application.
     * @method
     * @param username A username which uniquely identifies an application user.
     * @example userClient.exists('<username>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    UserClient.prototype.exists = function (username, options) {
        return this.apiClient.get(this.userRoute.exists(username, options));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @example userClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    UserClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified user resource.
     * @method
     * @param id A username or id which uniquely identifies an application user whose account information needs to be retrieved.
     * @param options Query resources options.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userClient.get({
                    username : '<username>',
                    embed : '<embedded-resource>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    UserClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user action has been performed; this action creates a new user.
     * @method
     * @param data An user object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user action has been performed.
     * @example userClient.create({
                    email : '<email>',
                    password : '<password>',
                    userName : '<username>',
                    additionalProperty: '<additional-property>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    UserClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user action has been performed; this action updates a user. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('put').href;
     * ```
     * @param data A user object used to update specified user resource.
     * @returns A promise that is resolved once the update user action has been performed.
     * @method
     * @example // user is a resource previously fetched using get action.
                    user.roles = ['<role-name>', '<new-role-name>'];
                    user.email = '<new-email>';
                    userClient.update(user)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    UserClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove user action has been performed. This action will remove a user from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data  A user object used to delete specified user resource.
     * @returns A promise that is resolved once the remove user action has been performed.
     * @example // user is a resource previously fetched using get action.
                    userClient.remove(user)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    UserClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the unlock user action has been performed. This action will unlock the user resource which was previously locked either manually or automatically by the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('unlock').href;
     * ```
     * @method
     * @param data A user object used to unlock specified user resource.
     * @returns A promise that is resolved once the unlock user action has been performed.
     * @example //  user is a resource previously fetched using get action.
                        userClient.unlock(user)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                // perform error handling here
                            });
     **/
    UserClient.prototype.unlock = function (data) {
        return this.apiClient.put(this.userRoute.unlock(data), data);
    };
    /**
     * Returns a promise that is resolved once the lock user action has been performed. This action will lock the user resource out of the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('lock').href;
     * ```
     * @method
     * @param data A user object used to lock specified user resource.
     * @returns A promise that is resolved once the lock user action has been performed.
     * @example // user is a resource previously fetched using get action.
                    userClient.lock(user)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    UserClient.prototype.lock = function (data) {
        return this.apiClient.put(this.userRoute.lock(data), data);
    };
    /**
     * Returns a promise that is resolved once the approve user action has been performed. This action will mark the user resource as 'approved' in the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('approve').href;
     * ```
     * @method
     * @param data A user object used to approve specified user resource.
     * @returns A promise that is resolved once the approve user action has been performed.
     * @example // user is a resource previously fetched using get action.
                    userClient.approve(user)
                        .then(function (data) {
                            // perform success action here
                        })
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    UserClient.prototype.approve = function (data) {
        return this.apiClient.put(this.userRoute.approve(data), data);
    };
    /**
     * Returns a promise that is resolved once the disapprove user action has been performed. This action will mark the user resource as 'not approved' in the system. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(user);
     * let uri = params['model'].links('disapprove').href;
     * ```
     * @method
     * @example // user is a resource previously fetched using get action.
                    userClient.disapprove(user).then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                        // perform error handling here
                    });
     **/
    UserClient.prototype.disapprove = function (data) {
        return this.apiClient.put(this.userRoute.disapprove(data), data);
    };
    /**
     * Returns a promise that is resolved once the changePassword action has been performed. This action will update user's password selection.
     * @method
     * @param username A username or id which uniquely identifies user resource.
     * @param data A new password object used to update specified user password resource.
     * @returns A promise that is resolved once the changedPassword action has been performed.
     * @example userClient.changePassword('<username>', {
                    newPassword : '<new-password>',
                    sendMailNotification : false
                })
                .then(function () {
                    // perform success action here
                },
                 function (data, status, headers, config) {
                    // perform error handling here
                })
                .finally (function () {});
     **/
    UserClient.prototype.changePassword = function (username, data) {
        return this.apiClient.put(this.userRoute.changePassword(username), data);
    };
    var _a, _b;
    UserClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserRoute !== "undefined" && _1.UserRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserClient);
    return UserClient;
}());
exports.UserClient = UserClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 *@module lookupRoute
 * @description Baasic Lookup Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Lookup Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var LookupRoute = /** @class */ (function (_super) {
    tslib_1.__extends(LookupRoute, _super);
    function LookupRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
        * Get route with route and query parameters.
        **/
        _this.getRoute = 'lookups/{?embed,fields}';
        /**
        * Get access section route with route and query parameters.
        **/
        _this.getAccessSectionRoute = 'lookups/access-sections';
        return _this;
    }
    /**
     * Parses get route which can be expanded with additional options. Supported items are:
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example baasicLookupRouteService.get(data);
     **/
    LookupRoute.prototype.get = function (data) {
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    var _a;
    LookupRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], LookupRoute);
    return LookupRoute;
}(common_1.BaseRoute));
exports.LookupRoute = LookupRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module lookupClient
 * @description  Lookup Client provides an easy way to consume  Lookup REST API end-points. In order to obtain needed routes `lookupClient` uses `lookupRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var common_1 = __webpack_require__(2);
var _1 = __webpack_require__(16);
var httpApi_1 = __webpack_require__(4);
var LookupClient = /** @class */ (function () {
    function LookupClient(lookupRoute, apiClient) {
        this.lookupRoute = lookupRoute;
        this.apiClient = apiClient;
        this.utility = new common_1.Utility();
    }
    Object.defineProperty(LookupClient.prototype, "routeDefinition", {
        get: function () {
            return this.lookupRoute;
        },
        enumerable: true,
        configurable: true
    });
    LookupClient.prototype.getResponseData = function (embed, data) {
        var responseData = {};
        if (embed) {
            var embeds = embed.split(',');
        }
        for (var index in embeds) {
            var propName = embeds[index];
            if (data.hasOwnProperty(propName)) {
                responseData[propName] = data[propName];
            }
        }
        return responseData;
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the lookup resources.
     * @method
     * @param options Options object that contains comma separated list of related resources to be contained within the current representation.
     * @returns A promise that is resolved once the get action has been performed.
     * @example lookupClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    LookupClient.prototype.get = function (options) {
        var _this = this;
        var embed = options.embed || 'role,accessAction,accessSection,snProvider';
        var opt = this.utility.extend({}, options, { embed: embed });
        var self = this;
        return this.apiClient.createPromise(function (resolve, reject) {
            self.apiClient.get(_this.lookupRoute.get(opt))
                .then(function (data) {
                data.data = self.getResponseData(embed, data.data);
                resolve(data);
            }, function (data) {
                reject(data);
            });
        });
    };
    var _a, _b;
    LookupClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LookupRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LookupRoute !== "undefined" && _1.LookupRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], LookupClient);
    return LookupClient;
}());
exports.LookupClient = LookupClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* globals module */
/**
 * @module loginRoute
 * @description Baasic Login Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Login Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var PermissionRoute = /** @class */ (function (_super) {
    tslib_1.__extends(PermissionRoute, _super);
    function PermissionRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Find all route with route and query parameters.
         */
        _this.findAllRoute = 'permissions/sections{?searchQuery,sort,embed,fields}';
        /**
        * Find route with route and query parameters.
        **/
        _this.findRoute = 'permissions/sections/{section}/{?searchQuery,sort,embed,fields}';
        /**
         * sectionsPolicies route and query parameters.
         */
        _this.sectionsPoliciesRoute = 'permissions/sections/policies/{?sectionAbrvs,searchQuery,sort,embed,fields}';
        /**
        * Get actions route with route and query parameters.
        **/
        _this.getActionsRoute = 'permissions/actions/{?searchQuery,sort,embed,fields}';
        /**
        * Get roles route with route and query parameters.
        **/
        _this.getRolesRoute = 'lookups/roles/{?searchQuery,page,rpp,sort,embed,fields}';
        /**
        * Get users route with route and query parameters.
        **/
        _this.getUsersRoute = 'users/{?searchQuery,page,rpp,sort,embed,fields}';
        /**
        * Create route with route and query parameters.
        **/
        _this.createRoute = 'permissions/';
        /**
        * Remove route with route and query parameters.
        **/
        _this.removeRoute = 'permissions/sections/{section}/actions/{action}/{{operation}}/{{subject}}/';
        return _this;
    }
    /**
     * Parses find all route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify access policy resources using the phrase search.
     * - `sort` - A string used to set the access policy property to sort the result collection by.
     * @method
     * @example
     permissionRoute.findAll(
     {searchQuery: '<search-phrase>'}
     );
     **/
    PermissionRoute.prototype.findAll = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.findAllRoute, this.utility.extend(opt));
    };
    /**
    * Parses find route which can be expanded with additional options. Supported items are:
    * - `section` - Section abbreviation which identifies part of the application for which security privileges can be retrieved and managed.
    * - `searchQuery` - A string value used to identify access policy resources using the phrase search.
    * - `sort` - A string used to set the access policy property to sort the result collection by.
    * @method
    * @example
permissionRoute.find(
    'sectionName',
    {searchQuery: '<search-phrase>'}
);
    **/
    PermissionRoute.prototype.find = function (section, options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.findRoute, this.utility.extend({ section: section }, opt));
    };
    /**
    * Parses getActions route which can be expanded with additional options. Supported items are:
    * - `searchQuery` - A string value used to identify access action resources using the phrase search.
    * - `sort` - A string used to set the access action property to sort the result collection by.
    * @method
    * @example
permissionRoute.getActions(
{searchQuery: '<search-phrase>'}
);
    **/
    PermissionRoute.prototype.getActions = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.getActionsRoute, opt);
    };
    /**
    * Parses getRoles route which can be expanded with additional options. Supported items are:
    * - `searchQuery` - A string value used to identify access policy resources using the phrase search.
    * - `sort` - A string used to set the access policy property to sort the result collection by.
    * - `page` - A value used to set the page number, i.e. to retrieve certain access policy subset from the storage.
    * - `rpp` - A value used to limit the size of result set per page.
    * @method
    * @example
permissionRoute.getRoles(
{searchQuery: '<search-phrase>'}
);
    **/
    PermissionRoute.prototype.getRoles = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.getRolesRoute, opt);
    };
    /**
    * Parses getUsers route which can be expanded with additional options. Supported items are:
    * - `searchQuery` - A string value used to identify access policy resources using the phrase search.
    * - `sort` - A string used to set the access policy property to sort the result collection by.
    * - `page` - A value used to set the page number, i.e. to retrieve certain access policy subset from the storage.
    * - `rpp` - A value used to limit the size of result set per page.
    * @method
    * @example
permissionRoute.getRoles(
{searchQuery: '<search-phrase>'}
);
    **/
    PermissionRoute.prototype.getUsers = function (options) {
        var opt = options || {};
        return _super.prototype.baseFind.call(this, this.getUsersRoute, opt);
    };
    /**
     * Parses sectionsPoliciesRoute which can be expanded with additional options.
     * - `searchQuery` - A string value used to identify access policy resources using the phrase search.
     * - `sort` - A string used to set the access policy property to sort the result collection by.
     * - `page` - A value used to set the page number, i.e. to retrieve certain access policy subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `section` - Section abbreviation which identifies part of the application for which security privileges can be retrieved and managed.
     * @param {string} sections - Comma-spearated list of section abbreviations that identify parts of the application for which security privileges can be retrieved and managed.
     */
    PermissionRoute.prototype.findSectionsPolicies = function (sectionAbrvs, options) {
        var opt = tslib_1.__assign({ sectionAbrvs: sectionAbrvs }, options);
        return _super.prototype.baseFind.call(this, this.sectionsPoliciesRoute, opt);
    };
    /**
    * Parses create permission route; this URI template doesn't expose any additional properties.
    * @method
    * @example permissionRoute.create({});
    **/
    PermissionRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute);
    };
    /**
     * Returns a promise that is resolved once the remove permission action has been performed. This action will remove a permission from the system, if completed successfully.
     * @param data A permission object used to delete specified permission resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @method
     * @example // Permission is a resource previously fetched using get action.
                    permissionClient.remove(permission)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                            // perform error handling here
                        });
     **/
    PermissionRoute.prototype.remove = function (data) {
        var params = _super.prototype.deleteParams.call(this, data);
        var action = data.actions[0];
        var operation = '';
        var subject = '';
        if (data.role && data.role.length > 0) {
            operation = 'Role';
            subject = data.role;
        }
        else {
            operation = 'User';
            subject = data.userName;
        }
        var route = this.removeRoute.replace('{{operation}}', operation.toLowerCase() + 's').replace('{{subject}}', subject);
        return _super.prototype.baseDelete.call(this, route, data, null, 'delete' + action.abrv + operation);
    };
    var _a;
    PermissionRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], PermissionRoute);
    return PermissionRoute;
}(common_1.BaseRoute));
exports.PermissionRoute = PermissionRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module permissionClient
 * @description  Role Client provides an easy way to consume  Role REST API end-points. In order to obtain needed routes `permissionClient` uses `permissionRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(16);
var contracts_1 = __webpack_require__(3);
var PermissionClient = /** @class */ (function () {
    function PermissionClient(permissionRoute, apiClient, application) {
        this.permissionRoute = permissionRoute;
        this.apiClient = apiClient;
        this.application = application;
        this.utility = new common_1.Utility();
        this.permissionHash = {};
    }
    Object.defineProperty(PermissionClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `permissionRoute`.
         * @method
         * @example permissionClient.routeDefinition.get().expand(expandObject);
         **/
        get: function () {
            return this.permissionRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the findAll action has been performed. Success response returns a list of access sections matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example permissionClient.findAll({
                    searchQuery : '<search-phrase>'
                })
     .then(function (collection) {
                    // perform success action here
                },
     function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    PermissionClient.prototype.findAll = function (options) {
        return this.apiClient.get(this.permissionRoute.findAll(options));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of role resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has beend performed.
     * @example permissionClient.find({
                    section : '<access-section>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                    // perform error handling here
                });
     **/
    PermissionClient.prototype.find = function (section, options) {
        return this.apiClient.get(this.permissionRoute.find(section, options));
    };
    /**
    * Returns a promise that is resolved once the getActions action has been performed. Success response returns a list of access policies that match the specified search parameters.
    * @method
    * @example
            permissionClient.getActions({
            search : '<search-phrase>'
            })
            .success(function (collection) {
            // perform success action here
            })
            .error(function (response, status, headers, config) {
            // perform error handling here
            });
    **/
    PermissionClient.prototype.getActions = function (options) {
        return this.apiClient.get(this.routeDefinition.getActions(options));
    };
    /**
     * Returns a promise that is resolved once the getSectionPolicies action has beed preformed. Success response returns a list of requested access policies that match the specified search parameters
     */
    PermissionClient.prototype.getSectionsPolicies = function (sectionAbrvs, options) {
        return this.apiClient.get(this.permissionRoute.findSectionsPolicies(sectionAbrvs, options));
    };
    /**
    * Returns a promise that is resolved once the getPermissionSubjects action has been performed. Success response returns a list of matching user and role resources.
    * @method
    * @example
            permissionClient.getPermissionSubjects({
            orderBy : '<field>',
            orderDirection : '<asc|desc>',
            search : '<search-phrase>'
            })
            .success(function (collection) {
            // perform success action here
            })
            .error(function (response, status, headers, config) {
            // perform error handling here
            });
    **/
    PermissionClient.prototype.getPermissionSubjects = function (options) {
        var queue = [];
        var resolvedTasks = 0;
        var self = this;
        queue.push(this.getUsers(options)
            .then(function (collection) {
            var membCollection = [];
            collection.data.item.forEach(function (element) {
                var membershipItem = {
                    name: element.userName,
                    role: ''
                };
                membCollection.push(self.utility.extend(membershipItem, element));
            });
            return membCollection;
        }, function (data) {
            if (data.status !== undefined && data.status !== 403) {
                return data;
            }
        }));
        queue.push(self.getRoles(options)
            .then(function (collection) {
            var membCollection = [];
            collection.data.item.forEach(function (element) {
                var membershipItem = {
                    name: element.name,
                    roleName: element.name,
                    userName: ''
                };
                membCollection.push(self.utility.extend(membershipItem, element));
            });
            return membCollection;
        }, function (data) {
            if (data.status !== undefined && data.status !== 403) {
                return data;
            }
        }));
        return Promise.all(queue).then(function (membershipCollection) {
            return self.utility.OrderByArray([].concat.apply([], membershipCollection), 'name');
        });
    };
    /**
     * Returns a promise that is resolved once the create action has been performed; this action creates a new permission resource.
     * @method
     * @example
            // readAction and updateActions are resources previously fetched using getActions.
            permissionClient.create({
            actions : [readAction, updateAction],
            section : '<section-name>',
            userName : '<userName>'
            })
            .success(function (data) {
            // perform success action here
            })
            .error(function (response, status, headers, config) {
            // perform error handling here
            });
    **/
    PermissionClient.prototype.create = function (data) {
        return this.apiClient.post(this.permissionRoute.create(), data);
    };
    /**
    * Returns a promise that is resolved once the remove action has been performed. If the action is successfully complete, an access policy assigned to the specified role and section will be removed.
    * @method
    * @example
            // permission is a resource previously fetched using get action.
            permissionClient.remove(permission)
            .success(function (data) {
            // perform success action here
            })
            .error(function (response, status, headers, config) {
            // perform error handling here
            });
   **/
    PermissionClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.remove(data));
    };
    /**
    * Creates a new in-memory permission object.
    * @method
    * @example
            // action collection are lookup items fetched using lookupClient.get action.
            var actionCollection;
            return lookupClient.get()
            .success(function (data) {
            actionCollection = data;
            })
            .error(function (data, status, headers, config) {});
            // subjectItem is an item fetched using permissionClient.getPermissionSubjects action.
            permissionClient.createPermission('<section-Name>', actionCollection, subjectItem);
   **/
    PermissionClient.prototype.createPermission = function (section, actions, membershipItem) {
        var _this = this;
        var permission = {
            dirty: true,
            role: membershipItem.roleName,
            userName: membershipItem.userName,
            section: section,
            actions: []
        };
        actions.forEach(function (element) {
            var newAction = {
                checked: false
            };
            _this.utility.extend(newAction, element);
            permission.actions.push(newAction);
        });
        return permission;
    };
    /**
    * Finds a permission in a given permission collection.
    * @method
    * @example permissionClient.findPermission(permissionObj, permissionCollection);
   **/
    PermissionClient.prototype.findPermission = function (permission, permissionCollection) {
        for (var i = 0; i < permissionCollection.length; i++) {
            var item = permissionCollection[i];
            if (item.section === permission.section &&
                ((!this.isEmpty(item.role) && !this.isEmpty(permission.role) && item.role === permission.role) ||
                    (!this.isEmpty(item.userName) && !this.isEmpty(permission.userName) && item.userName === permission.userName))) {
                return item;
            }
        }
        return undefined;
    };
    /**
    * Checks if a permission object exists in a given permission collection.
    * @method
    * @example permissionClient.exists(permissionObj, permissionCollection);
   **/
    PermissionClient.prototype.exists = function (permission, permissionCollection) {
        return this.findPermission(permission, permissionCollection) !== undefined;
    };
    /**
    * Returns a promise that is resolved once the togglePermission action has been completed. The action will internally either call a `remove` or `create` action based on given criteria.
    * @method
    * @example permissionClient.togglePermission(permissionObj, action);
    **/
    PermissionClient.prototype.togglePermission = function (permission, action) {
        var requestPermission = {
            actions: []
        };
        this.utility.extend(requestPermission, permission);
        requestPermission.actions = [action];
        var operation;
        if (!action.checked) {
            operation = this.remove;
        }
        else {
            operation = this.create;
        }
        return operation.call(this, requestPermission);
    };
    /**
    * Fetches and returns and object containing all existing module permissions.
    * @method
    * @example permissionClient.getModulePermissions('<section-name>');
    **/
    PermissionClient.prototype.getModulePermissions = function (section) {
        var permission = {
            update: this.hasPermission(this.firstCharToLowerCase(section) + '.update'),
            create: this.hasPermission(this.firstCharToLowerCase(section) + '.create'),
            remove: this.hasPermission(this.firstCharToLowerCase(section) + '.delete'),
            read: this.hasPermission(this.firstCharToLowerCase(section) + '.read'),
            full: this.hasPermission(this.firstCharToLowerCase(section) + '.full')
        };
        return permission;
    };
    PermissionClient.prototype.resetPermissions = function () {
        this.permissionHash[this.application.getApiKey()] = {};
    };
    /**
    * Checks if current user has permissions to perform a certain action. To optimize performance this information is cached and can be reset using the resetPermissions action. Permissions cache should be reset when updated user information is set.
    * @method
    * @example baasicAuthorizationService.hasPermission("<baasic-Section>.<action>");
    **/
    PermissionClient.prototype.hasPermission = function (authorization) {
        var apiKey = this.application.getApiKey();
        //Initialize application permissions
        if (!this.permissionHash.hasOwnProperty(apiKey)) {
            this.resetPermissions();
        }
        if (this.permissionHash[apiKey].hasOwnProperty(authorization)) {
            return this.permissionHash[apiKey][authorization];
        }
        var userContainer = this.application.getUser();
        if (userContainer === undefined) {
            return;
        }
        var user = userContainer.user;
        var hasPermission = false;
        if (user) {
            if (user.permissions) {
                var tokens = authorization.split('.');
                if (tokens.length > 0) {
                    var section = tokens[0];
                    var sectionPermissions = user.permissions[section];
                    if (sectionPermissions) {
                        if (tokens.length > 1) {
                            var action = tokens[1].toLowerCase();
                            for (var i = 0; i < sectionPermissions.length; i++) {
                                if (sectionPermissions[i].toLowerCase() === action) {
                                    hasPermission = true;
                                    break;
                                }
                            }
                        }
                        else {
                            hasPermission = true;
                        }
                    }
                }
            }
        }
        this.permissionHash[apiKey][authorization] = hasPermission;
        return hasPermission;
    };
    PermissionClient.prototype.isEmpty = function (data) {
        return data === undefined || data === null || data === '';
    };
    PermissionClient.prototype.getRoles = function (options) {
        return this.apiClient.get(this.routeDefinition.getRoles(options));
    };
    PermissionClient.prototype.getUsers = function (options) {
        return this.apiClient.get(this.routeDefinition.getUsers(options));
    };
    PermissionClient.prototype.firstCharToLowerCase = function (text) {
        return text.replace(/^./, function (char) {
            return char.toLowerCase();
        });
    };
    var _a, _b, _c;
    PermissionClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.PermissionRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IBaasicApp)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.PermissionRoute !== "undefined" && _1.PermissionRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IBaasicApp !== "undefined" && contracts_1.IBaasicApp) === "function" ? _c : Object])
    ], PermissionClient);
    return PermissionClient;
}());
exports.PermissionClient = PermissionClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
*/ 


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(16);
var inversify_1 = __webpack_require__(1);
var Root = /** @class */ (function () {
    function Root(login, loginSocial, passwordRecovery, register, role, user, lookups, permissions) {
        this.login = login;
        this.loginSocial = loginSocial;
        this.passwordRecovery = passwordRecovery;
        this.register = register;
        this.role = role;
        this.user = user;
        this.lookups = lookups;
        this.permissions = permissions;
    }
    var _a, _b, _c, _d, _e, _f, _g, _h;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.LoginClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.LoginSocialClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.PasswordRecoveryClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.RegisterClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.RoleClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.UserClient)),
        tslib_1.__param(6, inversify_1.inject(_1.TYPES.LookupClient)),
        tslib_1.__param(7, inversify_1.inject(_1.TYPES.PermissionClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.LoginClient !== "undefined" && _1.LoginClient) === "function" ? _a : Object, typeof (_b = typeof _1.LoginSocialClient !== "undefined" && _1.LoginSocialClient) === "function" ? _b : Object, typeof (_c = typeof _1.PasswordRecoveryClient !== "undefined" && _1.PasswordRecoveryClient) === "function" ? _c : Object, typeof (_d = typeof _1.RegisterClient !== "undefined" && _1.RegisterClient) === "function" ? _d : Object, typeof (_e = typeof _1.RoleClient !== "undefined" && _1.RoleClient) === "function" ? _e : Object, typeof (_f = typeof _1.UserClient !== "undefined" && _1.UserClient) === "function" ? _f : Object, typeof (_g = typeof _1.LookupClient !== "undefined" && _1.LookupClient) === "function" ? _g : Object, typeof (_h = typeof _1.PermissionClient !== "undefined" && _1.PermissionClient) === "function" ? _h : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(706), exports);
tslib_1.__exportStar(__webpack_require__(707), exports);
tslib_1.__exportStar(__webpack_require__(708), exports);
tslib_1.__exportStar(__webpack_require__(709), exports);
tslib_1.__exportStar(__webpack_require__(710), exports);
tslib_1.__exportStar(__webpack_require__(711), exports);
tslib_1.__exportStar(__webpack_require__(712), exports);
tslib_1.__exportStar(__webpack_require__(713), exports);
tslib_1.__exportStar(__webpack_require__(714), exports);
tslib_1.__exportStar(__webpack_require__(715), exports);
tslib_1.__exportStar(__webpack_require__(716), exports);
tslib_1.__exportStar(__webpack_require__(717), exports);
tslib_1.__exportStar(__webpack_require__(718), exports);
tslib_1.__exportStar(__webpack_require__(719), exports);
tslib_1.__exportStar(__webpack_require__(720), exports);
tslib_1.__exportStar(__webpack_require__(721), exports);
tslib_1.__exportStar(__webpack_require__(722), exports);
tslib_1.__exportStar(__webpack_require__(723), exports);
tslib_1.__exportStar(__webpack_require__(724), exports);
tslib_1.__exportStar(__webpack_require__(725), exports);
tslib_1.__exportStar(__webpack_require__(726), exports);
tslib_1.__exportStar(__webpack_require__(727), exports);
tslib_1.__exportStar(__webpack_require__(728), exports);
tslib_1.__exportStar(__webpack_require__(729), exports);


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(12);
var TYPES = {
    CompanyBatchClient: Symbol("CompanyBatchClient"),
    CompanyBatchRoute: Symbol("CompanyBatchRoute"),
    CompanyClient: Symbol("CompanyClient"),
    CompanyRoute: Symbol("CompanyRoute"),
    OrganizationBatchClient: Symbol("OrganizationBatchClient"),
    OrganizationBatchRoute: Symbol("OrganizationBatchRoute"),
    OrganizationClient: Symbol("OrganizationClient"),
    OrganizationRoute: Symbol("OrganizationRoute"),
    SkillBatchClient: Symbol("SkillBatchClient"),
    SkillBatchRoute: Symbol("SkillBatchRoute"),
    SkillClient: Symbol("SkillClient"),
    SkillRoute: Symbol("SkillRoute"),
    UserEducationClient: Symbol("UserEducationClient"),
    UserEducationRoute: Symbol("UserEducationRoute"),
    UserProfileACLClient: Symbol("UserProfileACLClient"),
    UserProfileACLRoute: Symbol("UserProfileACLRoute"),
    UserProfileAvatarClient: Symbol("UserProfileAvatarClient"),
    UserProfileAvatarRoute: Symbol("UserProfileAvatarRoute"),
    UserProfileAvatarStreamsClient: Symbol("UserProfileAvatarStreamsClient"),
    UserProfileAvatarStreamsRoute: Symbol("UserProfileAvatarStreamsClient"),
    UserProfileClient: Symbol("UserProfileClient"),
    UserProfileRoute: Symbol("UserProfileRoute"),
    UserSkillClient: Symbol("UserSkillClient"),
    UserSkillRoute: Symbol("UserSkillRoute"),
    UserWorkClient: Symbol("UserWorkClient"),
    UserWorkRoute: Symbol("UserWorkRoute"),
    Root: Symbol("UserProfile-Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.CompanyBatchRoute).to(_1.CompanyBatchRoute);
    bind(TYPES.CompanyBatchClient).to(_1.CompanyBatchClient);
    bind(TYPES.CompanyRoute).to(_1.CompanyRoute);
    bind(TYPES.CompanyClient).to(_1.CompanyClient);
    bind(TYPES.OrganizationBatchRoute).to(_1.OrganizationBatchRoute);
    bind(TYPES.OrganizationBatchClient).to(_1.OrganizationBatchClient);
    bind(TYPES.OrganizationRoute).to(_1.OrganizationRoute);
    bind(TYPES.OrganizationClient).to(_1.OrganizationClient);
    bind(TYPES.SkillBatchRoute).to(_1.SkillBatchRoute);
    bind(TYPES.SkillBatchClient).to(_1.SkillBatchClient);
    bind(TYPES.SkillRoute).to(_1.SkillRoute);
    bind(TYPES.SkillClient).to(_1.SkillClient);
    bind(TYPES.UserEducationRoute).to(_1.UserEducationRoute);
    bind(TYPES.UserEducationClient).to(_1.UserEducationClient);
    bind(TYPES.UserProfileACLRoute).to(_1.UserProfileACLRoute);
    bind(TYPES.UserProfileACLClient).to(_1.UserProfileACLClient);
    bind(TYPES.UserProfileAvatarStreamsRoute).to(_1.UserProfileAvatarStreamsRoute);
    bind(TYPES.UserProfileAvatarStreamsClient).to(_1.UserProfileAvatarStreamsClient);
    bind(TYPES.UserProfileAvatarRoute).to(_1.UserProfileAvatarRoute);
    bind(TYPES.UserProfileAvatarClient).to(_1.UserProfileAvatarClient);
    bind(TYPES.UserProfileRoute).to(_1.UserProfileRoute);
    bind(TYPES.UserProfileClient).to(_1.UserProfileClient);
    bind(TYPES.UserSkillRoute).to(_1.UserSkillRoute);
    bind(TYPES.UserSkillClient).to(_1.UserSkillClient);
    bind(TYPES.UserWorkRoute).to(_1.UserWorkRoute);
    bind(TYPES.UserWorkClient).to(_1.UserWorkClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module companyBatchRoute
 * @description Baasic Company Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var CompanyBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CompanyBatchRoute, _super);
    function CompanyBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'lookups/companies/batch';
        _this.updateRoute = 'lookups/companies/batch';
        _this.deleteRoute = 'lookups/companies/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example companyRoute.create();
     **/
    CompanyBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example companyRoute.update();
     **/
    CompanyBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example companyRoute.remove();
     **/
    CompanyBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    CompanyBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], CompanyBatchRoute);
    return CompanyBatchRoute;
}(common_1.BaseRoute));
exports.CompanyBatchRoute = CompanyBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module companyBatchClient
 * @description  Company Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var CompanyBatchClient = /** @class */ (function () {
    function CompanyBatchClient(companyBatchRoute, apiClient) {
        this.companyBatchRoute = companyBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CompanyBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.companyBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create company action has been performed; this action creates new company resources.
     * @method
     * @param data A collection of company objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create company action has been performed.
     * @example  companyBatchClient.create([{
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                 }])
                 .then(function (data) {
                     // perform success action here
                  },
                   function (response, status, headers, config) {
                       // perform error handling here
                 });
     **/
    CompanyBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update company action has been performed; this action updates specified company resources.
     * @method
     * @param data A collection of company objects used to update specified company resources.
     * @returns A promise that is resolved once the update company action has been performed.
     * @example   companyBatchClient.update(companies)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CompanyBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove company resources from the system if successfully completed.
     * @method
     * @param ids Collection of company ids which uniquely identifies company resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example companyBatchClient.remove(companyIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    CompanyBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.companyBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    CompanyBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CompanyBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CompanyBatchRoute !== "undefined" && _1.CompanyBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], CompanyBatchClient);
    return CompanyBatchClient;
}());
exports.CompanyBatchClient = CompanyBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module companyRoute
 * @description Baasic Company Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(12);
var contracts_1 = __webpack_require__(3);
var CompanyRoute = /** @class */ (function (_super) {
    tslib_1.__extends(CompanyRoute, _super);
    function CompanyRoute(appOptions, companyBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.companyBatchRoute = companyBatchRoute;
        _this.findRoute = 'lookups/companies/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.createRoute = 'lookups/companies';
        _this.getRoute = 'lookups/companies/{id}/{?embed,fields}';
        _this.updateRoute = 'lookups/companies/{id}';
        _this.deleteRoute = 'lookups/companies/{id}';
        return _this;
    }
    Object.defineProperty(CompanyRoute.prototype, "batch", {
        get: function () {
            return this.companyBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing company properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain company subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the company property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example companyRoute.find({searchQuery: '<search-phrase>'});
     **/
    CompanyRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example companyRoute.create();
     **/
    CompanyRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id Company id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example companyRoute.get();
     **/
    CompanyRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    CompanyRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    CompanyRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    CompanyRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CompanyBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.CompanyBatchRoute !== "undefined" && _1.CompanyBatchRoute) === "function" ? _b : Object])
    ], CompanyRoute);
    return CompanyRoute;
}(common_1.BaseRoute));
exports.CompanyRoute = CompanyRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module companyClient
 * @description  Company Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Company Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var CompanyClient = /** @class */ (function () {
    function CompanyClient(companyBatchClient, companyRoute, apiClient) {
        this.companyBatchClient = companyBatchClient;
        this.companyRoute = companyRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(CompanyClient.prototype, "routeDefinition", {
        get: function () {
            return this.companyRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompanyClient.prototype, "batch", {
        get: function () {
            return this.companyBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of company resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example companyClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CompanyClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the company resource.
     * @method
     * @param id Company id which uniquely identifies resource that needs to be retrieved.
     * @returns A promise that is resolved once the get action has been performed.
     * @param options Query resource options object.
     * @example companyClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    CompanyClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.companyRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create company action has been performed; this action creates a new company resource.
     * @method
     * @param data A company object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create company action has been performed.
     * @example companyClient.create({
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    CompanyClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update company action has been performed; this action updates a company resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `companyRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(company);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A company object used to update specified company resource.
     * @returns A promise that is resolved once the update company action has been performed.
     * @example // company is a resource previously fetched using get action.
                    company.description = '<description>';
                    baasicCompanyService.update(company)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    CompanyClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a company resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `companyRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(company);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data A company object used to delete specified company resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // company is a resource previously fetched using get action.
                    companyClient.remove(company)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                    });
     **/
    CompanyClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    CompanyClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.CompanyBatchClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CompanyRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.CompanyBatchClient !== "undefined" && _1.CompanyBatchClient) === "function" ? _a : Object, typeof (_b = typeof _1.CompanyRoute !== "undefined" && _1.CompanyRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], CompanyClient);
    return CompanyClient;
}());
exports.CompanyClient = CompanyClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module organizationBatchRoute
 * @description Baasic Organization Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Organization Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var OrganizationBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(OrganizationBatchRoute, _super);
    function OrganizationBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'lookups/organizations/batch';
        _this.updateRoute = 'lookups/organizations/batch';
        _this.deleteRoute = 'lookups/organizations/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example organizationBatchRoute.create();
     **/
    OrganizationBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @example organizationBatchRoute.update();
     **/
    OrganizationBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
     * Parses remove route; this URI template does not expose any additional options.
     * @method
     * @example organizationBatchRoute.delete();
     **/
    OrganizationBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    OrganizationBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], OrganizationBatchRoute);
    return OrganizationBatchRoute;
}(common_1.BaseRoute));
exports.OrganizationBatchRoute = OrganizationBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module organizationBatchClient
 * @description  Organization Batch Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Organization Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var OrganizationBatchClient = /** @class */ (function () {
    function OrganizationBatchClient(organizationBatchRoute, apiClient) {
        this.organizationBatchRoute = organizationBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(OrganizationBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.organizationBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create organization action has been performed; this action creates new organization resources.
     * @method
     * @param data A collection of organization objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create organization action has been performed.
     * @example   organizationBatchClient.create([{
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                  }])
                  .then(function (data) {
                      // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
     **/
    OrganizationBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update organization action has been performed; this action updates specified organization resources.
     * @method
     * @param data A collection of organization objects used to update specified organization resources.
     * @returns A promise that is resolved once the update organization action has been performed.
     * @example   organizationBatchClient.update(organizations)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    OrganizationBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove organization resources from the system if successfully completed.
     * @method
     * @example organizationBatchClient.remove(organizationIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    OrganizationBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.organizationBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    OrganizationBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.OrganizationBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.OrganizationBatchRoute !== "undefined" && _1.OrganizationBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], OrganizationBatchClient);
    return OrganizationBatchClient;
}());
exports.OrganizationBatchClient = OrganizationBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module organizationRoute
 * @description Baasic Organization Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Organization Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(12);
var contracts_1 = __webpack_require__(3);
var OrganizationRoute = /** @class */ (function (_super) {
    tslib_1.__extends(OrganizationRoute, _super);
    function OrganizationRoute(appOptions, organizationBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.organizationBatchRoute = organizationBatchRoute;
        _this.findRoute = 'lookups/organizations/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'lookups/organizations/{id}/{?embed,fields}';
        _this.createRoute = 'lookups/organizations';
        _this.updateRoute = 'lookups/organizations/{id}';
        _this.deleteRoute = 'lookups/organizations/{id}';
        return _this;
    }
    Object.defineProperty(OrganizationRoute.prototype, "batch", {
        get: function () {
            return this.organizationBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing organization properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain organization subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the organization property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example organizationRoute.find({searchQuery: '<search-phrase>'});
     **/
    OrganizationRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id Organization id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example organizationRoute.get(id, options);
     **/
    OrganizationRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example organizationRoute.create();
     **/
    OrganizationRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data An organization object used to update specified organization resource.
     * @example organizationRoute.updata(data);
     **/
    OrganizationRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this URI template does not expose any additional options.
     * @method
     * @param data An organization object used to delete specified organization resource.
     * @example organizationRoute.delete(data);
     **/
    OrganizationRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    OrganizationRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.OrganizationBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.OrganizationBatchRoute !== "undefined" && _1.OrganizationBatchRoute) === "function" ? _b : Object])
    ], OrganizationRoute);
    return OrganizationRoute;
}(common_1.BaseRoute));
exports.OrganizationRoute = OrganizationRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module organizationClient
 * @description  Organization Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Organization Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var OrganizationClient = /** @class */ (function () {
    function OrganizationClient(organizationRoute, organizationBatchClient, apiClient) {
        this.organizationRoute = organizationRoute;
        this.organizationBatchClient = organizationBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(OrganizationClient.prototype, "routeDefinition", {
        get: function () {
            return this.organizationRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(OrganizationClient.prototype, "batch", {
        get: function () {
            return this.organizationBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of organization resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example organizationClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    OrganizationClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the organization resource.
     * @method
     * @param id Organization id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example organizationClient.get(id, options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    OrganizationClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.organizationRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create organization action has been performed; this action creates a new organization resource.
     * @method
     * @param data An organization object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create organization action has been performed.
     * @example organizationClient.create({
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    OrganizationClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update organization action has been performed; this action updates an organization resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `organizationRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(organization);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An organization object used to update specified organization resource.
     * @returns A promise that is resolved once the update organization action has been performed.
     * @example // organization is a resource previously fetched using get action.
                    organization.description = '<description>';
                    organizationClient.update(organization)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    OrganizationClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove an organization resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `organizationRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(organization);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An organization object used to delete specified organization resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // organization is a resource previously fetched using get action.
                       organizationClient.remove(organization)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    OrganizationClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    OrganizationClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.OrganizationRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.OrganizationBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.OrganizationRoute !== "undefined" && _1.OrganizationRoute) === "function" ? _a : Object, typeof (_b = typeof _1.OrganizationBatchClient !== "undefined" && _1.OrganizationBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], OrganizationClient);
    return OrganizationClient;
}());
exports.OrganizationClient = OrganizationClient;


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module skillBatchRoute
 * @description Baasic Skill Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Skill Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var SkillBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(SkillBatchRoute, _super);
    function SkillBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'profile/lookups/skills/batch';
        _this.updateRoute = 'profile/lookups/skills/batch';
        _this.deleteRoute = 'profile/lookups/skills/batch';
        return _this;
    }
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example skillBatchRoute.create();
     **/
    SkillBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
      * Parses update route; this URI template does not expose any additional options.
      * @method
      * @example skillBatchRoute.update();
      **/
    SkillBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    /**
      * Parses delete route; this URI template does not expose any additional options.
      * @method
      * @example skillBatchRoute.delete();
      **/
    SkillBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    var _a;
    SkillBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], SkillBatchRoute);
    return SkillBatchRoute;
}(common_1.BaseRoute));
exports.SkillBatchRoute = SkillBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module skillBatchClient
 * @description Baasic Skill Batch Service provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Skill Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var SkillBatchClient = /** @class */ (function () {
    function SkillBatchClient(skillBatchRoute, apiClient) {
        this.skillBatchRoute = skillBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(SkillBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.skillBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create skill action has been performed; this action creates new skill resources.
     * @method
     * @param data A collection of skill objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create skill action has been performed.
     * @example   skillClient.create([{
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                  }])
                  .then(function (data) {
                      // perform success action here
                  },
                    function (response, status, headers, config) {
                        // perform error handling here
                  });
     **/
    SkillBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update skill action has been performed; this action updates specified skill resources.
     * @method
     * @param data A collection of skill objects used to update specified skill resources.
     * @returns A promise that is resolved once the update skill action has been performed.
     * @example   skillBatchClient.update(companies)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    SkillBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove skill resources from the system if successfully completed.
     * @method
     * @param ids Collection of skill ids which uniquely identifies skill resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example skillBatchClient.remove(skillIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    SkillBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.skillBatchRoute.delete(), undefined, ids);
    };
    var _a, _b;
    SkillBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.SkillBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.SkillBatchRoute !== "undefined" && _1.SkillBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], SkillBatchClient);
    return SkillBatchClient;
}());
exports.SkillBatchClient = SkillBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module skillRoute
 * @description Baasic Skill Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Skill Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(12);
var contracts_1 = __webpack_require__(3);
var SkillRoute = /** @class */ (function (_super) {
    tslib_1.__extends(SkillRoute, _super);
    function SkillRoute(appOptions, skillBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.skillBatchRoute = skillBatchRoute;
        _this.findRoute = 'profile/lookups/skills/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profile/lookups/skills/{id}/{?embed,fields}';
        _this.createRoute = 'profile/lookups/skills';
        _this.updateRoute = 'profile/lookups/skills/{id}';
        _this.deleteRoute = 'lookups/skills/{id}';
        return _this;
    }
    Object.defineProperty(SkillRoute.prototype, "batch", {
        get: function () {
            return this.skillBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing skill properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain skill subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the skill property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example skillRoute.find({searchQuery: '<search-phrase>'});
     **/
    SkillRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id Skill id which uniquely identifies skill resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example skillRoute.get(id, options);
     **/
    SkillRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @example skillRoute.create();
     **/
    SkillRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data A skill object used to update specified skill resource.
     * @example skillRoute.update(data);
     **/
    SkillRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this URI template does not expose any additional options.
     * @method
     * @param data A skill object used to delete specified skill resource.
     * @example skillRoute.delete(data);
     **/
    SkillRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    SkillRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.SkillBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.SkillBatchRoute !== "undefined" && _1.SkillBatchRoute) === "function" ? _b : Object])
    ], SkillRoute);
    return SkillRoute;
}(common_1.BaseRoute));
exports.SkillRoute = SkillRoute;


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module skillClient
 * @description  Skill Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Skill Route Service to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var SkillClient = /** @class */ (function () {
    function SkillClient(skillRoute, skillBatchClient, apiClient) {
        this.skillRoute = skillRoute;
        this.skillBatchClient = skillBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(SkillClient.prototype, "routeDefinition", {
        get: function () {
            return this.skillRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(SkillClient.prototype, "batch", {
        get: function () {
            return this.skillBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of skill resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example skillClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    SkillClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the skill resource.
     * @method
     * @param id Skill id which uniquely identifies skill resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example skillClient.get(id, options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    SkillClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.skillRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create skill action has been performed; this action creates a new skill resource.
     * @method
     * @param data A skill object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create skill action has been performed.
     * @example skillClient.create({
                    description : '<description>',
                    name : '<name>',
                    slug: '<slug>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    SkillClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update skill action has been performed; this action updates a skill resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `skillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data A skill object used to update specified skill resource.
     * @returns A promise that is resolved once the update skill action has been performed.
     * @example // skill is a resource previously fetched using get action.
                    skill.description = '<description>';
                    skillClient.update(skill)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    SkillClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a skill resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `skillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param A skill object used to delete specified skill resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // skill is a resource previously fetched using get action.
                       skillClient.remove(skill)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    SkillClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c;
    SkillClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.SkillRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.SkillBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.SkillRoute !== "undefined" && _1.SkillRoute) === "function" ? _a : Object, typeof (_b = typeof _1.SkillBatchClient !== "undefined" && _1.SkillBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], SkillClient);
    return SkillClient;
}());
exports.SkillClient = SkillClient;


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userEducationRoute
 * @description Baasic User Education Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Education Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var UserEducationRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserEducationRoute, _super);
    function UserEducationRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'profiles/{userId}/educations/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{userId}/educations/{id}/{?embed,fields}';
        _this.createRoute = 'profiles/{userId}/educations';
        _this.updateRoute = 'profiles/{userId}/educations/{id}';
        _this.deleteRoute = 'profiles/{userId}/educations/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user education properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user education subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user education property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userEducationRoute.find({searchQuery: '<search-phrase>'});
     **/
    UserEducationRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User education id which uniquely identifies user education resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userEducationRoute.get(id);
     **/
    UserEducationRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @param data An user education object that needs to be inserted into the system.
     * @example userEducationRoute.create(data);
     **/
    UserEducationRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data An user education object used to update specified skill resource.
     * @example userEducationRoute.update(data);
     **/
    UserEducationRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delte route; this URI template does not expose any additional options.
     * @method
     * @param data An user education object used to delete specified skill resource.
     * @example userEducationRoute.delete(data);
     **/
    UserEducationRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    UserEducationRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserEducationRoute);
    return UserEducationRoute;
}(common_1.BaseRoute));
exports.UserEducationRoute = UserEducationRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userEducationClient  * @description  User Education Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Education Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var UserEducationClient = /** @class */ (function () {
    function UserEducationClient(userEducationRoute, apiClient) {
        this.userEducationRoute = userEducationRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserEducationClient.prototype, "routeDefinition", {
        get: function () {
            return this.userEducationRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user education resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example userEducationClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserEducationClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the user education resource.
     * @method
     * @example userEducationClient.get(id)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserEducationClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userEducationRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user education action has been performed; this action creates a new user education resource.
     * @method
     * @param data An user education object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user education action has been performed.
     * @example userEducationClient.create({
                    organizationName : '<organization-name>',
                    summary: '<summary>',
                    userId: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserEducationClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user education action has been performed; this action updates a user education resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userEducationRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(education);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An user education object used to update specified user education resource.
     * @returns A promise that is resolved once the update user education action has been performed.
     * @example // education is a resource previously fetched using get action.
                    education.degree = '<degree>';
                    userEducationClient.update(education)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserEducationClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a user education resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `baasicUserEducationRoutDefinition` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(education);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // education is a resource previously fetched using get action.
                    userEducationClient.remove(education)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserEducationClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    UserEducationClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserEducationRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserEducationRoute !== "undefined" && _1.UserEducationRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserEducationClient);
    return UserEducationClient;
}());
exports.UserEducationClient = UserEducationClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileAvatarStreamsRoute
 * @description Baasic User Profile Avatar Streams Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Avatar Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var UserProfileAvatarStreamsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileAvatarStreamsRoute, _super);
    function UserProfileAvatarStreamsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'profiles/{id}/avatar-streams/{?width,height,t}';
        _this.createRoute = 'profiles/{id}/avatar-streams/{filename}';
        _this.updateRoute = 'profiles/{id}/avatar-streams/{?width,height}';
        return _this;
    }
    /**
     * Parses get route; this route should be expanded with id of profile. Additional supported items are:
     * - `width` - width of desired derived image.
     * - `height` - height of desired derived image.
     * - `t` - cache invalidation param.
     * @method
     * @example userProfileAvatarStreamsRoute.get({id: '<file-id>'});
     **/
    UserProfileAvatarStreamsRoute.prototype.get = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.getRoute, data);
    };
    /**
     * Parses create route; this route should be expanded with the filename which indicates where the stream will be saved as well with id of the profile.
     * @method
     * @example userProfileAvatarStreamRoute.create({ filename: '<filename>', id: '<file-id>' });
     **/
    UserProfileAvatarStreamsRoute.prototype.create = function (id, data) {
        if (!this.utility.isObject(data)) {
            data = {
                filename: data
            };
        }
        var params = this.utility.extend({}, data);
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.createRoute, params);
    };
    /**
     * Parses update route; this route should be expanded with the id of the profile. Additional supported items are:
     * - `width` - width of derived image to update.
     * - `height` - height of derived image to update.
     * @method
     * @param data
     * @example userProfileAvatarStreamsRoute.update({id: '<file-id>'});
     **/
    UserProfileAvatarStreamsRoute.prototype.update = function (data) {
        if (!this.utility.isObject(data)) {
            data = {
                id: data
            };
        }
        return _super.prototype.baseCreate.call(this, this.updateRoute, data);
    };
    var _a;
    UserProfileAvatarStreamsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserProfileAvatarStreamsRoute);
    return UserProfileAvatarStreamsRoute;
}(common_1.BaseRoute));
exports.UserProfileAvatarStreamsRoute = UserProfileAvatarStreamsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileAvatarStreamsClient
 * @description  User Profile Avatar Streams Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Avatar Streams Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var UserProfileAvatarStreamsClient = /** @class */ (function () {
    function UserProfileAvatarStreamsClient(userProfileAvatarStreamsRoute, apiClient) {
        this.userProfileAvatarStreamsRoute = userProfileAvatarStreamsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserProfileAvatarStreamsClient.prototype, "routeDefinition", {
        get: function () {
            return this.userProfileAvatarStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream if successfully completed. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a stream of the derived resource. Otherwise, stream of the original file resource will be retrieved.
     * @method
     * @param data User unique identifier.
     * @returns A promise that is resolved once the get action has been performed.
     * @example // Request the original file stream
                    userProfileAvatarStreamsClient.get({id: '<file-id>'})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
                    // Request derived file stream
                    userProfileAvatarStreamsClient.get({id: '<file-id>', width: <width>, height: <height>, t: <timestamp>})
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserProfileAvatarStreamsClient.prototype.get = function (data) {
        return this.apiClient.get(this.routeDefinition.get(data));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the file stream as a blob. If derived resource's format is passed, such as `width` and `height` for the image type of file resource, the operation will return a blob of the derived file resource. Otherwise, blob of the original file resource will be retrieved. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @example // Request the original blob
                    userProfileAvatarStreamsClient.getBlob('<file-id>')
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
                        // Request derived blob
                        userProfileAvatarStreamsClient.getBlob({id: '<file-id>', width: <width>, height: <height>, t: <timestamp>})
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    UserProfileAvatarStreamsClient.prototype.getBlob = function (data) {
        return this.apiClient.request({
            url: this.userProfileAvatarStreamsRoute.get(data),
            responseType: 'blob',
            headers: { 'Accept': 'application/octet-stream' },
            method: 'GET'
        });
    };
    /**
     * Returns a promise that is resolved once the create file stream action has been performed; this action will upload the specified blob. For more information on Blob objects please see [Blob Documentation](https://developer.mozilla.org/en-US/docs/Web/API/Blob).
     * @method
     * @param id
     * @param data
     * @param stream
     * @returns A promise that is resolved once the create file stream action has been performed.
     * @example userProfileAvatarStreamsClient.create('<file-id>', '<filename'>, <blob>)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileAvatarStreamsClient.prototype.create = function (id, data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.post(this.userProfileAvatarStreamsRoute.create(id, data), formData, { 'Content-Type': undefined });
    };
    /**
     * Returns a promise that is resolved once the update file stream action has been performed; this action will replace the existing stream with a new one. Alternatively, if a derived stream is being updated it will either create a new derived stream or replace the existing one. In order to update a derived stream, format needs to be passed (For example: `width` and `height` for the image type of file stream data type).
     * @method
     * @param data
     * @param stream
     * @returns A promise that is resolved once the update file stream action has been performed.
     * @example // Update original file stream
                    userProfileAvatarStreamsClient.update('<file-id>', <file-stream>)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
                        // Update derived file stream
                        userProfileAvatarStreamsClient.update({id: '<file-id>', width: <width>, height: <height>}, <file-stream>)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     **/
    UserProfileAvatarStreamsClient.prototype.update = function (data, stream) {
        var formData = new FormData();
        formData.append('file', stream);
        return this.apiClient.put(this.userProfileAvatarStreamsRoute.update(data), formData, { 'Content-Type': undefined });
    };
    var _a, _b;
    UserProfileAvatarStreamsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileAvatarStreamsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileAvatarStreamsRoute !== "undefined" && _1.UserProfileAvatarStreamsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserProfileAvatarStreamsClient);
    return UserProfileAvatarStreamsClient;
}());
exports.UserProfileAvatarStreamsClient = UserProfileAvatarStreamsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileAvatarRoute
 * @description Baasic User Profile Avatar Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Avatar Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(12);
var contracts_1 = __webpack_require__(3);
var UserProfileAvatarRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileAvatarRoute, _super);
    function UserProfileAvatarRoute(appOptions, userProfileAvatarStreamsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.userProfileAvatarStreamsRoute = userProfileAvatarStreamsRoute;
        _this.getRoute = 'profiles/{id}/avatars/{?embed,fields}';
        _this.updateRoute = 'profiles/{id}/avatars';
        _this.linkRoute = 'profiles/{id}/avatars/link';
        _this.unlinkRoute = 'profiles/{id}/avatars/unlink';
        return _this;
    }
    Object.defineProperty(UserProfileAvatarRoute.prototype, "streams", {
        get: function () {
            return this.userProfileAvatarStreamsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses get route; this route should be expanded with the Id of the profile.
     * @method
     * @param id User Profile id which uniquely identifies user avatar resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userProfileAvatarRoute.get({id: '<file-id>'});
     **/
    UserProfileAvatarRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data A Profile Avatar object used to update specified Profile Avatar resource.
     * @example userProfileAvatarRoute.update(data);
     **/
    UserProfileAvatarRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses link route; this route should be expanded with the Id of the profile.
     * @method
     * @param id User Profile id which uniquely identifies user avatar resource that needs to be retrieved.
     * @param data A Profile Avatar object used to link specified Profile Avatar resource.
     * @example userProfileAvatarRoute.link({id: '<file-id>'});
     **/
    UserProfileAvatarRoute.prototype.link = function (id, data) {
        var params = this.utility.extend({}, data);
        params.id = id;
        return _super.prototype.baseCreate.call(this, this.linkRoute, params);
    };
    /**
     * Parses link route; this route should be expanded with the Id of the profile.
     * @method
     * @param data A Profile Avatar object used to unlink specified Profile Avatar resource.
     * @param options Query resource options object.
     * @example userProfileAvatarRoute.unlink(data);
     **/
    UserProfileAvatarRoute.prototype.unlink = function (data, options) {
        if (!options) {
            options = {};
        }
        return _super.prototype.baseDelete.call(this, this.unlinkRoute, data, options);
    };
    UserProfileAvatarRoute.prototype.createParams = function (data, id) {
        var params = this.utility.extend(data);
        params.id = id;
        return _super.prototype.createParams.call(this, params);
    };
    var _a, _b;
    UserProfileAvatarRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserProfileAvatarStreamsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.UserProfileAvatarStreamsRoute !== "undefined" && _1.UserProfileAvatarStreamsRoute) === "function" ? _b : Object])
    ], UserProfileAvatarRoute);
    return UserProfileAvatarRoute;
}(common_1.BaseRoute));
exports.UserProfileAvatarRoute = UserProfileAvatarRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileAvatarClient
 * @description  User Profile Avatar Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Avatar Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var UserProfileAvatarClient = /** @class */ (function () {
    function UserProfileAvatarClient(userProfileAvatarRoute, userProfileAvatarStreamsClient, apiClient) {
        this.userProfileAvatarRoute = userProfileAvatarRoute;
        this.userProfileAvatarStreamsClient = userProfileAvatarStreamsClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserProfileAvatarClient.prototype, "routeDefinition", {
        get: function () {
            return this.userProfileAvatarRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileAvatarClient.prototype, "streams", {
        get: function () {
            return this.userProfileAvatarStreamsClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns requested file resource.
     * @method
     * @param id User Profile id which uniquely identifies user avatar resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userProfileAvatarClient.get('<file-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    **/
    UserProfileAvatarClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userProfileAvatarRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the update file action has been performed; this action will update a file resource if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userProfileAvatarRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(fileEntry);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data Avatar file object that need to be updated in the system.
     * @returns A promise that is resolved once the update file action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action.
                       fileEntry.description = '<description>';
                       userProfileAvatarClient.update(fileEntry)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                           });
                                // perform error handling here
    **/
    UserProfileAvatarClient.prototype.update = function (data) {
        return this.apiClient.put(this.userProfileAvatarRoute.update(data), data);
    };
    /**
     * Returns a promise that is resolved once the link action has been performed; this action links file resource from other modules into the Profile Files module (For example: file resources from the Media Vault module can be linked directly into the Profile Files module).
     * @method
     * @param id User Profile id which uniquely identifies user avatar resource that needs to be retrieved.
     * @param data A profile avatar file object that need to be inserted into the system.
     * @returns A promise that is resolved once the link action has been performed.
     * @example userProfileAvatarClient.link(fileObject)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileAvatarClient.prototype.link = function (id, data) {
        return this.apiClient.post(this.routeDefinition.link(id, data), this.routeDefinition.createParams(data, id));
    };
    /**
     * Returns a promise that is resolved once the unlink action has been performed. This action will remove one or many file resources from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply userProfileAvatarRoute route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(fileEntry);
     * let uri = params['model'].links('unlink').href;
     * ```
     * @method
     * @param data A profile avatar file object used to remove specific profile avatar from the system.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the unlink action has been performed.
     * @example // fileEntry is a file resource previously fetched using get action. The following action will remove the original file resource and all accompanying derived file resources.
                    userProfileAvatarRoute.remove(fileEntry)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserProfileAvatarClient.prototype.unlink = function (data, options) {
        return this.apiClient.delete(this.userProfileAvatarRoute.unlink(data, options));
    };
    var _a, _b, _c;
    UserProfileAvatarClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileAvatarRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserProfileAvatarStreamsClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileAvatarRoute !== "undefined" && _1.UserProfileAvatarRoute) === "function" ? _a : Object, typeof (_b = typeof _1.UserProfileAvatarStreamsClient !== "undefined" && _1.UserProfileAvatarStreamsClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], UserProfileAvatarClient);
    return UserProfileAvatarClient;
}());
exports.UserProfileAvatarClient = UserProfileAvatarClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileACLRoute
 * @description Baasic User ACL Profile Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile ACL Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var UserProfileACLRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileACLRoute, _super);
    function UserProfileACLRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'profiles/{id}/acl/{?fields}';
        _this.updateRoute = 'profiles/{id}/acl/{?fields}';
        _this.deleteByUserRoute = 'profiles/{id}/acl/actions/{accessAction}/users/{user}/';
        _this.deleteByRoleRoute = 'profiles/{id}/acl/actions/{accessAction}/roles/{role}/';
        return _this;
    }
    /**
     * Parses get user profile acl route; this URI template should be expanded with the Id of the user profile resource.
     * @method
     * @param options Query resource options object.
     * @example userProfileACLRoute.get({id: '<profile-id>'});
     **/
    UserProfileACLRoute.prototype.get = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.getRoute, params);
    };
    /**
     * Parses update user profile acl route; this URI template should be expanded with the Id of the user profile.
     * @method
     * @param options ACL options object.
     * @example userProfileACLRoute.update({id: '<profile-id>'});
     **/
    UserProfileACLRoute.prototype.update = function (options) {
        var params = this.utility.extend({}, options);
        return _super.prototype.baseCreate.call(this, this.updateRoute, params);
    };
    UserProfileACLRoute.prototype.updateParams = function (options) {
        var params = this.utility.extend({}, options);
        return params[this.modelMapper.modelPropertyName];
    };
    /**
     * Parses deleteByUser user profile acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the user profile resource.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified user and user profile resource.
     * - `user` - A value which uniquely identifies user for which ACL policy needs to be removed.
     * @method
     * @param profileId User profile id which uniquely identifies user profile resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user profile resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL policy object used to delete specified ACL policy resource.
     * @example userProfileACLRoute.deleteByUser({ id: '<profile-id>', accessAction: '<access-action>', user: '<username>' });
     **/
    UserProfileACLRoute.prototype.deleteByUser = function (profileId, action, user, data) {
        var params = this.modelMapper.removeParams(data);
        params.profileId = profileId;
        params.user = user;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByUserRoute, params);
    };
    /**
     * Parses deleteByUser user profile acl route which can be expanded with additional options. Supported items are:
     * - `id` - Id of the user profile.
     * - `accessAction` - Action abbreviation which identifies ACL policy assigned to the specified role and user profile resource.
     * - `role` - A value which uniquely identifies role for which ACL policy needs to be removed.
     * @method
     * @param profileId User profile id which uniquely identifies user profile resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user profile resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data  ACL policy object used to delete specified ACL policy resource.
     * @example userProfileACLRoute.deleteByRole.expand({ id: '<profile-id>', accessAction: '<access-action>', role: '<role-name>' });
     **/
    UserProfileACLRoute.prototype.deleteByRole = function (profileId, action, role, data) {
        var params = this.modelMapper.removeParams(data);
        params.profileId = profileId;
        params.role = role;
        params.accessAction = action;
        return _super.prototype.baseCreate.call(this, this.deleteByRoleRoute, params);
    };
    var _a;
    UserProfileACLRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserProfileACLRoute);
    return UserProfileACLRoute;
}(common_1.BaseRoute));
exports.UserProfileACLRoute = UserProfileACLRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileACLClient
 * @description  User Profile ACL Client provides an easy way to consume  User Profile REST API end-points. In order to obtain needed routes `userProfileACLClient` uses `userProfileACLRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var UserProfileACLClient = /** @class */ (function () {
    function UserProfileACLClient(userProfileACLRoute, apiClient) {
        this.userProfileACLRoute = userProfileACLRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserProfileACLClient.prototype, "routeDefinition", {
        get: function () {
            return this.userProfileACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns a list of ACL policies established for the specified user profile resource.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userProfileACLClient.get({id: '<profile-id>'})
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileACLClient.prototype.get = function (options) {
        return this.apiClient.get(this.routeDefinition.get(options));
    };
    /**
     * Returns a promise that is resolved once the update acl action has been performed, this action creates new ACL policy for the specified user profile resource.
     * @method
     * @param options ACL options object.
     * @returns A promise that is resolved once the update acl action has been performed.
     * @example let options = {id : '<profile-id>'};
                let aclObj =  {  actionId: '<action-id'>,  roleId: '<roleId>',  userId: '<userId>' };
                options[baasicConstants.modelPropertyName] = aclObj;
                userProfileACLClient.update(options)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileACLClient.prototype.update = function (options) {
        return this.apiClient.put(this.routeDefinition.update(options), this.routeDefinition.updateParams(options));
    };
    /**
     * Returns a promise that is resolved once the removeByUser action has been performed. This action deletes ACL policy assigned to the specified user and user profile resource.
     * @method
     * @param profileId User profile id which uniquely identifies user profile resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user profile resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param user A value that uniquely identifies user for which ACL policy needs to be removed.
     * @param data ACL policy object used to delete specified ACL policy resource.
     * @returns A promise that is resolved once the removeByUser action has been performed.
     * @example userProfileACLClient.removeByUser('<profile-id>', '<access-action>', '<username>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileACLClient.prototype.removeByUser = function (profileId, action, user, data) {
        return this.apiClient.delete(this.userProfileACLRoute.deleteByUser(profileId, action, user, data));
    };
    /**
     * Returns a promise that is resolved once the removeByRole action has been performed. This action deletes ACL policy assigned to the specified role and user profile resource.
     * @method
     * @param profileId User profile id which uniquely identifies user profile resource whose security privileges need to be retrieved and updated.
     * @param action Action abbreviation which identifies ACL policy assigned to the specified user and user profile resource.
     *               Supported Values:
     *               "Create"
     *               "Delete"
     *               "Read"
     *               "Update"
     * @param role A value that uniquely identifies role for which ACL policy needs to be removed.
     * @param data  ACL policy object used to delete specified ACL policy resource.
     * @returns A promise that is resolved once the removeByRole action has been performed.
     * @example userProfileACLClient.removeByRole('<profile-id>', '<access-action>', '<role-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileACLClient.prototype.removeByRole = function (profileId, action, role, data) {
        return this.apiClient.delete(this.userProfileACLRoute.deleteByRole(profileId, action, role, data));
    };
    var _a, _b;
    UserProfileACLClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileACLRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileACLRoute !== "undefined" && _1.UserProfileACLRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserProfileACLClient);
    return UserProfileACLClient;
}());
exports.UserProfileACLClient = UserProfileACLClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileRoute
 * @description Baasic User Profile Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Profile Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services  use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var _1 = __webpack_require__(12);
var contracts_1 = __webpack_require__(3);
var UserProfileRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserProfileRoute, _super);
    function UserProfileRoute(appOptions, userProfileACLRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.userProfileACLRoute = userProfileACLRoute;
        _this.findRoute = 'profiles/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{id}/{?embed,fields}';
        _this.createRoute = 'profiles';
        _this.updateRoute = 'profiles/{id}';
        _this.deleteRoute = 'profiles/{id}';
        return _this;
    }
    Object.defineProperty(UserProfileRoute.prototype, "acl", {
        get: function () {
            return this.userProfileACLRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses find user profile route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string value used to identify user profile resources using the phrase search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user profile subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user profile property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userProfileRoute.find.({searchQuery: '<search-phrase>'});
     **/
    UserProfileRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User profile id which uniquely identifies user profile resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userProfileRoute.get(id, options);
     **/
    UserProfileRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create user profile route; this URI template does not expose any additional options.
     * @method
     * @example baasicUserProfileRouteService.create();
     **/
    UserProfileRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses update user profile route; this URI template does not expose any additional options.
     * @method
     * @param data An user profile object used to update specified user profile resource.
     * @example baasicUserProfileRouteService.update(data);
     **/
    UserProfileRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses update user profile route; this URI template does not expose any additional options.
     * @method
     * @param data An user profile object used to delete specified user profile resource.
     * @example baasicUserProfileRouteService.delete(data);
     **/
    UserProfileRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    UserProfileRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserProfileACLRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.UserProfileACLRoute !== "undefined" && _1.UserProfileACLRoute) === "function" ? _b : Object])
    ], UserProfileRoute);
    return UserProfileRoute;
}(common_1.BaseRoute));
exports.UserProfileRoute = UserProfileRoute;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userProfileClient
 * @description  User Profile Client provides an easy way to consume  User Profile REST API end-points. In order to obtain needed routes `userProfileClient` uses `userProfileRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var UserProfileClient = /** @class */ (function () {
    function UserProfileClient(userProfileACLClient, userProfileRoute, apiClient, userEducationClient, userProfileAvatarClient, userSkillClient, userWorkClient) {
        this.userProfileACLClient = userProfileACLClient;
        this.userProfileRoute = userProfileRoute;
        this.apiClient = apiClient;
        this.userEducationClient = userEducationClient;
        this.userProfileAvatarClient = userProfileAvatarClient;
        this.userSkillClient = userSkillClient;
        this.userWorkClient = userWorkClient;
    }
    Object.defineProperty(UserProfileClient.prototype, "acl", {
        get: function () {
            return this.userProfileACLClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileClient.prototype, "routeDefinition", {
        get: function () {
            return this.userProfileRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileClient.prototype, "education", {
        get: function () {
            return this.userEducationClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileClient.prototype, "avatar", {
        get: function () {
            return this.userProfileAvatarClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileClient.prototype, "skill", {
        get: function () {
            return this.userSkillClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserProfileClient.prototype, "work", {
        get: function () {
            return this.userWorkClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user profile resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example userProfileClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserProfileClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the user profile resource.
     * @method
     * @param id User profile id which uniquely identifies user profile resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userProfileClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserProfileClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userProfileRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user profile action has been performed; this action creates a new user profile resource.
     * @method
     * @param data An user profile object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user profile action has been performed.
     * @example userProfileClient.create({
                    firstName : '<first-name>',
                    lastName : '<last-name>',
                    displayName: '<nick-name>'
                }.then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserProfileClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user profile action has been performed; this action updates a user profile resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userProfileRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(userProfile);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An user profile object used to update specified user profile resource.
     * @returns A promise that is resolved once the update user profile action has been performed.
     * @example // userProfile is a resource previously fetched using get action.
                       userProfile.displayName = '<nick-name>';
                       userProfileClient.update(userProfile)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    UserProfileClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a user profile resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userProfileRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(userProfile);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An user profile object used to delete specified user profile resource.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // userProfile is a resource previously fetched using get action.
                    userProfileClient.remove(userProfile)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserProfileClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b, _c, _d, _e, _f, _g;
    UserProfileClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileACLClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.UserProfileRoute)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.UserEducationClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.UserProfileAvatarClient)),
        tslib_1.__param(5, inversify_1.inject(_1.TYPES.UserSkillClient)),
        tslib_1.__param(6, inversify_1.inject(_1.TYPES.UserWorkClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileACLClient !== "undefined" && _1.UserProfileACLClient) === "function" ? _a : Object, typeof (_b = typeof _1.UserProfileRoute !== "undefined" && _1.UserProfileRoute) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object, typeof (_d = typeof _1.UserEducationClient !== "undefined" && _1.UserEducationClient) === "function" ? _d : Object, typeof (_e = typeof _1.UserProfileAvatarClient !== "undefined" && _1.UserProfileAvatarClient) === "function" ? _e : Object, typeof (_f = typeof _1.UserSkillClient !== "undefined" && _1.UserSkillClient) === "function" ? _f : Object, typeof (_g = typeof _1.UserWorkClient !== "undefined" && _1.UserWorkClient) === "function" ? _g : Object])
    ], UserProfileClient);
    return UserProfileClient;
}());
exports.UserProfileClient = UserProfileClient;
/**
 * @copyright (c) 2017 Mono Ltd
 * @license MIT
 * @author Mono Ltd
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userSkillRoute
 * @description Baasic User Skill Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Skill Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var UserSkillRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserSkillRoute, _super);
    function UserSkillRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'profiles/{userId}/skills/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{userId}/skills/{id}/{?embed,fields}';
        _this.createRoute = 'profiles/{userId}/skills';
        _this.updateRoute = 'profiles/{userId}/skills/{id}';
        _this.deleteRoute = 'profiles/{userId}/skills/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user skill properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user skill subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user skill property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userSkillRoute.find({searchQuery: '<search-phrase>'});
     **/
    UserSkillRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User profile id or display name which uniquely identifies user profile whose skill resources need to be retrieved.
     * @param options Query resource options object.
     * @example userSkillRoute.get(id, options);
     **/
    UserSkillRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @param data An user skill object that needs to be inserted into the system.
     * @example userSkillRoute.create(data);
     **/
    UserSkillRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
     * Parses update route; this URI template does not expose any additional options.
     * @method
     * @param data An user skill object used to update specific user skill resource in the system.
     * @example userSkillRoute.update(data);
     **/
    UserSkillRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete route; this URI template does not expose any additional options.
     * @method
     * @param data An user skill object used to delete specific user skill resource in the system.
     * @example userSkillRoute.delete(data);
     **/
    UserSkillRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    UserSkillRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserSkillRoute);
    return UserSkillRoute;
}(common_1.BaseRoute));
exports.UserSkillRoute = UserSkillRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userSkillClient
 * @description  User Skill Client provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Skill Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var UserSkillClient = /** @class */ (function () {
    function UserSkillClient(userSkillRoute, apiClient) {
        this.userSkillRoute = userSkillRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserSkillClient.prototype, "routeDefinition", {
        get: function () {
            return this.userSkillRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user skill resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example userSkillClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserSkillClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the user skill resource.
     * @method
     * @param id User profile id or display name which uniquely identifies user profile whose skill resources need to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example userSkillClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserSkillClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.userSkillRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user skill action has been performed; this action creates a new user skill resource.
     * @method
     * @param data An user skill object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user skill action has been performed.
     * @example userSkillClient.create({ skillName : '<skill-name>', userId: '<user-id>' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserSkillClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user skill action has been performed; this action updates a user skill resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userSkillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An user skill object used to update specified user skill resource.
     * @returns A promise that is resolved once the update user skill action has been performed.
     * @example // skill is a resource previously fetched using get action.
                       skill.description = '<description>';
                       userSkillClient.update(skill)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    UserSkillClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a user skill resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userSkillRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(skill);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An user skill object used to delete specific user skill resource in the system.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example // skill is a resource previously fetched using get action.
                    userSkillClient.remove(skill)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserSkillClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    UserSkillClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserSkillRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserSkillRoute !== "undefined" && _1.UserSkillRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserSkillClient);
    return UserSkillClient;
}());
exports.UserSkillClient = UserSkillClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userWorkRoute
 * @description Baasic User Work Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic User Work Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var UserWorkRoute = /** @class */ (function (_super) {
    tslib_1.__extends(UserWorkRoute, _super);
    function UserWorkRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.findRoute = 'profiles/{userId}/work/{?searchQuery,page,rpp,sort,embed,fields}';
        _this.getRoute = 'profiles/{userId}/work/{id}/{?embed,fields}';
        _this.createRoute = 'profiles/{userId}/work';
        _this.updateRoute = 'profiles/{userId}/work/{id}';
        _this.deleteRoute = 'profiles/{userId}/work/{id}';
        return _this;
    }
    /**
     * Parses find route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user work properties using the phrase or BQL (Baasic Query Language) search.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user work subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user work property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example userWorkRoute.find({searchQuery: '<search-phrase>'});
     **/
    UserWorkRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get route; this route doesn't expose any properties.
     * @method
     * @param id User work id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userWorkRoute.get(id, options);
     **/
    UserWorkRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses create route; this URI template does not expose any additional options.
     * @method
     * @param data An user work object that needs to be inserted into the system.
     * @example userWorkRoute.create(data);
     **/
    UserWorkRoute.prototype.create = function (data) {
        return _super.prototype.baseCreate.call(this, this.createRoute, data);
    };
    /**
      * Parses update route; this URI template does not expose any additional options.
      * @method
      * @param data An user work object used to update specified user work resource.
      * @example userWorkRoute.create(data);
      **/
    UserWorkRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    UserWorkRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a;
    UserWorkRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], UserWorkRoute);
    return UserWorkRoute;
}(common_1.BaseRoute));
exports.UserWorkRoute = UserWorkRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module userWorkClient
 * @description  User Work Client provides  route templates which can be expanded to  REST URIs. Various services can use  User Work Route Client to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(12);
var UserWorkClient = /** @class */ (function () {
    function UserWorkClient(userWorkRoute, apiClient) {
        this.userWorkRoute = userWorkRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(UserWorkClient.prototype, "routeDefinition", {
        get: function () {
            return this.userWorkRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user work resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example userWorkClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     **/
    UserWorkClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the user work resource.
     * @method
     * @param id User work id which uniquely identifies resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example userWorkClient.get()
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserWorkClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.routeDefinition.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the create user work action has been performed; this action creates a new user work resource.
     * @method
     * @param data An user work object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user work action has been performed.
     * @example userWorkClient.create({ companyName : '<company-name>', userId: '<user-id>' })
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     **/
    UserWorkClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(data), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the update user work action has been performed; this action updates a user work resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userWorkRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(work);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An user work object used to update specified user work resource.
     * @returns A promise that is resolved once the update user work action has been performed.
     * @example // work is a resource previously fetched using get action.
                    work.companyName = '<company-name>';
                    userWorkClient.update(work)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     **/
    UserWorkClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove a user work resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `userWorkRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(work);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @example // work is a resource previously fetched using get action.
                       userWorkClient.remove(work)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    **/
    UserWorkClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    var _a, _b;
    UserWorkClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserWorkRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserWorkRoute !== "undefined" && _1.UserWorkRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], UserWorkClient);
    return UserWorkClient;
}());
exports.UserWorkClient = UserWorkClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(12);
var inversify_1 = __webpack_require__(1);
var Root = /** @class */ (function () {
    function Root(profile, company, organization, skill) {
        this.profile = profile;
        this.company = company;
        this.organization = organization;
        this.skill = skill;
    }
    var _a, _b, _c, _d;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.UserProfileClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.CompanyClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.OrganizationClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.SkillClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.UserProfileClient !== "undefined" && _1.UserProfileClient) === "function" ? _a : Object, typeof (_b = typeof _1.CompanyClient !== "undefined" && _1.CompanyClient) === "function" ? _b : Object, typeof (_c = typeof _1.OrganizationClient !== "undefined" && _1.OrganizationClient) === "function" ? _c : Object, typeof (_d = typeof _1.SkillClient !== "undefined" && _1.SkillClient) === "function" ? _d : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(759), exports);
tslib_1.__exportStar(__webpack_require__(760), exports);
tslib_1.__exportStar(__webpack_require__(761), exports);
tslib_1.__exportStar(__webpack_require__(762), exports);
tslib_1.__exportStar(__webpack_require__(763), exports);
tslib_1.__exportStar(__webpack_require__(764), exports);
tslib_1.__exportStar(__webpack_require__(765), exports);
tslib_1.__exportStar(__webpack_require__(766), exports);
tslib_1.__exportStar(__webpack_require__(767), exports);
tslib_1.__exportStar(__webpack_require__(768), exports);
tslib_1.__exportStar(__webpack_require__(769), exports);
tslib_1.__exportStar(__webpack_require__(770), exports);


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(11);
var TYPES = {
    NotificationsClient: Symbol("NotificationsClient"),
    NotificationsPublishBatchClient: Symbol("NotificationsPublishBatchClient"),
    NotificationsPublishBatchRoute: Symbol("NotificationsPublishBatchRoute"),
    NotificationsPublishRoute: Symbol("NotificationsPublishRoute"),
    NotificationsPublishClient: Symbol("NotificationsPublishClient"),
    NotificationsRegistrationsAnonymousBatchClient: Symbol("NotificationsRegistrationsAnonymousBatchClient"),
    NotificationsRegistrationsAnonymousBatchRoute: Symbol("NotificationsRegistrationsAnonymousBatchRoute"),
    NotificationsRegistrationsAnonymousClient: Symbol("BasicNotificationsRegistrationsAnonymousClient"),
    NotificationsRegistrationsAnonymousRoute: Symbol("NotificationsRegistrationsAnonymousRoute"),
    NotificationsRegistrationsRoute: Symbol("NotificationsRegistrationsRoute"),
    NotificationsRegistrationsUsersBatchRoute: Symbol("NotificationsRegistrationsUsersBatchRoute"),
    NotificationsRegistrationsUsersBatchClient: Symbol("NotificationsRegistrationsUsersBatchClient"),
    NotificationsRegistrationsUsersClient: Symbol("NotificationsRegistrationsUsersClient"),
    NotificationsRegistrationsUsersRoute: Symbol("NotificationsRegistrationsUsersRoute"),
    NotificationsRoute: Symbol("NotificationsRoute"),
    NotificationsRegistrationsClient: Symbol("NotificationsRegistrationsClient"),
    NotificationsSubscriptionsClient: Symbol("NotificationsSubscriptionsClient"),
    NotificationsSubscriptionsRoute: Symbol("NotificationsSubscriptionsRoute"),
    NotificationsSubscriptionsAnonymousBatchClient: Symbol("NotificationsSubscriptionsAnonymousBatchClient"),
    NotificationsSubscriptionsAnonymousBatchRoute: Symbol("NotificationsSubscriptionsAnonymousBatchRoute"),
    NotificationsSubscriptionsAnonymousRoute: Symbol("NotificationsSubscriptionsAnonymousRoute"),
    NotificationsSubscriptionsAnonymousClient: Symbol("NotificationsSubscriptionsAnonymousClient"),
    NotificationsSubscriptionsUsersRoute: Symbol("BasicNotificationsSubscriptionsRoute"),
    NotificationsSubscriptionsUsersBatchClient: Symbol("NotificationsSubscriptionsUsersBatchClient"),
    NotificationsSubscriptionsUsersBatchRoute: Symbol("NotificationsSubscriptionsUsersBatchRoute"),
    NotificationsSubscriptionsUsersClient: Symbol("NotificationsSubscriptionsUsersClient"),
    NotificationsSettingsRoute: Symbol("NotificationsSettingsRoute"),
    NotificationsSettingsClient: Symbol("NotificationsSettingsClient")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.NotificationsPublishBatchRoute).to(_1.NotificationsPublishBatchRoute);
    bind(TYPES.NotificationsPublishBatchClient).to(_1.NotificationsPublishBatchClient);
    bind(TYPES.NotificationsPublishRoute).to(_1.NotificationsPublishRoute);
    bind(TYPES.NotificationsPublishClient).to(_1.NotificationsPublishClient);
    bind(TYPES.NotificationsSubscriptionsUsersBatchRoute).to(_1.NotificationsSubscriptionsUsersBatchRoute);
    bind(TYPES.NotificationsSubscriptionsUsersBatchClient).to(_1.NotificationsSubscriptionsUsersBatchClient);
    bind(TYPES.NotificationsSubscriptionsUsersRoute).to(_1.NotificationsSubscriptionsUsersRoute);
    bind(TYPES.NotificationsSubscriptionsUsersClient).to(_1.NotificationsSubscriptionsUsersClient);
    bind(TYPES.NotificationsSubscriptionsAnonymousRoute).to(_1.NotificationsSubscriptionsAnonymousRoute);
    bind(TYPES.NotificationsSubscriptionsAnonymousBatchRoute).to(_1.NotificationsSubscriptionsAnonymousBatchRoute);
    bind(TYPES.NotificationsSubscriptionsAnonymousBatchClient).to(_1.NotificationsSubscriptionsAnonymousBatchClient);
    bind(TYPES.NotificationsSubscriptionsAnonymousClient).to(_1.NotificationsSubscriptionsAnonymousClient);
    bind(TYPES.NotificationsSubscriptionsRoute).to(_1.NotificationsSubscriptionsRoute);
    bind(TYPES.NotificationsSubscriptionsClient).to(_1.NotificationsSubscriptionsClient);
    bind(TYPES.NotificationsRegistrationsUsersBatchRoute).to(_1.NotificationsRegistrationsUsersBatchRoute);
    bind(TYPES.NotificationsRegistrationsUsersBatchClient).to(_1.NotificationsRegistrationsUsersBatchClient);
    bind(TYPES.NotificationsRegistrationsUsersRoute).to(_1.NotificationsRegistrationsUsersRoute);
    bind(TYPES.NotificationsRegistrationsUsersClient).to(_1.NotificationsRegistrationsUsersClient);
    bind(TYPES.NotificationsRegistrationsAnonymousBatchRoute).to(_1.NotificationsRegistrationsAnonymousBatchRoute);
    bind(TYPES.NotificationsRegistrationsAnonymousBatchClient).to(_1.NotificationsRegistrationsAnonymousBatchClient);
    bind(TYPES.NotificationsRegistrationsAnonymousRoute).to(_1.NotificationsRegistrationsAnonymousRoute);
    bind(TYPES.NotificationsRegistrationsAnonymousClient).to(_1.NotificationsRegistrationsAnonymousClient);
    bind(TYPES.NotificationsRegistrationsRoute).to(_1.NotificationsRegistrationsRoute);
    bind(TYPES.NotificationsRegistrationsClient).to(_1.NotificationsRegistrationsClient);
    bind(TYPES.NotificationsSettingsRoute).to(_1.NotificationsSettingsRoute);
    bind(TYPES.NotificationsSettingsClient).to(_1.NotificationsSettingsClient);
    bind(TYPES.NotificationsRoute).to(_1.NotificationsRoute);
    bind(TYPES.NotificationsClient).to(_1.NotificationsClient);
});
exports.diModule = diModule;


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsPublishBatchRoute
 * @description Baasic Notifications Publish Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Publish Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var NotificationsPublishBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsPublishBatchRoute, _super);
    function NotificationsPublishBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/publish/batch';
        return _this;
    }
    /**
     * Parses create publish batch route; this route does not expose any additional options.
     * @method
     * @example notificationsPublishBatchRoute.create();
     */
    NotificationsPublishBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    var _a;
    NotificationsPublishBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsPublishBatchRoute);
    return NotificationsPublishBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsPublishBatchRoute = NotificationsPublishBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsPublishBatchClient
 * @description  Notifications Publish Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsPublishBatchClient` uses `notificationsPublishBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(11);
var NotificationsPublishBatchClient = /** @class */ (function () {
    function NotificationsPublishBatchClient(notificationsPublishBatchRoute, apiClient) {
        this.notificationsPublishBatchRoute = notificationsPublishBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsPublishBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsPublishBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create notification action has been performed; this action creates new notification resources.
     * @method
     * @param data The notification collection.
     * @returns A promise that is resolved once the create notification action has been performed.
     * @example notificationsPublishBatchClient.create([{
                    channels: ['<channel-name', '<channel-name>'],
                    moduleName: '<module-name>',
                    templateName: '<template-name>',
                    templateContext: {
                        prop1: '<prop1-value>',
                        prop2: '<prop2-value>'
                    }
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsPublishBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    var _a, _b;
    NotificationsPublishBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsPublishBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsPublishBatchRoute !== "undefined" && _1.NotificationsPublishBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsPublishBatchClient);
    return NotificationsPublishBatchClient;
}());
exports.NotificationsPublishBatchClient = NotificationsPublishBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsPublishRoute
 * @description Baasic Notifications Publish Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var NotificationsPublishRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsPublishRoute, _super);
    function NotificationsPublishRoute(appOptions, notificationsPublishBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsPublishBatchRoute = notificationsPublishBatchRoute;
        _this.createRoute = 'notifications/publish';
        return _this;
    }
    NotificationsPublishRoute.prototype.batch = function () {
        return this.notificationsPublishBatchRoute;
    };
    /**
     * Parses create publish route; this route does not expose any additional options.
     * @method
     * @example notificationsPublishRoute.create();
     */
    NotificationsPublishRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    var _a, _b;
    NotificationsPublishRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsPublishBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsPublishBatchRoute !== "undefined" && _1.NotificationsPublishBatchRoute) === "function" ? _b : Object])
    ], NotificationsPublishRoute);
    return NotificationsPublishRoute;
}(common_1.BaseRoute));
exports.NotificationsPublishRoute = NotificationsPublishRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsPublishClient
 * @description  Notifications Publish Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsPublishClient` uses `notificationsPublishRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(11);
var NotificationsPublishClient = /** @class */ (function () {
    function NotificationsPublishClient(notificationsPublishRoute, notificationsPublishBatchClient, apiClient) {
        this.notificationsPublishRoute = notificationsPublishRoute;
        this.notificationsPublishBatchClient = notificationsPublishBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsPublishClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsPublishRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsPublishClient.prototype, "batch", {
        get: function () {
            return this.notificationsPublishBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create notification action has been performed; this action creates a new notification resource.
     * @method
     * @param data The notification.
     * @returns A promise that is resolved once the create notification action has been performed.
     * @example notificationsPublishClient.create({
                    channels: ['<channel-name', '<channel-name>'],
                    moduleName: '<module-name>',
                    templateName: '<template-name>',
                    templateContext: {
                        prop1: '<prop1-value>',
                        prop2: '<prop2-value>'
                    }
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsPublishClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    var _a, _b, _c;
    NotificationsPublishClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsPublishRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsPublishBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsPublishRoute !== "undefined" && _1.NotificationsPublishRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsPublishBatchClient !== "undefined" && _1.NotificationsPublishBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsPublishClient);
    return NotificationsPublishClient;
}());
exports.NotificationsPublishClient = NotificationsPublishClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsAnonymousBatchRoute
 * @description Baasic Notifications Registrations Anonymous Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Anonymous Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var NotificationsRegistrationsAnonymousBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsAnonymousBatchRoute, _super);
    function NotificationsRegistrationsAnonymousBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/registrations/anonymous/batch';
        _this.deleteRoute = 'notifications/registrations/anonymous/batch';
        return _this;
    }
    /**
     * Parses create anonymous registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousBatchRoute.create();
     */
    NotificationsRegistrationsAnonymousBatchRoute.prototype.create = function () {
        return this.baseCreate(this.createRoute, {});
    };
    /**
     * Parses delete anonymous registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousBatchRoute.delete();
     */
    NotificationsRegistrationsAnonymousBatchRoute.prototype.delete = function () {
        return this.baseDelete(this.deleteRoute, {});
    };
    /**
     * Parses update anonymous registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousBatchRoute.update();
     */
    NotificationsRegistrationsAnonymousBatchRoute.prototype.update = function () {
        return this.baseUpdate('notifications/registrations/anonymous/batch', {});
    };
    var _a;
    NotificationsRegistrationsAnonymousBatchRoute = tslib_1.__decorate([
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsRegistrationsAnonymousBatchRoute);
    return NotificationsRegistrationsAnonymousBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsAnonymousBatchRoute = NotificationsRegistrationsAnonymousBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsAnonymousBatchClient
 * @description  Notifications Registrations Anonymous Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsAnonymousBatchClient` uses `notificationsRegistrationsAnonymousBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
;
var _1 = __webpack_require__(11);
var NotificationsRegistrationsAnonymousBatchClient = /** @class */ (function () {
    function NotificationsRegistrationsAnonymousBatchClient(notificationsRegistrationsAnonymousBatchRoute, apiClient) {
        this.notificationsRegistrationsAnonymousBatchRoute = notificationsRegistrationsAnonymousBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsAnonymousBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsAnonymousBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous registration action has been performed; this action creates new anonymous registration resources.
     * @method
     * @param data AnonymousRegistration objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous registration action has been performed.
     * @example notificationsRegistrationsAnonymousBatchClient.create([{
                    provider: '<provider-name>',
                    providerData: <provider-data>,
                    expirationDate: <expiration-date>
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsAnonymousBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove anonymous registration resources from the system if successfully completed.
     * @method
     * @param ids The registration ids which uniquely identify AnonymousRegistration resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example notificationsRegistrationsAnonymousBatchClient.remove(subscriptionIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsRegistrationsAnonymousBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.notificationsRegistrationsAnonymousBatchRoute.delete(), undefined, ids);
    };
    /**
     * Returns a promise that is resolved once the update anonymous registration action has been performed; this action updates specified anonymous registration  resources.
     * @method
     * @param data AnonymousRegistration objects used to update specified AnonymousRegistration resources.
     * @returns A promise that is resolved once the update anonymous registration action has been performed.
     * @example notificationsRegistrationsAnonymousBatchClient.update(registrations)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsAnonymousBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsRegistrationsAnonymousBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsAnonymousBatchRoute !== "undefined" && _1.NotificationsRegistrationsAnonymousBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsRegistrationsAnonymousBatchClient);
    return NotificationsRegistrationsAnonymousBatchClient;
}());
exports.NotificationsRegistrationsAnonymousBatchClient = NotificationsRegistrationsAnonymousBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsAnonymousRoute
 * @description Baasic Notifications Registrations Anonymous Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Anonymous Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var NotificationsRegistrationsAnonymousRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsAnonymousRoute, _super);
    function NotificationsRegistrationsAnonymousRoute(appOptions, notificationsRegistrationsAnonymousBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsRegistrationsAnonymousBatchRoute = notificationsRegistrationsAnonymousBatchRoute;
        _this.createRoute = 'notifications/registrations/anonymous';
        _this.findRoute = 'notifications/registrations/anonymous/{?searchQuery,providers,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/registrations/anonymous/{id}/{?embed}';
        _this.updateRoute = 'notifications/registrations/anonymous/{id}';
        _this.deleteRoute = 'notifications/registrations/anonymous/{id}';
        return _this;
    }
    Object.defineProperty(NotificationsRegistrationsAnonymousRoute.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsAnonymousBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses create anonymous registrations route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsAnonymousRoute.create();
     */
    NotificationsRegistrationsAnonymousRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find anonymous registrations route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `providers` - Comma separated list of notification providers.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscription subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example notificationsRegistrationsAnonymousRoute.find({
                   searchQuery: '<search-phrase>',
                   providers: '<provider-name>,<provider-name>'
               });
    */
    NotificationsRegistrationsAnonymousRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get anonymous registrations route; this route should be expanded with the Id of anonymous registrations resource.
     * @method
     * @param id The registration identifier which uniquely identifies AnonymousRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsRegistrationsAnonymousRoute.get({ id: '<registration-id>' });
     */
    NotificationsRegistrationsAnonymousRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses update anonymous registrations route; this route should be expanded with the Id of anonymous registrations resource.
     * @method
     * @param data An object used to update specified AnonymousRegistration resource.
     * @example notificationsRegistrationsAnonymousRoute.update(data);
     */
    NotificationsRegistrationsAnonymousRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    /**
     * Parses delete anonymous registrations route; this route should be expanded with the Id of anonymous registrations resource.
     * @method
     * @param data An object used to delete specified AnonymousRegistration resource.
     * @example notificationsRegistrationsAnonymousRoute.delete(data);
     */
    NotificationsRegistrationsAnonymousRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    var _a, _b;
    NotificationsRegistrationsAnonymousRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsAnonymousBatchRoute !== "undefined" && _1.NotificationsRegistrationsAnonymousBatchRoute) === "function" ? _b : Object])
    ], NotificationsRegistrationsAnonymousRoute);
    return NotificationsRegistrationsAnonymousRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsAnonymousRoute = NotificationsRegistrationsAnonymousRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsAnonymousClient
 * @description  Notifications Registrations Anonymous Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsAnonymousClient` uses `notificationsRegistrationsAnonymousRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
;
var _1 = __webpack_require__(11);
var NotificationsRegistrationsAnonymousClient = /** @class */ (function () {
    function NotificationsRegistrationsAnonymousClient(notificationsRegistrationsAnonymousRoute, notificationsRegistrationsAnonymousBatchClient, apiClient) {
        this.notificationsRegistrationsAnonymousRoute = notificationsRegistrationsAnonymousRoute;
        this.notificationsRegistrationsAnonymousBatchClient = notificationsRegistrationsAnonymousBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsAnonymousClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsAnonymousClient.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsAnonymousBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous registration action has been performed; this action creates a new anonymous registration resource.
     * @method
     * @param data An AnonymousRegistration object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous registration action has been performed.
     * @example notificationsRegistrationsAnonymousClient.create({
                    provider: '<provider-name>',
                    providerdata: <provider-data>,
                    expirationData: '<expiration-date>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsAnonymousClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of anonymous registration resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsRegistrationsAnonymousClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>',
                   providers: '<provider-name1>,<provider-name2>',
                   embed: '<embed>'
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    */
    NotificationsRegistrationsAnonymousClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified anonymous registration resource.
     * @method
     * @param id The registration identifier which uniquely identifies AnonymousRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsRegistrationsAnonymousClient.get('<registration-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsAnonymousClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsRegistrationsAnonymousRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove anonymous registration action has been performed. This action will remove a anonymous registration resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(registration);
     * var uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An object used to delete specified AnonymousRegistration resource.
     * @returns A promise that is resolved once the remove anonymous registration action has been performed.
     * @example // registration is a resource previously fetched using get action.
                    notificationsRegistrationsAnonymousClient.remove(registration)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsRegistrationsAnonymousClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update anonymous registration action has been performed; this action updates a anonymous registration resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(registration);
     * var uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified AnonymousRegistration resource.
     * @returns A promise that is resolved once the update anonymous registration action has been performed
     * @example // registration is a resource previously fetched using get action.
                        subscription.provider = '<provider-name>';
                        notificationsRegistrationsAnonymousClient.update(registration)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     */
    NotificationsRegistrationsAnonymousClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsRegistrationsAnonymousClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsAnonymousRoute !== "undefined" && _1.NotificationsRegistrationsAnonymousRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsAnonymousBatchClient !== "undefined" && _1.NotificationsRegistrationsAnonymousBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsRegistrationsAnonymousClient);
    return NotificationsRegistrationsAnonymousClient;
}());
exports.NotificationsRegistrationsAnonymousClient = NotificationsRegistrationsAnonymousClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsUsersBatchRoute
 * @description Baasic Notifications Registrations Users Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Users Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var NotificationsRegistrationsUsersBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsUsersBatchRoute, _super);
    function NotificationsRegistrationsUsersBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/registrations/user/batch';
        _this.deleteRoute = 'notifications/registrations/user/batch';
        _this.updateRoute = 'notifications/registrations/user/batch';
        return _this;
    }
    /**
     * Parses create users registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersBatchRoute.create();
     */
    NotificationsRegistrationsUsersBatchRoute.prototype.create = function () {
        return this.baseCreate(this.createRoute, {});
    };
    /**
     * Parses remove users registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersBatchRoute.delete();
     */
    NotificationsRegistrationsUsersBatchRoute.prototype.delete = function () {
        return this.baseDelete(this.deleteRoute, {});
    };
    /**
     * Parses update users registrations batch route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersBatchRoute.update();
     */
    NotificationsRegistrationsUsersBatchRoute.prototype.update = function () {
        return this.baseUpdate(this.updateRoute, {});
    };
    var _a;
    NotificationsRegistrationsUsersBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsRegistrationsUsersBatchRoute);
    return NotificationsRegistrationsUsersBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsUsersBatchRoute = NotificationsRegistrationsUsersBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsUsersBatchClient
 * @description  Notifications Registrations Users Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsUsersBatchClient` uses `notificationsRegistrationsUsersBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
;
var _1 = __webpack_require__(11);
var NotificationsRegistrationsUsersBatchClient = /** @class */ (function () {
    function NotificationsRegistrationsUsersBatchClient(notificationsRegistrationsUsersBatchRoute, apiClient) {
        this.notificationsRegistrationsUsersBatchRoute = notificationsRegistrationsUsersBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsUsersBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsUsersBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user registration action has been performed; this action creates new user registration resources.
     * @method
     * @param data UserRegistration collection that need to be inserted into the system.
     * @returns A promise that is resolved once the create user registration action has been performed.
     * @example notificationsRegistrationsUsersBatchClient.create([{
                    provider: '<provider-name>',
                    providerData: <provider-data>,
                    userId: '<user-id>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsUsersBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove user registration resources from the system if successfully completed.
     * @method
     * @param ids The subscription ids which uniquely identify UserRegistration resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example notificationsRegistrationsUsersBatchClient.remove(subscriptionIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsUsersBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.notificationsRegistrationsUsersBatchRoute.delete(), undefined, ids);
    };
    /**
     * Returns a promise that is resolved once the update user registration action has been performed; this action updates specified user registration resources.
     * @method
     * @param data UserRegistration objects used to update specified UserRegistration resources.
     * @returns A promise that is resolved once the update user registration action has been performed.
     * @example notificationsRegistrationsUsersBatchClient.update(registrations)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsRegistrationsUsersBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsRegistrationsUsersBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsUsersBatchRoute !== "undefined" && _1.NotificationsRegistrationsUsersBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsRegistrationsUsersBatchClient);
    return NotificationsRegistrationsUsersBatchClient;
}());
exports.NotificationsRegistrationsUsersBatchClient = NotificationsRegistrationsUsersBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsUsersRoute
 * @description Baasic Notifications Registrations Users Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Users Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var NotificationsRegistrationsUsersRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsUsersRoute, _super);
    function NotificationsRegistrationsUsersRoute(appOptions, notificationsRegistrationsUsersBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsRegistrationsUsersBatchRoute = notificationsRegistrationsUsersBatchRoute;
        _this.createRoute = 'notifications/registrations/user';
        _this.findRoute = 'notifications/registrations/user/{?searchQuery,userIds,providers,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/registrations/user/{id}/{?embed}';
        _this.deleteRoute = 'notifications/registrations/user/{id}';
        _this.updateRoute = 'notifications/registrations/user/{id}';
        return _this;
    }
    Object.defineProperty(NotificationsRegistrationsUsersRoute.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsUsersBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses create users registrations route; this route does not expose any additional options
     * @method
     * @example notificationsRegistrationsUsersRoute.create();
     */
    NotificationsRegistrationsUsersRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find users registrations route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `userIds` - Comma separated list of user identifiers.
     * - `providers` - Comma separated list of notification providers.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscription subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example notificationsRegistrationsUsersRoute.find({ searchQuery: '<search-phrase>', providers: '<provider-name>,<provider-name>' });
     */
    NotificationsRegistrationsUsersRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get users registrations route; this route should be expanded with the Id of users registrations resource.
     * @method
     * @param id The registration identifier which uniquely identifies UserRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsRegistrationsUsersRoute.get({ id: '<registration-id>' });
     */
    NotificationsRegistrationsUsersRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses delete users registrations route; this route should be expanded with the Id of users registrations resource.
     * @method
     * @param data An object used to delete specified UserRegistration resource.
     * @example notificationsRegistrationsUsersRoute.delete(data);
     */
    NotificationsRegistrationsUsersRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses update users registrations route; this route should be expanded with the Id of users registrations resource.
     * @method
     * @param data An object used to update specified UserRegistration resource.
     * @example notificationsRegistrationsUsersRoute.update(data);
     */
    NotificationsRegistrationsUsersRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b;
    NotificationsRegistrationsUsersRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsUsersBatchRoute !== "undefined" && _1.NotificationsRegistrationsUsersBatchRoute) === "function" ? _b : Object])
    ], NotificationsRegistrationsUsersRoute);
    return NotificationsRegistrationsUsersRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsUsersRoute = NotificationsRegistrationsUsersRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsUsersClient
 * @description  Notifications Registrations Users Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsUsersClient` uses `notificationsRegistrationsUsersRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
;
var _1 = __webpack_require__(11);
var NotificationsRegistrationsUsersClient = /** @class */ (function () {
    function NotificationsRegistrationsUsersClient(notificationsRegistrationsUsersRoute, notificationsRegistrationsUsersBatchClient, apiClient) {
        this.notificationsRegistrationsUsersRoute = notificationsRegistrationsUsersRoute;
        this.notificationsRegistrationsUsersBatchClient = notificationsRegistrationsUsersBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsRegistrationsUsersClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsUsersClient.prototype, "batch", {
        get: function () {
            return this.notificationsRegistrationsUsersBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user registration action has been performed; this action creates a new user registration resource.
     * @method
     * @param data An UserRegistration object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user registration action has been performed.
     * @example notificationsRegistrationsUsersClient.create({
                    provider: '<provider-name>',
                    providerData: <provider-data>,
                    userId: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsRegistrationsUsersClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user registrations resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsRegistrationsUsersClient.find({
                   pageNumber : 1,
                   pageSize : 10,
                   orderBy : '<field>',
                   orderDirection : '<asc|desc>',
                   search : '<search-phrase>',
                   providers: '<provider-name1>,<provider-name2>',
                   userIds: '<user-id1>,<user-id2>',
                   embed: '<embed>'
               })
               .then(function (collection) {
                   // perform success action here
               },
                function (response, status, headers, config) {
                    // perform error handling here
               });
    */
    NotificationsRegistrationsUsersClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified user registrations resource.
     * @method
     * @param id The registration identifier which uniquely identifies UserRegistration resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsRegistrationsUsersClient.get('<registration-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsRegistrationsUsersClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsRegistrationsUsersRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove user registrations action has been performed. This action will remove a user registrations resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(registration);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An object used to delete specified UserRegistration resource.
     * @example // registration is a resource previously fetched using get action.
                    notificationsRegistrationsUsersClient.remove(registration)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsRegistrationsUsersClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update user registration action has been performed; this action updates a user registration resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsRegistrationsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(subsregistrationcription);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified UserRegistration resource.
     * @returns A promise that is resolved once the update user registration action has been performed.
     * @example // registration is a resource previously fetched using get action.
                    registration.provider = '<provider-name>';
                    notificationsRegistrationsUsersClient.update(registration)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsRegistrationsUsersClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsRegistrationsUsersClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsUsersRoute !== "undefined" && _1.NotificationsRegistrationsUsersRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsUsersBatchClient !== "undefined" && _1.NotificationsRegistrationsUsersBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsRegistrationsUsersClient);
    return NotificationsRegistrationsUsersClient;
}());
exports.NotificationsRegistrationsUsersClient = NotificationsRegistrationsUsersClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsRoute
 * @description Baasic Notifications Registrations Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Registrations Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var NotificationsRegistrationsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRegistrationsRoute, _super);
    function NotificationsRegistrationsRoute(appOptions, notificationsRegistrationsUsersRoute, notificationsRegistrationsAnonymousRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsRegistrationsUsersRoute = notificationsRegistrationsUsersRoute;
        _this.notificationsRegistrationsAnonymousRoute = notificationsRegistrationsAnonymousRoute;
        return _this;
    }
    Object.defineProperty(NotificationsRegistrationsRoute.prototype, "users", {
        get: function () {
            return this.notificationsRegistrationsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsRoute.prototype, "anonymous", {
        get: function () {
            return this.notificationsRegistrationsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsRegistrationsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsUsersRoute !== "undefined" && _1.NotificationsRegistrationsUsersRoute) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsRegistrationsAnonymousRoute !== "undefined" && _1.NotificationsRegistrationsAnonymousRoute) === "function" ? _c : Object])
    ], NotificationsRegistrationsRoute);
    return NotificationsRegistrationsRoute;
}(common_1.BaseRoute));
exports.NotificationsRegistrationsRoute = NotificationsRegistrationsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRegistrationsClient
 * @description  Notifications Registrations Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsRegistrationsClient` uses `notificationsRegistrationsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var _1 = __webpack_require__(11);
var NotificationsRegistrationsClient = /** @class */ (function () {
    function NotificationsRegistrationsClient(notificationsRegistrationsRoute, notificationsRegistrationsAnonymousClient, notificationsRegistrationsUsersClient) {
        this.notificationsRegistrationsRoute = notificationsRegistrationsRoute;
        this.notificationsRegistrationsAnonymousClient = notificationsRegistrationsAnonymousClient;
        this.notificationsRegistrationsUsersClient = notificationsRegistrationsUsersClient;
    }
    Object.defineProperty(NotificationsRegistrationsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRegistrationsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsClient.prototype, "anonymous", {
        get: function () {
            return this.notificationsRegistrationsAnonymousClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRegistrationsClient.prototype, "users", {
        get: function () {
            return this.notificationsRegistrationsUsersClient;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsRegistrationsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsRegistrationsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsRegistrationsAnonymousClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsRegistrationsUsersClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsRegistrationsRoute !== "undefined" && _1.NotificationsRegistrationsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsRegistrationsAnonymousClient !== "undefined" && _1.NotificationsRegistrationsAnonymousClient) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsRegistrationsUsersClient !== "undefined" && _1.NotificationsRegistrationsUsersClient) === "function" ? _c : Object])
    ], NotificationsRegistrationsClient);
    return NotificationsRegistrationsClient;
}());
exports.NotificationsRegistrationsClient = NotificationsRegistrationsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsUsersBatchRoute
 * @description Baasic Notifications Subscriptions Users Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Subscriptions Users Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var NotificationsSubscriptionsUsersBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsUsersBatchRoute, _super);
    function NotificationsSubscriptionsUsersBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/subscriptions/user/batch';
        _this.deleteRoute = 'notifications/subscriptions/user/batch';
        _this.updateRoute = 'notifications/subscriptions/user/batch';
        return _this;
    }
    /**
     * Parses create user subscriptions batch route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsUsersBatchRoute.create();
     */
    NotificationsSubscriptionsUsersBatchRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses remove user subscriptions batch route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsUsersBatchRoute.delete(ids);
     */
    NotificationsSubscriptionsUsersBatchRoute.prototype.delete = function () {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, {});
    };
    /**
     * Parses update user subscriptions batch route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsUsersBatchRoute.update();
     */
    NotificationsSubscriptionsUsersBatchRoute.prototype.update = function () {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, {});
    };
    var _a;
    NotificationsSubscriptionsUsersBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsSubscriptionsUsersBatchRoute);
    return NotificationsSubscriptionsUsersBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsUsersBatchRoute = NotificationsSubscriptionsUsersBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsUsersBatchClient
 * @description  Notifications Subscriptions Users Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsUsersBatchUsersClient` uses `notificationsSubscriptionsUsersBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(11);
var NotificationsSubscriptionsUsersBatchClient = /** @class */ (function () {
    function NotificationsSubscriptionsUsersBatchClient(notificationsSubscriptionsUsersBatchRoute, apiClient) {
        this.notificationsSubscriptionsUsersBatchRoute = notificationsSubscriptionsUsersBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsUsersBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsUsersBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user subscription action has been performed; this action creates new user subscription resources.
     * @method
     * @param data UserSubscription collection that need to be inserted into the system.
     * @returns A promise that is resolved once the create user subscription action has been performed.
     * @example notificationsSubscriptionsUsersBatchClient.create([{
                    channel: '<channel-name>',
                    userId: '<user-id>'
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsUsersBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove user subscription resources from the system if successfully completed.
     * @method
     * @param ids The subscription ids which uniquely identify UserSubscription resources that need to be deleted.
     * @returns A promise that is resolved once the remove action has been performed.
     * @example notificationsSubscriptionsUsersBatchClient.remove(subscriptionIds)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSubscriptionsUsersBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.notificationsSubscriptionsUsersBatchRoute.delete(), undefined, ids);
    };
    /**
     * Returns a promise that is resolved once the update user subscriptions action has been performed; this action updates specified user subscription resources.
     * @method
     * @param data UserSubscription objects used to update specified UserSubscription resources.
     * @returns A promise that is resolved once the update user subscriptions action has been performed.
     * @example notificationsSubscriptionsUsersBatchClient.update(subscriptions)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSubscriptionsUsersBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsSubscriptionsUsersBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsUsersBatchRoute !== "undefined" && _1.NotificationsSubscriptionsUsersBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsSubscriptionsUsersBatchClient);
    return NotificationsSubscriptionsUsersBatchClient;
}());
exports.NotificationsSubscriptionsUsersBatchClient = NotificationsSubscriptionsUsersBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 788 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousBatchRoute
 * @description Baasic Notifications Subscriptions Anonymous Batch Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Subscriptions Anonymous Batch Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var NotificationsSubscriptionsAnonymousBatchRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsAnonymousBatchRoute, _super);
    function NotificationsSubscriptionsAnonymousBatchRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/subscriptions/anonymous/batch';
        _this.deleteRoute = 'notifications/subscriptions/anonymous/batch';
        _this.updateRoute = 'notifications/subscriptions/anonymous/batch';
        return _this;
    }
    /**
     * Parses create anonymous subscription batch route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsAnonymousBatchRoute.create();
     */
    NotificationsSubscriptionsAnonymousBatchRoute.prototype.create = function () {
        return this.baseCreate(this.createRoute, {});
    };
    /**
     * Parses remove anonymous subscription batch route; this route does not expose any additional options
     * @method
     * @example baasicNotificationsSubscriptionsAnonymousBatchRouteDefinitio.delete();
     */
    NotificationsSubscriptionsAnonymousBatchRoute.prototype.delete = function () {
        return this.baseDelete(this.deleteRoute, {});
    };
    /**
     * Parses update anonymous subscription batch route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsAnonymousBatchRoute.update();
     */
    NotificationsSubscriptionsAnonymousBatchRoute.prototype.update = function () {
        return this.baseUpdate(this.updateRoute, {});
    };
    var _a;
    NotificationsSubscriptionsAnonymousBatchRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsSubscriptionsAnonymousBatchRoute);
    return NotificationsSubscriptionsAnonymousBatchRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsAnonymousBatchRoute = NotificationsSubscriptionsAnonymousBatchRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 789 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousBatchClient
 * @description  Notifications Subscriptions Anonymous Batch Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsAnonymousBatchClient` uses `notificationsSubscriptionsAnonymousBatchRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(11);
var NotificationsSubscriptionsAnonymousBatchClient = /** @class */ (function () {
    function NotificationsSubscriptionsAnonymousBatchClient(notificationsSubscriptionsAnonymousBatchRoute, apiClient) {
        this.notificationsSubscriptionsAnonymousBatchRoute = notificationsSubscriptionsAnonymousBatchRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsAnonymousBatchClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous subscription action has been performed; this action creates new anonymous subscription resources.
     * @method
     * @param data AnonymousSubscription objects that need to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous subscription action has been performed.
     * @example notificationsSubscriptionsAnonymousBatchClient.create([{
                    channel: '<channel-name>',
                    registrationId: '<registration-id>' ž
                }])
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsAnonymousBatchClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the remove action has been performed. This action will remove anonymous subscription resources from the system if successfully completed.
     * @method
     * @param ids The subscription ids which uniquely identify AnonymousSubscription resources that need to be deleted.
     * @returns a promise that is resolved once the remove action has been performed.
     * @example notificationsSubscriptionsAnonymousBatchClient.remove(subscriptionIds)
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsSubscriptionsAnonymousBatchClient.prototype.remove = function (ids) {
        return this.apiClient.delete(this.notificationsSubscriptionsAnonymousBatchRoute.delete(), undefined, ids);
    };
    /**
     * Returns a promise that is resolved once the update anonymous subscriptions action has been performed; this action updates specified anonymous subscription resources.
     * @method
     * @param data AnonymousSubscription objects used to update specified AnonymousSubscription resources.
     * @returns A promise that is resolved once the update anonymous subscriptions action has been performed.
     * @example notificationsSubscriptionsAnonymousBatchClient.update(subscriptions)
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSubscriptionsAnonymousBatchClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsSubscriptionsAnonymousBatchClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousBatchRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousBatchRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsSubscriptionsAnonymousBatchClient);
    return NotificationsSubscriptionsAnonymousBatchClient;
}());
exports.NotificationsSubscriptionsAnonymousBatchClient = NotificationsSubscriptionsAnonymousBatchClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 790 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousRoute
 * @description Baasic Notifications Subscriptions Anonymous Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Subscriptions Anonymous Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var NotificationsSubscriptionsAnonymousRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsAnonymousRoute, _super);
    function NotificationsSubscriptionsAnonymousRoute(notificationsSubscriptionsAnonymousBatchRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.notificationsSubscriptionsAnonymousBatchRoute = notificationsSubscriptionsAnonymousBatchRoute;
        _this.appOptions = appOptions;
        _this.createRoute = 'notifications/subscriptions/anonymous';
        _this.findRoute = 'notifications/subscriptions/anonymous/{?searchQuery,registrationIds,channels,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/subscriptions/anonymous/{id}/{?embed,fields}';
        _this.deleteRoute = 'notifications/subscriptions/anonymous/{id}';
        _this.updateRoute = 'notifications/subscriptions/anonymous/{id}';
        return _this;
    }
    Object.defineProperty(NotificationsSubscriptionsAnonymousRoute.prototype, "batch", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousBatchRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Parses create anonymous subscription route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsAnonymousRoute.create();
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find anonymous subscriptions route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `registrationIds` - Comma separated list of anonymous registration identifiers.
     * - `channels` - Comma separated list of channels.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscription subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @param options Query resource options object.
     * @example notificationsSubscriptionsAnonymousRoute.find({
                   searchQuery: '<search-phrase>',
                   channels: '<channel-name>,<channel-name>'
               });
    */
    NotificationsSubscriptionsAnonymousRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get anonymous subscription route; this route should be expanded with the Id of anonymous subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies AnonymousSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsSubscriptionsAnonymousRoute.get({id: '<subscription-id>'});
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses delete anonymous subscription route; this route should be expanded with the Id of anonymous subscription resource.
     * @method
     * @param data The subscription identifier used to delete specific subscription resource in the system.
     * @example notificationsSubscriptionsAnonymousRoute.delete(data);
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses update anonymous subscription route; this route should be expanded with the Id of anonymous subscription resource.
     * @method
     * @param data The subscription identifier used to update specific subscription resource in the system.
     * @example notificationsSubscriptionsAnonymousRoute.update(data);
     */
    NotificationsSubscriptionsAnonymousRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b;
    NotificationsSubscriptionsAnonymousRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousBatchRoute)),
        tslib_1.__param(1, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousBatchRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousBatchRoute) === "function" ? _a : Object, typeof (_b = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _b : Object])
    ], NotificationsSubscriptionsAnonymousRoute);
    return NotificationsSubscriptionsAnonymousRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsAnonymousRoute = NotificationsSubscriptionsAnonymousRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 791 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsAnonymousClient
 * @description  Notifications Subscriptions Anonymous Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsAnonymousClient` uses `notificationsSubscriptionsAnonymousRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(11);
var NotificationsSubscriptionsAnonymousClient = /** @class */ (function () {
    function NotificationsSubscriptionsAnonymousClient(notificationsSubscriptionsAnonymousRoute, notificationsSubscriptionsAnonymousBatchClient, apiClient) {
        this.notificationsSubscriptionsAnonymousRoute = notificationsSubscriptionsAnonymousRoute;
        this.notificationsSubscriptionsAnonymousBatchClient = notificationsSubscriptionsAnonymousBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsAnonymousClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsAnonymousClient.prototype, "batch", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create anonymous subscription action has been performed; this action creates a new anonymous subscription resource.
     * @method
     * @param data An AnonymousSubscription object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create anonymous subscription action has been performed.
     * @example notificationsSubscriptionsAnonymousClient.create({
                    channel: '<channel-name>',
                    registrationId: '<registration-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of anonymous subscription resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsSubscriptionsAnonymousClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>',
                    channels: '<channel-name1>,<channel-name2>',
                    registrationIds: '<registration-id1>,<registration-id2>',
                    embed: '<embed>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.find = function (options) {
        return this.apiClient.get(this.notificationsSubscriptionsAnonymousRoute.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified anonymous subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies AnonymousSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsSubscriptionsAnonymousClient.get('<subscription-id>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsSubscriptionsAnonymousRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove anonymous subscription action has been performed. This action will remove a anonymous subscription resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(subscription);
     * var uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data The subscription identifier used to delete specific subscription resource in the system.
     * @returns A promise that is resolved once the remove anonymous subscription action has been performed.
     * @example // subscription is a resource previously fetched using get action.
                        notificationsSubscriptionsAnonymousClient.remove(subscription)
                            .then(function (data) {
                                // perform success action here
                            },
                             function (response, status, headers, config) {
                                 // perform error handling here
                            });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update anonymous subscription action has been performed; this action updates a anonymous subscription resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsAnonymousRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(subscription);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified AnonymousSubscription resource.
     * @returns A promise that is resolved once the update anonymous subscription action has been performed.
     * @example // subscription is a resource previously fetched using get action.
                    subscription.channel = '<channel-name>';
                    notificationsSubscriptionsAnonymousClient.update(subscription)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsSubscriptionsAnonymousClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsSubscriptionsAnonymousClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsAnonymousBatchClient !== "undefined" && _1.NotificationsSubscriptionsAnonymousBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsSubscriptionsAnonymousClient);
    return NotificationsSubscriptionsAnonymousClient;
}());
exports.NotificationsSubscriptionsAnonymousClient = NotificationsSubscriptionsAnonymousClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 792 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsUsersRoute
 * @description Baasic Notifications Subscriptions Users Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
;
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var NotificationsSubscriptionsUsersRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsUsersRoute, _super);
    function NotificationsSubscriptionsUsersRoute(appOptions, notificationsSubscriptionsUsersBatchRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsSubscriptionsUsersBatchRoute = notificationsSubscriptionsUsersBatchRoute;
        _this.createRoute = 'notifications/subscriptions/user';
        _this.findRoute = 'notifications/subscriptions/user/{?searchQuery,userIds,channels,page,rpp,sort,embed,fields}';
        _this.getRoute = 'notifications/subscriptions/user/{id}/{?embed,fields}';
        _this.deleteRoute = 'notifications/subscriptions/user/{id}';
        _this.updateRoute = 'notifications/subscriptions/user/{id}';
        return _this;
    }
    NotificationsSubscriptionsUsersRoute.prototype.batch = function () {
        return this.notificationsSubscriptionsUsersBatchRoute;
    };
    /**
     * Parses create user subscription route; this route does not expose any additional options
     * @method
     * @example notificationsSubscriptionsUsersRoute.create();
     */
    NotificationsSubscriptionsUsersRoute.prototype.create = function () {
        return _super.prototype.baseCreate.call(this, this.createRoute, {});
    };
    /**
     * Parses find user subscriptions route which can be expanded with additional options. Supported items are:
     * - `searchQuery` - A string referencing user subscription properties using the phrase search.
     * - `userIds` - Comma separated list of user identifiers.
     * - `channels` - Comma separated list of channels.
     * - `page` - A value used to set the page number, i.e. to retrieve certain user subscriptions subset from the storage.
     * - `rpp` - A value used to limit the size of result set per page.
     * - `sort` - A string used to set the user subscription property to sort the result collection by.
     * - `embed` - Comma separated list of resources to be contained within the current representation.
     * @method
     * @example notificationsSubscriptionsUsersRoute.find({ searchQuery: '<search-phrase>', channels: '<channel-name>,<channel-name>' });
     */
    NotificationsSubscriptionsUsersRoute.prototype.find = function (options) {
        return _super.prototype.baseFind.call(this, this.findRoute, options);
    };
    /**
     * Parses get user subscription route; this route should be expanded with the Id of user subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies UserSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @example notificationsSubscriptionsUsersRoute.get({ id: '<subscription-id>' });
     */
    NotificationsSubscriptionsUsersRoute.prototype.get = function (id, options) {
        return _super.prototype.baseGet.call(this, this.getRoute, id, options);
    };
    /**
     * Parses delete user subscription route; this route should be expanded with the Id of user subscription resource.
     * @method
     * @param data An object used to delete specified UserSubscription resource.
     * @example notificationsSubscriptionsUsersRoute.delete(data);
     */
    NotificationsSubscriptionsUsersRoute.prototype.delete = function (data) {
        return _super.prototype.baseDelete.call(this, this.deleteRoute, data);
    };
    /**
     * Parses update user subscription route; this route should be expanded with the Id of user subscription resource.
     * @method
     * @param data An object used to update specified UserSubscription resource.
     * @example notificationsSubscriptionsUsersRoute.update(data);
     */
    NotificationsSubscriptionsUsersRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a, _b;
    NotificationsSubscriptionsUsersRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersBatchRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsUsersBatchRoute !== "undefined" && _1.NotificationsSubscriptionsUsersBatchRoute) === "function" ? _b : Object])
    ], NotificationsSubscriptionsUsersRoute);
    return NotificationsSubscriptionsUsersRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsUsersRoute = NotificationsSubscriptionsUsersRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 793 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsUsersClient
 * @description  Notifications Subscriptions Users Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsUsersClient` uses `notificationsSubscriptionsUsersRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
;
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(11);
var NotificationsSubscriptionsUsersClient = /** @class */ (function () {
    function NotificationsSubscriptionsUsersClient(notificationsSubscriptionsUsersRoute, NotificationsSubscriptionsUsersBatchClient, apiClient) {
        this.notificationsSubscriptionsUsersRoute = notificationsSubscriptionsUsersRoute;
        this.NotificationsSubscriptionsUsersBatchClient = NotificationsSubscriptionsUsersBatchClient;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSubscriptionsUsersClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsUsersClient.prototype, "batch", {
        get: function () {
            return this.NotificationsSubscriptionsUsersBatchClient;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the create user subscription action has been performed; this action creates a new user subscription resource.
     * @method
     * @param data An UserSubscription object that needs to be inserted into the system.
     * @returns A promise that is resolved once the create user subscription action has been performed.
     * @example notificationsSubscriptionsUsersClient.create({
                    channel: '<channel-name>',
                    userId: '<user-id>'
                })
                .then(function (data) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsUsersClient.prototype.create = function (data) {
        return this.apiClient.post(this.routeDefinition.create(), this.routeDefinition.createParams(data));
    };
    /**
     * Returns a promise that is resolved once the find action has been performed. Success response returns a list of user subscription resources matching the given criteria.
     * @method
     * @param options Query resource options object.
     * @returns A promise that is resolved once the find action has been performed.
     * @example notificationsSubscriptionsUsersClient.find({
                    pageNumber : 1,
                    pageSize : 10,
                    orderBy : '<field>',
                    orderDirection : '<asc|desc>',
                    search : '<search-phrase>',
                    channels: '<channel-name1>,<channel-name2>',
                    userIds: '<user-id1>,<user-id2>',
                    embed: '<embed>'
                })
                .then(function (collection) {
                    // perform success action here
                },
                 function (response, status, headers, config) {
                     // perform error handling here
                });
     */
    NotificationsSubscriptionsUsersClient.prototype.find = function (options) {
        return this.apiClient.get(this.routeDefinition.find(options));
    };
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified user subscription resource.
     * @method
     * @param id The subscription identifier which uniquely identifies UserSubscription resource that needs to be retrieved.
     * @param options Query resource options object.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsSubscriptionsUsersClient.get('<subscription-id>')
                   .then(function (data) {
                       // perform success action here
                   },
                    function (response, status, headers, config) {
                        // perform error handling here
                   });
    */
    NotificationsSubscriptionsUsersClient.prototype.get = function (id, options) {
        return this.apiClient.get(this.notificationsSubscriptionsUsersRoute.get(id, options));
    };
    /**
     * Returns a promise that is resolved once the remove user subscription action has been performed. This action will remove a user subscription resource from the system if successfully completed. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.removeParams(subscription);
     * let uri = params['model'].links('delete').href;
     * ```
     * @method
     * @param data An object used to delete specified UserSubscription resource.
     * @returns A promise that is resolved once the remove user subscription action has been performed.
     * @example // subscription is a resource previously fetched using get action.
                    notificationsSubscriptionsUsersClient.remove(subscription)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsSubscriptionsUsersClient.prototype.remove = function (data) {
        return this.apiClient.delete(this.routeDefinition.delete(data));
    };
    /**
     * Returns a promise that is resolved once the update user subscription action has been performed; this action updates a user subscription resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSubscriptionsUsersRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(subscription);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data An object used to update specified UserSubscription resource.
     * @example // subscription is a resource previously fetched using get action.
                       subscription.channel = '<channel-name>';
                       notificationsSubscriptionsUsersClient.update(subscription)
                           .then(function (data) {
                               // perform success action here
                           },
                            function (response, status, headers, config) {
                                // perform error handling here
                           });
    */
    NotificationsSubscriptionsUsersClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b, _c;
    NotificationsSubscriptionsUsersClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersBatchClient)),
        tslib_1.__param(2, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsUsersRoute !== "undefined" && _1.NotificationsSubscriptionsUsersRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsUsersBatchClient !== "undefined" && _1.NotificationsSubscriptionsUsersBatchClient) === "function" ? _b : Object, typeof (_c = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _c : Object])
    ], NotificationsSubscriptionsUsersClient);
    return NotificationsSubscriptionsUsersClient;
}());
exports.NotificationsSubscriptionsUsersClient = NotificationsSubscriptionsUsersClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsRoute
 * @description Baasic Notifications Subscriptions Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var NotificationsSubscriptionsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSubscriptionsRoute, _super);
    function NotificationsSubscriptionsRoute(notificationsSubscriptionsAnonymousRoute, notificationsSubscriptionsUsersRoute, appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.notificationsSubscriptionsAnonymousRoute = notificationsSubscriptionsAnonymousRoute;
        _this.notificationsSubscriptionsUsersRoute = notificationsSubscriptionsUsersRoute;
        _this.appOptions = appOptions;
        return _this;
    }
    Object.defineProperty(NotificationsSubscriptionsRoute.prototype, "users", {
        get: function () {
            return this.notificationsSubscriptionsUsersRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsRoute.prototype, "anonymous", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsSubscriptionsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersRoute)),
        tslib_1.__param(2, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsAnonymousRoute !== "undefined" && _1.NotificationsSubscriptionsAnonymousRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsUsersRoute !== "undefined" && _1.NotificationsSubscriptionsUsersRoute) === "function" ? _b : Object, typeof (_c = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _c : Object])
    ], NotificationsSubscriptionsRoute);
    return NotificationsSubscriptionsRoute;
}(common_1.BaseRoute));
exports.NotificationsSubscriptionsRoute = NotificationsSubscriptionsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSubscriptionsClient
 * @description  Notifications Subscriptions Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSubscriptionsClient` uses `notificationsSubscriptionsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var _1 = __webpack_require__(11);
var NotificationsSubscriptionsClient = /** @class */ (function () {
    function NotificationsSubscriptionsClient(notificationsSubscriptionsRoute, notificationsSubscriptionsAnonymousClient, notificationsSubscriptionsUsersClient) {
        this.notificationsSubscriptionsRoute = notificationsSubscriptionsRoute;
        this.notificationsSubscriptionsAnonymousClient = notificationsSubscriptionsAnonymousClient;
        this.notificationsSubscriptionsUsersClient = notificationsSubscriptionsUsersClient;
    }
    Object.defineProperty(NotificationsSubscriptionsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsClient.prototype, "anonymous", {
        get: function () {
            return this.notificationsSubscriptionsAnonymousClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsSubscriptionsClient.prototype, "users", {
        get: function () {
            return this.notificationsSubscriptionsUsersClient;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c;
    NotificationsSubscriptionsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsRoute)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsAnonymousClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsUsersClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSubscriptionsRoute !== "undefined" && _1.NotificationsSubscriptionsRoute) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsAnonymousClient !== "undefined" && _1.NotificationsSubscriptionsAnonymousClient) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsSubscriptionsUsersClient !== "undefined" && _1.NotificationsSubscriptionsUsersClient) === "function" ? _c : Object])
    ], NotificationsSubscriptionsClient);
    return NotificationsSubscriptionsClient;
}());
exports.NotificationsSubscriptionsClient = NotificationsSubscriptionsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSettingsRoute
 * @description Baasic Notifications Settings Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Settings Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var NotificationsSettingsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsSettingsRoute, _super);
    function NotificationsSettingsRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.getRoute = 'notifications/settings/{id}';
        _this.updateRoute = 'notifications/settings/{id}';
        return _this;
    }
    /**
     * Parses get notification settings route; this route should be expanded with the notification provider name.
     * @method
     * @param provider The notification provider name.
     * @example notificationsSettingsRoute.get({ id: '<provider-name>' });
     */
    NotificationsSettingsRoute.prototype.get = function (provider) {
        return _super.prototype.baseGet.call(this, this.getRoute, provider);
    };
    /**
     * Parses update notification settings route; this route should be expanded with the notification provider name.
     * @method
     * @param data The notification settings.
     * @example notificationsSettingsRoute.update({ id: '<provider-name>' });
     */
    NotificationsSettingsRoute.prototype.update = function (data) {
        return _super.prototype.baseUpdate.call(this, this.updateRoute, data);
    };
    var _a;
    NotificationsSettingsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], NotificationsSettingsRoute);
    return NotificationsSettingsRoute;
}(common_1.BaseRoute));
exports.NotificationsSettingsRoute = NotificationsSettingsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsSettingsClient
 * @description  Notifications Settings Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsSettingsClient` uses `notificationsSettingsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(11);
var NotificationsSettingsClient = /** @class */ (function () {
    function NotificationsSettingsClient(notificationsSettingsRoute, apiClient) {
        this.notificationsSettingsRoute = notificationsSettingsRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(NotificationsSettingsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a promise that is resolved once the get action has been performed. Success response returns the specified setting resource.
     * @method
     * @param provider The notification provider name.
     * @returns A promise that is resolved once the get action has been performed.
     * @example notificationsSettingsClient.get('<provider-name>')
                    .then(function (data) {
                        // perform success action here
                    },
                     function (response, status, headers, config) {
                         // perform error handling here
                    });
     */
    NotificationsSettingsClient.prototype.get = function (provider) {
        return this.apiClient.get(this.routeDefinition.get(provider));
    };
    /**
     * Returns a promise that is resolved once the update settings action has been performed; this action updates a settings resource. This route uses HAL enabled objects to obtain routes and therefore it doesn't apply `notificationsSettingsRoute` route template. Here is an example of how a route can be obtained from HAL enabled objects:
     * ```
     * let params = modelMapper.updateParams(settings);
     * let uri = params['model'].links('put').href;
     * ```
     * @method
     * @param data The notification settings.
     * @returns A promise that is resolved once the update settings action has been performed.
     * @example // settings is a resource previously fetched using get action.
                    notificationsSettingsClient.update(settings)
                        .then(function (data) {
                            // perform success action here
                        },
                         function (response, status, headers, config) {
                             // perform error handling here
                        });
     */
    NotificationsSettingsClient.prototype.update = function (data) {
        return this.apiClient.put(this.routeDefinition.update(data), this.routeDefinition.updateParams(data));
    };
    var _a, _b;
    NotificationsSettingsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsSettingsRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsSettingsRoute !== "undefined" && _1.NotificationsSettingsRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], NotificationsSettingsClient);
    return NotificationsSettingsClient;
}());
exports.NotificationsSettingsClient = NotificationsSettingsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 798 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsRoute
 * @description Baasic Notifications Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Notifications Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var _1 = __webpack_require__(11);
var NotificationsRoute = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationsRoute, _super);
    function NotificationsRoute(appOptions, notificationsPublishRoute, basicNotificationsSubscriptionsRoute, notificationsRegistrationsRoute, notificationsSettingsRoute) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        _this.notificationsPublishRoute = notificationsPublishRoute;
        _this.basicNotificationsSubscriptionsRoute = basicNotificationsSubscriptionsRoute;
        _this.notificationsRegistrationsRoute = notificationsRegistrationsRoute;
        _this.notificationsSettingsRoute = notificationsSettingsRoute;
        return _this;
    }
    Object.defineProperty(NotificationsRoute.prototype, "publish", {
        get: function () {
            return this.notificationsPublishRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRoute.prototype, "subscriptions", {
        get: function () {
            return this.basicNotificationsSubscriptionsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRoute.prototype, "registrations", {
        get: function () {
            return this.notificationsRegistrationsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsRoute.prototype, "settings", {
        get: function () {
            return this.notificationsSettingsRoute;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    NotificationsRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsPublishRoute)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsRoute)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.NotificationsRegistrationsRoute)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.NotificationsSettingsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsPublishRoute !== "undefined" && _1.NotificationsPublishRoute) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsSubscriptionsRoute !== "undefined" && _1.NotificationsSubscriptionsRoute) === "function" ? _c : Object, typeof (_d = typeof _1.NotificationsRegistrationsRoute !== "undefined" && _1.NotificationsRegistrationsRoute) === "function" ? _d : Object, typeof (_e = typeof _1.NotificationsSettingsRoute !== "undefined" && _1.NotificationsSettingsRoute) === "function" ? _e : Object])
    ], NotificationsRoute);
    return NotificationsRoute;
}(common_1.BaseRoute));
exports.NotificationsRoute = NotificationsRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module notificationsClient
 * @description  Notifications Client provides an easy way to consume  Notifications REST API end-points. In order to obtain needed routes `notificationsClient` uses `notificationsRoute`.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var _1 = __webpack_require__(11);
var NotificationsClient = /** @class */ (function () {
    function NotificationsClient(notificationsPublishClient, basicNotificationsSubscriptionsClient, notificationsRegistrationsClient, notificationsSettingsClient, notificationsRoute) {
        this.notificationsPublishClient = notificationsPublishClient;
        this.basicNotificationsSubscriptionsClient = basicNotificationsSubscriptionsClient;
        this.notificationsRegistrationsClient = notificationsRegistrationsClient;
        this.notificationsSettingsClient = notificationsSettingsClient;
        this.notificationsRoute = notificationsRoute;
    }
    Object.defineProperty(NotificationsClient.prototype, "routeDefinition", {
        get: function () {
            return this.notificationsRoute;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "publish", {
        get: function () {
            return this.notificationsPublishClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "subscriptions", {
        get: function () {
            return this.basicNotificationsSubscriptionsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "registrations", {
        get: function () {
            return this.notificationsRegistrationsClient;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NotificationsClient.prototype, "settings", {
        get: function () {
            return this.notificationsSettingsClient;
        },
        enumerable: true,
        configurable: true
    });
    var _a, _b, _c, _d, _e;
    NotificationsClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.NotificationsPublishClient)),
        tslib_1.__param(1, inversify_1.inject(_1.TYPES.NotificationsSubscriptionsClient)),
        tslib_1.__param(2, inversify_1.inject(_1.TYPES.NotificationsRegistrationsClient)),
        tslib_1.__param(3, inversify_1.inject(_1.TYPES.NotificationsSettingsClient)),
        tslib_1.__param(4, inversify_1.inject(_1.TYPES.NotificationsRoute)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.NotificationsPublishClient !== "undefined" && _1.NotificationsPublishClient) === "function" ? _a : Object, typeof (_b = typeof _1.NotificationsSubscriptionsClient !== "undefined" && _1.NotificationsSubscriptionsClient) === "function" ? _b : Object, typeof (_c = typeof _1.NotificationsRegistrationsClient !== "undefined" && _1.NotificationsRegistrationsClient) === "function" ? _c : Object, typeof (_d = typeof _1.NotificationsSettingsClient !== "undefined" && _1.NotificationsSettingsClient) === "function" ? _d : Object, typeof (_e = typeof _1.NotificationsRoute !== "undefined" && _1.NotificationsRoute) === "function" ? _e : Object])
    ], NotificationsClient);
    return NotificationsClient;
}());
exports.NotificationsClient = NotificationsClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [REST API documentation](https://github.com/Baasic/baasic-rest-api/wiki) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
 */ 


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
tslib_1.__exportStar(__webpack_require__(801), exports);
tslib_1.__exportStar(__webpack_require__(802), exports);
tslib_1.__exportStar(__webpack_require__(803), exports);
tslib_1.__exportStar(__webpack_require__(804), exports);
tslib_1.__exportStar(__webpack_require__(805), exports);
tslib_1.__exportStar(__webpack_require__(806), exports);


/***/ }),
/* 801 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = __webpack_require__(1);
var Symbol = __webpack_require__(8);
var _1 = __webpack_require__(33);
var TYPES = {
    MaintenanceRoute: Symbol("MaintenanceRoute"),
    MaintenanceClient: Symbol("MaintenanceClient"),
    Root: Symbol("Maintenance-Root")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.MaintenanceRoute).to(_1.MaintenanceRoute);
    bind(TYPES.MaintenanceClient).to(_1.MaintenanceClient);
    bind(TYPES.Root).to(_1.Root);
});
exports.diModule = diModule;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
/* globals module */
/**
 * @module maintenanceRoute
 * @description Baasic Platform Maintenance Route Definition provides Baasic route templates which can be expanded to Baasic REST URIs. Various services can use Baasic Maintenance Route Definition to obtain needed routes while other routes will be obtained through HAL. By convention, all route services use the same function names as their corresponding services.
 */
var inversify_1 = __webpack_require__(1);
var common_1 = __webpack_require__(2);
var contracts_1 = __webpack_require__(3);
var MaintenanceRoute = /** @class */ (function (_super) {
    tslib_1.__extends(MaintenanceRoute, _super);
    function MaintenanceRoute(appOptions) {
        var _this = _super.call(this, appOptions) || this;
        _this.appOptions = appOptions;
        /**
         * Maintenance route with route and query parameters.
         **/
        _this.applicationMaintenanceRoute = 'platform/maintenance/{id}';
        /**
         * Maintenance route with route and query parameters.
         **/
        _this.maintenanceRoute = 'platform/maintenance';
        return _this;
    }
    /**
     * Parses application maintenance route.
     * @method
     * @example maintenanceRoute.maintain(id);
     **/
    MaintenanceRoute.prototype.maintainApp = function (id) {
        return _super.prototype.baseUpdate.call(this, this.applicationMaintenanceRoute, id);
    };
    /**
     * Parses maintenance route.
     * @method
     * @example maintenanceRoute.maintain();
     **/
    MaintenanceRoute.prototype.maintain = function () {
        return _super.prototype.baseUpdate.call(this, this.maintenanceRoute, {});
    };
    var _a;
    MaintenanceRoute = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(contracts_1.TYPES.IAppOptions)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof contracts_1.IAppOptions !== "undefined" && contracts_1.IAppOptions) === "function" ? _a : Object])
    ], MaintenanceRoute);
    return MaintenanceRoute;
}(common_1.BaseRoute));
exports.MaintenanceRoute = MaintenanceRoute;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - [URI Template](https://github.com/Baasic/uritemplate-js) syntax enables expanding the Baasic route templates to Baasic REST URIs providing it with an object that contains URI parameters.
 - All end-point objects are transformed by the associated route definition.
 */ 


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/* globals module */
/**
 * @module maintenanceClient
 * @description  Maintenance Client provides an easy way to consume  Password Recovery REST API end-points. In order to obtain needed routes `maintenanceClient` uses `maintenanceRoute`.
*/
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var inversify_1 = __webpack_require__(1);
var httpApi_1 = __webpack_require__(4);
var _1 = __webpack_require__(33);
var MaintenanceClient = /** @class */ (function () {
    function MaintenanceClient(maintenanceRoute, apiClient) {
        this.maintenanceRoute = maintenanceRoute;
        this.apiClient = apiClient;
    }
    Object.defineProperty(MaintenanceClient.prototype, "routeDefinition", {
        /**
         * Provides direct access to `maintenanceRoute`.
         * @method
         * @example maintenanceClient.routeDefinition.maintain(id);
         **/
        get: function () {
            return this.maintenanceRoute;
        },
        enumerable: true,
        configurable: true
    });
    MaintenanceClient.prototype.maintainApp = function (id) {
        return this.apiClient.put(this.routeDefinition.maintainApp(id), {});
    };
    MaintenanceClient.prototype.maintain = function () {
        return this.apiClient.put(this.routeDefinition.maintain(), {});
    };
    var _a, _b;
    MaintenanceClient = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MaintenanceRoute)),
        tslib_1.__param(1, inversify_1.inject(httpApi_1.httpTYPES.ApiClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MaintenanceRoute !== "undefined" && _1.MaintenanceRoute) === "function" ? _a : Object, typeof (_b = typeof httpApi_1.ApiClient !== "undefined" && httpApi_1.ApiClient) === "function" ? _b : Object])
    ], MaintenanceClient);
    return MaintenanceClient;
}());
exports.MaintenanceClient = MaintenanceClient;
/**
 * @overview
 ***Notes:**
 - Refer to the [Baasic REST API](http://dev.baasic.com/api/reference/home) for detailed information about available Baasic REST API end-points.
 - All end-point objects are transformed by the associated route service.
*/ 


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(0);
var _1 = __webpack_require__(33);
var inversify_1 = __webpack_require__(1);
var Root = /** @class */ (function () {
    function Root(maintenance) {
        this.maintenance = maintenance;
    }
    var _a;
    Root = tslib_1.__decorate([
        inversify_1.injectable(),
        tslib_1.__param(0, inversify_1.inject(_1.TYPES.MaintenanceClient)),
        tslib_1.__metadata("design:paramtypes", [typeof (_a = typeof _1.MaintenanceClient !== "undefined" && _1.MaintenanceClient) === "function" ? _a : Object])
    ], Root);
    return Root;
}());
exports.Root = Root;


/***/ })
/******/ ]);
});